!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var n = e();

    for (var r in n) {
      ("object" == typeof exports ? exports : t)[r] = n[r];
    }
  }
}(this, function () {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.p = "", e(0);
  }([function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function i(t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }

      return Array.from(t);
    }

    function o(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    function a(t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" != typeof e && "function" != typeof e ? t : e;
    }

    function s(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var u = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    },
        c = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }(),
        l = n(168),
        h = r(l),
        f = n(622),
        p = r(f),
        m = n(102),
        d = r(m),
        g = n(92),
        v = r(g),
        y = n(689),
        x = r(y),
        w = n(73),
        b = n(175),
        _ = n(100),
        E = n(101),
        M = function (t) {
      function e() {
        var t, n, r, s;
        o(this, e);

        for (var c = arguments.length, l = Array(c), h = 0; h < c; h++) {
          l[h] = arguments[h];
        }

        return n = r = a(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(l))), r.primordalInit = function () {
          r.renderDrawing(), r.setState({
            markerPositions: [],
            areWeLive: !1
          });
        }, r.state = {
          areWeLive: !1
        }, r.renderDrawing = function (t) {
          var e = r.props.holeImagePath;
          window.viewer && window.viewer.clearOverlays().addSimpleImage({
            url: e,
            success: r.setSeadragonHandlers
          });
        }, r.getActiveTee = function () {
          return r.props.activeTeeIndex;
        }, r.resetDrawing = function () {
          "undefined" != typeof window.viewer && window.viewer && (window.viewer.destroy(), window.viewer = null);
        }, r.initSeadragon = function (t, e) {
          var n = "";
          window.viewer = (0, v.default)({
            id: "seadragon-viewer",
            maxZoomLevel: 21,
            smoothTileEdgesMinZoom: 1 / 0,
            prefixUrl: n,
            degrees: 90,
            showNavigationControl: !1,
            animationTime: .2,
            visibilityRatio: 1,
            springStiffness: 4.5
          }), window.viewer.addHandler("update-viewport", function (t) {
            var e = r.props,
                n = e.fontSize,
                o = e.proj4text,
                a = e.boundingBox,
                s = a.world,
                c = a.canvas,
                l = (e.tees, e.dimensions),
                h = e.heatmapData,
                f = e.drawCurves,
                p = window.viewer.drawer.context;

            if (1938 === l.height && 984 === l.width ? (c.lowerLeft.y = 1.5 * l.height, c.lowerRight.x = 1.5 * l.width, c.lowerRight.y = 1.5 * l.height, c.upperRight.x = 1.5 * l.width) : 2907 === l.height && 1476 === l.width || console.warn("Unexpected dimensions: " + l.width + "x" + l.height), !d.default.isEmpty(h)) {
              var m = document.createElement("canvas");
              m.width = window.viewer.drawer.canvas.width, m.height = window.viewer.drawer.canvas.height;
              var g = (0, x.default)(m),
                  v = d.default.flatMap(function (t) {
                return d.default.map(function (t) {
                  return t;
                }, t);
              }, h),
                  y = d.default.map(function (t) {
                var e = d.default.get("location", t),
                    n = (0, w.translate)(window.viewer, c, s, e, o);
                return n.x = Math.round(n.x), n.y = Math.round(n.y), d.default.set("position", e, n);
              }, v),
                  M = d.default.flow(d.default.groupBy(function (t) {
                return t.x + "," + t.y;
              }), d.default.transform.convert({
                cap: !1
              })(function (t, e, n) {
                return t.push([].concat(i(d.default.map(Number, n.split(","))), [d.default.size(e)]));
              }, []))(y);
              g.max(d.default.get(2, d.default.maxBy(d.default.get(2), M))), g.data(M), g.draw(), p.drawImage(m, 0, 0);
            }

            var T = r.props.teeLocation && (0, w.translate)(window.viewer, c, s, r.props.teeLocation, o),
                N = d.default.map(function (t) {
              var e = d.default.get("location", t),
                  n = (0, w.translate)(window.viewer, c, s, e, o);
              return d.default.set("position", e, n);
            }, r.props.shotLocations),
                S = window.viewer.viewport.getBoundsWithMargins(!0),
                A = window.viewer.drawer.viewportToDrawerRectangle(S.rotate(window.viewer.viewport.getRotation(), window.viewer.viewport.getCenter(!0)));
            p.textAlign = "left", p.textBaseline = "middle", p.font = "bold " + n * (0, _.getDevicePixelRatio)() + "px Arial";

            var O = 2 * (0, _.getDevicePixelRatio)(),
                C = (1 * (0, _.getDevicePixelRatio)(), 4 * (0, _.getDevicePixelRatio)()),
                P = 1 * (0, _.getDevicePixelRatio)(),
                R = "#DBE6EC",
                I = "#DBE6EC",
                k = "#163739",
                z = "#163739",
                B = .05,
                L = 1,
                D = function D(t) {
              return function (e, n) {
                return Math.abs(e - n) < t;
              };
            },
                j = D(1e-5),
                F = u({}, T, {
              position: r.props.teeLocation
            });

            d.default.each(function (t) {
              var e = d.default.get("position", t),
                  n = d.default.get("position", F);

              if (!j(d.default.get("longitude", e), d.default.get("longitude", n)) || !j(d.default.get("latitude", e), d.default.get("latitude", n))) {
                var r = "" + Math.round((0, E.getDistance)({
                  source: e,
                  destination: n
                }));
                f ? ((0, b.drawFullBezierCurve)(p, R, O, F, t), p.globalAlpha = B, (0, b.drawShotLine)(p, z, C, F, t), (0, b.drawShotLine)(p, z, O, F, t), p.globalAlpha = L) : (0, b.drawShotLine)(p, R, O, F, t);
                var i = (0, b.getTextPlacement)(F, t, A);
                i && (0, b.drawText)(p, I, P, k, r, i), F = t;
              }
            }, N), p.closePath();
          }), window.viewer.setControlsEnabled(!1);
        }, r.setSeadragonHandlers = function (t) {
          var e = t.item;
          window.viewer.world.getItemCount() > 1 && (window.viewer.world.removeAll(), window.viewer.world.addItem(e));
          var n = window.viewer.viewport.getHomeZoom();
          n !== window.viewer.viewport.getZoom() && window.viewer.viewport.zoomTo(n);
          var i = window.viewer.viewport.getHomeBounds();
          i !== window.viewer.viewport.getBounds() && window.viewer.viewport.fitBounds(i), r.setState({
            areWeLive: !0
          });
        }, r.updatePlayerPosition = function (t) {
          var e = t.proj4text,
              n = t.boundingBox,
              r = n.world,
              i = n.canvas,
              o = t.playerPosition;

          if (o) {
            var a = (0, w.boundingBoxMapping)({
              bbFrom: r,
              bbTo: i,
              fromPoint: (0, w.ll2utm)(o, e)
            });
            window.viewer && (window.viewer.getOverlayById("player") ? window.viewer.updateOverlay("player", window.viewer.viewport.imageToViewportCoordinates(a), 0) : window.viewer.addOverlay({
              id: "player",
              location: window.viewer.viewport.imageToViewportCoordinates(a),
              placement: v.default.Placement.CENTER,
              checkResize: !0,
              rotationMode: v.default.OverlayRotationMode.NO_ROTATION
            }));
          }
        }, s = n, a(r, s);
      }

      return s(e, t), c(e, [{
        key: "componentDidMount",
        value: function value() {
          var t = this._dragon,
              e = t.clientHeight,
              n = t.clientWidth;
          this.initSeadragon(this.props, {
            clientHeight: e,
            clientWidth: n
          }), this.renderDrawing();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.resetDrawing();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(t, e) {
          this.props.holeImagePath !== t.holeImagePath && this.primordalInit();
        }
      }, {
        key: "render",
        value: function value() {
          var t = this;
          return h.default.createElement("div", {
            id: "seadragon-viewer",
            style: {
              width: "100%",
              height: "100%",
              backgroundColor: "#f2f2f2"
            },
            ref: function ref(e) {
              t._dragon = e;
            },
            className: "hole-container"
          });
        }
      }]), e;
    }(l.Component);

    M.propTypes = {
      boundingBox: p.default.shape({
        world: p.default.shape({
          upperLeft: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          upperRight: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          lowerLeft: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          lowerRight: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired
        }).isRequired,
        canvas: p.default.shape({
          upperLeft: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          upperRight: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          lowerLeft: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired,
          lowerRight: p.default.shape({
            x: p.default.number.isRequired,
            y: p.default.number.isRequired
          }).isRequired
        }).isRequired
      }).isRequired,
      holeImagePath: p.default.string.isRequired,
      proj4text: p.default.string.isRequired,
      fontSize: p.default.number,
      dimensions: p.default.shape({
        width: p.default.number.isRequired,
        height: p.default.number.isRequired
      })
    }, M.defaultProps = {
      fontSize: 24,
      dimensions: {
        width: 1938,
        height: 1938
      }
    }, e.default = M;
  }, function (t, e) {
    "use strict";

    t.exports = function t(e, n, r) {
      return e && "function" == typeof e.map ? e.map(function (e) {
        return t(e, n, r);
      }) : n(e);
    };
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      function i(e, n, r) {
        var i = t.Matrix.storage(n || "default");
        return new i(e, r);
      }

      var o = r("matrix", {
        "": function _() {
          return i([]);
        },
        string: function string(t) {
          return i([], t);
        },
        "string, string": function stringString(t, e) {
          return i([], t, e);
        },
        Array: function Array(t) {
          return i(t);
        },
        Matrix: function Matrix(t) {
          return i(t, t.storage());
        },
        "Array | Matrix, string": i,
        "Array | Matrix, string, string": i
      });
      return o.toTex = {
        0: "\\begin{bmatrix}\\end{bmatrix}",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(${args[0]}\\right)"
      }, o;
    }

    e.name = "matrix", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    var r = n(540);
    e.isNumber = function (t) {
      return "number" == typeof t;
    }, e.isInteger = function (t) {
      return !!isFinite(t) && t == Math.round(t);
    }, e.sign = Math.sign || function (t) {
      return t > 0 ? 1 : t < 0 ? -1 : 0;
    }, e.format = function (t, n) {
      if ("function" == typeof n) return n(t);
      if (t === 1 / 0) return "Infinity";
      if (t === -(1 / 0)) return "-Infinity";
      if (isNaN(t)) return "NaN";
      var r = "auto",
          i = void 0;

      switch (n && (n.notation && (r = n.notation), e.isNumber(n) ? i = n : n.precision && (i = n.precision)), r) {
        case "fixed":
          return e.toFixed(t, i);

        case "exponential":
          return e.toExponential(t, i);

        case "engineering":
          return e.toEngineering(t, i);

        case "auto":
          return e.toPrecision(t, i, n && n.exponential).replace(/((\.\d*?)(0+))($|e)/, function () {
            var t = arguments[2],
                e = arguments[4];
            return "." !== t ? t + e : e;
          });

        default:
          throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", or "fixed".');
      }
    }, e.toExponential = function (t, e) {
      return new r(t).toExponential(e);
    }, e.toEngineering = function (t, e) {
      return new r(t).toEngineering(e);
    }, e.toFixed = function (t, e) {
      return new r(t).toFixed(e);
    }, e.toPrecision = function (t, e, n) {
      return new r(t).toPrecision(e, n);
    }, e.digits = function (t) {
      return t.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
    }, e.DBL_EPSILON = Number.EPSILON || 2.220446049250313e-16, e.nearlyEqual = function (t, n, r) {
      if (null == r) return t == n;
      if (t == n) return !0;
      if (isNaN(t) || isNaN(n)) return !1;

      if (isFinite(t) && isFinite(n)) {
        var i = Math.abs(t - n);
        return i < e.DBL_EPSILON || i <= Math.max(Math.abs(t), Math.abs(n)) * r;
      }

      return !1;
    };
  }, function (t, e) {
    "use strict";

    e.symbols = {
      Alpha: "A",
      alpha: "\\alpha",
      Beta: "B",
      beta: "\\beta",
      Gamma: "\\Gamma",
      gamma: "\\gamma",
      Delta: "\\Delta",
      delta: "\\delta",
      Epsilon: "E",
      epsilon: "\\epsilon",
      varepsilon: "\\varepsilon",
      Zeta: "Z",
      zeta: "\\zeta",
      Eta: "H",
      eta: "\\eta",
      Theta: "\\Theta",
      theta: "\\theta",
      vartheta: "\\vartheta",
      Iota: "I",
      iota: "\\iota",
      Kappa: "K",
      kappa: "\\kappa",
      varkappa: "\\varkappa",
      Lambda: "\\Lambda",
      lambda: "\\lambda",
      Mu: "M",
      mu: "\\mu",
      Nu: "N",
      nu: "\\nu",
      Xi: "\\Xi",
      xi: "\\xi",
      Omicron: "O",
      omicron: "o",
      Pi: "\\Pi",
      pi: "\\pi",
      varpi: "\\varpi",
      Rho: "P",
      rho: "\\rho",
      varrho: "\\varrho",
      Sigma: "\\Sigma",
      sigma: "\\sigma",
      varsigma: "\\varsigma",
      Tau: "T",
      tau: "\\tau",
      Upsilon: "\\Upsilon",
      upsilon: "\\upsilon",
      Phi: "\\Phi",
      phi: "\\phi",
      varphi: "\\varphi",
      Chi: "X",
      chi: "\\chi",
      Psi: "\\Psi",
      psi: "\\psi",
      Omega: "\\Omega",
      omega: "\\omega",
      true: "\\mathrm{True}",
      false: "\\mathrm{False}",
      i: "i",
      inf: "\\infty",
      Inf: "\\infty",
      infinity: "\\infty",
      Infinity: "\\infty",
      oo: "\\infty",
      lim: "\\lim",
      undefined: "\\mathbf{?}"
    }, e.operators = {
      transpose: "^\\top",
      factorial: "!",
      pow: "^",
      dotPow: ".^\\wedge",
      unaryPlus: "+",
      unaryMinus: "-",
      bitNot: "~",
      not: "\\neg",
      multiply: "\\cdot",
      divide: "\\frac",
      dotMultiply: ".\\cdot",
      dotDivide: ".:",
      mod: "\\mod",
      add: "+",
      subtract: "-",
      to: "\\rightarrow",
      leftShift: "<<",
      rightArithShift: ">>",
      rightLogShift: ">>>",
      equal: "=",
      unequal: "\\neq",
      smaller: "<",
      larger: ">",
      smallerEq: "\\leq",
      largerEq: "\\geq",
      bitAnd: "\\&",
      bitXor: "\\underline{|}",
      bitOr: "|",
      and: "\\wedge",
      xor: "\\veebar",
      or: "\\vee"
    }, e.defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)";
    var n = {
      deg: "^\\circ"
    };

    e.toSymbol = function (t, r) {
      if (r = "undefined" != typeof r && r) return n.hasOwnProperty(t) ? n[t] : "\\mathrm{" + t + "}";
      if (e.symbols.hasOwnProperty(t)) return e.symbols[t];

      if (t.indexOf("_") !== -1) {
        var i = t.indexOf("_");
        return e.toSymbol(t.substring(0, i)) + "_{" + e.toSymbol(t.substring(i + 1)) + "}";
      }

      return t;
    };
  }, function (t, e) {
    "use strict";

    e.clone = function t(e) {
      var n = typeof e;
      if ("number" === n || "string" === n || "boolean" === n || null === e || void 0 === e) return e;
      if ("function" == typeof e.clone) return e.clone();
      if (Array.isArray(e)) return e.map(function (e) {
        return t(e);
      });
      if (e instanceof Number) return new Number(e.valueOf());
      if (e instanceof String) return new String(e.valueOf());
      if (e instanceof Boolean) return new Boolean(e.valueOf());
      if (e instanceof Date) return new Date(e.valueOf());
      if (e && e.isBigNumber === !0) return e;
      if (e instanceof RegExp) throw new TypeError("Cannot clone " + e);
      var r = {};

      for (var i in e) {
        e.hasOwnProperty(i) && (r[i] = t(e[i]));
      }

      return r;
    }, e.extend = function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }

      return t;
    }, e.deepExtend = function t(e, n) {
      if (Array.isArray(n)) throw new TypeError("Arrays are not supported by deepExtend");

      for (var r in n) {
        if (n.hasOwnProperty(r)) if (n[r] && n[r].constructor === Object) void 0 === e[r] && (e[r] = {}), e[r].constructor === Object ? t(e[r], n[r]) : e[r] = n[r];else {
          if (Array.isArray(n[r])) throw new TypeError("Arrays are not supported by deepExtend");
          e[r] = n[r];
        }
      }

      return e;
    }, e.deepEqual = function (t, n) {
      var r, i, o;

      if (Array.isArray(t)) {
        if (!Array.isArray(n)) return !1;
        if (t.length != n.length) return !1;

        for (i = 0, o = t.length; i < o; i++) {
          if (!e.deepEqual(t[i], n[i])) return !1;
        }

        return !0;
      }

      if (t instanceof Object) {
        if (Array.isArray(n) || !(n instanceof Object)) return !1;

        for (r in t) {
          if (!e.deepEqual(t[r], n[r])) return !1;
        }

        for (r in n) {
          if (!e.deepEqual(t[r], n[r])) return !1;
        }

        return !0;
      }

      return typeof t == typeof n && t == n;
    }, e.canDefineProperty = function () {
      try {
        if (Object.defineProperty) return Object.defineProperty({}, "x", {
          get: function get() {}
        }), !0;
      } catch (t) {}

      return !1;
    }, e.lazy = function (t, n, r) {
      if (e.canDefineProperty()) {
        var i,
            o = !0;
        Object.defineProperty(t, n, {
          get: function get() {
            return o && (i = r(), o = !1), i;
          },
          set: function set(t) {
            i = t, o = !1;
          },
          configurable: !0,
          enumerable: !0
        });
      } else t[n] = r();
    }, e.traverse = function (t, e) {
      var n = t;
      if (e) for (var r = e.split("."), i = 0; i < r.length; i++) {
        var o = r[i];
        o in n || (n[o] = {}), n = n[o];
      }
      return n;
    }, e.isFactory = function (t) {
      return t && "function" == typeof t.factory;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = t.DenseMatrix,
          a = function a(t, e, n, _a2) {
        var u,
            c = t._data,
            l = t._size,
            h = t._datatype,
            f = n;
        "string" == typeof h && (u = h, e = r.convert(e, u), f = r.find(n, [u, u]));
        var p = l.length > 0 ? s(f, 0, l, l[0], c, e, _a2) : [];
        return new o({
          data: p,
          size: i(l),
          datatype: u
        });
      },
          s = function s(t, e, n, r, i, o, a) {
        var u = [];
        if (e === n.length - 1) for (var c = 0; c < r; c++) {
          u[c] = a ? t(o, i[c]) : t(i[c], o);
        } else for (var l = 0; l < r; l++) {
          u[l] = s(t, e + 1, n, n[e + 1], i[l], o, a);
        }
        return u;
      };

      return a;
    }

    var i = n(5).clone;
    e.name = "algorithm14", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var i = t.DenseMatrix,
          a = function a(t, e, n) {
        var a = t._data,
            u = t._size,
            c = t._datatype,
            l = e._data,
            h = e._size,
            f = e._datatype,
            p = [];
        if (u.length !== h.length) throw new o(u.length, h.length);

        for (var m = 0; m < u.length; m++) {
          if (u[m] !== h[m]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + h + ")");
          p[m] = u[m];
        }

        var d,
            g = n;
        "string" == typeof c && c === f && (d = c, e = r.convert(e, d), g = r.find(n, [d, d]));
        var v = p.length > 0 ? s(g, 0, p, p[0], a, l) : [];
        return new i({
          data: v,
          size: p,
          datatype: d
        });
      },
          s = function s(t, e, n, r, i, o) {
        var a = [];
        if (e === n.length - 1) for (var u = 0; u < r; u++) {
          a[u] = t(i[u], o[u]);
        } else for (var c = 0; c < r; c++) {
          a[c] = s(t, e + 1, n, n[e + 1], i[c], o[c]);
        }
        return a;
      };

      return a;
    }

    var i = n(28),
        o = n(12),
        a = i.string;
    a.isString;
    e.name = "algorithm13", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n) {
      var i,
          o = t.length;
      if (o != e[n]) throw new c(o, e[n]);

      if (n < e.length - 1) {
        var a = n + 1;

        for (i = 0; i < o; i++) {
          var s = t[i];
          if (!Array.isArray(s)) throw new c(e.length - 1, e.length, "<");
          r(t[i], e, a);
        }
      } else for (i = 0; i < o; i++) {
        if (Array.isArray(t[i])) throw new c(e.length + 1, e.length, ">");
      }
    }

    function i(t, n, r, o) {
      var a,
          s,
          u = t.length,
          c = n[r],
          l = Math.min(u, c);

      if (t.length = c, r < n.length - 1) {
        var h = r + 1;

        for (a = 0; a < l; a++) {
          s = t[a], Array.isArray(s) || (s = [s], t[a] = s), i(s, n, h, o);
        }

        for (a = l; a < c; a++) {
          s = [], t[a] = s, i(s, n, h, o);
        }
      } else {
        for (a = 0; a < l; a++) {
          for (; Array.isArray(t[a]);) {
            t[a] = t[a][0];
          }
        }

        if (o !== e.UNINITIALIZED) for (a = l; a < c; a++) {
          t[a] = o;
        }
      }
    }

    function o(t, e, n) {
      var r, i;

      if (n < e) {
        var a = n + 1;

        for (r = 0, i = t.length; r < i; r++) {
          t[r] = o(t[r], e, a);
        }
      } else for (; Array.isArray(t);) {
        t = t[0];
      }

      return t;
    }

    function a(t, e, n) {
      var r, i;

      if (Array.isArray(t)) {
        var o = n + 1;

        for (r = 0, i = t.length; r < i; r++) {
          t[r] = a(t[r], e, o);
        }
      } else for (var s = n; s < e; s++) {
        t = [t];
      }

      return t;
    }

    var s = n(3),
        u = n(23),
        c = (n(5), n(70), n(12)),
        l = n(52);
    e.size = function (t) {
      for (var e = []; Array.isArray(t);) {
        e.push(t.length), t = t[0];
      }

      return e;
    }, e.validate = function (t, e) {
      var n = 0 == e.length;

      if (n) {
        if (Array.isArray(t)) throw new c(t.length, 0);
      } else r(t, e, 0);
    }, e.validateIndex = function (t, e) {
      if (!s.isNumber(t) || !s.isInteger(t)) throw new TypeError("Index must be an integer (value: " + t + ")");
      if (t < 0 || "number" == typeof e && t >= e) throw new l(t, e);
    }, e.UNINITIALIZED = {}, e.resize = function (t, e, n) {
      if (!Array.isArray(t) || !Array.isArray(e)) throw new TypeError("Array expected");
      if (0 === e.length) throw new Error("Resizing to scalar is not supported");
      e.forEach(function (t) {
        if (!s.isNumber(t) || !s.isInteger(t) || t < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + u.format(e) + ")");
      });
      var r = void 0 !== n ? n : 0;
      return i(t, e, 0, r), t;
    }, e.squeeze = function (t, n) {
      for (var r = n || e.size(t); Array.isArray(t) && 1 === t.length;) {
        t = t[0], r.shift();
      }

      for (var i = r.length; 1 === r[i - 1];) {
        i--;
      }

      return i < r.length && (t = o(t, i, 0), r.length = i), t;
    }, e.unsqueeze = function (t, n, r, i) {
      var o = i || e.size(t);
      if (r) for (var s = 0; s < r; s++) {
        t = [t], o.unshift(1);
      }

      for (t = a(t, n, 0); o.length < n;) {
        o.push(1);
      }

      return t;
    }, e.flatten = function (t) {
      if (!Array.isArray(t)) return t;
      var e = [];
      return t.forEach(function t(n) {
        Array.isArray(n) ? n.forEach(t) : e.push(n);
      }), e;
    }, e.isArray = Array.isArray;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, o, a, s, u) {
      if (i(e), !t) {
        var c;
        if (void 0 === e) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [n, r, o, a, s, u],
              h = 0;
          c = new Error(e.replace(/%s/g, function () {
            return l[h++];
          })), c.name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    }

    var i = function i(t) {};

    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    var r = n(33),
        i = r;
    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("equalScalar", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t === e;
        },
        "number, number": function numberNumber(t, n) {
          return t === n || i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return t.eq(n) || o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.equals(e);
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.equals(e);
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return a(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t === e;
        }
      });
      return a;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t, e, r) {
      if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
      this.actual = t, this.expected = e, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + " " + (this.relation || "!=") + " " + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + ")", this.stack = new Error().stack;
    }

    n.prototype = new RangeError(), n.prototype.constructor = RangeError, n.prototype.name = "DimensionError", n.prototype.isDimensionError = !0, t.exports = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(22)),
          l = r(n(26)),
          h = r(n(11)),
          f = r(n(16)),
          p = r(n(6)),
          m = t.DenseMatrix,
          d = t.SparseMatrix,
          g = a("multiply", i({
        "Array, Array": function ArrayArray(t, e) {
          v(o.size(t), o.size(e));
          var n = g(u(t), u(e));
          return n && n.isMatrix === !0 ? n.valueOf() : n;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n = t.size(),
              r = e.size();
          return v(n, r), 1 === n.length ? 1 === r.length ? y(t, e, n[0]) : x(t, e) : 1 === r.length ? b(t, e) : _(t, e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return g(t, u(e));
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return g(u(t, e.storage()), e);
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = f(t, e, l, !1);
              break;

            case "dense":
              n = p(t, e, l, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = f(e, t, l, !0);
              break;

            case "dense":
              n = p(e, t, l, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(u(t), e, l, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(u(e), t, l, !0).valueOf();
        },
        "any, any": l,
        "any, any, ...any": function anyAnyAny(t, e, n) {
          for (var r = g(t, e), i = 0; i < n.length; i++) {
            r = g(r, n[i]);
          }

          return r;
        }
      }, l.signatures)),
          v = function v(t, e) {
        switch (t.length) {
          case 1:
            switch (e.length) {
              case 1:
                if (t[0] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
                break;

              case 2:
                if (t[0] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + t[0] + ") must match Matrix rows (" + e[0] + ")");
                break;

              default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + e.length + " dimensions)");
            }

            break;

          case 2:
            switch (e.length) {
              case 1:
                if (t[1] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + t[1] + ") must match Vector length (" + e[0] + ")");
                break;

              case 2:
                if (t[1] !== e[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + t[1] + ") must match Matrix B rows (" + e[0] + ")");
                break;

              default:
                throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + e.length + " dimensions)");
            }

            break;

          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + t.length + " dimensions)");
        }
      },
          y = function y(t, e, n) {
        if (0 === n) throw new Error("Cannot multiply two empty vectors");
        var r,
            i = t._data,
            o = t._datatype,
            s = e._data,
            u = e._datatype,
            h = c,
            f = l;
        o && u && o === u && "string" == typeof o && (r = o, h = a.find(c, [r, r]), f = a.find(l, [r, r]));

        for (var p = f(i[0], s[0]), m = 1; m < n; m++) {
          p = h(p, f(i[m], s[m]));
        }

        return p;
      },
          x = function x(t, e) {
        switch (e.storage()) {
          case "dense":
            return w(t, e);
        }

        throw new Error("Not implemented");
      },
          w = function w(t, e) {
        var n,
            r = t._data,
            i = t._size,
            o = t._datatype,
            s = e._data,
            u = e._size,
            h = e._datatype,
            f = i[0],
            p = u[1],
            d = c,
            g = l;
        o && h && o === h && "string" == typeof o && (n = o, d = a.find(c, [n, n]), g = a.find(l, [n, n]));

        for (var v = [], y = 0; y < p; y++) {
          for (var x = g(r[0], s[0][y]), w = 1; w < f; w++) {
            x = d(x, g(r[w], s[w][y]));
          }

          v[y] = x;
        }

        return new m({
          data: v,
          size: [p],
          datatype: n
        });
      },
          b = function b(t, e) {
        switch (t.storage()) {
          case "dense":
            return E(t, e);

          case "sparse":
            return N(t, e);
        }
      },
          _ = function _(t, e) {
        switch (t.storage()) {
          case "dense":
            switch (e.storage()) {
              case "dense":
                return M(t, e);

              case "sparse":
                return T(t, e);
            }

            break;

          case "sparse":
            switch (e.storage()) {
              case "dense":
                return S(t, e);

              case "sparse":
                return A(t, e);
            }

        }
      },
          E = function E(t, e) {
        var n,
            r = t._data,
            i = t._size,
            o = t._datatype,
            s = e._data,
            u = e._datatype,
            h = i[0],
            f = i[1],
            p = c,
            d = l;
        o && u && o === u && "string" == typeof o && (n = o, p = a.find(c, [n, n]), d = a.find(l, [n, n]));

        for (var g = [], v = 0; v < h; v++) {
          for (var y = r[v], x = d(y[0], s[0]), w = 1; w < f; w++) {
            x = p(x, d(y[w], s[w]));
          }

          g[v] = x;
        }

        return new m({
          data: g,
          size: [h],
          datatype: n
        });
      },
          M = function M(t, e) {
        var n,
            r = t._data,
            i = t._size,
            o = t._datatype,
            s = e._data,
            u = e._size,
            h = e._datatype,
            f = i[0],
            p = i[1],
            d = u[1],
            g = c,
            v = l;
        o && h && o === h && "string" == typeof o && (n = o, g = a.find(c, [n, n]), v = a.find(l, [n, n]));

        for (var y = [], x = 0; x < f; x++) {
          var w = r[x];
          y[x] = [];

          for (var b = 0; b < d; b++) {
            for (var _ = v(w[0], s[0][b]), E = 1; E < p; E++) {
              _ = g(_, v(w[E], s[E][b]));
            }

            y[x][b] = _;
          }
        }

        return new m({
          data: y,
          size: [f, d],
          datatype: n
        });
      },
          T = function T(t, e) {
        var n = t._data,
            r = t._size,
            i = t._datatype,
            o = e._values,
            s = e._index,
            u = e._ptr,
            f = e._size,
            p = e._datatype;
        if (!o) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
        var m,
            g = r[0],
            v = f[1],
            y = c,
            x = l,
            w = h,
            b = 0;
        i && p && i === p && "string" == typeof i && (m = i, y = a.find(c, [m, m]), x = a.find(l, [m, m]), w = a.find(h, [m, m]), b = a.convert(0, m));

        for (var _ = [], E = [], M = [], T = new d({
          values: _,
          index: E,
          ptr: M,
          size: [g, v],
          datatype: m
        }), N = 0; N < v; N++) {
          M[N] = E.length;
          var S = u[N],
              A = u[N + 1];
          if (A > S) for (var O = 0, C = 0; C < g; C++) {
            for (var P, R = C + 1, I = S; I < A; I++) {
              var k = s[I];
              O !== R ? (P = x(n[C][k], o[I]), O = R) : P = y(P, x(n[C][k], o[I]));
            }

            O !== R || w(P, b) || (E.push(C), _.push(P));
          }
        }

        return M[v] = E.length, T;
      },
          N = function N(t, e) {
        var n = t._values,
            r = t._index,
            i = t._ptr,
            o = t._datatype;
        if (!n) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
        var s,
            u = e._data,
            f = e._datatype,
            p = t._size[0],
            m = e._size[0],
            g = [],
            v = [],
            y = [],
            x = c,
            w = l,
            b = h,
            _ = 0;
        o && f && o === f && "string" == typeof o && (s = o, x = a.find(c, [s, s]), w = a.find(l, [s, s]), b = a.find(h, [s, s]), _ = a.convert(0, s));
        var E = [],
            M = [];
        y[0] = 0;

        for (var T = 0; T < m; T++) {
          var N = u[T];
          if (!b(N, _)) for (var S = i[T], A = i[T + 1], O = S; O < A; O++) {
            var C = r[O];
            M[C] ? E[C] = x(E[C], w(N, n[O])) : (M[C] = !0, v.push(C), E[C] = w(N, n[O]));
          }
        }

        for (var P = v.length, R = 0; R < P; R++) {
          var I = v[R];
          g[R] = E[I];
        }

        return y[1] = v.length, new d({
          values: g,
          index: v,
          ptr: y,
          size: [p, 1],
          datatype: s
        });
      },
          S = function S(t, e) {
        var n = t._values,
            r = t._index,
            i = t._ptr,
            o = t._datatype;
        if (!n) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
        var s,
            u = e._data,
            f = e._datatype,
            p = t._size[0],
            m = e._size[0],
            g = e._size[1],
            v = c,
            y = l,
            x = h,
            w = 0;
        o && f && o === f && "string" == typeof o && (s = o, v = a.find(c, [s, s]), y = a.find(l, [s, s]), x = a.find(h, [s, s]), w = a.convert(0, s));

        for (var b = [], _ = [], E = [], M = new d({
          values: b,
          index: _,
          ptr: E,
          size: [p, g],
          datatype: s
        }), T = [], N = [], S = 0; S < g; S++) {
          E[S] = _.length;

          for (var A = S + 1, O = 0; O < m; O++) {
            var C = u[O][S];
            if (!x(C, w)) for (var P = i[O], R = i[O + 1], I = P; I < R; I++) {
              var k = r[I];
              N[k] !== A ? (N[k] = A, _.push(k), T[k] = y(C, n[I])) : T[k] = v(T[k], y(C, n[I]));
            }
          }

          for (var z = E[S], B = _.length, L = z; L < B; L++) {
            var D = _[L];
            b[L] = T[D];
          }
        }

        return E[g] = _.length, M;
      },
          A = function A(t, e) {
        var n,
            r = t._values,
            i = t._index,
            o = t._ptr,
            s = t._datatype,
            u = e._values,
            h = e._index,
            f = e._ptr,
            p = e._datatype,
            m = t._size[0],
            g = e._size[1],
            v = r && u,
            y = c,
            x = l;
        s && p && s === p && "string" == typeof s && (n = s, y = a.find(c, [n, n]), x = a.find(l, [n, n]));

        for (var w, b, _, E, M, T, N, S, A = v ? [] : void 0, O = [], C = [], P = new d({
          values: A,
          index: O,
          ptr: C,
          size: [m, g],
          datatype: n
        }), R = v ? [] : void 0, I = [], k = 0; k < g; k++) {
          C[k] = O.length;
          var z = k + 1;

          for (M = f[k], T = f[k + 1], E = M; E < T; E++) {
            if (S = h[E], v) for (b = o[S], _ = o[S + 1], w = b; w < _; w++) {
              N = i[w], I[N] !== z ? (I[N] = z, O.push(N), R[N] = x(u[E], r[w])) : R[N] = y(R[N], x(u[E], r[w]));
            } else for (b = o[S], _ = o[S + 1], w = b; w < _; w++) {
              N = i[w], I[N] !== z && (I[N] = z, O.push(N));
            }
          }

          if (v) for (var B = C[k], L = O.length, D = B; D < L; D++) {
            var j = O[D];
            A[D] = R[j];
          }
        }

        return C[g] = O.length, P;
      };

      return g.toTex = {
        2: "\\left(${args[0]}" + s.operators.multiply + "${args[1]}\\right)"
      }, g;
    }

    var i = n(5).extend,
        o = n(8);
    e.name = "multiply", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, a) {
      function s() {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
      }

      function u(t) {
        for (var e in t) {
          if (t.hasOwnProperty(e) && e in i) throw new Error('Scope contains an illegal symbol, "' + e + '" is a reserved keyword');
        }
      }

      return s.prototype.eval = function (t) {
        return this.compile().eval(t);
      }, s.prototype.type = "Node", s.prototype.isNode = !0, s.prototype.comment = "", s.prototype.compile = function () {
        if (arguments.length > 0) throw new Error("Calling compile(math) is deprecated. Call the function as compile() instead.");

        var t = {
          math: a.expression.transform,
          args: {},
          _validateScope: u
        },
            e = {},
            n = this._compile(t, e),
            r = Object.keys(t).map(function (t) {
          return "    var " + t + ' = defs["' + t + '"];';
        }),
            i = r.join(" ") + 'return {  "eval": function (scope) {    if (scope) _validateScope(scope);    scope = scope || {};    return ' + n + ";  }};",
            o = new Function("defs", i);

        return o(t);
      }, s.prototype._compile = function (t, e) {
        throw new Error("Cannot compile a Node interface");
      }, s.prototype.forEach = function (t) {
        throw new Error("Cannot run forEach on a Node interface");
      }, s.prototype.map = function (t) {
        throw new Error("Cannot run map on a Node interface");
      }, s.prototype._ifNode = function (t) {
        if (!t || !t.isNode) throw new TypeError("Callback function must return a Node");
        return t;
      }, s.prototype.traverse = function (t) {
        function e(t, n) {
          t.forEach(function (t, r, i) {
            n(t, r, i), e(t, n);
          });
        }

        t(this, null, null), e(this, t);
      }, s.prototype.transform = function (t) {
        function e(t, n) {
          return t.map(function (t, r, i) {
            var o = n(t, r, i);
            return e(o, n);
          });
        }

        var n = t(this, null, null);
        return e(n, t);
      }, s.prototype.filter = function (t) {
        var e = [];
        return this.traverse(function (n, r, i) {
          t(n, r, i) && e.push(n);
        }), e;
      }, s.prototype.find = function () {
        throw new Error("Function Node.find is deprecated. Use Node.filter instead.");
      }, s.prototype.match = function () {
        throw new Error("Function Node.match is deprecated. See functions Node.filter, Node.transform, Node.traverse.");
      }, s.prototype.clone = function () {
        throw new Error("Cannot clone a Node interface");
      }, s.prototype.cloneDeep = function () {
        return this.map(function (t) {
          return t.cloneDeep();
        });
      }, s.prototype.equals = function (t) {
        return !!t && o(this, t);
      }, s.prototype.toString = function (t) {
        var e;
        if (t && "object" == typeof t) switch (typeof t.handler) {
          case "object":
          case "undefined":
            break;

          case "function":
            e = t.handler(this, t);
            break;

          default:
            throw new TypeError("Object or function expected as callback");
        }
        return "undefined" != typeof e ? e : this._toString(t);
      }, s.prototype._toString = function () {
        throw new Error("_toString not implemented for " + this.type);
      }, s.prototype.toTex = function (t) {
        var e;
        if (t && "object" == typeof t) switch (typeof t.handler) {
          case "object":
          case "undefined":
            break;

          case "function":
            e = t.handler(this, t);
            break;

          default:
            throw new TypeError("Object or function expected as callback");
        }
        return "undefined" != typeof e ? e : this._toTex(t);
      }, s.prototype._toTex = function (t) {
        throw new Error("_toTex not implemented for " + this.type);
      }, s.prototype.getIdentifier = function () {
        return this.type;
      }, s.prototype.getContent = function () {
        return this;
      }, s;
    }

    var i = n(74),
        o = (n(5).extend, n(5).deepEqual);
    e.name = "Node", e.path = "expression.node", e.math = !0, e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = t.DenseMatrix,
          a = function a(t, e, n, _a3) {
        var s = t._data,
            u = t._size,
            c = t._datatype,
            l = e._values,
            h = e._index,
            f = e._ptr,
            p = e._size,
            m = e._datatype;
        if (u.length !== p.length) throw new i(u.length, p.length);
        if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
        if (!l) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        var d,
            g = u[0],
            v = u[1],
            y = 0,
            x = n;
        "string" == typeof c && c === m && (d = c, y = r.convert(0, d), x = r.find(n, [d, d]));

        for (var w = [], b = 0; b < g; b++) {
          w[b] = [];
        }

        for (var _ = [], E = [], M = 0; M < v; M++) {
          for (var T = M + 1, N = f[M], S = f[M + 1], A = N; A < S; A++) {
            var O = h[A];
            _[O] = _a3 ? x(l[A], s[O][M]) : x(s[O][M], l[A]), E[O] = T;
          }

          for (var C = 0; C < g; C++) {
            E[C] === T ? w[C][M] = _[C] : w[C][M] = _a3 ? x(y, s[C][M]) : x(s[C][M], y);
          }
        }

        return new o({
          data: w,
          size: [g, v],
          datatype: d
        });
      };

      return a;
    }

    var i = n(12);
    e.name = "algorithm03", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(11)),
          a = t.SparseMatrix,
          s = function s(t, e, n, r) {
        var s = t._values,
            u = t._index,
            c = t._ptr,
            l = t._size,
            h = t._datatype;
        if (!s) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        var f,
            p = l[0],
            m = l[1],
            d = o,
            g = 0,
            v = n;
        "string" == typeof h && (f = h, d = i.find(o, [f, f]), g = i.convert(0, f), e = i.convert(e, f), v = i.find(n, [f, f]));

        for (var y = [], x = [], w = [], b = new a({
          values: y,
          index: x,
          ptr: w,
          size: [p, m],
          datatype: f
        }), _ = 0; _ < m; _++) {
          w[_] = x.length;

          for (var E = c[_], M = c[_ + 1], T = E; T < M; T++) {
            var N = u[T],
                S = r ? v(e, s[T]) : v(s[T], e);
            d(S, g) || (x.push(N), y.push(S));
          }
        }

        return w[m] = x.length, b;
      };

      return s;
    }

    e.name = "algorithm11", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      var i = t.DenseMatrix,
          o = function o(t, e, n, _o2) {
        var a = t._values,
            s = t._index,
            u = t._ptr,
            c = t._size,
            l = t._datatype;
        if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        var h,
            f = c[0],
            p = c[1],
            m = n;
        "string" == typeof l && (h = l, e = r.convert(e, h), m = r.find(n, [h, h]));

        for (var d = [], g = new i({
          data: d,
          size: [f, p],
          datatype: h
        }), v = [], y = [], x = 0; x < p; x++) {
          for (var w = x + 1, b = u[x], _ = u[x + 1], E = b; E < _; E++) {
            var M = s[E];
            v[M] = a[E], y[M] = w;
          }

          for (var T = 0; T < f; T++) {
            0 === x && (d[T] = []), y[T] === w ? d[T][x] = _o2 ? m(e, v[T]) : m(v[T], e) : d[T][x] = _o2 ? m(e, 0) : m(0, e);
          }
        }

        return g;
      };

      return o;
    }

    e.name = "algorithm12", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(2)),
          s = r(n(22)),
          u = n(4),
          c = r(n(31)),
          l = r(n(87)),
          h = r(n(36)),
          f = r(n(7)),
          p = r(n(6)),
          m = o("add", i({
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, s);
                  break;

                default:
                  n = c(e, t, s, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, s, !1);
                  break;

                default:
                  n = f(t, e, s);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, s, !1);
              break;

            default:
              n = p(t, e, s, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, s, !0);
              break;

            default:
              n = p(e, t, s, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(a(t), e, s, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(a(e), t, s, !0).valueOf();
        },
        "any, any": s,
        "any, any, ...any": function anyAnyAny(t, e, n) {
          for (var r = m(t, e), i = 0; i < n.length; i++) {
            r = m(r, n[i]);
          }

          return r;
        }
      }, s.signatures));
      return m.toTex = {
        2: "\\left(${args[0]}" + u.operators.add + "${args[1]}\\right)"
      }, m;
    }

    var i = n(5).extend;
    e.name = "add", e.factory = r;
  },, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(26)),
          a = i("divide", {
        "number, number": function numberNumber(t, e) {
          return t / e;
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.div(e);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return t.div(e);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.div(e);
        },
        "Unit, number | Fraction | BigNumber": function UnitNumberFractionBigNumber(t, e) {
          var n = t.clone();
          return n.value = a(null === n.value ? n._normalize(1) : n.value, e), n;
        },
        "number | Fraction | BigNumber, Unit": function numberFractionBigNumberUnit(t, e) {
          var n = e.pow(-1);
          return n.value = o(null === n.value ? n._normalize(1) : n.value, t), n;
        },
        "Unit, Unit": function UnitUnit(t, e) {
          return t.divide(e);
        }
      });
      return a;
    }

    e.factory = r;
  }, function (t, e) {
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    "use strict";

    function n(t) {
      if (null === t || void 0 === t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }

    function r() {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

        for (var e = {}, n = 0; n < 10; n++) {
          e["_" + String.fromCharCode(n)] = n;
        }

        var r = Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        });
        if ("0123456789" !== r.join("")) return !1;
        var i = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          i[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
      } catch (t) {
        return !1;
      }
    }

    var i = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;
    t.exports = r() ? Object.assign : function (t, e) {
      for (var r, s, u = n(t), c = 1; c < arguments.length; c++) {
        r = Object(arguments[c]);

        for (var l in r) {
          o.call(r, l) && (u[l] = r[l]);
        }

        if (i) {
          s = i(r);

          for (var h = 0; h < s.length; h++) {
            a.call(r, s[h]) && (u[s[h]] = r[s[h]]);
          }
        }
      }

      return u;
    };
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      var i = r("add", {
        "number, number": function numberNumber(t, e) {
          return t + e;
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.add(e);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return t.plus(e);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.add(e);
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (null == t.value) throw new Error("Parameter x contains a unit with undefined value");
          if (null == e.value) throw new Error("Parameter y contains a unit with undefined value");
          if (!t.equalBase(e)) throw new Error("Units do not match");
          var n = t.clone();
          return n.value = i(n.value, e.value), n.fixPrefix = !1, n;
        }
      });
      return i;
    }

    e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, n) {
      if (Array.isArray(t)) {
        for (var i = "[", o = t.length, a = 0; a < o; a++) {
          0 != a && (i += ", "), i += r(t[a], n);
        }

        return i += "]";
      }

      return e.format(t, n);
    }

    var i = n(3).format,
        o = n(544).format;
    e.isString = function (t) {
      return "string" == typeof t;
    }, e.endsWith = function (t, e) {
      var n = t.length - e.length,
          r = t.length;
      return t.substring(n, r) === e;
    }, e.format = function (t, n) {
      if ("number" == typeof t) return i(t, n);
      if (t && t.isBigNumber === !0) return o(t, n);
      if (t && t.isFraction === !0) return n && "decimal" === n.fraction ? t.toString() : t.s * t.n + "/" + t.d;
      if (Array.isArray(t)) return r(t, n);
      if (e.isString(t)) return '"' + t + '"';
      if ("function" == typeof t) return t.syntax ? String(t.syntax) : "function";

      if (t && "object" == typeof t) {
        if ("function" == typeof t.format) return t.format(n);
        if (t && t.toString() !== {}.toString()) return t.toString();
        var a = [];

        for (var s in t) {
          t.hasOwnProperty(s) && a.push('"' + s + '": ' + e.format(t[s], n));
        }

        return "{" + a.join(", ") + "}";
      }

      return String(t);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = r(n(2)),
          u = r(n(22)),
          c = r(n(43)),
          l = r(n(31)),
          h = r(n(15)),
          f = r(n(66)),
          p = r(n(36)),
          m = r(n(7)),
          d = r(n(6)),
          g = o("subtract", {
        "number, number": function numberNumber(t, e) {
          return t - e;
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.sub(e);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return t.minus(e);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.sub(e);
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (null == t.value) throw new Error("Parameter x contains a unit with undefined value");
          if (null == e.value) throw new Error("Parameter y contains a unit with undefined value");
          if (!t.equalBase(e)) throw new Error("Units do not match");
          var n = t.clone();
          return n.value = g(n.value, e.value), n.fixPrefix = !1, n;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n = t.size(),
              r = e.size();
          if (n.length !== r.length) throw new i(n.length, r.length);
          var o;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  o = f(t, e, g);
                  break;

                default:
                  o = h(e, t, g, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  o = l(t, e, g, !1);
                  break;

                default:
                  o = m(t, e, g);
              }

          }

          return o;
        },
        "Array, Array": function ArrayArray(t, e) {
          return g(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return g(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return g(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = p(t, c(e), u);
              break;

            default:
              n = d(t, e, g);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = p(e, t, g, !0);
              break;

            default:
              n = d(e, t, g, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return d(s(t), e, g, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return d(s(e), t, g, !0).valueOf();
        }
      });
      return g.toTex = {
        2: "\\left(${args[0]}" + a.operators.subtract + "${args[1]}\\right)"
      }, g;
    }

    var i = n(12);
    e.name = "subtract", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(11)),
          s = t.SparseMatrix,
          u = function u(t, e, n, r) {
        var u = t._data,
            c = t._size,
            l = t._datatype,
            h = e._values,
            f = e._index,
            p = e._ptr,
            m = e._size,
            d = e._datatype;
        if (c.length !== m.length) throw new i(c.length, m.length);
        if (c[0] !== m[0] || c[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + m + ")");
        if (!h) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        var g,
            v = c[0],
            y = c[1],
            x = a,
            w = 0,
            b = n;
        "string" == typeof l && l === d && (g = l, x = o.find(a, [g, g]), w = o.convert(0, g), b = o.find(n, [g, g]));

        for (var _ = [], E = [], M = [], T = 0; T < y; T++) {
          M[T] = E.length;

          for (var N = p[T], S = p[T + 1], A = N; A < S; A++) {
            var O = f[A],
                C = r ? b(h[A], u[O][T]) : b(u[O][T], h[A]);
            x(C, w) || (E.push(O), _.push(C));
          }
        }

        return M[y] = E.length, new s({
          values: _,
          index: E,
          ptr: M,
          size: [v, y],
          datatype: g
        });
      };

      return u;
    }

    var i = n(12);
    e.name = "algorithm02", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      var i = r("multiplyScalar", {
        "number, number": function numberNumber(t, e) {
          return t * e;
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.mul(e);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return t.times(e);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.mul(e);
        },
        "number | Fraction | BigNumber | Complex, Unit": function numberFractionBigNumberComplexUnit(t, e) {
          var n = e.clone();
          return n.value = null === n.value ? n._normalize(t) : i(n.value, t), n;
        },
        "Unit, number | Fraction | BigNumber | Complex": function UnitNumberFractionBigNumberComplex(t, e) {
          var n = t.clone();
          return n.value = null === n.value ? n._normalize(e) : i(n.value, e), n;
        },
        "Unit, Unit": function UnitUnit(t, e) {
          return t.multiply(e);
        }
      });
      return i;
    }

    e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = t.DenseMatrix,
          a = function a(t, e, n) {
        var a = t._size,
            u = t._datatype,
            c = e._size,
            l = e._datatype;
        if (a.length !== c.length) throw new i(a.length, c.length);
        if (a[0] !== c[0] || a[1] !== c[1]) throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + c + ")");
        var h,
            f = a[0],
            p = a[1],
            m = 0,
            d = n;
        "string" == typeof u && u === l && (h = u, m = r.convert(0, h), d = r.find(n, [h, h]));
        var g,
            v,
            y = [];

        for (g = 0; g < f; g++) {
          y[g] = [];
        }

        var x = new o({
          data: y,
          size: [f, p],
          datatype: h
        }),
            w = [],
            b = [],
            _ = [],
            E = [];

        for (v = 0; v < p; v++) {
          var M = v + 1;

          for (s(t, v, _, w, M), s(e, v, E, b, M), g = 0; g < f; g++) {
            var T = _[g] === M ? w[g] : m,
                N = E[g] === M ? b[g] : m;
            y[g][v] = d(T, N);
          }
        }

        return x;
      },
          s = function s(t, e, n, r, i) {
        for (var o = t._values, a = t._index, s = t._ptr, u = s[e], c = s[e + 1]; u < c; u++) {
          var l = a[u];
          n[l] = i, r[l] = o[u];
        }
      };

      return a;
    }

    var i = n(12);
    e.name = "algorithm07", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    e.array = n(8), e.boolean = n(547), e.function = n(32), e.number = n(3), e.object = n(5), e.string = n(23), e.types = n(70), e.emitter = n(158);
  },, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = n(4),
          m = a("larger", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t > e;
        },
        "number, number": function numberNumber(t, n) {
          return t > n && !i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return t.gt(n) && !o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return 1 === t.compare(e);
        },
        "Complex, Complex": function ComplexComplex() {
          throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return m(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t > e;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m);
                  break;

                default:
                  n = u(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, m, !1);
                  break;

                default:
                  n = h(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, m, !1);
              break;

            default:
              n = f(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, m, !0);
              break;

            default:
              n = f(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + p.operators.larger + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "larger", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = t.DenseMatrix,
          a = function a(t, e, n, _a4) {
        var s = t._data,
            u = t._size,
            c = t._datatype,
            l = e._values,
            h = e._index,
            f = e._ptr,
            p = e._size,
            m = e._datatype;
        if (u.length !== p.length) throw new i(u.length, p.length);
        if (u[0] !== p[0] || u[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + p + ")");
        if (!l) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
        var d,
            g,
            v = u[0],
            y = u[1],
            x = "string" == typeof c && c === m ? c : void 0,
            w = x ? r.find(n, [x, x]) : n,
            b = [];

        for (d = 0; d < v; d++) {
          b[d] = [];
        }

        var _ = [],
            E = [];

        for (g = 0; g < y; g++) {
          for (var M = g + 1, T = f[g], N = f[g + 1], S = T; S < N; S++) {
            d = h[S], _[d] = _a4 ? w(l[S], s[d][g]) : w(s[d][g], l[S]), E[d] = M;
          }

          for (d = 0; d < v; d++) {
            E[d] === M ? b[d][g] = _[d] : b[d][g] = s[d][g];
          }
        }

        return new o({
          data: b,
          size: [v, y],
          datatype: x
        });
      };

      return a;
    }

    var i = n(12);
    e.name = "algorithm01", e.factory = r;
  }, function (t, e) {
    e.memoize = function (t, e) {
      return function n() {
        "object" != typeof n.cache && (n.cache = {});

        for (var r = [], i = 0; i < arguments.length; i++) {
          r[i] = arguments[i];
        }

        var o = e ? e(r) : JSON.stringify(r);
        return o in n.cache ? n.cache[o] : n.cache[o] = t.apply(t, r);
      };
    }, e.maxArgumentCount = function (t) {
      return Object.keys(t.signatures || {}).reduce(function (t, e) {
        var n = (e.match(/,/g) || []).length + 1;
        return Math.max(t, n);
      }, -1);
    };
  }, function (t, e) {
    "use strict";

    function n(t) {
      return function () {
        return t;
      };
    }

    var r = function r() {};

    r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (t) {
      return t;
    }, t.exports = r;
  }, function (t, e, n) {
    var r = n(52);

    e.transform = function (t) {
      return t && t.isIndexError ? new r(t.index + 1, t.min + 1, void 0 !== t.max ? t.max + 1 : void 0) : t;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("abs", {
        number: Math.abs,
        Complex: function Complex(t) {
          return t.abs();
        },
        BigNumber: function BigNumber(t) {
          return t.abs();
        },
        Fraction: function Fraction(t) {
          return t.abs();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        },
        Unit: function Unit(t) {
          return t.abs();
        }
      });
      return o.toTex = {
        1: "\\left|${args[0]}\\right|"
      }, o;
    }

    var i = n(1);
    e.name = "abs", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      var i = t.DenseMatrix,
          o = function o(t, e, n, _o3) {
        var a = t._values,
            s = t._index,
            u = t._ptr,
            c = t._size,
            l = t._datatype;
        if (!a) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
        var h,
            f = c[0],
            p = c[1],
            m = n;
        "string" == typeof l && (h = l, e = r.convert(e, h), m = r.find(n, [h, h]));

        for (var d = [], g = new i({
          data: d,
          size: [f, p],
          datatype: h
        }), v = [], y = [], x = 0; x < p; x++) {
          for (var w = x + 1, b = u[x], _ = u[x + 1], E = b; E < _; E++) {
            var M = s[E];
            v[M] = a[E], y[M] = w;
          }

          for (var T = 0; T < f; T++) {
            0 === x && (d[T] = []), y[T] === w ? d[T][x] = _o3 ? m(e, v[T]) : m(v[T], e) : d[T][x] = e;
          }
        }

        return g;
      };

      return o;
    }

    e.name = "algorithm10", e.factory = n;
  }, function (t, e) {
    "use strict";

    t.exports = function (t, e, n) {
      if (null == n) return t.eq(e);
      if (t.eq(e)) return !0;
      if (t.isNaN() || e.isNaN()) return !1;

      if (t.isFinite() && e.isFinite()) {
        var r = t.minus(e).abs();
        if (r.isZero()) return !0;
        var i = t.constructor.max(t.abs(), e.abs());
        return r.lte(i.times(n));
      }

      return !1;
    };
  }, function (t, e) {
    "use strict";

    t.exports = function t(e, n) {
      e && e.isMatrix === !0 && (e = e.valueOf());

      for (var r = 0, i = e.length; r < i; r++) {
        var o = e[r];
        Array.isArray(o) ? t(o, n) : n(o);
      }
    };
  },, function (t, e, n) {
    "use strict";

    function r(t, e, r, o, a) {
      function s(t) {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
        if ("string" != typeof t) throw new TypeError('String expected for parameter "name"');
        this.name = t;
      }

      function u(t) {
        throw new Error("Undefined symbol " + t);
      }

      var c = r(n(14)),
          l = r(n(156));
      return s.prototype = new c(), s.prototype.type = "SymbolNode", s.prototype.isSymbolNode = !0, s.prototype._compile = function (t, e) {
        return t.undef = u, t.Unit = l, e[this.name] ? this.name : this.name in t.math ? '("' + this.name + '" in scope ? scope["' + this.name + '"] : math["' + this.name + '"])' : '("' + this.name + '" in scope ? scope["' + this.name + '"] : ' + (l.isValuelessUnit(this.name) ? 'new Unit(null, "' + this.name + '")' : 'undef("' + this.name + '")') + ")";
      }, s.prototype.forEach = function (t) {}, s.prototype.map = function (t) {
        return this.clone();
      }, s.prototype.clone = function () {
        return new s(this.name);
      }, s.prototype._toString = function (t) {
        return this.name;
      }, s.prototype._toTex = function (t) {
        var e = !1;
        "undefined" == typeof a[this.name] && l.isValuelessUnit(this.name) && (e = !0);
        var n = i.toSymbol(this.name, e);
        return "\\" === n[0] ? n : " " + n;
      }, s;
    }

    var i = n(4);
    e.name = "SymbolNode", e.path = "expression.node", e.math = !0, e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(20)),
          s = r(n(13)),
          u = r(n(135)),
          c = r(n(2)),
          l = r(n(16)),
          h = r(n(6)),
          f = o("divide", i({
        "Array | Matrix, Array | Matrix": function ArrayMatrixArrayMatrix(t, e) {
          return s(t, u(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, a, !1);
              break;

            case "dense":
              n = h(t, e, a, !1);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return h(c(t), e, a, !1).valueOf();
        },
        "any, Array | Matrix": function anyArrayMatrix(t, e) {
          return s(t, u(e));
        }
      }, a.signatures));
      return f.toTex = {
        2: "\\frac{${args[0]}}{${args[1]}}"
      }, f;
    }

    var i = n(5).extend;
    e.name = "divide", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(n, r) {
        if (e.predictable && !i(r) && n < 0) try {
          var o = m(r),
              a = d(o);
          if ((r === a || Math.abs((r - a) / r) < 1e-14) && o.d % 2 === 1) return (o.n % 2 === 0 ? 1 : -1) * Math.pow(-n, r);
        } catch (t) {}
        return i(r) || n >= 0 || e.predictable ? Math.pow(n, r) : new t.Complex(n, 0).pow(r, 0);
      }

      function u(t, e) {
        if (!i(e) || e < 0) throw new TypeError("For A^b, b must be a positive integer (value is " + e + ")");
        var n = o(t);
        if (2 != n.length) throw new Error("For A^b, A must be 2 dimensional (A has " + n.length + " dimensions)");
        if (n[0] != n[1]) throw new Error("For A^b, A must be square (size is " + n[0] + "x" + n[1] + ")");

        for (var r = h(n[0]).valueOf(), a = t; e >= 1;) {
          1 == (1 & e) && (r = f(a, r)), e >>= 1, a = f(a, a);
        }

        return r;
      }

      function c(t, e) {
        return p(u(t.valueOf(), e));
      }

      var l = n(4),
          h = r(n(81)),
          f = r(n(13)),
          p = r(n(2)),
          m = r(n(151)),
          d = r(n(89)),
          g = a("pow", {
        "number, number": s,
        "Complex, Complex": function ComplexComplex(t, e) {
          return t.pow(e);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, r) {
          return r.isInteger() || n >= 0 || e.predictable ? n.pow(r) : new t.Complex(n.toNumber(), 0).pow(r.toNumber(), 0);
        },
        "Fraction, Fraction": function FractionFraction(t, n) {
          if (1 !== n.d) {
            if (e.predictable) throw new Error("Function pow does not support non-integer exponents for fractions.");
            return s(t.valueOf(), n.valueOf());
          }

          return t.pow(n);
        },
        "Array, number": u,
        "Array, BigNumber": function ArrayBigNumber(t, e) {
          return u(t, e.toNumber());
        },
        "Matrix, number": c,
        "Matrix, BigNumber": function MatrixBigNumber(t, e) {
          return c(t, e.toNumber());
        },
        "Unit, number": function UnitNumber(t, e) {
          return t.pow(e);
        }
      });
      return g.toTex = {
        2: "\\left(${args[0]}\\right)" + l.operators.pow + "{${args[1]}}"
      }, g;
    }

    var i = n(3).isInteger,
        o = n(8).size;
    e.name = "pow", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = o("unaryMinus", {
        number: function number(t) {
          return -t;
        },
        Complex: function Complex(t) {
          return t.neg();
        },
        BigNumber: function BigNumber(t) {
          return t.neg();
        },
        Fraction: function Fraction(t) {
          return t.neg();
        },
        Unit: function Unit(t) {
          var e = t.clone();
          return e.value = s(t.value), e;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, s, !0);
        }
      });
      return s.toTex = {
        1: a.operators.unaryMinus + "\\left(${args[0]}\\right)"
      }, s;
    }

    var i = n(1);
    e.name = "unaryMinus", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(e, n) {
        var r = u(e),
            i = r ? new t.BigNumber(0) : 0;

        if (c(e), n) {
          var a = l(n);
          return e.length > 0 ? a.resize(e, i) : a;
        }

        var s = [];
        return e.length > 0 ? o(s, e, i) : s;
      }

      function u(t) {
        var e = !1;
        return t.forEach(function (t, n, r) {
          t && t.isBigNumber === !0 && (e = !0, r[n] = t.toNumber());
        }), e;
      }

      function c(t) {
        t.forEach(function (t) {
          if ("number" != typeof t || !i(t) || t < 0) throw new Error("Parameters in function zeros must be positive integers");
        });
      }

      var l = r(n(2)),
          h = a("zeros", {
        "": function _() {
          return "Array" === e.matrix ? s([]) : s([], "default");
        },
        "...number | BigNumber | string": function numberBigNumberString(t) {
          var n = t[t.length - 1];

          if ("string" == typeof n) {
            var r = t.pop();
            return s(t, r);
          }

          return "Array" === e.matrix ? s(t) : s(t, "default");
        },
        Array: s,
        Matrix: function Matrix(t) {
          var e = t.storage();
          return s(t.valueOf(), e);
        },
        "Array | Matrix, string": function ArrayMatrixString(t, e) {
          return s(t.valueOf(), e);
        }
      });
      return h.toTex = void 0, h;
    }

    var i = n(3).isInteger,
        o = n(8).resize;
    e.name = "zeros", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = n(4),
          m = a("smaller", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t < e;
        },
        "number, number": function numberNumber(t, n) {
          return t < n && !i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return t.lt(n) && !o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.compare(e) === -1;
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return m(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t < e;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m);
                  break;

                default:
                  n = u(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, m, !1);
                  break;

                default:
                  n = h(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, m, !1);
              break;

            default:
              n = f(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, m, !0);
              break;

            default:
              n = f(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + p.operators.smaller + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "smaller", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("isInteger", {
        number: o.isInteger,
        BigNumber: function BigNumber(t) {
          return t.isInt();
        },
        Fraction: function Fraction(t) {
          return 1 === t.d && isFinite(t.n);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        }
      });
      return a;
    }

    var i = n(1),
        o = n(3);
    e.name = "isInteger", e.factory = r;
  }, function (t, e) {
    "use strict";

    t.exports = function (t) {
      return Array.isArray(t) || t && t.isMatrix === !0;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return void 0 !== t.ref;
    }

    function i(t) {
      return void 0 !== t.key;
    }

    var o = n(21),
        a = n(49),
        s = (n(10), n(166), Object.prototype.hasOwnProperty),
        u = n(164),
        c = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    },
        l = function l(t, e, n, r, i, o, a) {
      var s = {
        $$typeof: u,
        type: t,
        key: e,
        ref: n,
        props: a,
        _owner: o
      };
      return s;
    };

    l.createElement = function (t, e, n) {
      var o,
          u = {},
          h = null,
          f = null,
          p = null,
          m = null;

      if (null != e) {
        r(e) && (f = e.ref), i(e) && (h = "" + e.key), p = void 0 === e.__self ? null : e.__self, m = void 0 === e.__source ? null : e.__source;

        for (o in e) {
          s.call(e, o) && !c.hasOwnProperty(o) && (u[o] = e[o]);
        }
      }

      var d = arguments.length - 2;
      if (1 === d) u.children = n;else if (d > 1) {
        for (var g = Array(d), v = 0; v < d; v++) {
          g[v] = arguments[v + 2];
        }

        u.children = g;
      }

      if (t && t.defaultProps) {
        var y = t.defaultProps;

        for (o in y) {
          void 0 === u[o] && (u[o] = y[o]);
        }
      }

      return l(t, h, f, p, m, a.current, u);
    }, l.createFactory = function (t) {
      var e = l.createElement.bind(null, t);
      return e.type = t, e;
    }, l.cloneAndReplaceKey = function (t, e) {
      var n = l(t.type, e, t.ref, t._self, t._source, t._owner, t.props);
      return n;
    }, l.cloneElement = function (t, e, n) {
      var u,
          h = o({}, t.props),
          f = t.key,
          p = t.ref,
          m = t._self,
          d = t._source,
          g = t._owner;

      if (null != e) {
        r(e) && (p = e.ref, g = a.current), i(e) && (f = "" + e.key);
        var v;
        t.type && t.type.defaultProps && (v = t.type.defaultProps);

        for (u in e) {
          s.call(e, u) && !c.hasOwnProperty(u) && (void 0 === e[u] && void 0 !== v ? h[u] = v[u] : h[u] = e[u]);
        }
      }

      var y = arguments.length - 2;
      if (1 === y) h.children = n;else if (y > 1) {
        for (var x = Array(y), w = 0; w < y; w++) {
          x[w] = arguments[w + 2];
        }

        h.children = x;
      }
      return l(t.type, f, p, m, d, g, h);
    }, l.isValidElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === u;
    }, t.exports = l;
  }, function (t, e) {
    "use strict";

    var n = {
      current: null
    };
    t.exports = n;
  }, function (t, e) {
    "use strict";

    function n(t) {
      for (var e = arguments.length - 1, n = "Minified React error #" + t + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant=" + t, r = 0; r < e; r++) {
        n += "&args[]=" + encodeURIComponent(arguments[r + 1]);
      }

      n += " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      var i = new Error(n);
      throw i.name = "Invariant Violation", i.framesToPop = 1, i;
    }

    t.exports = n;
  }, function (t, e) {
    "use strict";

    function n(t, e, r, i) {
      if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
      this.fn = t, this.count = e, this.min = r, this.max = i, this.message = "Wrong number of arguments in function " + t + " (" + e + " provided, " + r + (void 0 != i ? "-" + i : "") + " expected)", this.stack = new Error().stack;
    }

    n.prototype = new Error(), n.prototype.constructor = Error, n.prototype.name = "ArgumentsError", n.prototype.isArgumentsError = !0, t.exports = n;
  }, function (t, e) {
    "use strict";

    function n(t, e, r) {
      if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
      this.index = t, arguments.length < 3 ? (this.min = 0, this.max = e) : (this.min = e, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
    }

    n.prototype = new RangeError(), n.prototype.constructor = RangeError, n.prototype.name = "IndexError", n.prototype.isIndexError = !0, t.exports = n;
  }, function (t, e) {
    "use strict";

    function n(t, e) {
      var n = t;
      "keep" !== e && (n = t.getContent());

      for (var r = n.getIdentifier(), i = 0; i < o.length; i++) {
        if (r in o[i]) return i;
      }

      return null;
    }

    function r(t, e) {
      var r = t;
      "keep" !== e && (r = t.getContent());
      var i = r.getIdentifier(),
          a = n(r, e);
      if (null === a) return null;
      var s = o[a][i];

      if (s.hasOwnProperty("associativity")) {
        if ("left" === s.associativity) return "left";
        if ("right" === s.associativity) return "right";
        throw Error("'" + i + "' has the invalid associativity '" + s.associativity + "'.");
      }

      return null;
    }

    function i(t, e, r) {
      var i = t,
          a = e;
      if ("keep" !== r) var i = t.getContent(),
          a = e.getContent();
      var s = i.getIdentifier(),
          u = a.getIdentifier(),
          c = n(i, r);
      if (null === c) return null;
      var l = o[c][s];

      if (l.hasOwnProperty("associativeWith") && l.associativeWith instanceof Array) {
        for (var h = 0; h < l.associativeWith.length; h++) {
          if (l.associativeWith[h] === u) return !0;
        }

        return !1;
      }

      return null;
    }

    var o = [{
      AssignmentNode: {},
      FunctionAssignmentNode: {}
    }, {
      ConditionalNode: {
        latexLeftParens: !1,
        latexRightParens: !1,
        latexParens: !1
      }
    }, {
      "OperatorNode:or": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:xor": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:and": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:bitOr": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:bitXor": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:bitAnd": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:equal": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:unequal": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:smaller": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:larger": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:smallerEq": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:largerEq": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:leftShift": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:rightArithShift": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:rightLogShift": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:to": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      RangeNode: {}
    }, {
      "OperatorNode:add": {
        associativity: "left",
        associativeWith: ["OperatorNode:add", "OperatorNode:subtract"]
      },
      "OperatorNode:subtract": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:multiply": {
        associativity: "left",
        associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
      },
      "OperatorNode:divide": {
        associativity: "left",
        associativeWith: [],
        latexLeftParens: !1,
        latexRightParens: !1,
        latexParens: !1
      },
      "OperatorNode:dotMultiply": {
        associativity: "left",
        associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"]
      },
      "OperatorNode:dotDivide": {
        associativity: "left",
        associativeWith: []
      },
      "OperatorNode:mod": {
        associativity: "left",
        associativeWith: []
      }
    }, {
      "OperatorNode:unaryPlus": {
        associativity: "right"
      },
      "OperatorNode:unaryMinus": {
        associativity: "right"
      },
      "OperatorNode:bitNot": {
        associativity: "right"
      },
      "OperatorNode:not": {
        associativity: "right"
      }
    }, {
      "OperatorNode:pow": {
        associativity: "right",
        associativeWith: [],
        latexRightParens: !1
      },
      "OperatorNode:dotPow": {
        associativity: "right",
        associativeWith: []
      }
    }, {
      "OperatorNode:factorial": {
        associativity: "left"
      }
    }, {
      "OperatorNode:transpose": {
        associativity: "left"
      }
    }];
    t.exports.properties = o, t.exports.getPrecedence = n, t.exports.getAssociativity = r, t.exports.isAssociativeWith = i;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(e, n) {
        if (1 != arguments.length && 2 != arguments.length) throw new i("parse", arguments.length, 1, 2);
        if (pt = n && n.nodes ? n.nodes : {}, "string" == typeof e) return mt = e, v();
        if (Array.isArray(e) || e instanceof t.Matrix) return o(e, function (t) {
          if ("string" != typeof t) throw new TypeError("String expected");
          return mt = t, v();
        });
        throw new TypeError("String or matrix expected");
      }

      function u() {
        gt = 0, vt = mt.charAt(0), wt = 0, bt = null;
      }

      function c() {
        gt++, vt = mt.charAt(gt);
      }

      function l() {
        return mt.charAt(gt - 1);
      }

      function h() {
        return mt.charAt(gt + 1);
      }

      function f() {
        return mt.charAt(gt + 2);
      }

      function p() {
        for (xt = lt.NULL, yt = "", dt = ""; s.isWhitespace(vt, wt);) {
          c();
        }

        if ("#" == vt) for (; "\n" != vt && "" != vt;) {
          dt += vt, c();
        }
        if ("" == vt) return void (xt = lt.DELIMITER);
        if ("\n" == vt && !wt) return xt = lt.DELIMITER, yt = vt, void c();
        var t = vt + h(),
            e = t + f();
        if (3 == e.length && ht[e]) return xt = lt.DELIMITER, yt = e, c(), c(), void c();
        if (2 == t.length && ht[t]) return xt = lt.DELIMITER, yt = t, c(), void c();
        if (ht[vt]) return xt = lt.DELIMITER, yt = vt, void c();

        if (!s.isDigitDot(vt)) {
          if (s.isAlpha(vt, l(), h())) {
            for (; s.isAlpha(vt, l(), h()) || s.isDigit(vt);) {
              yt += vt, c();
            }

            return void (xt = ft.hasOwnProperty(yt) ? lt.DELIMITER : lt.SYMBOL);
          }

          for (xt = lt.UNKNOWN; "" != vt;) {
            yt += vt, c();
          }

          throw Z('Syntax error in part "' + yt + '"');
        }

        if (xt = lt.NUMBER, "." == vt) yt += vt, c(), s.isDigit(vt) || (xt = lt.DELIMITER);else {
          for (; s.isDigit(vt);) {
            yt += vt, c();
          }

          s.isDecimalMark(vt, h()) && (yt += vt, c());
        }

        for (; s.isDigit(vt);) {
          yt += vt, c();
        }

        if (t = h(), "E" == vt || "e" == vt) if (s.isDigit(t) || "-" == t || "+" == t) {
          if (yt += vt, c(), "+" != vt && "-" != vt || (yt += vt, c()), !s.isDigit(vt)) throw Z('Digit expected, got "' + vt + '"');

          for (; s.isDigit(vt);) {
            yt += vt, c();
          }

          if (s.isDecimalMark(vt, h())) throw Z('Digit expected, got "' + vt + '"');
        } else if ("." == t) throw c(), Z('Digit expected, got "' + vt + '"');
      }

      function m() {
        do {
          p();
        } while ("\n" == yt);
      }

      function d() {
        wt++;
      }

      function g() {
        wt--;
      }

      function v() {
        u(), p();
        var t = y();
        if ("" != yt) throw xt == lt.DELIMITER ? X("Unexpected operator " + yt) : Z('Unexpected part "' + yt + '"');
        return t;
      }

      function y() {
        var t,
            e,
            n = [];
        if ("" == yt) return t = new et("undefined", "undefined"), t.comment = dt, t;

        for ("\n" != yt && ";" != yt && (t = x(), t.comment = dt); "\n" == yt || ";" == yt;) {
          0 == n.length && t && (e = ";" != yt, n.push({
            node: t,
            visible: e
          })), p(), "\n" != yt && ";" != yt && "" != yt && (t = x(), t.comment = dt, e = ";" != yt, n.push({
            node: t,
            visible: e
          }));
        }

        return n.length > 0 ? new Q(n) : t;
      }

      function x() {
        var t,
            e,
            n,
            r,
            i = w();

        if ("=" == yt) {
          if (i && i.isSymbolNode) return t = i.name, m(), n = x(), new J(new ct(t), n);
          if (i && i.isAccessorNode) return m(), n = x(), new J(i.object, i.index, n);
          if (i && i.isFunctionNode && (r = !0, e = [], t = i.name, i.args.forEach(function (t, n) {
            t && t.isSymbolNode ? e[n] = t.name : r = !1;
          }), r)) return m(), n = x(), new nt(t, e, n);
          throw Z("Invalid left hand side of assignment operator =");
        }

        return i;
      }

      function w() {
        for (var t = b(); "?" == yt;) {
          var e = bt;
          bt = wt, m();
          var n = t,
              r = x();
          if (":" != yt) throw Z("False part of conditional expression expected");
          bt = null, m();
          var i = x();
          t = new tt(n, r, i), bt = e;
        }

        return t;
      }

      function b() {
        for (var t = _(); "or" == yt;) {
          m(), t = new ot("or", "or", [t, _()]);
        }

        return t;
      }

      function _() {
        for (var t = E(); "xor" == yt;) {
          m(), t = new ot("xor", "xor", [t, E()]);
        }

        return t;
      }

      function E() {
        for (var t = M(); "and" == yt;) {
          m(), t = new ot("and", "and", [t, M()]);
        }

        return t;
      }

      function M() {
        for (var t = T(); "|" == yt;) {
          m(), t = new ot("|", "bitOr", [t, T()]);
        }

        return t;
      }

      function T() {
        for (var t = N(); "^|" == yt;) {
          m(), t = new ot("^|", "bitXor", [t, N()]);
        }

        return t;
      }

      function N() {
        for (var t = S(); "&" == yt;) {
          m(), t = new ot("&", "bitAnd", [t, S()]);
        }

        return t;
      }

      function S() {
        var t, e, n, r, i;

        for (t = A(), e = {
          "==": "equal",
          "!=": "unequal",
          "<": "smaller",
          ">": "larger",
          "<=": "smallerEq",
          ">=": "largerEq"
        }; (yt in e);) {
          n = yt, r = e[n], m(), i = [t, A()], t = new ot(n, r, i);
        }

        return t;
      }

      function A() {
        var t, e, n, r, i;

        for (t = O(), e = {
          "<<": "leftShift",
          ">>": "rightArithShift",
          ">>>": "rightLogShift"
        }; (yt in e);) {
          n = yt, r = e[n], m(), i = [t, O()], t = new ot(n, r, i);
        }

        return t;
      }

      function O() {
        var t, e, n, r, i;

        for (t = C(), e = {
          to: "to",
          in: "to"
        }; (yt in e);) {
          n = yt, r = e[n], m(), "in" === n && "" === yt ? t = new ot("*", "multiply", [t, new ct("in")], !0) : (i = [t, C()], t = new ot(n, r, i));
        }

        return t;
      }

      function C() {
        var t,
            e = [];

        if (t = ":" == yt ? new et("1", "number") : P(), ":" == yt && bt !== wt) {
          for (e.push(t); ":" == yt && e.length < 3;) {
            m(), ")" == yt || "]" == yt || "," == yt || "" == yt ? e.push(new ct("end")) : e.push(P());
          }

          t = 3 == e.length ? new ut(e[0], e[2], e[1]) : new ut(e[0], e[1]);
        }

        return t;
      }

      function P() {
        var t, e, n, r, i;

        for (t = R(), e = {
          "+": "add",
          "-": "subtract"
        }; (yt in e);) {
          n = yt, r = e[n], m(), i = [t, R()], t = new ot(n, r, i);
        }

        return t;
      }

      function R() {
        var t, e, n, r, i;

        for (t = I(), e = t, n = {
          "*": "multiply",
          ".*": "dotMultiply",
          "/": "divide",
          "./": "dotDivide",
          "%": "mod",
          mod: "mod"
        };;) {
          if (yt in n) r = yt, i = n[r], m(), e = I(), t = new ot(r, i, [t, e]);else {
            if (!(xt == lt.SYMBOL || "in" == yt && t && t.isConstantNode) && (xt != lt.NUMBER || e.isConstantNode || e.isOperatorNode && "!" !== e.op) && "(" != yt) break;
            e = I(), t = new ot("*", "multiply", [t, e], !0);
          }
        }

        return t;
      }

      function I() {
        var t,
            e,
            n = {
          "-": "unaryMinus",
          "+": "unaryPlus",
          "~": "bitNot",
          not: "not"
        }[yt];
        return n ? (t = yt, m(), e = [I()], new ot(t, n, e)) : k();
      }

      function k() {
        var t, e, n, r;
        return t = z(), "^" != yt && ".^" != yt || (e = yt, n = "^" == e ? "pow" : "dotPow", m(), r = [t, I()], t = new ot(e, n, r)), t;
      }

      function z() {
        var t, e, n, r, i;

        for (t = B(), e = {
          "!": "factorial",
          "'": "transpose"
        }; (yt in e);) {
          n = yt, r = e[n], p(), i = [t], t = new ot(n, r, i), t = D(t);
        }

        return t;
      }

      function B() {
        var t,
            e = [];

        if (xt == lt.SYMBOL && pt[yt]) {
          if (t = pt[yt], p(), "(" == yt) {
            if (e = [], d(), p(), ")" != yt) for (e.push(x()); "," == yt;) {
              p(), e.push(x());
            }
            if (")" != yt) throw Z("Parenthesis ) expected");
            g(), p();
          }

          return new t(e);
        }

        return L();
      }

      function L() {
        var t, e;
        return xt == lt.SYMBOL || xt == lt.DELIMITER && yt in ft ? (e = yt, p(), t = new ct(e), t = D(t)) : j();
      }

      function D(t, e) {
        for (var n; !("(" != yt && "[" != yt && "." != yt || e && e.indexOf(yt) === -1);) {
          if (n = [], "(" == yt) {
            if (!t.isSymbolNode && !t.isAccessorNode) return t;
            if (d(), p(), ")" != yt) for (n.push(x()); "," == yt;) {
              p(), n.push(x());
            }
            if (")" != yt) throw Z("Parenthesis ) expected");
            g(), p(), t = new st(t, n);
          } else if ("[" == yt) {
            if (d(), p(), "]" != yt) for (n.push(x()); "," == yt;) {
              p(), n.push(x());
            }
            if ("]" != yt) throw Z("Parenthesis ] expected");
            g(), p(), t = new Y(t, new rt(n));
          } else {
            if (p(), xt != lt.SYMBOL) throw Z("Property name expected after dot");
            n.push(new et(yt)), p();
            var r = !0;
            t = new Y(t, new rt(n, r));
          }
        }

        return t;
      }

      function j() {
        var t, e;
        return '"' == yt ? (e = F(), t = new et(e, "string"), t = D(t)) : U();
      }

      function F() {
        for (var t = ""; "" != vt && '"' != vt;) {
          "\\" == vt && (t += vt, c()), t += vt, c();
        }

        if (p(), '"' != yt) throw Z('End of string " expected');
        return p(), t;
      }

      function U() {
        var t, e, n, r;

        if ("[" == yt) {
          if (d(), p(), "]" != yt) {
            var i = q();

            if (";" == yt) {
              for (n = 1, e = [i]; ";" == yt;) {
                p(), e[n] = q(), n++;
              }

              if ("]" != yt) throw Z("End of matrix ] expected");
              g(), p(), r = e[0].items.length;

              for (var o = 1; o < n; o++) {
                if (e[o].items.length != r) throw X("Column dimensions mismatch (" + e[o].items.length + " != " + r + ")");
              }

              t = new K(e);
            } else {
              if ("]" != yt) throw Z("End of matrix ] expected");
              g(), p(), t = i;
            }
          } else g(), p(), t = new K([]);

          return D(t);
        }

        return H();
      }

      function q() {
        for (var t = [x()], e = 1; "," == yt;) {
          p(), t[e] = x(), e++;
        }

        return new K(t);
      }

      function H() {
        if ("{" == yt) {
          var t,
              e = {};

          do {
            if (p(), "}" != yt) {
              if ('"' == yt) t = F();else {
                if (xt != lt.SYMBOL) throw Z("Symbol or string expected as object key");
                t = yt, p();
              }
              if (":" != yt) throw Z("Colon : expected after object key");
              p(), e[t] = x();
            }
          } while ("," == yt);

          if ("}" != yt) throw Z("Comma , or bracket } expected after object value");
          p();
          var n = new it(e);
          return n = D(n);
        }

        return W();
      }

      function W() {
        var t;
        return xt == lt.NUMBER ? (t = yt, p(), new et(t, "number")) : G();
      }

      function G() {
        var t;

        if ("(" == yt) {
          if (d(), p(), t = x(), ")" != yt) throw Z("Parenthesis ) expected");
          return g(), p(), t = new at(t), t = D(t);
        }

        return $();
      }

      function $() {
        throw Z("" == yt ? "Unexpected end of expression" : "Value expected");
      }

      function V() {
        return gt - yt.length + 1;
      }

      function Z(t) {
        var e = V(),
            n = new SyntaxError(t + " (char " + e + ")");
        return n.char = e, n;
      }

      function X(t) {
        var e = V(),
            n = new SyntaxError(t + " (char " + e + ")");
        return n.char = e, n;
      }

      var Y = r(n(109)),
          K = r(n(75)),
          J = r(n(110)),
          Q = r(n(111)),
          tt = r(n(112)),
          et = r(n(76)),
          nt = r(n(113)),
          rt = r(n(114)),
          it = r(n(115)),
          ot = r(n(116)),
          at = r(n(117)),
          st = r(n(77)),
          ut = r(n(78)),
          ct = r(n(40)),
          lt = {
        NULL: 0,
        DELIMITER: 1,
        NUMBER: 2,
        SYMBOL: 3,
        UNKNOWN: 4
      },
          ht = {
        ",": !0,
        "(": !0,
        ")": !0,
        "[": !0,
        "]": !0,
        "{": !0,
        "}": !0,
        '"': !0,
        ";": !0,
        "+": !0,
        "-": !0,
        "*": !0,
        ".*": !0,
        "/": !0,
        "./": !0,
        "%": !0,
        "^": !0,
        ".^": !0,
        "~": !0,
        "!": !0,
        "&": !0,
        "|": !0,
        "^|": !0,
        "'": !0,
        "=": !0,
        ":": !0,
        "?": !0,
        "==": !0,
        "!=": !0,
        "<": !0,
        ">": !0,
        "<=": !0,
        ">=": !0,
        "<<": !0,
        ">>": !0,
        ">>>": !0
      },
          ft = {
        mod: !0,
        to: !0,
        in: !0,
        and: !0,
        xor: !0,
        or: !0,
        not: !0
      },
          pt = {},
          mt = "",
          dt = "",
          gt = 0,
          vt = "",
          yt = "",
          xt = lt.NULL,
          wt = 0,
          bt = null;
      return s.isAlpha = function (t, e, n) {
        return s.isValidLatinOrGreek(t) || s.isValidMathSymbol(t, n) || s.isValidMathSymbol(e, t);
      }, s.isValidLatinOrGreek = function (t) {
        return /^[a-zA-Z_\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(t);
      }, s.isValidMathSymbol = function (t, e) {
        return /^[\uD835]$/.test(t) && /^[\uDC00-\uDFFF]$/.test(e) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(e);
      }, s.isWhitespace = function (t, e) {
        return " " == t || "\t" == t || "\n" == t && e > 0;
      }, s.isDecimalMark = function (t, e) {
        return "." == t && "/" !== e && "*" !== e && "^" !== e;
      }, s.isDigitDot = function (t) {
        return t >= "0" && t <= "9" || "." == t;
      }, s.isDigit = function (t) {
        return t >= "0" && t <= "9";
      }, s;
    }

    var i = n(51),
        o = n(1);
    e.name = "parse", e.path = "expression", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(66)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = a("compare", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t === e ? 0 : t > e ? 1 : -1;
        },
        "number, number": function numberNumber(t, n) {
          return t === n || i(t, n, e.epsilon) ? 0 : t > n ? 1 : -1;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(n, r) {
          return n.eq(r) || o(n, r, e.epsilon) ? new t.BigNumber(0) : new t.BigNumber(n.cmp(r));
        },
        "Fraction, Fraction": function FractionFraction(e, n) {
          return new t.Fraction(e.compare(n));
        },
        "Complex, Complex": function ComplexComplex() {
          throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return p(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t === e ? 0 : t > e ? 1 : -1;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, p);
                  break;

                default:
                  n = u(e, t, p, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, p, !1);
                  break;

                default:
                  n = h(t, e, p);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, p, !1);
              break;

            default:
              n = f(t, e, p, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, p, !0);
              break;

            default:
              n = f(e, t, p, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, p, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, p, !0).valueOf();
        }
      });
      return p.toTex = void 0, p;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "compare", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isNegative", {
        number: function number(t) {
          return t < 0;
        },
        BigNumber: function BigNumber(t) {
          return t.isNeg() && !t.isZero() && !t.isNaN();
        },
        Fraction: function Fraction(t) {
          return t.s < 0;
        },
        Unit: function Unit(t) {
          return o(t.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    n(3);
    e.name = "isNegative", e.factory = r;
  },,, function (t, e, n) {
    "use strict";

    var r = {};
    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      function o(n) {
        return n >= 0 || e.predictable ? Math.sqrt(n) : new t.Complex(n, 0).sqrt();
      }

      var a = r("sqrt", {
        number: o,
        Complex: function Complex(t) {
          return t.sqrt();
        },
        BigNumber: function BigNumber(t) {
          return !t.isNegative() || e.predictable ? t.sqrt() : o(t.toNumber());
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a, !0);
        },
        Unit: function Unit(t) {
          return t.pow(.5);
        }
      });
      return a.toTex = {
        1: "\\sqrt{${args[0]}}"
      }, a;
    }

    var i = n(1);
    e.name = "sqrt", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, c) {
      function l(t, e) {
        if (!e || e.isIndex !== !0) throw new TypeError("Index expected");
        if (1 != e.size().length) throw new u(e.size().length, 1);
        var n = t.length;
        s(e.min()[0], n), s(e.max()[0], n);
        var r = e.dimension(0),
            i = "";
        return r.forEach(function (e) {
          i += t.charAt(e);
        }), i;
      }

      function h(t, e, n, r) {
        if (!e || e.isIndex !== !0) throw new TypeError("Index expected");
        if (1 != e.size().length) throw new u(e.size().length, 1);

        if (void 0 !== r) {
          if ("string" != typeof r || 1 !== r.length) throw new TypeError("Single character expected as defaultValue");
        } else r = " ";

        var i = e.dimension(0),
            o = i.size()[0];
        if (o != n.length) throw new u(i.size()[0], n.length);
        var a = t.length;
        s(e.min()[0]), s(e.max()[0]);

        for (var c = [], l = 0; l < a; l++) {
          c[l] = t.charAt(l);
        }

        if (i.forEach(function (t, e) {
          c[t] = n.charAt(e[0]);
        }), c.length > a) for (l = a - 1, o = c.length; l < o; l++) {
          c[l] || (c[l] = r);
        }
        return c.join("");
      }

      var f = r(n(2)),
          p = c("subset", {
        "Array, Index": function ArrayIndex(t, e) {
          var n = f(t),
              r = n.subset(e);
          return r && r.valueOf();
        },
        "Matrix, Index": function MatrixIndex(t, e) {
          return t.subset(e);
        },
        "Object, Index": i,
        "string, Index": l,
        "Array, Index, any": function ArrayIndexAny(t, e, n) {
          return f(a(t)).subset(e, n, void 0).valueOf();
        },
        "Array, Index, any, any": function ArrayIndexAnyAny(t, e, n, r) {
          return f(a(t)).subset(e, n, r).valueOf();
        },
        "Matrix, Index, any": function MatrixIndexAny(t, e, n) {
          return t.clone().subset(e, n);
        },
        "Matrix, Index, any, any": function MatrixIndexAnyAny(t, e, n, r) {
          return t.clone().subset(e, n, r);
        },
        "string, Index, string": h,
        "string, Index, string, string": h,
        "Object, Index, any": o
      });
      return p.toTex = void 0, p;
    }

    function i(t, e) {
      if (1 !== e.size().length) throw new u(e.size(), 1);
      var n = e.dimension(0);
      if ("string" != typeof n) throw new TypeError("String expected as index to retrieve an object property");
      return t[n];
    }

    function o(t, e, n) {
      if (1 !== e.size().length) throw new u(e.size(), 1);
      var r = e.dimension(0);
      if ("string" != typeof r) throw new TypeError("String expected as index to retrieve an object property");
      var i = a(t);
      return i[r] = n, i;
    }

    var a = n(5).clone,
        s = n(8).validateIndex,
        u = n(12);
    e.name = "subset", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = t.DenseMatrix,
          l = t.SparseMatrix,
          h = a("transpose", {
        Array: function Array(t) {
          return h(u(t)).valueOf();
        },
        Matrix: function Matrix(t) {
          var e,
              n = t.size();

          switch (n.length) {
            case 1:
              e = t.clone();
              break;

            case 2:
              var r = n[0],
                  i = n[1];
              if (0 === i) throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + o(n) + ")");

              switch (t.storage()) {
                case "dense":
                  e = f(t, r, i);
                  break;

                case "sparse":
                  e = p(t, r, i);
              }

              break;

            default:
              throw new RangeError("Matrix must be a vector or two dimensional (size: " + o(this._size) + ")");
          }

          return e;
        },
        any: function any(t) {
          return i(t);
        }
      }),
          f = function f(t, e, n) {
        for (var r, o = t._data, a = [], s = 0; s < n; s++) {
          r = a[s] = [];

          for (var u = 0; u < e; u++) {
            r[u] = i(o[u][s]);
          }
        }

        return new c({
          data: a,
          size: [n, e],
          datatype: t._datatype
        });
      },
          p = function p(t, e, n) {
        for (var r = t._values, o = t._index, a = t._ptr, s = r ? [] : void 0, u = [], c = [], h = [], f = 0; f < e; f++) {
          h[f] = 0;
        }

        var p, m, d;

        for (p = 0, m = o.length; p < m; p++) {
          h[o[p]]++;
        }

        for (var g = 0, v = 0; v < e; v++) {
          c.push(g), g += h[v], h[v] = c[v];
        }

        for (c.push(g), d = 0; d < n; d++) {
          for (var y = a[d], x = a[d + 1], w = y; w < x; w++) {
            var b = h[o[w]]++;
            u[b] = d, r && (s[b] = i(r[w]));
          }
        }

        return new l({
          values: s,
          index: u,
          ptr: c,
          size: [n, e],
          datatype: t._datatype
        });
      };

      return h.toTex = {
        1: "\\left(${args[0]}\\right)" + s.operators.transpose
      }, h;
    }

    var i = n(5).clone,
        o = n(23).format;
    e.name = "transpose", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("combinations", {
        "number, number": function numberNumber(t, e) {
          var n, r, i;
          if (!o(t) || t < 0) throw new TypeError("Positive integer value expected in function combinations");
          if (!o(e) || e < 0) throw new TypeError("Positive integer value expected in function combinations");
          if (e > t) throw new TypeError("k must be less than or equal to n");

          for (n = Math.max(e, t - e), r = 1, i = 1; i <= t - n; i++) {
            r = r * (n + i) / i;
          }

          return r;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(e, n) {
          var r,
              o,
              a,
              s,
              u = new t.BigNumber(1);
          if (!i(e) || !i(n)) throw new TypeError("Positive integer value expected in function combinations");
          if (n.gt(e)) throw new TypeError("k must be less than n in function combinations");

          for (r = e.minus(n), n.lt(r) && (r = n), o = u, a = u, s = e.minus(r); a.lte(s); a = a.plus(1)) {
            o = o.times(r.plus(a)).dividedBy(a);
          }

          return o;
        }
      });
      return a.toTex = {
        2: "\\binom{${args[0]}}{${args[1]}}"
      }, a;
    }

    function i(t) {
      return t.isInteger() && t.gte(0);
    }

    var o = n(3).isInteger;
    e.name = "combinations", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(139)),
          s = n(4),
          u = o("factorial", {
        number: function number(t) {
          if (t < 0) throw new Error("Value must be non-negative");
          return a(t + 1);
        },
        BigNumber: function BigNumber(t) {
          if (t.isNegative()) throw new Error("Value must be non-negative");
          return a(t.plus(1));
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, u);
        }
      });
      return u.toTex = {
        1: "\\left(${args[0]}\\right)" + s.operators.factorial
      }, u;
    }

    var i = n(1);
    e.name = "factorial", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isPositive", {
        number: function number(t) {
          return t > 0;
        },
        BigNumber: function BigNumber(t) {
          return !t.isNeg() && !t.isZero() && !t.isNaN();
        },
        Fraction: function Fraction(t) {
          return t.s > 0 && t.n > 0;
        },
        Unit: function Unit(t) {
          return o(t.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    n(3);
    e.name = "isPositive", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(11)),
          s = t.SparseMatrix,
          u = function u(t, e, n) {
        var r = t._values,
            u = t._index,
            c = t._ptr,
            l = t._size,
            h = t._datatype,
            f = e._values,
            p = e._index,
            m = e._ptr,
            d = e._size,
            g = e._datatype;
        if (l.length !== d.length) throw new i(l.length, d.length);
        if (l[0] !== d[0] || l[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + l + ") must match Matrix B (" + d + ")");
        var v,
            y = l[0],
            x = l[1],
            w = a,
            b = 0,
            _ = n;
        "string" == typeof h && h === g && (v = h, w = o.find(a, [v, v]), b = o.convert(0, v), _ = o.find(n, [v, v]));
        var E,
            M,
            T,
            N,
            S = r && f ? [] : void 0,
            A = [],
            O = [],
            C = new s({
          values: S,
          index: A,
          ptr: O,
          size: [y, x],
          datatype: v
        }),
            P = S ? [] : void 0,
            R = S ? [] : void 0,
            I = [],
            k = [];

        for (M = 0; M < x; M++) {
          O[M] = A.length;
          var z = M + 1;

          for (T = c[M], N = c[M + 1]; T < N; T++) {
            E = u[T], A.push(E), I[E] = z, P && (P[E] = r[T]);
          }

          for (T = m[M], N = m[M + 1]; T < N; T++) {
            E = p[T], I[E] !== z && A.push(E), k[E] = z, R && (R[E] = f[T]);
          }

          if (S) for (T = O[M]; T < A.length;) {
            E = A[T];
            var B = I[E],
                L = k[E];

            if (B === z || L === z) {
              var D = B === z ? P[E] : b,
                  j = L === z ? R[E] : b,
                  F = _(D, j);

              w(F, b) ? A.splice(T, 1) : (S.push(F), T++);
            }
          }
        }

        return O[x] = A.length, C;
      };

      return u;
    }

    var i = n(12);
    e.name = "algorithm05", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(11)),
          u = t.SparseMatrix,
          c = function c(t, e, n) {
        var r = t._values,
            c = t._size,
            l = t._datatype,
            h = e._values,
            f = e._size,
            p = e._datatype;
        if (c.length !== f.length) throw new o(c.length, f.length);
        if (c[0] !== f[0] || c[1] !== f[1]) throw new RangeError("Dimension mismatch. Matrix A (" + c + ") must match Matrix B (" + f + ")");
        var m,
            d = c[0],
            g = c[1],
            v = s,
            y = 0,
            x = n;
        "string" == typeof l && l === p && (m = l, v = a.find(s, [m, m]), y = a.convert(0, m), x = a.find(n, [m, m]));

        for (var w = r && h ? [] : void 0, b = [], _ = [], E = new u({
          values: w,
          index: b,
          ptr: _,
          size: [d, g],
          datatype: m
        }), M = w ? [] : void 0, T = [], N = [], S = 0; S < g; S++) {
          _[S] = b.length;
          var A = S + 1;
          if (i(t, S, T, M, N, A, E, x), i(e, S, T, M, N, A, E, x), M) for (var O = _[S]; O < b.length;) {
            var C = b[O];

            if (N[C] === A) {
              var P = M[C];
              v(P, y) ? b.splice(O, 1) : (w.push(P), O++);
            } else b.splice(O, 1);
          } else for (var R = _[S]; R < b.length;) {
            var I = b[R];
            N[I] !== A ? b.splice(R, 1) : R++;
          }
        }

        return _[g] = b.length, E;
      };

      return c;
    }

    var i = n(548),
        o = n(12);
    e.name = "algorithm06", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    var r = n(47);

    t.exports = function (t) {
      for (var e = 0; e < t.length; e++) {
        if (r(t[e])) return !0;
      }

      return !1;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n) {
      var o, a, s, u;

      if (e <= 0) {
        if (Array.isArray(t[0])) {
          for (u = i(t), a = [], o = 0; o < u.length; o++) {
            a[o] = r(u[o], e - 1, n);
          }

          return a;
        }

        for (s = t[0], o = 1; o < t.length; o++) {
          s = n(s, t[o]);
        }

        return s;
      }

      for (a = [], o = 0; o < t.length; o++) {
        a[o] = r(t[o], e - 1, n);
      }

      return a;
    }

    function i(t) {
      var e,
          n,
          r = t.length,
          i = t[0].length,
          o = [];

      for (n = 0; n < i; n++) {
        var a = [];

        for (e = 0; e < r; e++) {
          a.push(t[e][n]);
        }

        o.push(a);
      }

      return o;
    }

    var o = n(8).size,
        a = n(52);

    t.exports = function (t, e, n) {
      var i = Array.isArray(t) ? o(t) : t.size();
      if (e < 0 || e >= i.length) throw new a(e, i.length);
      return t && t.isMatrix === !0 ? t.create(r(t.valueOf(), e, n)) : r(t, e, n);
    };
  }, function (t, e) {
    "use strict";

    e.type = function (t) {
      var e = typeof t;
      return "object" === e ? null === t ? "null" : t instanceof Boolean ? "boolean" : t instanceof Number ? "number" : t instanceof String ? "string" : Array.isArray(t) ? "Array" : t instanceof Date ? "Date" : t instanceof RegExp ? "RegExp" : "Object" : "function" === e ? "Function" : e;
    }, e.isScalar = function (t) {
      return !(t && t.isMatrix || Array.isArray(t));
    };
  },, function (t, e, n) {
    "use strict";

    var r = n(21),
        i = n(569),
        o = n(94),
        a = n(574),
        s = n(570),
        u = n(571),
        c = n(48),
        l = n(572),
        h = n(575),
        f = n(576),
        p = (n(10), c.createElement),
        m = c.createFactory,
        d = c.cloneElement,
        g = r,
        v = {
      Children: {
        map: i.map,
        forEach: i.forEach,
        count: i.count,
        toArray: i.toArray,
        only: f
      },
      Component: o,
      PureComponent: a,
      createElement: p,
      cloneElement: d,
      isValidElement: c.isValidElement,
      PropTypes: l,
      createClass: s.createClass,
      createFactory: m,
      createMixin: function createMixin(t) {
        return t;
      },
      DOM: u,
      version: h,
      __spread: g
    };
    t.exports = v;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.translate = e.boundingBoxMapping = e.utm2ll = e.ll2utm = e.simpleDistance = e.haversine = void 0;

    var i = n(550),
        o = r(i),
        a = n(103),
        s = r(a),
        u = n(92),
        c = r(u),
        l = function l(t) {
      return t * Math.PI / 180;
    },
        h = (e.haversine = function (t, e) {
      var n = 6371,
          r = l(e.latitude - t.latitude),
          i = l(e.longitude - t.longitude),
          o = Math.sin(r / 2) * Math.sin(r / 2) + Math.cos(l(t.latitude)) * Math.cos(l(e.latitude)) * Math.sin(i / 2) * Math.sin(i / 2),
          a = 2 * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o)),
          s = n * a;
      return Math.round(1e3 * s);
    }, e.simpleDistance = function (t, e) {
      var n = e.x - t.x,
          r = e.y - t.y;
      return Math.sqrt(n * n + r * r);
    }, e.ll2utm = function (t, e) {
      var n = t.longitude,
          r = t.latitude;
      return (0, o.default)("WGS84", e, {
        x: n,
        y: r
      });
    }),
        f = (e.utm2ll = function (t, e) {
      var n = t.x,
          r = t.y,
          i = (0, o.default)(e, "WGS84", {
        x: n,
        y: r
      });
      return {
        longitude: i.x,
        latitude: i.y
      };
    }, e.boundingBoxMapping = function (t) {
      var e = t.bbFrom,
          n = t.bbTo,
          r = t.fromPoint,
          i = s.default.matrix([[n.upperLeft.x], [n.upperLeft.y], [n.lowerLeft.x], [n.lowerLeft.y]]),
          o = s.default.matrix([[e.upperLeft.x, e.upperLeft.y, 1, 0], [-e.upperLeft.y, e.upperLeft.x, 0, 1], [e.lowerLeft.x, e.lowerLeft.y, 1, 0], [-e.lowerLeft.y, e.lowerLeft.x, 0, 1]]),
          a = s.default.inv(o),
          u = s.default.multiply(a, i),
          l = u.subset(s.default.index(0, 0)),
          h = u.subset(s.default.index(1, 0)),
          f = u.subset(s.default.index(2, 0)),
          p = u.subset(s.default.index(3, 0));
      return new c.default.Point(s.default.round(l * r.x + h * r.y + f), s.default.round(h * r.x - l * r.y + p));
    });

    e.translate = function (t, e, n, r, i) {
      var o = f({
        bbFrom: n,
        bbTo: e,
        fromPoint: h(r, i)
      }),
          a = t.viewport.imageToViewportCoordinates(o).rotate(t.viewport.getRotation(), t.viewport.getCenter(!0));
      return t.drawer.viewportToDrawerRectangle(new c.default.Rect(a.x, a.y));
    };
  }, function (t, e) {
    "use strict";

    t.exports = {
      end: !0
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (this.items = t || [], !Array.isArray(this.items) || !this.items.every(function (t) {
          return t && t.isNode;
        })) throw new TypeError("Array containing Nodes expected");

        var e = function e() {
          throw new Error("Property `ArrayNode.nodes` is deprecated, use `ArrayNode.items` instead");
        };

        Object.defineProperty(this, "nodes", {
          get: e,
          set: e
        });
      }

      var a = r(n(14));
      return o.prototype = new a(), o.prototype.type = "ArrayNode", o.prototype.isArrayNode = !0, o.prototype._compile = function (t, e) {
        var n = "Array" !== t.math.config().matrix,
            r = this.items.map(function (n) {
          return n._compile(t, e);
        });
        return (n ? "math.matrix([" : "[") + r.join(",") + (n ? "])" : "]");
      }, o.prototype.forEach = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var n = this.items[e];
          t(n, "items[" + e + "]", this);
        }
      }, o.prototype.map = function (t) {
        for (var e = [], n = 0; n < this.items.length; n++) {
          e[n] = this._ifNode(t(this.items[n], "items[" + n + "]", this));
        }

        return new o(e);
      }, o.prototype.clone = function () {
        return new o(this.items.slice(0));
      }, o.prototype._toString = function (t) {
        var e = this.items.map(function (e) {
          return e.toString(t);
        });
        return "[" + e.join(", ") + "]";
      }, o.prototype._toTex = function (t) {
        var e = "\\begin{bmatrix}";
        return this.items.forEach(function (n) {
          e += n.items ? n.items.map(function (e) {
            return e.toTex(t);
          }).join("&") : n.toTex(t), e += "\\\\";
        }), e += "\\end{bmatrix}";
      }, o;
    }

    e.name = "ArrayNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e) {
        if (!(this instanceof a)) throw new SyntaxError("Constructor must be called with the new operator");

        if (e) {
          if ("string" != typeof e) throw new TypeError('String expected for parameter "valueType"');
          if ("string" != typeof t) throw new TypeError('String expected for parameter "value"');
          this.value = t, this.valueType = e;
        } else this.value = t + "", this.valueType = i(t);

        if (!u[this.valueType]) throw new TypeError('Unsupported type of value "' + this.valueType + '"');
      }

      var s = r(n(14)),
          u = {
        number: !0,
        string: !0,
        boolean: !0,
        undefined: !0,
        null: !0
      };
      return a.prototype = new s(), a.prototype.type = "ConstantNode", a.prototype.isConstantNode = !0, a.prototype._compile = function (t, e) {
        switch (this.valueType) {
          case "number":
            var n = t.math.config().number;
            return "BigNumber" === n ? 'math.bignumber("' + this.value + '")' : "Fraction" === n ? 'math.fraction("' + this.value + '")' : this.value.replace(/^(0*)[0-9]/, function (t, e) {
              return t.substring(e.length);
            });

          case "string":
            return '"' + this.value + '"';

          case "boolean":
            return this.value;

          case "undefined":
            return this.value;

          case "null":
            return this.value;

          default:
            throw new TypeError('Unsupported type of constant "' + this.valueType + '"');
        }
      }, a.prototype.forEach = function (t) {}, a.prototype.map = function (t) {
        return this.clone();
      }, a.prototype.clone = function () {
        return new a(this.value, this.valueType);
      }, a.prototype._toString = function (t) {
        switch (this.valueType) {
          case "string":
            return '"' + this.value + '"';

          default:
            return this.value;
        }
      }, a.prototype._toTex = function (t) {
        var e,
            n = this.value;

        switch (this.valueType) {
          case "string":
            return '\\mathtt{"' + n + '"}';

          case "number":
            return e = n.toLowerCase().indexOf("e"), e !== -1 ? n.substring(0, e) + "\\cdot10^{" + n.substring(e + 1) + "}" : n;

          default:
            return n;
        }
      }, a;
    }

    var i = n(70).type;
    e.name = "ConstantNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o, a) {
      function s(t, e) {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
        if ("string" == typeof t && (console.warn("WARNING: passing a string to FunctionNode is deprecated, pass a SymbolNode instead."), t = new l(t)), !t || !t.isNode) throw new TypeError('Node expected as parameter "fn"');
        if (!Array.isArray(e) || !e.every(function (t) {
          return t && t.isNode;
        })) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.fn = t, this.args = e || [], Object.defineProperty(this, "name", {
          get: function () {
            return this.fn.name || "";
          }.bind(this),
          set: function set() {
            throw new Error("Cannot assign a new name, name is read-only");
          }
        });

        var n = function n() {
          throw new Error("Property `FunctionNode.object` is deprecated, use `FunctionNode.fn` instead");
        };

        Object.defineProperty(this, "object", {
          get: n,
          set: n
        });
      }

      function u(t, e, n) {
        for (var r, i = "", o = new RegExp("\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)", "ig"), a = 0; null !== (r = o.exec(t));) {
          if (i += t.substring(a, r.index), a = r.index, "$$" === r[0]) i += "$", a++;else {
            a += r[0].length;
            var s = e[r[1]];
            if (!s) throw new ReferenceError("Template: Property " + r[1] + " does not exist.");
            if (void 0 === r[2]) switch (typeof s) {
              case "string":
                i += s;
                break;

              case "object":
                if (s.isNode) i += s.toTex(n);else {
                  if (!Array.isArray(s)) throw new TypeError("Template: " + r[1] + " has to be a Node, String or array of Nodes");
                  i += s.map(function (t, e) {
                    if (t && t.isNode) return t.toTex(n);
                    throw new TypeError("Template: " + r[1] + "[" + e + "] is not a Node.");
                  }).join(",");
                }
                break;

              default:
                throw new TypeError("Template: " + r[1] + " has to be a Node, String or array of Nodes");
            } else {
              if (!s[r[2]] || !s[r[2]].isNode) throw new TypeError("Template: " + r[1] + "[" + r[2] + "] is not a Node.");
              i += s[r[2]].toTex(n);
            }
          }
        }

        return i += t.slice(a);
      }

      var c = r(n(14)),
          l = r(n(40));
      s.prototype = new c(), s.prototype.type = "FunctionNode", s.prototype.isFunctionNode = !0, s.prototype._compile = function (t, e) {
        var n,
            r = this.fn._compile(t, e),
            i = this.args.map(function (n) {
          return n._compile(t, e);
        });

        if (this.fn.isSymbolNode) {
          var o = this.fn.name,
              a = t.math[o],
              s = "function" == typeof a && 1 == a.rawArgs;
          return s ? (n = this._getUniqueArgumentsName(t), t[n] = this.args, r + "(" + n + ", math, scope)") : r + "(" + i.join(", ") + ")";
        }

        if (this.fn.isAccessorNode && this.fn.index.isObjectProperty()) {
          n = this._getUniqueArgumentsName(t), t[n] = this.args;

          var u = this.fn.object._compile(t, e),
              c = this.fn.index.getObjectProperty();

          return "(function () {var object = " + u + ';return (object["' + c + '"] && object["' + c + '"].rawArgs)  ? object["' + c + '"](' + n + ', math, scope) : object["' + c + '"](' + i.join(", ") + ")})()";
        }

        return n = this._getUniqueArgumentsName(t), t[n] = this.args, "(function () {var fn = " + r + ";return (fn && fn.rawArgs)  ? fn(" + n + ", math, scope) : fn(" + i.join(", ") + ")})()";
      }, s.prototype._getUniqueArgumentsName = function (t) {
        var e,
            n = 0;

        do {
          e = "args" + n, n++;
        } while (e in t);

        return e;
      }, s.prototype.forEach = function (t) {
        for (var e = 0; e < this.args.length; e++) {
          t(this.args[e], "args[" + e + "]", this);
        }
      }, s.prototype.map = function (t) {
        for (var e = this.fn.map(t), n = [], r = 0; r < this.args.length; r++) {
          n[r] = this._ifNode(t(this.args[r], "args[" + r + "]", this));
        }

        return new s(e, n);
      }, s.prototype.clone = function () {
        return new s(this.fn, this.args.slice(0));
      };
      var h = s.prototype.toString;
      s.prototype.toString = function (t) {
        var e,
            n = this.fn.toString(t);
        return t && "object" == typeof t.handler && t.handler.hasOwnProperty(n) && (e = t.handler[n](this, t)), "undefined" != typeof e ? e : h.call(this, t);
      }, s.prototype._toString = function (t) {
        var e = this.args.map(function (e) {
          return e.toString(t);
        });
        return this.fn.toString(t) + "(" + e.join(", ") + ")";
      };
      var f = s.prototype.toTex;
      return s.prototype.toTex = function (t) {
        var e;
        return t && "object" == typeof t.handler && t.handler.hasOwnProperty(this.name) && (e = t.handler[this.name](this, t)), "undefined" != typeof e ? e : f.call(this, t);
      }, s.prototype._toTex = function (t) {
        var e,
            n = this.args.map(function (e) {
          return e.toTex(t);
        });
        !a[this.name] || "function" != typeof a[this.name].toTex && "object" != typeof a[this.name].toTex && "string" != typeof a[this.name].toTex || (e = a[this.name].toTex);
        var r;

        switch (typeof e) {
          case "function":
            r = e(this, t);
            break;

          case "string":
            r = u(e, this, t);
            break;

          case "object":
            switch (typeof e[n.length]) {
              case "function":
                r = e[n.length](this, t);
                break;

              case "string":
                r = u(e[n.length], this, t);
            }

        }

        return "undefined" != typeof r ? r : u(i.defaultTemplate, this, t);
      }, s.prototype.getIdentifier = function () {
        return this.type + ":" + this.name;
      }, s;
    }

    var i = n(4);
    e.name = "FunctionNode", e.path = "expression.node", e.math = !0, e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e, n) {
        if (!(this instanceof a)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!t || !t.isNode) throw new TypeError("Node expected");
        if (!e || !e.isNode) throw new TypeError("Node expected");
        if (n && (!n || !n.isNode)) throw new TypeError("Node expected");
        if (arguments.length > 3) throw new Error("Too many arguments");
        this.start = t, this.end = e, this.step = n || null;
      }

      function s(t, e) {
        var n = i.getPrecedence(t, e),
            r = {},
            o = i.getPrecedence(t.start, e);

        if (r.start = null !== o && o <= n || "all" === e, t.step) {
          var a = i.getPrecedence(t.step, e);
          r.step = null !== a && a <= n || "all" === e;
        }

        var s = i.getPrecedence(t.end, e);
        return r.end = null !== s && s <= n || "all" === e, r;
      }

      var u = r(n(14));
      return a.prototype = new u(), a.prototype.type = "RangeNode", a.prototype.isRangeNode = !0, a.prototype.needsEnd = function () {
        var t = this.filter(function (t) {
          return t && t.isSymbolNode && "end" == t.name;
        });
        return t.length > 0;
      }, a.prototype._compile = function (t, e) {
        return "math.range(" + this.start._compile(t, e) + ", " + this.end._compile(t, e) + (this.step ? ", " + this.step._compile(t, e) : "") + ")";
      }, a.prototype.forEach = function (t) {
        t(this.start, "start", this), t(this.end, "end", this), this.step && t(this.step, "step", this);
      }, a.prototype.map = function (t) {
        return new a(this._ifNode(t(this.start, "start", this)), this._ifNode(t(this.end, "end", this)), this.step && this._ifNode(t(this.step, "step", this)));
      }, a.prototype.clone = function () {
        return new a(this.start, this.end, this.step && this.step);
      }, a.prototype._toString = function (t) {
        var e,
            n = t && t.parenthesis ? t.parenthesis : "keep",
            r = s(this, n),
            i = this.start.toString(t);

        if (r.start && (i = "(" + i + ")"), e = i, this.step) {
          var o = this.step.toString(t);
          r.step && (o = "(" + o + ")"), e += ":" + o;
        }

        var a = this.end.toString(t);
        return r.end && (a = "(" + a + ")"), e += ":" + a;
      }, a.prototype._toTex = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = s(this, e),
            r = this.start.toTex(t);

        if (n.start && (r = "\\left(" + r + "\\right)"), this.step) {
          var i = this.step.toTex(t);
          n.step && (i = "\\left(" + i + "\\right)"), r += ":" + i;
        }

        var o = this.end.toTex(t);
        return n.end && (o = "\\left(" + o + "\\right)"), r += ":" + o;
      }, a;
    }

    var i = n(53);
    e.name = "RangeNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      var e = t.DenseMatrix,
          n = function n(t, _n2, r) {
        var i = t.size();
        if (2 !== i.length) throw new RangeError("Matrix must be two dimensional (size: " + o.format(i) + ")");
        var u = i[0],
            c = i[1];
        if (u !== c) throw new RangeError("Matrix must be square (size: " + o.format(i) + ")");
        var l, h, f;

        if (_n2 && _n2.isMatrix === !0) {
          var p = _n2.size();

          if (1 === p.length) {
            if (p[0] !== u) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");

            for (l = [], f = _n2._data, h = 0; h < u; h++) {
              l[h] = [f[h]];
            }

            return new e({
              data: l,
              size: [u, 1],
              datatype: _n2._datatype
            });
          }

          if (2 === p.length) {
            if (p[0] !== u || 1 !== p[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");

            if (_n2.isDenseMatrix === !0) {
              if (r) {
                for (l = [], f = _n2._data, h = 0; h < u; h++) {
                  l[h] = [f[h][0]];
                }

                return new e({
                  data: l,
                  size: [u, 1],
                  datatype: _n2._datatype
                });
              }

              return _n2;
            }

            for (l = [], h = 0; h < u; h++) {
              l[h] = [0];
            }

            for (var m = _n2._values, d = _n2._index, g = _n2._ptr, v = g[1], y = g[0]; y < v; y++) {
              h = d[y], l[h][0] = m[y];
            }

            return new e({
              data: l,
              size: [u, 1],
              datatype: _n2._datatype
            });
          }

          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        }

        if (s(_n2)) {
          var x = a.size(_n2);

          if (1 === x.length) {
            if (x[0] !== u) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");

            for (l = [], h = 0; h < u; h++) {
              l[h] = [_n2[h]];
            }

            return new e({
              data: l,
              size: [u, 1]
            });
          }

          if (2 === x.length) {
            if (x[0] !== u || 1 !== x[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");

            for (l = [], h = 0; h < u; h++) {
              l[h] = [_n2[h][0]];
            }

            return new e({
              data: l,
              size: [u, 1]
            });
          }

          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        }
      };

      return n;
    }

    var i = n(28),
        o = i.string,
        a = i.array,
        s = Array.isArray;
    e.factory = r;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t2) {
        return -_t2 - 2;
      };

      return t;
    }

    e.name = "cs_flip", e.path = "sparse", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(t, e) {
        switch (t.length) {
          case 0:
            return e ? c(e) : [];

          case 1:
            return u(t[0], t[0], e);

          case 2:
            return u(t[0], t[1], e);

          default:
            throw new Error("Vector containing two values expected");
        }
      }

      function u(e, n, r) {
        var a = e && e.isBigNumber === !0 ? t.BigNumber : n && n.isBigNumber === !0 ? t.BigNumber : null;
        if (e && e.isBigNumber === !0 && (e = e.toNumber()), n && n.isBigNumber === !0 && (n = n.toNumber()), !o(e) || e < 1) throw new Error("Parameters in function eye must be positive integers");
        if (!o(n) || n < 1) throw new Error("Parameters in function eye must be positive integers");
        var s = a ? new t.BigNumber(1) : 1,
            u = a ? new a(0) : 0,
            c = [e, n];

        if (r) {
          var l = t.Matrix.storage(r);
          return l.diagonal(c, s, 0, u);
        }

        for (var h = i.resize([], c, u), f = e < n ? e : n, p = 0; p < f; p++) {
          h[p][p] = s;
        }

        return h;
      }

      var c = r(n(2)),
          l = a("eye", {
        "": function _() {
          return "Matrix" === e.matrix ? c([]) : [];
        },
        string: function string(t) {
          return c(t);
        },
        "number | BigNumber": function numberBigNumber(t) {
          return u(t, t, "Matrix" === e.matrix ? "default" : void 0);
        },
        "number | BigNumber, string": function numberBigNumberString(t, e) {
          return u(t, t, e);
        },
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(t, n) {
          return u(t, n, "Matrix" === e.matrix ? "default" : void 0);
        },
        "number | BigNumber, number | BigNumber, string": function numberBigNumberNumberBigNumberString(t, e, n) {
          return u(t, e, n);
        },
        Array: function Array(t) {
          return s(t);
        },
        "Array, string": function ArrayString(t, e) {
          return s(t, e);
        },
        Matrix: function Matrix(t) {
          return s(t.valueOf(), t.storage());
        },
        "Matrix, string": function MatrixString(t, e) {
          return s(t.valueOf(), e);
        }
      });
      return l.toTex = void 0, l;
    }

    var i = n(8),
        o = n(3).isInteger;
    e.name = "eye", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e) {
        return -c(t, e);
      }

      function s(t, e, n) {
        if (!i(e) || e < 0) throw new Error("k must be a non-negative integer");

        if (t && t.isMatrix) {
          var r = t.size();
          if (r.length > 1) throw new Error("Only one dimensional matrices supported");
          return u(t.valueOf(), e, n);
        }

        if (Array.isArray(t)) return u(t, e, n);
      }

      function u(t, e, n) {
        if (e >= t.length) throw new Error("k out of bounds");

        for (var r = 0, i = t.length - 1; r < i;) {
          for (var o = r, a = i, s = t[Math.floor(Math.random() * (i - r + 1)) + r]; o < a;) {
            if (n(t[o], s) >= 0) {
              var u = t[a];
              t[a] = t[o], t[o] = u, --a;
            } else ++o;
          }

          n(t[o], s) > 0 && --o, e <= o ? i = o : r = o + 1;
        }

        return t[e];
      }

      var c = r(n(55));
      return o("partitionSelect", {
        "Array | Matrix, number": function ArrayMatrixNumber(t, e) {
          return s(t, e, c);
        },
        "Array | Matrix, number, string": function ArrayMatrixNumberString(t, e, n) {
          if ("asc" === n) return s(t, e, c);
          if ("desc" === n) return s(t, e, a);
          throw new Error('Compare string must be "asc" or "desc"');
        },
        "Array | Matrix, number, function": s
      });
    }

    var i = n(3).isInteger;
    e.name = "partitionSelect", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      function u(t) {
        if (!h.hasOwnProperty(t)) throw new Error("Unknown distribution " + t);
        var e = Array.prototype.slice.call(arguments, 1),
            n = h[t].apply(this, e);
        return function (t) {
          var e = {
            random: function random(t, e, n) {
              var s, u, l;
              if (arguments.length > 3) throw new i("random", arguments.length, 0, 3);
              if (1 === arguments.length ? o(t) ? s = t : l = t : 2 === arguments.length ? o(t) ? (s = t, l = e) : (u = t, l = e) : (s = t, u = e, l = n), void 0 !== u && !a(u) || void 0 !== l && !a(l)) throw new TypeError("Invalid argument in function random");

              if (void 0 === l && (l = 1), void 0 === u && (u = 0), void 0 !== s) {
                var f = h(s.valueOf(), u, l, r);
                return s && s.isMatrix === !0 ? c(f) : f;
              }

              return r(u, l);
            },
            randomInt: s({
              "number | Array": function numberArray(t) {
                var e = 0;

                if (o(t)) {
                  var n = t,
                      r = 1,
                      i = h(n.valueOf(), e, r, u);
                  return n && n.isMatrix === !0 ? c(i) : i;
                }

                var r = t;
                return u(e, r);
              },
              "number | Array, number": function numberArrayNumber(t, e) {
                if (o(t)) {
                  var n = t,
                      r = e,
                      i = 0,
                      a = h(n.valueOf(), i, r, u);
                  return n && n.isMatrix === !0 ? c(a) : a;
                }

                var i = t,
                    r = e;
                return u(i, r);
              },
              "Array, number, number": function ArrayNumberNumber(t, e, n) {
                var r = h(t.valueOf(), e, n, u);
                return t && t.isMatrix === !0 ? c(r) : r;
              }
            }),
            pickRandom: s({
              Array: function Array(t) {
                return n(t);
              },
              "Array, number | Array": function ArrayNumberArray(t, e) {
                var r, i;
                if (Array.isArray(e)) i = e;else {
                  if (!a(e)) throw new TypeError("Invalid argument in function pickRandom");
                  r = e;
                }
                return n(t, r, i);
              },
              "Array, number | Array, Array | number": function ArrayNumberArrayArrayNumber(t, e, r) {
                var i, o;
                if (Array.isArray(e) ? (o = e, i = r) : (o = r, i = e), !Array.isArray(o) || !a(i)) throw new TypeError("Invalid argument in function pickRandom");
                return n(t, i, o);
              }
            })
          },
              n = function n(t, e, _n3) {
            var r = "undefined" == typeof e;
            if (r && (e = 1), t && t.isMatrix === !0) t = t.valueOf();else if (!Array.isArray(t)) throw new TypeError("Unsupported type of value in function pickRandom");
            if (l.size(t).length > 1) throw new Error("Only one dimensional vectors supported");

            if ("undefined" != typeof _n3) {
              if (_n3.length != t.length) throw new Error("Weights must have the same length as possibles");

              for (var i = 0, o = 0, s = _n3.length; o < s; o++) {
                if (!a(_n3[o]) || _n3[o] < 0) throw new Error("Weights must be an array of positive numbers");
                i += _n3[o];
              }
            }

            var u = t.length;
            if (0 == u) return [];
            if (e >= u) return t;

            for (var c, h = []; h.length < e;) {
              if ("undefined" == typeof _n3) c = t[Math.floor(Math.random() * u)];else for (var f = Math.random() * i, o = 0, s = t.length; o < s; o++) {
                if (f -= _n3[o], f < 0) {
                  c = t[o];
                  break;
                }
              }
              h.indexOf(c) == -1 && h.push(c);
            }

            return r ? h[0] : h;
          },
              r = function r(e, n) {
            return e + t() * (n - e);
          },
              u = function u(e, n) {
            return Math.floor(e + t() * (n - e));
          },
              h = function h(t, e, n, r) {
            var i,
                o,
                a = [];
            if (t = t.slice(0), t.length > 1) for (var o = 0, i = t.shift(); o < i; o++) {
              a.push(h(t, e, n, r));
            } else for (var o = 0, i = t.shift(); o < i; o++) {
              a.push(r(e, n));
            }
            return a;
          };

          return e;
        }(n);
      }

      var c = r(n(2)),
          l = n(8),
          h = {
        uniform: function uniform() {
          return Math.random;
        },
        normal: function normal() {
          return function () {
            for (var t, e, n = -1; n < 0 || n > 1;) {
              t = Math.random(), e = Math.random(), n = 1 / 6 * Math.pow(-2 * Math.log(t), .5) * Math.cos(2 * Math.PI * e) + .5;
            }

            return n;
          };
        }
      };
      return u.toTex = void 0, u;
    }

    var i = n(51),
        o = n(47),
        a = n(3).isNumber;
    e.name = "distribution", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(11)),
          s = r(n(15)),
          u = r(n(27)),
          c = r(n(17)),
          l = r(n(7)),
          h = r(n(6)),
          f = n(4),
          p = i("equal", {
        "any, any": function anyAny(t, e) {
          return null === t ? null === e : null === e ? null === t : void 0 === t ? void 0 === e : void 0 === e ? void 0 === t : a(t, e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, a);
                  break;

                default:
                  n = s(e, t, a, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = s(t, e, a, !1);
                  break;

                default:
                  n = l(t, e, a);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(o(t), o(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(o(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, o(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = c(t, e, a, !1);
              break;

            default:
              n = h(t, e, a, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = c(e, t, a, !0);
              break;

            default:
              n = h(e, t, a, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return h(o(t), e, a, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return h(o(e), t, a, !0).valueOf();
        }
      });
      return p.toTex = {
        2: "\\left(${args[0]}" + f.operators.equal + "${args[1]}\\right)"
      }, p;
    }

    e.name = "equal", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isNumeric", {
        "number | BigNumber | Fraction | boolean": function numberBigNumberFractionBoolean() {
          return !0;
        },
        "Complex | Unit | string": function ComplexUnitString() {
          return !1;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    n(3);
    e.name = "isNumeric", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      function i() {
        if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
      }

      return i.prototype.type = "Matrix", i.prototype.isMatrix = !0, i.storage = function (t) {
        if (!a(t)) throw new TypeError("format must be a string value");
        var e = i._storage[t];
        if (!e) throw new SyntaxError("Unsupported matrix storage format: " + t);
        return e;
      }, i._storage = {}, i.prototype.storage = function () {
        throw new Error("Cannot invoke storage on a Matrix interface");
      }, i.prototype.datatype = function () {
        throw new Error("Cannot invoke datatype on a Matrix interface");
      }, i.prototype.create = function (t, e) {
        throw new Error("Cannot invoke create on a Matrix interface");
      }, i.prototype.subset = function (t, e, n) {
        throw new Error("Cannot invoke subset on a Matrix interface");
      }, i.prototype.get = function (t) {
        throw new Error("Cannot invoke get on a Matrix interface");
      }, i.prototype.set = function (t, e, n) {
        throw new Error("Cannot invoke set on a Matrix interface");
      }, i.prototype.resize = function (t, e) {
        throw new Error("Cannot invoke resize on a Matrix interface");
      }, i.prototype.clone = function () {
        throw new Error("Cannot invoke clone on a Matrix interface");
      }, i.prototype.size = function () {
        throw new Error("Cannot invoke size on a Matrix interface");
      }, i.prototype.map = function (t, e) {
        throw new Error("Cannot invoke map on a Matrix interface");
      }, i.prototype.forEach = function (t) {
        throw new Error("Cannot invoke forEach on a Matrix interface");
      }, i.prototype.toArray = function () {
        throw new Error("Cannot invoke toArray on a Matrix interface");
      }, i.prototype.valueOf = function () {
        throw new Error("Cannot invoke valueOf on a Matrix interface");
      }, i.prototype.format = function (t) {
        throw new Error("Cannot invoke format on a Matrix interface");
      }, i.prototype.toString = function () {
        throw new Error("Cannot invoke toString on a Matrix interface");
      }, i;
    }

    var i = n(28),
        o = i.string,
        a = o.isString;
    e.name = "Matrix", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(11)),
          s = t.SparseMatrix,
          u = function u(t, e, n) {
        var r = t._values,
            u = t._index,
            c = t._ptr,
            l = t._size,
            h = t._datatype,
            f = e._values,
            p = e._index,
            m = e._ptr,
            d = e._size,
            g = e._datatype;
        if (l.length !== d.length) throw new i(l.length, d.length);
        if (l[0] !== d[0] || l[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + l + ") must match Matrix B (" + d + ")");
        var v,
            y = l[0],
            x = l[1],
            w = a,
            b = 0,
            _ = n;
        "string" == typeof h && h === g && (v = h, w = o.find(a, [v, v]), b = o.convert(0, v), _ = o.find(n, [v, v]));
        var E,
            M,
            T,
            N,
            S,
            A = r && f ? [] : void 0,
            O = [],
            C = [],
            P = new s({
          values: A,
          index: O,
          ptr: C,
          size: [y, x],
          datatype: v
        }),
            R = r && f ? [] : void 0,
            I = r && f ? [] : void 0,
            k = [],
            z = [];

        for (M = 0; M < x; M++) {
          C[M] = O.length;
          var B = M + 1;

          for (N = c[M], S = c[M + 1], T = N; T < S; T++) {
            E = u[T], O.push(E), k[E] = B, R && (R[E] = r[T]);
          }

          for (N = m[M], S = m[M + 1], T = N; T < S; T++) {
            if (E = p[T], k[E] === B) {
              if (R) {
                var L = _(R[E], f[T]);

                w(L, b) ? k[E] = null : R[E] = L;
              }
            } else O.push(E), z[E] = B, I && (I[E] = f[T]);
          }

          if (R && I) for (T = C[M]; T < O.length;) {
            E = O[T], k[E] === B ? (A[T] = R[E], T++) : z[E] === B ? (A[T] = I[E], T++) : O.splice(T, 1);
          }
        }

        return C[x] = O.length, P;
      };

      return u;
    }

    var i = n(12);
    e.name = "algorithm04", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(11)),
          s = t.SparseMatrix,
          u = function u(t, e, n) {
        var r = t._values,
            u = t._index,
            c = t._ptr,
            l = t._size,
            h = t._datatype,
            f = e._values,
            p = e._index,
            m = e._ptr,
            d = e._size,
            g = e._datatype;
        if (l.length !== d.length) throw new i(l.length, d.length);
        if (l[0] !== d[0] || l[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + l + ") must match Matrix B (" + d + ")");
        if (!r || !f) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
        var v,
            y = l[0],
            x = l[1],
            w = a,
            b = 0,
            _ = n;
        "string" == typeof h && h === g && (v = h, w = o.find(a, [v, v]), b = o.convert(0, v), _ = o.find(n, [v, v]));

        for (var E, M, T, N, S = [], A = [], O = [], C = new s({
          values: S,
          index: A,
          ptr: O,
          size: [y, x],
          datatype: v
        }), P = [], R = [], I = 0; I < x; I++) {
          O[I] = A.length;
          var k = I + 1;

          for (M = c[I], T = c[I + 1], E = M; E < T; E++) {
            N = u[E], R[N] = k, P[N] = r[E], A.push(N);
          }

          for (M = m[I], T = m[I + 1], E = M; E < T; E++) {
            N = p[E], R[N] === k && (P[N] = _(P[N], f[E]));
          }

          for (E = O[I]; E < A.length;) {
            N = A[E];
            var z = P[N];
            w(z, b) ? A.splice(E, 1) : (S.push(z), E++);
          }
        }

        return O[x] = A.length, C;
      };

      return u;
    }

    var i = n(12);
    e.name = "algorithm08", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("number", {
        "": function _() {
          return 0;
        },
        number: function number(t) {
          return t;
        },
        string: function string(t) {
          var e = Number(t);
          if (isNaN(e)) throw new SyntaxError('String "' + t + '" is no valid number');
          return e;
        },
        BigNumber: function BigNumber(t) {
          return t.toNumber();
        },
        Fraction: function Fraction(t) {
          return t.valueOf();
        },
        Unit: function Unit(t) {
          throw new Error("Second argument with valueless unit expected");
        },
        "Unit, string | Unit": function UnitStringUnit(t, e) {
          return t.toNumber(e);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "number", e.factory = r;
  }, function (t, e) {
    t.exports = function (t) {
      if (t.isFinite() && !t.isInteger()) throw new Error("Integer expected in function bitNot");
      var e = t.constructor,
          n = e.precision;
      e.config({
        precision: 1e9
      });
      var t = t.plus(new e(1));
      return t.s = -t.s || null, e.config({
        precision: n
      }), t;
    };
  }, function (t, e, n) {
    function r(t) {
      for (var e = t.d, n = e[0] + "", r = 1; r < e.length; ++r) {
        for (var i = e[r] + "", o = 7 - i.length; o--;) {
          i = "0" + i;
        }

        n += i;
      }

      var a;

      for (a = n.length - 1; "0" == n.charAt(a); --a) {
        ;
      }

      var s = t.e,
          u = n.slice(0, a + 1 || 1),
          c = u.length;
      if (s > 0) if (++s > c) for (s -= c; s--; u += "0") {
        ;
      } else s < c && (u = u.slice(0, s) + "." + u.slice(s));

      for (var l = [0], r = 0; r < u.length;) {
        for (var h = l.length; h--; l[h] *= 10) {
          ;
        }

        l[0] += u.charAt(r++) << 0;

        for (var a = 0; a < l.length; ++a) {
          l[a] > 1 && (null == l[a + 1] && (l[a + 1] = 0), l[a + 1] += l[a] >> 1, l[a] &= 1);
        }
      }

      return l.reverse();
    }

    var i = n(90);

    t.exports = function (t, e, n) {
      var o,
          a,
          s = t.constructor,
          u = +(t.s < 0),
          c = +(e.s < 0);

      if (u) {
        o = r(i(t));

        for (var l = 0; l < o.length; ++l) {
          o[l] ^= 1;
        }
      } else o = r(t);

      if (c) {
        a = r(i(e));

        for (var l = 0; l < a.length; ++l) {
          a[l] ^= 1;
        }
      } else a = r(e);

      var h, f, p;
      o.length <= a.length ? (h = o, f = a, p = u) : (h = a, f = o, p = c);
      var m = h.length,
          d = f.length,
          g = 1 ^ n(u, c),
          v = new s(1 ^ g),
          y = new s(1),
          x = new s(2),
          w = s.precision;

      for (s.config({
        precision: 1e9
      }); m > 0;) {
        n(h[--m], f[--d]) == g && (v = v.plus(y)), y = y.times(x);
      }

      for (; d > 0;) {
        n(p, f[--d]) == g && (v = v.plus(y)), y = y.times(x);
      }

      return s.config({
        precision: w
      }), 0 == g && (v.s = -v.s), v;
    };
  }, function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_RESULT__; //! openseadragon 2.2.1
    //! Built on 2016-07-01
    //! Git commit: v2.2.1-0-babdefd
    //! http://openseadragon.github.io
    //! License: http://openseadragon.github.io/license/


    window.OpenSeadragon = window.OpenSeadragon || function (t) {
      return new OpenSeadragon.Viewer(t);
    }, __WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return window.OpenSeadragon;
    }.call(exports, __webpack_require__, exports, module), !(void 0 !== __WEBPACK_AMD_DEFINE_RESULT__ && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)), function (t) {
      t.version = {
        versionStr: "2.2.1",
        major: parseInt("2", 10),
        minor: parseInt("2", 10),
        revision: parseInt("1", 10)
      };
      var e = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regexp",
        "[object Object]": "object"
      },
          n = Object.prototype.toString,
          r = Object.prototype.hasOwnProperty;
      t.isFunction = function (e) {
        return "function" === t.type(e);
      }, t.isArray = Array.isArray || function (e) {
        return "array" === t.type(e);
      }, t.isWindow = function (t) {
        return t && "object" == typeof t && "setInterval" in t;
      }, t.type = function (t) {
        return null === t || void 0 === t ? String(t) : e[n.call(t)] || "object";
      }, t.isPlainObject = function (e) {
        if (!e || "object" !== OpenSeadragon.type(e) || e.nodeType || t.isWindow(e)) return !1;
        if (e.constructor && !r.call(e, "constructor") && !r.call(e.constructor.prototype, "isPrototypeOf")) return !1;
        var n;

        for (var i in e) {
          n = i;
        }

        return void 0 === n || r.call(e, n);
      }, t.isEmptyObject = function (t) {
        for (var e in t) {
          return !1;
        }

        return !0;
      }, t.freezeObject = function (e) {
        return Object.freeze ? t.freezeObject = Object.freeze : t.freezeObject = function (t) {
          return t;
        }, t.freezeObject(e);
      }, t.supportsCanvas = function () {
        var e = document.createElement("canvas");
        return !(!t.isFunction(e.getContext) || !e.getContext("2d"));
      }(), t.isCanvasTainted = function (t) {
        var e = !1;

        try {
          t.getContext("2d").getImageData(0, 0, 1, 1);
        } catch (t) {
          e = !0;
        }

        return e;
      }, t.pixelDensityRatio = function () {
        if (t.supportsCanvas) {
          var e = document.createElement("canvas").getContext("2d"),
              n = window.devicePixelRatio || 1,
              r = e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.oBackingStorePixelRatio || e.backingStorePixelRatio || 1;
          return n / r;
        }

        return 1;
      }();
    }(OpenSeadragon), function ($) {
      function getOffsetParent(t, e) {
        return e && t != document.body ? document.body : t.offsetParent;
      }

      $.extend = function () {
        var t,
            e,
            n,
            r,
            i,
            o,
            a = arguments[0] || {},
            s = arguments.length,
            u = !1,
            c = 1;

        for ("boolean" == typeof a && (u = a, a = arguments[1] || {}, c = 2), "object" == typeof a || OpenSeadragon.isFunction(a) || (a = {}), s === c && (a = this, --c); c < s; c++) {
          if (t = arguments[c], null !== t || void 0 !== t) for (e in t) {
            n = a[e], r = t[e], a !== r && (u && r && (OpenSeadragon.isPlainObject(r) || (i = OpenSeadragon.isArray(r))) ? (i ? (i = !1, o = n && OpenSeadragon.isArray(n) ? n : []) : o = n && OpenSeadragon.isPlainObject(n) ? n : {}, a[e] = OpenSeadragon.extend(u, o, r)) : void 0 !== r && (a[e] = r));
          }
        }

        return a;
      };

      var isIOSDevice = function isIOSDevice() {
        if ("object" != typeof navigator) return !1;
        var t = navigator.userAgent;
        return "string" == typeof t && (t.indexOf("iPhone") !== -1 || t.indexOf("iPad") !== -1 || t.indexOf("iPod") !== -1);
      };

      $.extend($, {
        DEFAULT_SETTINGS: {
          xmlPath: null,
          tileSources: null,
          tileHost: null,
          initialPage: 0,
          crossOriginPolicy: !1,
          ajaxWithCredentials: !1,
          panHorizontal: !0,
          panVertical: !0,
          constrainDuringPan: !1,
          wrapHorizontal: !1,
          wrapVertical: !1,
          visibilityRatio: .5,
          minPixelRatio: .5,
          defaultZoomLevel: 0,
          minZoomLevel: null,
          maxZoomLevel: null,
          homeFillsViewer: !1,
          clickTimeThreshold: 300,
          clickDistThreshold: 5,
          dblClickTimeThreshold: 300,
          dblClickDistThreshold: 20,
          springStiffness: 6.5,
          animationTime: 1.2,
          gestureSettingsMouse: {
            scrollToZoom: !0,
            clickToZoom: !0,
            dblClickToZoom: !1,
            pinchToZoom: !1,
            flickEnabled: !1,
            flickMinSpeed: 120,
            flickMomentum: .25,
            pinchRotate: !1
          },
          gestureSettingsTouch: {
            scrollToZoom: !1,
            clickToZoom: !1,
            dblClickToZoom: !0,
            pinchToZoom: !0,
            flickEnabled: !0,
            flickMinSpeed: 120,
            flickMomentum: .25,
            pinchRotate: !1
          },
          gestureSettingsPen: {
            scrollToZoom: !1,
            clickToZoom: !0,
            dblClickToZoom: !1,
            pinchToZoom: !1,
            flickEnabled: !1,
            flickMinSpeed: 120,
            flickMomentum: .25,
            pinchRotate: !1
          },
          gestureSettingsUnknown: {
            scrollToZoom: !1,
            clickToZoom: !1,
            dblClickToZoom: !0,
            pinchToZoom: !0,
            flickEnabled: !0,
            flickMinSpeed: 120,
            flickMomentum: .25,
            pinchRotate: !1
          },
          zoomPerClick: 2,
          zoomPerScroll: 1.2,
          zoomPerSecond: 1,
          blendTime: 0,
          alwaysBlend: !1,
          autoHideControls: !0,
          immediateRender: !1,
          minZoomImageRatio: .9,
          maxZoomPixelRatio: 1.1,
          smoothTileEdgesMinZoom: 1.1,
          iOSDevice: isIOSDevice(),
          pixelsPerWheelLine: 40,
          autoResize: !0,
          preserveImageSizeOnResize: !1,
          minScrollDeltaTime: 50,
          showSequenceControl: !0,
          sequenceControlAnchor: null,
          preserveViewport: !1,
          preserveOverlays: !1,
          navPrevNextWrap: !1,
          showNavigationControl: !0,
          navigationControlAnchor: null,
          showZoomControl: !0,
          showHomeControl: !0,
          showFullPageControl: !0,
          showRotationControl: !1,
          controlsFadeDelay: 2e3,
          controlsFadeLength: 1500,
          mouseNavEnabled: !0,
          showNavigator: !1,
          navigatorId: null,
          navigatorPosition: null,
          navigatorSizeRatio: .2,
          navigatorMaintainSizeRatio: !1,
          navigatorTop: null,
          navigatorLeft: null,
          navigatorHeight: null,
          navigatorWidth: null,
          navigatorAutoResize: !0,
          navigatorAutoFade: !0,
          navigatorRotate: !0,
          degrees: 0,
          opacity: 1,
          compositeOperation: null,
          placeholderFillStyle: null,
          showReferenceStrip: !1,
          referenceStripScroll: "horizontal",
          referenceStripElement: null,
          referenceStripHeight: null,
          referenceStripWidth: null,
          referenceStripPosition: "BOTTOM_LEFT",
          referenceStripSizeRatio: .2,
          collectionRows: 3,
          collectionColumns: 0,
          collectionLayout: "horizontal",
          collectionMode: !1,
          collectionTileSize: 800,
          collectionTileMargin: 80,
          imageLoaderLimit: 0,
          maxImageCacheCount: 200,
          timeout: 3e4,
          useCanvas: !0,
          prefixUrl: "/images/",
          navImages: {
            zoomIn: {
              REST: "zoomin_rest.png",
              GROUP: "zoomin_grouphover.png",
              HOVER: "zoomin_hover.png",
              DOWN: "zoomin_pressed.png"
            },
            zoomOut: {
              REST: "zoomout_rest.png",
              GROUP: "zoomout_grouphover.png",
              HOVER: "zoomout_hover.png",
              DOWN: "zoomout_pressed.png"
            },
            home: {
              REST: "home_rest.png",
              GROUP: "home_grouphover.png",
              HOVER: "home_hover.png",
              DOWN: "home_pressed.png"
            },
            fullpage: {
              REST: "fullpage_rest.png",
              GROUP: "fullpage_grouphover.png",
              HOVER: "fullpage_hover.png",
              DOWN: "fullpage_pressed.png"
            },
            rotateleft: {
              REST: "rotateleft_rest.png",
              GROUP: "rotateleft_grouphover.png",
              HOVER: "rotateleft_hover.png",
              DOWN: "rotateleft_pressed.png"
            },
            rotateright: {
              REST: "rotateright_rest.png",
              GROUP: "rotateright_grouphover.png",
              HOVER: "rotateright_hover.png",
              DOWN: "rotateright_pressed.png"
            },
            previous: {
              REST: "previous_rest.png",
              GROUP: "previous_grouphover.png",
              HOVER: "previous_hover.png",
              DOWN: "previous_pressed.png"
            },
            next: {
              REST: "next_rest.png",
              GROUP: "next_grouphover.png",
              HOVER: "next_hover.png",
              DOWN: "next_pressed.png"
            }
          },
          debugMode: !1,
          debugGridColor: "#437AB2"
        },
        SIGNAL: "----seadragon----",
        delegate: function delegate(t, e) {
          return function () {
            var n = arguments;
            return void 0 === n && (n = []), e.apply(t, n);
          };
        },
        BROWSERS: {
          UNKNOWN: 0,
          IE: 1,
          FIREFOX: 2,
          SAFARI: 3,
          CHROME: 4,
          OPERA: 5
        },
        getElement: function getElement(t) {
          return "string" == typeof t && (t = document.getElementById(t)), t;
        },
        getElementPosition: function getElementPosition(t) {
          var e,
              n,
              r = new $.Point();

          for (t = $.getElement(t), e = "fixed" == $.getElementStyle(t).position, n = getOffsetParent(t, e); n;) {
            r.x += t.offsetLeft, r.y += t.offsetTop, e && (r = r.plus($.getPageScroll())), t = n, e = "fixed" == $.getElementStyle(t).position, n = getOffsetParent(t, e);
          }

          return r;
        },
        getElementOffset: function getElementOffset(t) {
          t = $.getElement(t);
          var e,
              n,
              r = t && t.ownerDocument,
              i = {
            top: 0,
            left: 0
          };
          return r ? (e = r.documentElement, "undefined" != typeof t.getBoundingClientRect && (i = t.getBoundingClientRect()), n = r == r.window ? r : 9 === r.nodeType && (r.defaultView || r.parentWindow), new $.Point(i.left + (n.pageXOffset || e.scrollLeft) - (e.clientLeft || 0), i.top + (n.pageYOffset || e.scrollTop) - (e.clientTop || 0))) : new $.Point();
        },
        getElementSize: function getElementSize(t) {
          return t = $.getElement(t), new $.Point(t.clientWidth, t.clientHeight);
        },
        getElementStyle: document.documentElement.currentStyle ? function (t) {
          return t = $.getElement(t), t.currentStyle;
        } : function (t) {
          return t = $.getElement(t), window.getComputedStyle(t, "");
        },
        getCssPropertyWithVendorPrefix: function getCssPropertyWithVendorPrefix(t) {
          var e = {};
          return $.getCssPropertyWithVendorPrefix = function (t) {
            if (void 0 !== e[t]) return e[t];
            var n = document.createElement("div").style,
                r = null;
            if (void 0 !== n[t]) r = t;else for (var i = ["Webkit", "Moz", "MS", "O", "webkit", "moz", "ms", "o"], o = $.capitalizeFirstLetter(t), a = 0; a < i.length; a++) {
              var s = i[a] + o;

              if (void 0 !== n[s]) {
                r = s;
                break;
              }
            }
            return e[t] = r, r;
          }, $.getCssPropertyWithVendorPrefix(t);
        },
        capitalizeFirstLetter: function capitalizeFirstLetter(t) {
          return t.charAt(0).toUpperCase() + t.slice(1);
        },
        pointInElement: function pointInElement(t, e) {
          t = $.getElement(t);
          var n = $.getElementOffset(t),
              r = $.getElementSize(t);
          return e.x >= n.x && e.x < n.x + r.x && e.y < n.y + r.y && e.y >= n.y;
        },
        getEvent: function getEvent(t) {
          return t ? $.getEvent = function (t) {
            return t;
          } : $.getEvent = function () {
            return window.event;
          }, $.getEvent(t);
        },
        getMousePosition: function getMousePosition(t) {
          if ("number" == typeof t.pageX) $.getMousePosition = function (t) {
            var e = new $.Point();
            return t = $.getEvent(t), e.x = t.pageX, e.y = t.pageY, e;
          };else {
            if ("number" != typeof t.clientX) throw new Error("Unknown event mouse position, no known technique.");

            $.getMousePosition = function (t) {
              var e = new $.Point();
              return t = $.getEvent(t), e.x = t.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, e.y = t.clientY + document.body.scrollTop + document.documentElement.scrollTop, e;
            };
          }
          return $.getMousePosition(t);
        },
        getPageScroll: function getPageScroll() {
          var t = document.documentElement || {},
              e = document.body || {};
          if ("number" == typeof window.pageXOffset) $.getPageScroll = function () {
            return new $.Point(window.pageXOffset, window.pageYOffset);
          };else if (e.scrollLeft || e.scrollTop) $.getPageScroll = function () {
            return new $.Point(document.body.scrollLeft, document.body.scrollTop);
          };else {
            if (!t.scrollLeft && !t.scrollTop) return new $.Point(0, 0);

            $.getPageScroll = function () {
              return new $.Point(document.documentElement.scrollLeft, document.documentElement.scrollTop);
            };
          }
          return $.getPageScroll();
        },
        setPageScroll: function setPageScroll(t) {
          if ("undefined" != typeof window.scrollTo) $.setPageScroll = function (t) {
            window.scrollTo(t.x, t.y);
          };else {
            var e = $.getPageScroll();
            if (e.x === t.x && e.y === t.y) return;
            document.body.scrollLeft = t.x, document.body.scrollTop = t.y;
            var n = $.getPageScroll();
            if (n.x !== e.x && n.y !== e.y) return void ($.setPageScroll = function (t) {
              document.body.scrollLeft = t.x, document.body.scrollTop = t.y;
            });
            if (document.documentElement.scrollLeft = t.x, document.documentElement.scrollTop = t.y, n = $.getPageScroll(), n.x !== e.x && n.y !== e.y) return void ($.setPageScroll = function (t) {
              document.documentElement.scrollLeft = t.x, document.documentElement.scrollTop = t.y;
            });

            $.setPageScroll = function (t) {};
          }
          return $.setPageScroll(t);
        },
        getWindowSize: function getWindowSize() {
          var t = document.documentElement || {},
              e = document.body || {};
          if ("number" == typeof window.innerWidth) $.getWindowSize = function () {
            return new $.Point(window.innerWidth, window.innerHeight);
          };else if (t.clientWidth || t.clientHeight) $.getWindowSize = function () {
            return new $.Point(document.documentElement.clientWidth, document.documentElement.clientHeight);
          };else {
            if (!e.clientWidth && !e.clientHeight) throw new Error("Unknown window size, no known technique.");

            $.getWindowSize = function () {
              return new $.Point(document.body.clientWidth, document.body.clientHeight);
            };
          }
          return $.getWindowSize();
        },
        makeCenteredNode: function makeCenteredNode(t) {
          t = $.getElement(t);
          var e = [$.makeNeutralElement("div"), $.makeNeutralElement("div"), $.makeNeutralElement("div")];
          return $.extend(e[0].style, {
            display: "table",
            height: "100%",
            width: "100%"
          }), $.extend(e[1].style, {
            display: "table-row"
          }), $.extend(e[2].style, {
            display: "table-cell",
            verticalAlign: "middle",
            textAlign: "center"
          }), e[0].appendChild(e[1]), e[1].appendChild(e[2]), e[2].appendChild(t), e[0];
        },
        makeNeutralElement: function makeNeutralElement(t) {
          var e = document.createElement(t),
              n = e.style;
          return n.background = "transparent none", n.border = "none", n.margin = "0px", n.padding = "0px", n.position = "static", e;
        },
        now: function now() {
          return Date.now ? $.now = Date.now : $.now = function () {
            return new Date().getTime();
          }, $.now();
        },
        makeTransparentImage: function makeTransparentImage(t) {
          return $.makeTransparentImage = function (t) {
            var e = $.makeNeutralElement("img");
            return e.src = t, e;
          }, $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7 && ($.makeTransparentImage = function (t) {
            var e = $.makeNeutralElement("img"),
                n = null;
            return n = $.makeNeutralElement("span"), n.style.display = "inline-block", e.onload = function () {
              n.style.width = n.style.width || e.width + "px", n.style.height = n.style.height || e.height + "px", e.onload = null, e = null;
            }, e.src = t, n.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + t + "', sizingMethod='scale')", n;
          }), $.makeTransparentImage(t);
        },
        setElementOpacity: function setElementOpacity(t, e, n) {
          var r, i;
          t = $.getElement(t), n && !$.Browser.alpha && (e = Math.round(e)), $.Browser.opacity ? t.style.opacity = e < 1 ? e : "" : e < 1 ? (r = Math.round(100 * e), i = "alpha(opacity=" + r + ")", t.style.filter = i) : t.style.filter = "";
        },
        setElementTouchActionNone: function setElementTouchActionNone(t) {
          t = $.getElement(t), "undefined" != typeof t.style.touchAction ? t.style.touchAction = "none" : "undefined" != typeof t.style.msTouchAction && (t.style.msTouchAction = "none");
        },
        addClass: function addClass(t, e) {
          t = $.getElement(t), t.className ? (" " + t.className + " ").indexOf(" " + e + " ") === -1 && (t.className += " " + e) : t.className = e;
        },
        indexOf: function indexOf(t, e, n) {
          return Array.prototype.indexOf ? this.indexOf = function (t, e, n) {
            return t.indexOf(e, n);
          } : this.indexOf = function (t, e, n) {
            var r,
                i,
                o = n ? n : 0;
            if (!t) throw new TypeError();
            if (i = t.length, 0 === i || o >= i) return -1;

            for (o < 0 && (o = i - Math.abs(o)), r = o; r < i; r++) {
              if (t[r] === e) return r;
            }

            return -1;
          }, this.indexOf(t, e, n);
        },
        removeClass: function removeClass(t, e) {
          var n,
              r,
              i = [];

          for (t = $.getElement(t), n = t.className.split(/\s+/), r = 0; r < n.length; r++) {
            n[r] && n[r] !== e && i.push(n[r]);
          }

          t.className = i.join(" ");
        },
        addEvent: function () {
          if (window.addEventListener) return function (t, e, n, r) {
            t = $.getElement(t), t.addEventListener(e, n, r);
          };
          if (window.attachEvent) return function (t, e, n, r) {
            t = $.getElement(t), t.attachEvent("on" + e, n);
          };
          throw new Error("No known event model.");
        }(),
        removeEvent: function () {
          if (window.removeEventListener) return function (t, e, n, r) {
            t = $.getElement(t), t.removeEventListener(e, n, r);
          };
          if (window.detachEvent) return function (t, e, n, r) {
            t = $.getElement(t), t.detachEvent("on" + e, n);
          };
          throw new Error("No known event model.");
        }(),
        cancelEvent: function cancelEvent(t) {
          t = $.getEvent(t), t.preventDefault ? $.cancelEvent = function (t) {
            t.preventDefault();
          } : $.cancelEvent = function (t) {
            t = $.getEvent(t), t.cancel = !0, t.returnValue = !1;
          }, $.cancelEvent(t);
        },
        stopEvent: function stopEvent(t) {
          t = $.getEvent(t), t.stopPropagation ? $.stopEvent = function (t) {
            t.stopPropagation();
          } : $.stopEvent = function (t) {
            t = $.getEvent(t), t.cancelBubble = !0;
          }, $.stopEvent(t);
        },
        createCallback: function createCallback(t, e) {
          var n,
              r = [];

          for (n = 2; n < arguments.length; n++) {
            r.push(arguments[n]);
          }

          return function () {
            var n,
                i = r.concat([]);

            for (n = 0; n < arguments.length; n++) {
              i.push(arguments[n]);
            }

            return e.apply(t, i);
          };
        },
        getUrlParameter: function getUrlParameter(t) {
          var e = URLPARAMS[t];
          return e ? e : null;
        },
        getUrlProtocol: function getUrlProtocol(t) {
          var e = t.match(/^([a-z]+:)\/\//i);
          return null === e ? window.location.protocol : e[1].toLowerCase();
        },
        createAjaxRequest: function createAjaxRequest(t) {
          var e;

          try {
            e = !!new ActiveXObject("Microsoft.XMLHTTP");
          } catch (t) {
            e = !1;
          }

          if (e) window.XMLHttpRequest ? $.createAjaxRequest = function (t) {
            return t ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest();
          } : $.createAjaxRequest = function () {
            return new ActiveXObject("Microsoft.XMLHTTP");
          };else {
            if (!window.XMLHttpRequest) throw new Error("Browser doesn't support XMLHttpRequest.");

            $.createAjaxRequest = function () {
              return new XMLHttpRequest();
            };
          }
          return $.createAjaxRequest(t);
        },
        makeAjaxRequest: function makeAjaxRequest(t, e, n) {
          var r;
          $.isPlainObject(t) && (e = t.success, n = t.error, r = t.withCredentials, t = t.url);
          var i = $.getUrlProtocol(t),
              o = $.createAjaxRequest("file:" === i);
          if (!$.isFunction(e)) throw new Error("makeAjaxRequest requires a success callback");
          o.onreadystatechange = function () {
            4 == o.readyState && (o.onreadystatechange = function () {}, 200 === o.status || 0 === o.status && "http:" !== i && "https:" !== i ? e(o) : ($.console.log("AJAX request returned %d: %s", o.status, t), $.isFunction(n) && n(o)));
          }, r && (o.withCredentials = !0);

          try {
            o.open("GET", t, !0), o.send(null);
          } catch (r) {
            var a = r.message,
                s = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;

            if (s && "undefined" != typeof r.number && r.number == -2147024891 && (a += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain"), $.console.log("%s while making AJAX request: %s", r.name, a), o.onreadystatechange = function () {}, window.XDomainRequest) {
              var u = new XDomainRequest();

              if (u) {
                u.onload = function (t) {
                  $.isFunction(e) && e({
                    responseText: u.responseText,
                    status: 200,
                    statusText: "OK"
                  });
                }, u.onerror = function (t) {
                  $.isFunction(n) && n({
                    responseText: u.responseText,
                    status: 444,
                    statusText: "An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser."
                  });
                };

                try {
                  u.open("GET", t), u.send();
                } catch (t) {
                  $.isFunction(n) && n(o, r);
                }
              }
            } else $.isFunction(n) && n(o, r);
          }
        },
        jsonp: function jsonp(t) {
          var e,
              n = t.url,
              r = document.head || document.getElementsByTagName("head")[0] || document.documentElement,
              i = t.callbackName || "openseadragon" + $.now(),
              o = window[i],
              a = "$1" + i + "$2",
              s = t.param || "callback",
              u = t.callback;
          n = n.replace(/(\=)\?(&|$)|\?\?/i, a), n += (/\?/.test(n) ? "&" : "?") + s + "=" + i, window[i] = function (t) {
            if (o) window[i] = o;else try {
              delete window[i];
            } catch (t) {}
            u && $.isFunction(u) && u(t);
          }, e = document.createElement("script"), void 0 === t.async && !1 === t.async || (e.async = "async"), t.scriptCharset && (e.charset = t.scriptCharset), e.src = n, e.onload = e.onreadystatechange = function (t, n) {
            (n || !e.readyState || /loaded|complete/.test(e.readyState)) && (e.onload = e.onreadystatechange = null, r && e.parentNode && r.removeChild(e), e = void 0);
          }, r.insertBefore(e, r.firstChild);
        },
        createFromDZI: function createFromDZI() {
          throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
        },
        parseXml: function parseXml(t) {
          if (window.DOMParser) $.parseXml = function (t) {
            var e,
                n = null;
            return e = new DOMParser(), n = e.parseFromString(t, "text/xml");
          };else {
            if (!window.ActiveXObject) throw new Error("Browser doesn't support XML DOM.");

            $.parseXml = function (t) {
              var e = null;
              return e = new ActiveXObject("Microsoft.XMLDOM"), e.async = !1, e.loadXML(t), e;
            };
          }
          return $.parseXml(t);
        },
        parseJSON: function parseJSON(string) {
          return window.JSON && window.JSON.parse ? $.parseJSON = window.JSON.parse : $.parseJSON = function (string) {
            return eval("(" + string + ")");
          }, $.parseJSON(string);
        },
        imageFormatSupported: function imageFormatSupported(t) {
          return t = t ? t : "", !!FILEFORMATS[t.toLowerCase()];
        }
      }), $.Browser = {
        vendor: $.BROWSERS.UNKNOWN,
        version: 0,
        alpha: !0
      };
      var FILEFORMATS = {
        bmp: !1,
        jpeg: !0,
        jpg: !0,
        png: !0,
        tif: !1,
        wdp: !1
      },
          URLPARAMS = {};
      !function () {
        var t,
            e = (navigator.appName, navigator.appVersion),
            n = navigator.userAgent;

        switch (navigator.appName) {
          case "Microsoft Internet Explorer":
            window.attachEvent && window.ActiveXObject && ($.Browser.vendor = $.BROWSERS.IE, $.Browser.version = parseFloat(n.substring(n.indexOf("MSIE") + 5, n.indexOf(";", n.indexOf("MSIE")))));
            break;

          case "Netscape":
            window.addEventListener && (n.indexOf("Firefox") >= 0 ? ($.Browser.vendor = $.BROWSERS.FIREFOX, $.Browser.version = parseFloat(n.substring(n.indexOf("Firefox") + 8))) : n.indexOf("Safari") >= 0 ? ($.Browser.vendor = n.indexOf("Chrome") >= 0 ? $.BROWSERS.CHROME : $.BROWSERS.SAFARI, $.Browser.version = parseFloat(n.substring(n.substring(0, n.indexOf("Safari")).lastIndexOf("/") + 1, n.indexOf("Safari")))) : (t = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})"), null !== t.exec(n) && ($.Browser.vendor = $.BROWSERS.IE, $.Browser.version = parseFloat(RegExp.$1))));
            break;

          case "Opera":
            $.Browser.vendor = $.BROWSERS.OPERA, $.Browser.version = parseFloat(e);
        }

        var r,
            i,
            o,
            a = window.location.search.substring(1),
            s = a.split("&");

        for (o = 0; o < s.length; o++) {
          r = s[o], i = r.indexOf("="), i > 0 && (URLPARAMS[r.substring(0, i)] = decodeURIComponent(r.substring(i + 1)));
        }

        $.Browser.alpha = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9 || $.Browser.vendor == $.BROWSERS.CHROME && $.Browser.version < 2), $.Browser.opacity = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9);
      }();

      var nullfunction = function nullfunction(t) {};

      $.console = window.console || {
        log: nullfunction,
        debug: nullfunction,
        info: nullfunction,
        warn: nullfunction,
        error: nullfunction,
        assert: nullfunction
      }, function (t) {
        var e = t.requestAnimationFrame || t.mozRequestAnimationFrame || t.webkitRequestAnimationFrame || t.msRequestAnimationFrame,
            n = t.cancelAnimationFrame || t.mozCancelAnimationFrame || t.webkitCancelAnimationFrame || t.msCancelAnimationFrame;
        if (e && n) $.requestAnimationFrame = function () {
          return e.apply(t, arguments);
        }, $.cancelAnimationFrame = function () {
          return n.apply(t, arguments);
        };else {
          var r,
              i = [],
              o = [],
              a = 0;
          $.requestAnimationFrame = function (t) {
            return i.push([++a, t]), r || (r = setInterval(function () {
              if (i.length) {
                var t = $.now(),
                    e = o;

                for (o = i, i = e; o.length;) {
                  o.shift()[1](t);
                }
              } else clearInterval(r), r = void 0;
            }, 20)), a;
          }, $.cancelAnimationFrame = function (t) {
            var e, n;

            for (e = 0, n = i.length; e < n; e += 1) {
              if (i[e][0] === t) return void i.splice(e, 1);
            }

            for (e = 0, n = o.length; e < n; e += 1) {
              if (o[e][0] === t) return void o.splice(e, 1);
            }
          };
        }
      }(window);
    }(OpenSeadragon), function (t) {
      var e = {
        supportsFullScreen: !1,
        isFullScreen: function isFullScreen() {
          return !1;
        },
        getFullScreenElement: function getFullScreenElement() {
          return null;
        },
        requestFullScreen: function requestFullScreen() {},
        exitFullScreen: function exitFullScreen() {},
        cancelFullScreen: function cancelFullScreen() {},
        fullScreenEventName: "",
        fullScreenErrorEventName: ""
      };
      document.exitFullscreen ? (e.supportsFullScreen = !0, e.getFullScreenElement = function () {
        return document.fullscreenElement;
      }, e.requestFullScreen = function (t) {
        return t.requestFullscreen();
      }, e.exitFullScreen = function () {
        document.exitFullscreen();
      }, e.fullScreenEventName = "fullscreenchange", e.fullScreenErrorEventName = "fullscreenerror") : document.msExitFullscreen ? (e.supportsFullScreen = !0, e.getFullScreenElement = function () {
        return document.msFullscreenElement;
      }, e.requestFullScreen = function (t) {
        return t.msRequestFullscreen();
      }, e.exitFullScreen = function () {
        document.msExitFullscreen();
      }, e.fullScreenEventName = "MSFullscreenChange", e.fullScreenErrorEventName = "MSFullscreenError") : document.webkitExitFullscreen ? (e.supportsFullScreen = !0, e.getFullScreenElement = function () {
        return document.webkitFullscreenElement;
      }, e.requestFullScreen = function (t) {
        return t.webkitRequestFullscreen();
      }, e.exitFullScreen = function () {
        document.webkitExitFullscreen();
      }, e.fullScreenEventName = "webkitfullscreenchange", e.fullScreenErrorEventName = "webkitfullscreenerror") : document.webkitCancelFullScreen ? (e.supportsFullScreen = !0, e.getFullScreenElement = function () {
        return document.webkitCurrentFullScreenElement;
      }, e.requestFullScreen = function (t) {
        return t.webkitRequestFullScreen();
      }, e.exitFullScreen = function () {
        document.webkitCancelFullScreen();
      }, e.fullScreenEventName = "webkitfullscreenchange", e.fullScreenErrorEventName = "webkitfullscreenerror") : document.mozCancelFullScreen && (e.supportsFullScreen = !0, e.getFullScreenElement = function () {
        return document.mozFullScreenElement;
      }, e.requestFullScreen = function (t) {
        return t.mozRequestFullScreen();
      }, e.exitFullScreen = function () {
        document.mozCancelFullScreen();
      }, e.fullScreenEventName = "mozfullscreenchange", e.fullScreenErrorEventName = "mozfullscreenerror"), e.isFullScreen = function () {
        return null !== e.getFullScreenElement();
      }, e.cancelFullScreen = function () {
        t.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead."), e.exitFullScreen();
      }, t.extend(t, e);
    }(OpenSeadragon), function (t) {
      t.EventSource = function () {
        this.events = {};
      }, t.EventSource.prototype = {
        addOnceHandler: function addOnceHandler(t, e, n, r) {
          var i = this;
          r = r || 1;

          var o = 0,
              a = function a(n) {
            o++, o === r && i.removeHandler(t, a), e(n);
          };

          this.addHandler(t, a, n);
        },
        addHandler: function addHandler(e, n, r) {
          var i = this.events[e];
          i || (this.events[e] = i = []), n && t.isFunction(n) && (i[i.length] = {
            handler: n,
            userData: r || null
          });
        },
        removeHandler: function removeHandler(e, n) {
          var r,
              i = this.events[e],
              o = [];

          if (i && t.isArray(i)) {
            for (r = 0; r < i.length; r++) {
              i[r].handler !== n && o.push(i[r]);
            }

            this.events[e] = o;
          }
        },
        removeAllHandlers: function removeAllHandlers(t) {
          if (t) this.events[t] = [];else for (var e in this.events) {
            this.events[e] = [];
          }
        },
        getHandler: function getHandler(t) {
          var e = this.events[t];
          return e && e.length ? (e = 1 === e.length ? [e[0]] : Array.apply(null, e), function (t, n) {
            var r,
                i = e.length;

            for (r = 0; r < i; r++) {
              e[r] && (n.eventSource = t, n.userData = e[r].userData, e[r].handler(n));
            }
          }) : null;
        },
        raiseEvent: function raiseEvent(t, e) {
          var n = this.getHandler(t);
          n && (e || (e = {}), n(this, e));
        }
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        var n,
            r = dt[e.hash],
            i = r.activePointersLists.length;

        for (n = 0; n < i; n++) {
          r.activePointersLists[n].captureCount > 0 && (t.removeEvent(t.MouseTracker.captureElement, "mousemove", r.mousemovecaptured, !0), t.removeEvent(t.MouseTracker.captureElement, "mouseup", r.mouseupcaptured, !0), t.removeEvent(t.MouseTracker.captureElement, t.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove", r.pointermovecaptured, !0), t.removeEvent(t.MouseTracker.captureElement, t.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp", r.pointerupcaptured, !0), t.removeEvent(t.MouseTracker.captureElement, "touchmove", r.touchmovecaptured, !0), t.removeEvent(t.MouseTracker.captureElement, "touchend", r.touchendcaptured, !0), r.activePointersLists[n].captureCount = 0);
        }

        for (n = 0; n < i; n++) {
          r.activePointersLists.pop();
        }
      }

      function n(n) {
        var r,
            i,
            o = dt[n.hash];

        if (!o.tracking) {
          for (i = 0; i < t.MouseTracker.subscribeEvents.length; i++) {
            r = t.MouseTracker.subscribeEvents[i], t.addEvent(n.element, r, o[r], !1);
          }

          e(n), o.tracking = !0;
        }
      }

      function r(n) {
        var r,
            i,
            o = dt[n.hash];

        if (o.tracking) {
          for (i = 0; i < t.MouseTracker.subscribeEvents.length; i++) {
            r = t.MouseTracker.subscribeEvents[i], t.removeEvent(n.element, r, o[r], !1);
          }

          e(n), o.tracking = !1;
        }
      }

      function i(e, n) {
        var r = dt[e.hash];
        if ("pointerevent" === n) return {
          upName: t.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp",
          upHandler: r.pointerupcaptured,
          moveName: t.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove",
          moveHandler: r.pointermovecaptured
        };
        if ("mouse" === n) return {
          upName: "mouseup",
          upHandler: r.mouseupcaptured,
          moveName: "mousemove",
          moveHandler: r.mousemovecaptured
        };
        if ("touch" === n) return {
          upName: "touchend",
          upHandler: r.touchendcaptured,
          moveName: "touchmove",
          moveHandler: r.touchmovecaptured
        };
        throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");
      }

      function o(e, n, r) {
        var o,
            a = e.getActivePointersListByType(n);
        a.captureCount += r || 1, 1 === a.captureCount && (t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? e.element.setCapture(!0) : (o = i(e, t.MouseTracker.havePointerEvents ? "pointerevent" : n), gt && pt(window.top) && t.addEvent(window.top, o.upName, o.upHandler, !0), t.addEvent(t.MouseTracker.captureElement, o.upName, o.upHandler, !0), t.addEvent(t.MouseTracker.captureElement, o.moveName, o.moveHandler, !0)));
      }

      function a(e, n, r) {
        var o,
            a = e.getActivePointersListByType(n);
        a.captureCount -= r || 1, 0 === a.captureCount && (t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? e.element.releaseCapture() : (o = i(e, t.MouseTracker.havePointerEvents ? "pointerevent" : n), gt && pt(window.top) && t.removeEvent(window.top, o.upName, o.upHandler, !0), t.removeEvent(t.MouseTracker.captureElement, o.moveName, o.moveHandler, !0), t.removeEvent(t.MouseTracker.captureElement, o.upName, o.upHandler, !0)));
      }

      function s(e) {
        var n;
        if (t.MouseTracker.unprefixedPointerEvents) n = e.pointerType;else switch (e.pointerType) {
          case 2:
            n = "touch";
            break;

          case 3:
            n = "pen";
            break;

          case 4:
            n = "mouse";
            break;

          default:
            n = "";
        }
        return n;
      }

      function u(e) {
        return t.getMousePosition(e);
      }

      function c(t, e) {
        return l(u(t), e);
      }

      function l(e, n) {
        var r = t.getElementOffset(n);
        return e.minus(r);
      }

      function h(e, n) {
        return new t.Point((e.x + n.x) / 2, (e.y + n.y) / 2);
      }

      function f(e, n) {
        e.clickHandler && t.cancelEvent(n);
      }

      function p(e, n) {
        e.dblClickHandler && t.cancelEvent(n);
      }

      function m(e, n) {
        var r;
        e.keyDownHandler && (n = t.getEvent(n), r = e.keyDownHandler({
          eventSource: e,
          keyCode: n.keyCode ? n.keyCode : n.charCode,
          ctrl: n.ctrlKey,
          shift: n.shiftKey,
          alt: n.altKey,
          meta: n.metaKey,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), r || t.cancelEvent(n));
      }

      function d(e, n) {
        var r;
        e.keyUpHandler && (n = t.getEvent(n), r = e.keyUpHandler({
          eventSource: e,
          keyCode: n.keyCode ? n.keyCode : n.charCode,
          ctrl: n.ctrlKey,
          shift: n.shiftKey,
          alt: n.altKey,
          meta: n.metaKey,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), r || t.cancelEvent(n));
      }

      function g(e, n) {
        var r;
        e.keyHandler && (n = t.getEvent(n), r = e.keyHandler({
          eventSource: e,
          keyCode: n.keyCode ? n.keyCode : n.charCode,
          ctrl: n.ctrlKey,
          shift: n.shiftKey,
          alt: n.altKey,
          meta: n.metaKey,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), r || t.cancelEvent(n));
      }

      function v(e, n) {
        var r;
        e.focusHandler && (n = t.getEvent(n), r = e.focusHandler({
          eventSource: e,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), r === !1 && t.cancelEvent(n));
      }

      function y(e, n) {
        var r;
        e.blurHandler && (n = t.getEvent(n), r = e.blurHandler({
          eventSource: e,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), r === !1 && t.cancelEvent(n));
      }

      function x(t, e) {
        b(t, e, e);
      }

      function w(e, n) {
        n = t.getEvent(n);
        var r = {
          target: n.target || n.srcElement,
          type: "wheel",
          shiftKey: n.shiftKey || !1,
          clientX: n.clientX,
          clientY: n.clientY,
          pageX: n.pageX ? n.pageX : n.clientX,
          pageY: n.pageY ? n.pageY : n.clientY,
          deltaMode: "MozMousePixelScroll" == n.type ? 0 : 1,
          deltaX: 0,
          deltaZ: 0
        };
        "mousewheel" == t.MouseTracker.wheelEventName ? r.deltaY = -1 / t.DEFAULT_SETTINGS.pixelsPerWheelLine * n.wheelDelta : r.deltaY = n.detail, b(e, r, n);
      }

      function b(e, n, r) {
        var i,
            o = 0;
        o = n.deltaY < 0 ? 1 : -1, e.scrollHandler && (i = e.scrollHandler({
          eventSource: e,
          pointerType: "mouse",
          position: c(n, e.element),
          scroll: o,
          shift: n.shiftKey,
          isTouchEvent: !1,
          originalEvent: r,
          preventDefaultAction: !1,
          userData: e.userData
        }), i === !1 && t.cancelEvent(r));
      }

      function _(t, e) {
        if (t === e) return !1;

        for (; e && e !== t;) {
          e = e.parentNode;
        }

        return e === t;
      }

      function E(e, n) {
        n = t.getEvent(n), T(e, n);
      }

      function M(e, n) {
        n = t.getEvent(n), n.currentTarget === n.relatedTarget || _(n.currentTarget, n.relatedTarget) || T(e, n);
      }

      function T(e, n) {
        var r = {
          id: t.MouseTracker.mousePointerId,
          type: "mouse",
          isPrimary: !0,
          currentPos: u(n),
          currentTime: t.now()
        };
        at(e, n, [r]);
      }

      function N(e, n) {
        n = t.getEvent(n), A(e, n);
      }

      function S(e, n) {
        n = t.getEvent(n), n.currentTarget === n.relatedTarget || _(n.currentTarget, n.relatedTarget) || A(e, n);
      }

      function A(e, n) {
        var r = {
          id: t.MouseTracker.mousePointerId,
          type: "mouse",
          isPrimary: !0,
          currentPos: u(n),
          currentTime: t.now()
        };
        st(e, n, [r]);
      }

      function O(e) {
        return t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? 1 === e ? 0 : 2 === e ? 2 : 4 === e ? 1 : -1 : e;
      }

      function C(e, n) {
        var r;
        n = t.getEvent(n), r = {
          id: t.MouseTracker.mousePointerId,
          type: "mouse",
          isPrimary: !0,
          currentPos: u(n),
          currentTime: t.now()
        }, ut(e, n, [r], O(n.button)) && (t.stopEvent(n), o(e, "mouse")), (e.clickHandler || e.dblClickHandler || e.pressHandler || e.dragHandler || e.dragEndHandler) && t.cancelEvent(n);
      }

      function P(t, e) {
        I(t, e);
      }

      function R(e, n) {
        I(e, n), t.stopEvent(n);
      }

      function I(e, n) {
        var r;
        n = t.getEvent(n), r = {
          id: t.MouseTracker.mousePointerId,
          type: "mouse",
          isPrimary: !0,
          currentPos: u(n),
          currentTime: t.now()
        }, ct(e, n, [r], O(n.button)) && a(e, "mouse");
      }

      function k(t, e) {
        B(t, e);
      }

      function z(e, n) {
        B(e, n), t.stopEvent(n);
      }

      function B(e, n) {
        var r;
        n = t.getEvent(n), r = {
          id: t.MouseTracker.mousePointerId,
          type: "mouse",
          isPrimary: !0,
          currentPos: u(n),
          currentTime: t.now()
        }, lt(e, n, [r]);
      }

      function L(t, e, n) {
        var r,
            i = n.getLength(),
            o = [];

        for (r = 0; r < i; r++) {
          o.push(n.getByIndex(r));
        }

        o.length > 0 && (ct(t, e, o, 0), n.captureCount = 1, a(t, "touch"), st(t, e, o));
      }

      function D(e, n) {
        var r,
            i,
            a,
            s,
            c = n.changedTouches.length,
            l = [],
            h = e.getActivePointersListByType("touch");

        for (r = t.now(), h.getLength() > n.touches.length - c && (t.console.warn("Tracked touch contact count doesn't match event.touches.length. Removing all tracked touch pointers."), L(e, n, h)), i = 0; i < c; i++) {
          l.push({
            id: n.changedTouches[i].identifier,
            type: "touch",
            currentPos: u(n.changedTouches[i]),
            currentTime: r
          });
        }

        for (at(e, n, l), i = 0; i < mt.length; i++) {
          if (mt[i] !== e && mt[i].isTracking() && _(mt[i].element, e.element)) {
            for (s = [], a = 0; a < c; a++) {
              s.push({
                id: n.changedTouches[a].identifier,
                type: "touch",
                currentPos: u(n.changedTouches[a]),
                currentTime: r
              });
            }

            at(mt[i], n, s);
          }
        }

        ut(e, n, l, 0) && (t.stopEvent(n), o(e, "touch", c)), t.cancelEvent(n);
      }

      function j(t, e) {
        U(t, e);
      }

      function F(e, n) {
        U(e, n), t.stopEvent(n);
      }

      function U(e, n) {
        var r,
            i,
            o,
            s,
            c = n.changedTouches.length,
            l = [];

        for (r = t.now(), i = 0; i < c; i++) {
          l.push({
            id: n.changedTouches[i].identifier,
            type: "touch",
            currentPos: u(n.changedTouches[i]),
            currentTime: r
          });
        }

        for (ct(e, n, l, 0) && a(e, "touch", c), st(e, n, l), i = 0; i < mt.length; i++) {
          if (mt[i] !== e && mt[i].isTracking() && _(mt[i].element, e.element)) {
            for (s = [], o = 0; o < c; o++) {
              s.push({
                id: n.changedTouches[o].identifier,
                type: "touch",
                currentPos: u(n.changedTouches[o]),
                currentTime: r
              });
            }

            st(mt[i], n, s);
          }
        }

        t.cancelEvent(n);
      }

      function q(t, e) {
        W(t, e);
      }

      function H(e, n) {
        W(e, n), t.stopEvent(n);
      }

      function W(e, n) {
        var r,
            i = n.changedTouches.length,
            o = [];

        for (r = 0; r < i; r++) {
          o.push({
            id: n.changedTouches[r].identifier,
            type: "touch",
            currentPos: u(n.changedTouches[r]),
            currentTime: t.now()
          });
        }

        lt(e, n, o), t.cancelEvent(n);
      }

      function G(t, e) {
        var n = (e.changedTouches.length, t.getActivePointersListByType("touch"));
        L(t, e, n);
      }

      function $(t, e) {
        return e.stopPropagation(), e.preventDefault(), !1;
      }

      function V(t, e) {
        return e.stopPropagation(), e.preventDefault(), !1;
      }

      function Z(e, n) {
        var r;
        n.currentTarget === n.relatedTarget || _(n.currentTarget, n.relatedTarget) || (r = {
          id: n.pointerId,
          type: s(n),
          isPrimary: n.isPrimary,
          currentPos: u(n),
          currentTime: t.now()
        }, at(e, n, [r]));
      }

      function X(e, n) {
        var r;
        n.currentTarget === n.relatedTarget || _(n.currentTarget, n.relatedTarget) || (r = {
          id: n.pointerId,
          type: s(n),
          isPrimary: n.isPrimary,
          currentPos: u(n),
          currentTime: t.now()
        }, st(e, n, [r]));
      }

      function Y(e, n) {
        var r;
        r = {
          id: n.pointerId,
          type: s(n),
          isPrimary: n.isPrimary,
          currentPos: u(n),
          currentTime: t.now()
        }, ut(e, n, [r], n.button) && (t.stopEvent(n), o(e, r.type)), (e.clickHandler || e.dblClickHandler || e.pressHandler || e.dragHandler || e.dragEndHandler || e.pinchHandler) && t.cancelEvent(n);
      }

      function K(t, e) {
        Q(t, e);
      }

      function J(e, n) {
        var r = e.getActivePointersListByType(s(n));
        r.getById(n.pointerId) && Q(e, n), t.stopEvent(n);
      }

      function Q(e, n) {
        var r;
        r = {
          id: n.pointerId,
          type: s(n),
          isPrimary: n.isPrimary,
          currentPos: u(n),
          currentTime: t.now()
        }, ct(e, n, [r], n.button) && a(e, r.type);
      }

      function tt(t, e) {
        nt(t, e);
      }

      function et(e, n) {
        var r = e.getActivePointersListByType(s(n));
        r.getById(n.pointerId) && nt(e, n), t.stopEvent(n);
      }

      function nt(e, n) {
        var r;
        r = {
          id: n.pointerId,
          type: s(n),
          isPrimary: n.isPrimary,
          currentPos: u(n),
          currentTime: t.now()
        }, lt(e, n, [r]);
      }

      function rt(t, e) {
        var n;
        n = {
          id: e.pointerId,
          type: s(e)
        }, ht(t, e, [n]);
      }

      function it(t, e) {
        return e.hasOwnProperty("isPrimary") || (0 === t.getLength() ? e.isPrimary = !0 : e.isPrimary = !1), e.speed = 0, e.direction = 0, e.contactPos = e.currentPos, e.contactTime = e.currentTime, e.lastPos = e.currentPos, e.lastTime = e.currentTime, t.add(e);
      }

      function ot(t, e) {
        var n, r;
        return t.getById(e.id) ? (n = t.removeById(e.id), e.hasOwnProperty("isPrimary") || (r = t.getPrimary(), r || (r = t.getByIndex(0), r && (r.isPrimary = !0)))) : n = t.getLength(), n;
      }

      function at(e, n, r) {
        var i,
            o,
            a,
            s,
            u = e.getActivePointersListByType(r[0].type),
            c = r.length;

        for (i = 0; i < c; i++) {
          o = r[i], a = u.getById(o.id), a ? (a.insideElement = !0, a.lastPos = a.currentPos, a.lastTime = a.currentTime, a.currentPos = o.currentPos, a.currentTime = o.currentTime, o = a) : (o.captured = !1, o.insideElementPressed = !1, o.insideElement = !0, it(u, o)), e.enterHandler && (s = e.enterHandler({
            eventSource: e,
            pointerType: o.type,
            position: l(o.currentPos, e.element),
            buttons: u.buttons,
            pointers: e.getActivePointerCount(),
            insideElementPressed: o.insideElementPressed,
            buttonDownAny: 0 !== u.buttons,
            isTouchEvent: "touch" === o.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), s === !1 && t.cancelEvent(n));
        }
      }

      function st(e, n, r) {
        var i,
            o,
            a,
            s,
            u = (dt[e.hash], e.getActivePointersListByType(r[0].type)),
            c = r.length;

        for (i = 0; i < c; i++) {
          o = r[i], a = u.getById(o.id), a && (a.captured ? (a.insideElement = !1, a.lastPos = a.currentPos, a.lastTime = a.currentTime, a.currentPos = o.currentPos, a.currentTime = o.currentTime) : ot(u, a), o = a), e.exitHandler && (s = e.exitHandler({
            eventSource: e,
            pointerType: o.type,
            position: l(o.currentPos, e.element),
            buttons: u.buttons,
            pointers: e.getActivePointerCount(),
            insideElementPressed: !!a && a.insideElementPressed,
            buttonDownAny: 0 !== u.buttons,
            isTouchEvent: "touch" === o.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), s === !1 && t.cancelEvent(n));
        }
      }

      function ut(e, n, r, i) {
        var o,
            a,
            s,
            u,
            c = dt[e.hash],
            f = e.getActivePointersListByType(r[0].type),
            p = r.length;
        if ("undefined" != typeof n.buttons ? f.buttons = n.buttons : t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? 0 === i ? f.buttons += 1 : 1 === i ? f.buttons += 4 : 2 === i ? f.buttons += 2 : 3 === i ? f.buttons += 8 : 4 === i ? f.buttons += 16 : 5 === i && (f.buttons += 32) : 0 === i ? f.buttons |= 1 : 1 === i ? f.buttons |= 4 : 2 === i ? f.buttons |= 2 : 3 === i ? f.buttons |= 8 : 4 === i ? f.buttons |= 16 : 5 === i && (f.buttons |= 32), 0 !== i) return e.nonPrimaryPressHandler && (o = e.nonPrimaryPressHandler({
          eventSource: e,
          pointerType: r[0].type,
          position: l(r[0].currentPos, e.element),
          button: i,
          buttons: f.buttons,
          isTouchEvent: "touch" === r[0].type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), o === !1 && t.cancelEvent(n)), !1;

        for (a = 0; a < p; a++) {
          s = r[a], u = f.getById(s.id), u ? (u.captured = !0, u.insideElementPressed = !0, u.insideElement = !0, u.contactPos = s.currentPos, u.contactTime = s.currentTime, u.lastPos = u.currentPos, u.lastTime = u.currentTime, u.currentPos = s.currentPos, u.currentTime = s.currentTime, s = u) : (s.captured = !0, s.insideElementPressed = !0, s.insideElement = !0, it(f, s)), f.contacts++, (e.dragHandler || e.dragEndHandler || e.pinchHandler) && t.MouseTracker.gesturePointVelocityTracker.addPoint(e, s), 1 === f.contacts ? e.pressHandler && (o = e.pressHandler({
            eventSource: e,
            pointerType: s.type,
            position: l(s.contactPos, e.element),
            buttons: f.buttons,
            isTouchEvent: "touch" === s.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)) : 2 === f.contacts && e.pinchHandler && "touch" === s.type && (c.pinchGPoints = f.asArray(), c.lastPinchDist = c.currentPinchDist = c.pinchGPoints[0].currentPos.distanceTo(c.pinchGPoints[1].currentPos), c.lastPinchCenter = c.currentPinchCenter = h(c.pinchGPoints[0].currentPos, c.pinchGPoints[1].currentPos));
        }

        return !0;
      }

      function ct(e, n, r, i) {
        var o,
            a,
            s,
            u,
            c,
            f,
            p,
            m = dt[e.hash],
            d = e.getActivePointersListByType(r[0].type),
            g = r.length,
            v = !1,
            y = !1;
        if ("undefined" != typeof n.buttons ? d.buttons = n.buttons : t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? 0 === i ? d.buttons -= 1 : 1 === i ? d.buttons -= 4 : 2 === i ? d.buttons -= 2 : 3 === i ? d.buttons -= 8 : 4 === i ? d.buttons -= 16 : 5 === i && (d.buttons -= 32) : 0 === i ? d.buttons ^= -2 : 1 === i ? d.buttons ^= -5 : 2 === i ? d.buttons ^= -3 : 3 === i ? d.buttons ^= -9 : 4 === i ? d.buttons ^= -17 : 5 === i && (d.buttons ^= -33), 0 !== i) return e.nonPrimaryReleaseHandler && (o = e.nonPrimaryReleaseHandler({
          eventSource: e,
          pointerType: r[0].type,
          position: l(r[0].currentPos, e.element),
          button: i,
          buttons: d.buttons,
          isTouchEvent: "touch" === r[0].type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), o === !1 && t.cancelEvent(n)), !1;

        for (u = 0; u < g; u++) {
          c = r[u], f = d.getById(c.id), f && (f.captured && (f.captured = !1, v = !0, y = !0), f.lastPos = f.currentPos, f.lastTime = f.currentTime, f.currentPos = c.currentPos, f.currentTime = c.currentTime, f.insideElement || ot(d, f), a = f.currentPos, s = f.currentTime, y ? (d.contacts--, (e.dragHandler || e.dragEndHandler || e.pinchHandler) && t.MouseTracker.gesturePointVelocityTracker.removePoint(e, f), 0 === d.contacts ? (e.releaseHandler && (o = e.releaseHandler({
            eventSource: e,
            pointerType: f.type,
            position: l(a, e.element),
            buttons: d.buttons,
            insideElementPressed: f.insideElementPressed,
            insideElementReleased: f.insideElement,
            isTouchEvent: "touch" === f.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)), e.dragEndHandler && !f.currentPos.equals(f.contactPos) && (o = e.dragEndHandler({
            eventSource: e,
            pointerType: f.type,
            position: l(f.currentPos, e.element),
            speed: f.speed,
            direction: f.direction,
            shift: n.shiftKey,
            isTouchEvent: "touch" === f.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)), (e.clickHandler || e.dblClickHandler) && f.insideElement && (p = s - f.contactTime <= e.clickTimeThreshold && f.contactPos.distanceTo(a) <= e.clickDistThreshold, e.clickHandler && (o = e.clickHandler({
            eventSource: e,
            pointerType: f.type,
            position: l(f.currentPos, e.element),
            quick: p,
            shift: n.shiftKey,
            isTouchEvent: "touch" === f.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)), e.dblClickHandler && p && (d.clicks++, 1 === d.clicks ? (m.lastClickPos = a, m.dblClickTimeOut = setTimeout(function () {
            d.clicks = 0;
          }, e.dblClickTimeThreshold)) : 2 === d.clicks && (clearTimeout(m.dblClickTimeOut), d.clicks = 0, m.lastClickPos.distanceTo(a) <= e.dblClickDistThreshold && (o = e.dblClickHandler({
            eventSource: e,
            pointerType: f.type,
            position: l(f.currentPos, e.element),
            shift: n.shiftKey,
            isTouchEvent: "touch" === f.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)), m.lastClickPos = null)))) : 2 === d.contacts && e.pinchHandler && "touch" === f.type && (m.pinchGPoints = d.asArray(), m.lastPinchDist = m.currentPinchDist = m.pinchGPoints[0].currentPos.distanceTo(m.pinchGPoints[1].currentPos), m.lastPinchCenter = m.currentPinchCenter = h(m.pinchGPoints[0].currentPos, m.pinchGPoints[1].currentPos))) : e.releaseHandler && (o = e.releaseHandler({
            eventSource: e,
            pointerType: f.type,
            position: l(a, e.element),
            buttons: d.buttons,
            insideElementPressed: f.insideElementPressed,
            insideElementReleased: f.insideElement,
            isTouchEvent: "touch" === f.type,
            originalEvent: n,
            preventDefaultAction: !1,
            userData: e.userData
          }), o === !1 && t.cancelEvent(n)));
        }

        return v;
      }

      function lt(e, n, r) {
        var i,
            o,
            a,
            s,
            u,
            c,
            f = dt[e.hash],
            p = e.getActivePointersListByType(r[0].type),
            m = r.length;

        for ("undefined" != typeof n.buttons && (p.buttons = n.buttons), i = 0; i < m; i++) {
          o = r[i], a = p.getById(o.id), a ? (o.hasOwnProperty("isPrimary") && (a.isPrimary = o.isPrimary), a.lastPos = a.currentPos, a.lastTime = a.currentTime, a.currentPos = o.currentPos, a.currentTime = o.currentTime) : (o.captured = !1, o.insideElementPressed = !1, o.insideElement = !0, it(p, o));
        }

        e.stopHandler && "mouse" === r[0].type && (clearTimeout(e.stopTimeOut), e.stopTimeOut = setTimeout(function () {
          ft(e, n, r[0].type);
        }, e.stopDelay)), 0 === p.contacts ? e.moveHandler && (c = e.moveHandler({
          eventSource: e,
          pointerType: r[0].type,
          position: l(r[0].currentPos, e.element),
          buttons: p.buttons,
          isTouchEvent: "touch" === r[0].type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), c === !1 && t.cancelEvent(n)) : 1 === p.contacts ? (e.moveHandler && (a = p.asArray()[0], c = e.moveHandler({
          eventSource: e,
          pointerType: a.type,
          position: l(a.currentPos, e.element),
          buttons: p.buttons,
          isTouchEvent: "touch" === a.type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), c === !1 && t.cancelEvent(n)), e.dragHandler && (a = p.asArray()[0], u = a.currentPos.minus(a.lastPos), c = e.dragHandler({
          eventSource: e,
          pointerType: a.type,
          position: l(a.currentPos, e.element),
          buttons: p.buttons,
          delta: u,
          speed: a.speed,
          direction: a.direction,
          shift: n.shiftKey,
          isTouchEvent: "touch" === a.type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), c === !1 && t.cancelEvent(n))) : 2 === p.contacts && (e.moveHandler && (s = p.asArray(), c = e.moveHandler({
          eventSource: e,
          pointerType: s[0].type,
          position: l(h(s[0].currentPos, s[1].currentPos), e.element),
          buttons: p.buttons,
          isTouchEvent: "touch" === s[0].type,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), c === !1 && t.cancelEvent(n)), e.pinchHandler && "touch" === r[0].type && (u = f.pinchGPoints[0].currentPos.distanceTo(f.pinchGPoints[1].currentPos), u != f.currentPinchDist && (f.lastPinchDist = f.currentPinchDist, f.currentPinchDist = u, f.lastPinchCenter = f.currentPinchCenter, f.currentPinchCenter = h(f.pinchGPoints[0].currentPos, f.pinchGPoints[1].currentPos), c = e.pinchHandler({
          eventSource: e,
          pointerType: "touch",
          gesturePoints: f.pinchGPoints,
          lastCenter: l(f.lastPinchCenter, e.element),
          center: l(f.currentPinchCenter, e.element),
          lastDistance: f.lastPinchDist,
          distance: f.currentPinchDist,
          shift: n.shiftKey,
          originalEvent: n,
          preventDefaultAction: !1,
          userData: e.userData
        }), c === !1 && t.cancelEvent(n))));
      }

      function ht(t, e, n) {
        ct(t, e, n, 0), st(t, e, n);
      }

      function ft(t, e, n) {
        t.stopHandler && t.stopHandler({
          eventSource: t,
          pointerType: n,
          position: c(e, t.element),
          buttons: t.getActivePointersListByType(n).buttons,
          isTouchEvent: "touch" === n,
          originalEvent: e,
          preventDefaultAction: !1,
          userData: t.userData
        });
      }

      function pt(t) {
        try {
          return t.addEventListener && t.removeEventListener;
        } catch (t) {
          return !1;
        }
      }

      var mt = [],
          dt = {};
      t.MouseTracker = function (e) {
        mt.push(this);
        var n = arguments;
        t.isPlainObject(e) || (e = {
          element: n[0],
          clickTimeThreshold: n[1],
          clickDistThreshold: n[2]
        }), this.hash = Math.random(), this.element = t.getElement(e.element), this.clickTimeThreshold = e.clickTimeThreshold || t.DEFAULT_SETTINGS.clickTimeThreshold, this.clickDistThreshold = e.clickDistThreshold || t.DEFAULT_SETTINGS.clickDistThreshold, this.dblClickTimeThreshold = e.dblClickTimeThreshold || t.DEFAULT_SETTINGS.dblClickTimeThreshold, this.dblClickDistThreshold = e.dblClickDistThreshold || t.DEFAULT_SETTINGS.dblClickDistThreshold, this.userData = e.userData || null, this.stopDelay = e.stopDelay || 50, this.enterHandler = e.enterHandler || null, this.exitHandler = e.exitHandler || null, this.pressHandler = e.pressHandler || null, this.nonPrimaryPressHandler = e.nonPrimaryPressHandler || null, this.releaseHandler = e.releaseHandler || null, this.nonPrimaryReleaseHandler = e.nonPrimaryReleaseHandler || null, this.moveHandler = e.moveHandler || null, this.scrollHandler = e.scrollHandler || null, this.clickHandler = e.clickHandler || null, this.dblClickHandler = e.dblClickHandler || null, this.dragHandler = e.dragHandler || null, this.dragEndHandler = e.dragEndHandler || null, this.pinchHandler = e.pinchHandler || null, this.stopHandler = e.stopHandler || null, this.keyDownHandler = e.keyDownHandler || null, this.keyUpHandler = e.keyUpHandler || null, this.keyHandler = e.keyHandler || null, this.focusHandler = e.focusHandler || null, this.blurHandler = e.blurHandler || null;
        var r = this;
        dt[this.hash] = {
          click: function click(t) {
            f(r, t);
          },
          dblclick: function dblclick(t) {
            p(r, t);
          },
          keydown: function keydown(t) {
            m(r, t);
          },
          keyup: function keyup(t) {
            d(r, t);
          },
          keypress: function keypress(t) {
            g(r, t);
          },
          focus: function focus(t) {
            v(r, t);
          },
          blur: function blur(t) {
            y(r, t);
          },
          wheel: function wheel(t) {
            x(r, t);
          },
          mousewheel: function mousewheel(t) {
            w(r, t);
          },
          DOMMouseScroll: function DOMMouseScroll(t) {
            w(r, t);
          },
          MozMousePixelScroll: function MozMousePixelScroll(t) {
            w(r, t);
          },
          mouseenter: function mouseenter(t) {
            E(r, t);
          },
          mouseleave: function mouseleave(t) {
            N(r, t);
          },
          mouseover: function mouseover(t) {
            M(r, t);
          },
          mouseout: function mouseout(t) {
            S(r, t);
          },
          mousedown: function mousedown(t) {
            C(r, t);
          },
          mouseup: function mouseup(t) {
            P(r, t);
          },
          mouseupcaptured: function mouseupcaptured(t) {
            R(r, t);
          },
          mousemove: function mousemove(t) {
            k(r, t);
          },
          mousemovecaptured: function mousemovecaptured(t) {
            z(r, t);
          },
          touchstart: function touchstart(t) {
            D(r, t);
          },
          touchend: function touchend(t) {
            j(r, t);
          },
          touchendcaptured: function touchendcaptured(t) {
            F(r, t);
          },
          touchmove: function touchmove(t) {
            q(r, t);
          },
          touchmovecaptured: function touchmovecaptured(t) {
            H(r, t);
          },
          touchcancel: function touchcancel(t) {
            G(r, t);
          },
          gesturestart: function gesturestart(t) {
            $(r, t);
          },
          gesturechange: function gesturechange(t) {
            V(r, t);
          },
          pointerover: function pointerover(t) {
            Z(r, t);
          },
          MSPointerOver: function MSPointerOver(t) {
            Z(r, t);
          },
          pointerout: function pointerout(t) {
            X(r, t);
          },
          MSPointerOut: function MSPointerOut(t) {
            X(r, t);
          },
          pointerdown: function pointerdown(t) {
            Y(r, t);
          },
          MSPointerDown: function MSPointerDown(t) {
            Y(r, t);
          },
          pointerup: function pointerup(t) {
            K(r, t);
          },
          MSPointerUp: function MSPointerUp(t) {
            K(r, t);
          },
          pointermove: function pointermove(t) {
            tt(r, t);
          },
          MSPointerMove: function MSPointerMove(t) {
            tt(r, t);
          },
          pointercancel: function pointercancel(t) {
            rt(r, t);
          },
          MSPointerCancel: function MSPointerCancel(t) {
            rt(r, t);
          },
          pointerupcaptured: function pointerupcaptured(t) {
            J(r, t);
          },
          pointermovecaptured: function pointermovecaptured(t) {
            et(r, t);
          },
          tracking: !1,
          activePointersLists: [],
          lastClickPos: null,
          dblClickTimeOut: null,
          pinchGPoints: [],
          lastPinchDist: 0,
          currentPinchDist: 0,
          lastPinchCenter: null,
          currentPinchCenter: null
        }, e.startDisabled || this.setTracking(!0);
      }, t.MouseTracker.prototype = {
        destroy: function destroy() {
          var t;

          for (r(this), this.element = null, t = 0; t < mt.length; t++) {
            if (mt[t] === this) {
              mt.splice(t, 1);
              break;
            }
          }

          dt[this.hash] = null, delete dt[this.hash];
        },
        isTracking: function isTracking() {
          return dt[this.hash].tracking;
        },
        setTracking: function setTracking(t) {
          return t ? n(this) : r(this), this;
        },
        getActivePointersListByType: function getActivePointersListByType(e) {
          var n,
              r,
              i = dt[this.hash],
              o = i.activePointersLists.length;

          for (n = 0; n < o; n++) {
            if (i.activePointersLists[n].type === e) return i.activePointersLists[n];
          }

          return r = new t.MouseTracker.GesturePointList(e), i.activePointersLists.push(r), r;
        },
        getActivePointerCount: function getActivePointerCount() {
          var t,
              e = dt[this.hash],
              n = e.activePointersLists.length,
              r = 0;

          for (t = 0; t < n; t++) {
            r += e.activePointersLists[t].getLength();
          }

          return r;
        },
        enterHandler: function enterHandler() {},
        exitHandler: function exitHandler() {},
        pressHandler: function pressHandler() {},
        nonPrimaryPressHandler: function nonPrimaryPressHandler() {},
        releaseHandler: function releaseHandler() {},
        nonPrimaryReleaseHandler: function nonPrimaryReleaseHandler() {},
        moveHandler: function moveHandler() {},
        scrollHandler: function scrollHandler() {},
        clickHandler: function clickHandler() {},
        dblClickHandler: function dblClickHandler() {},
        dragHandler: function dragHandler() {},
        dragEndHandler: function dragEndHandler() {},
        pinchHandler: function pinchHandler() {},
        stopHandler: function stopHandler() {},
        keyDownHandler: function keyDownHandler() {},
        keyUpHandler: function keyUpHandler() {},
        keyHandler: function keyHandler() {},
        focusHandler: function focusHandler() {},
        blurHandler: function blurHandler() {}
      }, t.MouseTracker.gesturePointVelocityTracker = function () {
        var e = [],
            n = 0,
            r = 0,
            i = function i(t, e) {
          return t.hash.toString() + e.type + e.id.toString();
        },
            o = function o() {
          var n,
              i,
              o,
              a,
              s,
              u,
              c = e.length,
              l = t.now();

          for (a = l - r, r = l, n = 0; n < c; n++) {
            i = e[n], o = i.gPoint, o.direction = Math.atan2(o.currentPos.y - i.lastPos.y, o.currentPos.x - i.lastPos.x), s = i.lastPos.distanceTo(o.currentPos), i.lastPos = o.currentPos, u = 1e3 * s / (a + 1), o.speed = .75 * u + .25 * o.speed;
          }
        },
            a = function a(_a5, s) {
          var u = i(_a5, s);
          e.push({
            guid: u,
            gPoint: s,
            lastPos: s.currentPos
          }), 1 === e.length && (r = t.now(), n = window.setInterval(o, 50));
        },
            s = function s(t, r) {
          var o,
              a = i(t, r),
              s = e.length;

          for (o = 0; o < s; o++) {
            if (e[o].guid === a) {
              e.splice(o, 1), s--, 0 === s && window.clearInterval(n);
              break;
            }
          }
        };

        return {
          addPoint: a,
          removePoint: s
        };
      }(), t.MouseTracker.captureElement = document, t.MouseTracker.wheelEventName = t.Browser.vendor == t.BROWSERS.IE && t.Browser.version > 8 || "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll", t.MouseTracker.supportsMouseCapture = function () {
        var e = document.createElement("div");
        return t.isFunction(e.setCapture) && t.isFunction(e.releaseCapture);
      }(), t.MouseTracker.subscribeEvents = ["click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", t.MouseTracker.wheelEventName], "DOMMouseScroll" == t.MouseTracker.wheelEventName && t.MouseTracker.subscribeEvents.push("MozMousePixelScroll"), window.PointerEvent && (window.navigator.pointerEnabled || t.Browser.vendor !== t.BROWSERS.IE) ? (t.MouseTracker.havePointerEvents = !0, t.MouseTracker.subscribeEvents.push("pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel"), t.MouseTracker.unprefixedPointerEvents = !0, navigator.maxTouchPoints ? t.MouseTracker.maxTouchPoints = navigator.maxTouchPoints : t.MouseTracker.maxTouchPoints = 0, t.MouseTracker.haveMouseEnter = !1) : window.MSPointerEvent && window.navigator.msPointerEnabled ? (t.MouseTracker.havePointerEvents = !0, t.MouseTracker.subscribeEvents.push("MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel"), t.MouseTracker.unprefixedPointerEvents = !1, navigator.msMaxTouchPoints ? t.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints : t.MouseTracker.maxTouchPoints = 0, t.MouseTracker.haveMouseEnter = !1) : (t.MouseTracker.havePointerEvents = !1, t.Browser.vendor === t.BROWSERS.IE && t.Browser.version < 9 ? (t.MouseTracker.subscribeEvents.push("mouseenter", "mouseleave"), t.MouseTracker.haveMouseEnter = !0) : (t.MouseTracker.subscribeEvents.push("mouseover", "mouseout"), t.MouseTracker.haveMouseEnter = !1), t.MouseTracker.subscribeEvents.push("mousedown", "mouseup", "mousemove"), "ontouchstart" in window && t.MouseTracker.subscribeEvents.push("touchstart", "touchend", "touchmove", "touchcancel"), "ongesturestart" in window && t.MouseTracker.subscribeEvents.push("gesturestart", "gesturechange"), t.MouseTracker.mousePointerId = "legacy-mouse", t.MouseTracker.maxTouchPoints = 10), t.MouseTracker.GesturePointList = function (t) {
        this._gPoints = [], this.type = t, this.buttons = 0, this.contacts = 0, this.clicks = 0, this.captureCount = 0;
      }, t.MouseTracker.GesturePointList.prototype = {
        getLength: function getLength() {
          return this._gPoints.length;
        },
        asArray: function asArray() {
          return this._gPoints;
        },
        add: function add(t) {
          return this._gPoints.push(t);
        },
        removeById: function removeById(t) {
          var e,
              n = this._gPoints.length;

          for (e = 0; e < n; e++) {
            if (this._gPoints[e].id === t) {
              this._gPoints.splice(e, 1);

              break;
            }
          }

          return this._gPoints.length;
        },
        getByIndex: function getByIndex(t) {
          return t < this._gPoints.length ? this._gPoints[t] : null;
        },
        getById: function getById(t) {
          var e,
              n = this._gPoints.length;

          for (e = 0; e < n; e++) {
            if (this._gPoints[e].id === t) return this._gPoints[e];
          }

          return null;
        },
        getPrimary: function getPrimary(t) {
          var e,
              n = this._gPoints.length;

          for (e = 0; e < n; e++) {
            if (this._gPoints[e].isPrimary) return this._gPoints[e];
          }

          return null;
        }
      };

      var gt = function () {
        try {
          return window.self !== window.top;
        } catch (t) {
          return !0;
        }
      }();
    }(OpenSeadragon), function (t) {
      t.ControlAnchor = {
        NONE: 0,
        TOP_LEFT: 1,
        TOP_RIGHT: 2,
        BOTTOM_RIGHT: 3,
        BOTTOM_LEFT: 4,
        ABSOLUTE: 5
      }, t.Control = function (e, n, r) {
        var i = e.parentNode;
        "number" == typeof n && (t.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; please use an options object instead.  Support for this deprecated variant is scheduled for removal in December 2013"), n = {
          anchor: n
        }), n.attachToViewer = "undefined" == typeof n.attachToViewer || n.attachToViewer, this.autoFade = "undefined" == typeof n.autoFade || n.autoFade, this.element = e, this.anchor = n.anchor, this.container = r, this.anchor == t.ControlAnchor.ABSOLUTE ? (this.wrapper = t.makeNeutralElement("div"), this.wrapper.style.position = "absolute", this.wrapper.style.top = "number" == typeof n.top ? n.top + "px" : n.top, this.wrapper.style.left = "number" == typeof n.left ? n.left + "px" : n.left, this.wrapper.style.height = "number" == typeof n.height ? n.height + "px" : n.height, this.wrapper.style.width = "number" == typeof n.width ? n.width + "px" : n.width, this.wrapper.style.margin = "0px", this.wrapper.style.padding = "0px", this.element.style.position = "relative", this.element.style.top = "0px", this.element.style.left = "0px", this.element.style.height = "100%", this.element.style.width = "100%") : (this.wrapper = t.makeNeutralElement("div"), this.wrapper.style.display = "inline-block", this.anchor == t.ControlAnchor.NONE && (this.wrapper.style.width = this.wrapper.style.height = "100%")), this.wrapper.appendChild(this.element), n.attachToViewer ? this.anchor == t.ControlAnchor.TOP_RIGHT || this.anchor == t.ControlAnchor.BOTTOM_RIGHT ? this.container.insertBefore(this.wrapper, this.container.firstChild) : this.container.appendChild(this.wrapper) : i.appendChild(this.wrapper);
      }, t.Control.prototype = {
        destroy: function destroy() {
          this.wrapper.removeChild(this.element), this.container.removeChild(this.wrapper);
        },
        isVisible: function isVisible() {
          return "none" != this.wrapper.style.display;
        },
        setVisible: function setVisible(e) {
          this.wrapper.style.display = e ? this.anchor == t.ControlAnchor.ABSOLUTE ? "block" : "inline-block" : "none";
        },
        setOpacity: function setOpacity(e) {
          this.element[t.SIGNAL] && t.Browser.vendor == t.BROWSERS.IE ? t.setElementOpacity(this.element, e, !0) : t.setElementOpacity(this.wrapper, e, !0);
        }
      };
    }(OpenSeadragon), function (t) {
      function e(t, e) {
        var n,
            r = t.controls;

        for (n = r.length - 1; n >= 0; n--) {
          if (r[n].element == e) return n;
        }

        return -1;
      }

      t.ControlDock = function (e) {
        var n,
            r,
            i = ["topleft", "topright", "bottomright", "bottomleft"];

        for (t.extend(!0, this, {
          id: "controldock-" + t.now() + "-" + Math.floor(1e6 * Math.random()),
          container: t.makeNeutralElement("div"),
          controls: []
        }, e), this.container.onsubmit = function () {
          return !1;
        }, this.element && (this.element = t.getElement(this.element), this.element.appendChild(this.container), this.element.style.position = "relative", this.container.style.width = "100%", this.container.style.height = "100%"), r = 0; r < i.length; r++) {
          n = i[r], this.controls[n] = t.makeNeutralElement("div"), this.controls[n].style.position = "absolute", n.match("left") && (this.controls[n].style.left = "0px"), n.match("right") && (this.controls[n].style.right = "0px"), n.match("top") && (this.controls[n].style.top = "0px"), n.match("bottom") && (this.controls[n].style.bottom = "0px");
        }

        this.container.appendChild(this.controls.topleft), this.container.appendChild(this.controls.topright), this.container.appendChild(this.controls.bottomright), this.container.appendChild(this.controls.bottomleft);
      }, t.ControlDock.prototype = {
        addControl: function addControl(n, r) {
          n = t.getElement(n);
          var i = null;

          if (!(e(this, n) >= 0)) {
            switch (r.anchor) {
              case t.ControlAnchor.TOP_RIGHT:
                i = this.controls.topright, n.style.position = "relative", n.style.paddingRight = "0px", n.style.paddingTop = "0px";
                break;

              case t.ControlAnchor.BOTTOM_RIGHT:
                i = this.controls.bottomright, n.style.position = "relative", n.style.paddingRight = "0px", n.style.paddingBottom = "0px";
                break;

              case t.ControlAnchor.BOTTOM_LEFT:
                i = this.controls.bottomleft, n.style.position = "relative", n.style.paddingLeft = "0px", n.style.paddingBottom = "0px";
                break;

              case t.ControlAnchor.TOP_LEFT:
                i = this.controls.topleft, n.style.position = "relative", n.style.paddingLeft = "0px", n.style.paddingTop = "0px";
                break;

              case t.ControlAnchor.ABSOLUTE:
                i = this.container, n.style.margin = "0px", n.style.padding = "0px";
                break;

              default:
              case t.ControlAnchor.NONE:
                i = this.container, n.style.margin = "0px", n.style.padding = "0px";
            }

            this.controls.push(new t.Control(n, r, i)), n.style.display = "inline-block";
          }
        },
        removeControl: function removeControl(n) {
          n = t.getElement(n);
          var r = e(this, n);
          return r >= 0 && (this.controls[r].destroy(), this.controls.splice(r, 1)), this;
        },
        clearControls: function clearControls() {
          for (; this.controls.length > 0;) {
            this.controls.pop().destroy();
          }

          return this;
        },
        areControlsEnabled: function areControlsEnabled() {
          var t;

          for (t = this.controls.length - 1; t >= 0; t--) {
            if (this.controls[t].isVisible()) return !0;
          }

          return !1;
        },
        setControlsEnabled: function setControlsEnabled(t) {
          var e;

          for (e = this.controls.length - 1; e >= 0; e--) {
            this.controls[e].setVisible(t);
          }

          return this;
        }
      };
    }(OpenSeadragon), function (t) {
      t.Placement = t.freezeObject({
        CENTER: 0,
        TOP_LEFT: 1,
        TOP: 2,
        TOP_RIGHT: 3,
        RIGHT: 4,
        BOTTOM_RIGHT: 5,
        BOTTOM: 6,
        BOTTOM_LEFT: 7,
        LEFT: 8,
        properties: {
          0: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          },
          1: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          2: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          3: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !0,
            isVerticallyCentered: !1,
            isBottom: !1
          },
          4: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          },
          5: {
            isLeft: !1,
            isHorizontallyCentered: !1,
            isRight: !0,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          6: {
            isLeft: !1,
            isHorizontallyCentered: !0,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          7: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !1,
            isBottom: !0
          },
          8: {
            isLeft: !0,
            isHorizontallyCentered: !1,
            isRight: !1,
            isTop: !1,
            isVerticallyCentered: !0,
            isBottom: !1
          }
        }
      });
    }(OpenSeadragon), function (t) {
      function e(e) {
        return e = t.getElement(e), new t.Point(0 === e.clientWidth ? 1 : e.clientWidth, 0 === e.clientHeight ? 1 : e.clientHeight);
      }

      function n(e, n, r, i) {
        function o(t, e) {
          t.ready ? r(t) : (t.addHandler("ready", function () {
            r(t);
          }), t.addHandler("open-failed", function (t) {
            i({
              message: t.message,
              source: e
            });
          }));
        }

        var a = e;
        "string" == t.type(n) && (n.match(/\s*<.*/) ? n = t.parseXml(n) : n.match(/\s*[\{\[].*/) && (n = t.parseJSON(n))), setTimeout(function () {
          if ("string" == t.type(n)) n = new t.TileSource({
            url: n,
            crossOriginPolicy: e.crossOriginPolicy,
            ajaxWithCredentials: e.ajaxWithCredentials,
            useCanvas: e.useCanvas,
            success: function success(t) {
              r(t.tileSource);
            }
          }), n.addHandler("open-failed", function (t) {
            i(t);
          });else if (t.isPlainObject(n) || n.nodeType) {
            if (!n.crossOriginPolicy && e.crossOriginPolicy && (n.crossOriginPolicy = e.crossOriginPolicy), void 0 === n.ajaxWithCredentials && (n.ajaxWithCredentials = e.ajaxWithCredentials), void 0 === n.useCanvas && (n.useCanvas = e.useCanvas), t.isFunction(n.getTileUrl)) {
              var s = new t.TileSource(n);
              s.getTileUrl = n.getTileUrl, r(s);
            } else {
              var u = t.TileSource.determineType(a, n);
              if (!u) return void i({
                message: "Unable to load TileSource",
                source: n
              });
              var c = u.prototype.configure.apply(a, [n]);
              o(new u(c), n);
            }
          } else o(n, n);
        });
      }

      function r(e, n) {
        if (n instanceof t.Overlay) return n;
        var r = null;
        if (n.element) r = t.getElement(n.element);else {
          var i = n.id ? n.id : "openseadragon-overlay-" + Math.floor(1e7 * Math.random());
          r = t.getElement(n.id), r || (r = document.createElement("a"), r.href = "#/overlay/" + i), r.id = i, t.addClass(r, n.className ? n.className : "openseadragon-overlay");
        }
        var o = n.location,
            a = n.width,
            s = n.height;

        if (!o) {
          var u = n.x,
              c = n.y;

          if (void 0 !== n.px) {
            var l = e.viewport.imageToViewportRectangle(new t.Rect(n.px, n.py, a || 0, s || 0));
            u = l.x, c = l.y, a = void 0 !== a ? l.width : void 0, s = void 0 !== s ? l.height : void 0;
          }

          o = new t.Point(u, c);
        }

        var h = n.placement;
        return h && "string" === t.type(h) && (h = t.Placement[n.placement.toUpperCase()]), new t.Overlay({
          element: r,
          location: o,
          placement: h,
          onDraw: n.onDraw,
          checkResize: n.checkResize,
          width: a,
          height: s,
          rotationMode: n.rotationMode
        });
      }

      function i(t, e) {
        var n;

        for (n = t.length - 1; n >= 0; n--) {
          if (t[n].element === e) return n;
        }

        return -1;
      }

      function o(e, n) {
        return t.requestAnimationFrame(function () {
          n(e);
        });
      }

      function a(e) {
        t.requestAnimationFrame(function () {
          u(e);
        });
      }

      function s(e) {
        e.autoHideControls && (e.controlsShouldFade = !0, e.controlsFadeBeginTime = t.now() + e.controlsFadeDelay, window.setTimeout(function () {
          a(e);
        }, e.controlsFadeDelay));
      }

      function u(e) {
        var n, r, i, o;

        if (e.controlsShouldFade) {
          for (n = t.now(), r = n - e.controlsFadeBeginTime, i = 1 - r / e.controlsFadeLength, i = Math.min(1, i), i = Math.max(0, i), o = e.controls.length - 1; o >= 0; o--) {
            e.controls[o].autoFade && e.controls[o].setOpacity(i);
          }

          i > 0 && a(e);
        }
      }

      function c(t) {
        var e;

        for (t.controlsShouldFade = !1, e = t.controls.length - 1; e >= 0; e--) {
          t.controls[e].setOpacity(1);
        }
      }

      function l() {
        c(this);
      }

      function h() {
        s(this);
      }

      function f(e) {
        if (e.preventDefaultAction || e.ctrl || e.alt || e.meta) return !0;

        switch (e.keyCode) {
          case 38:
            return e.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(0, -40))), this.viewport.applyConstraints(), !1;

          case 40:
            return e.shift ? this.viewport.zoomBy(.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(0, 40))), this.viewport.applyConstraints(), !1;

          case 37:
            return this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(-40, 0))), this.viewport.applyConstraints(), !1;

          case 39:
            return this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(40, 0))), this.viewport.applyConstraints(), !1;

          default:
            return !0;
        }
      }

      function p(e) {
        if (e.preventDefaultAction || e.ctrl || e.alt || e.meta) return !0;

        switch (e.keyCode) {
          case 43:
          case 61:
            return this.viewport.zoomBy(1.1), this.viewport.applyConstraints(), !1;

          case 45:
            return this.viewport.zoomBy(.9), this.viewport.applyConstraints(), !1;

          case 48:
            return this.viewport.goHome(), this.viewport.applyConstraints(), !1;

          case 119:
          case 87:
            return e.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(0, -40))), this.viewport.applyConstraints(), !1;

          case 115:
          case 83:
            return e.shift ? this.viewport.zoomBy(.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(0, 40))), this.viewport.applyConstraints(), !1;

          case 97:
            return this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(-40, 0))), this.viewport.applyConstraints(), !1;

          case 100:
            return this.viewport.panBy(this.viewport.deltaPointsFromPixels(new t.Point(40, 0))), this.viewport.applyConstraints(), !1;

          default:
            return !0;
        }
      }

      function m(t) {
        var e,
            n = document.activeElement == this.canvas;
        n || this.canvas.focus(), !t.preventDefaultAction && this.viewport && t.quick && (e = this.gestureSettingsByDeviceType(t.pointerType), e.clickToZoom && (this.viewport.zoomBy(t.shift ? 1 / this.zoomPerClick : this.zoomPerClick, this.viewport.pointFromPixel(t.position, !0)), this.viewport.applyConstraints())), this.raiseEvent("canvas-click", {
          tracker: t.eventSource,
          position: t.position,
          quick: t.quick,
          shift: t.shift,
          originalEvent: t.originalEvent
        });
      }

      function d(t) {
        var e;
        !t.preventDefaultAction && this.viewport && (e = this.gestureSettingsByDeviceType(t.pointerType), e.dblClickToZoom && (this.viewport.zoomBy(t.shift ? 1 / this.zoomPerClick : this.zoomPerClick, this.viewport.pointFromPixel(t.position, !0)), this.viewport.applyConstraints())), this.raiseEvent("canvas-double-click", {
          tracker: t.eventSource,
          position: t.position,
          shift: t.shift,
          originalEvent: t.originalEvent
        });
      }

      function g(t) {
        var e;
        !t.preventDefaultAction && this.viewport && (e = this.gestureSettingsByDeviceType(t.pointerType), this.panHorizontal || (t.delta.x = 0), this.panVertical || (t.delta.y = 0), this.viewport.panBy(this.viewport.deltaPointsFromPixels(t.delta.negate()), e.flickEnabled), this.constrainDuringPan && this.viewport.applyConstraints()), this.raiseEvent("canvas-drag", {
          tracker: t.eventSource,
          position: t.position,
          delta: t.delta,
          speed: t.speed,
          direction: t.direction,
          shift: t.shift,
          originalEvent: t.originalEvent
        });
      }

      function v(e) {
        if (!e.preventDefaultAction && this.viewport) {
          var n = this.gestureSettingsByDeviceType(e.pointerType);

          if (n.flickEnabled && e.speed >= n.flickMinSpeed) {
            var r = 0;
            this.panHorizontal && (r = n.flickMomentum * e.speed * Math.cos(e.direction));
            var i = 0;
            this.panVertical && (i = n.flickMomentum * e.speed * Math.sin(e.direction));
            var o = this.viewport.pixelFromPoint(this.viewport.getCenter(!0)),
                a = this.viewport.pointFromPixel(new t.Point(o.x - r, o.y - i));
            this.viewport.panTo(a, !1);
          }

          this.viewport.applyConstraints();
        }

        this.raiseEvent("canvas-drag-end", {
          tracker: e.eventSource,
          position: e.position,
          speed: e.speed,
          direction: e.direction,
          shift: e.shift,
          originalEvent: e.originalEvent
        });
      }

      function y(t) {
        this.raiseEvent("canvas-enter", {
          tracker: t.eventSource,
          pointerType: t.pointerType,
          position: t.position,
          buttons: t.buttons,
          pointers: t.pointers,
          insideElementPressed: t.insideElementPressed,
          buttonDownAny: t.buttonDownAny,
          originalEvent: t.originalEvent
        });
      }

      function x(t) {
        this.raiseEvent("canvas-exit", {
          tracker: t.eventSource,
          pointerType: t.pointerType,
          position: t.position,
          buttons: t.buttons,
          pointers: t.pointers,
          insideElementPressed: t.insideElementPressed,
          buttonDownAny: t.buttonDownAny,
          originalEvent: t.originalEvent
        });
      }

      function w(t) {
        this.raiseEvent("canvas-press", {
          tracker: t.eventSource,
          pointerType: t.pointerType,
          position: t.position,
          insideElementPressed: t.insideElementPressed,
          insideElementReleased: t.insideElementReleased,
          originalEvent: t.originalEvent
        });
      }

      function b(t) {
        this.raiseEvent("canvas-release", {
          tracker: t.eventSource,
          pointerType: t.pointerType,
          position: t.position,
          insideElementPressed: t.insideElementPressed,
          insideElementReleased: t.insideElementReleased,
          originalEvent: t.originalEvent
        });
      }

      function _(t) {
        this.raiseEvent("canvas-nonprimary-press", {
          tracker: t.eventSource,
          position: t.position,
          pointerType: t.pointerType,
          button: t.button,
          buttons: t.buttons,
          originalEvent: t.originalEvent
        });
      }

      function E(t) {
        this.raiseEvent("canvas-nonprimary-release", {
          tracker: t.eventSource,
          position: t.position,
          pointerType: t.pointerType,
          button: t.button,
          buttons: t.buttons,
          originalEvent: t.originalEvent
        });
      }

      function M(t) {
        var e, n, r, i;

        if (!t.preventDefaultAction && this.viewport && (e = this.gestureSettingsByDeviceType(t.pointerType), e.pinchToZoom && (n = this.viewport.pointFromPixel(t.center, !0), r = this.viewport.pointFromPixel(t.lastCenter, !0), i = r.minus(n), this.panHorizontal || (i.x = 0), this.panVertical || (i.y = 0), this.viewport.zoomBy(t.distance / t.lastDistance, n, !0), this.viewport.panBy(i, !0), this.viewport.applyConstraints()), e.pinchRotate)) {
          var o = Math.atan2(t.gesturePoints[0].currentPos.y - t.gesturePoints[1].currentPos.y, t.gesturePoints[0].currentPos.x - t.gesturePoints[1].currentPos.x),
              a = Math.atan2(t.gesturePoints[0].lastPos.y - t.gesturePoints[1].lastPos.y, t.gesturePoints[0].lastPos.x - t.gesturePoints[1].lastPos.x);
          this.viewport.setRotation(this.viewport.getRotation() + (o - a) * (180 / Math.PI));
        }

        return this.raiseEvent("canvas-pinch", {
          tracker: t.eventSource,
          gesturePoints: t.gesturePoints,
          lastCenter: t.lastCenter,
          center: t.center,
          lastDistance: t.lastDistance,
          distance: t.distance,
          shift: t.shift,
          originalEvent: t.originalEvent
        }), !1;
      }

      function T(e) {
        var n, r, i, o;

        if (i = t.now(), o = i - this._lastScrollTime, o > this.minScrollDeltaTime) {
          if (this._lastScrollTime = i, !e.preventDefaultAction && this.viewport && (n = this.gestureSettingsByDeviceType(e.pointerType), n.scrollToZoom && (r = Math.pow(this.zoomPerScroll, e.scroll), this.viewport.zoomBy(r, this.viewport.pointFromPixel(e.position, !0)), this.viewport.applyConstraints())), this.raiseEvent("canvas-scroll", {
            tracker: e.eventSource,
            position: e.position,
            scroll: e.scroll,
            shift: e.shift,
            originalEvent: e.originalEvent
          }), n && n.scrollToZoom) return !1;
        } else if (n = this.gestureSettingsByDeviceType(e.pointerType), n && n.scrollToZoom) return !1;
      }

      function N(t) {
        $[this.hash].mouseInside = !0, c(this), this.raiseEvent("container-enter", {
          tracker: t.eventSource,
          position: t.position,
          buttons: t.buttons,
          pointers: t.pointers,
          insideElementPressed: t.insideElementPressed,
          buttonDownAny: t.buttonDownAny,
          originalEvent: t.originalEvent
        });
      }

      function S(t) {
        t.pointers < 1 && ($[this.hash].mouseInside = !1, $[this.hash].animating || s(this)), this.raiseEvent("container-exit", {
          tracker: t.eventSource,
          position: t.position,
          buttons: t.buttons,
          pointers: t.pointers,
          insideElementPressed: t.insideElementPressed,
          buttonDownAny: t.buttonDownAny,
          originalEvent: t.originalEvent
        });
      }

      function A(t) {
        O(t), t.isOpen() ? t._updateRequestId = o(t, A) : t._updateRequestId = !1;
      }

      function O(t) {
        if (!t._opening) {
          if (t.autoResize) {
            var n = e(t.container),
                r = $[t.hash].prevContainerSize;

            if (!n.equals(r)) {
              var i = t.viewport;

              if (t.preserveImageSizeOnResize) {
                var o = r.x / n.x,
                    a = i.getZoom() * o,
                    u = i.getCenter();
                i.resize(n, !1), i.zoomTo(a, null, !0), i.panTo(u, !0);
              } else {
                var l = i.getBounds();
                i.resize(n, !0), i.fitBoundsWithConstraints(l, !0);
              }

              $[t.hash].prevContainerSize = n, $[t.hash].forceRedraw = !0;
            }
          }

          var h = t.viewport.update(),
              f = t.world.update() || h;
          h && t.raiseEvent("viewport-change"), t.referenceStrip && (f = t.referenceStrip.update(t.viewport) || f), !$[t.hash].animating && f && (t.raiseEvent("animation-start"), c(t)), (f || $[t.hash].forceRedraw || t.world.needsDraw()) && (C(t), t._drawOverlays(), t.navigator && t.navigator.update(t.viewport), $[t.hash].forceRedraw = !1, f && t.raiseEvent("animation")), $[t.hash].animating && !f && (t.raiseEvent("animation-finish"), $[t.hash].mouseInside || s(t)), $[t.hash].animating = f;
        }
      }

      function C(t) {
        t.imageLoader.clear(), t.drawer.clear(), t.world.draw(), t.raiseEvent("update-viewport", {});
      }

      function P(t, e) {
        return t ? t + e : e;
      }

      function R() {
        $[this.hash].lastZoomTime = t.now(), $[this.hash].zoomFactor = this.zoomPerSecond, $[this.hash].zooming = !0, z(this);
      }

      function I() {
        $[this.hash].lastZoomTime = t.now(), $[this.hash].zoomFactor = 1 / this.zoomPerSecond, $[this.hash].zooming = !0, z(this);
      }

      function k() {
        $[this.hash].zooming = !1;
      }

      function z(e) {
        t.requestAnimationFrame(t.delegate(e, B));
      }

      function B() {
        var e, n, r;
        $[this.hash].zooming && this.viewport && (e = t.now(), n = e - $[this.hash].lastZoomTime, r = Math.pow($[this.hash].zoomFactor, n / 1e3), this.viewport.zoomBy(r), this.viewport.applyConstraints(), $[this.hash].lastZoomTime = e, z(this));
      }

      function L() {
        this.viewport && ($[this.hash].zooming = !1, this.viewport.zoomBy(this.zoomPerClick / 1), this.viewport.applyConstraints());
      }

      function D() {
        this.viewport && ($[this.hash].zooming = !1, this.viewport.zoomBy(1 / this.zoomPerClick), this.viewport.applyConstraints());
      }

      function j() {
        this.buttons.emulateEnter(), this.buttons.emulateExit();
      }

      function F() {
        this.viewport && this.viewport.goHome();
      }

      function U() {
        this.isFullPage() && !t.isFullScreen() ? this.setFullPage(!1) : this.setFullScreen(!this.isFullPage()), this.buttons && this.buttons.emulateExit(), this.fullPageButton.element.focus(), this.viewport && this.viewport.applyConstraints();
      }

      function q() {
        if (this.viewport) {
          var t = this.viewport.getRotation();
          0 === t ? t = 270 : t -= 90, this.viewport.setRotation(t);
        }
      }

      function H() {
        if (this.viewport) {
          var t = this.viewport.getRotation();
          270 === t ? t = 0 : t += 90, this.viewport.setRotation(t);
        }
      }

      function W() {
        var t = this._sequenceIndex - 1;
        this.navPrevNextWrap && t < 0 && (t += this.tileSources.length), this.goToPage(t);
      }

      function G() {
        var t = this._sequenceIndex + 1;
        this.navPrevNextWrap && t >= this.tileSources.length && (t = 0), this.goToPage(t);
      }

      var $ = {},
          V = 1;
      t.Viewer = function (n) {
        var r,
            i = arguments,
            a = this;
        if (t.isPlainObject(n) || (n = {
          id: i[0],
          xmlPath: i.length > 1 ? i[1] : void 0,
          prefixUrl: i.length > 2 ? i[2] : void 0,
          controls: i.length > 3 ? i[3] : void 0,
          overlays: i.length > 4 ? i[4] : void 0
        }), n.config && (t.extend(!0, n, n.config), delete n.config), t.extend(!0, this, {
          id: n.id,
          hash: n.hash || V++,
          element: null,
          container: null,
          canvas: null,
          overlays: [],
          overlaysContainer: null,
          previousBody: [],
          customControls: [],
          source: null,
          drawer: null,
          world: null,
          viewport: null,
          navigator: null,
          collectionViewport: null,
          collectionDrawer: null,
          navImages: null,
          buttons: null,
          profiler: null
        }, t.DEFAULT_SETTINGS, n), "undefined" == typeof this.hash) throw new Error("A hash must be defined, either by specifying options.id or options.hash.");

        for ("undefined" != typeof $[this.hash] && t.console.warn("Hash " + this.hash + " has already been used."), $[this.hash] = {
          fsBoundsDelta: new t.Point(1, 1),
          prevContainerSize: null,
          animating: !1,
          forceRedraw: !1,
          mouseInside: !1,
          group: null,
          zooming: !1,
          zoomFactor: null,
          lastZoomTime: null,
          fullPage: !1,
          onfullscreenchange: null
        }, this._sequenceIndex = 0, this._firstOpen = !0, this._updateRequestId = null, this._loadQueue = [], this.currentOverlays = [], this._lastScrollTime = t.now(), t.EventSource.call(this), this.addHandler("open-failed", function (e) {
          var n = t.getString("Errors.OpenFailed", e.eventSource, e.message);

          a._showMessage(n);
        }), t.ControlDock.call(this, n), this.xmlPath && (this.tileSources = [this.xmlPath]), this.element = this.element || document.getElementById(this.id), this.canvas = t.makeNeutralElement("div"), this.canvas.className = "openseadragon-canvas", function (t) {
          t.width = "100%", t.height = "100%", t.overflow = "hidden", t.position = "absolute", t.top = "0px", t.left = "0px";
        }(this.canvas.style), t.setElementTouchActionNone(this.canvas), "" !== n.tabIndex && (this.canvas.tabIndex = void 0 === n.tabIndex ? 0 : n.tabIndex), this.container.className = "openseadragon-container", function (t) {
          t.width = "100%", t.height = "100%", t.position = "relative", t.overflow = "hidden", t.left = "0px", t.top = "0px", t.textAlign = "left";
        }(this.container.style), this.container.insertBefore(this.canvas, this.container.firstChild), this.element.appendChild(this.container), this.bodyWidth = document.body.style.width, this.bodyHeight = document.body.style.height, this.bodyOverflow = document.body.style.overflow, this.docOverflow = document.documentElement.style.overflow, this.innerTracker = new t.MouseTracker({
          element: this.canvas,
          startDisabled: !this.mouseNavEnabled,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          dblClickTimeThreshold: this.dblClickTimeThreshold,
          dblClickDistThreshold: this.dblClickDistThreshold,
          keyDownHandler: t.delegate(this, f),
          keyHandler: t.delegate(this, p),
          clickHandler: t.delegate(this, m),
          dblClickHandler: t.delegate(this, d),
          dragHandler: t.delegate(this, g),
          dragEndHandler: t.delegate(this, v),
          enterHandler: t.delegate(this, y),
          exitHandler: t.delegate(this, x),
          pressHandler: t.delegate(this, w),
          releaseHandler: t.delegate(this, b),
          nonPrimaryPressHandler: t.delegate(this, _),
          nonPrimaryReleaseHandler: t.delegate(this, E),
          scrollHandler: t.delegate(this, T),
          pinchHandler: t.delegate(this, M)
        }), this.outerTracker = new t.MouseTracker({
          element: this.container,
          startDisabled: !this.mouseNavEnabled,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          dblClickTimeThreshold: this.dblClickTimeThreshold,
          dblClickDistThreshold: this.dblClickDistThreshold,
          enterHandler: t.delegate(this, N),
          exitHandler: t.delegate(this, S)
        }), this.toolbar && (this.toolbar = new t.ControlDock({
          element: this.toolbar
        })), this.bindStandardControls(), $[this.hash].prevContainerSize = e(this.container), this.world = new t.World({
          viewer: this
        }), this.world.addHandler("add-item", function (t) {
          a.source = a.world.getItemAt(0).source, $[a.hash].forceRedraw = !0, a._updateRequestId || (a._updateRequestId = o(a, A));
        }), this.world.addHandler("remove-item", function (t) {
          a.world.getItemCount() ? a.source = a.world.getItemAt(0).source : a.source = null, $[a.hash].forceRedraw = !0;
        }), this.world.addHandler("metrics-change", function (t) {
          a.viewport && a.viewport._setContentBounds(a.world.getHomeBounds(), a.world.getContentFactor());
        }), this.world.addHandler("item-index-change", function (t) {
          a.source = a.world.getItemAt(0).source;
        }), this.viewport = new t.Viewport({
          containerSize: $[this.hash].prevContainerSize,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime,
          minZoomImageRatio: this.minZoomImageRatio,
          maxZoomPixelRatio: this.maxZoomPixelRatio,
          visibilityRatio: this.visibilityRatio,
          wrapHorizontal: this.wrapHorizontal,
          wrapVertical: this.wrapVertical,
          defaultZoomLevel: this.defaultZoomLevel,
          minZoomLevel: this.minZoomLevel,
          maxZoomLevel: this.maxZoomLevel,
          viewer: this,
          degrees: this.degrees,
          navigatorRotate: this.navigatorRotate,
          homeFillsViewer: this.homeFillsViewer,
          margins: this.viewportMargins
        }), this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor()), this.imageLoader = new t.ImageLoader({
          jobLimit: this.imageLoaderLimit
        }), this.tileCache = new t.TileCache({
          maxImageCacheCount: this.maxImageCacheCount
        }), this.drawer = new t.Drawer({
          viewer: this,
          viewport: this.viewport,
          element: this.canvas,
          debugGridColor: this.debugGridColor
        }), this.overlaysContainer = t.makeNeutralElement("div"), this.canvas.appendChild(this.overlaysContainer), this.drawer.canRotate() || (this.rotateLeft && (r = this.buttons.buttons.indexOf(this.rotateLeft), this.buttons.buttons.splice(r, 1), this.buttons.element.removeChild(this.rotateLeft.element)), this.rotateRight && (r = this.buttons.buttons.indexOf(this.rotateRight), this.buttons.buttons.splice(r, 1), this.buttons.element.removeChild(this.rotateRight.element))), this.showNavigator && (this.navigator = new t.Navigator({
          id: this.navigatorId,
          position: this.navigatorPosition,
          sizeRatio: this.navigatorSizeRatio,
          maintainSizeRatio: this.navigatorMaintainSizeRatio,
          top: this.navigatorTop,
          left: this.navigatorLeft,
          width: this.navigatorWidth,
          height: this.navigatorHeight,
          autoResize: this.navigatorAutoResize,
          autoFade: this.navigatorAutoFade,
          prefixUrl: this.prefixUrl,
          viewer: this,
          navigatorRotate: this.navigatorRotate,
          crossOriginPolicy: this.crossOriginPolicy
        })), this.sequenceMode && this.bindSequenceControls(), this.tileSources && this.open(this.tileSources), r = 0; r < this.customControls.length; r++) {
          this.addControl(this.customControls[r].id, {
            anchor: this.customControls[r].anchor
          });
        }

        t.requestAnimationFrame(function () {
          s(a);
        });
      }, t.extend(t.Viewer.prototype, t.EventSource.prototype, t.ControlDock.prototype, {
        isOpen: function isOpen() {
          return !!this.world.getItemCount();
        },
        openDzi: function openDzi(e) {
          return t.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead."), this.open(e);
        },
        openTileSource: function openTileSource(e) {
          return t.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead."), this.open(e);
        },
        open: function open(e) {
          var n = this;

          if (this.close(), e) {
            if (this.sequenceMode && t.isArray(e)) return this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), this.tileSources = e, this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage)), this.tileSources.length && (this.open(this.tileSources[this._sequenceIndex]), this.showReferenceStrip && (this.referenceStrip = new t.ReferenceStrip({
              id: this.referenceStripElement,
              position: this.referenceStripPosition,
              sizeRatio: this.referenceStripSizeRatio,
              scroll: this.referenceStripScroll,
              height: this.referenceStripHeight,
              width: this.referenceStripWidth,
              tileSources: this.tileSources,
              prefixUrl: this.prefixUrl,
              viewer: this
            }))), void this._updateSequenceButtons(this._sequenceIndex);

            if (t.isArray(e) || (e = [e]), e.length) {
              this._opening = !0;

              for (var i, o = e.length, a = 0, s = 0, u = function u() {
                if (a + s === o) if (a) {
                  !n._firstOpen && n.preserveViewport || (n.viewport.goHome(!0), n.viewport.update()), n._firstOpen = !1;
                  var t = e[0];
                  if (t.tileSource && (t = t.tileSource), n.overlays && !n.preserveOverlays) for (var u = 0; u < n.overlays.length; u++) {
                    n.currentOverlays[u] = r(n, n.overlays[u]);
                  }
                  n._drawOverlays(), n._opening = !1, n.raiseEvent("open", {
                    source: t
                  });
                } else n._opening = !1, n.raiseEvent("open-failed", i);
              }, c = function c(e) {
                t.isPlainObject(e) && e.tileSource || (e = {
                  tileSource: e
                }), void 0 !== e.index && (t.console.error("[Viewer.open] setting indexes here is not supported; use addTiledImage instead"), delete e.index), void 0 === e.collectionImmediately && (e.collectionImmediately = !0);
                var r = e.success;

                e.success = function (t) {
                  if (a++, e.tileSource.overlays) for (var i = 0; i < e.tileSource.overlays.length; i++) {
                    n.addOverlay(e.tileSource.overlays[i]);
                  }
                  r && r(t), u();
                };

                var o = e.error;
                e.error = function (t) {
                  s++, i || (i = t), o && o(t), u();
                }, n.addTiledImage(e);
              }, l = 0; l < e.length; l++) {
                c(e[l]);
              }

              return this;
            }
          }
        },
        close: function close() {
          return $[this.hash] ? (this._opening = !1, this.navigator && this.navigator.close(), this.preserveOverlays || (this.clearOverlays(), this.overlaysContainer.innerHTML = ""), $[this.hash].animating = !1, this.world.removeAll(), this.imageLoader.clear(), this.raiseEvent("close"), this) : this;
        },
        destroy: function destroy() {
          if ($[this.hash]) {
            if (this.close(), this.clearOverlays(), this.overlaysContainer.innerHTML = "", this.referenceStrip && (this.referenceStrip.destroy(), this.referenceStrip = null), null !== this._updateRequestId && (t.cancelAnimationFrame(this._updateRequestId), this._updateRequestId = null), this.drawer && this.drawer.destroy(), this.removeAllHandlers(), this.element) for (; this.element.firstChild;) {
              this.element.removeChild(this.element.firstChild);
            }
            this.innerTracker && this.innerTracker.destroy(), this.outerTracker && this.outerTracker.destroy(), $[this.hash] = null, delete $[this.hash], this.canvas = null, this.container = null, this.element = null;
          }
        },
        isMouseNavEnabled: function isMouseNavEnabled() {
          return this.innerTracker.isTracking();
        },
        setMouseNavEnabled: function setMouseNavEnabled(t) {
          return this.innerTracker.setTracking(t), this.outerTracker.setTracking(t), this.raiseEvent("mouse-enabled", {
            enabled: t
          }), this;
        },
        areControlsEnabled: function areControlsEnabled() {
          var t,
              e = this.controls.length;

          for (t = 0; t < this.controls.length; t++) {
            e = e && this.controls[t].isVisibile();
          }

          return e;
        },
        setControlsEnabled: function setControlsEnabled(t) {
          return t ? c(this) : s(this), this.raiseEvent("controls-enabled", {
            enabled: t
          }), this;
        },
        isFullPage: function isFullPage() {
          return $[this.hash].fullPage;
        },
        setFullPage: function setFullPage(e) {
          var n,
              r,
              i = document.body,
              o = i.style,
              a = document.documentElement.style,
              s = this;
          if (e == this.isFullPage()) return this;
          var u = {
            fullPage: e,
            preventDefaultAction: !1
          };
          if (this.raiseEvent("pre-full-page", u), u.preventDefaultAction) return this;

          if (e) {
            for (this.elementSize = t.getElementSize(this.element), this.pageScroll = t.getPageScroll(), this.elementMargin = this.element.style.margin, this.element.style.margin = "0", this.elementPadding = this.element.style.padding, this.element.style.padding = "0", this.bodyMargin = o.margin, this.docMargin = a.margin, o.margin = "0", a.margin = "0", this.bodyPadding = o.padding, this.docPadding = a.padding, o.padding = "0", a.padding = "0", this.bodyWidth = o.width, this.docWidth = a.width, o.width = "100%", a.width = "100%", this.bodyHeight = o.height, this.docHeight = a.height, o.height = "100%", a.height = "100%", this.previousBody = [], $[this.hash].prevElementParent = this.element.parentNode, $[this.hash].prevNextSibling = this.element.nextSibling, $[this.hash].prevElementWidth = this.element.style.width, $[this.hash].prevElementHeight = this.element.style.height, n = i.childNodes.length, r = 0; r < n; r++) {
              this.previousBody.push(i.childNodes[0]), i.removeChild(i.childNodes[0]);
            }

            this.toolbar && this.toolbar.element && (this.toolbar.parentNode = this.toolbar.element.parentNode, this.toolbar.nextSibling = this.toolbar.element.nextSibling, i.appendChild(this.toolbar.element), t.addClass(this.toolbar.element, "fullpage")), t.addClass(this.element, "fullpage"), i.appendChild(this.element), this.element.style.height = t.getWindowSize().y + "px", this.element.style.width = t.getWindowSize().x + "px", this.toolbar && this.toolbar.element && (this.element.style.height = t.getElementSize(this.element).y - t.getElementSize(this.toolbar.element).y + "px"), $[this.hash].fullPage = !0, t.delegate(this, N)({});
          } else {
            for (this.element.style.margin = this.elementMargin, this.element.style.padding = this.elementPadding, o.margin = this.bodyMargin, a.margin = this.docMargin, o.padding = this.bodyPadding, a.padding = this.docPadding, o.width = this.bodyWidth, a.width = this.docWidth, o.height = this.bodyHeight, a.height = this.docHeight, i.removeChild(this.element), n = this.previousBody.length, r = 0; r < n; r++) {
              i.appendChild(this.previousBody.shift());
            }

            t.removeClass(this.element, "fullpage"), $[this.hash].prevElementParent.insertBefore(this.element, $[this.hash].prevNextSibling), this.toolbar && this.toolbar.element && (i.removeChild(this.toolbar.element), t.removeClass(this.toolbar.element, "fullpage"), this.toolbar.parentNode.insertBefore(this.toolbar.element, this.toolbar.nextSibling), delete this.toolbar.parentNode, delete this.toolbar.nextSibling), this.element.style.width = $[this.hash].prevElementWidth, this.element.style.height = $[this.hash].prevElementHeight;

            var c = 0,
                l = function l() {
              t.setPageScroll(s.pageScroll);
              var e = t.getPageScroll();
              c++, (c < 10 && e.x !== s.pageScroll.x || e.y !== s.pageScroll.y) && t.requestAnimationFrame(l);
            };

            t.requestAnimationFrame(l), $[this.hash].fullPage = !1, t.delegate(this, S)({});
          }

          return this.navigator && this.viewport && this.navigator.update(this.viewport), this.raiseEvent("full-page", {
            fullPage: e
          }), this;
        },
        setFullScreen: function setFullScreen(e) {
          var n = this;
          if (!t.supportsFullScreen) return this.setFullPage(e);
          if (t.isFullScreen() === e) return this;
          var r = {
            fullScreen: e,
            preventDefaultAction: !1
          };
          if (this.raiseEvent("pre-full-screen", r), r.preventDefaultAction) return this;

          if (e) {
            if (this.setFullPage(!0), !this.isFullPage()) return this;
            this.fullPageStyleWidth = this.element.style.width, this.fullPageStyleHeight = this.element.style.height, this.element.style.width = "100%", this.element.style.height = "100%";

            var i = function i() {
              var e = t.isFullScreen();
              e || (t.removeEvent(document, t.fullScreenEventName, i), t.removeEvent(document, t.fullScreenErrorEventName, i), n.setFullPage(!1), n.isFullPage() && (n.element.style.width = n.fullPageStyleWidth, n.element.style.height = n.fullPageStyleHeight)), n.navigator && n.viewport && n.navigator.update(n.viewport), n.raiseEvent("full-screen", {
                fullScreen: e
              });
            };

            t.addEvent(document, t.fullScreenEventName, i), t.addEvent(document, t.fullScreenErrorEventName, i), t.requestFullScreen(document.body);
          } else t.exitFullScreen();

          return this;
        },
        isVisible: function isVisible() {
          return "hidden" != this.container.style.visibility;
        },
        setVisible: function setVisible(t) {
          return this.container.style.visibility = t ? "" : "hidden", this.raiseEvent("visible", {
            visible: t
          }), this;
        },
        addTiledImage: function addTiledImage(e) {
          function r(t) {
            for (var n = 0; n < o._loadQueue.length; n++) {
              if (o._loadQueue[n] === a) {
                o._loadQueue.splice(n, 1);

                break;
              }
            }

            0 === o._loadQueue.length && i(a), o.raiseEvent("add-item-failed", t), e.error && e.error(t);
          }

          function i(t) {
            o.collectionMode && (o.world.arrange({
              immediately: t.options.collectionImmediately,
              rows: o.collectionRows,
              columns: o.collectionColumns,
              layout: o.collectionLayout,
              tileSize: o.collectionTileSize,
              tileMargin: o.collectionTileMargin
            }), o.world.setAutoRefigureSizes(!0));
          }

          t.console.assert(e, "[Viewer.addTiledImage] options is required"), t.console.assert(e.tileSource, "[Viewer.addTiledImage] options.tileSource is required"), t.console.assert(!e.replace || e.index > -1 && e.index < this.world.getItemCount(), "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");
          var o = this;
          e.replace && (e.replaceItem = o.world.getItemAt(e.index)), this._hideMessage(), void 0 === e.placeholderFillStyle && (e.placeholderFillStyle = this.placeholderFillStyle), void 0 === e.opacity && (e.opacity = this.opacity), void 0 === e.compositeOperation && (e.compositeOperation = this.compositeOperation);
          var a = {
            options: e
          };
          return t.isArray(e.tileSource) ? void setTimeout(function () {
            r({
              message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",
              source: e.tileSource,
              options: e
            });
          }) : (this._loadQueue.push(a), void n(this, e.tileSource, function (e) {
            a.tileSource = e;

            for (var n, r, s; o._loadQueue.length && (n = o._loadQueue[0], n.tileSource);) {
              if (o._loadQueue.splice(0, 1), n.options.replace) {
                var u = o.world.getIndexOfItem(n.options.replaceItem);
                u != -1 && (n.options.index = u), o.world.removeItem(n.options.replaceItem);
              }

              r = new t.TiledImage({
                viewer: o,
                source: n.tileSource,
                viewport: o.viewport,
                drawer: o.drawer,
                tileCache: o.tileCache,
                imageLoader: o.imageLoader,
                x: n.options.x,
                y: n.options.y,
                width: n.options.width,
                height: n.options.height,
                fitBounds: n.options.fitBounds,
                fitBoundsPlacement: n.options.fitBoundsPlacement,
                clip: n.options.clip,
                placeholderFillStyle: n.options.placeholderFillStyle,
                opacity: n.options.opacity,
                compositeOperation: n.options.compositeOperation,
                springStiffness: o.springStiffness,
                animationTime: o.animationTime,
                minZoomImageRatio: o.minZoomImageRatio,
                wrapHorizontal: o.wrapHorizontal,
                wrapVertical: o.wrapVertical,
                immediateRender: o.immediateRender,
                blendTime: o.blendTime,
                alwaysBlend: o.alwaysBlend,
                minPixelRatio: o.minPixelRatio,
                smoothTileEdgesMinZoom: o.smoothTileEdgesMinZoom,
                iOSDevice: o.iOSDevice,
                crossOriginPolicy: o.crossOriginPolicy,
                debugMode: o.debugMode
              }), o.collectionMode && o.world.setAutoRefigureSizes(!1), o.world.addItem(r, {
                index: n.options.index
              }), 0 === o._loadQueue.length && i(n), 1 !== o.world.getItemCount() || o.preserveViewport || o.viewport.goHome(!0), o.navigator && (s = t.extend({}, n.options, {
                replace: !1,
                originalTiledImage: r,
                tileSource: n.tileSource
              }), o.navigator.addTiledImage(s)), n.options.success && n.options.success({
                item: r
              });
            }
          }, function (t) {
            t.options = e, r(t);
          }));
        },
        addSimpleImage: function addSimpleImage(e) {
          t.console.assert(e, "[Viewer.addSimpleImage] options is required"), t.console.assert(e.url, "[Viewer.addSimpleImage] options.url is required");
          var n = t.extend({}, e, {
            tileSource: {
              type: "image",
              url: e.url
            }
          });
          delete n.url, this.addTiledImage(n);
        },
        addLayer: function addLayer(e) {
          var n = this;
          t.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");
          var r = t.extend({}, e, {
            success: function success(t) {
              n.raiseEvent("add-layer", {
                options: e,
                drawer: t.item
              });
            },
            error: function error(t) {
              n.raiseEvent("add-layer-failed", t);
            }
          });
          return this.addTiledImage(r), this;
        },
        getLayerAtLevel: function getLayerAtLevel(e) {
          return t.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead."), this.world.getItemAt(e);
        },
        getLevelOfLayer: function getLevelOfLayer(e) {
          return t.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead."), this.world.getIndexOfItem(e);
        },
        getLayersCount: function getLayersCount() {
          return t.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead."), this.world.getItemCount();
        },
        setLayerLevel: function setLayerLevel(e, n) {
          return t.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead."), this.world.setItemIndex(e, n);
        },
        removeLayer: function removeLayer(e) {
          return t.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead."), this.world.removeItem(e);
        },
        forceRedraw: function forceRedraw() {
          return $[this.hash].forceRedraw = !0, this;
        },
        bindSequenceControls: function bindSequenceControls() {
          var e = t.delegate(this, l),
              n = t.delegate(this, h),
              r = t.delegate(this, G),
              i = t.delegate(this, W),
              o = this.navImages,
              a = !0;
          return this.showSequenceControl && ((this.previousButton || this.nextButton) && (a = !1), this.previousButton = new t.Button({
            element: this.previousButton ? t.getElement(this.previousButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.PreviousPage"),
            srcRest: P(this.prefixUrl, o.previous.REST),
            srcGroup: P(this.prefixUrl, o.previous.GROUP),
            srcHover: P(this.prefixUrl, o.previous.HOVER),
            srcDown: P(this.prefixUrl, o.previous.DOWN),
            onRelease: i,
            onFocus: e,
            onBlur: n
          }), this.nextButton = new t.Button({
            element: this.nextButton ? t.getElement(this.nextButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.NextPage"),
            srcRest: P(this.prefixUrl, o.next.REST),
            srcGroup: P(this.prefixUrl, o.next.GROUP),
            srcHover: P(this.prefixUrl, o.next.HOVER),
            srcDown: P(this.prefixUrl, o.next.DOWN),
            onRelease: r,
            onFocus: e,
            onBlur: n
          }), this.navPrevNextWrap || this.previousButton.disable(), this.tileSources && this.tileSources.length || this.nextButton.disable(), a && (this.paging = new t.ButtonGroup({
            buttons: [this.previousButton, this.nextButton],
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold
          }), this.pagingControl = this.paging.element, this.toolbar ? this.toolbar.addControl(this.pagingControl, {
            anchor: t.ControlAnchor.BOTTOM_RIGHT
          }) : this.addControl(this.pagingControl, {
            anchor: this.sequenceControlAnchor || t.ControlAnchor.TOP_LEFT
          }))), this;
        },
        bindStandardControls: function bindStandardControls() {
          var e = t.delegate(this, R),
              n = t.delegate(this, k),
              r = t.delegate(this, L),
              i = t.delegate(this, I),
              o = t.delegate(this, D),
              a = t.delegate(this, F),
              s = t.delegate(this, U),
              u = t.delegate(this, q),
              c = t.delegate(this, H),
              f = t.delegate(this, l),
              p = t.delegate(this, h),
              m = this.navImages,
              d = [],
              g = !0;
          return this.showNavigationControl && ((this.zoomInButton || this.zoomOutButton || this.homeButton || this.fullPageButton || this.rotateLeftButton || this.rotateRightButton) && (g = !1), this.showZoomControl && (d.push(this.zoomInButton = new t.Button({
            element: this.zoomInButton ? t.getElement(this.zoomInButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.ZoomIn"),
            srcRest: P(this.prefixUrl, m.zoomIn.REST),
            srcGroup: P(this.prefixUrl, m.zoomIn.GROUP),
            srcHover: P(this.prefixUrl, m.zoomIn.HOVER),
            srcDown: P(this.prefixUrl, m.zoomIn.DOWN),
            onPress: e,
            onRelease: n,
            onClick: r,
            onEnter: e,
            onExit: n,
            onFocus: f,
            onBlur: p
          })), d.push(this.zoomOutButton = new t.Button({
            element: this.zoomOutButton ? t.getElement(this.zoomOutButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.ZoomOut"),
            srcRest: P(this.prefixUrl, m.zoomOut.REST),
            srcGroup: P(this.prefixUrl, m.zoomOut.GROUP),
            srcHover: P(this.prefixUrl, m.zoomOut.HOVER),
            srcDown: P(this.prefixUrl, m.zoomOut.DOWN),
            onPress: i,
            onRelease: n,
            onClick: o,
            onEnter: i,
            onExit: n,
            onFocus: f,
            onBlur: p
          }))), this.showHomeControl && d.push(this.homeButton = new t.Button({
            element: this.homeButton ? t.getElement(this.homeButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.Home"),
            srcRest: P(this.prefixUrl, m.home.REST),
            srcGroup: P(this.prefixUrl, m.home.GROUP),
            srcHover: P(this.prefixUrl, m.home.HOVER),
            srcDown: P(this.prefixUrl, m.home.DOWN),
            onRelease: a,
            onFocus: f,
            onBlur: p
          })), this.showFullPageControl && d.push(this.fullPageButton = new t.Button({
            element: this.fullPageButton ? t.getElement(this.fullPageButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.FullPage"),
            srcRest: P(this.prefixUrl, m.fullpage.REST),
            srcGroup: P(this.prefixUrl, m.fullpage.GROUP),
            srcHover: P(this.prefixUrl, m.fullpage.HOVER),
            srcDown: P(this.prefixUrl, m.fullpage.DOWN),
            onRelease: s,
            onFocus: f,
            onBlur: p
          })), this.showRotationControl && (d.push(this.rotateLeftButton = new t.Button({
            element: this.rotateLeftButton ? t.getElement(this.rotateLeftButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.RotateLeft"),
            srcRest: P(this.prefixUrl, m.rotateleft.REST),
            srcGroup: P(this.prefixUrl, m.rotateleft.GROUP),
            srcHover: P(this.prefixUrl, m.rotateleft.HOVER),
            srcDown: P(this.prefixUrl, m.rotateleft.DOWN),
            onRelease: u,
            onFocus: f,
            onBlur: p
          })), d.push(this.rotateRightButton = new t.Button({
            element: this.rotateRightButton ? t.getElement(this.rotateRightButton) : null,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            tooltip: t.getString("Tooltips.RotateRight"),
            srcRest: P(this.prefixUrl, m.rotateright.REST),
            srcGroup: P(this.prefixUrl, m.rotateright.GROUP),
            srcHover: P(this.prefixUrl, m.rotateright.HOVER),
            srcDown: P(this.prefixUrl, m.rotateright.DOWN),
            onRelease: c,
            onFocus: f,
            onBlur: p
          }))), g && (this.buttons = new t.ButtonGroup({
            buttons: d,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold
          }), this.navControl = this.buttons.element, this.addHandler("open", t.delegate(this, j)), this.toolbar ? this.toolbar.addControl(this.navControl, {
            anchor: t.ControlAnchor.TOP_LEFT
          }) : this.addControl(this.navControl, {
            anchor: this.navigationControlAnchor || t.ControlAnchor.TOP_LEFT
          }))), this;
        },
        currentPage: function currentPage() {
          return this._sequenceIndex;
        },
        goToPage: function goToPage(t) {
          return this.tileSources && t >= 0 && t < this.tileSources.length && (this.raiseEvent("page", {
            page: t
          }), this._sequenceIndex = t, this._updateSequenceButtons(t), this.open(this.tileSources[t]), this.referenceStrip && this.referenceStrip.setFocus(t)), this;
        },
        addOverlay: function addOverlay(e, n, o, a) {
          var s;
          if (s = t.isPlainObject(e) ? e : {
            element: e,
            location: n,
            placement: o,
            onDraw: a
          }, e = t.getElement(s.element), i(this.currentOverlays, e) >= 0) return this;
          var u = r(this, s);
          return this.currentOverlays.push(u), u.drawHTML(this.overlaysContainer, this.viewport), this.raiseEvent("add-overlay", {
            element: e,
            location: s.location,
            placement: s.placement
          }), this;
        },
        updateOverlay: function updateOverlay(e, n, r) {
          var o;
          return e = t.getElement(e), o = i(this.currentOverlays, e), o >= 0 && (this.currentOverlays[o].update(n, r), $[this.hash].forceRedraw = !0, this.raiseEvent("update-overlay", {
            element: e,
            location: n,
            placement: r
          })), this;
        },
        removeOverlay: function removeOverlay(e) {
          var n;
          return e = t.getElement(e), n = i(this.currentOverlays, e), n >= 0 && (this.currentOverlays[n].destroy(), this.currentOverlays.splice(n, 1), $[this.hash].forceRedraw = !0, this.raiseEvent("remove-overlay", {
            element: e
          })), this;
        },
        clearOverlays: function clearOverlays() {
          for (; this.currentOverlays.length > 0;) {
            this.currentOverlays.pop().destroy();
          }

          return $[this.hash].forceRedraw = !0, this.raiseEvent("clear-overlay", {}), this;
        },
        getOverlayById: function getOverlayById(e) {
          var n;
          return e = t.getElement(e), n = i(this.currentOverlays, e), n >= 0 ? this.currentOverlays[n] : null;
        },
        _updateSequenceButtons: function _updateSequenceButtons(t) {
          this.nextButton && (this.tileSources && this.tileSources.length - 1 !== t ? this.nextButton.enable() : this.navPrevNextWrap || this.nextButton.disable()), this.previousButton && (t > 0 ? this.previousButton.enable() : this.navPrevNextWrap || this.previousButton.disable());
        },
        _showMessage: function _showMessage(e) {
          this._hideMessage();

          var n = t.makeNeutralElement("div");
          n.appendChild(document.createTextNode(e)), this.messageDiv = t.makeCenteredNode(n), t.addClass(this.messageDiv, "openseadragon-message"), this.container.appendChild(this.messageDiv);
        },
        _hideMessage: function _hideMessage() {
          var t = this.messageDiv;
          t && (t.parentNode.removeChild(t), delete this.messageDiv);
        },
        gestureSettingsByDeviceType: function gestureSettingsByDeviceType(t) {
          switch (t) {
            case "mouse":
              return this.gestureSettingsMouse;

            case "touch":
              return this.gestureSettingsTouch;

            case "pen":
              return this.gestureSettingsPen;

            default:
              return this.gestureSettingsUnknown;
          }
        },
        _drawOverlays: function _drawOverlays() {
          var t,
              e = this.currentOverlays.length;

          for (t = 0; t < e; t++) {
            this.currentOverlays[t].drawHTML(this.overlaysContainer, this.viewport);
          }
        },
        _cancelPendingImages: function _cancelPendingImages() {
          this._loadQueue = [];
        }
      });
    }(OpenSeadragon), function (t) {
      function e(t) {
        t.quick && this.viewer.viewport && (this.viewer.viewport.panTo(this.viewport.pointFromPixel(t.position)), this.viewer.viewport.applyConstraints());
      }

      function n(t) {
        this.viewer.viewport && (this.panHorizontal || (t.delta.x = 0), this.panVertical || (t.delta.y = 0), this.viewer.viewport.panBy(this.viewport.deltaPointsFromPixels(t.delta)));
      }

      function r(t) {
        t.insideElementPressed && this.viewer.viewport && this.viewer.viewport.applyConstraints();
      }

      function i(t) {
        return this.viewer.raiseEvent("navigator-scroll", {
          tracker: t.eventSource,
          position: t.position,
          scroll: t.scroll,
          shift: t.shift,
          originalEvent: t.originalEvent
        }), !1;
      }

      function o(t, e) {
        t.style.webkitTransform = "rotate(" + e + "deg)", t.style.mozTransform = "rotate(" + e + "deg)", t.style.msTransform = "rotate(" + e + "deg)", t.style.oTransform = "rotate(" + e + "deg)", t.style.transform = "rotate(" + e + "deg)";
      }

      t.Navigator = function (a) {
        function s(t) {
          o(h.displayRegionContainer, t), o(h.displayRegion, -t), h.viewport.setRotation(t);
        }

        var u,
            c,
            l = a.viewer,
            h = this;

        if (a.id ? (this.element = document.getElementById(a.id), a.controlOptions = {
          anchor: t.ControlAnchor.NONE,
          attachToViewer: !1,
          autoFade: !1
        }) : (a.id = "navigator-" + t.now(), this.element = t.makeNeutralElement("div"), a.controlOptions = {
          anchor: t.ControlAnchor.TOP_RIGHT,
          attachToViewer: !0,
          autoFade: a.autoFade
        }, a.position && ("BOTTOM_RIGHT" == a.position ? a.controlOptions.anchor = t.ControlAnchor.BOTTOM_RIGHT : "BOTTOM_LEFT" == a.position ? a.controlOptions.anchor = t.ControlAnchor.BOTTOM_LEFT : "TOP_RIGHT" == a.position ? a.controlOptions.anchor = t.ControlAnchor.TOP_RIGHT : "TOP_LEFT" == a.position ? a.controlOptions.anchor = t.ControlAnchor.TOP_LEFT : "ABSOLUTE" == a.position && (a.controlOptions.anchor = t.ControlAnchor.ABSOLUTE, a.controlOptions.top = a.top, a.controlOptions.left = a.left, a.controlOptions.height = a.height, a.controlOptions.width = a.width))), this.element.id = a.id, this.element.className += " navigator", a = t.extend(!0, {
          sizeRatio: t.DEFAULT_SETTINGS.navigatorSizeRatio
        }, a, {
          element: this.element,
          tabIndex: -1,
          showNavigator: !1,
          mouseNavEnabled: !1,
          showNavigationControl: !1,
          showSequenceControl: !1,
          immediateRender: !0,
          blendTime: 0,
          animationTime: 0,
          autoResize: a.autoResize,
          minZoomImageRatio: 1
        }), a.minPixelRatio = this.minPixelRatio = l.minPixelRatio, t.setElementTouchActionNone(this.element), this.borderWidth = 2, this.fudge = new t.Point(1, 1), this.totalBorderWidths = new t.Point(2 * this.borderWidth, 2 * this.borderWidth).minus(this.fudge), a.controlOptions.anchor != t.ControlAnchor.NONE && !function (t, e) {
          t.margin = "0px", t.border = e + "px solid #555", t.padding = "0px", t.background = "#000", t.opacity = .8, t.overflow = "hidden";
        }(this.element.style, this.borderWidth), this.displayRegion = t.makeNeutralElement("div"), this.displayRegion.id = this.element.id + "-displayregion", this.displayRegion.className = "displayregion", function (t, e) {
          t.position = "relative", t.top = "0px", t.left = "0px", t.fontSize = "0px", t.overflow = "hidden", t.border = e + "px solid #900", t.margin = "0px", t.padding = "0px", t.background = "transparent", t.float = "left", t.cssFloat = "left", t.styleFloat = "left", t.zIndex = 999999999, t.cursor = "default";
        }(this.displayRegion.style, this.borderWidth), this.displayRegionContainer = t.makeNeutralElement("div"), this.displayRegionContainer.id = this.element.id + "-displayregioncontainer", this.displayRegionContainer.className = "displayregioncontainer", this.displayRegionContainer.style.width = "100%", this.displayRegionContainer.style.height = "100%", l.addControl(this.element, a.controlOptions), this._resizeWithViewer = a.controlOptions.anchor != t.ControlAnchor.ABSOLUTE && a.controlOptions.anchor != t.ControlAnchor.NONE, this._resizeWithViewer && (a.width && a.height ? (this.element.style.height = "number" == typeof a.height ? a.height + "px" : a.height, this.element.style.width = "number" == typeof a.width ? a.width + "px" : a.width) : (u = t.getElementSize(l.element), this.element.style.height = Math.round(u.y * a.sizeRatio) + "px", this.element.style.width = Math.round(u.x * a.sizeRatio) + "px", this.oldViewerSize = u), c = t.getElementSize(this.element), this.elementArea = c.x * c.y), this.oldContainerSize = new t.Point(0, 0), t.Viewer.apply(this, [a]), this.displayRegionContainer.appendChild(this.displayRegion), this.element.getElementsByTagName("div")[0].appendChild(this.displayRegionContainer), a.navigatorRotate) {
          var f = a.viewer.viewport ? a.viewer.viewport.getRotation() : a.viewer.degrees || 0;
          s(f), a.viewer.addHandler("rotate", function (t) {
            s(t.degrees);
          });
        }

        this.innerTracker.destroy(), this.innerTracker = new t.MouseTracker({
          element: this.element,
          dragHandler: t.delegate(this, n),
          clickHandler: t.delegate(this, e),
          releaseHandler: t.delegate(this, r),
          scrollHandler: t.delegate(this, i)
        }), this.addHandler("reset-size", function () {
          h.viewport && h.viewport.goHome(!0);
        }), l.world.addHandler("item-index-change", function (t) {
          var e = h.world.getItemAt(t.previousIndex);
          h.world.setItemIndex(e, t.newIndex);
        }), l.world.addHandler("remove-item", function (t) {
          var e = t.item,
              n = h._getMatchingItem(e);

          n && h.world.removeItem(n);
        }), this.update(l.viewport);
      }, t.extend(t.Navigator.prototype, t.EventSource.prototype, t.Viewer.prototype, {
        updateSize: function updateSize() {
          if (this.viewport) {
            var e = new t.Point(0 === this.container.clientWidth ? 1 : this.container.clientWidth, 0 === this.container.clientHeight ? 1 : this.container.clientHeight);
            e.equals(this.oldContainerSize) || (this.viewport.resize(e, !0), this.viewport.goHome(!0), this.oldContainerSize = e, this.drawer.clear(), this.world.draw());
          }
        },
        update: function update(e) {
          var n, r, i, o, a, s;

          if (n = t.getElementSize(this.viewer.element), this._resizeWithViewer && n.x && n.y && !n.equals(this.oldViewerSize) && (this.oldViewerSize = n, this.maintainSizeRatio || !this.elementArea ? (r = n.x * this.sizeRatio, i = n.y * this.sizeRatio) : (r = Math.sqrt(this.elementArea * (n.x / n.y)), i = this.elementArea / r), this.element.style.width = Math.round(r) + "px", this.element.style.height = Math.round(i) + "px", this.elementArea || (this.elementArea = r * i), this.updateSize()), e && this.viewport) {
            o = e.getBoundsNoRotate(!0), a = this.viewport.pixelFromPointNoRotate(o.getTopLeft(), !1), s = this.viewport.pixelFromPointNoRotate(o.getBottomRight(), !1).minus(this.totalBorderWidths);
            var u = this.displayRegion.style;
            u.display = this.world.getItemCount() ? "block" : "none", u.top = Math.round(a.y) + "px", u.left = Math.round(a.x) + "px";
            var c = Math.abs(a.x - s.x),
                l = Math.abs(a.y - s.y);
            u.width = Math.round(Math.max(c, 0)) + "px", u.height = Math.round(Math.max(l, 0)) + "px";
          }
        },
        addTiledImage: function addTiledImage(e) {
          var n = this,
              r = e.originalTiledImage;
          delete e.original;
          var i = t.extend({}, e, {
            success: function success(t) {
              var e = t.item;
              e._originalForNavigator = r, n._matchBounds(e, r, !0), r.addHandler("bounds-change", function () {
                n._matchBounds(e, r);
              });
            }
          });
          return t.Viewer.prototype.addTiledImage.apply(this, [i]);
        },
        _getMatchingItem: function _getMatchingItem(t) {
          for (var e, n = this.world.getItemCount(), r = 0; r < n; r++) {
            if (e = this.world.getItemAt(r), e._originalForNavigator === t) return e;
          }

          return null;
        },
        _matchBounds: function _matchBounds(t, e, n) {
          var r = e.getBounds();
          t.setPosition(r.getTopLeft(), n), t.setWidth(r.width, n);
        }
      });
    }(OpenSeadragon), function (t) {
      var e = {
        Errors: {
          Dzc: "Sorry, we don't support Deep Zoom Collections!",
          Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
          Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
          ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.",
          Security: "It looks like a security restriction stopped us from loading this Deep Zoom Image.",
          Status: "This space unintentionally left blank ({0} {1}).",
          OpenFailed: "Unable to open {0}: {1}"
        },
        Tooltips: {
          FullPage: "Toggle full page",
          Home: "Go home",
          ZoomIn: "Zoom in",
          ZoomOut: "Zoom out",
          NextPage: "Next page",
          PreviousPage: "Previous page",
          RotateLeft: "Rotate left",
          RotateRight: "Rotate right"
        }
      };
      t.extend(t, {
        getString: function getString(n) {
          var r,
              i = n.split("."),
              o = null,
              a = arguments,
              s = e;

          for (r = 0; r < i.length - 1; r++) {
            s = s[i[r]] || {};
          }

          return o = s[i[r]], "string" != typeof o && (t.console.debug("Untranslated source string:", n), o = ""), o.replace(/\{\d+\}/g, function (t) {
            var e = parseInt(t.match(/\d+/), 10) + 1;
            return e < a.length ? a[e] : "";
          });
        },
        setString: function setString(t, n) {
          var r,
              i = t.split("."),
              o = e;

          for (r = 0; r < i.length - 1; r++) {
            o[i[r]] || (o[i[r]] = {}), o = o[i[r]];
          }

          o[i[r]] = n;
        }
      });
    }(OpenSeadragon), function (t) {
      t.Point = function (t, e) {
        this.x = "number" == typeof t ? t : 0, this.y = "number" == typeof e ? e : 0;
      }, t.Point.prototype = {
        clone: function clone() {
          return new t.Point(this.x, this.y);
        },
        plus: function plus(e) {
          return new t.Point(this.x + e.x, this.y + e.y);
        },
        minus: function minus(e) {
          return new t.Point(this.x - e.x, this.y - e.y);
        },
        times: function times(e) {
          return new t.Point(this.x * e, this.y * e);
        },
        divide: function divide(e) {
          return new t.Point(this.x / e, this.y / e);
        },
        negate: function negate() {
          return new t.Point(-this.x, -this.y);
        },
        distanceTo: function distanceTo(t) {
          return Math.sqrt(Math.pow(this.x - t.x, 2) + Math.pow(this.y - t.y, 2));
        },
        apply: function apply(e) {
          return new t.Point(e(this.x), e(this.y));
        },
        equals: function equals(e) {
          return e instanceof t.Point && this.x === e.x && this.y === e.y;
        },
        rotate: function rotate(e, n) {
          n = n || new t.Point(0, 0);
          var r, i;

          if (e % 90 === 0) {
            var o = e % 360;

            switch (o < 0 && (o += 360), o) {
              case 0:
                r = 1, i = 0;
                break;

              case 90:
                r = 0, i = 1;
                break;

              case 180:
                r = -1, i = 0;
                break;

              case 270:
                r = 0, i = -1;
            }
          } else {
            var a = e * Math.PI / 180;
            r = Math.cos(a), i = Math.sin(a);
          }

          var s = r * (this.x - n.x) - i * (this.y - n.y) + n.x,
              u = i * (this.x - n.x) + r * (this.y - n.y) + n.y;
          return new t.Point(s, u);
        },
        toString: function toString() {
          return "(" + Math.round(100 * this.x) / 100 + "," + Math.round(100 * this.y) / 100 + ")";
        }
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        var n,
            r,
            i = e.responseText,
            o = e.status;
        if (!e) throw new Error(t.getString("Errors.Security"));
        if (200 !== e.status && 0 !== e.status) throw o = e.status, n = 404 == o ? "Not Found" : e.statusText, new Error(t.getString("Errors.Status", o, n));
        if (i.match(/\s*<.*/)) try {
          r = e.responseXML && e.responseXML.documentElement ? e.responseXML : t.parseXml(i);
        } catch (t) {
          r = e.responseText;
        } else r = i.match(/\s*[\{\[].*/) ? t.parseJSON(i) : i;
        return r;
      }

      t.TileSource = function (e, n, r, i, o, a) {
        var s,
            u,
            c = this,
            l = arguments;
        if (s = t.isPlainObject(e) ? e : {
          width: l[0],
          height: l[1],
          tileSize: l[2],
          tileOverlap: l[3],
          minLevel: l[4],
          maxLevel: l[5]
        }, t.EventSource.call(this), t.extend(!0, this, s), !this.success) for (u = 0; u < arguments.length; u++) {
          if (t.isFunction(arguments[u])) {
            this.success = arguments[u];
            break;
          }
        }
        this.success && this.addHandler("ready", function (t) {
          c.success(t);
        }), "string" == t.type(arguments[0]) && (this.url = arguments[0]), this.url ? (this.aspectRatio = 1, this.dimensions = new t.Point(10, 10), this._tileWidth = 0, this._tileHeight = 0, this.tileOverlap = 0, this.minLevel = 0, this.maxLevel = 0, this.ready = !1, this.getImageInfo(this.url)) : (this.ready = !0, this.aspectRatio = s.width && s.height ? s.width / s.height : 1, this.dimensions = new t.Point(s.width, s.height), this.tileSize ? (this._tileWidth = this._tileHeight = this.tileSize, delete this.tileSize) : (this.tileWidth ? (this._tileWidth = this.tileWidth, delete this.tileWidth) : this._tileWidth = 0, this.tileHeight ? (this._tileHeight = this.tileHeight, delete this.tileHeight) : this._tileHeight = 0), this.tileOverlap = s.tileOverlap ? s.tileOverlap : 0, this.minLevel = s.minLevel ? s.minLevel : 0, this.maxLevel = void 0 !== s.maxLevel && null !== s.maxLevel ? s.maxLevel : s.width && s.height ? Math.ceil(Math.log(Math.max(s.width, s.height)) / Math.log(2)) : 0, this.success && t.isFunction(this.success) && this.success(this));
      }, t.TileSource.prototype = {
        getTileSize: function getTileSize(e) {
          return t.console.error("[TileSource.getTileSize] is deprecated.Use TileSource.getTileWidth() and TileSource.getTileHeight() instead"), this._tileWidth;
        },
        getTileWidth: function getTileWidth(t) {
          return this._tileWidth ? this._tileWidth : this.getTileSize(t);
        },
        getTileHeight: function getTileHeight(t) {
          return this._tileHeight ? this._tileHeight : this.getTileSize(t);
        },
        getLevelScale: function getLevelScale(t) {
          var e,
              n = {};

          for (e = 0; e <= this.maxLevel; e++) {
            n[e] = 1 / Math.pow(2, this.maxLevel - e);
          }

          return this.getLevelScale = function (t) {
            return n[t];
          }, this.getLevelScale(t);
        },
        getNumTiles: function getNumTiles(e) {
          var n = this.getLevelScale(e),
              r = Math.ceil(n * this.dimensions.x / this.getTileWidth(e)),
              i = Math.ceil(n * this.dimensions.y / this.getTileHeight(e));
          return new t.Point(r, i);
        },
        getPixelRatio: function getPixelRatio(e) {
          var n = this.dimensions.times(this.getLevelScale(e)),
              r = 1 / n.x,
              i = 1 / n.y;
          return new t.Point(r, i);
        },
        getClosestLevel: function getClosestLevel(e) {
          var n, r, i;

          for (n = this.minLevel; n < this.maxLevel && (i = this.getNumTiles(n), r = new t.Point(Math.floor(e.x / this.getTileWidth(n)), Math.floor(e.y / this.getTileHeight(n))), !(i.x + 1 >= r.x && i.y + 1 >= r.y)); n++) {
            ;
          }

          return Math.max(0, n - 1);
        },
        getTileAtPoint: function getTileAtPoint(e, n) {
          var r = n.times(this.dimensions.x).times(this.getLevelScale(e)),
              i = Math.floor(r.x / this.getTileWidth(e)),
              o = Math.floor(r.y / this.getTileHeight(e));
          return new t.Point(i, o);
        },
        getTileBounds: function getTileBounds(e, n, r) {
          var i = this.dimensions.times(this.getLevelScale(e)),
              o = this.getTileWidth(e),
              a = this.getTileHeight(e),
              s = 0 === n ? 0 : o * n - this.tileOverlap,
              u = 0 === r ? 0 : a * r - this.tileOverlap,
              c = o + (0 === n ? 1 : 2) * this.tileOverlap,
              l = a + (0 === r ? 1 : 2) * this.tileOverlap,
              h = 1 / i.x;
          return c = Math.min(c, i.x - s), l = Math.min(l, i.y - u), new t.Rect(s * h, u * h, c * h, l * h);
        },
        getImageInfo: function getImageInfo(n) {
          var r,
              i,
              o,
              a,
              s,
              u,
              c,
              l = this;
          n && (s = n.split("/"), u = s[s.length - 1], c = u.lastIndexOf("."), c > -1 && (s[s.length - 1] = u.slice(0, c))), i = function i(e) {
            "string" == typeof e && (e = t.parseXml(e));
            var r = t.TileSource.determineType(l, e, n);
            return r ? (a = r.prototype.configure.apply(l, [e, n]), void 0 === a.ajaxWithCredentials && (a.ajaxWithCredentials = l.ajaxWithCredentials), o = new r(a), l.ready = !0, void l.raiseEvent("ready", {
              tileSource: o
            })) : void l.raiseEvent("open-failed", {
              message: "Unable to load TileSource",
              source: n
            });
          }, n.match(/\.js$/) ? (r = n.split("/").pop().replace(".js", ""), t.jsonp({
            url: n,
            async: !1,
            callbackName: r,
            callback: i
          })) : t.makeAjaxRequest({
            url: n,
            withCredentials: this.ajaxWithCredentials,
            success: function success(t) {
              var n = e(t);
              i(n);
            },
            error: function error(t, e) {
              var r;

              try {
                r = "HTTP " + t.status + " attempting to load TileSource";
              } catch (t) {
                var i;
                i = "undefined" != typeof e && e.toString ? e.toString() : "Unknown error", r = i + " attempting to load TileSource";
              }

              l.raiseEvent("open-failed", {
                message: r,
                source: n
              });
            }
          });
        },
        supports: function supports(t, e) {
          return !1;
        },
        configure: function configure(t, e) {
          throw new Error("Method not implemented.");
        },
        getTileUrl: function getTileUrl(t, e, n) {
          throw new Error("Method not implemented.");
        },
        tileExists: function tileExists(t, e, n) {
          var r = this.getNumTiles(t);
          return t >= this.minLevel && t <= this.maxLevel && e >= 0 && n >= 0 && e < r.x && n < r.y;
        }
      }, t.extend(!0, t.TileSource.prototype, t.EventSource.prototype), t.TileSource.determineType = function (e, n, r) {
        var i;

        for (i in OpenSeadragon) {
          if (i.match(/.+TileSource$/) && t.isFunction(OpenSeadragon[i]) && t.isFunction(OpenSeadragon[i].prototype.supports) && OpenSeadragon[i].prototype.supports.call(e, n, r)) return OpenSeadragon[i];
        }

        t.console.error("No TileSource was able to open %s %s", r, n);
      };
    }(OpenSeadragon), function (t) {
      function e(e, r) {
        if (!r || !r.documentElement) throw new Error(t.getString("Errors.Xml"));
        var i,
            o,
            a,
            s,
            u,
            c = r.documentElement,
            l = c.localName || c.tagName,
            h = r.documentElement.namespaceURI,
            f = null,
            p = [];
        if ("Image" == l) try {
          if (s = c.getElementsByTagName("Size")[0], void 0 === s && (s = c.getElementsByTagNameNS(h, "Size")[0]), f = {
            Image: {
              xmlns: "http://schemas.microsoft.com/deepzoom/2008",
              Url: c.getAttribute("Url"),
              Format: c.getAttribute("Format"),
              DisplayRect: null,
              Overlap: parseInt(c.getAttribute("Overlap"), 10),
              TileSize: parseInt(c.getAttribute("TileSize"), 10),
              Size: {
                Height: parseInt(s.getAttribute("Height"), 10),
                Width: parseInt(s.getAttribute("Width"), 10)
              }
            }
          }, !t.imageFormatSupported(f.Image.Format)) throw new Error(t.getString("Errors.ImageFormat", f.Image.Format.toUpperCase()));

          for (i = c.getElementsByTagName("DisplayRect"), void 0 === i && (i = c.getElementsByTagNameNS(h, "DisplayRect")[0]), u = 0; u < i.length; u++) {
            o = i[u], a = o.getElementsByTagName("Rect")[0], void 0 === a && (a = o.getElementsByTagNameNS(h, "Rect")[0]), p.push({
              Rect: {
                X: parseInt(a.getAttribute("X"), 10),
                Y: parseInt(a.getAttribute("Y"), 10),
                Width: parseInt(a.getAttribute("Width"), 10),
                Height: parseInt(a.getAttribute("Height"), 10),
                MinLevel: parseInt(o.getAttribute("MinLevel"), 10),
                MaxLevel: parseInt(o.getAttribute("MaxLevel"), 10)
              }
            });
          }

          return p.length && (f.Image.DisplayRect = p), n(e, f);
        } catch (e) {
          throw e instanceof Error ? e : new Error(t.getString("Errors.Dzi"));
        } else {
          if ("Collection" == l) throw new Error(t.getString("Errors.Dzc"));

          if ("Error" == l) {
            var m = c.getElementsByTagName("Message")[0],
                d = m.firstChild.nodeValue;
            throw new Error(d);
          }
        }
        throw new Error(t.getString("Errors.Dzi"));
      }

      function n(e, n) {
        var r,
            i,
            o = n.Image,
            a = o.Url,
            s = o.Format,
            u = o.Size,
            c = o.DisplayRect || [],
            l = parseInt(u.Width, 10),
            h = parseInt(u.Height, 10),
            f = parseInt(o.TileSize, 10),
            p = parseInt(o.Overlap, 10),
            m = [];

        for (i = 0; i < c.length; i++) {
          r = c[i].Rect, m.push(new t.DisplayRect(parseInt(r.X, 10), parseInt(r.Y, 10), parseInt(r.Width, 10), parseInt(r.Height, 10), parseInt(r.MinLevel, 10), parseInt(r.MaxLevel, 10)));
        }

        return t.extend(!0, {
          width: l,
          height: h,
          tileSize: f,
          tileOverlap: p,
          minLevel: null,
          maxLevel: null,
          tilesUrl: a,
          fileFormat: s,
          displayRects: m
        }, n);
      }

      t.DziTileSource = function (e, n, r, i, o, a, s, u, c) {
        var l, h, f, p;
        if (p = t.isPlainObject(e) ? e : {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4],
          fileFormat: arguments[5],
          displayRects: arguments[6],
          minLevel: arguments[7],
          maxLevel: arguments[8]
        }, this._levelRects = {}, this.tilesUrl = p.tilesUrl, this.fileFormat = p.fileFormat, this.displayRects = p.displayRects, this.displayRects) for (l = this.displayRects.length - 1; l >= 0; l--) {
          for (h = this.displayRects[l], f = h.minLevel; f <= h.maxLevel; f++) {
            this._levelRects[f] || (this._levelRects[f] = []), this._levelRects[f].push(h);
          }
        }
        t.TileSource.apply(this, [p]);
      }, t.extend(t.DziTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          var n;
          return t.Image ? n = t.Image.xmlns : t.documentElement && ("Image" != t.documentElement.localName && "Image" != t.documentElement.tagName || (n = t.documentElement.namespaceURI)), "http://schemas.microsoft.com/deepzoom/2008" == n || "http://schemas.microsoft.com/deepzoom/2009" == n;
        },
        configure: function configure(r, i) {
          var o;
          return o = t.isPlainObject(r) ? n(this, r) : e(this, r), i && !o.tilesUrl && (o.tilesUrl = i.replace(/([^\/]+?)(\.(dzi|xml|js))?\/?(\?.*)?$/, "$1_files/"), i.search(/\.(dzi|xml|js)\?/) != -1 ? o.queryParams = i.match(/\?.*/) : o.queryParams = ""), o;
        },
        getTileUrl: function getTileUrl(t, e, n) {
          return [this.tilesUrl, t, "/", e, "_", n, ".", this.fileFormat, this.queryParams].join("");
        },
        tileExists: function tileExists(t, e, n) {
          var r,
              i,
              o,
              a,
              s,
              u,
              c,
              l = this._levelRects[t];
          if (!l || !l.length) return !0;

          for (c = l.length - 1; c >= 0; c--) {
            if (r = l[c], !(t < r.minLevel || t > r.maxLevel) && (i = this.getLevelScale(t), o = r.x * i, a = r.y * i, s = o + r.width * i, u = a + r.height * i, o = Math.floor(o / this.tileSize), a = Math.floor(a / this.tileSize), s = Math.ceil(s / this.tileSize), u = Math.ceil(u / this.tileSize), o <= e && e < s && a <= n && n < u)) return !0;
          }

          return !1;
        }
      });
    }(OpenSeadragon), function (t) {
      function e(t) {
        var e = ["http://library.stanford.edu/iiif/image-api/compliance.html#level0", "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", "http://iiif.io/api/image/2/level0.json"],
            n = e.indexOf(t[0]) != -1;
        return !n || t.indexOf("sizeByW") != -1;
      }

      function n(t) {
        for (var e = [], n = 0; n < t.sizes.length; n++) {
          e.push({
            url: t["@id"] + "/full/" + t.sizes[n].width + ",/0/default.jpg",
            width: t.sizes[n].width,
            height: t.sizes[n].height
          });
        }

        return e.sort(function (t, e) {
          return t.width - e.width;
        });
      }

      function r(e) {
        if (!e || !e.documentElement) throw new Error(t.getString("Errors.Xml"));
        var n = e.documentElement,
            r = n.tagName,
            o = null;
        if ("info" == r) try {
          return o = {}, i(n, o), o;
        } catch (e) {
          throw e instanceof Error ? e : new Error(t.getString("Errors.IIIF"));
        }
        throw new Error(t.getString("Errors.IIIF"));
      }

      function i(e, n, r) {
        var o, a;
        if (3 == e.nodeType && r) a = e.nodeValue.trim(), a.match(/^\d*$/) && (a = Number(a)), n[r] ? (t.isArray(n[r]) || (n[r] = [n[r]]), n[r].push(a)) : n[r] = a;else if (1 == e.nodeType) for (o = 0; o < e.childNodes.length; o++) {
          i(e.childNodes[o], n, e.nodeName);
        }
      }

      t.IIIFTileSource = function (r) {
        if (t.extend(!0, this, r), !(this.height && this.width && this["@id"])) throw new Error("IIIF required parameters not provided.");
        if (r.tileSizePerScaleFactor = {}, this.tile_width && this.tile_height) r.tileWidth = this.tile_width, r.tileHeight = this.tile_height;else if (this.tile_width) r.tileSize = this.tile_width;else if (this.tile_height) r.tileSize = this.tile_height;else if (this.tiles) {
          if (1 == this.tiles.length) r.tileWidth = this.tiles[0].width, r.tileHeight = this.tiles[0].height || this.tiles[0].width, this.scale_factors = this.tiles[0].scaleFactors;else {
            this.scale_factors = [];

            for (var i = 0; i < this.tiles.length; i++) {
              for (var o = 0; o < this.tiles[i].scaleFactors.length; o++) {
                var a = this.tiles[i].scaleFactors[o];
                this.scale_factors.push(a), r.tileSizePerScaleFactor[a] = {
                  width: this.tiles[i].width,
                  height: this.tiles[i].height || this.tiles[i].width
                };
              }
            }
          }
        } else if (e(r.profile)) {
          for (var s = Math.min(this.height, this.width), u = [256, 512, 1024], c = [], l = 0; l < u.length; l++) {
            u[l] <= s && c.push(u[l]);
          }

          c.length > 0 ? r.tileSize = Math.max.apply(null, c) : r.tileSize = s;
        } else this.sizes && this.sizes.length > 0 ? (this.emulateLegacyImagePyramid = !0, r.levels = n(this), t.extend(!0, r, {
          width: r.levels[r.levels.length - 1].width,
          height: r.levels[r.levels.length - 1].height,
          tileSize: Math.max(r.height, r.width),
          tileOverlap: 0,
          minLevel: 0,
          maxLevel: r.levels.length - 1
        }), this.levels = r.levels) : t.console.error("Nothing in the info.json to construct image pyramids from");
        r.maxLevel || this.emulateLegacyImagePyramid || (this.scale_factors ? r.maxLevel = Math.floor(Math.pow(Math.max.apply(null, this.scale_factors), .5)) : r.maxLevel = Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2)))), t.TileSource.apply(this, [r]);
      }, t.extend(t.IIIFTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          return !(!t.protocol || "http://iiif.io/api/image" != t.protocol) || !(!t["@context"] || "http://library.stanford.edu/iiif/image-api/1.1/context.json" != t["@context"] && "http://iiif.io/api/image/1/context.json" != t["@context"]) || !(!t.profile || 0 !== t.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html")) || !!(t.identifier && t.width && t.height) || !(!t.documentElement || "info" != t.documentElement.tagName || "http://library.stanford.edu/iiif/image-api/ns/" != t.documentElement.namespaceURI);
        },
        configure: function configure(e, n) {
          if (t.isPlainObject(e)) return e["@context"] ? e : (e["@context"] = "http://iiif.io/api/image/1.0/context.json", e["@id"] = n.replace("/info.json", ""), e);
          var i = r(e);
          return i["@context"] = "http://iiif.io/api/image/1.0/context.json", i["@id"] = n.replace("/info.xml", ""), i;
        },
        getTileWidth: function getTileWidth(e) {
          if (this.emulateLegacyImagePyramid) return t.TileSource.prototype.getTileWidth.call(this, e);
          var n = Math.pow(2, this.maxLevel - e);
          return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[n] ? this.tileSizePerScaleFactor[n].width : this._tileWidth;
        },
        getTileHeight: function getTileHeight(e) {
          if (this.emulateLegacyImagePyramid) return t.TileSource.prototype.getTileHeight.call(this, e);
          var n = Math.pow(2, this.maxLevel - e);
          return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[n] ? this.tileSizePerScaleFactor[n].height : this._tileHeight;
        },
        getLevelScale: function getLevelScale(e) {
          if (this.emulateLegacyImagePyramid) {
            var n = NaN;
            return this.levels.length > 0 && e >= this.minLevel && e <= this.maxLevel && (n = this.levels[e].width / this.levels[this.maxLevel].width), n;
          }

          return t.TileSource.prototype.getLevelScale.call(this, e);
        },
        getNumTiles: function getNumTiles(e) {
          if (this.emulateLegacyImagePyramid) {
            var n = this.getLevelScale(e);
            return n ? new t.Point(1, 1) : new t.Point(0, 0);
          }

          return t.TileSource.prototype.getNumTiles.call(this, e);
        },
        getTileAtPoint: function getTileAtPoint(e, n) {
          return this.emulateLegacyImagePyramid ? new t.Point(0, 0) : t.TileSource.prototype.getTileAtPoint.call(this, e, n);
        },
        getTileUrl: function getTileUrl(t, e, n) {
          if (this.emulateLegacyImagePyramid) {
            var r = null;
            return this.levels.length > 0 && t >= this.minLevel && t <= this.maxLevel && (r = this.levels[t].url), r;
          }

          var i,
              o,
              a,
              s,
              u,
              c,
              l,
              h,
              f,
              p,
              m,
              d,
              g = "0",
              v = Math.pow(.5, this.maxLevel - t),
              y = Math.ceil(this.width * v),
              x = Math.ceil(this.height * v);
          return i = this.getTileWidth(t), o = this.getTileHeight(t), a = Math.ceil(i / v), s = Math.ceil(o / v), m = this["@context"].indexOf("/1.0/context.json") > -1 || this["@context"].indexOf("/1.1/context.json") > -1 || this["@context"].indexOf("/1/context.json") > -1 ? "native.jpg" : "default.jpg", y < i && x < o ? (p = y + ",", u = "full") : (c = e * a, l = n * s, h = Math.min(a, this.width - c), f = Math.min(s, this.height - l), p = Math.ceil(h * v) + ",", u = [c, l, h, f].join(",")), d = [this["@id"], u, p, g, m].join("/");
        }
      });
    }(OpenSeadragon), function (t) {
      t.OsmTileSource = function (e, n, r, i, o) {
        var a;
        a = t.isPlainObject(e) ? e : {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4]
        }, a.width && a.height || (a.width = 65572864, a.height = 65572864), a.tileSize || (a.tileSize = 256, a.tileOverlap = 0), a.tilesUrl || (a.tilesUrl = "http://tile.openstreetmap.org/"), a.minLevel = 8, t.TileSource.apply(this, [a]);
      }, t.extend(t.OsmTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          return t.type && "openstreetmaps" == t.type;
        },
        configure: function configure(t, e) {
          return t;
        },
        getTileUrl: function getTileUrl(t, e, n) {
          return this.tilesUrl + (t - 8) + "/" + e + "/" + n + ".png";
        }
      });
    }(OpenSeadragon), function (t) {
      t.TmsTileSource = function (e, n, r, i, o) {
        var a;
        a = t.isPlainObject(e) ? e : {
          width: arguments[0],
          height: arguments[1],
          tileSize: arguments[2],
          tileOverlap: arguments[3],
          tilesUrl: arguments[4]
        };
        var s,
            u = 256 * Math.ceil(a.width / 256),
            c = 256 * Math.ceil(a.height / 256);
        s = u > c ? u / 256 : c / 256, a.maxLevel = Math.ceil(Math.log(s) / Math.log(2)) - 1, a.tileSize = 256, a.width = u, a.height = c, t.TileSource.apply(this, [a]);
      }, t.extend(t.TmsTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          return t.type && "tiledmapservice" == t.type;
        },
        configure: function configure(t, e) {
          return t;
        },
        getTileUrl: function getTileUrl(t, e, n) {
          var r = this.getNumTiles(t).y - 1;
          return this.tilesUrl + t + "/" + e + "/" + (r - n) + ".png";
        }
      });
    }(OpenSeadragon), function (t) {
      function e(e) {
        var n,
            r,
            i = [];

        for (r = 0; r < e.length; r++) {
          n = e[r], n.height && n.width && n.url && (n.url.toLowerCase().match(/^.*\.(png|jpg|jpeg|gif)(?:\?.*)?$/) || n.mimetype && n.mimetype.toLowerCase().match(/^.*\/(png|jpg|jpeg|gif)$/)) ? i.push({
            url: n.url,
            width: Number(n.width),
            height: Number(n.height)
          }) : t.console.error("Unsupported image format: %s", n.url ? n.url : "<no URL>");
        }

        return i.sort(function (t, e) {
          return t.height - e.height;
        });
      }

      function n(e, n) {
        if (!n || !n.documentElement) throw new Error(t.getString("Errors.Xml"));
        var i,
            o,
            a = n.documentElement,
            s = a.tagName,
            u = null,
            c = [];
        if ("image" == s) try {
          for (u = {
            type: a.getAttribute("type"),
            levels: []
          }, c = a.getElementsByTagName("level"), o = 0; o < c.length; o++) {
            i = c[o], u.levels.push({
              url: i.getAttribute("url"),
              width: parseInt(i.getAttribute("width"), 10),
              height: parseInt(i.getAttribute("height"), 10)
            });
          }

          return r(e, u);
        } catch (t) {
          throw t instanceof Error ? t : new Error("Unknown error parsing Legacy Image Pyramid XML.");
        } else {
          if ("collection" == s) throw new Error("Legacy Image Pyramid Collections not yet supported.");
          if ("error" == s) throw new Error("Error: " + n);
        }
        throw new Error("Unknown element " + s);
      }

      function r(t, e) {
        return e.levels;
      }

      t.LegacyTileSource = function (n) {
        var r, i, o;
        t.isArray(n) && (r = {
          type: "legacy-image-pyramid",
          levels: n
        }), r.levels = e(r.levels), r.levels.length > 0 ? (i = r.levels[r.levels.length - 1].width, o = r.levels[r.levels.length - 1].height) : (i = 0, o = 0, t.console.error("No supported image formats found")), t.extend(!0, r, {
          width: i,
          height: o,
          tileSize: Math.max(o, i),
          tileOverlap: 0,
          minLevel: 0,
          maxLevel: r.levels.length > 0 ? r.levels.length - 1 : 0
        }), t.TileSource.apply(this, [r]), this.levels = r.levels;
      }, t.extend(t.LegacyTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          return t.type && "legacy-image-pyramid" == t.type || t.documentElement && "legacy-image-pyramid" == t.documentElement.getAttribute("type");
        },
        configure: function configure(e, i) {
          var o;
          return o = t.isPlainObject(e) ? r(this, e) : n(this, e);
        },
        getLevelScale: function getLevelScale(t) {
          var e = NaN;
          return this.levels.length > 0 && t >= this.minLevel && t <= this.maxLevel && (e = this.levels[t].width / this.levels[this.maxLevel].width), e;
        },
        getNumTiles: function getNumTiles(e) {
          var n = this.getLevelScale(e);
          return n ? new t.Point(1, 1) : new t.Point(0, 0);
        },
        getTileAtPoint: function getTileAtPoint(e, n) {
          return new t.Point(0, 0);
        },
        getTileUrl: function getTileUrl(t, e, n) {
          var r = null;
          return this.levels.length > 0 && t >= this.minLevel && t <= this.maxLevel && (r = this.levels[t].url), r;
        }
      });
    }(OpenSeadragon), function (t) {
      t.ImageTileSource = function (e) {
        e = t.extend({
          buildPyramid: !0,
          crossOriginPolicy: !1,
          ajaxWithCredentials: !1,
          useCanvas: !0
        }, e), t.TileSource.apply(this, [e]);
      }, t.extend(t.ImageTileSource.prototype, t.TileSource.prototype, {
        supports: function supports(t, e) {
          return t.type && "image" === t.type;
        },
        configure: function configure(t, e) {
          return t;
        },
        getImageInfo: function getImageInfo(e) {
          var n = this._image = new Image(),
              r = this;
          this.crossOriginPolicy && (n.crossOrigin = this.crossOriginPolicy), this.ajaxWithCredentials && (n.useCredentials = this.ajaxWithCredentials), t.addEvent(n, "load", function () {
            r.width = n.naturalWidth, r.height = n.naturalHeight, r.aspectRatio = r.width / r.height, r.dimensions = new t.Point(r.width, r.height), r._tileWidth = r.width, r._tileHeight = r.height, r.tileOverlap = 0, r.minLevel = 0, r.levels = r._buildLevels(), r.maxLevel = r.levels.length - 1, r.ready = !0, r.raiseEvent("ready", {
              tileSource: r
            });
          }), t.addEvent(n, "error", function () {
            r.raiseEvent("open-failed", {
              message: "Error loading image at " + e,
              source: e
            });
          }), n.src = e;
        },
        getLevelScale: function getLevelScale(t) {
          var e = NaN;
          return t >= this.minLevel && t <= this.maxLevel && (e = this.levels[t].width / this.levels[this.maxLevel].width), e;
        },
        getNumTiles: function getNumTiles(e) {
          var n = this.getLevelScale(e);
          return n ? new t.Point(1, 1) : new t.Point(0, 0);
        },
        getTileAtPoint: function getTileAtPoint(e, n) {
          return new t.Point(0, 0);
        },
        getTileUrl: function getTileUrl(t, e, n) {
          var r = null;
          return t >= this.minLevel && t <= this.maxLevel && (r = this.levels[t].url), r;
        },
        getContext2D: function getContext2D(t, e, n) {
          var r = null;
          return t >= this.minLevel && t <= this.maxLevel && (r = this.levels[t].context2D), r;
        },
        _buildLevels: function _buildLevels() {
          var e = [{
            url: this._image.src,
            width: this._image.naturalWidth,
            height: this._image.naturalHeight
          }];
          if (!this.buildPyramid || !t.supportsCanvas || !this.useCanvas) return delete this._image, e;
          var n = this._image.naturalWidth,
              r = this._image.naturalHeight,
              i = document.createElement("canvas"),
              o = i.getContext("2d");
          if (i.width = n, i.height = r, o.drawImage(this._image, 0, 0, n, r), e[0].context2D = o, delete this._image, t.isCanvasTainted(i)) return e;

          for (; n >= 2 && r >= 2;) {
            n = Math.floor(n / 2), r = Math.floor(r / 2);
            var a = document.createElement("canvas"),
                s = a.getContext("2d");
            a.width = n, a.height = r, s.drawImage(i, 0, 0, n, r), e.splice(0, 0, {
              context2D: s,
              width: n,
              height: r
            }), i = a, o = s;
          }

          return e;
        }
      });
    }(OpenSeadragon), function (t) {
      t.TileSourceCollection = function (e, n, r, i) {
        t.console.error("TileSourceCollection is deprecated; use World instead");
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        t.requestAnimationFrame(function () {
          n(e);
        });
      }

      function n(n) {
        var r, i, o;
        n.shouldFade && (r = t.now(), i = r - n.fadeBeginTime, o = 1 - i / n.fadeLength, o = Math.min(1, o), o = Math.max(0, o), n.imgGroup && t.setElementOpacity(n.imgGroup, o, !0), o > 0 && e(n));
      }

      function r(n) {
        n.shouldFade = !0, n.fadeBeginTime = t.now() + n.fadeDelay, window.setTimeout(function () {
          e(n);
        }, n.fadeDelay);
      }

      function i(e) {
        e.shouldFade = !1, e.imgGroup && t.setElementOpacity(e.imgGroup, 1, !0);
      }

      function o(e, n) {
        e.element.disabled || (n >= t.ButtonState.GROUP && e.currentState == t.ButtonState.REST && (i(e), e.currentState = t.ButtonState.GROUP), n >= t.ButtonState.HOVER && e.currentState == t.ButtonState.GROUP && (e.imgHover && (e.imgHover.style.visibility = ""), e.currentState = t.ButtonState.HOVER), n >= t.ButtonState.DOWN && e.currentState == t.ButtonState.HOVER && (e.imgDown && (e.imgDown.style.visibility = ""), e.currentState = t.ButtonState.DOWN));
      }

      function a(e, n) {
        e.element.disabled || (n <= t.ButtonState.HOVER && e.currentState == t.ButtonState.DOWN && (e.imgDown && (e.imgDown.style.visibility = "hidden"), e.currentState = t.ButtonState.HOVER), n <= t.ButtonState.GROUP && e.currentState == t.ButtonState.HOVER && (e.imgHover && (e.imgHover.style.visibility = "hidden"), e.currentState = t.ButtonState.GROUP), n <= t.ButtonState.REST && e.currentState == t.ButtonState.GROUP && (r(e), e.currentState = t.ButtonState.REST));
      }

      t.ButtonState = {
        REST: 0,
        GROUP: 1,
        HOVER: 2,
        DOWN: 3
      }, t.Button = function (e) {
        var n = this;
        t.EventSource.call(this), t.extend(!0, this, {
          tooltip: null,
          srcRest: null,
          srcGroup: null,
          srcHover: null,
          srcDown: null,
          clickTimeThreshold: t.DEFAULT_SETTINGS.clickTimeThreshold,
          clickDistThreshold: t.DEFAULT_SETTINGS.clickDistThreshold,
          fadeDelay: 0,
          fadeLength: 2e3,
          onPress: null,
          onRelease: null,
          onClick: null,
          onEnter: null,
          onExit: null,
          onFocus: null,
          onBlur: null
        }, e), this.element = e.element || t.makeNeutralElement("div"), e.element || (this.imgRest = t.makeTransparentImage(this.srcRest), this.imgGroup = t.makeTransparentImage(this.srcGroup), this.imgHover = t.makeTransparentImage(this.srcHover), this.imgDown = t.makeTransparentImage(this.srcDown), this.imgRest.alt = this.imgGroup.alt = this.imgHover.alt = this.imgDown.alt = this.tooltip, this.element.style.position = "relative", t.setElementTouchActionNone(this.element), this.imgGroup.style.position = this.imgHover.style.position = this.imgDown.style.position = "absolute", this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "0px", this.imgGroup.style.left = this.imgHover.style.left = this.imgDown.style.left = "0px", this.imgHover.style.visibility = this.imgDown.style.visibility = "hidden", t.Browser.vendor == t.BROWSERS.FIREFOX && t.Browser.version < 3 && (this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = ""), this.element.appendChild(this.imgRest), this.element.appendChild(this.imgGroup), this.element.appendChild(this.imgHover), this.element.appendChild(this.imgDown)), this.addHandler("press", this.onPress), this.addHandler("release", this.onRelease), this.addHandler("click", this.onClick), this.addHandler("enter", this.onEnter), this.addHandler("exit", this.onExit), this.addHandler("focus", this.onFocus), this.addHandler("blur", this.onBlur), this.currentState = t.ButtonState.GROUP, this.fadeBeginTime = null, this.shouldFade = !1, this.element.style.display = "inline-block", this.element.style.position = "relative", this.element.title = this.tooltip, this.tracker = new t.MouseTracker({
          element: this.element,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          enterHandler: function enterHandler(e) {
            e.insideElementPressed ? (o(n, t.ButtonState.DOWN), n.raiseEvent("enter", {
              originalEvent: e.originalEvent
            })) : e.buttonDownAny || o(n, t.ButtonState.HOVER);
          },
          focusHandler: function focusHandler(t) {
            this.enterHandler(t), n.raiseEvent("focus", {
              originalEvent: t.originalEvent
            });
          },
          exitHandler: function exitHandler(e) {
            a(n, t.ButtonState.GROUP), e.insideElementPressed && n.raiseEvent("exit", {
              originalEvent: e.originalEvent
            });
          },
          blurHandler: function blurHandler(t) {
            this.exitHandler(t), n.raiseEvent("blur", {
              originalEvent: t.originalEvent
            });
          },
          pressHandler: function pressHandler(e) {
            o(n, t.ButtonState.DOWN), n.raiseEvent("press", {
              originalEvent: e.originalEvent
            });
          },
          releaseHandler: function releaseHandler(e) {
            e.insideElementPressed && e.insideElementReleased ? (a(n, t.ButtonState.HOVER), n.raiseEvent("release", {
              originalEvent: e.originalEvent
            })) : e.insideElementPressed ? a(n, t.ButtonState.GROUP) : o(n, t.ButtonState.HOVER);
          },
          clickHandler: function clickHandler(t) {
            t.quick && n.raiseEvent("click", {
              originalEvent: t.originalEvent
            });
          },
          keyHandler: function keyHandler(t) {
            return 13 !== t.keyCode || (n.raiseEvent("click", {
              originalEvent: t.originalEvent
            }), n.raiseEvent("release", {
              originalEvent: t.originalEvent
            }), !1);
          }
        }), a(this, t.ButtonState.REST);
      }, t.extend(t.Button.prototype, t.EventSource.prototype, {
        notifyGroupEnter: function notifyGroupEnter() {
          o(this, t.ButtonState.GROUP);
        },
        notifyGroupExit: function notifyGroupExit() {
          a(this, t.ButtonState.REST);
        },
        disable: function disable() {
          this.notifyGroupExit(), this.element.disabled = !0, t.setElementOpacity(this.element, .2, !0);
        },
        enable: function enable() {
          this.element.disabled = !1, t.setElementOpacity(this.element, 1, !0), this.notifyGroupEnter();
        }
      });
    }(OpenSeadragon), function (t) {
      t.ButtonGroup = function (e) {
        t.extend(!0, this, {
          buttons: [],
          clickTimeThreshold: t.DEFAULT_SETTINGS.clickTimeThreshold,
          clickDistThreshold: t.DEFAULT_SETTINGS.clickDistThreshold,
          labelText: ""
        }, e);
        var n,
            r = this.buttons.concat([]),
            i = this;
        if (this.element = e.element || t.makeNeutralElement("div"), !e.group) for (this.label = t.makeNeutralElement("label"), this.element.style.display = "inline-block", this.element.appendChild(this.label), n = 0; n < r.length; n++) {
          this.element.appendChild(r[n].element);
        }
        t.setElementTouchActionNone(this.element), this.tracker = new t.MouseTracker({
          element: this.element,
          clickTimeThreshold: this.clickTimeThreshold,
          clickDistThreshold: this.clickDistThreshold,
          enterHandler: function enterHandler(t) {
            var e;

            for (e = 0; e < i.buttons.length; e++) {
              i.buttons[e].notifyGroupEnter();
            }
          },
          exitHandler: function exitHandler(t) {
            var e;
            if (!t.insideElementPressed) for (e = 0; e < i.buttons.length; e++) {
              i.buttons[e].notifyGroupExit();
            }
          }
        });
      }, t.ButtonGroup.prototype = {
        emulateEnter: function emulateEnter() {
          this.tracker.enterHandler({
            eventSource: this.tracker
          });
        },
        emulateExit: function emulateExit() {
          this.tracker.exitHandler({
            eventSource: this.tracker
          });
        }
      };
    }(OpenSeadragon), function (t) {
      t.Rect = function (t, e, n, r, i) {
        this.x = "number" == typeof t ? t : 0, this.y = "number" == typeof e ? e : 0, this.width = "number" == typeof n ? n : 0, this.height = "number" == typeof r ? r : 0, this.degrees = "number" == typeof i ? i : 0, this.degrees = this.degrees % 360, this.degrees < 0 && (this.degrees += 360);
        var o, a;
        this.degrees >= 270 ? (o = this.getTopRight(), this.x = o.x, this.y = o.y, a = this.height, this.height = this.width, this.width = a, this.degrees -= 270) : this.degrees >= 180 ? (o = this.getBottomRight(), this.x = o.x, this.y = o.y, this.degrees -= 180) : this.degrees >= 90 && (o = this.getBottomLeft(), this.x = o.x, this.y = o.y, a = this.height, this.height = this.width, this.width = a, this.degrees -= 90);
      }, t.Rect.fromSummits = function (e, n, r) {
        var i = e.distanceTo(n),
            o = e.distanceTo(r),
            a = n.minus(e),
            s = Math.atan(a.y / a.x);
        return a.x < 0 ? s += Math.PI : a.y < 0 && (s += 2 * Math.PI), new t.Rect(e.x, e.y, i, o, s / Math.PI * 180);
      }, t.Rect.prototype = {
        clone: function clone() {
          return new t.Rect(this.x, this.y, this.width, this.height, this.degrees);
        },
        getAspectRatio: function getAspectRatio() {
          return this.width / this.height;
        },
        getTopLeft: function getTopLeft() {
          return new t.Point(this.x, this.y);
        },
        getBottomRight: function getBottomRight() {
          return new t.Point(this.x + this.width, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        getTopRight: function getTopRight() {
          return new t.Point(this.x + this.width, this.y).rotate(this.degrees, this.getTopLeft());
        },
        getBottomLeft: function getBottomLeft() {
          return new t.Point(this.x, this.y + this.height).rotate(this.degrees, this.getTopLeft());
        },
        getCenter: function getCenter() {
          return new t.Point(this.x + this.width / 2, this.y + this.height / 2).rotate(this.degrees, this.getTopLeft());
        },
        getSize: function getSize() {
          return new t.Point(this.width, this.height);
        },
        equals: function equals(e) {
          return e instanceof t.Rect && this.x === e.x && this.y === e.y && this.width === e.width && this.height === e.height && this.degrees === e.degrees;
        },
        times: function times(e) {
          return new t.Rect(this.x * e, this.y * e, this.width * e, this.height * e, this.degrees);
        },
        translate: function translate(e) {
          return new t.Rect(this.x + e.x, this.y + e.y, this.width, this.height, this.degrees);
        },
        union: function union(e) {
          var n = this.getBoundingBox(),
              r = e.getBoundingBox(),
              i = Math.min(n.x, r.x),
              o = Math.min(n.y, r.y),
              a = Math.max(n.x + n.width, r.x + r.width),
              s = Math.max(n.y + n.height, r.y + r.height);
          return new t.Rect(i, o, a - i, s - o);
        },
        intersection: function intersection(e) {
          function n(e, n, i, o) {
            var a = n.minus(e),
                s = o.minus(i),
                u = -s.x * a.y + a.x * s.y;
            if (0 === u) return null;
            var c = (a.x * (e.y - i.y) - a.y * (e.x - i.x)) / u,
                l = (s.x * (e.y - i.y) - s.y * (e.x - i.x)) / u;
            return -r <= c && c <= 1 - r && -r <= l && l <= 1 - r ? new t.Point(e.x + l * a.x, e.y + l * a.y) : null;
          }

          var r = 1e-10,
              i = [],
              o = this.getTopLeft();
          e.containsPoint(o, r) && i.push(o);
          var a = this.getTopRight();
          e.containsPoint(a, r) && i.push(a);
          var s = this.getBottomLeft();
          e.containsPoint(s, r) && i.push(s);
          var u = this.getBottomRight();
          e.containsPoint(u, r) && i.push(u);
          var c = e.getTopLeft();
          this.containsPoint(c, r) && i.push(c);
          var l = e.getTopRight();
          this.containsPoint(l, r) && i.push(l);
          var h = e.getBottomLeft();
          this.containsPoint(h, r) && i.push(h);
          var f = e.getBottomRight();
          this.containsPoint(f, r) && i.push(f);

          for (var p = this._getSegments(), m = e._getSegments(), d = 0; d < p.length; d++) {
            for (var g = p[d], v = 0; v < m.length; v++) {
              var y = m[v],
                  x = n(g[0], g[1], y[0], y[1]);
              x && i.push(x);
            }
          }

          if (0 === i.length) return null;

          for (var w = i[0].x, b = i[0].x, _ = i[0].y, E = i[0].y, M = 1; M < i.length; M++) {
            var T = i[M];
            T.x < w && (w = T.x), T.x > b && (b = T.x), T.y < _ && (_ = T.y), T.y > E && (E = T.y);
          }

          return new t.Rect(w, _, b - w, E - _);
        },
        _getSegments: function _getSegments() {
          var t = this.getTopLeft(),
              e = this.getTopRight(),
              n = this.getBottomLeft(),
              r = this.getBottomRight();
          return [[t, e], [e, r], [r, n], [n, t]];
        },
        rotate: function rotate(e, n) {
          if (e %= 360, 0 === e) return this.clone();
          e < 0 && (e += 360), n = n || this.getCenter();
          var r = this.getTopLeft().rotate(e, n),
              i = this.getTopRight().rotate(e, n),
              o = i.minus(r),
              a = Math.atan(o.y / o.x);
          return o.x < 0 ? a += Math.PI : o.y < 0 && (a += 2 * Math.PI), new t.Rect(r.x, r.y, this.width, this.height, a / Math.PI * 180);
        },
        getBoundingBox: function getBoundingBox() {
          if (0 === this.degrees) return this.clone();
          var e = this.getTopLeft(),
              n = this.getTopRight(),
              r = this.getBottomLeft(),
              i = this.getBottomRight(),
              o = Math.min(e.x, n.x, r.x, i.x),
              a = Math.max(e.x, n.x, r.x, i.x),
              s = Math.min(e.y, n.y, r.y, i.y),
              u = Math.max(e.y, n.y, r.y, i.y);
          return new t.Rect(o, s, a - o, u - s);
        },
        getIntegerBoundingBox: function getIntegerBoundingBox() {
          var e = this.getBoundingBox(),
              n = Math.floor(e.x),
              r = Math.floor(e.y),
              i = Math.ceil(e.width + e.x - n),
              o = Math.ceil(e.height + e.y - r);
          return new t.Rect(n, r, i, o);
        },
        containsPoint: function containsPoint(t, e) {
          e = e || 0;
          var n = this.getTopLeft(),
              r = this.getTopRight(),
              i = this.getBottomLeft(),
              o = r.minus(n),
              a = i.minus(n);
          return (t.x - n.x) * o.x + (t.y - n.y) * o.y >= -e && (t.x - r.x) * o.x + (t.y - r.y) * o.y <= e && (t.x - n.x) * a.x + (t.y - n.y) * a.y >= -e && (t.x - i.x) * a.x + (t.y - i.y) * a.y <= e;
        },
        toString: function toString() {
          return "[" + Math.round(100 * this.x) / 100 + ", " + Math.round(100 * this.y) / 100 + ", " + Math.round(100 * this.width) / 100 + "x" + Math.round(100 * this.height) / 100 + ", " + Math.round(100 * this.degrees) / 100 + "deg]";
        }
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        var n = Number(this.element.style.marginLeft.replace("px", "")),
            i = Number(this.element.style.marginTop.replace("px", "")),
            o = Number(this.element.style.width.replace("px", "")),
            a = Number(this.element.style.height.replace("px", "")),
            s = t.getElementSize(this.viewer.canvas);
        return this.dragging = !0, this.element && ("horizontal" == this.scroll ? -e.delta.x > 0 ? n > -(o - s.x) && (this.element.style.marginLeft = n + 2 * e.delta.x + "px", r(this, s.x, n + 2 * e.delta.x)) : -e.delta.x < 0 && n < 0 && (this.element.style.marginLeft = n + 2 * e.delta.x + "px", r(this, s.x, n + 2 * e.delta.x)) : -e.delta.y > 0 ? i > -(a - s.y) && (this.element.style.marginTop = i + 2 * e.delta.y + "px", r(this, s.y, i + 2 * e.delta.y)) : -e.delta.y < 0 && i < 0 && (this.element.style.marginTop = i + 2 * e.delta.y + "px", r(this, s.y, i + 2 * e.delta.y))), !1;
      }

      function n(e) {
        var n = Number(this.element.style.marginLeft.replace("px", "")),
            i = Number(this.element.style.marginTop.replace("px", "")),
            o = Number(this.element.style.width.replace("px", "")),
            a = Number(this.element.style.height.replace("px", "")),
            s = t.getElementSize(this.viewer.canvas);
        return this.element && ("horizontal" == this.scroll ? e.scroll > 0 ? n > -(o - s.x) && (this.element.style.marginLeft = n - 60 * e.scroll + "px", r(this, s.x, n - 60 * e.scroll)) : e.scroll < 0 && n < 0 && (this.element.style.marginLeft = n - 60 * e.scroll + "px", r(this, s.x, n - 60 * e.scroll)) : e.scroll < 0 ? i > s.y - a && (this.element.style.marginTop = i + 60 * e.scroll + "px", r(this, s.y, i + 60 * e.scroll)) : e.scroll > 0 && i < 0 && (this.element.style.marginTop = i + 60 * e.scroll + "px", r(this, s.y, i + 60 * e.scroll))), !1;
      }

      function r(e, n, r) {
        var i, o, a, s, u, c, l;

        for (i = "horizontal" == e.scroll ? e.panelWidth : e.panelHeight, o = Math.ceil(n / i) + 5, a = Math.ceil((Math.abs(r) + n) / i) + 1, o = a - o, o = o < 0 ? 0 : o, c = o; c < a && c < e.panels.length; c++) {
          l = e.panels[c], l.activePanel || (s = new t.Viewer({
            id: l.id,
            tileSources: [e.viewer.tileSources[c]],
            element: l,
            navigatorSizeRatio: e.sizeRatio,
            showNavigator: !1,
            mouseNavEnabled: !1,
            showNavigationControl: !1,
            showSequenceControl: !1,
            immediateRender: !0,
            blendTime: 0,
            animationTime: 0
          }), s.displayRegion = t.makeNeutralElement("div"), s.displayRegion.id = l.id + "-displayregion", s.displayRegion.className = "displayregion", u = s.displayRegion.style, u.position = "relative", u.top = "0px", u.left = "0px", u.fontSize = "0px", u.overflow = "hidden", u.float = "left", u.cssFloat = "left", u.styleFloat = "left", u.zIndex = 999999999, u.cursor = "default", u.width = e.panelWidth - 4 + "px", u.height = e.panelHeight - 4 + "px", s.displayRegion.innerTracker = new t.MouseTracker({
            element: s.displayRegion,
            startDisabled: !0
          }), l.getElementsByTagName("div")[0].appendChild(s.displayRegion), l.activePanel = !0);
        }
      }

      function i(t) {
        var e = t.eventSource.element;
        return "horizontal" == this.scroll ? e.style.marginBottom = "0px" : e.style.marginLeft = "0px", !1;
      }

      function o(e) {
        var n = e.eventSource.element;
        return "horizontal" == this.scroll ? n.style.marginBottom = "-" + t.getElementSize(n).y / 2 + "px" : n.style.marginLeft = "-" + t.getElementSize(n).x / 2 + "px", !1;
      }

      function a(t) {
        if (t.preventDefaultAction || t.ctrl || t.alt || t.meta) return !0;

        switch (t.keyCode) {
          case 38:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: 1,
              shift: null
            }), !1;

          case 40:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: -1,
              shift: null
            }), !1;

          case 37:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: -1,
              shift: null
            }), !1;

          case 39:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: 1,
              shift: null
            }), !1;

          default:
            return !0;
        }
      }

      function s(t) {
        if (t.preventDefaultAction || t.ctrl || t.alt || t.meta) return !0;

        switch (t.keyCode) {
          case 61:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: 1,
              shift: null
            }), !1;

          case 45:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: -1,
              shift: null
            }), !1;

          case 48:
          case 119:
          case 87:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: 1,
              shift: null
            }), !1;

          case 115:
          case 83:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: -1,
              shift: null
            }), !1;

          case 97:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: -1,
              shift: null
            }), !1;

          case 100:
            return n.call(this, {
              eventSource: this.tracker,
              position: null,
              scroll: 1,
              shift: null
            }), !1;

          default:
            return !0;
        }
      }

      var u = {};
      t.ReferenceStrip = function (c) {
        var l,
            h,
            f,
            p = this,
            m = c.viewer,
            d = t.getElementSize(m.element);

        for (c.id || (c.id = "referencestrip-" + t.now(), this.element = t.makeNeutralElement("div"), this.element.id = c.id, this.element.className = "referencestrip"), c = t.extend(!0, {
          sizeRatio: t.DEFAULT_SETTINGS.referenceStripSizeRatio,
          position: t.DEFAULT_SETTINGS.referenceStripPosition,
          scroll: t.DEFAULT_SETTINGS.referenceStripScroll,
          clickTimeThreshold: t.DEFAULT_SETTINGS.clickTimeThreshold
        }, c, {
          element: this.element,
          showNavigator: !1,
          mouseNavEnabled: !1,
          showNavigationControl: !1,
          showSequenceControl: !1
        }), t.extend(this, c), u[this.id] = {
          animating: !1
        }, this.minPixelRatio = this.viewer.minPixelRatio, h = this.element.style, h.marginTop = "0px", h.marginRight = "0px", h.marginBottom = "0px", h.marginLeft = "0px", h.left = "0px", h.bottom = "0px", h.border = "0px", h.background = "#000", h.position = "relative", t.setElementTouchActionNone(this.element), t.setElementOpacity(this.element, .8), this.viewer = m, this.innerTracker = new t.MouseTracker({
          element: this.element,
          dragHandler: t.delegate(this, e),
          scrollHandler: t.delegate(this, n),
          enterHandler: t.delegate(this, i),
          exitHandler: t.delegate(this, o),
          keyDownHandler: t.delegate(this, a),
          keyHandler: t.delegate(this, s)
        }), c.width && c.height ? (this.element.style.width = c.width + "px", this.element.style.height = c.height + "px", m.addControl(this.element, {
          anchor: t.ControlAnchor.BOTTOM_LEFT
        })) : "horizontal" == c.scroll ? (this.element.style.width = d.x * c.sizeRatio * m.tileSources.length + 12 * m.tileSources.length + "px", this.element.style.height = d.y * c.sizeRatio + "px", m.addControl(this.element, {
          anchor: t.ControlAnchor.BOTTOM_LEFT
        })) : (this.element.style.height = d.y * c.sizeRatio * m.tileSources.length + 12 * m.tileSources.length + "px", this.element.style.width = d.x * c.sizeRatio + "px", m.addControl(this.element, {
          anchor: t.ControlAnchor.TOP_LEFT
        })), this.panelWidth = d.x * this.sizeRatio + 8, this.panelHeight = d.y * this.sizeRatio + 8, this.panels = [], f = 0; f < m.tileSources.length; f++) {
          l = t.makeNeutralElement("div"), l.id = this.element.id + "-" + f, l.style.width = p.panelWidth + "px", l.style.height = p.panelHeight + "px", l.style.display = "inline", l.style.float = "left", l.style.cssFloat = "left", l.style.styleFloat = "left", l.style.padding = "2px", t.setElementTouchActionNone(l), l.innerTracker = new t.MouseTracker({
            element: l,
            clickTimeThreshold: this.clickTimeThreshold,
            clickDistThreshold: this.clickDistThreshold,
            pressHandler: function pressHandler(e) {
              e.eventSource.dragging = t.now();
            },
            releaseHandler: function releaseHandler(e) {
              var n = e.eventSource,
                  r = n.element.id,
                  i = Number(r.split("-")[2]),
                  o = t.now();
              e.insideElementPressed && e.insideElementReleased && n.dragging && o - n.dragging < n.clickTimeThreshold && (n.dragging = null, m.goToPage(i));
            }
          }), this.element.appendChild(l), l.activePanel = !1, this.panels.push(l);
        }

        r(this, "vertical" == this.scroll ? d.y : d.x, 0), this.setFocus(0);
      }, t.extend(t.ReferenceStrip.prototype, t.EventSource.prototype, t.Viewer.prototype, {
        setFocus: function setFocus(e) {
          var n,
              o = t.getElement(this.element.id + "-" + e),
              a = t.getElementSize(this.viewer.canvas),
              s = Number(this.element.style.width.replace("px", "")),
              u = Number(this.element.style.height.replace("px", "")),
              c = -Number(this.element.style.marginLeft.replace("px", "")),
              l = -Number(this.element.style.marginTop.replace("px", ""));
          this.currentSelected !== o && (this.currentSelected && (this.currentSelected.style.background = "#000"), this.currentSelected = o, this.currentSelected.style.background = "#999", "horizontal" == this.scroll ? (n = Number(e) * (this.panelWidth + 3), n > c + a.x - this.panelWidth ? (n = Math.min(n, s - a.x), this.element.style.marginLeft = -n + "px", r(this, a.x, -n)) : n < c && (n = Math.max(0, n - a.x / 2), this.element.style.marginLeft = -n + "px", r(this, a.x, -n))) : (n = Number(e) * (this.panelHeight + 3), n > l + a.y - this.panelHeight ? (n = Math.min(n, u - a.y), this.element.style.marginTop = -n + "px", r(this, a.y, -n)) : n < l && (n = Math.max(0, n - a.y / 2), this.element.style.marginTop = -n + "px", r(this, a.y, -n))), this.currentPage = e, i.call(this, {
            eventSource: this.innerTracker
          }));
        },
        update: function update() {
          return !!u[this.id].animating && (t.console.log("image reference strip update"), !0);
        },
        destroy: function destroy() {
          this.element && this.element.parentNode.removeChild(this.element);
        }
      });
    }(OpenSeadragon), function (t) {
      t.DisplayRect = function (e, n, r, i, o, a) {
        t.Rect.apply(this, [e, n, r, i]), this.minLevel = o, this.maxLevel = a;
      }, t.extend(t.DisplayRect.prototype, t.Rect.prototype);
    }(OpenSeadragon), function (t) {
      function e(t, e) {
        return (1 - Math.exp(t * -e)) / (1 - Math.exp(-t));
      }

      t.Spring = function (e) {
        var n = arguments;
        "object" != typeof e && (e = {
          initial: n.length && "number" == typeof n[0] ? n[0] : void 0,
          springStiffness: n.length > 1 ? n[1].springStiffness : 5,
          animationTime: n.length > 1 ? n[1].animationTime : 1.5
        }), t.console.assert("number" == typeof e.springStiffness && 0 !== e.springStiffness, "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number"), t.console.assert("number" == typeof e.animationTime && e.animationTime >= 0, "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0"), e.exponential && (this._exponential = !0, delete e.exponential), t.extend(!0, this, e), this.current = {
          value: "number" == typeof this.initial ? this.initial : this._exponential ? 0 : 1,
          time: t.now()
        }, t.console.assert(!this._exponential || 0 !== this.current.value, "[OpenSeadragon.Spring] value must be non-zero for exponential springs"), this.start = {
          value: this.current.value,
          time: this.current.time
        }, this.target = {
          value: this.current.value,
          time: this.current.time
        }, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
      }, t.Spring.prototype = {
        resetTo: function resetTo(e) {
          t.console.assert(!this._exponential || 0 !== e, "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs"), this.start.value = this.target.value = this.current.value = e, this.start.time = this.target.time = this.current.time = t.now(), this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
        },
        springTo: function springTo(e) {
          t.console.assert(!this._exponential || 0 !== e, "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs"), this.start.value = this.current.value, this.start.time = this.current.time, this.target.value = e, this.target.time = this.start.time + 1e3 * this.animationTime, this._exponential && (this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
        },
        shiftBy: function shiftBy(e) {
          this.start.value += e, this.target.value += e, this._exponential && (t.console.assert(0 !== this.target.value && 0 !== this.start.value, "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs"), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value));
        },
        setExponential: function setExponential(e) {
          this._exponential = e, this._exponential && (t.console.assert(0 !== this.current.value && 0 !== this.target.value && 0 !== this.start.value, "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs"), this.start._logValue = Math.log(this.start.value), this.target._logValue = Math.log(this.target.value), this.current._logValue = Math.log(this.current.value));
        },
        update: function update() {
          this.current.time = t.now();
          var n, r;
          this._exponential ? (n = this.start._logValue, r = this.target._logValue) : (n = this.start.value, r = this.target.value);
          var i = this.current.time >= this.target.time ? r : n + (r - n) * e(this.springStiffness, (this.current.time - this.start.time) / (this.target.time - this.start.time));
          this._exponential ? this.current.value = Math.exp(i) : this.current.value = i;
        },
        isAtTargetValue: function isAtTargetValue() {
          return this.current.value === this.target.value;
        }
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        t.extend(!0, this, {
          timeout: t.DEFAULT_SETTINGS.timeout,
          jobId: null
        }, e), this.image = null;
      }

      function n(t, e, n) {
        var r;
        t.jobsInProgress--, (!t.jobLimit || t.jobsInProgress < t.jobLimit) && t.jobQueue.length > 0 && (r = t.jobQueue.shift(), r.start(), t.jobsInProgress++), n(e.image, e.errorMsg);
      }

      e.prototype = {
        errorMsg: null,
        start: function start() {
          var t = this;
          this.image = new Image(), this.crossOriginPolicy !== !1 && (this.image.crossOrigin = this.crossOriginPolicy), this.image.onload = function () {
            t.finish(!0);
          }, this.image.onabort = this.image.onerror = function () {
            t.errorMsg = "Image load aborted", t.finish(!1);
          }, this.jobId = window.setTimeout(function () {
            t.errorMsg = "Image load exceeded timeout", t.finish(!1);
          }, this.timeout), this.image.src = this.src;
        },
        finish: function finish(t) {
          this.image.onload = this.image.onerror = this.image.onabort = null, t || (this.image = null), this.jobId && window.clearTimeout(this.jobId), this.callback(this);
        }
      }, t.ImageLoader = function (e) {
        t.extend(!0, this, {
          jobLimit: t.DEFAULT_SETTINGS.imageLoaderLimit,
          jobQueue: [],
          jobsInProgress: 0
        }, e);
      }, t.ImageLoader.prototype = {
        addJob: function addJob(t) {
          var r = this,
              i = function i(e) {
            n(r, e, t.callback);
          },
              o = {
            src: t.src,
            crossOriginPolicy: t.crossOriginPolicy,
            callback: i,
            abort: t.abort
          },
              a = new e(o);

          !this.jobLimit || this.jobsInProgress < this.jobLimit ? (a.start(), this.jobsInProgress++) : this.jobQueue.push(a);
        },
        clear: function clear() {
          for (var t = 0; t < this.jobQueue.length; t++) {
            var e = this.jobQueue[t];
            "function" == typeof e.abort && e.abort();
          }

          this.jobQueue = [];
        }
      };
    }(OpenSeadragon), function (t) {
      t.Tile = function (t, e, n, r, i, o, a) {
        this.level = t, this.x = e, this.y = n, this.bounds = r, this.exists = i, this.url = o, this.context2D = a, this.loaded = !1, this.loading = !1, this.element = null, this.imgElement = null, this.image = null, this.style = null, this.position = null, this.size = null, this.blendStart = null, this.opacity = null, this.distance = null, this.visibility = null, this.beingDrawn = !1, this.lastTouchTime = 0;
      }, t.Tile.prototype = {
        toString: function toString() {
          return this.level + "/" + this.x + "_" + this.y;
        },
        _hasTransparencyChannel: function _hasTransparencyChannel() {
          return !!this.context2D || this.url.match(".png");
        },
        drawHTML: function drawHTML(e) {
          return this.cacheImageRecord ? this.loaded ? (this.element || (this.element = t.makeNeutralElement("div"), this.imgElement = this.cacheImageRecord.getImage().cloneNode(), this.imgElement.style.msInterpolationMode = "nearest-neighbor", this.imgElement.style.width = "100%", this.imgElement.style.height = "100%", this.style = this.element.style, this.style.position = "absolute"), this.element.parentNode != e && e.appendChild(this.element), this.imgElement.parentNode != this.element && this.element.appendChild(this.imgElement), this.style.top = this.position.y + "px", this.style.left = this.position.x + "px", this.style.height = this.size.y + "px", this.style.width = this.size.x + "px", void t.setElementOpacity(this.element, this.opacity)) : void t.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString()) : void t.console.warn("[Tile.drawHTML] attempting to draw tile %s when it's not cached", this.toString());
        },
        drawCanvas: function drawCanvas(e, n, r, i) {
          var o,
              a = this.position.times(t.pixelDensityRatio),
              s = this.size.times(t.pixelDensityRatio);
          return this.context2D || this.cacheImageRecord ? (o = this.context2D || this.cacheImageRecord.getRenderedContext(), this.loaded && o ? (e.save(), e.globalAlpha = this.opacity, "number" == typeof r && 1 !== r && (a = a.times(r), s = s.times(r)), i instanceof t.Point && (a = a.plus(i)), 1 === e.globalAlpha && this._hasTransparencyChannel() && e.clearRect(a.x + 1, a.y + 1, s.x - 2, s.y - 2), n({
            context: e,
            tile: this,
            rendered: o
          }), e.drawImage(o.canvas, 0, 0, o.canvas.width, o.canvas.height, a.x, a.y, s.x, s.y), void e.restore()) : void t.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString())) : void t.console.warn("[Tile.drawCanvas] attempting to draw tile %s when it's not cached", this.toString());
        },
        getScaleForEdgeSmoothing: function getScaleForEdgeSmoothing() {
          var e;
          if (this.cacheImageRecord) e = this.cacheImageRecord.getRenderedContext();else {
            if (!this.context2D) return t.console.warn("[Tile.drawCanvas] attempting to get tile scale %s when tile's not cached", this.toString()), 1;
            e = this.context2D;
          }
          return e.canvas.width / (this.size.x * t.pixelDensityRatio);
        },
        getTranslationForEdgeSmoothing: function getTranslationForEdgeSmoothing(e, n, r) {
          var i = Math.max(1, Math.ceil((r.x - n.x) / 2)),
              o = Math.max(1, Math.ceil((r.y - n.y) / 2));
          return new t.Point(i, o).minus(this.position.times(t.pixelDensityRatio).times(e || 1).apply(function (t) {
            return t % 1;
          }));
        },
        unload: function unload() {
          this.imgElement && this.imgElement.parentNode && this.imgElement.parentNode.removeChild(this.imgElement), this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = null, this.imgElement = null, this.loaded = !1, this.loading = !1;
        }
      };
    }(OpenSeadragon), function (t) {
      t.OverlayPlacement = t.Placement, t.OverlayRotationMode = t.freezeObject({
        NO_ROTATION: 1,
        EXACT: 2,
        BOUNDING_BOX: 3
      }), t.Overlay = function (e, n, r) {
        var i;
        i = t.isPlainObject(e) ? e : {
          element: e,
          location: n,
          placement: r
        }, this.element = i.element, this.style = i.element.style, this._init(i);
      }, t.Overlay.prototype = {
        _init: function _init(e) {
          this.location = e.location, this.placement = void 0 === e.placement ? t.Placement.TOP_LEFT : e.placement, this.onDraw = e.onDraw, this.checkResize = void 0 === e.checkResize || e.checkResize, this.width = void 0 === e.width ? null : e.width, this.height = void 0 === e.height ? null : e.height, this.rotationMode = e.rotationMode || t.OverlayRotationMode.EXACT, this.location instanceof t.Rect && (this.width = this.location.width, this.height = this.location.height, this.location = this.location.getTopLeft(), this.placement = t.Placement.TOP_LEFT), this.scales = null !== this.width && null !== this.height, this.bounds = new t.Rect(this.location.x, this.location.y, this.width, this.height), this.position = this.location;
        },
        adjust: function adjust(e, n) {
          var r = t.Placement.properties[this.placement];
          r && (r.isHorizontallyCentered ? e.x -= n.x / 2 : r.isRight && (e.x -= n.x), r.isVerticallyCentered ? e.y -= n.y / 2 : r.isBottom && (e.y -= n.y));
        },
        destroy: function destroy() {
          var e = this.element,
              n = this.style;
          e.parentNode && (e.parentNode.removeChild(e), e.prevElementParent && (n.display = "none", document.body.appendChild(e))), this.onDraw = null, n.top = "", n.left = "", n.position = "", null !== this.width && (n.width = ""), null !== this.height && (n.height = "");
          var r = t.getCssPropertyWithVendorPrefix("transformOrigin"),
              i = t.getCssPropertyWithVendorPrefix("transform");
          r && i && (n[r] = "", n[i] = "");
        },
        drawHTML: function drawHTML(e, n) {
          var r = this.element;
          r.parentNode !== e && (r.prevElementParent = r.parentNode, r.prevNextSibling = r.nextSibling, e.appendChild(r), this.size = t.getElementSize(r));

          var i = this._getOverlayPositionAndSize(n),
              o = i.position,
              a = this.size = i.size,
              s = i.rotate;

          if (this.onDraw) this.onDraw(o, a, this.element);else {
            var u = this.style;
            u.left = o.x + "px", u.top = o.y + "px", null !== this.width && (u.width = a.x + "px"), null !== this.height && (u.height = a.y + "px");
            var c = t.getCssPropertyWithVendorPrefix("transformOrigin"),
                l = t.getCssPropertyWithVendorPrefix("transform");
            c && l && (s ? (u[c] = this._getTransformOrigin(), u[l] = "rotate(" + s + "deg)") : (u[c] = "", u[l] = "")), u.position = "absolute", "none" !== u.display && (u.display = "block");
          }
        },
        _getOverlayPositionAndSize: function _getOverlayPositionAndSize(e) {
          var n = e.pixelFromPoint(this.location, !0),
              r = this._getSizeInPixels(e);

          this.adjust(n, r);
          var i = 0;
          if (e.degrees && this.rotationMode !== t.OverlayRotationMode.NO_ROTATION) if (this.rotationMode === t.OverlayRotationMode.BOUNDING_BOX && null !== this.width && null !== this.height) {
            var o = new t.Rect(n.x, n.y, r.x, r.y),
                a = this._getBoundingBox(o, e.degrees);

            n = a.getTopLeft(), r = a.getSize();
          } else i = e.degrees;
          return {
            position: n,
            size: r,
            rotate: i
          };
        },
        _getSizeInPixels: function _getSizeInPixels(e) {
          var n = this.size.x,
              r = this.size.y;

          if (null !== this.width || null !== this.height) {
            var i = e.deltaPixelsFromPointsNoRotate(new t.Point(this.width || 0, this.height || 0), !0);
            null !== this.width && (n = i.x), null !== this.height && (r = i.y);
          }

          if (this.checkResize && (null === this.width || null === this.height)) {
            var o = this.size = t.getElementSize(this.element);
            null === this.width && (n = o.x), null === this.height && (r = o.y);
          }

          return new t.Point(n, r);
        },
        _getBoundingBox: function _getBoundingBox(t, e) {
          var n = this._getPlacementPoint(t);

          return t.rotate(e, n).getBoundingBox();
        },
        _getPlacementPoint: function _getPlacementPoint(e) {
          var n = new t.Point(e.x, e.y),
              r = t.Placement.properties[this.placement];
          return r && (r.isHorizontallyCentered ? n.x += e.width / 2 : r.isRight && (n.x += e.width), r.isVerticallyCentered ? n.y += e.height / 2 : r.isBottom && (n.y += e.height)), n;
        },
        _getTransformOrigin: function _getTransformOrigin() {
          var e = "",
              n = t.Placement.properties[this.placement];
          return n ? (n.isLeft ? e = "left" : n.isRight && (e = "right"), n.isTop ? e += " top" : n.isBottom && (e += " bottom"), e) : e;
        },
        update: function update(e, n) {
          var r = t.isPlainObject(e) ? e : {
            location: e,
            placement: n
          };

          this._init({
            location: r.location || this.location,
            placement: void 0 !== r.placement ? r.placement : this.placement,
            onDraw: r.onDraw || this.onDraw,
            checkResize: r.checkResize || this.checkResize,
            width: void 0 !== r.width ? r.width : this.width,
            height: void 0 !== r.height ? r.height : this.height,
            rotationMode: r.rotationMode || this.rotationMode
          });
        },
        getBounds: function getBounds(e) {
          t.console.assert(e, "A viewport must now be passed to Overlay.getBounds.");
          var n = this.width,
              r = this.height;

          if (null === n || null === r) {
            var i = e.deltaPointsFromPixelsNoRotate(this.size, !0);
            null === n && (n = i.x), null === r && (r = i.y);
          }

          var o = this.location.clone();
          return this.adjust(o, new t.Point(n, r)), this._adjustBoundsForRotation(e, new t.Rect(o.x, o.y, n, r));
        },
        _adjustBoundsForRotation: function _adjustBoundsForRotation(e, n) {
          if (!e || 0 === e.degrees || this.rotationMode === t.OverlayRotationMode.EXACT) return n;

          if (this.rotationMode === t.OverlayRotationMode.BOUNDING_BOX) {
            if (null === this.width || null === this.height) return n;

            var r = this._getOverlayPositionAndSize(e);

            return e.viewerElementToViewportRectangle(new t.Rect(r.position.x, r.position.y, r.size.x, r.size.y));
          }

          return n.rotate(-e.degrees, this._getPlacementPoint(n));
        }
      };
    }(OpenSeadragon), function (t) {
      t.Drawer = function (e) {
        t.console.assert(e.viewer, "[Drawer] options.viewer is required");
        var n = arguments;

        if (t.isPlainObject(e) || (e = {
          source: n[0],
          viewport: n[1],
          element: n[2]
        }), t.console.assert(e.viewport, "[Drawer] options.viewport is required"), t.console.assert(e.element, "[Drawer] options.element is required"), e.source && t.console.error("[Drawer] options.source is no longer accepted; use TiledImage instead"), this.viewer = e.viewer, this.viewport = e.viewport, this.debugGridColor = e.debugGridColor || t.DEFAULT_SETTINGS.debugGridColor, e.opacity && t.console.error("[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead"), this.useCanvas = t.supportsCanvas && (!this.viewer || this.viewer.useCanvas), this.container = t.getElement(e.element), this.canvas = t.makeNeutralElement(this.useCanvas ? "canvas" : "div"), this.context = this.useCanvas ? this.canvas.getContext("2d") : null, this.sketchCanvas = null, this.sketchContext = null, this.element = this.container, this.container.dir = "ltr", this.useCanvas) {
          var r = this._calculateCanvasSize();

          this.canvas.width = r.x, this.canvas.height = r.y;
        }

        this.canvas.style.width = "100%", this.canvas.style.height = "100%", this.canvas.style.position = "absolute", t.setElementOpacity(this.canvas, this.opacity, !0), this.container.style.textAlign = "left", this.container.appendChild(this.canvas);
      }, t.Drawer.prototype = {
        addOverlay: function addOverlay(e, n, r, i) {
          return t.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead."), this.viewer.addOverlay(e, n, r, i), this;
        },
        updateOverlay: function updateOverlay(e, n, r) {
          return t.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead."), this.viewer.updateOverlay(e, n, r), this;
        },
        removeOverlay: function removeOverlay(e) {
          return t.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead."), this.viewer.removeOverlay(e), this;
        },
        clearOverlays: function clearOverlays() {
          return t.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead."), this.viewer.clearOverlays(), this;
        },
        setOpacity: function setOpacity(e) {
          t.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");

          for (var n = this.viewer.world, r = 0; r < n.getItemCount(); r++) {
            n.getItemAt(r).setOpacity(e);
          }

          return this;
        },
        getOpacity: function getOpacity() {
          t.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");

          for (var e = this.viewer.world, n = 0, r = 0; r < e.getItemCount(); r++) {
            var i = e.getItemAt(r).getOpacity();
            i > n && (n = i);
          }

          return n;
        },
        needsUpdate: function needsUpdate() {
          return t.console.error("[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead."), this.viewer.world.needsDraw();
        },
        numTilesLoaded: function numTilesLoaded() {
          return t.console.error("[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead."), this.viewer.tileCache.numTilesLoaded();
        },
        reset: function reset() {
          return t.console.error("[Drawer.reset] this function is deprecated. Use World.resetItems instead."), this.viewer.world.resetItems(), this;
        },
        update: function update() {
          return t.console.error("[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead."), this.clear(), this.viewer.world.draw(), this;
        },
        canRotate: function canRotate() {
          return this.useCanvas;
        },
        destroy: function destroy() {
          this.canvas.width = 1, this.canvas.height = 1, this.sketchCanvas = null, this.sketchContext = null;
        },
        clear: function clear() {
          if (this.canvas.innerHTML = "", this.useCanvas) {
            var t = this._calculateCanvasSize();

            if ((this.canvas.width != t.x || this.canvas.height != t.y) && (this.canvas.width = t.x, this.canvas.height = t.y, null !== this.sketchCanvas)) {
              var e = this._calculateSketchCanvasSize();

              this.sketchCanvas.width = e.x, this.sketchCanvas.height = e.y;
            }

            this._clear();
          }
        },
        _clear: function _clear(t, e) {
          if (this.useCanvas) {
            var n = this._getContext(t);

            if (e) n.clearRect(e.x, e.y, e.width, e.height);else {
              var r = n.canvas;
              n.clearRect(0, 0, r.width, r.height);
            }
          }
        },
        viewportToDrawerRectangle: function viewportToDrawerRectangle(e) {
          var n = this.viewport.pixelFromPointNoRotate(e.getTopLeft(), !0),
              r = this.viewport.deltaPixelsFromPointsNoRotate(e.getSize(), !0);
          return new t.Rect(n.x * t.pixelDensityRatio, n.y * t.pixelDensityRatio, r.x * t.pixelDensityRatio, r.y * t.pixelDensityRatio);
        },
        drawTile: function drawTile(e, n, r, i, o) {
          if (t.console.assert(e, "[Drawer.drawTile] tile is required"), t.console.assert(n, "[Drawer.drawTile] drawingHandler is required"), this.useCanvas) {
            var a = this._getContext(r);

            i = i || 1, e.drawCanvas(a, n, i, o);
          } else e.drawHTML(this.canvas);
        },
        _getContext: function _getContext(t) {
          var e = this.context;

          if (t) {
            if (null === this.sketchCanvas) {
              this.sketchCanvas = document.createElement("canvas");

              var n = this._calculateSketchCanvasSize();

              if (this.sketchCanvas.width = n.x, this.sketchCanvas.height = n.y, this.sketchContext = this.sketchCanvas.getContext("2d"), 0 === this.viewport.getRotation()) {
                var r = this;
                this.viewer.addHandler("rotate", function t() {
                  r.viewer.removeHandler("rotate", t);

                  var e = r._calculateSketchCanvasSize();

                  r.sketchCanvas.width = e.x, r.sketchCanvas.height = e.y;
                });
              }
            }

            e = this.sketchContext;
          }

          return e;
        },
        saveContext: function saveContext(t) {
          this.useCanvas && this._getContext(t).save();
        },
        restoreContext: function restoreContext(t) {
          this.useCanvas && this._getContext(t).restore();
        },
        setClip: function setClip(t, e) {
          if (this.useCanvas) {
            var n = this._getContext(e);

            n.beginPath(), n.rect(t.x, t.y, t.width, t.height), n.clip();
          }
        },
        drawRectangle: function drawRectangle(t, e, n) {
          if (this.useCanvas) {
            var r = this._getContext(n);

            r.save(), r.fillStyle = e, r.fillRect(t.x, t.y, t.width, t.height), r.restore();
          }
        },
        blendSketch: function blendSketch(e, n, r, i) {
          var o = e;

          if (t.isPlainObject(o) || (o = {
            opacity: e,
            scale: n,
            translate: r,
            compositeOperation: i
          }), this.useCanvas && this.sketchCanvas) {
            e = o.opacity, i = o.compositeOperation;
            var a = o.bounds;
            if (this.context.save(), this.context.globalAlpha = e, i && (this.context.globalCompositeOperation = i), a) this.context.drawImage(this.sketchCanvas, a.x, a.y, a.width, a.height, a.x, a.y, a.width, a.height);else {
              n = o.scale || 1, r = o.translate;
              var s = r instanceof t.Point ? r : new t.Point(0, 0),
                  u = 0,
                  c = 0;

              if (r) {
                var l = this.sketchCanvas.width - this.canvas.width,
                    h = this.sketchCanvas.height - this.canvas.height;
                u = Math.round(l / 2), c = Math.round(h / 2);
              }

              this.context.drawImage(this.sketchCanvas, s.x - u * n, s.y - c * n, (this.canvas.width + 2 * u) * n, (this.canvas.height + 2 * c) * n, -u, -c, this.canvas.width + 2 * u, this.canvas.height + 2 * c);
            }
            this.context.restore();
          }
        },
        drawDebugInfo: function drawDebugInfo(e, n, r) {
          if (this.useCanvas) {
            var i = this.context;
            i.save(), i.lineWidth = 2 * t.pixelDensityRatio, i.font = "small-caps bold " + 13 * t.pixelDensityRatio + "px arial", i.strokeStyle = this.debugGridColor, i.fillStyle = this.debugGridColor, 0 !== this.viewport.degrees && this._offsetForRotation(this.viewport.degrees), i.strokeRect(e.position.x * t.pixelDensityRatio, e.position.y * t.pixelDensityRatio, e.size.x * t.pixelDensityRatio, e.size.y * t.pixelDensityRatio);
            var o = (e.position.x + e.size.x / 2) * t.pixelDensityRatio,
                a = (e.position.y + e.size.y / 2) * t.pixelDensityRatio;
            i.translate(o, a), i.rotate(Math.PI / 180 * -this.viewport.degrees), i.translate(-o, -a), 0 === e.x && 0 === e.y && (i.fillText("Zoom: " + this.viewport.getZoom(), e.position.x * t.pixelDensityRatio, (e.position.y - 30) * t.pixelDensityRatio), i.fillText("Pan: " + this.viewport.getBounds().toString(), e.position.x * t.pixelDensityRatio, (e.position.y - 20) * t.pixelDensityRatio)), i.fillText("Level: " + e.level, (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 20) * t.pixelDensityRatio), i.fillText("Column: " + e.x, (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 30) * t.pixelDensityRatio), i.fillText("Row: " + e.y, (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 40) * t.pixelDensityRatio), i.fillText("Order: " + r + " of " + n, (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 50) * t.pixelDensityRatio), i.fillText("Size: " + e.size.toString(), (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 60) * t.pixelDensityRatio), i.fillText("Position: " + e.position.toString(), (e.position.x + 10) * t.pixelDensityRatio, (e.position.y + 70) * t.pixelDensityRatio), 0 !== this.viewport.degrees && this._restoreRotationChanges(), i.restore();
          }
        },
        debugRect: function debugRect(e) {
          if (this.useCanvas) {
            var n = this.context;
            n.save(), n.lineWidth = 2 * t.pixelDensityRatio, n.strokeStyle = this.debugGridColor, n.fillStyle = this.debugGridColor, n.strokeRect(e.x * t.pixelDensityRatio, e.y * t.pixelDensityRatio, e.width * t.pixelDensityRatio, e.height * t.pixelDensityRatio), n.restore();
          }
        },
        getCanvasSize: function getCanvasSize(e) {
          var n = this._getContext(e).canvas;

          return new t.Point(n.width, n.height);
        },
        _offsetForRotation: function _offsetForRotation(t, e) {
          var n = this.canvas.width / 2,
              r = this.canvas.height / 2,
              i = this._getContext(e);

          i.save(), i.translate(n, r), i.rotate(Math.PI / 180 * t), i.translate(-n, -r);
        },
        _restoreRotationChanges: function _restoreRotationChanges(t) {
          var e = this._getContext(t);

          e.restore();
        },
        _calculateCanvasSize: function _calculateCanvasSize() {
          var e = t.pixelDensityRatio,
              n = this.viewport.getContainerSize();
          return {
            x: n.x * e,
            y: n.y * e
          };
        },
        _calculateSketchCanvasSize: function _calculateSketchCanvasSize() {
          var t = this._calculateCanvasSize();

          if (0 === this.viewport.getRotation()) return t;
          var e = Math.ceil(Math.sqrt(t.x * t.x + t.y * t.y));
          return {
            x: e,
            y: e
          };
        }
      };
    }(OpenSeadragon), function (t) {
      t.Viewport = function (e) {
        var n = arguments;
        n.length && n[0] instanceof t.Point && (e = {
          containerSize: n[0],
          contentSize: n[1],
          config: n[2]
        }), e.config && (t.extend(!0, e, e.config), delete e.config), this._margins = t.extend({
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }, e.margins || {}), delete e.margins, t.extend(!0, this, {
          containerSize: null,
          contentSize: null,
          zoomPoint: null,
          viewer: null,
          springStiffness: t.DEFAULT_SETTINGS.springStiffness,
          animationTime: t.DEFAULT_SETTINGS.animationTime,
          minZoomImageRatio: t.DEFAULT_SETTINGS.minZoomImageRatio,
          maxZoomPixelRatio: t.DEFAULT_SETTINGS.maxZoomPixelRatio,
          visibilityRatio: t.DEFAULT_SETTINGS.visibilityRatio,
          wrapHorizontal: t.DEFAULT_SETTINGS.wrapHorizontal,
          wrapVertical: t.DEFAULT_SETTINGS.wrapVertical,
          defaultZoomLevel: t.DEFAULT_SETTINGS.defaultZoomLevel,
          minZoomLevel: t.DEFAULT_SETTINGS.minZoomLevel,
          maxZoomLevel: t.DEFAULT_SETTINGS.maxZoomLevel,
          degrees: t.DEFAULT_SETTINGS.degrees,
          homeFillsViewer: t.DEFAULT_SETTINGS.homeFillsViewer
        }, e), this._updateContainerInnerSize(), this.centerSpringX = new t.Spring({
          initial: 0,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this.centerSpringY = new t.Spring({
          initial: 0,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this.zoomSpring = new t.Spring({
          exponential: !0,
          initial: 1,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, this._setContentBounds(new t.Rect(0, 0, 1, 1), 1), this.goHome(!0), this.update();
      }, t.Viewport.prototype = {
        resetContentSize: function resetContentSize(e) {
          return t.console.assert(e, "[Viewport.resetContentSize] contentSize is required"), t.console.assert(e instanceof t.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point"), t.console.assert(e.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0"), t.console.assert(e.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0"), this._setContentBounds(new t.Rect(0, 0, 1, e.y / e.x), e.x), this;
        },
        setHomeBounds: function setHomeBounds(e, n) {
          t.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually."), this._setContentBounds(e, n);
        },
        _setContentBounds: function _setContentBounds(e, n) {
          t.console.assert(e, "[Viewport._setContentBounds] bounds is required"), t.console.assert(e instanceof t.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect"), t.console.assert(e.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0"), t.console.assert(e.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0"), this._contentBoundsNoRotate = e.clone(), this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(n), this._contentBounds = e.rotate(this.degrees).getBoundingBox(), this._contentSize = this._contentBounds.getSize().times(n), this._contentAspectRatio = this._contentSize.x / this._contentSize.y, this.viewer && this.viewer.raiseEvent("reset-size", {
            contentSize: this._contentSizeNoRotate.clone(),
            contentFactor: n,
            homeBounds: this._contentBoundsNoRotate.clone(),
            contentBounds: this._contentBounds.clone()
          });
        },
        getHomeZoom: function getHomeZoom() {
          if (this.defaultZoomLevel) return this.defaultZoomLevel;
          var t,
              e = this._contentAspectRatio / this.getAspectRatio();
          return t = this.homeFillsViewer ? e >= 1 ? e : 1 : e >= 1 ? 1 : e, t / this._contentBounds.width;
        },
        getHomeBounds: function getHomeBounds() {
          return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
        },
        getHomeBoundsNoRotate: function getHomeBoundsNoRotate() {
          var e = this._contentBounds.getCenter(),
              n = 1 / this.getHomeZoom(),
              r = n / this.getAspectRatio();

          return new t.Rect(e.x - n / 2, e.y - r / 2, n, r);
        },
        goHome: function goHome(t) {
          return this.viewer && this.viewer.raiseEvent("home", {
            immediately: t
          }), this.fitBounds(this.getHomeBounds(), t);
        },
        getMinZoom: function getMinZoom() {
          var t = this.getHomeZoom(),
              e = this.minZoomLevel ? this.minZoomLevel : this.minZoomImageRatio * t;
          return e;
        },
        getMaxZoom: function getMaxZoom() {
          var t = this.maxZoomLevel;
          return t || (t = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x, t /= this._contentBounds.width), Math.max(t, this.getHomeZoom());
        },
        getAspectRatio: function getAspectRatio() {
          return this._containerInnerSize.x / this._containerInnerSize.y;
        },
        getContainerSize: function getContainerSize() {
          return new t.Point(this.containerSize.x, this.containerSize.y);
        },
        getMargins: function getMargins() {
          return t.extend({}, this._margins);
        },
        setMargins: function setMargins(e) {
          t.console.assert("object" === t.type(e), "[Viewport.setMargins] margins must be an object"), this._margins = t.extend({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          }, e), this._updateContainerInnerSize(), this.viewer && this.viewer.forceRedraw();
        },
        getBounds: function getBounds(t) {
          return this.getBoundsNoRotate(t).rotate(-this.getRotation());
        },
        getBoundsNoRotate: function getBoundsNoRotate(e) {
          var n = this.getCenter(e),
              r = 1 / this.getZoom(e),
              i = r / this.getAspectRatio();
          return new t.Rect(n.x - r / 2, n.y - i / 2, r, i);
        },
        getBoundsWithMargins: function getBoundsWithMargins(t) {
          return this.getBoundsNoRotateWithMargins(t).rotate(-this.getRotation(), this.getCenter(t));
        },
        getBoundsNoRotateWithMargins: function getBoundsNoRotateWithMargins(t) {
          var e = this.getBoundsNoRotate(t),
              n = this._containerInnerSize.x * this.getZoom(t);
          return e.x -= this._margins.left / n, e.y -= this._margins.top / n, e.width += (this._margins.left + this._margins.right) / n, e.height += (this._margins.top + this._margins.bottom) / n, e;
        },
        getCenter: function getCenter(e) {
          var n,
              r,
              i,
              o,
              a,
              s,
              u,
              c,
              l = new t.Point(this.centerSpringX.current.value, this.centerSpringY.current.value),
              h = new t.Point(this.centerSpringX.target.value, this.centerSpringY.target.value);
          return e ? l : this.zoomPoint ? (n = this.pixelFromPoint(this.zoomPoint, !0), r = this.getZoom(), i = 1 / r, o = i / this.getAspectRatio(), a = new t.Rect(l.x - i / 2, l.y - o / 2, i, o), s = this._pixelFromPoint(this.zoomPoint, a), u = s.minus(n), c = u.divide(this._containerInnerSize.x * r), h.plus(c)) : h;
        },
        getZoom: function getZoom(t) {
          return t ? this.zoomSpring.current.value : this.zoomSpring.target.value;
        },
        _applyZoomConstraints: function _applyZoomConstraints(t) {
          return Math.max(Math.min(t, this.getMaxZoom()), this.getMinZoom());
        },
        _applyBoundaryConstraints: function _applyBoundaryConstraints(e, n) {
          var r = new t.Rect(e.x, e.y, e.width, e.height);
          if (this.wrapHorizontal) ;else {
            var i = this.visibilityRatio * r.width,
                o = r.x + r.width,
                a = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width,
                s = this._contentBoundsNoRotate.x - o + i,
                u = a - r.x - i;
            i > this._contentBoundsNoRotate.width ? r.x += (s + u) / 2 : u < 0 ? r.x += u : s > 0 && (r.x += s);
          }
          if (this.wrapVertical) ;else {
            var c = this.visibilityRatio * r.height,
                l = r.y + r.height,
                h = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height,
                f = this._contentBoundsNoRotate.y - l + c,
                p = h - r.y - c;
            c > this._contentBoundsNoRotate.height ? r.y += (f + p) / 2 : p < 0 ? r.y += p : f > 0 && (r.y += f);
          }
          return this.viewer && this.viewer.raiseEvent("constrain", {
            immediately: n
          }), r;
        },
        applyConstraints: function applyConstraints(t) {
          var e = this.getZoom(),
              n = this._applyZoomConstraints(e);

          e !== n && this.zoomTo(n, this.zoomPoint, t);

          var r = this.getBoundsNoRotate(),
              i = this._applyBoundaryConstraints(r, t);

          return (r.x !== i.x || r.y !== i.y || t) && this.fitBounds(i.rotate(-this.getRotation()), t), this;
        },
        ensureVisible: function ensureVisible(t) {
          return this.applyConstraints(t);
        },
        _fitBounds: function _fitBounds(e, n) {
          n = n || {};
          var r = n.immediately || !1,
              i = n.constraints || !1,
              o = this.getAspectRatio(),
              a = e.getCenter(),
              s = new t.Rect(e.x, e.y, e.width, e.height, e.degrees + this.getRotation()).getBoundingBox();
          s.getAspectRatio() >= o ? s.height = s.width / o : s.width = s.height * o, s.x = a.x - s.width / 2, s.y = a.y - s.height / 2;
          var u = 1 / s.width;

          if (i) {
            var c = s.getAspectRatio(),
                l = this._applyZoomConstraints(u);

            u !== l && (u = l, s.width = 1 / u, s.x = a.x - s.width / 2, s.height = s.width / c, s.y = a.y - s.height / 2), s = this._applyBoundaryConstraints(s, r), a = s.getCenter();
          }

          if (r) return this.panTo(a, !0), this.zoomTo(u, null, !0);
          this.panTo(this.getCenter(!0), !0), this.zoomTo(this.getZoom(!0), null, !0);
          var h = this.getBounds(),
              f = this.getZoom();
          if (0 === f || Math.abs(u / f - 1) < 1e-8) return this.zoomTo(u, !0), this.panTo(a, r);
          s = s.rotate(-this.getRotation());
          var p = s.getTopLeft().times(u).minus(h.getTopLeft().times(f)).divide(u - f);
          return this.zoomTo(u, p, r);
        },
        fitBounds: function fitBounds(t, e) {
          return this._fitBounds(t, {
            immediately: e,
            constraints: !1
          });
        },
        fitBoundsWithConstraints: function fitBoundsWithConstraints(t, e) {
          return this._fitBounds(t, {
            immediately: e,
            constraints: !0
          });
        },
        fitVertically: function fitVertically(e) {
          var n = new t.Rect(this._contentBounds.x + this._contentBounds.width / 2, this._contentBounds.y, 0, this._contentBounds.height);
          return this.fitBounds(n, e);
        },
        fitHorizontally: function fitHorizontally(e) {
          var n = new t.Rect(this._contentBounds.x, this._contentBounds.y + this._contentBounds.height / 2, this._contentBounds.width, 0);
          return this.fitBounds(n, e);
        },
        panBy: function panBy(e, n) {
          var r = new t.Point(this.centerSpringX.target.value, this.centerSpringY.target.value);
          return this.panTo(r.plus(e), n);
        },
        panTo: function panTo(t, e) {
          return e ? (this.centerSpringX.resetTo(t.x), this.centerSpringY.resetTo(t.y)) : (this.centerSpringX.springTo(t.x), this.centerSpringY.springTo(t.y)), this.viewer && this.viewer.raiseEvent("pan", {
            center: t,
            immediately: e
          }), this;
        },
        zoomBy: function zoomBy(t, e, n) {
          return this.zoomTo(this.zoomSpring.target.value * t, e, n);
        },
        zoomTo: function zoomTo(e, n, r) {
          return this.zoomPoint = n instanceof t.Point && !isNaN(n.x) && !isNaN(n.y) ? n : null, r ? this.zoomSpring.resetTo(e) : this.zoomSpring.springTo(e), this.viewer && this.viewer.raiseEvent("zoom", {
            zoom: e,
            refPoint: n,
            immediately: r
          }), this;
        },
        setRotation: function setRotation(t) {
          return this.viewer && this.viewer.drawer.canRotate() ? (t %= 360, t < 0 && (t += 360), this.degrees = t, this._setContentBounds(this.viewer.world.getHomeBounds(), this.viewer.world.getContentFactor()), this.viewer.forceRedraw(), this.viewer.raiseEvent("rotate", {
            degrees: t
          }), this) : this;
        },
        getRotation: function getRotation() {
          return this.degrees;
        },
        resize: function resize(t, e) {
          var n,
              r = this.getBoundsNoRotate(),
              i = r;
          return this.containerSize.x = t.x, this.containerSize.y = t.y, this._updateContainerInnerSize(), e && (n = t.x / this.containerSize.x, i.width = r.width * n, i.height = i.width / this.getAspectRatio()), this.viewer && this.viewer.raiseEvent("resize", {
            newContainerSize: t,
            maintain: e
          }), this.fitBounds(i, !0);
        },
        _updateContainerInnerSize: function _updateContainerInnerSize() {
          this._containerInnerSize = new t.Point(Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)), Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom)));
        },
        update: function update() {
          if (this.zoomPoint) {
            var t = this.pixelFromPoint(this.zoomPoint, !0);
            this.zoomSpring.update();
            var e = this.pixelFromPoint(this.zoomPoint, !0),
                n = e.minus(t),
                r = this.deltaPointsFromPixels(n, !0);
            this.centerSpringX.shiftBy(r.x), this.centerSpringY.shiftBy(r.y), this.zoomSpring.isAtTargetValue() && (this.zoomPoint = null);
          } else this.zoomSpring.update();

          this.centerSpringX.update(), this.centerSpringY.update();
          var i = this.centerSpringX.current.value !== this._oldCenterX || this.centerSpringY.current.value !== this._oldCenterY || this.zoomSpring.current.value !== this._oldZoom;
          return this._oldCenterX = this.centerSpringX.current.value, this._oldCenterY = this.centerSpringY.current.value, this._oldZoom = this.zoomSpring.current.value, i;
        },
        deltaPixelsFromPointsNoRotate: function deltaPixelsFromPointsNoRotate(t, e) {
          return t.times(this._containerInnerSize.x * this.getZoom(e));
        },
        deltaPixelsFromPoints: function deltaPixelsFromPoints(t, e) {
          return this.deltaPixelsFromPointsNoRotate(t.rotate(this.getRotation()), e);
        },
        deltaPointsFromPixelsNoRotate: function deltaPointsFromPixelsNoRotate(t, e) {
          return t.divide(this._containerInnerSize.x * this.getZoom(e));
        },
        deltaPointsFromPixels: function deltaPointsFromPixels(t, e) {
          return this.deltaPointsFromPixelsNoRotate(t, e).rotate(-this.getRotation());
        },
        pixelFromPointNoRotate: function pixelFromPointNoRotate(t, e) {
          return this._pixelFromPointNoRotate(t, this.getBoundsNoRotate(e));
        },
        pixelFromPoint: function pixelFromPoint(t, e) {
          return this._pixelFromPoint(t, this.getBoundsNoRotate(e));
        },
        _pixelFromPointNoRotate: function _pixelFromPointNoRotate(e, n) {
          return e.minus(n.getTopLeft()).times(this._containerInnerSize.x / n.width).plus(new t.Point(this._margins.left, this._margins.top));
        },
        _pixelFromPoint: function _pixelFromPoint(t, e) {
          return this._pixelFromPointNoRotate(t.rotate(this.getRotation(), this.getCenter(!0)), e);
        },
        pointFromPixelNoRotate: function pointFromPixelNoRotate(e, n) {
          var r = this.getBoundsNoRotate(n);
          return e.minus(new t.Point(this._margins.left, this._margins.top)).divide(this._containerInnerSize.x / r.width).plus(r.getTopLeft());
        },
        pointFromPixel: function pointFromPixel(t, e) {
          return this.pointFromPixelNoRotate(t, e).rotate(-this.getRotation(), this.getCenter(!0));
        },
        _viewportToImageDelta: function _viewportToImageDelta(e, n) {
          var r = this._contentBoundsNoRotate.width;
          return new t.Point(e * this._contentSizeNoRotate.x / r, n * this._contentSizeNoRotate.x / r);
        },
        viewportToImageCoordinates: function viewportToImageCoordinates(e, n) {
          if (e instanceof t.Point) return this.viewportToImageCoordinates(e.x, e.y);

          if (this.viewer) {
            var r = this.viewer.world.getItemCount();
            if (r > 1) t.console.error("[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.");else if (1 === r) {
              var i = this.viewer.world.getItemAt(0);
              return i.viewportToImageCoordinates(e, n, !0);
            }
          }

          return this._viewportToImageDelta(e - this._contentBoundsNoRotate.x, n - this._contentBoundsNoRotate.y);
        },
        _imageToViewportDelta: function _imageToViewportDelta(e, n) {
          var r = this._contentBoundsNoRotate.width;
          return new t.Point(e / this._contentSizeNoRotate.x * r, n / this._contentSizeNoRotate.x * r);
        },
        imageToViewportCoordinates: function imageToViewportCoordinates(e, n) {
          if (e instanceof t.Point) return this.imageToViewportCoordinates(e.x, e.y);

          if (this.viewer) {
            var r = this.viewer.world.getItemCount();
            if (r > 1) t.console.error("[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.");else if (1 === r) {
              var i = this.viewer.world.getItemAt(0);
              return i.imageToViewportCoordinates(e, n, !0);
            }
          }

          var o = this._imageToViewportDelta(e, n);

          return o.x += this._contentBoundsNoRotate.x, o.y += this._contentBoundsNoRotate.y, o;
        },
        imageToViewportRectangle: function imageToViewportRectangle(e, n, r, i) {
          var o = e;

          if (o instanceof t.Rect || (o = new t.Rect(e, n, r, i)), this.viewer) {
            var a = this.viewer.world.getItemCount();
            if (a > 1) t.console.error("[Viewport.imageToViewportRectangle] is not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.");else if (1 === a) {
              var s = this.viewer.world.getItemAt(0);
              return s.imageToViewportRectangle(e, n, r, i, !0);
            }
          }

          var u = this.imageToViewportCoordinates(o.x, o.y),
              c = this._imageToViewportDelta(o.width, o.height);

          return new t.Rect(u.x, u.y, c.x, c.y, o.degrees);
        },
        viewportToImageRectangle: function viewportToImageRectangle(e, n, r, i) {
          var o = e;

          if (o instanceof t.Rect || (o = new t.Rect(e, n, r, i)), this.viewer) {
            var a = this.viewer.world.getItemCount();
            if (a > 1) t.console.error("[Viewport.viewportToImageRectangle] is not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.");else if (1 === a) {
              var s = this.viewer.world.getItemAt(0);
              return s.viewportToImageRectangle(e, n, r, i, !0);
            }
          }

          var u = this.viewportToImageCoordinates(o.x, o.y),
              c = this._viewportToImageDelta(o.width, o.height);

          return new t.Rect(u.x, u.y, c.x, c.y, o.degrees);
        },
        viewerElementToImageCoordinates: function viewerElementToImageCoordinates(t) {
          var e = this.pointFromPixel(t, !0);
          return this.viewportToImageCoordinates(e);
        },
        imageToViewerElementCoordinates: function imageToViewerElementCoordinates(t) {
          var e = this.imageToViewportCoordinates(t);
          return this.pixelFromPoint(e, !0);
        },
        windowToImageCoordinates: function windowToImageCoordinates(e) {
          t.console.assert(this.viewer, "[Viewport.windowToImageCoordinates] the viewport must have a viewer.");
          var n = e.minus(t.getElementPosition(this.viewer.element));
          return this.viewerElementToImageCoordinates(n);
        },
        imageToWindowCoordinates: function imageToWindowCoordinates(e) {
          t.console.assert(this.viewer, "[Viewport.imageToWindowCoordinates] the viewport must have a viewer.");
          var n = this.imageToViewerElementCoordinates(e);
          return n.plus(t.getElementPosition(this.viewer.element));
        },
        viewerElementToViewportCoordinates: function viewerElementToViewportCoordinates(t) {
          return this.pointFromPixel(t, !0);
        },
        viewportToViewerElementCoordinates: function viewportToViewerElementCoordinates(t) {
          return this.pixelFromPoint(t, !0);
        },
        viewerElementToViewportRectangle: function viewerElementToViewportRectangle(e) {
          return t.Rect.fromSummits(this.pointFromPixel(e.getTopLeft(), !0), this.pointFromPixel(e.getTopRight(), !0), this.pointFromPixel(e.getBottomLeft(), !0));
        },
        viewportToViewerElementRectangle: function viewportToViewerElementRectangle(e) {
          return t.Rect.fromSummits(this.pixelFromPoint(e.getTopLeft(), !0), this.pixelFromPoint(e.getTopRight(), !0), this.pixelFromPoint(e.getBottomLeft(), !0));
        },
        windowToViewportCoordinates: function windowToViewportCoordinates(e) {
          t.console.assert(this.viewer, "[Viewport.windowToViewportCoordinates] the viewport must have a viewer.");
          var n = e.minus(t.getElementPosition(this.viewer.element));
          return this.viewerElementToViewportCoordinates(n);
        },
        viewportToWindowCoordinates: function viewportToWindowCoordinates(e) {
          t.console.assert(this.viewer, "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer.");
          var n = this.viewportToViewerElementCoordinates(e);
          return n.plus(t.getElementPosition(this.viewer.element));
        },
        viewportToImageZoom: function viewportToImageZoom(e) {
          if (this.viewer) {
            var n = this.viewer.world.getItemCount();
            if (n > 1) t.console.error("[Viewport.viewportToImageZoom] is not accurate with multi-image.");else if (1 === n) {
              var r = this.viewer.world.getItemAt(0);
              return r.viewportToImageZoom(e);
            }
          }

          var i = this._contentSizeNoRotate.x,
              o = this._containerInnerSize.x,
              a = this._contentBoundsNoRotate.width,
              s = o / i * a;
          return e * s;
        },
        imageToViewportZoom: function imageToViewportZoom(e) {
          if (this.viewer) {
            var n = this.viewer.world.getItemCount();
            if (n > 1) t.console.error("[Viewport.imageToViewportZoom] is not accurate with multi-image.");else if (1 === n) {
              var r = this.viewer.world.getItemAt(0);
              return r.imageToViewportZoom(e);
            }
          }

          var i = this._contentSizeNoRotate.x,
              o = this._containerInnerSize.x,
              a = this._contentBoundsNoRotate.width,
              s = i / o / a;
          return e * s;
        }
      };
    }(OpenSeadragon), function (t) {
      function e(e) {
        e._needsDraw = !1;

        for (var r, i, a, s, u, c, h, f, p = null, m = !1, g = t.now(), v = e.viewport.getBoundsWithMargins(!0), y = e.viewport.deltaPixelsFromPointsNoRotate(e.source.getPixelRatio(0), !0).x * e._scaleSpring.current.value, x = Math.max(e.source.minLevel, Math.floor(Math.log(e.minZoomImageRatio) / Math.log(2))), w = Math.min(Math.abs(e.source.maxLevel), Math.abs(Math.floor(Math.log(y / e.minPixelRatio) / Math.log(2)))); e.lastDrawn.length > 0;) {
          r = e.lastDrawn.pop(), r.beingDrawn = !1;
        }

        if (!e.wrapHorizontal && !e.wrapVertical) {
          var b = e.getClippedBounds(!0),
              _ = v.intersection(b);

          if (null === _) return;
          v = _;
        }

        v = v.getBoundingBox(), v.x -= e._xSpring.current.value, v.y -= e._ySpring.current.value;
        var E = v.getTopLeft(),
            M = v.getBottomRight();

        if ((e.wrapHorizontal || !(M.x < 0 || E.x > e._worldWidthCurrent)) && (e.wrapVertical || !(M.y < 0 || E.y > e._worldHeightCurrent))) {
          e.wrapHorizontal || (E.x = Math.max(E.x, 0), M.x = Math.min(M.x, e._worldWidthCurrent)), e.wrapVertical || (E.y = Math.max(E.y, 0), M.y = Math.min(M.y, e._worldHeightCurrent)), x = Math.min(x, w);
          var T;

          for (i = w; i >= x; i--) {
            if (T = !1, a = e.viewport.deltaPixelsFromPointsNoRotate(e.source.getPixelRatio(i), !0).x * e._scaleSpring.current.value, !m && a >= e.minPixelRatio || i == x) T = !0, m = !0;else if (!m) continue;
            if (s = e.viewport.deltaPixelsFromPointsNoRotate(e.source.getPixelRatio(i), !1).x * e._scaleSpring.current.value, u = e.viewport.deltaPixelsFromPointsNoRotate(e.source.getPixelRatio(Math.max(e.source.getClosestLevel(e.viewport.containerSize) - 1, 0)), !1).x * e._scaleSpring.current.value, c = e.immediateRender ? 1 : u, h = Math.min(1, (a - .5) / .5), f = c / Math.abs(c - s), p = n(e, m, T, i, h, f, E, M, g, p), l(e.coverage, i)) break;
          }

          d(e, e.lastDrawn), p && !p.context2D && o(e, p, g);
        }
      }

      function n(t, e, n, i, o, a, s, u, c, l) {
        var h,
            f,
            m,
            d,
            g,
            v = t.viewport.pixelFromPoint(t.viewport.getCenter());

        for (t.viewer && t.viewer.raiseEvent("update-level", {
          tiledImage: t,
          havedrawn: e,
          level: i,
          opacity: o,
          visibility: a,
          topleft: s,
          bottomright: u,
          currenttime: c,
          best: l
        }), m = t.source.getTileAtPoint(i, s.divide(t._scaleSpring.current.value)), d = t.source.getTileAtPoint(i, u.divide(t._scaleSpring.current.value)), g = t.source.getNumTiles(i), p(t.coverage, i), t.wrapHorizontal || (d.x = Math.min(d.x, g.x - 1)), t.wrapVertical || (d.y = Math.min(d.y, g.y - 1)), h = m.x; h <= d.x; h++) {
          for (f = m.y; f <= d.y; f++) {
            l = r(t, n, e, h, f, i, o, a, v, g, c, l);
          }
        }

        return l;
      }

      function r(t, e, n, r, o, a, l, p, d, g, v, y) {
        var x = i(r, o, a, t.source, t.tilesMatrix, v, g, t._worldWidthCurrent, t._worldHeightCurrent),
            w = e;
        if (t.viewer && t.viewer.raiseEvent("update-tile", {
          tiledImage: t,
          tile: x
        }), f(t.coverage, a, r, o, !1), !x.exists) return y;
        if (n && !w && (h(t.coverage, a, r, o) ? f(t.coverage, a, r, o, !0) : w = !0), !w) return y;
        if (u(x, t.source.tileOverlap, t.viewport, d, p, t), !x.loaded) if (x.context2D) s(t, x);else {
          var b = t._tileCache.getImageRecord(x.url);

          if (b) {
            var _ = b.getImage();

            s(t, x, _);
          }
        }

        if (x.loaded) {
          var E = c(t, x, r, o, a, l, v);
          E && (t._needsDraw = !0);
        } else x.loading || (y = m(y, x));

        return y;
      }

      function i(e, n, r, i, o, a, s, u, c) {
        var l, h, f, p, m, d, g;
        return o[r] || (o[r] = {}), o[r][e] || (o[r][e] = {}), o[r][e][n] || (l = (s.x + e % s.x) % s.x, h = (s.y + n % s.y) % s.y, f = i.getTileBounds(r, l, h), p = i.tileExists(r, l, h), m = i.getTileUrl(r, l, h), d = i.getContext2D ? i.getContext2D(r, l, h) : void 0, f.x += (e - l) / s.x, f.y += c / u * ((n - h) / s.y), o[r][e][n] = new t.Tile(r, e, n, f, p, m, d)), g = o[r][e][n], g.lastTouchTime = a, g;
      }

      function o(t, e, n) {
        e.loading = !0, t._imageLoader.addJob({
          src: e.url,
          crossOriginPolicy: t.crossOriginPolicy,
          callback: function callback(r, i) {
            a(t, e, n, r, i);
          },
          abort: function abort() {
            e.loading = !1;
          }
        });
      }

      function a(e, n, r, i, o) {
        if (!i) return t.console.log("Tile %s failed to load: %s - error: %s", n, n.url, o), e.viewer.raiseEvent("tile-load-failed", {
          tile: n,
          tiledImage: e,
          time: r,
          message: o
        }), n.loading = !1, void (n.exists = !1);
        if (r < e.lastResetTime) return t.console.log("Ignoring tile %s loaded before reset: %s", n, n.url), void (n.loading = !1);

        var a = function a() {
          var t = Math.ceil(Math.log(e.source.getTileWidth(n.level)) / Math.log(2));
          s(e, n, i, t);
        };

        e._midDraw ? window.setTimeout(a, 1) : a();
      }

      function s(t, e, n, r) {
        function i() {
          return a++, o;
        }

        function o() {
          a--, 0 === a && (e.loading = !1, e.loaded = !0, e.context2D || t._tileCache.cacheTile({
            image: n,
            tile: e,
            cutoff: r,
            tiledImage: t
          }), t._needsDraw = !0);
        }

        var a = 0;
        t.viewer.raiseEvent("tile-loaded", {
          tile: e,
          tiledImage: t,
          image: n,
          getCompletionCallback: i
        }), i()();
      }

      function u(e, n, r, i, o, a) {
        var s = e.bounds.getTopLeft();
        s.x *= a._scaleSpring.current.value, s.y *= a._scaleSpring.current.value, s.x += a._xSpring.current.value, s.y += a._ySpring.current.value;
        var u = e.bounds.getSize();
        u.x *= a._scaleSpring.current.value, u.y *= a._scaleSpring.current.value;
        var c = r.pixelFromPointNoRotate(s, !0),
            l = r.pixelFromPointNoRotate(s, !1),
            h = r.deltaPixelsFromPointsNoRotate(u, !0),
            f = r.deltaPixelsFromPointsNoRotate(u, !1),
            p = l.plus(f.divide(2)),
            m = i.distanceTo(p);
        n || (h = h.plus(new t.Point(1, 1))), e.position = c, e.size = h, e.distance = m, e.visibility = o;
      }

      function c(t, e, n, r, i, o, a) {
        var s,
            u,
            c = 1e3 * t.blendTime;
        if (e.blendStart || (e.blendStart = a), s = a - e.blendStart, u = c ? Math.min(1, s / c) : 1, t.alwaysBlend && (u *= o), e.opacity = u, t.lastDrawn.push(e), 1 == u) f(t.coverage, i, n, r, !0), t._hasOpaqueTile = !0;else if (s < c) return !0;
        return !1;
      }

      function l(t, e, n, r) {
        var i, o, a, s;
        if (!t[e]) return !1;

        if (void 0 === n || void 0 === r) {
          i = t[e];

          for (a in i) {
            if (i.hasOwnProperty(a)) {
              o = i[a];

              for (s in o) {
                if (o.hasOwnProperty(s) && !o[s]) return !1;
              }
            }
          }

          return !0;
        }

        return void 0 === t[e][n] || void 0 === t[e][n][r] || t[e][n][r] === !0;
      }

      function h(t, e, n, r) {
        return void 0 === n || void 0 === r ? l(t, e + 1) : l(t, e + 1, 2 * n, 2 * r) && l(t, e + 1, 2 * n, 2 * r + 1) && l(t, e + 1, 2 * n + 1, 2 * r) && l(t, e + 1, 2 * n + 1, 2 * r + 1);
      }

      function f(e, n, r, i, o) {
        return e[n] ? (e[n][r] || (e[n][r] = {}), void (e[n][r][i] = o)) : void t.console.warn("Setting coverage for a tile before its level's coverage has been reset: %s", n);
      }

      function p(t, e) {
        t[e] = {};
      }

      function m(t, e) {
        return t ? e.visibility > t.visibility ? e : e.visibility == t.visibility && e.distance < t.distance ? e : t : e;
      }

      function d(e, n) {
        if (0 !== n.length) {
          var r,
              i,
              o = n[0],
              a = e.opacity < 1 || e.compositeOperation && "source-over" !== e.compositeOperation || !e._isBottomItem() && o._hasTransparencyChannel(),
              s = e.viewport.getZoom(!0),
              u = e.viewportToImageZoom(s);

          u > e.smoothTileEdgesMinZoom && !e.iOSDevice && (a = !0, r = o.getScaleForEdgeSmoothing(), i = o.getTranslationForEdgeSmoothing(r, e._drawer.getCanvasSize(!1), e._drawer.getCanvasSize(!0)));
          var c;
          a && (r || (c = e.viewport.viewportToViewerElementRectangle(e.getClippedBounds(!0)).getIntegerBoundingBox().times(t.pixelDensityRatio)), e._drawer._clear(!0, c)), 0 === e.viewport.degrees || r || e._drawer._offsetForRotation(e.viewport.degrees, a);
          var l = !1;

          if (e._clip) {
            e._drawer.saveContext(a);

            var h = e.imageToViewportRectangle(e._clip, !0),
                f = e._drawer.viewportToDrawerRectangle(h);

            r && (f = f.times(r)), i && (f = f.translate(i)), e._drawer.setClip(f, a), l = !0;
          }

          if (e.placeholderFillStyle && e._hasOpaqueTile === !1) {
            var p = e._drawer.viewportToDrawerRectangle(e.getBounds(!0));

            r && (p = p.times(r)), i && (p = p.translate(i));
            var m = null;
            m = "function" == typeof e.placeholderFillStyle ? e.placeholderFillStyle(e, e._drawer.context) : e.placeholderFillStyle, e._drawer.drawRectangle(p, m, a);
          }

          for (var d = n.length - 1; d >= 0; d--) {
            o = n[d], e._drawer.drawTile(o, e._drawingHandler, a, r, i), o.beingDrawn = !0, e.viewer && e.viewer.raiseEvent("tile-drawn", {
              tiledImage: e,
              tile: o
            });
          }

          if (l && e._drawer.restoreContext(a), 0 === e.viewport.degrees || r || e._drawer._restoreRotationChanges(a), a) {
            var v = 0 !== e.viewport.degrees && r;
            v && e._drawer._offsetForRotation(e.viewport.degrees, !1), e._drawer.blendSketch({
              opacity: e.opacity,
              scale: r,
              translate: i,
              compositeOperation: e.compositeOperation,
              bounds: c
            }), v && e._drawer._restoreRotationChanges(!1);
          }

          g(e, n);
        }
      }

      function g(e, n) {
        if (e.debugMode) for (var r = n.length - 1; r >= 0; r--) {
          var i = n[r];

          try {
            e._drawer.drawDebugInfo(i, n.length, r);
          } catch (e) {
            t.console.error(e);
          }
        }
      }

      t.TiledImage = function (e) {
        var n = this;
        t.console.assert(e.tileCache, "[TiledImage] options.tileCache is required"), t.console.assert(e.drawer, "[TiledImage] options.drawer is required"), t.console.assert(e.viewer, "[TiledImage] options.viewer is required"), t.console.assert(e.imageLoader, "[TiledImage] options.imageLoader is required"), t.console.assert(e.source, "[TiledImage] options.source is required"), t.console.assert(!e.clip || e.clip instanceof t.Rect, "[TiledImage] options.clip must be an OpenSeadragon.Rect if present"), t.EventSource.call(this), this._tileCache = e.tileCache, delete e.tileCache, this._drawer = e.drawer, delete e.drawer, this._imageLoader = e.imageLoader, delete e.imageLoader, e.clip instanceof t.Rect && (this._clip = e.clip.clone()), delete e.clip;
        var r = e.x || 0;
        delete e.x;
        var i = e.y || 0;
        delete e.y, this.normHeight = e.source.dimensions.y / e.source.dimensions.x, this.contentAspectX = e.source.dimensions.x / e.source.dimensions.y;
        var o = 1;
        e.width ? (o = e.width, delete e.width, e.height && (t.console.error("specifying both width and height to a tiledImage is not supported"), delete e.height)) : e.height && (o = e.height / this.normHeight, delete e.height);
        var a = e.fitBounds;
        delete e.fitBounds;
        var s = e.fitBoundsPlacement || OpenSeadragon.Placement.CENTER;
        delete e.fitBoundsPlacement, t.extend(!0, this, {
          viewer: null,
          tilesMatrix: {},
          coverage: {},
          lastDrawn: [],
          lastResetTime: 0,
          _midDraw: !1,
          _needsDraw: !0,
          _hasOpaqueTile: !1,
          springStiffness: t.DEFAULT_SETTINGS.springStiffness,
          animationTime: t.DEFAULT_SETTINGS.animationTime,
          minZoomImageRatio: t.DEFAULT_SETTINGS.minZoomImageRatio,
          wrapHorizontal: t.DEFAULT_SETTINGS.wrapHorizontal,
          wrapVertical: t.DEFAULT_SETTINGS.wrapVertical,
          immediateRender: t.DEFAULT_SETTINGS.immediateRender,
          blendTime: t.DEFAULT_SETTINGS.blendTime,
          alwaysBlend: t.DEFAULT_SETTINGS.alwaysBlend,
          minPixelRatio: t.DEFAULT_SETTINGS.minPixelRatio,
          smoothTileEdgesMinZoom: t.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,
          iOSDevice: t.DEFAULT_SETTINGS.iOSDevice,
          debugMode: t.DEFAULT_SETTINGS.debugMode,
          crossOriginPolicy: t.DEFAULT_SETTINGS.crossOriginPolicy,
          placeholderFillStyle: t.DEFAULT_SETTINGS.placeholderFillStyle,
          opacity: t.DEFAULT_SETTINGS.opacity,
          compositeOperation: t.DEFAULT_SETTINGS.compositeOperation
        }, e), this._xSpring = new t.Spring({
          initial: r,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._ySpring = new t.Spring({
          initial: i,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._scaleSpring = new t.Spring({
          initial: o,
          springStiffness: this.springStiffness,
          animationTime: this.animationTime
        }), this._updateForScale(), a && this.fitBounds(a, s, !0), this._drawingHandler = function (e) {
          n.viewer.raiseEvent("tile-drawing", t.extend({
            tiledImage: n
          }, e));
        };
      }, t.extend(t.TiledImage.prototype, t.EventSource.prototype, {
        needsDraw: function needsDraw() {
          return this._needsDraw;
        },
        reset: function reset() {
          this._tileCache.clearTilesFor(this), this.lastResetTime = t.now(), this._needsDraw = !0;
        },
        update: function update() {
          var t = this._xSpring.current.value,
              e = this._ySpring.current.value,
              n = this._scaleSpring.current.value;
          return this._xSpring.update(), this._ySpring.update(), this._scaleSpring.update(), (this._xSpring.current.value !== t || this._ySpring.current.value !== e || this._scaleSpring.current.value !== n) && (this._updateForScale(), this._needsDraw = !0, !0);
        },
        draw: function draw() {
          0 !== this.opacity && (this._midDraw = !0, e(this), this._midDraw = !1);
        },
        destroy: function destroy() {
          this.reset();
        },
        getBounds: function getBounds(e) {
          return e ? new t.Rect(this._xSpring.current.value, this._ySpring.current.value, this._worldWidthCurrent, this._worldHeightCurrent) : new t.Rect(this._xSpring.target.value, this._ySpring.target.value, this._worldWidthTarget, this._worldHeightTarget);
        },
        getWorldBounds: function getWorldBounds() {
          return t.console.error("[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead"), this.getBounds();
        },
        getClippedBounds: function getClippedBounds(e) {
          var n = this.getBounds(e);

          if (this._clip) {
            var r = this._worldWidthCurrent / this.source.dimensions.x,
                i = this._clip.times(r);

            n = new t.Rect(n.x + i.x, n.y + i.y, i.width, i.height);
          }

          return n;
        },
        getContentSize: function getContentSize() {
          return new t.Point(this.source.dimensions.x, this.source.dimensions.y);
        },
        _viewportToImageDelta: function _viewportToImageDelta(e, n, r) {
          var i = r ? this._scaleSpring.current.value : this._scaleSpring.target.value;
          return new t.Point(e * (this.source.dimensions.x / i), n * (this.source.dimensions.y * this.contentAspectX / i));
        },
        viewportToImageCoordinates: function viewportToImageCoordinates(e, n, r) {
          return e instanceof t.Point && (r = n, n = e.y, e = e.x), r ? this._viewportToImageDelta(e - this._xSpring.current.value, n - this._ySpring.current.value) : this._viewportToImageDelta(e - this._xSpring.target.value, n - this._ySpring.target.value);
        },
        _imageToViewportDelta: function _imageToViewportDelta(e, n, r) {
          var i = r ? this._scaleSpring.current.value : this._scaleSpring.target.value;
          return new t.Point(e / this.source.dimensions.x * i, n / this.source.dimensions.y / this.contentAspectX * i);
        },
        imageToViewportCoordinates: function imageToViewportCoordinates(e, n, r) {
          e instanceof t.Point && (r = n, n = e.y, e = e.x);

          var i = this._imageToViewportDelta(e, n);

          return r ? (i.x += this._xSpring.current.value, i.y += this._ySpring.current.value) : (i.x += this._xSpring.target.value, i.y += this._ySpring.target.value), i;
        },
        imageToViewportRectangle: function imageToViewportRectangle(e, n, r, i, o) {
          var a = e;
          a instanceof t.Rect ? o = n : a = new t.Rect(e, n, r, i);

          var s = this.imageToViewportCoordinates(a.getTopLeft(), o),
              u = this._imageToViewportDelta(a.width, a.height, o);

          return new t.Rect(s.x, s.y, u.x, u.y, a.degrees);
        },
        viewportToImageRectangle: function viewportToImageRectangle(e, n, r, i, o) {
          var a = e;
          e instanceof t.Rect ? o = n : a = new t.Rect(e, n, r, i);

          var s = this.viewportToImageCoordinates(a.getTopLeft(), o),
              u = this._viewportToImageDelta(a.width, a.height, o);

          return new t.Rect(s.x, s.y, u.x, u.y, a.degrees);
        },
        viewerElementToImageCoordinates: function viewerElementToImageCoordinates(t) {
          var e = this.viewport.pointFromPixel(t, !0);
          return this.viewportToImageCoordinates(e);
        },
        imageToViewerElementCoordinates: function imageToViewerElementCoordinates(t) {
          var e = this.imageToViewportCoordinates(t);
          return this.viewport.pixelFromPoint(e, !0);
        },
        windowToImageCoordinates: function windowToImageCoordinates(t) {
          var e = t.minus(OpenSeadragon.getElementPosition(this.viewer.element));
          return this.viewerElementToImageCoordinates(e);
        },
        imageToWindowCoordinates: function imageToWindowCoordinates(t) {
          var e = this.imageToViewerElementCoordinates(t);
          return e.plus(OpenSeadragon.getElementPosition(this.viewer.element));
        },
        viewportToImageZoom: function viewportToImageZoom(t) {
          var e = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
          return e * t;
        },
        imageToViewportZoom: function imageToViewportZoom(t) {
          var e = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;
          return t / e;
        },
        setPosition: function setPosition(t, e) {
          var n = this._xSpring.target.value === t.x && this._ySpring.target.value === t.y;

          if (e) {
            if (n && this._xSpring.current.value === t.x && this._ySpring.current.value === t.y) return;
            this._xSpring.resetTo(t.x), this._ySpring.resetTo(t.y), this._needsDraw = !0;
          } else {
            if (n) return;
            this._xSpring.springTo(t.x), this._ySpring.springTo(t.y), this._needsDraw = !0;
          }

          n || this._raiseBoundsChange();
        },
        setWidth: function setWidth(t, e) {
          this._setScale(t, e);
        },
        setHeight: function setHeight(t, e) {
          this._setScale(t / this.normHeight, e);
        },
        fitBounds: function fitBounds(e, n, r) {
          n = n || t.Placement.CENTER;
          var i = t.Placement.properties[n],
              o = this.contentAspectX,
              a = 0,
              s = 0,
              u = 1,
              c = 1;

          if (this._clip && (o = this._clip.getAspectRatio(), u = this._clip.width / this.source.dimensions.x, c = this._clip.height / this.source.dimensions.y, e.getAspectRatio() > o ? (a = this._clip.x / this._clip.height * e.height, s = this._clip.y / this._clip.height * e.height) : (a = this._clip.x / this._clip.width * e.width, s = this._clip.y / this._clip.width * e.width)), e.getAspectRatio() > o) {
            var l = e.height / c,
                h = 0;
            i.isHorizontallyCentered ? h = (e.width - e.height * o) / 2 : i.isRight && (h = e.width - e.height * o), this.setPosition(new t.Point(e.x - a + h, e.y - s), r), this.setHeight(l, r);
          } else {
            var f = e.width / u,
                p = 0;
            i.isVerticallyCentered ? p = (e.height - e.width / o) / 2 : i.isBottom && (p = e.height - e.width / o), this.setPosition(new t.Point(e.x - a, e.y - s + p), r), this.setWidth(f, r);
          }
        },
        getClip: function getClip() {
          return this._clip ? this._clip.clone() : null;
        },
        setClip: function setClip(e) {
          t.console.assert(!e || e instanceof t.Rect, "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null"), e instanceof t.Rect ? this._clip = e.clone() : this._clip = null, this._needsDraw = !0;
        },
        getOpacity: function getOpacity() {
          return this.opacity;
        },
        setOpacity: function setOpacity(t) {
          this.opacity = t, this._needsDraw = !0;
        },
        getCompositeOperation: function getCompositeOperation() {
          return this.compositeOperation;
        },
        setCompositeOperation: function setCompositeOperation(t) {
          this.compositeOperation = t, this._needsDraw = !0;
        },
        _setScale: function _setScale(t, e) {
          var n = this._scaleSpring.target.value === t;

          if (e) {
            if (n && this._scaleSpring.current.value === t) return;
            this._scaleSpring.resetTo(t), this._updateForScale(), this._needsDraw = !0;
          } else {
            if (n) return;
            this._scaleSpring.springTo(t), this._updateForScale(), this._needsDraw = !0;
          }

          n || this._raiseBoundsChange();
        },
        _updateForScale: function _updateForScale() {
          this._worldWidthTarget = this._scaleSpring.target.value, this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value, this._worldWidthCurrent = this._scaleSpring.current.value, this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
        },
        _raiseBoundsChange: function _raiseBoundsChange() {
          this.raiseEvent("bounds-change");
        },
        _isBottomItem: function _isBottomItem() {
          return this.viewer.world.getItemAt(0) === this;
        }
      });
    }(OpenSeadragon), function (t) {
      var e = function e(_e2) {
        t.console.assert(_e2, "[TileCache.cacheTile] options is required"), t.console.assert(_e2.tile, "[TileCache.cacheTile] options.tile is required"), t.console.assert(_e2.tiledImage, "[TileCache.cacheTile] options.tiledImage is required"), this.tile = _e2.tile, this.tiledImage = _e2.tiledImage;
      },
          n = function n(e) {
        t.console.assert(e, "[ImageRecord] options is required"), t.console.assert(e.image, "[ImageRecord] options.image is required"), this._image = e.image, this._tiles = [];
      };

      n.prototype = {
        destroy: function destroy() {
          this._image = null, this._renderedContext = null, this._tiles = null;
        },
        getImage: function getImage() {
          return this._image;
        },
        getRenderedContext: function getRenderedContext() {
          if (!this._renderedContext) {
            var t = document.createElement("canvas");
            t.width = this._image.width, t.height = this._image.height, this._renderedContext = t.getContext("2d"), this._renderedContext.drawImage(this._image, 0, 0), this._image = null;
          }

          return this._renderedContext;
        },
        setRenderedContext: function setRenderedContext(e) {
          t.console.error("ImageRecord.setRenderedContext is deprecated. The rendered context should be created by the ImageRecord itself when calling ImageRecord.getRenderedContext."), this._renderedContext = e;
        },
        addTile: function addTile(e) {
          t.console.assert(e, "[ImageRecord.addTile] tile is required"), this._tiles.push(e);
        },
        removeTile: function removeTile(e) {
          for (var n = 0; n < this._tiles.length; n++) {
            if (this._tiles[n] === e) return void this._tiles.splice(n, 1);
          }

          t.console.warn("[ImageRecord.removeTile] trying to remove unknown tile", e);
        },
        getTileCount: function getTileCount() {
          return this._tiles.length;
        }
      }, t.TileCache = function (e) {
        e = e || {}, this._maxImageCacheCount = e.maxImageCacheCount || t.DEFAULT_SETTINGS.maxImageCacheCount, this._tilesLoaded = [], this._imagesLoaded = [], this._imagesLoadedCount = 0;
      }, t.TileCache.prototype = {
        numTilesLoaded: function numTilesLoaded() {
          return this._tilesLoaded.length;
        },
        cacheTile: function cacheTile(r) {
          t.console.assert(r, "[TileCache.cacheTile] options is required"), t.console.assert(r.tile, "[TileCache.cacheTile] options.tile is required"), t.console.assert(r.tile.url, "[TileCache.cacheTile] options.tile.url is required"), t.console.assert(r.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");
          var i = r.cutoff || 0,
              o = this._tilesLoaded.length,
              a = this._imagesLoaded[r.tile.url];

          if (a || (t.console.assert(r.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord"), a = this._imagesLoaded[r.tile.url] = new n({
            image: r.image
          }), this._imagesLoadedCount++), a.addTile(r.tile), r.tile.cacheImageRecord = a, this._imagesLoadedCount > this._maxImageCacheCount) {
            for (var s, u, c, l, h, f, p = null, m = -1, d = null, g = this._tilesLoaded.length - 1; g >= 0; g--) {
              f = this._tilesLoaded[g], s = f.tile, s.level <= i || s.beingDrawn || (p ? (l = s.lastTouchTime, u = p.lastTouchTime, h = s.level, c = p.level, (l < u || l == u && h > c) && (p = s, m = g, d = f)) : (p = s, m = g, d = f));
            }

            p && m >= 0 && (this._unloadTile(d), o = m);
          }

          this._tilesLoaded[o] = new e({
            tile: r.tile,
            tiledImage: r.tiledImage
          });
        },
        clearTilesFor: function clearTilesFor(e) {
          t.console.assert(e, "[TileCache.clearTilesFor] tiledImage is required");

          for (var n, r = 0; r < this._tilesLoaded.length; ++r) {
            n = this._tilesLoaded[r], n.tiledImage === e && (this._unloadTile(n), this._tilesLoaded.splice(r, 1), r--);
          }
        },
        getImageRecord: function getImageRecord(e) {
          return t.console.assert(e, "[TileCache.getImageRecord] url is required"), this._imagesLoaded[e];
        },
        _unloadTile: function _unloadTile(e) {
          t.console.assert(e, "[TileCache._unloadTile] tileRecord is required");
          var n = e.tile,
              r = e.tiledImage;
          n.unload(), n.cacheImageRecord = null;
          var i = this._imagesLoaded[n.url];
          i.removeTile(n), i.getTileCount() || (i.destroy(), delete this._imagesLoaded[n.url], this._imagesLoadedCount--), r.viewer.raiseEvent("tile-unloaded", {
            tile: n,
            tiledImage: r
          });
        }
      };
    }(OpenSeadragon), function (t) {
      t.World = function (e) {
        var n = this;
        t.console.assert(e.viewer, "[World] options.viewer is required"), t.EventSource.call(this), this.viewer = e.viewer, this._items = [], this._needsDraw = !1, this._autoRefigureSizes = !0, this._needsSizesFigured = !1, this._delegatedFigureSizes = function (t) {
          n._autoRefigureSizes ? n._figureSizes() : n._needsSizesFigured = !0;
        }, this._figureSizes();
      }, t.extend(t.World.prototype, t.EventSource.prototype, {
        addItem: function addItem(e, n) {
          if (t.console.assert(e, "[World.addItem] item is required"), t.console.assert(e instanceof t.TiledImage, "[World.addItem] only TiledImages supported at this time"), n = n || {}, void 0 !== n.index) {
            var r = Math.max(0, Math.min(this._items.length, n.index));

            this._items.splice(r, 0, e);
          } else this._items.push(e);

          this._autoRefigureSizes ? this._figureSizes() : this._needsSizesFigured = !0, this._needsDraw = !0, e.addHandler("bounds-change", this._delegatedFigureSizes), this.raiseEvent("add-item", {
            item: e
          });
        },
        getItemAt: function getItemAt(e) {
          return t.console.assert(void 0 !== e, "[World.getItemAt] index is required"), this._items[e];
        },
        getIndexOfItem: function getIndexOfItem(e) {
          return t.console.assert(e, "[World.getIndexOfItem] item is required"), t.indexOf(this._items, e);
        },
        getItemCount: function getItemCount() {
          return this._items.length;
        },
        setItemIndex: function setItemIndex(e, n) {
          t.console.assert(e, "[World.setItemIndex] item is required"), t.console.assert(void 0 !== n, "[World.setItemIndex] index is required");
          var r = this.getIndexOfItem(e);
          if (n >= this._items.length) throw new Error("Index bigger than number of layers.");
          n !== r && r !== -1 && (this._items.splice(r, 1), this._items.splice(n, 0, e), this._needsDraw = !0, this.raiseEvent("item-index-change", {
            item: e,
            previousIndex: r,
            newIndex: n
          }));
        },
        removeItem: function removeItem(e) {
          t.console.assert(e, "[World.removeItem] item is required");
          var n = t.indexOf(this._items, e);
          n !== -1 && (e.removeHandler("bounds-change", this._delegatedFigureSizes), e.destroy(), this._items.splice(n, 1), this._figureSizes(), this._needsDraw = !0, this._raiseRemoveItem(e));
        },
        removeAll: function removeAll() {
          this.viewer._cancelPendingImages();

          for (var t, e = 0; e < this._items.length; e++) {
            t = this._items[e], t.removeHandler("bounds-change", this._delegatedFigureSizes), t.destroy();
          }

          var n = this._items;

          for (this._items = [], this._figureSizes(), this._needsDraw = !0, e = 0; e < n.length; e++) {
            t = n[e], this._raiseRemoveItem(t);
          }
        },
        resetItems: function resetItems() {
          for (var t = 0; t < this._items.length; t++) {
            this._items[t].reset();
          }
        },
        update: function update() {
          for (var t = !1, e = 0; e < this._items.length; e++) {
            t = this._items[e].update() || t;
          }

          return t;
        },
        draw: function draw() {
          for (var t = 0; t < this._items.length; t++) {
            this._items[t].draw();
          }

          this._needsDraw = !1;
        },
        needsDraw: function needsDraw() {
          for (var t = 0; t < this._items.length; t++) {
            if (this._items[t].needsDraw()) return !0;
          }

          return this._needsDraw;
        },
        getHomeBounds: function getHomeBounds() {
          return this._homeBounds.clone();
        },
        getContentFactor: function getContentFactor() {
          return this._contentFactor;
        },
        setAutoRefigureSizes: function setAutoRefigureSizes(t) {
          this._autoRefigureSizes = t, t & this._needsSizesFigured && (this._figureSizes(), this._needsSizesFigured = !1);
        },
        arrange: function arrange(e) {
          e = e || {};
          var n,
              r = e.immediately || !1,
              i = e.layout || t.DEFAULT_SETTINGS.collectionLayout,
              o = e.rows || t.DEFAULT_SETTINGS.collectionRows,
              a = e.columns || t.DEFAULT_SETTINGS.collectionColumns,
              s = e.tileSize || t.DEFAULT_SETTINGS.collectionTileSize,
              u = e.tileMargin || t.DEFAULT_SETTINGS.collectionTileMargin,
              c = s + u;
          n = !e.rows && a ? a : Math.ceil(this._items.length / o);
          var l,
              h,
              f,
              p,
              m,
              d = 0,
              g = 0;
          this.setAutoRefigureSizes(!1);

          for (var v = 0; v < this._items.length; v++) {
            v && v % n === 0 && ("horizontal" === i ? (g += c, d = 0) : (d += c, g = 0)), l = this._items[v], h = l.getBounds(), f = h.width > h.height ? s : s * (h.width / h.height), p = f * (h.height / h.width), m = new t.Point(d + (s - f) / 2, g + (s - p) / 2), l.setPosition(m, r), l.setWidth(f, r), "horizontal" === i ? d += c : g += c;
          }

          this.setAutoRefigureSizes(!0);
        },
        _figureSizes: function _figureSizes() {
          var e = this._homeBounds ? this._homeBounds.clone() : null,
              n = this._contentSize ? this._contentSize.clone() : null,
              r = this._contentFactor || 0;

          if (this._items.length) {
            var i = this._items[0],
                o = i.getBounds();
            this._contentFactor = i.getContentSize().x / o.width;

            for (var a = i.getClippedBounds(), s = a.x, u = a.y, c = a.x + a.width, l = a.y + a.height, h = 1; h < this._items.length; h++) {
              i = this._items[h], o = i.getBounds(), this._contentFactor = Math.max(this._contentFactor, i.getContentSize().x / o.width), a = i.getClippedBounds(), s = Math.min(s, a.x), u = Math.min(u, a.y), c = Math.max(c, a.x + a.width), l = Math.max(l, a.y + a.height);
            }

            this._homeBounds = new t.Rect(s, u, c - s, l - u), this._contentSize = new t.Point(this._homeBounds.width * this._contentFactor, this._homeBounds.height * this._contentFactor);
          } else this._homeBounds = new t.Rect(0, 0, 1, 1), this._contentSize = new t.Point(1, 1), this._contentFactor = 1;

          this._contentFactor === r && this._homeBounds.equals(e) && this._contentSize.equals(n) || this.raiseEvent("metrics-change", {});
        },
        _raiseRemoveItem: function _raiseRemoveItem(t) {
          this.raiseEvent("remove-item", {
            item: t
          });
        }
      });
    }(OpenSeadragon);
  },, function (t, e, n) {
    "use strict";

    function r(t, e, n) {
      this.props = t, this.context = e, this.refs = a, this.updater = n || o;
    }

    var i = n(50),
        o = n(95),
        a = (n(166), n(59));
    n(9), n(10);
    r.prototype.isReactComponent = {}, r.prototype.setState = function (t, e) {
      "object" != typeof t && "function" != typeof t && null != t ? i("85") : void 0, this.updater.enqueueSetState(this, t), e && this.updater.enqueueCallback(this, e, "setState");
    }, r.prototype.forceUpdate = function (t) {
      this.updater.enqueueForceUpdate(this), t && this.updater.enqueueCallback(this, t, "forceUpdate");
    };
    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {}

    var i = (n(10), {
      isMounted: function isMounted(t) {
        return !1;
      },
      enqueueCallback: function enqueueCallback(t, e) {},
      enqueueForceUpdate: function enqueueForceUpdate(t) {
        r(t, "forceUpdate");
      },
      enqueueReplaceState: function enqueueReplaceState(t, e) {
        r(t, "replaceState");
      },
      enqueueSetState: function enqueueSetState(t, e) {
        r(t, "setState");
      }
    });
    t.exports = i;
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children = [], t.webpackPolyfill = 1), t;
    };
  },,,, function (t, e) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    };

    e.getDevicePixelRatio = function () {
      return "object" !== ("undefined" == typeof window ? "undefined" : n(window)) ? 1 : window.devicePixelRatio || 1;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getDistance = void 0;
    var r = n(73);

    e.getDistance = function (t) {
      var e = t.source,
          n = t.destination;
      return e && n ? (0, r.haversine)(e, n) : null;
    };
  }, function (t, e, n) {
    var r = n(184).runInContext();
    t.exports = n(181)(r, r);
  }, function (t, e, n) {
    function r(t) {
      var e = i.create(t);
      return e.create = r, e.import(n(510)), e;
    }

    var i = n(185);
    t.exports = r();
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o, a) {
      function s() {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
        this.scope = {};
      }

      var u = r(n(54));
      return s.prototype.type = "Parser", s.prototype.isParser = !0, s.prototype.parse = function (t) {
        throw new Error("Parser.parse is deprecated. Use math.parse instead.");
      }, s.prototype.compile = function (t) {
        throw new Error("Parser.compile is deprecated. Use math.compile instead.");
      }, s.prototype.eval = function (t) {
        return u(t).compile().eval(this.scope);
      }, s.prototype.get = function (t) {
        return this.scope[t];
      }, s.prototype.getAll = function () {
        return i({}, this.scope);
      }, s.prototype.set = function (t, e) {
        return this.scope[t] = e;
      }, s.prototype.remove = function (t) {
        delete this.scope[t];
      }, s.prototype.clear = function () {
        for (var t in this.scope) {
          this.scope.hasOwnProperty(t) && delete this.scope[t];
        }
      }, s;
    }

    var i = n(5).extend;
    e.name = "Parser", e.path = "expression", e.factory = r, e.math = !0;
  }, function (t, e) {
    t.exports = {
      name: "e",
      category: "Constants",
      syntax: ["e"],
      description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
      examples: ["e", "e ^ 2", "exp(2)", "log(e)"],
      seealso: ["exp"]
    };
  }, function (t, e) {
    t.exports = {
      name: "pi",
      category: "Constants",
      syntax: ["pi"],
      description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
      examples: ["pi", "sin(pi/2)"],
      seealso: ["tau"]
    };
  }, function (t, e, n) {
    function r(t, e, r, i) {
      var o = {};
      return o.bignumber = n(208), o.boolean = n(209), o.complex = n(210), o.createUnit = n(211), o.fraction = n(212), o.index = n(213), o.matrix = n(214), o.number = n(215), o.sparse = n(216), o.splitUnit = n(217), o.string = n(218), o.unit = n(219), o.e = n(105), o.E = n(105), o.false = n(201), o.i = n(202), o.Infinity = n(193), o.LN2 = n(195), o.LN10 = n(194), o.LOG2E = n(197), o.LOG10E = n(196), o.NaN = n(198), o.null = n(203), o.pi = n(106), o.PI = n(106), o.phi = n(204), o.SQRT1_2 = n(199), o.SQRT2 = n(200), o.tau = n(205), o.true = n(206), o.version = n(207), o.speedOfLight = {
        description: "Speed of light in vacuum",
        examples: ["speedOfLight"]
      }, o.gravitationConstant = {
        description: "Newtonian constant of gravitation",
        examples: ["gravitationConstant"]
      }, o.planckConstant = {
        description: "Planck constant",
        examples: ["planckConstant"]
      }, o.reducedPlanckConstant = {
        description: "Reduced Planck constant",
        examples: ["reducedPlanckConstant"]
      }, o.magneticConstant = {
        description: "Magnetic constant (vacuum permeability)",
        examples: ["magneticConstant"]
      }, o.electricConstant = {
        description: "Electric constant (vacuum permeability)",
        examples: ["electricConstant"]
      }, o.vacuumImpedance = {
        description: "Characteristic impedance of vacuum",
        examples: ["vacuumImpedance"]
      }, o.coulomb = {
        description: "Coulomb's constant",
        examples: ["coulomb"]
      }, o.elementaryCharge = {
        description: "Elementary charge",
        examples: ["elementaryCharge"]
      }, o.bohrMagneton = {
        description: "Borh magneton",
        examples: ["bohrMagneton"]
      }, o.conductanceQuantum = {
        description: "Conductance quantum",
        examples: ["conductanceQuantum"]
      }, o.inverseConductanceQuantum = {
        description: "Inverse conductance quantum",
        examples: ["inverseConductanceQuantum"]
      }, o.magneticFluxQuantum = {
        description: "Magnetic flux quantum",
        examples: ["magneticFluxQuantum"]
      }, o.nuclearMagneton = {
        description: "Nuclear magneton",
        examples: ["nuclearMagneton"]
      }, o.klitzing = {
        description: "Von Klitzing constant",
        examples: ["klitzing"]
      }, o.bohrRadius = {
        description: "Borh radius",
        examples: ["bohrRadius"]
      }, o.classicalElectronRadius = {
        description: "Classical electron radius",
        examples: ["classicalElectronRadius"]
      }, o.electronMass = {
        description: "Electron mass",
        examples: ["electronMass"]
      }, o.fermiCoupling = {
        description: "Fermi coupling constant",
        examples: ["fermiCoupling"]
      }, o.fineStructure = {
        description: "Fine-structure constant",
        examples: ["fineStructure"]
      }, o.hartreeEnergy = {
        description: "Hartree energy",
        examples: ["hartreeEnergy"]
      }, o.protonMass = {
        description: "Proton mass",
        examples: ["protonMass"]
      }, o.deuteronMass = {
        description: "Deuteron Mass",
        examples: ["deuteronMass"]
      }, o.neutronMass = {
        description: "Neutron mass",
        examples: ["neutronMass"]
      }, o.quantumOfCirculation = {
        description: "Quantum of circulation",
        examples: ["quantumOfCirculation"]
      }, o.rydberg = {
        description: "Rydberg constant",
        examples: ["rydberg"]
      }, o.thomsonCrossSection = {
        description: "Thomson cross section",
        examples: ["thomsonCrossSection"]
      }, o.weakMixingAngle = {
        description: "Weak mixing angle",
        examples: ["weakMixingAngle"]
      }, o.efimovFactor = {
        description: "Efimov factor",
        examples: ["efimovFactor"]
      }, o.atomicMass = {
        description: "Atomic mass constant",
        examples: ["atomicMass"]
      }, o.avogadro = {
        description: "Avogadro's number",
        examples: ["avogadro"]
      }, o.boltzmann = {
        description: "Boltzmann constant",
        examples: ["boltzmann"]
      }, o.faraday = {
        description: "Faraday constant",
        examples: ["faraday"]
      }, o.firstRadiation = {
        description: "First radiation constant",
        examples: ["firstRadiation"]
      }, o.loschmidt = {
        description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
        examples: ["loschmidt"]
      }, o.gasConstant = {
        description: "Gas constant",
        examples: ["gasConstant"]
      }, o.molarPlanckConstant = {
        description: "Molar Planck constant",
        examples: ["molarPlanckConstant"]
      }, o.molarVolume = {
        description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
        examples: ["molarVolume"]
      }, o.sackurTetrode = {
        description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
        examples: ["sackurTetrode"]
      }, o.secondRadiation = {
        description: "Second radiation constant",
        examples: ["secondRadiation"]
      }, o.stefanBoltzmann = {
        description: "Stefan-Boltzmann constant",
        examples: ["stefanBoltzmann"]
      }, o.wienDisplacement = {
        description: "Wien displacement law constant",
        examples: ["wienDisplacement"]
      }, o.molarMass = {
        description: "Molar mass constant",
        examples: ["molarMass"]
      }, o.molarMassC12 = {
        description: "Molar mass constant of carbon-12",
        examples: ["molarMassC12"]
      }, o.gravity = {
        description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
        examples: ["gravity"]
      }, o.planckLength = {
        description: "Planck length",
        examples: ["planckLength"]
      }, o.planckMass = {
        description: "Planck mass",
        examples: ["planckMass"]
      }, o.planckTime = {
        description: "Planck time",
        examples: ["planckTime"]
      }, o.planckCharge = {
        description: "Planck charge",
        examples: ["planckCharge"]
      }, o.planckTemperature = {
        description: "Planck temperature",
        examples: ["planckTemperature"]
      }, o.lsolve = n(223), o.lup = n(224), o.lusolve = n(225), o.slu = n(226), o.usolve = n(227), o.abs = n(228), o.add = n(229), o.cbrt = n(230), o.ceil = n(231), o.cube = n(232), o.divide = n(233), o.dotDivide = n(234), o.dotMultiply = n(235), o.dotPow = n(236), o.exp = n(237), o.fix = n(238), o.floor = n(239), o.gcd = n(240), o.hypot = n(241), o.lcm = n(242), o.log = n(243), o.log10 = n(244), o.mod = n(245), o.multiply = n(246), o.norm = n(247), o.nthRoot = n(248), o.pow = n(249), o.round = n(250), o.sign = n(251), o.sqrt = n(252), o.square = n(253), o.subtract = n(254), o.unaryMinus = n(255), o.unaryPlus = n(256), o.xgcd = n(257), o.bitAnd = n(258), o.bitNot = n(259), o.bitOr = n(260), o.bitXor = n(261), o.leftShift = n(262), o.rightArithShift = n(263), o.rightLogShift = n(264), o.bellNumbers = n(265), o.catalan = n(266), o.composition = n(267), o.stirlingS2 = n(268), o.config = n(220), o.import = n(221), o.typed = n(222), o.arg = n(269), o.conj = n(270), o.re = n(272), o.im = n(271), o.eval = n(273), o.help = n(274), o.distance = n(275), o.intersect = n(276), o.and = n(277), o.not = n(278), o.or = n(279), o.xor = n(280), o.concat = n(281), o.cross = n(282), o.det = n(283), o.diag = n(284), o.dot = n(285), o.eye = n(286), o.filter = n(287), o.flatten = n(288), o.forEach = n(289), o.inv = n(290), o.map = n(291), o.ones = n(292), o.partitionSelect = n(293), o.range = n(294), o.resize = n(295), o.size = n(296), o.sort = n(297), o.squeeze = n(298), o.subset = n(299), o.trace = n(300), o.transpose = n(301), o.zeros = n(302), o.combinations = n(303), o.factorial = n(304), o.gamma = n(305), o.kldivergence = n(306), o.multinomial = n(307), o.permutations = n(308), o.pickRandom = n(309), o.random = n(310), o.randomInt = n(311), o.compare = n(312), o.deepEqual = n(313), o.equal = n(314), o.larger = n(315), o.largerEq = n(316), o.smaller = n(317), o.smallerEq = n(318), o.unequal = n(319), o.erf = n(320), o.max = n(321), o.mean = n(322), o.median = n(323), o.min = n(324), o.mode = n(325), o.prod = n(326), o.quantileSeq = n(327), o.std = n(328), o.sum = n(329), o.var = n(330), o.acos = n(331), o.acosh = n(332), o.acot = n(333), o.acoth = n(334), o.acsc = n(335), o.acsch = n(336), o.asec = n(337), o.asech = n(338), o.asin = n(339), o.asinh = n(340), o.atan = n(341), o.atanh = n(343), o.atan2 = n(342), o.cos = n(344), o.cosh = n(345), o.cot = n(346), o.coth = n(347), o.csc = n(348), o.csch = n(349), o.sec = n(350), o.sech = n(351), o.sin = n(352), o.sinh = n(353), o.tan = n(354), o.tanh = n(355), o.to = n(356), o.clone = n(357), o.format = n(358), o.isNaN = n(360), o.isInteger = n(359), o.isNegative = n(361), o.isNumeric = n(362), o.isPositive = n(363), o.isPrime = n(364), o.isZero = n(365), o.typeof = n(366), o;
    }

    e.name = "docs", e.path = "expression", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i, o) {
      var a = r(n(104));
      return i("parser", {
        "": function _() {
          return new a(o);
        }
      });
    }

    e.name = "parser", e.factory = r, e.math = !0;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!t || !t.isNode) throw new TypeError('Node expected for parameter "object"');
        if (!e || !e.isIndexNode) throw new TypeError('IndexNode expected for parameter "index"');
        this.object = t || null, this.index = e, Object.defineProperty(this, "name", {
          get: function () {
            return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
          }.bind(this),
          set: function set() {
            throw new Error("Cannot assign a new name, name is read-only");
          }
        });
      }

      function a(t) {
        return !(t.isAccessorNode || t.isArrayNode || t.isConstantNode || t.isFunctionNode || t.isObjectNode || t.isParenthesisNode || t.isSymbolNode);
      }

      var s = r(n(14)),
          u = r(n(118));
      return o.prototype = new s(), o.prototype.type = "AccessorNode", o.prototype.isAccessorNode = !0, o.prototype._compile = function (t, e) {
        t.access = u;

        var n = this.object._compile(t, e),
            r = this.index._compile(t, e);

        return this.index.isObjectProperty() ? n + '["' + this.index.getObjectProperty() + '"]' : this.index.needsSize() ? "(function () {  var object = " + n + ";  var size = math.size(object).valueOf();  return access(object, " + r + ");})()" : "access(" + n + ", " + r + ")";
      }, o.prototype.forEach = function (t) {
        t(this.object, "object", this), t(this.index, "index", this);
      }, o.prototype.map = function (t) {
        return new o(this._ifNode(t(this.object, "object", this)), this._ifNode(t(this.index, "index", this)));
      }, o.prototype.clone = function () {
        return new o(this.object, this.index);
      }, o.prototype._toString = function (t) {
        var e = this.object.toString(t);
        return a(this.object) && (e = "(" + e + ")"), e + this.index.toString(t);
      }, o.prototype._toTex = function (t) {
        var e = this.object.toTex(t);
        return a(this.object) && (e = "\\left(" + e + "\\right)"), e + this.index.toTex(t);
      }, o;
    }

    e.name = "AccessorNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e, n) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (this.object = t, this.index = n ? e : null, this.value = n ? n : e, !t || !t.isSymbolNode && !t.isAccessorNode) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
        if (t && t.isSymbolNode && "end" === t.name) throw new Error('Cannot assign to symbol "end"');
        if (this.index && !this.index.isIndexNode) throw new TypeError('IndexNode expected as "index"');
        if (!this.value || !this.value.isNode) throw new TypeError('Node expected as "value"');
        Object.defineProperty(this, "name", {
          get: function () {
            return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
          }.bind(this),
          set: function set() {
            throw new Error("Cannot assign a new name, name is read-only");
          }
        });
      }

      function a(t, e) {
        e || (e = "keep");
        var n = l.getPrecedence(t, e),
            r = l.getPrecedence(t.value, e);
        return "all" === e || null !== r && r <= n;
      }

      var s = r(n(14)),
          u = (r(n(75)), r(n(2)), r(n(375))),
          c = r(n(118)),
          l = (n(74), n(53));
      return o.prototype = new s(), o.prototype.type = "AssignmentNode", o.prototype.isAssignmentNode = !0, o.prototype._compile = function (t, e) {
        t.assign = u, t.access = c;

        var n,
            r = this.object._compile(t, e),
            i = this.index ? this.index._compile(t, e) : null,
            o = this.value._compile(t, e);

        if (this.index) {
          if (this.index.isObjectProperty()) return r + '["' + this.index.getObjectProperty() + '"] = ' + o;
          if (this.object.isSymbolNode) return n = this.index.needsSize() ? "var size = math.size(object).valueOf();" : "", "(function () {  var object = " + r + ";  var value = " + o + ";  " + n + '  scope["' + this.object.name + '"] = assign(object, ' + i + ", value);  return value;})()";
          n = this.index.needsSize() ? "var size = math.size(object).valueOf();" : "";

          var a = this.object.object._compile(t, e);

          if (this.object.index.isObjectProperty()) {
            var s = '["' + this.object.index.getObjectProperty() + '"]';
            return "(function () {  var parent = " + a + ";  var object = parent" + s + ";  var value = " + o + ";" + n + "  parent" + s + " = assign(object, " + i + ", value);  return value;})()";
          }

          var l = this.object.index.needsSize() ? "var size = math.size(parent).valueOf();" : "",
              h = this.object.index._compile(t, e);

          return "(function () {  var parent = " + a + ";  " + l + "  var parentIndex = " + h + ";  var object = access(parent, parentIndex);  var value = " + o + ";  " + n + "  assign(parent, parentIndex, assign(object, " + i + ", value));  return value;})()";
        }

        if (!this.object.isSymbolNode) throw new TypeError("SymbolNode expected as object");
        return 'scope["' + this.object.name + '"] = ' + o;
      }, o.prototype.forEach = function (t) {
        t(this.object, "object", this), this.index && t(this.index, "index", this), t(this.value, "value", this);
      }, o.prototype.map = function (t) {
        var e = this._ifNode(t(this.object, "object", this)),
            n = this.index ? this._ifNode(t(this.index, "index", this)) : null,
            r = this._ifNode(t(this.value, "value", this));

        return new o(e, n, r);
      }, o.prototype.clone = function () {
        return new o(this.object, this.index, this.value);
      }, o.prototype._toString = function (t) {
        var e = this.object.toString(t),
            n = this.index ? this.index.toString(t) : "",
            r = this.value.toString(t);
        return a(this, t && t.parenthesis) && (r = "(" + r + ")"), e + n + " = " + r;
      }, o.prototype._toTex = function (t) {
        var e = this.object.toTex(t),
            n = this.index ? this.index.toTex(t) : "",
            r = this.value.toTex(t);
        return a(this, t && t.parenthesis) && (r = "\\left(" + r + "\\right)"), e + n + ":=" + r;
      }, o;
    }

    n(4);
    e.name = "AssignmentNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!Array.isArray(t)) throw new Error("Array expected");
        this.blocks = t.map(function (t) {
          var e = t && t.node,
              n = !t || void 0 === t.visible || t.visible;
          if (!e || !e.isNode) throw new TypeError('Property "node" must be a Node');
          if ("boolean" != typeof n) throw new TypeError('Property "visible" must be a boolean');
          return {
            node: e,
            visible: n
          };
        });
      }

      var a = r(n(14)),
          s = r(n(155));
      return o.prototype = new a(), o.prototype.type = "BlockNode", o.prototype.isBlockNode = !0, o.prototype._compile = function (t, e) {
        t.ResultSet = s;
        var n = this.blocks.map(function (n) {
          var r = n.node._compile(t, e);

          return n.visible ? "results.push(" + r + ");" : r + ";";
        });
        return "(function () {var results = [];" + n.join("") + "return new ResultSet(results);})()";
      }, o.prototype.forEach = function (t) {
        for (var e = 0; e < this.blocks.length; e++) {
          t(this.blocks[e].node, "blocks[" + e + "].node", this);
        }
      }, o.prototype.map = function (t) {
        for (var e = [], n = 0; n < this.blocks.length; n++) {
          var r = this.blocks[n],
              i = this._ifNode(t(r.node, "blocks[" + n + "].node", this));

          e[n] = {
            node: i,
            visible: r.visible
          };
        }

        return new o(e);
      }, o.prototype.clone = function () {
        var t = this.blocks.map(function (t) {
          return {
            node: t.node,
            visible: t.visible
          };
        });
        return new o(t);
      }, o.prototype._toString = function (t) {
        return this.blocks.map(function (e) {
          return e.node.toString(t) + (e.visible ? "" : ";");
        }).join("\n");
      }, o.prototype._toTex = function (t) {
        return this.blocks.map(function (e) {
          return e.node.toTex(t) + (e.visible ? "" : ";");
        }).join("\\;\\;\n");
      }, o;
    }

    e.name = "BlockNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e, n) {
        if (!(this instanceof a)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!t || !t.isNode) throw new TypeError("Parameter condition must be a Node");
        if (!e || !e.isNode) throw new TypeError("Parameter trueExpr must be a Node");
        if (!n || !n.isNode) throw new TypeError("Parameter falseExpr must be a Node");
        this.condition = t, this.trueExpr = e, this.falseExpr = n;
      }

      var s = r(n(14));
      return a.prototype = new s(), a.prototype.type = "ConditionalNode", a.prototype.isConditionalNode = !0, a.prototype._compile = function (t, e) {
        return t.testCondition = function (e) {
          if ("number" == typeof e || "boolean" == typeof e || "string" == typeof e) return !!e;

          if (e) {
            if (e.isBigNumber === !0) return !e.isZero();
            if (e.isComplex === !0) return !(!e.re && !e.im);
            if (e.isUnit === !0) return !!e.value;
          }

          if (null === e || void 0 === e) return !1;
          throw new TypeError('Unsupported type of condition "' + t.math.typeof(e) + '"');
        }, "testCondition(" + this.condition._compile(t, e) + ") ? ( " + this.trueExpr._compile(t, e) + ") : ( " + this.falseExpr._compile(t, e) + ")";
      }, a.prototype.forEach = function (t) {
        t(this.condition, "condition", this), t(this.trueExpr, "trueExpr", this), t(this.falseExpr, "falseExpr", this);
      }, a.prototype.map = function (t) {
        return new a(this._ifNode(t(this.condition, "condition", this)), this._ifNode(t(this.trueExpr, "trueExpr", this)), this._ifNode(t(this.falseExpr, "falseExpr", this)));
      }, a.prototype.clone = function () {
        return new a(this.condition, this.trueExpr, this.falseExpr);
      }, a.prototype._toString = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = i.getPrecedence(this, e),
            r = this.condition.toString(t),
            o = i.getPrecedence(this.condition, e);
        ("all" === e || "OperatorNode" === this.condition.type || null !== o && o <= n) && (r = "(" + r + ")");
        var a = this.trueExpr.toString(t),
            s = i.getPrecedence(this.trueExpr, e);
        ("all" === e || "OperatorNode" === this.trueExpr.type || null !== s && s <= n) && (a = "(" + a + ")");
        var u = this.falseExpr.toString(t),
            c = i.getPrecedence(this.falseExpr, e);
        return ("all" === e || "OperatorNode" === this.falseExpr.type || null !== c && c <= n) && (u = "(" + u + ")"), r + " ? " + a + " : " + u;
      }, a.prototype._toTex = function (t) {
        return "\\begin{cases} {" + this.trueExpr.toTex(t) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(t) + "}\\\\{" + this.falseExpr.toTex(t) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
      }, a;
    }

    var i = (n(4), n(53));
    e.name = "ConditionalNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      function u(t, e, n) {
        if (!(this instanceof u)) throw new SyntaxError("Constructor must be called with the new operator");
        if ("string" != typeof t) throw new TypeError('String expected for parameter "name"');
        if (!Array.isArray(e)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
        if (!n || !n.isNode) throw new TypeError('Node expected for parameter "expr"');
        if (t in i) throw new Error('Illegal function name, "' + t + '" is a reserved keyword');
        this.name = t, this.params = e.map(function (t) {
          return t && t.name || t;
        }), this.types = e.map(function (t) {
          return t && t.type || "any";
        }), this.expr = n;
      }

      function c(t, e) {
        var n = a.getPrecedence(t, e),
            r = a.getPrecedence(t.expr, e);
        return "all" === e || null !== r && r <= n;
      }

      var l = r(n(14));
      return u.prototype = new l(), u.prototype.type = "FunctionAssignmentNode", u.prototype.isFunctionAssignmentNode = !0, u.prototype._compile = function (t, e) {
        t.typed = s;
        var n = Object.create(e);
        this.params.forEach(function (t) {
          n[t] = !0;
        });

        var r = this.expr._compile(t, n);

        return 'scope["' + this.name + '"] =   (function () {    var fn = typed("' + this.name + '", {      "' + this.types.join(",") + '": function (' + this.params.join(",") + ") {        return " + r + '      }    });    fn.syntax = "' + this.name + "(" + this.params.join(", ") + ')";    return fn;  })()';
      }, u.prototype.forEach = function (t) {
        t(this.expr, "expr", this);
      }, u.prototype.map = function (t) {
        var e = this._ifNode(t(this.expr, "expr", this));

        return new u(this.name, this.params.slice(0), e);
      }, u.prototype.clone = function () {
        return new u(this.name, this.params.slice(0), this.expr);
      }, u.prototype._toString = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = this.expr.toString(t);
        return c(this, e) && (n = "(" + n + ")"), "function " + this.name + "(" + this.params.join(", ") + ") = " + n;
      }, u.prototype._toTex = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = this.expr.toTex(t);
        return c(this, e) && (n = "\\left(" + n + "\\right)"), "\\mathrm{" + this.name + "}\\left(" + this.params.map(o.toSymbol).join(",") + "\\right):=" + n;
      }, u;
    }

    var i = n(74),
        o = n(4),
        a = n(53);
    e.name = "FunctionAssignmentNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (this.dimensions = t, this.dotNotation = e || !1, !u(t) || !t.every(function (t) {
          return t && t.isNode;
        })) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
        if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");

        var n = function n() {
          throw new Error("Property `IndexNode.object` is deprecated, use `IndexNode.fn` instead");
        };

        Object.defineProperty(this, "object", {
          get: n,
          set: n
        });
      }

      var a = r(n(14)),
          s = (r(n(78)), r(n(40)), r(n(153))),
          u = Array.isArray;
      return o.prototype = new a(), o.prototype.type = "IndexNode", o.prototype.isIndexNode = !0, o.prototype._compile = function (t, e) {
        var n = Object.create(e);

        t.range = function (t, e, n) {
          return new s(t && t.isBigNumber === !0 ? t.toNumber() : t, e && e.isBigNumber === !0 ? e.toNumber() : e, n && n.isBigNumber === !0 ? n.toNumber() : n);
        };

        var r = this.dimensions.map(function (e, r) {
          return e && e.isRangeNode ? e.needsEnd() ? (n.end = !0, "(function () {var end = size[" + r + "]; return range(" + e.start._compile(t, n) + ", " + e.end._compile(t, n) + ", " + (e.step ? e.step._compile(t, n) : "1") + "); })()") : "range(" + e.start._compile(t, n) + ", " + e.end._compile(t, n) + ", " + (e.step ? e.step._compile(t, n) : "1") + ")" : e.isSymbolNode && "end" === e.name ? (n.end = !0, "(function () {var end = size[" + r + "]; return " + e._compile(t, n) + "; })()") : e._compile(t, n);
        });
        return "math.index(" + r.join(", ") + ")";
      }, o.prototype.forEach = function (t) {
        for (var e = 0; e < this.dimensions.length; e++) {
          t(this.dimensions[e], "dimensions[" + e + "]", this);
        }
      }, o.prototype.map = function (t) {
        for (var e = [], n = 0; n < this.dimensions.length; n++) {
          e[n] = this._ifNode(t(this.dimensions[n], "dimensions[" + n + "]", this));
        }

        return new o(e);
      }, o.prototype.clone = function () {
        return new o(this.dimensions.slice(0));
      }, o.prototype.isObjectProperty = function () {
        return 1 === this.dimensions.length && this.dimensions[0].isConstantNode && "string" === this.dimensions[0].valueType;
      }, o.prototype.getObjectProperty = function () {
        return this.isObjectProperty() ? this.dimensions[0].value : null;
      }, o.prototype._toString = function (t) {
        return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
      }, o.prototype._toTex = function (t) {
        var e = this.dimensions.map(function (e) {
          return e.toTex(t);
        });
        return this.dotNotation ? "." + this.getObjectProperty() : "_{" + e.join(",") + "}";
      }, o.prototype.needsSize = function () {
        return this.dimensions.some(function (t) {
          return t.isRangeNode && t.needsEnd() || t.isSymbolNode && "end" === t.name;
        });
      }, o;
    }

    e.name = "IndexNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (this.properties = t || {}, t && ("object" != typeof t || Object.keys(t).some(function (e) {
          return !t[e] || !t[e].isNode;
        }))) throw new TypeError("Object containing Nodes expected");
      }

      var a = r(n(14));
      return o.prototype = new a(), o.prototype.type = "ObjectNode", o.prototype.isObjectNode = !0, o.prototype._compile = function (t, e) {
        var n = [];

        for (var r in this.properties) {
          this.properties.hasOwnProperty(r) && n.push('"' + r + '": ' + this.properties[r]._compile(t, e));
        }

        return "{" + n.join(", ") + "}";
      }, o.prototype.forEach = function (t) {
        for (var e in this.properties) {
          this.properties.hasOwnProperty(e) && t(this.properties[e], 'properties["' + e + '"]', this);
        }
      }, o.prototype.map = function (t) {
        var e = {};

        for (var n in this.properties) {
          this.properties.hasOwnProperty(n) && (e[n] = this._ifNode(t(this.properties[n], 'properties["' + n + '"]', this)));
        }

        return new o(e);
      }, o.prototype.clone = function () {
        var t = {};

        for (var e in this.properties) {
          this.properties.hasOwnProperty(e) && (t[e] = this.properties[e]);
        }

        return new o(t);
      }, o.prototype._toString = function (t) {
        var e = [];

        for (var n in this.properties) {
          this.properties.hasOwnProperty(n) && e.push('"' + n + '": ' + this.properties[n].toString(t));
        }

        return "{" + e.join(", ") + "}";
      }, o.prototype._toTex = function (t) {
        var e = [];

        for (var n in this.properties) {
          this.properties.hasOwnProperty(n) && e.push("\\mathbf{" + n + ":} & " + this.properties[n].toTex(t) + "\\\\");
        }

        return "\\left\\{\\begin{array}{ll}" + e.join("\n") + "\\end{array}\\right\\}";
      }, o;
    }

    n(23);
    e.name = "ObjectNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a, s) {
      function u(t, e, n, r) {
        if (!(this instanceof u)) throw new SyntaxError("Constructor must be called with the new operator");
        if ("string" != typeof t) throw new TypeError('string expected for parameter "op"');
        if ("string" != typeof e) throw new TypeError('string expected for parameter "fn"');
        if (!Array.isArray(n) || !n.every(function (t) {
          return t && t.isNode;
        })) throw new TypeError('Array containing Nodes expected for parameter "args"');
        this.implicit = r === !0, this.op = t, this.fn = e, this.args = n || [];
      }

      function c(t, e, n, r) {
        var i = o.getPrecedence(t, e),
            a = o.getAssociativity(t, e);

        if ("all" === e || n.length > 2 && "OperatorNode:add" !== t.getIdentifier() && "OperatorNode:multiply" !== t.getIdentifier()) {
          var s = n.map(function (t) {
            switch (t.getContent().type) {
              case "ArrayNode":
              case "ConstantNode":
              case "SymbolNode":
              case "ParenthesisNode":
                return !1;

              default:
                return !0;
            }
          });
          return s;
        }

        if (0 === n.length) return [];

        if (1 === n.length) {
          var u = o.getPrecedence(n[0], e);

          if (r && null !== u) {
            var c, l;
            if ("keep" === e ? (c = n[0].getIdentifier(), l = t.getIdentifier()) : (c = n[0].getContent().getIdentifier(), l = t.getContent().getIdentifier()), o.properties[i][l].latexLeftParens === !1) return [!1];
            if (o.properties[u][c].latexParens === !1) return [!1];
          }

          return null === u ? [!1] : u <= i ? [!0] : [!1];
        }

        if (2 === n.length) {
          var h,
              f = o.getPrecedence(n[0], e),
              p = o.isAssociativeWith(t, n[0], e);
          h = null !== f && (f === i && "right" === a && !p || f < i);
          var m,
              d = o.getPrecedence(n[1], e),
              g = o.isAssociativeWith(t, n[1], e);

          if (m = null !== d && (d === i && "left" === a && !g || d < i), r) {
            var l, v, y;
            "keep" === e ? (l = t.getIdentifier(), v = t.args[0].getIdentifier(), y = t.args[1].getIdentifier()) : (l = t.getContent().getIdentifier(), v = t.args[0].getContent().getIdentifier(), y = t.args[1].getContent().getIdentifier()), null !== f && (o.properties[i][l].latexLeftParens === !1 && (h = !1), o.properties[f][v].latexParens === !1 && (h = !1)), null !== d && (o.properties[i][l].latexRightParens === !1 && (m = !1), o.properties[d][y].latexParens === !1 && (m = !1));
          }

          return [h, m];
        }

        if (n.length > 2 && ("OperatorNode:add" === t.getIdentifier() || "OperatorNode:multiply" === t.getIdentifier())) {
          var x = n.map(function (n) {
            var r = o.getPrecedence(n, e),
                s = o.isAssociativeWith(t, n, e),
                u = o.getAssociativity(n, e);
            return null !== r && (i === r && a === u && !s || r < i);
          });
          return x;
        }
      }

      var l = r(n(14));
      r(n(76)), r(n(40)), r(n(77));
      return u.prototype = new l(), u.prototype.type = "OperatorNode", u.prototype.isOperatorNode = !0, u.prototype._compile = function (t, e) {
        if (!t.math[this.fn]) throw new Error("Function " + this.fn + ' missing in provided namespace "math"');
        var n = this.args.map(function (n) {
          return n._compile(t, e);
        });
        return "math." + this.fn + "(" + n.join(", ") + ")";
      }, u.prototype.forEach = function (t) {
        for (var e = 0; e < this.args.length; e++) {
          t(this.args[e], "args[" + e + "]", this);
        }
      }, u.prototype.map = function (t) {
        for (var e = [], n = 0; n < this.args.length; n++) {
          e[n] = this._ifNode(t(this.args[n], "args[" + n + "]", this));
        }

        return new u(this.op, this.fn, e);
      }, u.prototype.clone = function () {
        return new u(this.op, this.fn, this.args.slice(0), this.implicit);
      }, u.prototype._toString = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = t && t.implicit ? t.implicit : "hide",
            r = this.args,
            i = c(this, e, r, !1);

        if (1 === r.length) {
          var a = o.getAssociativity(this, e),
              s = r[0].toString(t);
          return i[0] && (s = "(" + s + ")"), "right" === a ? this.op + s : "left" === a ? s + this.op : s + this.op;
        }

        if (2 == r.length) {
          var u = r[0].toString(t),
              l = r[1].toString(t);
          return i[0] && (u = "(" + u + ")"), i[1] && (l = "(" + l + ")"), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" == n ? u + " " + l : u + " " + this.op + " " + l;
        }

        if (r.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
          var h = r.map(function (e, n) {
            return e = e.toString(t), i[n] && (e = "(" + e + ")"), e;
          });
          return this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === n ? h.join(" ") : h.join(" " + this.op + " ");
        }

        return this.fn + "(" + this.args.join(", ") + ")";
      }, u.prototype._toTex = function (t) {
        var e = t && t.parenthesis ? t.parenthesis : "keep",
            n = t && t.implicit ? t.implicit : "hide",
            r = this.args,
            a = c(this, e, r, !0),
            s = i.operators[this.fn];

        if (s = "undefined" == typeof s ? this.op : s, 1 === r.length) {
          var u = o.getAssociativity(this, e),
              l = r[0].toTex(t);
          return a[0] && (l = "\\left(" + l + "\\right)"), "right" === u ? s + l : "left" === u ? l + s : l + s;
        }

        if (2 === r.length) {
          var h = r[0],
              f = h.toTex(t);
          a[0] && (f = "\\left(" + f + "\\right)");
          var p = r[1],
              m = p.toTex(t);
          a[1] && (m = "\\left(" + m + "\\right)");
          var d;

          switch (d = "keep" === e ? h.getIdentifier() : h.getContent().getIdentifier(), this.getIdentifier()) {
            case "OperatorNode:divide":
              return s + "{" + f + "}{" + m + "}";

            case "OperatorNode:pow":
              switch (f = "{" + f + "}", m = "{" + m + "}", d) {
                case "ConditionalNode":
                case "OperatorNode:divide":
                  f = "\\left(" + f + "\\right)";
              }

            case "OperatorNode:multiply":
              if (this.implicit && "hide" === n) return f + "~" + m;
          }

          return f + s + m;
        }

        if (r.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
          var g = r.map(function (e, n) {
            return e = e.toTex(t), a[n] && (e = "\\left(" + e + "\\right)"), e;
          });
          return "OperatorNode:multiply" === this.getIdentifier() && this.implicit ? g.join("~") : g.join(s);
        }

        return "\\mathrm{" + this.fn + "}\\left(" + r.map(function (e) {
          return e.toTex(t);
        }).join(",") + "\\right)";
      }, u.prototype.getIdentifier = function () {
        return this.type + ":" + this.fn;
      }, u;
    }

    var i = n(4),
        o = n(53);
    e.name = "OperatorNode", e.path = "expression.node", e.math = !0, e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!t || !t.isNode) throw new TypeError('Node expected for parameter "content"');
        this.content = t;
      }

      var a = r(n(14));
      return o.prototype = new a(), o.prototype.type = "ParenthesisNode", o.prototype.isParenthesisNode = !0, o.prototype._compile = function (t, e) {
        return this.content._compile(t, e);
      }, o.prototype.getContent = function () {
        return this.content.getContent();
      }, o.prototype.forEach = function (t) {
        t(this.content, "content", this);
      }, o.prototype.map = function (t) {
        var e = t(this.content, "content", this);
        return new o(e);
      }, o.prototype.clone = function () {
        return new o(this.content);
      }, o.prototype._toString = function (t) {
        return !t || t && !t.parenthesis || t && "keep" === t.parenthesis ? "(" + this.content.toString(t) + ")" : this.content.toString(t);
      }, o.prototype._toTex = function (t) {
        return !t || t && !t.parenthesis || t && "keep" === t.parenthesis ? "\\left(" + this.content.toTex(t) + "\\right)" : this.content.toTex(t);
      }, o;
    }

    e.name = "ParenthesisNode", e.path = "expression.node", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(61)),
          s = r(n(2));
      return function (t, e) {
        try {
          if (Array.isArray(t)) return s(t).subset(e).valueOf();
          if (t && "function" == typeof t.subset) return t.subset(e);
          if ("string" == typeof t) return a(t, e);

          if ("object" == typeof t) {
            if (!e.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
            return t[e.getObjectProperty()];
          }

          throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (t) {
          throw i(t);
        }
      };
    }

    var i = n(34).transform;
    e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var a = r(n(2)),
          s = r(n(35)),
          u = r(n(22)),
          c = r(n(20)),
          l = r(n(26)),
          h = r(n(24)),
          f = r(n(30)),
          p = r(n(11)),
          m = r(n(43)),
          d = t.SparseMatrix,
          g = t.DenseMatrix,
          v = t.Spa,
          y = i("lup", {
        DenseMatrix: function DenseMatrix(t) {
          return x(t);
        },
        SparseMatrix: function SparseMatrix(t) {
          return w(t);
        },
        Array: function Array(t) {
          var e = a(t),
              n = x(e);
          return {
            L: n.L.valueOf(),
            U: n.U.valueOf(),
            p: n.p
          };
        }
      }),
          x = function x(t) {
        var e,
            n,
            r,
            i = t._size[0],
            a = t._size[1],
            m = Math.min(i, a),
            d = o.clone(t._data),
            v = [],
            y = [i, m],
            x = [],
            w = [m, a],
            b = [];

        for (e = 0; e < i; e++) {
          b[e] = e;
        }

        for (n = 0; n < a; n++) {
          if (n > 0) for (e = 0; e < i; e++) {
            var _ = Math.min(e, n),
                E = 0;

            for (r = 0; r < _; r++) {
              E = u(E, l(d[e][r], d[r][n]));
            }

            d[e][n] = h(d[e][n], E);
          }
          var M = n,
              T = 0,
              N = 0;

          for (e = n; e < i; e++) {
            var S = d[e][n],
                A = s(S);
            f(A, T) && (M = e, T = A, N = S);
          }

          if (n !== M && (b[n] = [b[M], b[M] = b[n]][0], g._swapRows(n, M, d)), n < i) for (e = n + 1; e < i; e++) {
            var O = d[e][n];
            p(O, 0) || (d[e][n] = c(d[e][n], N));
          }
        }

        for (n = 0; n < a; n++) {
          for (e = 0; e < i; e++) {
            0 === n && (e < a && (x[e] = []), v[e] = []), e < n ? (e < a && (x[e][n] = d[e][n]), n < i && (v[e][n] = 0)) : e !== n ? (e < a && (x[e][n] = 0), n < i && (v[e][n] = d[e][n])) : (e < a && (x[e][n] = d[e][n]), n < i && (v[e][n] = 1));
          }
        }

        var C = new g({
          data: v,
          size: y
        }),
            P = new g({
          data: x,
          size: w
        }),
            R = [];

        for (e = 0, m = b.length; e < m; e++) {
          R[b[e]] = e;
        }

        return {
          L: C,
          U: P,
          p: R,
          toString: function toString() {
            return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
          }
        };
      },
          w = function w(t) {
        var e,
            n,
            r,
            i = t._size[0],
            o = t._size[1],
            a = Math.min(i, o),
            u = t._values,
            h = t._index,
            g = t._ptr,
            y = [],
            x = [],
            w = [],
            b = [i, a],
            _ = [],
            E = [],
            M = [],
            T = [a, o],
            N = [],
            S = [];

        for (e = 0; e < i; e++) {
          N[e] = e, S[e] = e;
        }

        var A = function A(t, e) {
          var n = S[t],
              r = S[e];
          N[n] = e, N[r] = t, S[t] = r, S[e] = n;
        };

        for (n = 0; n < o; n++) {
          var O = new v();
          n < i && (w.push(y.length), y.push(1), x.push(n)), M.push(_.length);
          var C = g[n],
              P = g[n + 1];

          for (r = C; r < P; r++) {
            e = h[r], O.set(N[e], u[r]);
          }

          n > 0 && O.forEach(0, n - 1, function (t, e) {
            d._forEachRow(t, y, x, w, function (n, r) {
              n > t && O.accumulate(n, m(l(r, e)));
            });
          });
          var R = n,
              I = O.get(n),
              k = s(I);
          O.forEach(n + 1, i - 1, function (t, e) {
            var n = s(e);
            f(n, k) && (R = t, k = n, I = e);
          }), n !== R && (d._swapRows(n, R, b[1], y, x, w), d._swapRows(n, R, T[1], _, E, M), O.swap(n, R), A(n, R)), O.forEach(0, i - 1, function (t, e) {
            t <= n ? (_.push(e), E.push(t)) : (e = c(e, I), p(e, 0) || (y.push(e), x.push(t)));
          });
        }

        return M.push(_.length), w.push(y.length), {
          L: new d({
            values: y,
            index: x,
            ptr: w,
            size: b
          }),
          U: new d({
            values: _,
            index: E,
            ptr: M,
            size: T
          }),
          p: N,
          toString: function toString() {
            return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
          }
        };
      };

      return y;
    }

    var i = n(28),
        o = i.object;
    e.name = "lup", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(401)),
          s = r(n(396)),
          u = i("slu", {
        "SparseMatrix, number, number": function SparseMatrixNumberNumber(t, e, n) {
          if (!a(e) || e < 0 || e > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
          if (n < 0 || n > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
          var r = o(e, t, !1),
              i = s(t, r, n);
          return {
            L: i.L,
            U: i.U,
            p: i.pinv,
            q: r.q,
            toString: function toString() {
              return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
            }
          };
        }
      });
      return u;
    }

    var i = n(28),
        o = i.number,
        a = o.isInteger;
    e.name = "slu", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(20)),
          s = r(n(26)),
          u = r(n(24)),
          c = r(n(11)),
          l = r(n(79)),
          h = t.DenseMatrix,
          f = i("lsolve", {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(t, e) {
          return m(t, e);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(t, e) {
          return p(t, e);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(t, e) {
          var n = o(t),
              r = p(n, e);
          return r.valueOf();
        }
      }),
          p = function p(t, e) {
        e = l(t, e, !0);

        for (var n = e._data, r = t._size[0], i = t._size[1], o = [], f = t._data, p = 0; p < i; p++) {
          var m,
              d = n[p][0] || 0;
          if (c(d, 0)) m = 0;else {
            var g = f[p][p];
            if (c(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
            m = a(d, g);

            for (var v = p + 1; v < r; v++) {
              n[v] = [u(n[v][0] || 0, s(m, f[v][p]))];
            }
          }
          o[p] = [m];
        }

        return new h({
          data: o,
          size: [r, 1]
        });
      },
          m = function m(t, e) {
        e = l(t, e, !0);

        for (var n, r, i = e._data, o = t._size[0], f = t._size[1], p = t._values, m = t._index, d = t._ptr, g = [], v = 0; v < f; v++) {
          var y = i[v][0] || 0;
          if (c(y, 0)) g[v] = [0];else {
            var x = 0,
                w = [],
                b = [],
                _ = d[v + 1];

            for (r = d[v]; r < _; r++) {
              n = m[r], n === v ? x = p[r] : n > v && (w.push(p[r]), b.push(n));
            }

            if (c(x, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
            var E = a(y, x);

            for (r = 0, _ = b.length; r < _; r++) {
              n = b[r], i[n] = [u(i[n][0] || 0, s(E, w[r]))];
            }

            g[v] = [E];
          }
        }

        return new h({
          data: g,
          size: [o, 1]
        });
      };

      return f;
    }

    e.name = "lsolve", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(20)),
          s = r(n(26)),
          u = r(n(24)),
          c = r(n(11)),
          l = r(n(79)),
          h = t.DenseMatrix,
          f = i("usolve", {
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(t, e) {
          return m(t, e);
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(t, e) {
          return p(t, e);
        },
        "Array, Array | Matrix": function ArrayArrayMatrix(t, e) {
          var n = o(t),
              r = p(n, e);
          return r.valueOf();
        }
      }),
          p = function p(t, e) {
        e = l(t, e, !0);

        for (var n = e._data, r = t._size[0], i = t._size[1], o = [], f = t._data, p = i - 1; p >= 0; p--) {
          var m,
              d = n[p][0] || 0;
          if (c(d, 0)) m = 0;else {
            var g = f[p][p];
            if (c(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
            m = a(d, g);

            for (var v = p - 1; v >= 0; v--) {
              n[v] = [u(n[v][0] || 0, s(m, f[v][p]))];
            }
          }
          o[p] = [m];
        }

        return new h({
          data: o,
          size: [r, 1]
        });
      },
          m = function m(t, e) {
        e = l(t, e, !0);

        for (var n, r, i = e._data, o = t._size[0], f = t._size[1], p = t._values, m = t._index, d = t._ptr, g = [], v = f - 1; v >= 0; v--) {
          var y = i[v][0] || 0;
          if (c(y, 0)) g[v] = [0];else {
            var x = 0,
                w = [],
                b = [],
                _ = d[v],
                E = d[v + 1];

            for (r = E - 1; r >= _; r--) {
              n = m[r], n === v ? x = p[r] : n < v && (w.push(p[r]), b.push(n));
            }

            if (c(x, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
            var M = a(y, x);

            for (r = 0, E = b.length; r < E; r++) {
              n = b[r], i[n] = [u(i[n][0], s(M, w[r]))];
            }

            g[v] = [M];
          }
        }

        return new h({
          data: g,
          size: [o, 1]
        });
      };

      return f;
    }

    e.name = "usolve", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(80)),
          o = function o(t, e) {
        t[e] = i(t[e]);
      };

      return o;
    }

    e.name = "cs_mark", e.path = "sparse", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t3, e) {
        return _t3[e] < 0;
      };

      return t;
    }

    e.name = "cs_marked", e.path = "sparse", e.factory = n;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t4, e, n, r, i, o, a) {
        var s = 0;

        for (n[a] = _t4; s >= 0;) {
          var u = n[a + s],
              c = n[r + u];
          c == -1 ? (s--, o[e++] = u) : (n[r + u] = n[i + c], ++s, n[a + s] = c);
        }

        return e;
      };

      return t;
    }

    e.name = "cs_tdfs", e.path = "sparse", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(20)),
          s = n(4),
          u = r(n(25)),
          c = r(n(15)),
          l = r(n(27)),
          h = r(n(16)),
          f = r(n(17)),
          p = r(n(7)),
          m = r(n(6)),
          d = i("dotDivide", {
        "any, any": a,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, a, !1);
                  break;

                default:
                  n = u(e, t, a, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, a, !1);
                  break;

                default:
                  n = p(t, e, a);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return d(o(t), o(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return d(o(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return d(t, o(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, a, !1);
              break;

            default:
              n = m(t, e, a, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = f(e, t, a, !0);
              break;

            default:
              n = m(e, t, a, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return m(o(t), e, a, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return m(o(e), t, a, !0).valueOf();
        }
      });
      return d.toTex = {
        2: "\\left(${args[0]}" + s.operators.dotDivide + "${args[1]}\\right)"
      }, d;
    }

    e.name = "dotDivide", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("fix", {
        number: function number(t) {
          return t > 0 ? Math.floor(t) : Math.ceil(t);
        },
        Complex: function Complex(e) {
          return new t.Complex(e.re > 0 ? Math.floor(e.re) : Math.ceil(e.re), e.im > 0 ? Math.floor(e.im) : Math.ceil(e.im));
        },
        BigNumber: function BigNumber(t) {
          return t.isNegative() ? t.ceil() : t.floor();
        },
        Fraction: function Fraction(t) {
          return t.s < 0 ? t.ceil() : t.floor();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "fix", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(20)),
          s = o("log", {
        number: function number(n) {
          return n >= 0 || e.predictable ? Math.log(n) : new t.Complex(n, 0).log();
        },
        Complex: function Complex(t) {
          return t.log();
        },
        BigNumber: function BigNumber(n) {
          return !n.isNegative() || e.predictable ? n.ln() : new t.Complex(n.toNumber(), 0).log();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, s);
        },
        "any, any": function anyAny(t, e) {
          return a(s(t), s(e));
        }
      });
      return s.toTex = {
        1: "\\ln\\left(${args[0]}\\right)",
        2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
      }, s;
    }

    var i = n(1);
    e.name = "log", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(18)),
          a = r(n(24)),
          s = r(n(13)),
          u = r(n(41)),
          c = r(n(42)),
          l = r(n(64)),
          h = r(n(63)),
          f = r(n(56)),
          p = r(n(46)),
          m = r(n(30)),
          d = i("stirlingS2", {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(t, e) {
          if (!p(t) || f(t) || !p(e) || f(e)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
          if (m(e, t)) throw new TypeError("k must be less than or equal to n in function stirlingS2");

          for (var n = l(e), r = 0, i = 0; i <= e; i++) {
            var d = c(-1, a(e, i)),
                g = h(e, i),
                v = c(i, t);
            r = o(r, s(s(g, v), d));
          }

          return u(r, n);
        }
      });
      return d.toTex = {
        2: "\\mathrm{S}\\left(${args}\\right)"
      }, d;
    }

    e.name = "stirlingS2", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = o("not", {
        number: function number(t) {
          return !t;
        },
        Complex: function Complex(t) {
          return 0 === t.re && 0 === t.im;
        },
        BigNumber: function BigNumber(t) {
          return t.isZero() || t.isNaN();
        },
        Unit: function Unit(t) {
          return s(t.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, s);
        }
      });
      return s.toTex = {
        1: a.operators.not + "\\left(${args[0]}\\right)"
      }, s;
    }

    var i = n(1);
    e.name = "not", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, l) {
      var h = r(n(2)),
          f = l("concat", {
        "...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumber(t) {
          var e,
              n,
              r = t.length,
              l = -1,
              f = !1,
              p = [];

          for (e = 0; e < r; e++) {
            var m = t[e];

            if (m && m.isMatrix === !0 && (f = !0), "number" == typeof m || m && m.isBigNumber === !0) {
              if (e !== r - 1) throw new Error("Dimension must be specified as last argument");
              if (n = l, l = m.valueOf(), !a(l)) throw new TypeError("Integer number expected for dimension");
              if (l < 0 || e > 0 && l > n) throw new u(l, n + 1);
            } else {
              var d = o(m).valueOf(),
                  g = s.size(d);
              if (p[e] = d, n = l, l = g.length - 1, e > 0 && l != n) throw new c(n + 1, l + 1);
            }
          }

          if (0 == p.length) throw new SyntaxError("At least one matrix expected");

          for (var v = p.shift(); p.length;) {
            v = i(v, p.shift(), l, 0);
          }

          return f ? h(v) : v;
        },
        "...string": function string(t) {
          return t.join("");
        }
      });
      return f.toTex = void 0, f;
    }

    function i(t, e, n, r) {
      if (r < n) {
        if (t.length != e.length) throw new c(t.length, e.length);

        for (var o = [], a = 0; a < t.length; a++) {
          o[a] = i(t[a], e[a], n, r + 1);
        }

        return o;
      }

      return t.concat(e);
    }

    var o = n(5).clone,
        a = n(3).isInteger,
        s = n(8),
        u = n(52),
        c = n(12);
    e.name = "concat", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function s(t, e, n) {
        if (1 == e) return o.clone(t[0][0]);
        if (2 == e) return l(h(t[0][0], t[1][1]), h(t[1][0], t[0][1]));

        for (var r = function r(t) {
          var e,
              n,
              r = new Array(t.length),
              i = 0;

          for (e = 1; e < t.length; e++) {
            i = c(i, t[e][e]);
          }

          for (e = 0; e < t.length; e++) {
            for (r[e] = new Array(t.length), r[e][e] = f(i), n = 0; n < e; n++) {
              r[e][n] = 0;
            }

            for (n = e + 1; n < t.length; n++) {
              r[e][n] = t[e][n];
            }

            e + 1 < t.length && (i = l(i, t[e + 1][e + 1]));
          }

          return r;
        }, i = t, a = 0; a < e - 1; a++) {
          i = h(r(i), t);
        }

        return e % 2 == 0 ? f(i[0][0]) : i[0][0];
      }

      var u = r(n(2)),
          c = r(n(18)),
          l = r(n(24)),
          h = r(n(13)),
          f = r(n(43)),
          p = i("det", {
        any: function any(t) {
          return o.clone(t);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          var e;

          switch (t && t.isMatrix === !0 ? e = t.size() : Array.isArray(t) ? (t = u(t), e = t.size()) : e = [], e.length) {
            case 0:
              return o.clone(t);

            case 1:
              if (1 == e[0]) return o.clone(t.valueOf()[0]);
              throw new RangeError("Matrix must be square (size: " + a.format(e) + ")");

            case 2:
              var n = e[0],
                  r = e[1];
              if (n == r) return s(t.clone().valueOf(), n, r);
              throw new RangeError("Matrix must be square (size: " + a.format(e) + ")");

            default:
              throw new RangeError("Matrix must be two dimensional (size: " + a.format(e) + ")");
          }
        }
      });
      return p.toTex = {
        1: "\\det\\left(${args[0]}\\right)"
      }, p;
    }

    var i = n(28),
        o = i.object,
        a = i.string;
    e.name = "det", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = a("filter", {
        "Array, function": i,
        "Array, RegExp": o,
        "Matrix, function": function MatrixFunction(t, e) {
          return s(i(t.toArray(), e));
        },
        "Matrix, RegExp": function MatrixRegExp(t, e) {
          return s(o(t.toArray(), e));
        }
      });
      return u.toTex = void 0, u;
    }

    function i(t, e) {
      if (1 !== a(t).length) throw new Error("Only one dimensional matrices supported");
      var n = s(e);
      return t.filter(function (t, r, i) {
        return 1 === n ? e(t) : 2 === n ? e(t, [r]) : e(t, [r], i);
      });
    }

    function o(t, e) {
      if (1 !== a(t).length) throw new Error("Only one dimensional matrices supported");
      return t.filter(function (t) {
        return e.test(t);
      });
    }

    var a = n(8).size,
        s = n(32).maxArgumentCount;
    e.name = "filter", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("forEach", {
        "Array, function": i,
        "Matrix, function": function MatrixFunction(t, e) {
          return t.forEach(e);
        }
      });
      return o.toTex = void 0, o;
    }

    function i(t, e) {
      var n = o(e),
          r = function r(i, o) {
        Array.isArray(i) ? i.forEach(function (t, e) {
          r(t, o.concat(e));
        }) : 1 === n ? e(i) : 2 === n ? e(i, o) : e(i, o, t);
      };

      r(t, []);
    }

    var o = n(32).maxArgumentCount;
    e.name = "forEach", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e, n) {
        var r, i, o, a, s;

        if (1 == e) {
          if (a = t[0][0], 0 == a) throw Error("Cannot calculate inverse, determinant is zero");
          return [[u(1, a)]];
        }

        if (2 == e) {
          var m = f(t);
          if (0 == m) throw Error("Cannot calculate inverse, determinant is zero");
          return [[u(t[1][1], m), u(h(t[0][1]), m)], [u(h(t[1][0]), m), u(t[0][0], m)]];
        }

        var d = t.concat();

        for (r = 0; r < e; r++) {
          d[r] = d[r].concat();
        }

        for (var g = p(e).valueOf(), v = 0; v < n; v++) {
          for (r = v; r < e && 0 == d[r][v];) {
            r++;
          }

          if (r == e || 0 == d[r][v]) throw Error("Cannot calculate inverse, determinant is zero");
          r != v && (s = d[v], d[v] = d[r], d[r] = s, s = g[v], g[v] = g[r], g[r] = s);
          var y = d[v],
              x = g[v];

          for (r = 0; r < e; r++) {
            var w = d[r],
                b = g[r];

            if (r != v) {
              if (0 != w[v]) {
                for (o = u(h(w[v]), y[v]), i = v; i < n; i++) {
                  w[i] = c(w[i], l(o, y[i]));
                }

                for (i = 0; i < n; i++) {
                  b[i] = c(b[i], l(o, x[i]));
                }
              }
            } else {
              for (o = y[v], i = v; i < n; i++) {
                w[i] = u(w[i], o);
              }

              for (i = 0; i < n; i++) {
                b[i] = u(b[i], o);
              }
            }
          }
        }

        return g;
      }

      var s = r(n(2)),
          u = r(n(20)),
          c = r(n(22)),
          l = r(n(13)),
          h = r(n(43)),
          f = r(n(132)),
          p = r(n(81)),
          m = o("inv", {
        "Array | Matrix": function ArrayMatrix(t) {
          var e = t.isMatrix === !0 ? t.size() : i.array.size(t);

          switch (e.length) {
            case 1:
              if (1 == e[0]) return t.isMatrix === !0 ? s([u(1, t.valueOf()[0])]) : [u(1, t[0])];
              throw new RangeError("Matrix must be square (size: " + i.string.format(e) + ")");

            case 2:
              var n = e[0],
                  r = e[1];
              if (n == r) return t.isMatrix === !0 ? s(a(t.valueOf(), n, r), t.storage()) : a(t, n, r);
              throw new RangeError("Matrix must be square (size: " + i.string.format(e) + ")");

            default:
              throw new RangeError("Matrix must be two dimensional (size: " + i.string.format(e) + ")");
          }
        },
        any: function any(t) {
          return u(1, t);
        }
      });
      return m.toTex = {
        1: "\\left(${args[0]}\\right)^{-1}"
      }, m;
    }

    var i = n(28);
    e.name = "inv", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("map", {
        "Array, function": i,
        "Matrix, function": function MatrixFunction(t, e) {
          return t.map(e);
        }
      });
      return o.toTex = void 0, o;
    }

    function i(t, e) {
      var n = o(e),
          r = function r(i, o) {
        return Array.isArray(i) ? i.map(function (t, e) {
          return r(t, o.concat(e));
        }) : 1 === n ? e(i) : 2 === n ? e(i, o) : e(i, o, t);
      };

      return r(t, []);
    }

    var o = n(32).maxArgumentCount;
    e.name = "map", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        return "Array" === e.matrix ? t : f(t);
      }

      function a(n, r) {
        var i = h(n);
        if (!i) throw new SyntaxError('String "' + n + '" is no valid range');
        var a;
        return "BigNumber" === e.number ? (a = r ? l : c, o(a(new t.BigNumber(i.start), new t.BigNumber(i.end), new t.BigNumber(i.step)))) : (a = r ? u : s, o(a(i.start, i.end, i.step)));
      }

      function s(t, e, n) {
        var r = [],
            i = t;
        if (n > 0) for (; i < e;) {
          r.push(i), i += n;
        } else if (n < 0) for (; i > e;) {
          r.push(i), i += n;
        }
        return r;
      }

      function u(t, e, n) {
        var r = [],
            i = t;
        if (n > 0) for (; i <= e;) {
          r.push(i), i += n;
        } else if (n < 0) for (; i >= e;) {
          r.push(i), i += n;
        }
        return r;
      }

      function c(t, e, n) {
        var r = [],
            i = t;
        if (n.gt(p)) for (; i.lt(e);) {
          r.push(i), i = i.plus(n);
        } else if (n.lt(p)) for (; i.gt(e);) {
          r.push(i), i = i.plus(n);
        }
        return r;
      }

      function l(t, e, n) {
        var r = [],
            i = t;
        if (n.gt(p)) for (; i.lte(e);) {
          r.push(i), i = i.plus(n);
        } else if (n.lt(p)) for (; i.gte(e);) {
          r.push(i), i = i.plus(n);
        }
        return r;
      }

      function h(t) {
        var e = t.split(":"),
            n = e.map(function (t) {
          return Number(t);
        }),
            r = n.some(function (t) {
          return isNaN(t);
        });
        if (r) return null;

        switch (n.length) {
          case 2:
            return {
              start: n[0],
              end: n[1],
              step: 1
            };

          case 3:
            return {
              start: n[0],
              end: n[2],
              step: n[1]
            };

          default:
            return null;
        }
      }

      var f = r(n(2)),
          p = new t.BigNumber(0),
          m = new t.BigNumber(1),
          d = i("range", {
        string: a,
        "string, boolean": a,
        "number, number": function numberNumber(t, e) {
          return o(s(t, e, 1));
        },
        "number, number, number": function numberNumberNumber(t, e, n) {
          return o(s(t, e, n));
        },
        "number, number, boolean": function numberNumberBoolean(t, e, n) {
          return o(n ? u(t, e, 1) : s(t, e, 1));
        },
        "number, number, number, boolean": function numberNumberNumberBoolean(t, e, n, r) {
          return o(r ? u(t, e, n) : s(t, e, n));
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return o(c(t, e, m));
        },
        "BigNumber, BigNumber, BigNumber": function BigNumberBigNumberBigNumber(t, e, n) {
          return o(c(t, e, n));
        },
        "BigNumber, BigNumber, boolean": function BigNumberBigNumberBoolean(t, e, n) {
          return o(n ? l(t, e, m) : c(t, e, m));
        },
        "BigNumber, BigNumber, BigNumber, boolean": function BigNumberBigNumberBigNumberBoolean(t, e, n, r) {
          return o(r ? l(t, e, n) : c(t, e, n));
        }
      });
      return d.toTex = void 0, d;
    }

    e.name = "range", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(18)),
          c = a("trace", {
        Array: function Array(t) {
          return c(s(t));
        },
        Matrix: function Matrix(t) {
          var e;

          switch (t.storage()) {
            case "dense":
              e = l(t);
              break;

            case "sparse":
              e = h(t);
          }

          return e;
        },
        any: i
      }),
          l = function l(t) {
        var e = t._size,
            n = t._data;

        switch (e.length) {
          case 1:
            if (1 == e[0]) return i(n[0]);
            throw new RangeError("Matrix must be square (size: " + o(e) + ")");

          case 2:
            var r = e[0],
                a = e[1];

            if (r === a) {
              for (var s = 0, c = 0; c < r; c++) {
                s = u(s, n[c][c]);
              }

              return s;
            }

            throw new RangeError("Matrix must be square (size: " + o(e) + ")");

          default:
            throw new RangeError("Matrix must be two dimensional (size: " + o(e) + ")");
        }
      },
          h = function h(t) {
        var e = t._values,
            n = t._index,
            r = t._ptr,
            i = t._size,
            a = i[0],
            s = i[1];

        if (a === s) {
          var c = 0;
          if (e.length > 0) for (var l = 0; l < s; l++) {
            for (var h = r[l], f = r[l + 1], p = h; p < f; p++) {
              var m = n[p];

              if (m === l) {
                c = u(c, e[p]);
                break;
              }

              if (m > l) break;
            }
          }
          return c;
        }

        throw new RangeError("Matrix must be square (size: " + o(i) + ")");
      };

      return c.toTex = {
        1: "\\mathrm{tr}\\left(${args[0]}\\right)"
      }, c;
    }

    var i = n(5).clone,
        o = n(23).format;
    e.name = "trace", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, u) {
      function c(n) {
        if (n.isZero()) return new t.BigNumber(1);

        for (var r = e.precision + (0 | Math.log(n.toNumber())), i = t.BigNumber.clone({
          precision: r
        }), o = new i(n), a = n.toNumber() - 1; a > 1;) {
          o = o.times(a), a--;
        }

        return new t.BigNumber(o.toPrecision(t.BigNumber.precision));
      }

      var l = r(n(13)),
          h = r(n(42)),
          f = u("gamma", {
        number: function number(t) {
          var e, n;

          if (o(t)) {
            if (t <= 0) return isFinite(t) ? 1 / 0 : NaN;
            if (t > 171) return 1 / 0;

            for (var r = t - 2, i = t - 1; r > 1;) {
              i *= r, r--;
            }

            return 0 == i && (i = 1), i;
          }

          if (t < .5) return Math.PI / (Math.sin(Math.PI * t) * f(1 - t));
          if (t >= 171.35) return 1 / 0;

          if (t > 85) {
            var u = t * t,
                c = u * t,
                l = c * t,
                h = l * t;
            return Math.sqrt(2 * Math.PI / t) * Math.pow(t / Math.E, t) * (1 + 1 / (12 * t) + 1 / (288 * u) - 139 / (51840 * c) - 571 / (2488320 * l) + 163879 / (209018880 * h) + 5246819 / (75246796800 * h * t));
          }

          --t, n = s[0];

          for (var p = 1; p < s.length; ++p) {
            n += s[p] / (t + p);
          }

          return e = t + a + .5, Math.sqrt(2 * Math.PI) * Math.pow(e, t + .5) * Math.exp(-e) * n;
        },
        Complex: function Complex(e) {
          var n, r;
          if (0 == e.im) return f(e.re);
          e = new t.Complex(e.re - 1, e.im), r = new t.Complex(s[0], 0);

          for (var i = 1; i < s.length; ++i) {
            var o = e.re + i,
                u = o * o + e.im * e.im;
            0 != u ? (r.re += s[i] * o / u, r.im += -(s[i] * e.im) / u) : r.re = s[i] < 0 ? -(1 / 0) : 1 / 0;
          }

          n = new t.Complex(e.re + a + .5, e.im);
          var c = Math.sqrt(2 * Math.PI);
          e.re += .5;
          var p = h(n, e);
          0 == p.im ? p.re *= c : 0 == p.re ? p.im *= c : (p.re *= c, p.im *= c);
          var m = Math.exp(-n.re);
          return n.re = m * Math.cos(-n.im), n.im = m * Math.sin(-n.im), l(l(p, n), r);
        },
        BigNumber: function BigNumber(e) {
          if (e.isInteger()) return e.isNegative() || e.isZero() ? new t.BigNumber(1 / 0) : c(e.minus(1));
          if (!e.isFinite()) return new t.BigNumber(e.isNegative() ? NaN : 1 / 0);
          throw new Error("Integer BigNumber expected");
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, f);
        }
      });
      return f.toTex = {
        1: "\\Gamma\\left(${args[0]}\\right)"
      }, f;
    }

    var i = n(1),
        o = n(3).isInteger,
        a = 4.7421875,
        s = [.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, .0001580887032249125, -.00021026444172410488, .00021743961811521265, -.0001643181065367639, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22];
    e.name = "gamma", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = n(4),
          m = a("largerEq", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t >= e;
        },
        "number, number": function numberNumber(t, n) {
          return t >= n || i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return t.gte(n) || o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.compare(e) !== -1;
        },
        "Complex, Complex": function ComplexComplex() {
          throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return m(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t >= e;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m);
                  break;

                default:
                  n = u(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, m, !1);
                  break;

                default:
                  n = h(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, m, !1);
              break;

            default:
              n = f(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, m, !0);
              break;

            default:
              n = f(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + p.operators.largerEq + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "largerEq", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      function u(t, e) {
        return l(t, e) ? t : e;
      }

      function c(t) {
        var e = void 0;
        if (i(t, function (t) {
          (void 0 === e || l(t, e)) && (e = t);
        }), void 0 === e) throw new Error("Cannot calculate max of an empty array");
        return e;
      }

      var l = r(n(30)),
          h = s("max", {
        "Array | Matrix": c,
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(t, e) {
          return o(t, e.valueOf(), u);
        },
        "...": function _(t) {
          if (a(t)) throw new TypeError("Scalar values expected in function max");
          return c(t);
        }
      });
      return h.toTex = "\\max\\left(${args}\\right)", h;
    }

    var i = n(38),
        o = n(69),
        a = n(68);
    e.name = "max", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, u) {
      function c(t, e) {
        var n = a(t, e, h),
            r = Array.isArray(t) ? i(t) : t.size();
        return f(n, r[e]);
      }

      function l(t) {
        var e = 0,
            n = 0;
        if (o(t, function (t) {
          e = h(e, t), n++;
        }), 0 === n) throw new Error("Cannot calculate mean of an empty array");
        return f(e, n);
      }

      var h = r(n(18)),
          f = r(n(41)),
          p = u("mean", {
        "Array | Matrix": l,
        "Array | Matrix, number | BigNumber": c,
        "...": function _(t) {
          if (s(t)) throw new TypeError("Scalar values expected in function mean");
          return l(t);
        }
      });
      return p.toTex = void 0, p;
    }

    var i = n(8).size,
        o = n(38),
        a = n(69),
        s = n(68);
    e.name = "mean", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      function u(t, e) {
        return l(t, e) ? t : e;
      }

      function c(t) {
        var e = void 0;
        if (i(t, function (t) {
          (void 0 === e || l(t, e)) && (e = t);
        }), void 0 === e) throw new Error("Cannot calculate min of an empty array");
        return e;
      }

      var l = r(n(45)),
          h = s("min", {
        "Array | Matrix": c,
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(t, e) {
          return o(t, e.valueOf(), u);
        },
        "...": function _(t) {
          if (a(t)) throw new TypeError("Scalar values expected in function min");
          return c(t);
        }
      });
      return h.toTex = "\\min\\left(${args}\\right)", h;
    }

    var i = n(38),
        o = n(69),
        a = n(68);
    e.name = "min", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(n) {
        var r = void 0;
        if (i(n, function (t) {
          r = void 0 === r ? t : s(r, t);
        }), void 0 === r) switch (e.number) {
          case "number":
            return 0;

          case "BigNumber":
            return new t.BigNumber(0);

          case "Fraction":
            return new t.Fraction(0);

          default:
            return 0;
        }
        return r;
      }

      var s = r(n(22)),
          u = o("sum", {
        "Array | Matrix": function ArrayMatrix(t) {
          return a(t);
        },
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber() {
          throw new Error("sum(A, dim) is not yet supported");
        },
        "...": function _(t) {
          return a(t);
        }
      });
      return u.toTex = void 0, u;
    }

    var i = n(38);
    e.name = "sum", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(e, n) {
        var r = 0,
            i = 0;
        if (0 == e.length) throw new SyntaxError("Function var requires one or more parameters (0 provided)");
        if (o(e, function (t) {
          r = u(r, t), i++;
        }), 0 === i) throw new Error("Cannot calculate var of an empty array");
        var a = h(r, i);

        switch (r = 0, o(e, function (t) {
          var e = c(t, a);
          r = u(r, l(e, e));
        }), n) {
          case "uncorrected":
            return h(r, i);

          case "biased":
            return h(r, i + 1);

          case "unbiased":
            var s = r && r.isBigNumber === !0 ? new t.BigNumber(0) : 0;
            return 1 == i ? s : h(r, i - 1);

          default:
            throw new Error('Unknown normalization "' + n + '". Choose "unbiased" (default), "uncorrected", or "biased".');
        }
      }

      var u = r(n(22)),
          c = r(n(24)),
          l = r(n(26)),
          h = r(n(20)),
          f = a("variance", {
        "Array | Matrix": function ArrayMatrix(t) {
          return s(t, i);
        },
        "Array | Matrix, string": s,
        "...": function _(t) {
          return s(t, i);
        }
      });
      return f.toTex = "\\mathrm{Var}\\left(${args}\\right)", f;
    }

    var i = "unbiased",
        o = n(38);
    e.name = "var", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("format", {
        any: i.format,
        "any, Object | function | number": i.format
      });
      return o.toTex = void 0, o;
    }

    var i = n(23);
    e.name = "format", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("acosh", {
        number: function number(n) {
          return n >= 1 || e.predictable ? o(n) : n <= -1 ? new t.Complex(Math.log(Math.sqrt(n * n - 1) - n), Math.PI) : new t.Complex(n, 0).acosh();
        },
        Complex: function Complex(t) {
          return t.acosh();
        },
        BigNumber: function BigNumber(t) {
          return t.acosh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        }
      });
      return a.toTex = {
        1: "\\cosh^{-1}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.acosh || function (t) {
      return Math.log(Math.sqrt(t * t - 1) + t);
    };

    e.name = "acosh", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isZero", {
        number: function number(t) {
          return 0 === t;
        },
        BigNumber: function BigNumber(t) {
          return t.isZero();
        },
        Complex: function Complex(t) {
          return 0 === t.re && 0 === t.im;
        },
        Fraction: function Fraction(t) {
          return 1 === t.d && 0 === t.n;
        },
        Unit: function Unit(t) {
          return o(t.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    n(3);
    e.name = "isZero", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("_typeof", {
        any: function any(t) {
          var e = i.type(t);

          if ("Object" === e) {
            if (t.isBigNumber === !0) return "BigNumber";
            if (t.isComplex === !0) return "Complex";
            if (t.isFraction === !0) return "Fraction";
            if (t.isMatrix === !0) return "Matrix";
            if (t.isUnit === !0) return "Unit";
            if (t.isIndex === !0) return "Index";
            if (t.isRange === !0) return "Range";
            if (t.isChain === !0) return "Chain";
            if (t.isHelp === !0) return "Help";
          }

          return e;
        }
      });
      return o.toTex = void 0, o;
    }

    var i = n(70);
    e.name = "typeof", e.factory = r;
  }, function (t, e, n) {
    function r(t, e, n, r, s) {
      return i.prototype.type = "Complex", i.prototype.isComplex = !0, i.prototype.toJSON = function () {
        return {
          mathjs: "Complex",
          re: this.re,
          im: this.im
        };
      }, i.prototype.toPolar = function () {
        return {
          r: this.abs(),
          phi: this.arg()
        };
      }, i.prototype.format = function (t) {
        var e = "",
            n = this.im,
            r = this.re,
            i = o(this.re, t),
            s = o(this.im, t),
            u = a(t) ? t : t ? t.precision : null;

        if (null !== u) {
          var c = Math.pow(10, -u);
          Math.abs(r / n) < c && (r = 0), Math.abs(n / r) < c && (n = 0);
        }

        return e = 0 == n ? i : 0 == r ? 1 == n ? "i" : n == -1 ? "-i" : s + "i" : n > 0 ? 1 == n ? i + " + i" : i + " + " + s + "i" : n == -1 ? i + " - i" : i + " - " + s.substring(1) + "i";
      }, i.fromPolar = function (t) {
        switch (arguments.length) {
          case 1:
            var e = arguments[0];
            if ("object" == typeof e) return i(e);
            throw new TypeError("Input has to be an object with r and phi keys.");

          case 2:
            var n = arguments[0],
                r = arguments[1];

            if (a(n)) {
              if (r && r.isUnit && r.hasBase("ANGLE") && (r = r.toNumber("rad")), a(r)) return new i({
                r: n,
                phi: r
              });
              throw new TypeError("Phi is not a number nor an angle unit.");
            }

            throw new TypeError("Radius r is not a number.");

          default:
            throw new SyntaxError("Wrong number of arguments in function fromPolar");
        }
      }, i.prototype.valueOf = i.prototype.toString, i.fromJSON = function (t) {
        return new i(t);
      }, i.EPSILON = e.epsilon, s.on("config", function (t, e) {
        t.epsilon !== e.epsilon && (i.EPSILON = t.epsilon);
      }), i;
    }

    var i = n(176),
        o = n(3).format,
        a = n(3).isNumber;
    e.name = "Complex", e.path = "type", e.factory = r, e.math = !0;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("fraction", {
        number: function number(e) {
          if (!isFinite(e) || isNaN(e)) throw new Error(e + " cannot be represented as a fraction");
          return new t.Fraction(e);
        },
        string: function string(e) {
          return new t.Fraction(e);
        },
        "number, number": function numberNumber(e, n) {
          return new t.Fraction(e, n);
        },
        BigNumber: function BigNumber(e) {
          return new t.Fraction(e.toString());
        },
        Fraction: function Fraction(t) {
          return t;
        },
        Object: function Object(e) {
          return new t.Fraction(e);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    e.name = "fraction", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, c) {
      function d(t, e) {
        if (!(this instanceof d)) throw new SyntaxError("Constructor must be called with the new operator");
        if (e && !p(e)) throw new Error("Invalid datatype: " + e);
        if (t && t.isMatrix === !0) "DenseMatrix" === t.type ? (this._data = u.clone(t._data), this._size = u.clone(t._size), this._datatype = e || t._datatype) : (this._data = t.toArray(), this._size = t.size(), this._datatype = e || t._datatype);else if (t && l(t.data) && l(t.size)) this._data = t.data, this._size = t.size, this._datatype = e || t.datatype;else if (l(t)) this._data = b(t), this._size = s.size(this._data), s.validate(this._data, this._size), this._datatype = e;else {
          if (t) throw new TypeError("Unsupported type of data (" + i.types.type(t) + ")");
          this._data = [], this._size = [0], this._datatype = e;
        }
      }

      function g(t, e) {
        if (!e || e.isIndex !== !0) throw new TypeError("Invalid index");
        var n = e.isScalar();
        if (n) return t.get(e.min());
        var r = e.size();
        if (r.length != t._size.length) throw new o(r.length, t._size.length);

        for (var i = e.min(), a = e.max(), s = 0, u = t._size.length; s < u; s++) {
          m(i[s], t._size[s]), m(a[s], t._size[s]);
        }

        return new d(v(t._data, e, r.length, 0), t._datatype);
      }

      function v(t, e, n, r) {
        var i = r == n - 1,
            o = e.dimension(r);
        return i ? o.map(function (e) {
          return t[e];
        }).valueOf() : o.map(function (i) {
          var o = t[i];
          return v(o, e, n, r + 1);
        }).valueOf();
      }

      function y(t, e, n, r) {
        if (!e || e.isIndex !== !0) throw new TypeError("Invalid index");
        var i,
            a = e.size(),
            c = e.isScalar();

        if (n && n.isMatrix === !0 ? (i = n.size(), n = n.valueOf()) : i = s.size(n), c) {
          if (0 !== i.length) throw new TypeError("Scalar expected");
          t.set(e.min(), n, r);
        } else {
          if (a.length < t._size.length) throw new o(a.length, t._size.length, "<");

          if (i.length < a.length) {
            for (var l = 0, h = 0; 1 === a[l] && 1 === i[l];) {
              l++;
            }

            for (; 1 === a[l];) {
              h++, l++;
            }

            n = s.unsqueeze(n, a.length, h, i);
          }

          if (!u.deepEqual(a, i)) throw new o(a, i, ">");
          var f = e.max().map(function (t) {
            return t + 1;
          });
          w(t, f, r);
          var p = a.length,
              m = 0;
          x(t._data, e, n, p, m);
        }

        return t;
      }

      function x(t, e, n, r, i) {
        var o = i == r - 1,
            a = e.dimension(i);
        o ? a.forEach(function (e, r) {
          m(e), t[e] = n[r[0]];
        }) : a.forEach(function (o, a) {
          m(o), x(t[o], e, n[a[0]], r, i + 1);
        });
      }

      function w(t, e, n) {
        for (var r = t._size.slice(0), i = !1; r.length < e.length;) {
          r.push(0), i = !0;
        }

        for (var o = 0, a = e.length; o < a; o++) {
          e[o] > r[o] && (r[o] = e[o], i = !0);
        }

        i && E(t, r, n);
      }

      function b(t) {
        for (var e = 0, n = t.length; e < n; e++) {
          var r = t[e];
          l(r) ? t[e] = b(r) : r && r.isMatrix === !0 && (t[e] = b(r.valueOf()));
        }

        return t;
      }

      var _ = r(n(86));

      d.prototype = new _(), d.prototype.type = "DenseMatrix", d.prototype.isDenseMatrix = !0, d.prototype.storage = function () {
        return "dense";
      }, d.prototype.datatype = function () {
        return this._datatype;
      }, d.prototype.create = function (t, e) {
        return new d(t, e);
      }, d.prototype.subset = function (t, e, n) {
        switch (arguments.length) {
          case 1:
            return g(this, t);

          case 2:
          case 3:
            return y(this, t, e, n);

          default:
            throw new SyntaxError("Wrong number of arguments");
        }
      }, d.prototype.get = function (t) {
        if (!l(t)) throw new TypeError("Array expected");
        if (t.length != this._size.length) throw new o(t.length, this._size.length);

        for (var e = 0; e < t.length; e++) {
          m(t[e], this._size[e]);
        }

        for (var n = this._data, r = 0, i = t.length; r < i; r++) {
          var a = t[r];
          m(a, n.length), n = n[a];
        }

        return n;
      }, d.prototype.set = function (t, e, n) {
        if (!l(t)) throw new TypeError("Array expected");
        if (t.length < this._size.length) throw new o(t.length, this._size.length, "<");
        var r,
            i,
            a,
            s = t.map(function (t) {
          return t + 1;
        });
        w(this, s, n);
        var u = this._data;

        for (r = 0, i = t.length - 1; r < i; r++) {
          a = t[r], m(a, u.length), u = u[a];
        }

        return a = t[t.length - 1], m(a, u.length), u[a] = e, this;
      }, d.prototype.resize = function (t, e, n) {
        if (!l(t)) throw new TypeError("Array expected");
        var r = n ? this.clone() : this;
        return E(r, t, e);
      };

      var E = function E(t, e, n) {
        if (0 === e.length) {
          for (var r = t._data; l(r);) {
            r = r[0];
          }

          return r;
        }

        return t._size = e.slice(0), t._data = s.resize(t._data, t._size, n), t;
      };

      return d.prototype.clone = function () {
        var t = new d({
          data: u.clone(this._data),
          size: u.clone(this._size),
          datatype: this._datatype
        });
        return t;
      }, d.prototype.size = function () {
        return this._size.slice(0);
      }, d.prototype.map = function (t) {
        var e = this,
            n = function n(r, i) {
          return l(r) ? r.map(function (t, e) {
            return n(t, i.concat(e));
          }) : t(r, i, e);
        };

        return new d({
          data: n(this._data, []),
          size: u.clone(this._size),
          datatype: this._datatype
        });
      }, d.prototype.forEach = function (t) {
        var e = this,
            n = function n(r, i) {
          l(r) ? r.forEach(function (t, e) {
            n(t, i.concat(e));
          }) : t(r, i, e);
        };

        n(this._data, []);
      }, d.prototype.toArray = function () {
        return u.clone(this._data);
      }, d.prototype.valueOf = function () {
        return this._data;
      }, d.prototype.format = function (t) {
        return a.format(this._data, t);
      }, d.prototype.toString = function () {
        return a.format(this._data);
      }, d.prototype.toJSON = function () {
        return {
          mathjs: "DenseMatrix",
          data: this._data,
          size: this._size,
          datatype: this._datatype
        };
      }, d.prototype.diagonal = function (t) {
        if (t) {
          if (t.isBigNumber === !0 && (t = t.toNumber()), !h(t) || !f(t)) throw new TypeError("The parameter k must be an integer number");
        } else t = 0;

        for (var e = t > 0 ? t : 0, n = t < 0 ? -t : 0, r = this._size[0], i = this._size[1], o = Math.min(r - n, i - e), a = [], s = 0; s < o; s++) {
          a[s] = this._data[s + n][s + e];
        }

        return new d({
          data: a,
          size: [o],
          datatype: this._datatype
        });
      }, d.diagonal = function (e, n, r, i, o) {
        if (!l(e)) throw new TypeError("Array expected, size parameter");
        if (2 !== e.length) throw new Error("Only two dimensions matrix are supported");

        if (e = e.map(function (t) {
          if (t && t.isBigNumber === !0 && (t = t.toNumber()), !h(t) || !f(t) || t < 1) throw new Error("Size values must be positive integers");
          return t;
        }), r) {
          if (r && r.isBigNumber === !0 && (r = r.toNumber()), !h(r) || !f(r)) throw new TypeError("The parameter k must be an integer number");
        } else r = 0;

        i && p(o) && (i = c.convert(i, o));
        var a,
            u = r > 0 ? r : 0,
            m = r < 0 ? -r : 0,
            g = e[0],
            v = e[1],
            y = Math.min(g - m, v - u);

        if (l(n)) {
          if (n.length !== y) throw new Error("Invalid value array length");

          a = function a(t) {
            return n[t];
          };
        } else if (n && n.isMatrix === !0) {
          var x = n.size();
          if (1 !== x.length || x[0] !== y) throw new Error("Invalid matrix length");

          a = function a(t) {
            return n.get([t]);
          };
        } else a = function a() {
          return n;
        };

        i || (i = a(0) && a(0).isBigNumber === !0 ? new t.BigNumber(0) : 0);
        var w = [];

        if (e.length > 0) {
          w = s.resize(w, e, i);

          for (var b = 0; b < y; b++) {
            w[b + m][b + u] = a(b);
          }
        }

        return new d({
          data: w,
          size: [g, v]
        });
      }, d.fromJSON = function (t) {
        return new d(t);
      }, d.prototype.swapRows = function (t, e) {
        if (!(h(t) && f(t) && h(e) && f(e))) throw new Error("Row index must be positive integers");
        if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
        return m(t, this._size[0]), m(e, this._size[0]), d._swapRows(t, e, this._data), this;
      }, d._swapRows = function (t, e, n) {
        var r = n[t];
        n[t] = n[e], n[e] = r;
      }, t.Matrix._storage.dense = d, t.Matrix._storage.default = d, d;
    }

    var i = n(28),
        o = n(12),
        a = i.string,
        s = i.array,
        u = i.object,
        c = i.number,
        l = Array.isArray,
        h = c.isNumber,
        f = c.isInteger,
        p = a.isString,
        m = s.validateIndex;
    e.name = "DenseMatrix", e.path = "type", e.factory = r, e.lazy = !1;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      function o(t, e, n) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (null != t) if (t.isBigNumber === !0) t = t.toNumber();else if ("number" != typeof t) throw new TypeError("Parameter start must be a number");
        if (null != e) if (e.isBigNumber === !0) e = e.toNumber();else if ("number" != typeof e) throw new TypeError("Parameter end must be a number");
        if (null != n) if (n.isBigNumber === !0) n = n.toNumber();else if ("number" != typeof n) throw new TypeError("Parameter step must be a number");
        this.start = null != t ? parseFloat(t) : 0, this.end = null != e ? parseFloat(e) : 0, this.step = null != n ? parseFloat(n) : 1;
      }

      return o.prototype.type = "Range", o.prototype.isRange = !0, o.parse = function (t) {
        if ("string" != typeof t) return null;
        var e = t.split(":"),
            n = e.map(function (t) {
          return parseFloat(t);
        }),
            r = n.some(function (t) {
          return isNaN(t);
        });
        if (r) return null;

        switch (n.length) {
          case 2:
            return new o(n[0], n[1]);

          case 3:
            return new o(n[0], n[2], n[1]);

          default:
            return null;
        }
      }, o.prototype.clone = function () {
        return new o(this.start, this.end, this.step);
      }, o.prototype.size = function () {
        var t = 0,
            e = this.start,
            n = this.step,
            r = this.end,
            o = r - e;
        return i.sign(n) == i.sign(o) ? t = Math.ceil(o / n) : 0 == o && (t = 0), isNaN(t) && (t = 0), [t];
      }, o.prototype.min = function () {
        var t = this.size()[0];
        return t > 0 ? this.step > 0 ? this.start : this.start + (t - 1) * this.step : void 0;
      }, o.prototype.max = function () {
        var t = this.size()[0];
        return t > 0 ? this.step > 0 ? this.start + (t - 1) * this.step : this.start : void 0;
      }, o.prototype.forEach = function (t) {
        var e = this.start,
            n = this.step,
            r = this.end,
            i = 0;
        if (n > 0) for (; e < r;) {
          t(e, [i], this), e += n, i++;
        } else if (n < 0) for (; e > r;) {
          t(e, [i], this), e += n, i++;
        }
      }, o.prototype.map = function (t) {
        var e = [];
        return this.forEach(function (n, r, i) {
          e[r[0]] = t(n, r, i);
        }), e;
      }, o.prototype.toArray = function () {
        var t = [];
        return this.forEach(function (e, n) {
          t[n[0]] = e;
        }), t;
      }, o.prototype.valueOf = function () {
        return this.toArray();
      }, o.prototype.format = function (t) {
        var e = i.format(this.start, t);
        return 1 != this.step && (e += ":" + i.format(this.step, t)), e += ":" + i.format(this.end, t);
      }, o.prototype.toString = function () {
        return this.format();
      }, o.prototype.toJSON = function () {
        return {
          mathjs: "Range",
          start: this.start,
          end: this.end,
          step: this.step
        };
      }, o.fromJSON = function (t) {
        return new o(t.start, t.end, t.step);
      }, o;
    }

    var i = n(3);
    e.name = "Range", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(11)),
          s = t.SparseMatrix,
          u = function u(t, e, n) {
        var r = t._values,
            u = t._index,
            c = t._ptr,
            l = t._size,
            h = t._datatype,
            f = e._values,
            p = e._index,
            m = e._ptr,
            d = e._size,
            g = e._datatype;
        if (l.length !== d.length) throw new i(l.length, d.length);
        if (l[0] !== d[0] || l[1] !== d[1]) throw new RangeError("Dimension mismatch. Matrix A (" + l + ") must match Matrix B (" + d + ")");
        var v,
            y = l[0],
            x = l[1],
            w = a,
            b = 0,
            _ = n;
        "string" == typeof h && h === g && (v = h, w = o.find(a, [v, v]), b = o.convert(0, v), _ = o.find(n, [v, v]));
        var E,
            M,
            T,
            N,
            S,
            A = r && f ? [] : void 0,
            O = [],
            C = [],
            P = new s({
          values: A,
          index: O,
          ptr: C,
          size: [y, x],
          datatype: v
        }),
            R = A ? [] : void 0,
            I = [];

        for (M = 0; M < x; M++) {
          C[M] = O.length;
          var k = M + 1;
          if (R) for (N = m[M], S = m[M + 1], T = N; T < S; T++) {
            E = p[T], I[E] = k, R[E] = f[T];
          }

          for (N = c[M], S = c[M + 1], T = N; T < S; T++) {
            if (E = u[T], R) {
              var z = I[E] === k ? R[E] : b,
                  B = _(r[T], z);

              w(B, b) || (O.push(E), A.push(B));
            } else O.push(E);
          }
        }

        return C[x] = O.length, P;
      };

      return u;
    }

    var i = n(12);
    e.name = "algorithm09", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      function i(t) {
        if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
        this.entries = t || [];
      }

      return i.prototype.type = "ResultSet", i.prototype.isResultSet = !0, i.prototype.valueOf = function () {
        return this.entries;
      }, i.prototype.toString = function () {
        return "[" + this.entries.join(", ") + "]";
      }, i.prototype.toJSON = function () {
        return {
          mathjs: "ResultSet",
          entries: this.entries
        };
      }, i.fromJSON = function (t) {
        return new i(t.entries);
      }, i;
    }

    e.name = "ResultSet", e.path = "type", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s, u) {
      function c(t, e) {
        if (!(this instanceof c)) throw new Error("Constructor must be called with the new operator");
        if (void 0 !== t && !O(t) && !t.isComplex) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
        if (void 0 != e && ("string" != typeof e || "" == e)) throw new TypeError("Second parameter in Unit constructor must be a string");

        if (void 0 != e) {
          var n = c.parse(e);
          this.units = n.units, this.dimensions = n.dimensions;
        } else {
          this.units = [{
            unit: H,
            prefix: D.NONE,
            power: 0
          }], this.dimensions = [];

          for (var r = 0; r < F.length; r++) {
            this.dimensions[r] = 0;
          }
        }

        this.value = void 0 != t ? this._normalize(t) : null, this.fixPrefix = !1, this.isUnitListSimplified = !0;
      }

      function l() {
        for (; " " == B || "\t" == B;) {
          p();
        }
      }

      function h(t) {
        return t >= "0" && t <= "9" || "." == t;
      }

      function f(t) {
        return t >= "0" && t <= "9";
      }

      function p() {
        z++, B = k.charAt(z);
      }

      function m(t) {
        z = t, B = k.charAt(z);
      }

      function d() {
        var t,
            e = "";
        if (t = z, "+" == B ? p() : "-" == B && (e += B, p()), !h(B)) return m(t), null;

        if ("." == B) {
          if (e += B, p(), !f(B)) return m(t), null;
        } else {
          for (; f(B);) {
            e += B, p();
          }

          "." == B && (e += B, p());
        }

        for (; f(B);) {
          e += B, p();
        }

        if ("E" == B || "e" == B) {
          var n = "",
              r = z;
          if (n += B, p(), "+" != B && "-" != B || (n += B, p()), !f(B)) return m(r), e;

          for (e += n; f(B);) {
            e += B, p();
          }
        }

        return e;
      }

      function g() {
        for (var t = "", e = k.charCodeAt(z); e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122;) {
          t += B, p(), e = k.charCodeAt(z);
        }

        return e = t.charCodeAt(0), e >= 65 && e <= 90 || e >= 97 && e <= 122 ? t || null : null;
      }

      function v(t) {
        return B === t ? (p(), t) : null;
      }

      function y(t) {
        if (W.hasOwnProperty(t)) {
          var e = W[t],
              n = e.prefixes[""];
          return {
            unit: e,
            prefix: n
          };
        }

        for (var r in W) {
          if (W.hasOwnProperty(r) && i(t, r)) {
            var e = W[r],
                o = t.length - r.length,
                a = t.substring(0, o),
                n = e.prefixes[a];
            if (void 0 !== n) return {
              unit: e,
              prefix: n
            };
          }
        }

        return null;
      }

      function x(e) {
        if ("BigNumber" === e.number) {
          var n = a.pi(t.BigNumber);
          W.rad.value = new t.BigNumber(1), W.deg.value = n.div(180), W.grad.value = n.div(200), W.cycle.value = n.times(2), W.arcsec.value = n.div(648e3), W.arcmin.value = n.div(10800);
        } else W.rad.value = 1, W.deg.value = Math.PI / 180, W.grad.value = Math.PI / 200, W.cycle.value = 2 * Math.PI, W.arcsec.value = Math.PI / 648e3, W.arcmin.value = Math.PI / 10800;
      }

      function w(t) {
        for (var e = 0; e < t.length; e++) {
          var n = t.charAt(e),
              r = function r(t) {
            return /^[a-zA-Z]$/.test(t);
          },
              i = function i(t) {
            return t >= "0" && t <= "9";
          };

          if (0 === e && !r(n)) throw new Error('Invalid unit name (must begin with alpha character): "' + t + '"');
          if (e > 0 && !r(n) && !i(n)) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + t + '"');
        }
      }

      var b = r(n(22)),
          _ = r(n(24)),
          E = r(n(26)),
          M = r(n(20)),
          T = r(n(42)),
          N = r(n(35)),
          S = r(n(127)),
          A = r(n(84)),
          O = r(n(85)),
          C = r(n(146)),
          P = r(n(149)),
          R = r(n(89)),
          I = r(n(150));

      c.prototype.type = "Unit", c.prototype.isUnit = !0;
      var k, z, B;
      c.parse = function (n, r) {
        if (r = r || {}, k = n, z = -1, B = "", "string" != typeof k) throw new TypeError("Invalid argument in Unit.parse, string expected");
        var i = new c();
        i.units = [], p(), l();
        var o = d(),
            a = null;
        o && (a = "BigNumber" === e.number ? new t.BigNumber(o) : "Fraction" === e.number ? new t.Fraction(o) : parseFloat(o)), l();

        for (var s = 1, u = !1, h = [], f = 1;;) {
          for (l(); "(" === B;) {
            h.push(s), f *= s, s = 1, p(), l();
          }

          if (!B) break;
          var m = B,
              x = g();
          if (null == x) throw new SyntaxError('Unexpected "' + m + '" in "' + k + '" at index ' + z.toString());
          var w = y(x);
          if (null == w) throw new SyntaxError('Unit "' + x + '" not found.');
          var b = s * f;

          if (l(), v("^")) {
            l();

            var _ = d();

            if (null == _) throw new SyntaxError('In "' + n + '", "^" must be followed by a floating-point number');
            b *= _;
          }

          i.units.push({
            unit: w.unit,
            prefix: w.prefix,
            power: b
          });

          for (var E = 0; E < F.length; E++) {
            i.dimensions[E] += (w.unit.dimensions[E] || 0) * b;
          }

          for (l(); ")" === B;) {
            if (0 === h.length) throw new SyntaxError('Unmatched ")" in "' + k + '" at index ' + z.toString());
            f /= h.pop(), p(), l();
          }

          if (u = !1, v("*") ? (s = 1, u = !0) : v("/") ? (s = -1, u = !0) : s = 1, w.unit.base) {
            var M = w.unit.base.key;
            $.auto[M] = {
              unit: w.unit,
              prefix: w.prefix
            };
          }
        }

        if (l(), B) throw new SyntaxError('Could not parse: "' + n + '"');
        if (u) throw new SyntaxError('Trailing characters: "' + n + '"');
        if (0 !== h.length) throw new SyntaxError('Unmatched "(" in "' + k + '"');
        if (0 == i.units.length && !r.allowNoUnits) throw new SyntaxError('"' + n + '" contains no units');
        return i.value = void 0 != a ? i._normalize(a) : null, i;
      }, c.prototype.clone = function () {
        var t = new c();
        t.fixPrefix = this.fixPrefix, t.isUnitListSimplified = this.isUnitListSimplified, t.value = o(this.value), t.dimensions = this.dimensions.slice(0), t.units = [];

        for (var e = 0; e < this.units.length; e++) {
          t.units[e] = {};

          for (var n in this.units[e]) {
            this.units[e].hasOwnProperty(n) && (t.units[e][n] = this.units[e][n]);
          }
        }

        return t;
      }, c.prototype._isDerived = function () {
        return 0 !== this.units.length && (this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15);
      }, c.prototype._normalize = function (t) {
        var e, n, r, i, o;
        if (null == t || 0 === this.units.length) return t;

        if (this._isDerived()) {
          var a = t;
          o = c._getNumberConverter(P(t));

          for (var s = 0; s < this.units.length; s++) {
            e = o(this.units[s].unit.value), i = o(this.units[s].prefix.value), r = o(this.units[s].power), a = E(a, T(E(e, i), r));
          }

          return a;
        }

        return o = c._getNumberConverter(P(t)), e = o(this.units[0].unit.value), n = o(this.units[0].unit.offset), i = o(this.units[0].prefix.value), E(b(t, n), E(e, i));
      }, c.prototype._denormalize = function (t, e) {
        var n, r, i, o, a;
        if (null == t || 0 === this.units.length) return t;

        if (this._isDerived()) {
          var s = t;
          a = c._getNumberConverter(P(t));

          for (var u = 0; u < this.units.length; u++) {
            n = a(this.units[u].unit.value), o = a(this.units[u].prefix.value), i = a(this.units[u].power), s = M(s, T(E(n, o), i));
          }

          return s;
        }

        return a = c._getNumberConverter(P(t)), n = a(this.units[0].unit.value), o = a(this.units[0].prefix.value), r = a(this.units[0].unit.offset), void 0 == e ? _(M(M(t, n), o), r) : _(M(M(t, n), e), r);
      }, c.isValuelessUnit = function (t) {
        return null != y(t);
      }, c.prototype.hasBase = function (t) {
        if ("string" == typeof t && (t = U[t]), !t) return !1;

        for (var e = 0; e < F.length; e++) {
          if (Math.abs((this.dimensions[e] || 0) - (t.dimensions[e] || 0)) > 1e-12) return !1;
        }

        return !0;
      }, c.prototype.equalBase = function (t) {
        for (var e = 0; e < F.length; e++) {
          if (Math.abs((this.dimensions[e] || 0) - (t.dimensions[e] || 0)) > 1e-12) return !1;
        }

        return !0;
      }, c.prototype.equals = function (t) {
        return this.equalBase(t) && A(this.value, t.value);
      }, c.prototype.multiply = function (t) {
        for (var e = this.clone(), n = 0; n < F.length; n++) {
          e.dimensions[n] = (this.dimensions[n] || 0) + (t.dimensions[n] || 0);
        }

        for (var n = 0; n < t.units.length; n++) {
          var r = {};

          for (var i in t.units[n]) {
            r[i] = t.units[n][i];
          }

          e.units.push(r);
        }

        if (null != this.value || null != t.value) {
          var o = null == this.value ? this._normalize(1) : this.value,
              a = null == t.value ? t._normalize(1) : t.value;
          e.value = E(o, a);
        } else e.value = null;

        return e.isUnitListSimplified = !1, L(e);
      }, c.prototype.divide = function (t) {
        for (var e = this.clone(), n = 0; n < F.length; n++) {
          e.dimensions[n] = (this.dimensions[n] || 0) - (t.dimensions[n] || 0);
        }

        for (var n = 0; n < t.units.length; n++) {
          var r = {};

          for (var i in t.units[n]) {
            r[i] = t.units[n][i];
          }

          r.power = -r.power, e.units.push(r);
        }

        if (null != this.value || null != t.value) {
          var o = null == this.value ? this._normalize(1) : this.value,
              a = null == t.value ? t._normalize(1) : t.value;
          e.value = M(o, a);
        } else e.value = null;

        return e.isUnitListSimplified = !1, L(e);
      }, c.prototype.pow = function (t) {
        for (var e = this.clone(), n = 0; n < F.length; n++) {
          e.dimensions[n] = (this.dimensions[n] || 0) * t;
        }

        for (var n = 0; n < e.units.length; n++) {
          e.units[n].power *= t;
        }

        return null != e.value ? e.value = T(e.value, t) : e.value = null, e.isUnitListSimplified = !1, L(e);
      };

      var L = function L(t) {
        return t.equalBase(U.NONE) && null !== t.value && !e.predictable ? t.value : t;
      };

      c.prototype.abs = function () {
        var t = this.clone();
        t.value = N(t.value);

        for (var e in t.units) {
          "VA" !== t.units[e].unit.name && "VAR" !== t.units[e].unit.name || (t.units[e].unit = W.W);
        }

        return t;
      }, c.prototype.to = function (t) {
        var e,
            n = null == this.value ? this._normalize(1) : this.value;

        if ("string" == typeof t) {
          if (e = c.parse(t), !this.equalBase(e)) throw new Error("Units do not match");
          if (null !== e.value) throw new Error("Cannot convert to a unit with a value");
          return e.value = o(n), e.fixPrefix = !0, e.isUnitListSimplified = !0, e;
        }

        if (t && t.isUnit) {
          if (!this.equalBase(t)) throw new Error("Units do not match");
          if (null !== t.value) throw new Error("Cannot convert to a unit with a value");
          return e = t.clone(), e.value = o(n), e.fixPrefix = !0, e.isUnitListSimplified = !0, e;
        }

        throw new Error("String or Unit expected as parameter");
      }, c.prototype.toNumber = function (t) {
        return R(this.toNumeric(t));
      }, c.prototype.toNumeric = function (t) {
        var e = this;
        return t && (e = this.to(t)), e._isDerived() ? e._denormalize(e.value) : e._denormalize(e.value, e.units[0].prefix.value);
      }, c.prototype.toString = function () {
        return this.format();
      }, c.prototype.toJSON = function () {
        return {
          mathjs: "Unit",
          value: this._denormalize(this.value),
          unit: this.formatUnits(),
          fixPrefix: this.fixPrefix
        };
      }, c.fromJSON = function (t) {
        var e = new c(t.value, t.unit);
        return e.fixPrefix = t.fixPrefix || !1, e;
      }, c.prototype.valueOf = c.prototype.toString, c.prototype.simplifyUnitListLazy = function () {
        if (!this.isUnitListSimplified && null != this.value) {
          var t,
              e = [];

          for (var r in V) {
            if (this.hasBase(U[r])) {
              t = r;
              break;
            }
          }

          if ("NONE" === t) this.units = [];else {
            var i;
            t && V.hasOwnProperty(t) && (i = V[t]);
            if (i) this.units = [{
              unit: i.unit,
              prefix: i.prefix,
              power: 1
            }];else {
              for (var o = !1, a = 0; a < F.length; a++) {
                var s = F[a];
                Math.abs(this.dimensions[a] || 0) > 1e-12 && (V.hasOwnProperty(s) ? e.push({
                  unit: V[s].unit,
                  prefix: V[s].prefix,
                  power: this.dimensions[a] || 0
                }) : o = !0);
              }

              n(581);
              e.length < this.units.length && !o && (this.units = e);
            }
          }
          this.isUnitListSimplified = !0;
        }
      }, c.prototype.formatUnits = function () {
        this.simplifyUnitListLazy();

        for (var t = "", e = "", n = 0, r = 0, i = 0; i < this.units.length; i++) {
          this.units[i].power > 0 ? (n++, t += " " + this.units[i].prefix.name + this.units[i].unit.name, Math.abs(this.units[i].power - 1) > 1e-15 && (t += "^" + this.units[i].power)) : this.units[i].power < 0 && r++;
        }

        if (r > 0) for (var i = 0; i < this.units.length; i++) {
          this.units[i].power < 0 && (n > 0 ? (e += " " + this.units[i].prefix.name + this.units[i].unit.name, Math.abs(this.units[i].power + 1) > 1e-15 && (e += "^" + -this.units[i].power)) : (e += " " + this.units[i].prefix.name + this.units[i].unit.name, e += "^" + this.units[i].power));
        }
        t = t.substr(1), e = e.substr(1), n > 1 && r > 0 && (t = "(" + t + ")"), r > 1 && n > 0 && (e = "(" + e + ")");
        var o = t;
        return n > 0 && r > 0 && (o += " / "), o += e;
      }, c.prototype.format = function (t) {
        this.simplifyUnitListLazy();
        var e = !1,
            n = !0;
        "undefined" != typeof this.value && null !== this.value && this.value.isComplex && (e = Math.abs(this.value.re) < 1e-14, n = Math.abs(this.value.im) < 1e-14);

        for (var r in this.units) {
          this.units[r].unit && ("VA" === this.units[r].unit.name && e ? this.units[r].unit = W.VAR : "VAR" !== this.units[r].unit.name || e || (this.units[r].unit = W.VA));
        }

        1 !== this.units.length || this.fixPrefix || Math.abs(this.units[0].power - Math.round(this.units[0].power)) < 1e-14 && (this.units[0].prefix = this._bestPrefix());

        var i = this._denormalize(this.value),
            o = null !== this.value ? C(i, t || {}) : "",
            a = this.formatUnits();

        return this.value && this.value.isComplex && (o = "(" + o + ")"), a.length > 0 && o.length > 0 && (o += " "), o += a;
      }, c.prototype._bestPrefix = function () {
        if (1 !== this.units.length) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
        var t = N(this.value),
            e = N(this.units[0].unit.value),
            n = this.units[0].prefix;
        if (0 === t) return n;
        var r = this.units[0].power,
            i = Math.log(t / Math.pow(n.value * e, r)) / Math.LN10 - 1.2;
        if (i > -2.200001 && i < 1.800001) return n;
        i = Math.abs(i);
        var o = this.units[0].unit.prefixes;

        for (var a in o) {
          if (o.hasOwnProperty(a)) {
            var s = o[a];

            if (s.scientific) {
              var u = Math.abs(Math.log(t / Math.pow(s.value * e, r)) / Math.LN10 - 1.2);
              (u < i || u === i && s.name.length < n.name.length) && (n = s, i = u);
            }
          }
        }

        return n;
      }, c.prototype.splitUnit = function (t) {
        for (var e = this.clone(), n = [], r = 0; r < t.length && (e = e.to(t[r]), r != t.length - 1); r++) {
          var i = S(e.toNumeric()),
              o = new c(i, t[r].toString());
          n.push(o), e = _(e, o);
        }

        return n.push(e), n;
      };
      var D = {
        NONE: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          }
        },
        SHORT: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          da: {
            name: "da",
            value: 10,
            scientific: !1
          },
          h: {
            name: "h",
            value: 100,
            scientific: !1
          },
          k: {
            name: "k",
            value: 1e3,
            scientific: !0
          },
          M: {
            name: "M",
            value: 1e6,
            scientific: !0
          },
          G: {
            name: "G",
            value: 1e9,
            scientific: !0
          },
          T: {
            name: "T",
            value: 1e12,
            scientific: !0
          },
          P: {
            name: "P",
            value: 1e15,
            scientific: !0
          },
          E: {
            name: "E",
            value: 1e18,
            scientific: !0
          },
          Z: {
            name: "Z",
            value: 1e21,
            scientific: !0
          },
          Y: {
            name: "Y",
            value: 1e24,
            scientific: !0
          },
          d: {
            name: "d",
            value: .1,
            scientific: !1
          },
          c: {
            name: "c",
            value: .01,
            scientific: !1
          },
          m: {
            name: "m",
            value: .001,
            scientific: !0
          },
          u: {
            name: "u",
            value: 1e-6,
            scientific: !0
          },
          n: {
            name: "n",
            value: 1e-9,
            scientific: !0
          },
          p: {
            name: "p",
            value: 1e-12,
            scientific: !0
          },
          f: {
            name: "f",
            value: 1e-15,
            scientific: !0
          },
          a: {
            name: "a",
            value: 1e-18,
            scientific: !0
          },
          z: {
            name: "z",
            value: 1e-21,
            scientific: !0
          },
          y: {
            name: "y",
            value: 1e-24,
            scientific: !0
          }
        },
        LONG: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          deca: {
            name: "deca",
            value: 10,
            scientific: !1
          },
          hecto: {
            name: "hecto",
            value: 100,
            scientific: !1
          },
          kilo: {
            name: "kilo",
            value: 1e3,
            scientific: !0
          },
          mega: {
            name: "mega",
            value: 1e6,
            scientific: !0
          },
          giga: {
            name: "giga",
            value: 1e9,
            scientific: !0
          },
          tera: {
            name: "tera",
            value: 1e12,
            scientific: !0
          },
          peta: {
            name: "peta",
            value: 1e15,
            scientific: !0
          },
          exa: {
            name: "exa",
            value: 1e18,
            scientific: !0
          },
          zetta: {
            name: "zetta",
            value: 1e21,
            scientific: !0
          },
          yotta: {
            name: "yotta",
            value: 1e24,
            scientific: !0
          },
          deci: {
            name: "deci",
            value: .1,
            scientific: !1
          },
          centi: {
            name: "centi",
            value: .01,
            scientific: !1
          },
          milli: {
            name: "milli",
            value: .001,
            scientific: !0
          },
          micro: {
            name: "micro",
            value: 1e-6,
            scientific: !0
          },
          nano: {
            name: "nano",
            value: 1e-9,
            scientific: !0
          },
          pico: {
            name: "pico",
            value: 1e-12,
            scientific: !0
          },
          femto: {
            name: "femto",
            value: 1e-15,
            scientific: !0
          },
          atto: {
            name: "atto",
            value: 1e-18,
            scientific: !0
          },
          zepto: {
            name: "zepto",
            value: 1e-21,
            scientific: !0
          },
          yocto: {
            name: "yocto",
            value: 1e-24,
            scientific: !0
          }
        },
        SQUARED: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          da: {
            name: "da",
            value: 100,
            scientific: !1
          },
          h: {
            name: "h",
            value: 1e4,
            scientific: !1
          },
          k: {
            name: "k",
            value: 1e6,
            scientific: !0
          },
          M: {
            name: "M",
            value: 1e12,
            scientific: !0
          },
          G: {
            name: "G",
            value: 1e18,
            scientific: !0
          },
          T: {
            name: "T",
            value: 1e24,
            scientific: !0
          },
          P: {
            name: "P",
            value: 1e30,
            scientific: !0
          },
          E: {
            name: "E",
            value: 1e36,
            scientific: !0
          },
          Z: {
            name: "Z",
            value: 1e42,
            scientific: !0
          },
          Y: {
            name: "Y",
            value: 1e48,
            scientific: !0
          },
          d: {
            name: "d",
            value: .01,
            scientific: !1
          },
          c: {
            name: "c",
            value: 1e-4,
            scientific: !1
          },
          m: {
            name: "m",
            value: 1e-6,
            scientific: !0
          },
          u: {
            name: "u",
            value: 1e-12,
            scientific: !0
          },
          n: {
            name: "n",
            value: 1e-18,
            scientific: !0
          },
          p: {
            name: "p",
            value: 1e-24,
            scientific: !0
          },
          f: {
            name: "f",
            value: 1e-30,
            scientific: !0
          },
          a: {
            name: "a",
            value: 1e-36,
            scientific: !0
          },
          z: {
            name: "z",
            value: 1e-42,
            scientific: !0
          },
          y: {
            name: "y",
            value: 1e-48,
            scientific: !0
          }
        },
        CUBIC: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          da: {
            name: "da",
            value: 1e3,
            scientific: !1
          },
          h: {
            name: "h",
            value: 1e6,
            scientific: !1
          },
          k: {
            name: "k",
            value: 1e9,
            scientific: !0
          },
          M: {
            name: "M",
            value: 1e18,
            scientific: !0
          },
          G: {
            name: "G",
            value: 1e27,
            scientific: !0
          },
          T: {
            name: "T",
            value: 1e36,
            scientific: !0
          },
          P: {
            name: "P",
            value: 1e45,
            scientific: !0
          },
          E: {
            name: "E",
            value: 1e54,
            scientific: !0
          },
          Z: {
            name: "Z",
            value: 1e63,
            scientific: !0
          },
          Y: {
            name: "Y",
            value: 1e72,
            scientific: !0
          },
          d: {
            name: "d",
            value: .001,
            scientific: !1
          },
          c: {
            name: "c",
            value: 1e-6,
            scientific: !1
          },
          m: {
            name: "m",
            value: 1e-9,
            scientific: !0
          },
          u: {
            name: "u",
            value: 1e-18,
            scientific: !0
          },
          n: {
            name: "n",
            value: 1e-27,
            scientific: !0
          },
          p: {
            name: "p",
            value: 1e-36,
            scientific: !0
          },
          f: {
            name: "f",
            value: 1e-45,
            scientific: !0
          },
          a: {
            name: "a",
            value: 1e-54,
            scientific: !0
          },
          z: {
            name: "z",
            value: 1e-63,
            scientific: !0
          },
          y: {
            name: "y",
            value: 1e-72,
            scientific: !0
          }
        },
        BINARY_SHORT: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          k: {
            name: "k",
            value: 1e3,
            scientific: !0
          },
          M: {
            name: "M",
            value: 1e6,
            scientific: !0
          },
          G: {
            name: "G",
            value: 1e9,
            scientific: !0
          },
          T: {
            name: "T",
            value: 1e12,
            scientific: !0
          },
          P: {
            name: "P",
            value: 1e15,
            scientific: !0
          },
          E: {
            name: "E",
            value: 1e18,
            scientific: !0
          },
          Z: {
            name: "Z",
            value: 1e21,
            scientific: !0
          },
          Y: {
            name: "Y",
            value: 1e24,
            scientific: !0
          },
          Ki: {
            name: "Ki",
            value: 1024,
            scientific: !0
          },
          Mi: {
            name: "Mi",
            value: Math.pow(1024, 2),
            scientific: !0
          },
          Gi: {
            name: "Gi",
            value: Math.pow(1024, 3),
            scientific: !0
          },
          Ti: {
            name: "Ti",
            value: Math.pow(1024, 4),
            scientific: !0
          },
          Pi: {
            name: "Pi",
            value: Math.pow(1024, 5),
            scientific: !0
          },
          Ei: {
            name: "Ei",
            value: Math.pow(1024, 6),
            scientific: !0
          },
          Zi: {
            name: "Zi",
            value: Math.pow(1024, 7),
            scientific: !0
          },
          Yi: {
            name: "Yi",
            value: Math.pow(1024, 8),
            scientific: !0
          }
        },
        BINARY_LONG: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          kilo: {
            name: "kilo",
            value: 1e3,
            scientific: !0
          },
          mega: {
            name: "mega",
            value: 1e6,
            scientific: !0
          },
          giga: {
            name: "giga",
            value: 1e9,
            scientific: !0
          },
          tera: {
            name: "tera",
            value: 1e12,
            scientific: !0
          },
          peta: {
            name: "peta",
            value: 1e15,
            scientific: !0
          },
          exa: {
            name: "exa",
            value: 1e18,
            scientific: !0
          },
          zetta: {
            name: "zetta",
            value: 1e21,
            scientific: !0
          },
          yotta: {
            name: "yotta",
            value: 1e24,
            scientific: !0
          },
          kibi: {
            name: "kibi",
            value: 1024,
            scientific: !0
          },
          mebi: {
            name: "mebi",
            value: Math.pow(1024, 2),
            scientific: !0
          },
          gibi: {
            name: "gibi",
            value: Math.pow(1024, 3),
            scientific: !0
          },
          tebi: {
            name: "tebi",
            value: Math.pow(1024, 4),
            scientific: !0
          },
          pebi: {
            name: "pebi",
            value: Math.pow(1024, 5),
            scientific: !0
          },
          exi: {
            name: "exi",
            value: Math.pow(1024, 6),
            scientific: !0
          },
          zebi: {
            name: "zebi",
            value: Math.pow(1024, 7),
            scientific: !0
          },
          yobi: {
            name: "yobi",
            value: Math.pow(1024, 8),
            scientific: !0
          }
        },
        BTU: {
          "": {
            name: "",
            value: 1,
            scientific: !0
          },
          MM: {
            name: "MM",
            value: 1e6,
            scientific: !0
          }
        }
      };
      D.SHORTLONG = {};

      for (var j in D.SHORT) {
        D.SHORT.hasOwnProperty(j) && (D.SHORTLONG[j] = D.SHORT[j]);
      }

      for (var j in D.LONG) {
        D.LONG.hasOwnProperty(j) && (D.SHORTLONG[j] = D.LONG[j]);
      }

      var F = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"],
          U = {
        NONE: {
          dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        MASS: {
          dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        LENGTH: {
          dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
        },
        TIME: {
          dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
        },
        CURRENT: {
          dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
        },
        TEMPERATURE: {
          dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
        },
        LUMINOUS_INTENSITY: {
          dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
        },
        AMOUNT_OF_SUBSTANCE: {
          dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
        },
        FORCE: {
          dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
        },
        SURFACE: {
          dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
        },
        VOLUME: {
          dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
        },
        ENERGY: {
          dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
        },
        POWER: {
          dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
        },
        PRESSURE: {
          dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
        },
        ELECTRIC_CHARGE: {
          dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
        },
        ELECTRIC_CAPACITANCE: {
          dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
        },
        ELECTRIC_POTENTIAL: {
          dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
        },
        ELECTRIC_RESISTANCE: {
          dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
        },
        ELECTRIC_INDUCTANCE: {
          dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
        },
        ELECTRIC_CONDUCTANCE: {
          dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
        },
        MAGNETIC_FLUX: {
          dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
        },
        MAGNETIC_FLUX_DENSITY: {
          dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
        },
        FREQUENCY: {
          dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
        },
        ANGLE: {
          dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
        },
        BIT: {
          dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
        }
      };

      for (var j in U) {
        U[j].key = j;
      }

      var q = {},
          H = {
        name: "",
        base: q,
        value: 1,
        offset: 0,
        dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
          W = {
        meter: {
          name: "meter",
          base: U.LENGTH,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        inch: {
          name: "inch",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .0254,
          offset: 0
        },
        foot: {
          name: "foot",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .3048,
          offset: 0
        },
        yard: {
          name: "yard",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .9144,
          offset: 0
        },
        mile: {
          name: "mile",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 1609.344,
          offset: 0
        },
        link: {
          name: "link",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .201168,
          offset: 0
        },
        rod: {
          name: "rod",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 5.02921,
          offset: 0
        },
        chain: {
          name: "chain",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 20.1168,
          offset: 0
        },
        angstrom: {
          name: "angstrom",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 1e-10,
          offset: 0
        },
        m: {
          name: "m",
          base: U.LENGTH,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        in: {
          name: "in",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .0254,
          offset: 0
        },
        ft: {
          name: "ft",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .3048,
          offset: 0
        },
        yd: {
          name: "yd",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .9144,
          offset: 0
        },
        mi: {
          name: "mi",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 1609.344,
          offset: 0
        },
        li: {
          name: "li",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: .201168,
          offset: 0
        },
        rd: {
          name: "rd",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 5.02921,
          offset: 0
        },
        ch: {
          name: "ch",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 20.1168,
          offset: 0
        },
        mil: {
          name: "mil",
          base: U.LENGTH,
          prefixes: D.NONE,
          value: 254e-7,
          offset: 0
        },
        m2: {
          name: "m2",
          base: U.SURFACE,
          prefixes: D.SQUARED,
          value: 1,
          offset: 0
        },
        sqin: {
          name: "sqin",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 64516e-8,
          offset: 0
        },
        sqft: {
          name: "sqft",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: .09290304,
          offset: 0
        },
        sqyd: {
          name: "sqyd",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: .83612736,
          offset: 0
        },
        sqmi: {
          name: "sqmi",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 2589988.110336,
          offset: 0
        },
        sqrd: {
          name: "sqrd",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 25.29295,
          offset: 0
        },
        sqch: {
          name: "sqch",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 404.6873,
          offset: 0
        },
        sqmil: {
          name: "sqmil",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 6.4516e-10,
          offset: 0
        },
        acre: {
          name: "acre",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 4046.86,
          offset: 0
        },
        hectare: {
          name: "hectare",
          base: U.SURFACE,
          prefixes: D.NONE,
          value: 1e4,
          offset: 0
        },
        m3: {
          name: "m3",
          base: U.VOLUME,
          prefixes: D.CUBIC,
          value: 1,
          offset: 0
        },
        L: {
          name: "L",
          base: U.VOLUME,
          prefixes: D.SHORT,
          value: .001,
          offset: 0
        },
        l: {
          name: "l",
          base: U.VOLUME,
          prefixes: D.SHORT,
          value: .001,
          offset: 0
        },
        litre: {
          name: "litre",
          base: U.VOLUME,
          prefixes: D.LONG,
          value: .001,
          offset: 0
        },
        cuin: {
          name: "cuin",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 16387064e-12,
          offset: 0
        },
        cuft: {
          name: "cuft",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .028316846592,
          offset: 0
        },
        cuyd: {
          name: "cuyd",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .764554857984,
          offset: 0
        },
        teaspoon: {
          name: "teaspoon",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 5e-6,
          offset: 0
        },
        tablespoon: {
          name: "tablespoon",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 15e-6,
          offset: 0
        },
        drop: {
          name: "drop",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 5e-8,
          offset: 0
        },
        gtt: {
          name: "gtt",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 5e-8,
          offset: 0
        },
        minim: {
          name: "minim",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 6.161152e-8,
          offset: 0
        },
        fluiddram: {
          name: "fluiddram",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 36966911e-13,
          offset: 0
        },
        fluidounce: {
          name: "fluidounce",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 2957353e-11,
          offset: 0
        },
        gill: {
          name: "gill",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0001182941,
          offset: 0
        },
        cc: {
          name: "cc",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 1e-6,
          offset: 0
        },
        cup: {
          name: "cup",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0002365882,
          offset: 0
        },
        pint: {
          name: "pint",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0004731765,
          offset: 0
        },
        quart: {
          name: "quart",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0009463529,
          offset: 0
        },
        gallon: {
          name: "gallon",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .003785412,
          offset: 0
        },
        beerbarrel: {
          name: "beerbarrel",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .1173478,
          offset: 0
        },
        oilbarrel: {
          name: "oilbarrel",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .1589873,
          offset: 0
        },
        hogshead: {
          name: "hogshead",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .238481,
          offset: 0
        },
        fldr: {
          name: "fldr",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 36966911e-13,
          offset: 0
        },
        floz: {
          name: "floz",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: 2957353e-11,
          offset: 0
        },
        gi: {
          name: "gi",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0001182941,
          offset: 0
        },
        cp: {
          name: "cp",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0002365882,
          offset: 0
        },
        pt: {
          name: "pt",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0004731765,
          offset: 0
        },
        qt: {
          name: "qt",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .0009463529,
          offset: 0
        },
        gal: {
          name: "gal",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .003785412,
          offset: 0
        },
        bbl: {
          name: "bbl",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .1173478,
          offset: 0
        },
        obl: {
          name: "obl",
          base: U.VOLUME,
          prefixes: D.NONE,
          value: .1589873,
          offset: 0
        },
        g: {
          name: "g",
          base: U.MASS,
          prefixes: D.SHORT,
          value: .001,
          offset: 0
        },
        gram: {
          name: "gram",
          base: U.MASS,
          prefixes: D.LONG,
          value: .001,
          offset: 0
        },
        ton: {
          name: "ton",
          base: U.MASS,
          prefixes: D.SHORT,
          value: 907.18474,
          offset: 0
        },
        tonne: {
          name: "tonne",
          base: U.MASS,
          prefixes: D.SHORT,
          value: 1e3,
          offset: 0
        },
        grain: {
          name: "grain",
          base: U.MASS,
          prefixes: D.NONE,
          value: 6479891e-11,
          offset: 0
        },
        dram: {
          name: "dram",
          base: U.MASS,
          prefixes: D.NONE,
          value: .0017718451953125,
          offset: 0
        },
        ounce: {
          name: "ounce",
          base: U.MASS,
          prefixes: D.NONE,
          value: .028349523125,
          offset: 0
        },
        poundmass: {
          name: "poundmass",
          base: U.MASS,
          prefixes: D.NONE,
          value: .45359237,
          offset: 0
        },
        hundredweight: {
          name: "hundredweight",
          base: U.MASS,
          prefixes: D.NONE,
          value: 45.359237,
          offset: 0
        },
        stick: {
          name: "stick",
          base: U.MASS,
          prefixes: D.NONE,
          value: .115,
          offset: 0
        },
        stone: {
          name: "stone",
          base: U.MASS,
          prefixes: D.NONE,
          value: 6.35029318,
          offset: 0
        },
        gr: {
          name: "gr",
          base: U.MASS,
          prefixes: D.NONE,
          value: 6479891e-11,
          offset: 0
        },
        dr: {
          name: "dr",
          base: U.MASS,
          prefixes: D.NONE,
          value: .0017718451953125,
          offset: 0
        },
        oz: {
          name: "oz",
          base: U.MASS,
          prefixes: D.NONE,
          value: .028349523125,
          offset: 0
        },
        lbm: {
          name: "lbm",
          base: U.MASS,
          prefixes: D.NONE,
          value: .45359237,
          offset: 0
        },
        cwt: {
          name: "cwt",
          base: U.MASS,
          prefixes: D.NONE,
          value: 45.359237,
          offset: 0
        },
        s: {
          name: "s",
          base: U.TIME,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        min: {
          name: "min",
          base: U.TIME,
          prefixes: D.NONE,
          value: 60,
          offset: 0
        },
        h: {
          name: "h",
          base: U.TIME,
          prefixes: D.NONE,
          value: 3600,
          offset: 0
        },
        second: {
          name: "second",
          base: U.TIME,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        sec: {
          name: "sec",
          base: U.TIME,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        minute: {
          name: "minute",
          base: U.TIME,
          prefixes: D.NONE,
          value: 60,
          offset: 0
        },
        hour: {
          name: "hour",
          base: U.TIME,
          prefixes: D.NONE,
          value: 3600,
          offset: 0
        },
        day: {
          name: "day",
          base: U.TIME,
          prefixes: D.NONE,
          value: 86400,
          offset: 0
        },
        week: {
          name: "week",
          base: U.TIME,
          prefixes: D.NONE,
          value: 604800,
          offset: 0
        },
        month: {
          name: "month",
          base: U.TIME,
          prefixes: D.NONE,
          value: 2629800,
          offset: 0
        },
        year: {
          name: "year",
          base: U.TIME,
          prefixes: D.NONE,
          value: 31557600,
          offset: 0
        },
        decade: {
          name: "year",
          base: U.TIME,
          prefixes: D.NONE,
          value: 315576e3,
          offset: 0
        },
        century: {
          name: "century",
          base: U.TIME,
          prefixes: D.NONE,
          value: 315576e4,
          offset: 0
        },
        millennium: {
          name: "millennium",
          base: U.TIME,
          prefixes: D.NONE,
          value: 315576e5,
          offset: 0
        },
        hertz: {
          name: "Hertz",
          base: U.FREQUENCY,
          prefixes: D.LONG,
          value: 1,
          offset: 0,
          reciprocal: !0
        },
        Hz: {
          name: "Hz",
          base: U.FREQUENCY,
          prefixes: D.SHORT,
          value: 1,
          offset: 0,
          reciprocal: !0
        },
        rad: {
          name: "rad",
          base: U.ANGLE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        deg: {
          name: "deg",
          base: U.ANGLE,
          prefixes: D.LONG,
          value: null,
          offset: 0
        },
        grad: {
          name: "grad",
          base: U.ANGLE,
          prefixes: D.LONG,
          value: null,
          offset: 0
        },
        cycle: {
          name: "cycle",
          base: U.ANGLE,
          prefixes: D.NONE,
          value: null,
          offset: 0
        },
        arcsec: {
          name: "arcsec",
          base: U.ANGLE,
          prefixes: D.NONE,
          value: null,
          offset: 0
        },
        arcmin: {
          name: "arcmin",
          base: U.ANGLE,
          prefixes: D.NONE,
          value: null,
          offset: 0
        },
        A: {
          name: "A",
          base: U.CURRENT,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        ampere: {
          name: "ampere",
          base: U.CURRENT,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        K: {
          name: "K",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1,
          offset: 0
        },
        degC: {
          name: "degC",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1,
          offset: 273.15
        },
        degF: {
          name: "degF",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1 / 1.8,
          offset: 459.67
        },
        degR: {
          name: "degR",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1 / 1.8,
          offset: 0
        },
        kelvin: {
          name: "kelvin",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1,
          offset: 0
        },
        celsius: {
          name: "celsius",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1,
          offset: 273.15
        },
        fahrenheit: {
          name: "fahrenheit",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1 / 1.8,
          offset: 459.67
        },
        rankine: {
          name: "rankine",
          base: U.TEMPERATURE,
          prefixes: D.NONE,
          value: 1 / 1.8,
          offset: 0
        },
        mol: {
          name: "mol",
          base: U.AMOUNT_OF_SUBSTANCE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        mole: {
          name: "mole",
          base: U.AMOUNT_OF_SUBSTANCE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        cd: {
          name: "cd",
          base: U.LUMINOUS_INTENSITY,
          prefixes: D.NONE,
          value: 1,
          offset: 0
        },
        candela: {
          name: "candela",
          base: U.LUMINOUS_INTENSITY,
          prefixes: D.NONE,
          value: 1,
          offset: 0
        },
        N: {
          name: "N",
          base: U.FORCE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        newton: {
          name: "newton",
          base: U.FORCE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        dyn: {
          name: "dyn",
          base: U.FORCE,
          prefixes: D.SHORT,
          value: 1e-5,
          offset: 0
        },
        dyne: {
          name: "dyne",
          base: U.FORCE,
          prefixes: D.LONG,
          value: 1e-5,
          offset: 0
        },
        lbf: {
          name: "lbf",
          base: U.FORCE,
          prefixes: D.NONE,
          value: 4.4482216152605,
          offset: 0
        },
        poundforce: {
          name: "poundforce",
          base: U.FORCE,
          prefixes: D.NONE,
          value: 4.4482216152605,
          offset: 0
        },
        kip: {
          name: "kip",
          base: U.FORCE,
          prefixes: D.LONG,
          value: 4448.2216,
          offset: 0
        },
        J: {
          name: "J",
          base: U.ENERGY,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        joule: {
          name: "joule",
          base: U.ENERGY,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        erg: {
          name: "erg",
          base: U.ENERGY,
          prefixes: D.NONE,
          value: 1e-5,
          offset: 0
        },
        Wh: {
          name: "Wh",
          base: U.ENERGY,
          prefixes: D.SHORT,
          value: 3600,
          offset: 0
        },
        BTU: {
          name: "BTU",
          base: U.ENERGY,
          prefixes: D.BTU,
          value: 1055.05585262,
          offset: 0
        },
        eV: {
          name: "eV",
          base: U.ENERGY,
          prefixes: D.SHORT,
          value: 1.602176565e-19,
          offset: 0
        },
        electronvolt: {
          name: "electronvolt",
          base: U.ENERGY,
          prefixes: D.LONG,
          value: 1.602176565e-19,
          offset: 0
        },
        W: {
          name: "W",
          base: U.POWER,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        watt: {
          name: "W",
          base: U.POWER,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        hp: {
          name: "hp",
          base: U.POWER,
          prefixes: D.NONE,
          value: 745.6998715386,
          offset: 0
        },
        VAR: {
          name: "VAR",
          base: U.POWER,
          prefixes: D.SHORT,
          value: I.I,
          offset: 0
        },
        VA: {
          name: "VA",
          base: U.POWER,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        Pa: {
          name: "Pa",
          base: U.PRESSURE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        psi: {
          name: "psi",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 6894.75729276459,
          offset: 0
        },
        atm: {
          name: "atm",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 101325,
          offset: 0
        },
        bar: {
          name: "bar",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 1e5,
          offset: 0
        },
        torr: {
          name: "torr",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 133.322,
          offset: 0
        },
        mmHg: {
          name: "mmHg",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 133.322,
          offset: 0
        },
        mmH2O: {
          name: "mmH2O",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 9.80665,
          offset: 0
        },
        cmH2O: {
          name: "cmH2O",
          base: U.PRESSURE,
          prefixes: D.NONE,
          value: 98.0665,
          offset: 0
        },
        coulomb: {
          name: "coulomb",
          base: U.ELECTRIC_CHARGE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        C: {
          name: "C",
          base: U.ELECTRIC_CHARGE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        farad: {
          name: "farad",
          base: U.ELECTRIC_CAPACITANCE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        F: {
          name: "F",
          base: U.ELECTRIC_CAPACITANCE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        volt: {
          name: "volt",
          base: U.ELECTRIC_POTENTIAL,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        V: {
          name: "V",
          base: U.ELECTRIC_POTENTIAL,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        ohm: {
          name: "ohm",
          base: U.ELECTRIC_RESISTANCE,
          prefixes: D.SHORTLONG,
          value: 1,
          offset: 0
        },
        henry: {
          name: "henry",
          base: U.ELECTRIC_INDUCTANCE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        H: {
          name: "H",
          base: U.ELECTRIC_INDUCTANCE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        siemens: {
          name: "siemens",
          base: U.ELECTRIC_CONDUCTANCE,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        S: {
          name: "S",
          base: U.ELECTRIC_CONDUCTANCE,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        weber: {
          name: "weber",
          base: U.MAGNETIC_FLUX,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        Wb: {
          name: "Wb",
          base: U.MAGNETIC_FLUX,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        tesla: {
          name: "tesla",
          base: U.MAGNETIC_FLUX_DENSITY,
          prefixes: D.LONG,
          value: 1,
          offset: 0
        },
        T: {
          name: "T",
          base: U.MAGNETIC_FLUX_DENSITY,
          prefixes: D.SHORT,
          value: 1,
          offset: 0
        },
        b: {
          name: "b",
          base: U.BIT,
          prefixes: D.BINARY_SHORT,
          value: 1,
          offset: 0
        },
        bits: {
          name: "bits",
          base: U.BIT,
          prefixes: D.BINARY_LONG,
          value: 1,
          offset: 0
        },
        B: {
          name: "B",
          base: U.BIT,
          prefixes: D.BINARY_SHORT,
          value: 8,
          offset: 0
        },
        bytes: {
          name: "bytes",
          base: U.BIT,
          prefixes: D.BINARY_LONG,
          value: 8,
          offset: 0
        }
      },
          G = {
        meters: "meter",
        inches: "inch",
        feet: "foot",
        yards: "yard",
        miles: "mile",
        links: "link",
        rods: "rod",
        chains: "chain",
        angstroms: "angstrom",
        lt: "l",
        litres: "litre",
        liter: "litre",
        liters: "litre",
        teaspoons: "teaspoon",
        tablespoons: "tablespoon",
        minims: "minim",
        fluiddrams: "fluiddram",
        fluidounces: "fluidounce",
        gills: "gill",
        cups: "cup",
        pints: "pint",
        quarts: "quart",
        gallons: "gallon",
        beerbarrels: "beerbarrel",
        oilbarrels: "oilbarrel",
        hogsheads: "hogshead",
        gtts: "gtt",
        grams: "gram",
        tons: "ton",
        tonnes: "tonne",
        grains: "grain",
        drams: "dram",
        ounces: "ounce",
        poundmasses: "poundmass",
        hundredweights: "hundredweight",
        sticks: "stick",
        lb: "lbm",
        lbs: "lbm",
        kips: "kip",
        acres: "acre",
        hectares: "hectare",
        sqfeet: "sqft",
        sqyard: "sqyd",
        sqmile: "sqmi",
        sqmiles: "sqmi",
        mmhg: "mmHg",
        mmh2o: "mmH2O",
        cmh2o: "cmH2O",
        seconds: "second",
        secs: "second",
        minutes: "minute",
        mins: "minute",
        hours: "hour",
        hr: "hour",
        hrs: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
        hertz: "hertz",
        radians: "rad",
        degree: "deg",
        degrees: "deg",
        gradian: "grad",
        gradians: "grad",
        cycles: "cycle",
        arcsecond: "arcsec",
        arcseconds: "arcsec",
        arcminute: "arcmin",
        arcminutes: "arcmin",
        BTUs: "BTU",
        watts: "watt",
        joules: "joule",
        amperes: "ampere",
        coulombs: "coulomb",
        volts: "volt",
        ohms: "ohm",
        farads: "farad",
        webers: "weber",
        teslas: "tesla",
        electronvolts: "electronvolt",
        moles: "mole"
      };
      x(e), u.on("config", function (t, e) {
        t.number !== e.number && x(t);
      });
      var $ = {
        si: {
          NONE: {
            unit: H,
            prefix: D.NONE[""]
          },
          LENGTH: {
            unit: W.m,
            prefix: D.SHORT[""]
          },
          MASS: {
            unit: W.g,
            prefix: D.SHORT.k
          },
          TIME: {
            unit: W.s,
            prefix: D.SHORT[""]
          },
          CURRENT: {
            unit: W.A,
            prefix: D.SHORT[""]
          },
          TEMPERATURE: {
            unit: W.K,
            prefix: D.SHORT[""]
          },
          LUMINOUS_INTENSITY: {
            unit: W.cd,
            prefix: D.SHORT[""]
          },
          AMOUNT_OF_SUBSTANCE: {
            unit: W.mol,
            prefix: D.SHORT[""]
          },
          ANGLE: {
            unit: W.rad,
            prefix: D.SHORT[""]
          },
          BIT: {
            unit: W.bit,
            prefix: D.SHORT[""]
          },
          FORCE: {
            unit: W.N,
            prefix: D.SHORT[""]
          },
          ENERGY: {
            unit: W.J,
            prefix: D.SHORT[""]
          },
          POWER: {
            unit: W.W,
            prefix: D.SHORT[""]
          },
          PRESSURE: {
            unit: W.Pa,
            prefix: D.SHORT[""]
          },
          ELECTRIC_CHARGE: {
            unit: W.C,
            prefix: D.SHORT[""]
          },
          ELECTRIC_CAPACITANCE: {
            unit: W.F,
            prefix: D.SHORT[""]
          },
          ELECTRIC_POTENTIAL: {
            unit: W.V,
            prefix: D.SHORT[""]
          },
          ELECTRIC_RESISTANCE: {
            unit: W.ohm,
            prefix: D.SHORT[""]
          },
          ELECTRIC_INDUCTANCE: {
            unit: W.H,
            prefix: D.SHORT[""]
          },
          ELECTRIC_CONDUCTANCE: {
            unit: W.S,
            prefix: D.SHORT[""]
          },
          MAGNETIC_FLUX: {
            unit: W.Wb,
            prefix: D.SHORT[""]
          },
          MAGNETIC_FLUX_DENSITY: {
            unit: W.T,
            prefix: D.SHORT[""]
          },
          FREQUENCY: {
            unit: W.Hz,
            prefix: D.SHORT[""]
          }
        }
      };
      $.cgs = JSON.parse(JSON.stringify($.si)), $.cgs.LENGTH = {
        unit: W.m,
        prefix: D.SHORT.c
      }, $.cgs.MASS = {
        unit: W.g,
        prefix: D.SHORT[""]
      }, $.cgs.FORCE = {
        unit: W.dyn,
        prefix: D.SHORT[""]
      }, $.cgs.ENERGY = {
        unit: W.erg,
        prefix: D.NONE[""]
      }, $.us = JSON.parse(JSON.stringify($.si)), $.us.LENGTH = {
        unit: W.ft,
        prefix: D.NONE[""]
      }, $.us.MASS = {
        unit: W.lbm,
        prefix: D.NONE[""]
      }, $.us.TEMPERATURE = {
        unit: W.degF,
        prefix: D.NONE[""]
      }, $.us.FORCE = {
        unit: W.lbf,
        prefix: D.NONE[""]
      }, $.us.ENERGY = {
        unit: W.BTU,
        prefix: D.BTU[""]
      }, $.us.POWER = {
        unit: W.hp,
        prefix: D.NONE[""]
      }, $.us.PRESSURE = {
        unit: W.psi,
        prefix: D.NONE[""]
      }, $.auto = JSON.parse(JSON.stringify($.si));
      var V = $.auto;
      c.setUnitSystem = function (t) {
        if (!$.hasOwnProperty(t)) throw new Error("Unit system " + t + " does not exist. Choices are: " + Object.keys($).join(", "));
        V = $[t];
      }, c.getUnitSystem = function () {
        for (var t in $) {
          if ($[t] === V) return t;
        }
      }, c.typeConverters = {
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(e + "");
        },
        Fraction: function Fraction(e) {
          return new t.Fraction(e);
        },
        Complex: function Complex(t) {
          return t;
        },
        number: function number(t) {
          return t;
        }
      }, c._getNumberConverter = function (t) {
        if (!c.typeConverters[t]) throw new TypeError('Unsupported type "' + t + '"');
        return c.typeConverters[t];
      };

      for (var j in W) {
        var Z = W[j];
        Z.dimensions = Z.base.dimensions;
      }

      for (var X in G) {
        if (G.hasOwnProperty(X)) {
          var Z = W[G[X]],
              Y = {};

          for (var j in Z) {
            Z.hasOwnProperty(j) && (Y[j] = Z[j]);
          }

          Y.name = X, W[X] = Y;
        }
      }

      return c.createUnit = function (t, e) {
        if ("object" != typeof t) throw new TypeError("createUnit expects first parameter to be of type 'Object'");
        if (e && e.override) for (var n in t) {
          if (t.hasOwnProperty(n) && c.deleteUnit(n), t[n].aliases) for (var r = 0; r < t[n].aliases.length; r++) {
            c.deleteUnit(t[n].aliases[r]);
          }
        }
        var i;

        for (var n in t) {
          t.hasOwnProperty(n) && (i = c.createUnitSingle(n, t[n]));
        }

        return i;
      }, c.createUnitSingle = function (t, e, n) {
        if ("undefined" != typeof e && null !== e || (e = {}), "string" != typeof t) throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
        if (W.hasOwnProperty(t)) throw new Error('Cannot create unit "' + t + '": a unit with that name already exists');
        w(t);
        var r,
            i,
            o = null,
            a = [],
            s = 0;
        if (e && "Unit" === e.type) o = e.clone();else if ("string" == typeof e) "" !== e && (r = e);else {
          if ("object" != typeof e) throw new TypeError('Cannot create unit "' + t + '" from "' + e.toString() + '": expecting "string" or "Unit" or "Object"');
          r = e.definition, i = e.prefixes, s = e.offset, a = e.aliases;
        }
        if (a) for (var u = 0; u < a.length; u++) {
          if (W.hasOwnProperty(a[u])) throw new Error('Cannot create alias "' + a[u] + '": a unit with that name already exists');
        }
        if (r && "string" == typeof r && !o) try {
          o = c.parse(r, {
            allowNoUnits: !0
          });
        } catch (e) {
          throw e.message = 'Could not create unit "' + t + '" from "' + r + '": ' + e.message, e;
        } else r && "Unit" === r.type && (o = r.clone());
        a = a || [], s = s || 0, i = i && i.toUpperCase ? D[i.toUpperCase()] || D.NONE : D.NONE;
        var l = {};

        if (o) {
          l = {
            name: t,
            value: o.value,
            dimensions: o.dimensions.slice(0),
            prefixes: i,
            offset: s
          };
          var h = !1;

          for (var u in U) {
            if (U.hasOwnProperty(u)) {
              for (var f = !0, p = 0; p < F.length; p++) {
                if (Math.abs((l.dimensions[p] || 0) - (U[u].dimensions[p] || 0)) > 1e-12) {
                  f = !1;
                  break;
                }
              }

              if (f) {
                h = !0;
                break;
              }
            }
          }

          if (!h) {
            var m = t + "_STUFF",
                d = {
              dimensions: o.dimensions.slice(0)
            };
            d.key = m, U[m] = d, V[m] = {
              unit: l,
              prefix: D.NONE[""]
            }, l.base = m;
          }
        } else {
          var m = t + "_STUFF";
          if (F.indexOf(m) >= 0) throw new Error('Cannot create new base unit "' + t + '": a base unit with that name already exists (and cannot be overridden)');
          F.push(m);

          for (var g in U) {
            U.hasOwnProperty(g) && (U[g].dimensions[F.length - 1] = 0);
          }

          for (var d = {
            dimensions: []
          }, u = 0; u < F.length; u++) {
            d.dimensions[u] = 0;
          }

          d.dimensions[F.length - 1] = 1, d.key = m, U[m] = d, l = {
            name: t,
            value: 1,
            dimensions: U[m].dimensions.slice(0),
            prefixes: i,
            offset: s,
            base: m
          }, V[m] = {
            unit: l,
            prefix: D.NONE[""]
          };
        }

        c.UNITS[t] = l;

        for (var u = 0; u < a.length; u++) {
          var v = a[u],
              y = {};

          for (var x in l) {
            l.hasOwnProperty(x) && (y[x] = l[x]);
          }

          y.name = v, c.UNITS[v] = y;
        }

        return new c(null, t);
      }, c.deleteUnit = function (t) {
        delete c.UNITS[t];
      }, c.PREFIXES = D, c.BASE_UNITS = U, c.UNITS = W, c.UNIT_SYSTEMS = $, c;
    }

    var i = n(23).endsWith,
        o = n(5).clone,
        a = n(157);
    e.name = "Unit", e.path = "type", e.factory = r, e.math = !0;
  }, function (t, e, n) {
    function r(t) {
      return t[0].precision;
    }

    var i = n(32).memoize;
    e.e = i(function (t) {
      return new t(1).exp();
    }, r), e.phi = i(function (t) {
      return new t(1).plus(new t(5).sqrt()).div(2);
    }, r), e.pi = i(function (t) {
      return pi = t.acos(-1);
    }, r), e.tau = i(function (t) {
      return e.pi(t).times(2);
    }, r);
  }, function (t, e, n) {
    var r = n(578);

    e.mixin = function (t) {
      var e = new r();
      return t.on = e.on.bind(e), t.off = e.off.bind(e), t.once = e.once.bind(e), t.emit = e.emit.bind(e), t;
    };
  }, function (t, e) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function i(t) {
      if (l === setTimeout) return setTimeout(t, 0);
      if ((l === n || !l) && setTimeout) return l = setTimeout, setTimeout(t, 0);

      try {
        return l(t, 0);
      } catch (e) {
        try {
          return l.call(null, t, 0);
        } catch (e) {
          return l.call(this, t, 0);
        }
      }
    }

    function o(t) {
      if (h === clearTimeout) return clearTimeout(t);
      if ((h === r || !h) && clearTimeout) return h = clearTimeout, clearTimeout(t);

      try {
        return h(t);
      } catch (e) {
        try {
          return h.call(null, t);
        } catch (e) {
          return h.call(this, t);
        }
      }
    }

    function a() {
      d && p && (d = !1, p.length ? m = p.concat(m) : g = -1, m.length && s());
    }

    function s() {
      if (!d) {
        var t = i(a);
        d = !0;

        for (var e = m.length; e;) {
          for (p = m, m = []; ++g < e;) {
            p && p[g].run();
          }

          g = -1, e = m.length;
        }

        p = null, d = !1, o(t);
      }
    }

    function u(t, e) {
      this.fun = t, this.array = e;
    }

    function c() {}

    var l,
        h,
        f = t.exports = {};
    !function () {
      try {
        l = "function" == typeof setTimeout ? setTimeout : n;
      } catch (t) {
        l = n;
      }

      try {
        h = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (t) {
        h = r;
      }
    }();
    var p,
        m = [],
        d = !1,
        g = -1;
    f.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      m.push(new u(t, e)), 1 !== m.length || d || i(s);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = c, f.addListener = c, f.once = c, f.off = c, f.removeListener = c, f.removeAllListeners = c, f.emit = c, f.prependListener = c, f.prependOnceListener = c, f.listeners = function (t) {
      return [];
    }, f.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, f.cwd = function () {
      return "/";
    }, f.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, f.umask = function () {
      return 0;
    };
  },,,,, function (t, e) {
    "use strict";

    var n = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    var r = {};
    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    var r = !1;
    t.exports = r;
  }, function (t, e) {
    "use strict";

    function n(t) {
      var e = t && (r && t[r] || t[i]);
      if ("function" == typeof e) return e;
    }

    var r = "function" == typeof Symbol && Symbol.iterator,
        i = "@@iterator";
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    t.exports = n(72);
  }, function (t, e) {
    t.exports = function () {
      throw new Error("define cannot be used indirect");
    };
  },,,,,, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.steppingCurveDrawer = e.getTextPlacement = e.drawGrid = e.drawText = e.drawFullBezierCurve = e.drawDashedStraigthLine = e.drawShotLine = e.drawFullStraigthLine = void 0;

    var i = n(100),
        o = n(102),
        a = r(o),
        s = n(92),
        u = r(s),
        c = n(73),
        l = n(101),
        h = n(103),
        f = r(h),
        p = e.drawFullStraigthLine = function (t, e, n, r, i) {
      t.beginPath(), t.strokeStyle = e, t.lineWidth = n, t.moveTo(r.x, r.y), t.lineTo(i.x, i.y), t.stroke();
    },
        m = (e.drawShotLine = function (t, e, n, r, i) {
      t.lineWidth = n, t.beginPath(), t.strokeStyle = e, t.moveTo(r.x, r.y), t.lineTo(i.x, i.y), t.stroke(), t.strokeStyle = "transparent", t.fillStyle = e, t.beginPath(), t.arc(i.x, i.y, 8, 0, 2 * Math.PI, !1), t.fill();
    }, e.drawDashedStraigthLine = function (t, e, n, r, o) {
      t.setLineDash([8 * (0, i.getDevicePixelRatio)(), 8 * (0, i.getDevicePixelRatio)()]), t.lineWidth = n, t.beginPath(), t.strokeStyle = e, t.moveTo(r.x, r.y), t.lineTo(o.x, o.y), t.stroke(), t.setLineDash([]);
    }),
        d = e.drawFullBezierCurve = function (t, e, n, r, i) {
      t.lineWidth = n, t.beginPath(), t.strokeStyle = e, t.moveTo(r.x, r.y), t.bezierCurveTo(.2 * r.x + .8 * i.x, .2 * r.y + .8 * i.y - Math.max(10, .5 * Math.abs(r.x - i.x)), .1 * r.x + .9 * i.x, .1 * r.y + .9 * i.y - Math.max(10, .2 * Math.abs(r.x - i.x)), i.x, i.y), t.stroke();
    },
        g = function g(t, e) {
      var n = a.default.flow(a.default.maxBy("distance"), a.default.get("distance"), a.default.multiply(1.1))(t);
      if (!(e > n)) return a.default.minBy(function (t) {
        var n = a.default.get("distance", t);
        return n ? Math.abs(e - n) : 1 / 0;
      }, t);
    },
        v = e.drawText = function (t, e, n, r, i, o) {
      var s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6],
          u = i;
      t.lineWidth = n, t.fillStyle = e, t.strokeStyle = r;
      var c = s && g(s, a.default.parseInt(10, i));

      if (c) {
        var l = a.default.get("width", t.measureText("W"));
        t.save(), t.beginPath(), t.arc(o.x, o.y, .8 * l, 0, 2 * Math.PI), t.fillStyle = e, t.lineWidth = 5, t.shadowColor = "#163739", t.strokeStyle = r, t.shadowBlur = 5, t.shadowOffsetX = 0, t.shadowOffsetY = 0, t.fill(), t.stroke(), t.restore(), t.save(), t.fillStyle = r, t.strokeStyle = e, t.textAlign = "center", u = "" + a.default.get("shortname", c), t.fillText(u, o.x, o.y), t.strokeText(u, o.x, o.y), t.restore(), u = "" + i;
        var h = o.x + 4 * l / 3;
        t.fillText(u, h, o.y), t.strokeText(u, h, o.y);
      } else t.fillText(u, o.x, o.y), t.strokeText(u, o.x, o.y);
    },
        y = function y(t, e) {
      var n = Math.atan2(e.x - t.x, t.y - e.y);
      return n;
    },
        x = function x(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
          i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
          o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1,
          a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0;
      return {
        x: e * t.x + n * t.y + r,
        y: i * t.x + o * t.y + a
      };
    },
        w = function w(t) {
      return function (e) {
        return x(e, Math.cos(t), -1 * Math.sin(t), 0, Math.sin(t), Math.cos(t), 0);
      };
    },
        b = function b(t, e) {
      return function (n) {
        return x(n, 1, 0, t, 0, 1, e);
      };
    },
        _ = function _(t, e) {
      return function (n) {
        return a.default.flow(b(-e.x, -e.y), w(t), b(e.x, e.y))(n);
      };
    },
        E = (e.drawGrid = function (t, e, n, r, i, o, s, u) {
      if (r && i) for (var c = i ? y(r, i) : 0, l = 0; l < Math.max(25, u); l++) {
        p(t, 0 === l ? "#d54336" : e, n, a.default.flow(b(l * o, -s), _(c, r))(r), a.default.flow(b(l * o, s), _(c, r))(r)), p(t, 0 === l ? "#d54336" : e, n, a.default.flow(b(-(l * o), -s), _(c, r))(r), a.default.flow(b(-(l * o), s), _(c, r))(r)), p(t, 0 === l ? "#d54336" : e, n, a.default.flow(b(-s, l * o), _(c, r))(r), a.default.flow(b(s, l * o), _(c, r))(r)), p(t, 0 === l ? "#d54336" : e, n, a.default.flow(b(-s, -(l * o)), _(c, r))(r), a.default.flow(b(s, -(l * o)), _(c, r))(r));
      }
    }, e.getTextPlacement = function (t, e, n) {
      var r = (0, c.simpleDistance)(t, e);
      if (r < 75) return !1;
      var i = n.getTopLeft(),
          o = n.getTopRight(),
          a = n.getBottomLeft(),
          s = n.getBottomRight(),
          l = t,
          h = e,
          p = f.default.intersect([t.x, t.y], [e.x, e.y], [s.x, s.y], [a.x, a.y]),
          m = f.default.intersect([t.x, t.y], [e.x, e.y], [o.x, o.y], [i.x, i.y]),
          d = f.default.intersect([t.x, t.y], [e.x, e.y], [i.x, i.y], [a.x, a.y]),
          g = f.default.intersect([t.x, t.y], [e.x, e.y], [o.x, o.y], [s.x, s.y]);

      if (p && p[0] < s.x && p[0] > a.x) {
        var v = 0;
        if (p[1] < e.y && (h = new u.default.Point(p[0], p[1]), v++), p[1] < t.y && (l = new u.default.Point(p[0], p[1]), v++), 2 === v) return !1;
      }

      if (m && m[0] < o.x && m[0] > i.x) {
        var y = 0;
        if (m[1] > e.y && (h = new u.default.Point(m[0], m[1]), y++), m[1] > t.y && (l = new u.default.Point(m[0], m[1]), y++), 2 === y) return !1;
      }

      if (d && d[1] > i.y && d[1] < a.y) {
        var x = 0;
        if (d[0] > e.x && (h = new u.default.Point(d[0], d[1]), x++), d[0] > t.x && (l = new u.default.Point(d[0], d[1]), x++), 2 === x) return !1;
      }

      if (g && g[1] > o.y && g[1] < s.y) {
        var w = 0;
        if (g[0] < e.x && (h = new u.default.Point(g[0], g[1]), w++), g[0] < t.x && (l = new u.default.Point(g[0], g[1]), w++), 2 === w) return !1;
      }

      return new u.default.Point(.5 * (l.x + h.x), .5 * (l.y + h.y));
    });

    e.steppingCurveDrawer = function (t, e, n, r, i, o) {
      var s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : void 0,
          u = e.lineWidth,
          c = e.shadowWidth,
          h = e.textWidth,
          f = e.lineColor,
          g = e.textColor,
          y = e.textBorder,
          x = e.shadowColor,
          w = e.shadowAlpha,
          b = e.drawAlpha,
          _ = n;
      a.default.each.convert({
        cap: !1
      })(function (e, n) {
        var r = window.viewer.drawer.viewportToDrawerRectangle(window.viewer.getOverlayById("clickMarker-" + n).getBounds(window.viewer.viewport)).getCenter(),
            i = Math.round((0, l.getDistance)({
          source: e,
          destination: a.default.get("world", _)
        })) + "";
        i > 1e3 ? m(t, f, u, _.canvas, r) : (t.globalAlpha = w, p(t, x, c, _.canvas, r), p(t, x, u, _.canvas, r), t.globalAlpha = b, d(t, f, u, _.canvas, r));
        var M = E(_.canvas, r, o);
        M && v(t, g, h, y, i, M, s), _ = {
          world: e,
          canvas: r
        };
      }, r);
      var M = Math.round((0, l.getDistance)({
        source: _.world,
        destination: a.default.get("world", i)
      })) + "";
      t.globalAlpha = w, p(t, x, c, _.canvas, a.default.get("canvas", i)), p(t, x, u, _.canvas, a.default.get("canvas", i)), t.globalAlpha = b, d(t, f, u, _.canvas, a.default.get("canvas", i));
      var T = E(_.canvas, a.default.get("canvas", i), o);
      T && v(t, g, h, y, M, T, s);
    };
  }, function (t, e, n) {
    var r, i;
    (function (t) {
      /**
      * @license Complex.js v2.0.1 11/02/2016
      *
      * Copyright (c) 2016, Robert Eisele (robert@xarg.org)
      * Dual licensed under the MIT or GPL Version 2 licenses.
      **/
      !function (o) {
        "use strict";

        function a(t, e) {
          var n = Math.abs(t),
              r = Math.abs(e);
          return 0 === t ? Math.log(r) : 0 === e ? Math.log(n) : n < 3e3 && r < 3e3 ? .5 * Math.log(t * t + e * e) : Math.log(t / Math.cos(Math.atan2(e, t)));
        }

        function s(t, e) {
          return this instanceof s ? (l(t, e), this.re = u.re, void (this.im = u.im)) : new s(t, e);
        }

        var u = {
          re: 0,
          im: 0
        };
        Math.cosh = Math.cosh || function (t) {
          return .5 * (Math.exp(t) + Math.exp(-t));
        }, Math.sinh = Math.sinh || function (t) {
          return .5 * (Math.exp(t) - Math.exp(-t));
        };

        var c = function c() {
          throw SyntaxError("Invalid Param");
        },
            l = function l(t, e) {
          if (void 0 === t || null === t) u.re = u.im = 0;else if (void 0 !== e) u.re = t, u.im = e;else switch (typeof t) {
            case "object":
              "im" in t && "re" in t ? (u.re = t.re, u.im = t.im) : "abs" in t && "arg" in t ? (u.re = t.abs * Math.cos(t.arg), u.im = t.abs * Math.sin(t.arg)) : "r" in t && "phi" in t ? (u.re = t.r * Math.cos(t.phi), u.im = t.r * Math.sin(t.phi)) : c();
              break;

            case "string":
              u.im = u.re = 0;
              var n = t.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g),
                  r = 1,
                  i = 0;
              null === n && c();

              for (var o = 0; o < n.length; o++) {
                var a = n[o];
                " " === a || "\t" === a || "\n" === a || ("+" === a ? r++ : "-" === a ? i++ : "i" === a || "I" === a ? (r + i === 0 && c(), " " === n[o + 1] || isNaN(n[o + 1]) ? u.im += parseFloat((i % 2 ? "-" : "") + "1") : (u.im += parseFloat((i % 2 ? "-" : "") + n[o + 1]), o++), r = i = 0) : ((r + i === 0 || isNaN(a)) && c(), "i" === n[o + 1] || "I" === n[o + 1] ? (u.im += parseFloat((i % 2 ? "-" : "") + a), o++) : u.re += parseFloat((i % 2 ? "-" : "") + a), r = i = 0));
              }

              r + i > 0 && c();
              break;

            case "number":
              u.im = 0, u.re = t;
              break;

            default:
              c();
          }
          isNaN(u.re) || isNaN(u.im);
        };

        s.prototype = {
          re: 0,
          im: 0,
          sign: function sign() {
            var t = this.abs();
            return new s(this.re / t, this.im / t);
          },
          add: function add(t, e) {
            return l(t, e), new s(this.re + u.re, this.im + u.im);
          },
          sub: function sub(t, e) {
            return l(t, e), new s(this.re - u.re, this.im - u.im);
          },
          mul: function mul(t, e) {
            return l(t, e), 0 === u.im && 0 === this.im ? new s(this.re * u.re, 0) : new s(this.re * u.re - this.im * u.im, this.re * u.im + this.im * u.re);
          },
          div: function div(t, e) {
            l(t, e), t = this.re, e = this.im;
            var n,
                r,
                i = u.re,
                o = u.im;
            return 0 === i && 0 === o ? new s(0 !== t ? t / 0 : 0, 0 !== e ? e / 0 : 0) : 0 === o ? new s(t / i, e / i) : Math.abs(i) < Math.abs(o) ? (r = i / o, n = i * r + o, new s((t * r + e) / n, (e * r - t) / n)) : (r = o / i, n = o * r + i, new s((t + e * r) / n, (e - t * r) / n));
          },
          pow: function pow(t, e) {
            if (l(t, e), t = this.re, e = this.im, 0 === t && 0 === e) return new s(0, 0);
            var n = Math.atan2(e, t),
                r = a(t, e);

            if (0 === u.im) {
              if (0 === e && t >= 0) return new s(Math.pow(t, u.re), 0);
              if (0 === t) switch (u.re % 4) {
                case 0:
                  return new s(Math.pow(e, u.re), 0);

                case 1:
                  return new s(0, Math.pow(e, u.re));

                case 2:
                  return new s(-Math.pow(e, u.re), 0);

                case 3:
                  return new s(0, -Math.pow(e, u.re));
              }
            }

            return t = Math.exp(u.re * r - u.im * n), e = u.im * r + u.re * n, new s(t * Math.cos(e), t * Math.sin(e));
          },
          sqrt: function sqrt() {
            var t,
                e,
                n = this.re,
                r = this.im,
                i = this.abs();
            return n >= 0 && 0 === r ? new s(Math.sqrt(n), 0) : (t = n >= 0 ? .5 * Math.sqrt(2 * (i + n)) : Math.abs(r) / Math.sqrt(2 * (i - n)), e = n <= 0 ? .5 * Math.sqrt(2 * (i - n)) : Math.abs(r) / Math.sqrt(2 * (i + n)), new s(t, r >= 0 ? e : -e));
          },
          exp: function exp() {
            var t = Math.exp(this.re);
            return 0 === this.im, new s(t * Math.cos(this.im), t * Math.sin(this.im));
          },
          log: function log() {
            var t = this.re,
                e = this.im;
            return new s(a(t, e), Math.atan2(e, t));
          },
          abs: function abs() {
            var t = Math.abs(this.re),
                e = Math.abs(this.im);
            return t < 3e3 && e < 3e3 ? Math.sqrt(t * t + e * e) : (t < e ? (t = e, e = this.re / this.im) : e = this.im / this.re, t * Math.sqrt(1 + e * e));
          },
          arg: function arg() {
            return Math.atan2(this.im, this.re);
          },
          sin: function sin() {
            var t = this.re,
                e = this.im;
            return new s(Math.sin(t) * Math.cosh(e), Math.cos(t) * Math.sinh(e));
          },
          cos: function cos() {
            var t = this.re,
                e = this.im;
            return new s(Math.cos(t) * Math.cosh(e), -Math.sin(t) * Math.sinh(e));
          },
          tan: function tan() {
            var t = 2 * this.re,
                e = 2 * this.im,
                n = Math.cos(t) + Math.cosh(e);
            return new s(Math.sin(t) / n, Math.sinh(e) / n);
          },
          cot: function cot() {
            var t = 2 * this.re,
                e = 2 * this.im,
                n = Math.cos(t) - Math.cosh(e);
            return new s(-Math.sin(t) / n, Math.sinh(e) / n);
          },
          sec: function sec() {
            var t = this.re,
                e = this.im,
                n = .5 * Math.cosh(2 * e) + .5 * Math.cos(2 * t);
            return new s(Math.cos(t) * Math.cosh(e) / n, Math.sin(t) * Math.sinh(e) / n);
          },
          csc: function csc() {
            var t = this.re,
                e = this.im,
                n = .5 * Math.cosh(2 * e) - .5 * Math.cos(2 * t);
            return new s(Math.sin(t) * Math.cosh(e) / n, -Math.cos(t) * Math.sinh(e) / n);
          },
          asin: function asin() {
            var t = this.re,
                e = this.im,
                n = new s(e * e - t * t + 1, -2 * t * e).sqrt(),
                r = new s(n.re - e, n.im + t).log();
            return new s(r.im, -r.re);
          },
          acos: function acos() {
            var t = this.re,
                e = this.im,
                n = new s(e * e - t * t + 1, -2 * t * e).sqrt(),
                r = new s(n.re - e, n.im + t).log();
            return new s(Math.PI / 2 - r.im, r.re);
          },
          atan: function atan() {
            var t = this.re,
                e = this.im;

            if (0 === t) {
              if (1 === e) return new s(0, 1 / 0);
              if (e === -1) return new s(0, -(1 / 0));
            }

            var n = t * t + (1 - e) * (1 - e),
                r = new s((1 - e * e - t * t) / n, -2 * t / n).log();
            return new s(-.5 * r.im, .5 * r.re);
          },
          acot: function acot() {
            var t = this.re,
                e = this.im;
            if (0 === e) return new s(Math.atan2(1, t), 0);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).atan() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).atan();
          },
          asec: function asec() {
            var t = this.re,
                e = this.im;
            if (0 === t && 0 === e) return new s(0, 1 / 0);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).acos() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).acos();
          },
          acsc: function acsc() {
            var t = this.re,
                e = this.im;
            if (0 === t && 0 === e) return new s(Math.PI / 2, 1 / 0);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).asin() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).asin();
          },
          sinh: function sinh() {
            var t = this.re,
                e = this.im;
            return new s(Math.sinh(t) * Math.cos(e), Math.cosh(t) * Math.sin(e));
          },
          cosh: function cosh() {
            var t = this.re,
                e = this.im;
            return new s(Math.cosh(t) * Math.cos(e), Math.sinh(t) * Math.sin(e));
          },
          tanh: function tanh() {
            var t = 2 * this.re,
                e = 2 * this.im,
                n = Math.cosh(t) + Math.cos(e);
            return new s(Math.sinh(t) / n, Math.sin(e) / n);
          },
          coth: function coth() {
            var t = 2 * this.re,
                e = 2 * this.im,
                n = Math.cosh(t) - Math.cos(e);
            return new s(Math.sinh(t) / n, -Math.sin(e) / n);
          },
          csch: function csch() {
            var t = this.re,
                e = this.im,
                n = Math.cos(2 * e) - Math.cosh(2 * t);
            return new s(-2 * Math.sinh(t) * Math.cos(e) / n, 2 * Math.cosh(t) * Math.sin(e) / n);
          },
          sech: function sech() {
            var t = this.re,
                e = this.im,
                n = Math.cos(2 * e) + Math.cosh(2 * t);
            return new s(2 * Math.cosh(t) * Math.cos(e) / n, -2 * Math.sinh(t) * Math.sin(e) / n);
          },
          asinh: function asinh() {
            var t = this.im;
            this.im = -this.re, this.re = t;
            var e = this.asin();
            return this.re = -this.im, this.im = t, t = e.re, e.re = -e.im, e.im = t, e;
          },
          acosh: function acosh() {
            var t,
                e = this.acos();
            return e.im <= 0 ? (t = e.re, e.re = -e.im, e.im = t) : (t = e.im, e.im = -e.re, e.re = t), e;
          },
          atanh: function atanh() {
            var t = this.re,
                e = this.im,
                n = t > 1 && 0 === e,
                r = 1 - t,
                i = 1 + t,
                o = r * r + e * e,
                u = 0 !== o ? new s((i * r - e * e) / o, (e * r + i * e) / o) : new s(t !== -1 ? t / 0 : 0, 0 !== e ? e / 0 : 0),
                c = u.re;
            return u.re = a(u.re, u.im) / 2, u.im = Math.atan2(u.im, c) / 2, n && (u.im = -u.im), u;
          },
          acoth: function acoth() {
            var t = this.re,
                e = this.im;
            if (0 === t && 0 === e) return new s(0, Math.PI / 2);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).atanh() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).atanh();
          },
          acsch: function acsch() {
            var t = this.re,
                e = this.im;
            if (0 === e) return new s(0 !== t ? Math.log(t + Math.sqrt(t * t + 1)) : 1 / 0, 0);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).asinh() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).asinh();
          },
          asech: function asech() {
            var t = this.re,
                e = this.im;
            if (0 === t && 0 === e) return new s(1 / 0, 0);
            var n = t * t + e * e;
            return 0 !== n ? new s(t / n, -e / n).acosh() : new s(0 !== t ? t / 0 : 0, 0 !== e ? -e / 0 : 0).acosh();
          },
          inverse: function inverse() {
            var t = this.re,
                e = this.im,
                n = t * t + e * e;
            return new s(0 !== t ? t / n : 0, 0 !== e ? -e / n : 0);
          },
          conjugate: function conjugate() {
            return new s(this.re, -this.im);
          },
          neg: function neg() {
            return new s(-this.re, -this.im);
          },
          ceil: function ceil(t) {
            return t = Math.pow(10, t || 0), new s(Math.ceil(this.re * t) / t, Math.ceil(this.im * t) / t);
          },
          floor: function floor(t) {
            return t = Math.pow(10, t || 0), new s(Math.floor(this.re * t) / t, Math.floor(this.im * t) / t);
          },
          round: function round(t) {
            return t = Math.pow(10, t || 0), new s(Math.round(this.re * t) / t, Math.round(this.im * t) / t);
          },
          equals: function equals(t, e) {
            return l(t, e), Math.abs(u.re - this.re) <= s.EPSILON && Math.abs(u.im - this.im) <= s.EPSILON;
          },
          clone: function clone() {
            return new s(this.re, this.im);
          },
          toString: function toString() {
            var t = this.re,
                e = this.im,
                n = "";
            return isNaN(t) || isNaN(e) ? "NaN" : (0 !== t && (n += t), 0 !== e && (0 !== t ? n += e < 0 ? " - " : " + " : e < 0 && (n += "-"), e = Math.abs(e), 1 !== e && (n += e), n += "i"), n ? n : "0");
          },
          toVector: function toVector() {
            return [this.re, this.im];
          },
          valueOf: function valueOf() {
            return 0 === this.im ? this.re : null;
          },
          isNaN: function (_isNaN) {
            function isNaN() {
              return _isNaN.apply(this, arguments);
            }

            isNaN.toString = function () {
              return _isNaN.toString();
            };

            return isNaN;
          }(function () {
            return isNaN(this.re) || isNaN(this.im);
          })
        }, s.ZERO = new s(0, 0), s.ONE = new s(1, 0), s.I = new s(0, 1), s.PI = new s(Math.PI, 0), s.E = new s(Math.E, 0), s.EPSILON = 1e-16, n(169).amd ? (r = [], i = function () {
          return s;
        }.apply(e, r), !(void 0 !== i && (t.exports = i))) : t.exports = s;
      }(this);
    }).call(e, n(96)(t));
  }, function (t, e, n) {
    var r;
    !function (i) {
      "use strict";

      function o(t) {
        var e,
            n,
            r,
            i = t.length - 1,
            o = "",
            a = t[0];

        if (i > 0) {
          for (o += a, e = 1; e < i; e++) {
            r = t[e] + "", n = zt - r.length, n && (o += g(n)), o += r;
          }

          a = t[e], r = a + "", n = zt - r.length, n && (o += g(n));
        } else if (0 === a) return "0";

        for (; a % 10 === 0;) {
          a /= 10;
        }

        return o + a;
      }

      function a(t, e, n) {
        if (t !== ~~t || t < e || t > n) throw Error(Nt + t);
      }

      function s(t, e, n, r) {
        var i, o, a, s;

        for (o = t[0]; o >= 10; o /= 10) {
          --e;
        }

        return --e < 0 ? (e += zt, i = 0) : (i = Math.ceil((e + 1) / zt), e %= zt), o = Ot(10, zt - e), s = t[i] % o | 0, null == r ? e < 3 ? (0 == e ? s = s / 100 | 0 : 1 == e && (s = s / 10 | 0), a = n < 4 && 99999 == s || n > 3 && 49999 == s || 5e4 == s || 0 == s) : a = (n < 4 && s + 1 == o || n > 3 && s + 1 == o / 2) && (t[i + 1] / o / 100 | 0) == Ot(10, e - 2) - 1 || (s == o / 2 || 0 == s) && 0 == (t[i + 1] / o / 100 | 0) : e < 4 ? (0 == e ? s = s / 1e3 | 0 : 1 == e ? s = s / 100 | 0 : 2 == e && (s = s / 10 | 0), a = (r || n < 4) && 9999 == s || !r && n > 3 && 4999 == s) : a = ((r || n < 4) && s + 1 == o || !r && n > 3 && s + 1 == o / 2) && (t[i + 1] / o / 1e3 | 0) == Ot(10, e - 3) - 1, a;
      }

      function u(t, e, n) {
        for (var r, i, o = [0], a = 0, s = t.length; a < s;) {
          for (i = o.length; i--;) {
            o[i] *= e;
          }

          for (o[0] += xt.indexOf(t.charAt(a++)), r = 0; r < o.length; r++) {
            o[r] > n - 1 && (void 0 === o[r + 1] && (o[r + 1] = 0), o[r + 1] += o[r] / n | 0, o[r] %= n);
          }
        }

        return o.reverse();
      }

      function c(t, e) {
        var n,
            r,
            i = e.d.length;
        i < 32 ? (n = Math.ceil(i / 3), r = Math.pow(4, -n).toString()) : (n = 16, r = "2.3283064365386962890625e-10"), t.precision += n, e = N(t, 1, e.times(r), new t(1));

        for (var o = n; o--;) {
          var a = e.times(e);
          e = a.times(a).minus(a).times(8).plus(1);
        }

        return t.precision -= n, e;
      }

      function l(t, e, n, r) {
        var i,
            o,
            a,
            s,
            u,
            c,
            l,
            h,
            f,
            p = t.constructor;

        t: if (null != e) {
          if (h = t.d, !h) return t;

          for (i = 1, s = h[0]; s >= 10; s /= 10) {
            i++;
          }

          if (o = e - i, o < 0) o += zt, a = e, l = h[f = 0], u = l / Ot(10, i - a - 1) % 10 | 0;else if (f = Math.ceil((o + 1) / zt), s = h.length, f >= s) {
            if (!r) break t;

            for (; s++ <= f;) {
              h.push(0);
            }

            l = u = 0, i = 1, o %= zt, a = o - zt + 1;
          } else {
            for (l = s = h[f], i = 1; s >= 10; s /= 10) {
              i++;
            }

            o %= zt, a = o - zt + i, u = a < 0 ? 0 : l / Ot(10, i - a - 1) % 10 | 0;
          }
          if (r = r || e < 0 || void 0 !== h[f + 1] || (a < 0 ? l : l % Ot(10, i - a - 1)), c = n < 4 ? (u || r) && (0 == n || n == (t.s < 0 ? 3 : 2)) : u > 5 || 5 == u && (4 == n || r || 6 == n && (o > 0 ? a > 0 ? l / Ot(10, i - a) : 0 : h[f - 1]) % 10 & 1 || n == (t.s < 0 ? 8 : 7)), e < 1 || !h[0]) return h.length = 0, c ? (e -= t.e + 1, h[0] = Ot(10, (zt - e % zt) % zt), t.e = -e || 0) : h[0] = t.e = 0, t;
          if (0 == o ? (h.length = f, s = 1, f--) : (h.length = f + 1, s = Ot(10, zt - o), h[f] = a > 0 ? (l / Ot(10, i - a) % Ot(10, a) | 0) * s : 0), c) for (;;) {
            if (0 == f) {
              for (o = 1, a = h[0]; a >= 10; a /= 10) {
                o++;
              }

              for (a = h[0] += s, s = 1; a >= 10; a /= 10) {
                s++;
              }

              o != s && (t.e++, h[0] == kt && (h[0] = 1));
              break;
            }

            if (h[f] += s, h[f] != kt) break;
            h[f--] = 0, s = 1;
          }

          for (o = h.length; 0 === h[--o];) {
            h.pop();
          }
        }

        return Mt && (t.e > p.maxE ? (t.d = null, t.e = NaN) : t.e < p.minE && (t.e = 0, t.d = [0])), t;
      }

      function h(t, e, n) {
        if (!t.isFinite()) return _(t);
        var r,
            i = t.e,
            a = o(t.d),
            s = a.length;
        return e ? (n && (r = n - s) > 0 ? a = a.charAt(0) + "." + a.slice(1) + g(r) : s > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (t.e < 0 ? "e" : "e+") + t.e) : i < 0 ? (a = "0." + g(-i - 1) + a, n && (r = n - s) > 0 && (a += g(r))) : i >= s ? (a += g(i + 1 - s), n && (r = n - i - 1) > 0 && (a = a + "." + g(r))) : ((r = i + 1) < s && (a = a.slice(0, r) + "." + a.slice(r)), n && (r = n - s) > 0 && (i + 1 === s && (a += "."), a += g(r))), a;
      }

      function f(t, e) {
        for (var n = 1, r = t[0]; r >= 10; r /= 10) {
          n++;
        }

        return n + e * zt - 1;
      }

      function p(t, e, n) {
        if (e > Lt) throw Mt = !0, n && (t.precision = n), Error(St);
        return l(new t(wt), e, 1, !0);
      }

      function m(t, e, n) {
        if (e > Dt) throw Error(St);
        return l(new t(bt), e, n, !0);
      }

      function d(t) {
        var e = t.length - 1,
            n = e * zt + 1;

        if (e = t[e]) {
          for (; e % 10 == 0; e /= 10) {
            n--;
          }

          for (e = t[0]; e >= 10; e /= 10) {
            n++;
          }
        }

        return n;
      }

      function g(t) {
        for (var e = ""; t--;) {
          e += "0";
        }

        return e;
      }

      function v(t, e, n, r) {
        var i,
            o = new t(1),
            a = Math.ceil(r / zt + 4);

        for (Mt = !1;;) {
          if (n % 2 && (o = o.times(e), O(o.d, a) && (i = !0)), n = At(n / 2), 0 === n) {
            n = o.d.length - 1, i && 0 === o.d[n] && ++o.d[n];
            break;
          }

          e = e.times(e), O(e.d, a);
        }

        return Mt = !0, o;
      }

      function y(t) {
        return 1 & t.d[t.d.length - 1];
      }

      function x(t, e, n) {
        for (var r, i = new t(e[0]), o = 0; ++o < e.length;) {
          if (r = new t(e[o]), !r.s) {
            i = r;
            break;
          }

          i[n](r) && (i = r);
        }

        return i;
      }

      function w(t, e) {
        var n,
            r,
            i,
            a,
            u,
            c,
            h,
            f = 0,
            p = 0,
            m = 0,
            d = t.constructor,
            g = d.rounding,
            v = d.precision;
        if (!t.d || !t.d[0] || t.e > 17) return new d(t.d ? t.d[0] ? t.s < 0 ? 0 : 1 / 0 : 1 : t.s ? t.s < 0 ? 0 : t : NaN);

        for (null == e ? (Mt = !1, h = v) : h = e, c = new d(.03125); t.e > -2;) {
          t = t.times(c), m += 5;
        }

        for (r = Math.log(Ot(2, m)) / Math.LN10 * 2 + 5 | 0, h += r, n = a = u = new d(1), d.precision = h;;) {
          if (a = l(a.times(t), h, 1), n = n.times(++p), c = u.plus(Ft(a, n, h, 1)), o(c.d).slice(0, h) === o(u.d).slice(0, h)) {
            for (i = m; i--;) {
              u = l(u.times(u), h, 1);
            }

            if (null != e) return d.precision = v, u;
            if (!(f < 3 && s(u.d, h - r, g, f))) return l(u, d.precision = v, g, Mt = !0);
            d.precision = h += 10, n = a = c = new d(1), p = 0, f++;
          }

          u = c;
        }
      }

      function b(t, e) {
        var n,
            r,
            i,
            a,
            u,
            c,
            h,
            f,
            m,
            d,
            g,
            v = 1,
            y = 10,
            x = t,
            w = x.d,
            _ = x.constructor,
            E = _.rounding,
            M = _.precision;
        if (x.s < 0 || !w || !w[0] || !x.e && 1 == w[0] && 1 == w.length) return new _(w && !w[0] ? -1 / 0 : 1 != x.s ? NaN : w ? 0 : x);
        if (null == e ? (Mt = !1, m = M) : m = e, _.precision = m += y, n = o(w), r = n.charAt(0), !(Math.abs(a = x.e) < 15e14)) return f = p(_, m + 2, M).times(a + ""), x = b(new _(r + "." + n.slice(1)), m - y).plus(f), _.precision = M, null == e ? l(x, M, E, Mt = !0) : x;

        for (; r < 7 && 1 != r || 1 == r && n.charAt(1) > 3;) {
          x = x.times(t), n = o(x.d), r = n.charAt(0), v++;
        }

        for (a = x.e, r > 1 ? (x = new _("0." + n), a++) : x = new _(r + "." + n.slice(1)), d = x, h = u = x = Ft(x.minus(1), x.plus(1), m, 1), g = l(x.times(x), m, 1), i = 3;;) {
          if (u = l(u.times(g), m, 1), f = h.plus(Ft(u, new _(i), m, 1)), o(f.d).slice(0, m) === o(h.d).slice(0, m)) {
            if (h = h.times(2), 0 !== a && (h = h.plus(p(_, m + 2, M).times(a + ""))), h = Ft(h, new _(v), m, 1), null != e) return _.precision = M, h;
            if (!s(h.d, m - y, E, c)) return l(h, _.precision = M, E, Mt = !0);
            _.precision = m += y, f = u = x = Ft(d.minus(1), d.plus(1), m, 1), g = l(x.times(x), m, 1), i = c = 1;
          }

          h = f, i += 2;
        }
      }

      function _(t) {
        return String(t.s * t.s / 0);
      }

      function E(t, e) {
        var n, r, i;

        for ((n = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +e.slice(r + 1), e = e.substring(0, r)) : n < 0 && (n = e.length), r = 0; 48 === e.charCodeAt(r); r++) {
          ;
        }

        for (i = e.length; 48 === e.charCodeAt(i - 1); --i) {
          ;
        }

        if (e = e.slice(r, i)) {
          if (i -= r, t.e = n = n - r - 1, t.d = [], r = (n + 1) % zt, n < 0 && (r += zt), r < i) {
            for (r && t.d.push(+e.slice(0, r)), i -= zt; r < i;) {
              t.d.push(+e.slice(r, r += zt));
            }

            e = e.slice(r), r = zt - e.length;
          } else r -= i;

          for (; r--;) {
            e += "0";
          }

          t.d.push(+e), Mt && (t.e > t.constructor.maxE ? (t.d = null, t.e = NaN) : t.e < t.constructor.minE && (t.e = 0, t.d = [0]));
        } else t.e = 0, t.d = [0];

        return t;
      }

      function M(t, e) {
        var n, r, i, o, a, s, c, l, h;
        if ("Infinity" === e || "NaN" === e) return +e || (t.s = NaN), t.e = NaN, t.d = null, t;
        if (Pt.test(e)) n = 16, e = e.toLowerCase();else if (Ct.test(e)) n = 2;else {
          if (!Rt.test(e)) throw Error(Nt + e);
          n = 8;
        }

        for (o = e.search(/p/i), o > 0 ? (c = +e.slice(o + 1), e = e.substring(2, o)) : e = e.slice(2), o = e.indexOf("."), a = o >= 0, r = t.constructor, a && (e = e.replace(".", ""), s = e.length, o = s - o, i = v(r, new r(n), o, 2 * o)), l = u(e, n, kt), h = l.length - 1, o = h; 0 === l[o]; --o) {
          l.pop();
        }

        return o < 0 ? new r(0 * t.s) : (t.e = f(l, h), t.d = l, Mt = !1, a && (t = Ft(t, i, 4 * s)), c && (t = t.times(Math.abs(c) < 54 ? Math.pow(2, c) : _t.pow(2, c))), Mt = !0, t);
      }

      function T(t, e) {
        var n,
            r = e.d.length;
        if (r < 3) return N(t, 2, e, e);
        n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : 0 | n, e = e.times(Math.pow(5, -n)), e = N(t, 2, e, e);

        for (var i, o = new t(5), a = new t(16), s = new t(20); n--;) {
          i = e.times(e), e = e.times(o.plus(i.times(a.times(i).minus(s))));
        }

        return e;
      }

      function N(t, e, n, r, i) {
        var o,
            a,
            s,
            u,
            c = 1,
            l = t.precision,
            h = Math.ceil(l / zt);

        for (Mt = !1, u = n.times(n), s = new t(r);;) {
          if (a = Ft(s.times(u), new t(e++ * e++), l, 1), s = i ? r.plus(a) : r.minus(a), r = Ft(a.times(u), new t(e++ * e++), l, 1), a = s.plus(r), void 0 !== a.d[h]) {
            for (o = h; a.d[o] === s.d[o] && o--;) {
              ;
            }

            if (o == -1) break;
          }

          o = s, s = r, r = a, a = o, c++;
        }

        return Mt = !0, a.d.length = h + 1, a;
      }

      function S(t, e) {
        var n,
            r = e.s < 0,
            i = m(t, t.precision, 1),
            o = i.times(.5);
        if (e = e.abs(), e.lte(o)) return gt = r ? 4 : 1, e;
        if (n = e.divToInt(i), n.isZero()) gt = r ? 3 : 2;else {
          if (e = e.minus(n.times(i)), e.lte(o)) return gt = y(n) ? r ? 2 : 3 : r ? 4 : 1, e;
          gt = y(n) ? r ? 1 : 4 : r ? 3 : 2;
        }
        return e.minus(i).abs();
      }

      function A(t, e, n, r) {
        var i,
            o,
            s,
            c,
            l,
            f,
            p,
            m,
            d,
            g = t.constructor,
            v = void 0 !== n;

        if (v ? (a(n, 1, yt), void 0 === r ? r = g.rounding : a(r, 0, 8)) : (n = g.precision, r = g.rounding), t.isFinite()) {
          for (p = h(t), s = p.indexOf("."), v ? (i = 2, 16 == e ? n = 4 * n - 3 : 8 == e && (n = 3 * n - 2)) : i = e, s >= 0 && (p = p.replace(".", ""), d = new g(1), d.e = p.length - s, d.d = u(h(d), 10, i), d.e = d.d.length), m = u(p, 10, i), o = l = m.length; 0 == m[--l];) {
            m.pop();
          }

          if (m[0]) {
            if (s < 0 ? o-- : (t = new g(t), t.d = m, t.e = o, t = Ft(t, d, n, r, 0, i), m = t.d, o = t.e, f = dt), s = m[n], c = i / 2, f = f || void 0 !== m[n + 1], f = r < 4 ? (void 0 !== s || f) && (0 === r || r === (t.s < 0 ? 3 : 2)) : s > c || s === c && (4 === r || f || 6 === r && 1 & m[n - 1] || r === (t.s < 0 ? 8 : 7)), m.length = n, f) for (; ++m[--n] > i - 1;) {
              m[n] = 0, n || (++o, m.unshift(1));
            }

            for (l = m.length; !m[l - 1]; --l) {
              ;
            }

            for (s = 0, p = ""; s < l; s++) {
              p += xt.charAt(m[s]);
            }

            if (v) {
              if (l > 1) if (16 == e || 8 == e) {
                for (s = 16 == e ? 4 : 3, --l; l % s; l++) {
                  p += "0";
                }

                for (m = u(p, i, e), l = m.length; !m[l - 1]; --l) {
                  ;
                }

                for (s = 1, p = "1."; s < l; s++) {
                  p += xt.charAt(m[s]);
                }
              } else p = p.charAt(0) + "." + p.slice(1);
              p = p + (o < 0 ? "p" : "p+") + o;
            } else if (o < 0) {
              for (; ++o;) {
                p = "0" + p;
              }

              p = "0." + p;
            } else if (++o > l) for (o -= l; o--;) {
              p += "0";
            } else o < l && (p = p.slice(0, o) + "." + p.slice(o));
          } else p = v ? "0p+0" : "0";

          p = (16 == e ? "0x" : 2 == e ? "0b" : 8 == e ? "0o" : "") + p;
        } else p = _(t);

        return t.s < 0 ? "-" + p : p;
      }

      function O(t, e) {
        if (t.length > e) return t.length = e, !0;
      }

      function C(t) {
        return new this(t).abs();
      }

      function P(t) {
        return new this(t).acos();
      }

      function R(t) {
        return new this(t).acosh();
      }

      function I(t, e) {
        return new this(t).plus(e);
      }

      function k(t) {
        return new this(t).asin();
      }

      function z(t) {
        return new this(t).asinh();
      }

      function B(t) {
        return new this(t).atan();
      }

      function L(t) {
        return new this(t).atanh();
      }

      function D(t, e) {
        t = new this(t), e = new this(e);
        var n,
            r = this.precision,
            i = this.rounding,
            o = r + 4;
        return t.s && e.s ? t.d || e.d ? !e.d || t.isZero() ? (n = e.s < 0 ? m(this, r, i) : new this(0), n.s = t.s) : !t.d || e.isZero() ? (n = m(this, o, 1).times(.5), n.s = t.s) : e.s < 0 ? (this.precision = o, this.rounding = 1, n = this.atan(Ft(t, e, o, 1)), e = m(this, o, 1), this.precision = r, this.rounding = i, n = t.s < 0 ? n.minus(e) : n.plus(e)) : n = this.atan(Ft(t, e, o, 1)) : (n = m(this, o, 1).times(e.s > 0 ? .25 : .75), n.s = t.s) : n = new this(NaN), n;
      }

      function j(t) {
        return new this(t).cbrt();
      }

      function F(t) {
        return l(t = new this(t), t.e + 1, 2);
      }

      function U(t) {
        if (!t || "object" != typeof t) throw Error(Tt + "Object expected");
        var e,
            n,
            r,
            i = ["precision", 1, yt, "rounding", 0, 8, "toExpNeg", -vt, 0, "toExpPos", 0, vt, "maxE", 0, vt, "minE", -vt, 0, "modulo", 0, 9];

        for (e = 0; e < i.length; e += 3) {
          if (void 0 !== (r = t[n = i[e]])) {
            if (!(At(r) === r && r >= i[e + 1] && r <= i[e + 2])) throw Error(Nt + n + ": " + r);
            this[n] = r;
          }
        }

        if (t.hasOwnProperty(n = "crypto")) if (void 0 === (r = t[n])) this[n] = r;else {
          if (r !== !0 && r !== !1 && 0 !== r && 1 !== r) throw Error(Nt + n + ": " + r);
          this[n] = !(!r || !Et || !Et.getRandomValues && !Et.randomBytes);
        }
        return this;
      }

      function q(t) {
        return new this(t).cos();
      }

      function H(t) {
        return new this(t).cosh();
      }

      function W(t) {
        function e(t) {
          var n,
              r,
              i,
              o = this;
          if (!(o instanceof e)) return new e(t);
          if (o.constructor = e, t instanceof e) return o.s = t.s, o.e = t.e, void (o.d = (t = t.d) ? t.slice() : t);

          if (i = typeof t, "number" === i) {
            if (0 === t) return o.s = 1 / t < 0 ? -1 : 1, o.e = 0, void (o.d = [0]);

            if (t < 0 ? (t = -t, o.s = -1) : o.s = 1, t === ~~t && t < 1e7) {
              for (n = 0, r = t; r >= 10; r /= 10) {
                n++;
              }

              return o.e = n, void (o.d = [t]);
            }

            return 0 * t !== 0 ? (t || (o.s = NaN), o.e = NaN, void (o.d = null)) : E(o, t.toString());
          }

          if ("string" !== i) throw Error(Nt + t);
          return 45 === t.charCodeAt(0) ? (t = t.slice(1), o.s = -1) : o.s = 1, It.test(t) ? E(o, t) : M(o, t);
        }

        var n, r, i;
        if (e.prototype = jt, e.ROUND_UP = 0, e.ROUND_DOWN = 1, e.ROUND_CEIL = 2, e.ROUND_FLOOR = 3, e.ROUND_HALF_UP = 4, e.ROUND_HALF_DOWN = 5, e.ROUND_HALF_EVEN = 6, e.ROUND_HALF_CEIL = 7, e.ROUND_HALF_FLOOR = 8, e.EUCLID = 9, e.config = U, e.clone = W, e.abs = C, e.acos = P, e.acosh = R, e.add = I, e.asin = k, e.asinh = z, e.atan = B, e.atanh = L, e.atan2 = D, e.cbrt = j, e.ceil = F, e.cos = q, e.cosh = H, e.div = G, e.exp = $, e.floor = V, e.fromJSON = Z, e.hypot = X, e.ln = Y, e.log = K, e.log10 = Q, e.log2 = J, e.max = tt, e.min = et, e.mod = nt, e.mul = rt, e.pow = it, e.random = ot, e.round = at, e.sign = st, e.sin = ut, e.sinh = ct, e.sqrt = lt, e.sub = ht, e.tan = ft, e.tanh = pt, e.trunc = mt, void 0 === t && (t = {}), t) for (i = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], n = 0; n < i.length;) {
          t.hasOwnProperty(r = i[n++]) || (t[r] = this[r]);
        }
        return e.config(t), e;
      }

      function G(t, e) {
        return new this(t).div(e);
      }

      function $(t) {
        return new this(t).exp();
      }

      function V(t) {
        return l(t = new this(t), t.e + 1, 3);
      }

      function Z(t) {
        var e, n, r, i;
        if ("string" != typeof t || !t) throw Error(Nt + t);
        if (r = t.length, i = xt.indexOf(t.charAt(0)), 1 === r) return new this(i > 81 ? [-1 / 0, 1 / 0, NaN][i - 82] : i > 40 ? -(i - 41) : i);
        if (64 & i) n = 16 & i, e = n ? (7 & i) - 3 : (15 & i) - 7, r = 1;else {
          if (2 === r) return i = 88 * i + xt.indexOf(t.charAt(1)), new this(i >= 2816 ? -(i - 2816) - 41 : i + 41);
          if (n = 32 & i, !(31 & i)) return t = u(t.slice(1), 88, 10).join(""), new this(n ? "-" + t : t);
          e = 15 & i, r = e + 1, e = 1 === e ? xt.indexOf(t.charAt(1)) : 2 === e ? 88 * xt.indexOf(t.charAt(1)) + xt.indexOf(t.charAt(2)) : +u(t.slice(1, r), 88, 10).join(""), 16 & i && (e = -e);
        }
        return t = u(t.slice(r), 88, 10).join(""), e = e - t.length + 1, t = t + "e" + e, new this(n ? "-" + t : t);
      }

      function X() {
        var t,
            e,
            n = new this(0);

        for (Mt = !1, t = 0; t < arguments.length;) {
          if (e = new this(arguments[t++]), e.d) n.d && (n = n.plus(e.times(e)));else {
            if (e.s) return Mt = !0, new this(1 / 0);
            n = e;
          }
        }

        return Mt = !0, n.sqrt();
      }

      function Y(t) {
        return new this(t).ln();
      }

      function K(t, e) {
        return new this(t).log(e);
      }

      function J(t) {
        return new this(t).log(2);
      }

      function Q(t) {
        return new this(t).log(10);
      }

      function tt() {
        return x(this, arguments, "lt");
      }

      function et() {
        return x(this, arguments, "gt");
      }

      function nt(t, e) {
        return new this(t).mod(e);
      }

      function rt(t, e) {
        return new this(t).mul(e);
      }

      function it(t, e) {
        return new this(t).pow(e);
      }

      function ot(t) {
        var e,
            n,
            r,
            i,
            o = 0,
            s = new this(1),
            u = [];
        if (void 0 === t ? t = this.precision : a(t, 1, yt), r = Math.ceil(t / zt), this.crypto === !1) for (; o < r;) {
          u[o++] = 1e7 * Math.random() | 0;
        } else if (Et && Et.getRandomValues) for (e = Et.getRandomValues(new Uint32Array(r)); o < r;) {
          i = e[o], i >= 429e7 ? e[o] = Et.getRandomValues(new Uint32Array(1))[0] : u[o++] = i % 1e7;
        } else if (Et && Et.randomBytes) {
          for (e = Et.randomBytes(r *= 4); o < r;) {
            i = e[o] + (e[o + 1] << 8) + (e[o + 2] << 16) + ((127 & e[o + 3]) << 24), i >= 214e7 ? Et.randomBytes(4).copy(e, o) : (u.push(i % 1e7), o += 4);
          }

          o = r / 4;
        } else {
          if (this.crypto) throw Error(Tt + "crypto unavailable");

          for (; o < r;) {
            u[o++] = 1e7 * Math.random() | 0;
          }
        }

        for (r = u[--o], t %= zt, r && t && (i = Ot(10, zt - t), u[o] = (r / i | 0) * i); 0 === u[o]; o--) {
          u.pop();
        }

        if (o < 0) n = 0, u = [0];else {
          for (n = -1; 0 === u[0]; n -= zt) {
            u.shift();
          }

          for (r = 1, i = u[0]; i >= 10; i /= 10) {
            r++;
          }

          r < zt && (n -= zt - r);
        }
        return s.e = n, s.d = u, s;
      }

      function at(t) {
        return l(t = new this(t), t.e + 1, this.rounding);
      }

      function st(t) {
        return t = new this(t), t.d ? t.d[0] ? t.s : 0 * t.s : t.s || NaN;
      }

      function ut(t) {
        return new this(t).sin();
      }

      function ct(t) {
        return new this(t).sinh();
      }

      function lt(t) {
        return new this(t).sqrt();
      }

      function ht(t, e) {
        return new this(t).sub(e);
      }

      function ft(t) {
        return new this(t).tan();
      }

      function pt(t) {
        return new this(t).tanh();
      }

      function mt(t) {
        return l(t = new this(t), t.e + 1, 1);
      }

      var dt,
          gt,
          vt = 9e15,
          yt = 1e9,
          xt = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%()*+,-./:;=?@[]^_`{|}~",
          wt = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",
          bt = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",
          _t = {
        precision: 20,
        rounding: 4,
        modulo: 1,
        toExpNeg: -7,
        toExpPos: 21,
        minE: -vt,
        maxE: vt,
        crypto: void 0
      },
          Et = "undefined" != typeof crypto ? crypto : null,
          Mt = !0,
          Tt = "[DecimalError] ",
          Nt = Tt + "Invalid argument: ",
          St = Tt + "Precision limit exceeded",
          At = Math.floor,
          Ot = Math.pow,
          Ct = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
          Pt = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
          Rt = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
          It = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
          kt = 1e7,
          zt = 7,
          Bt = 9007199254740991,
          Lt = wt.length - 1,
          Dt = bt.length - 1,
          jt = {};
      jt.absoluteValue = jt.abs = function () {
        var t = new this.constructor(this);
        return t.s < 0 && (t.s = 1), l(t);
      }, jt.ceil = function () {
        return l(new this.constructor(this), this.e + 1, 2);
      }, jt.comparedTo = jt.cmp = function (t) {
        var e,
            n,
            r,
            i,
            o = this,
            a = o.d,
            s = (t = new o.constructor(t)).d,
            u = o.s,
            c = t.s;
        if (!a || !s) return u && c ? u !== c ? u : a === s ? 0 : !a ^ u < 0 ? 1 : -1 : NaN;
        if (!a[0] || !s[0]) return a[0] ? u : s[0] ? -c : 0;
        if (u !== c) return u;
        if (o.e !== t.e) return o.e > t.e ^ u < 0 ? 1 : -1;

        for (r = a.length, i = s.length, e = 0, n = r < i ? r : i; e < n; ++e) {
          if (a[e] !== s[e]) return a[e] > s[e] ^ u < 0 ? 1 : -1;
        }

        return r === i ? 0 : r > i ^ u < 0 ? 1 : -1;
      }, jt.cosine = jt.cos = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return n.d ? n.d[0] ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + zt, r.rounding = 1, n = c(r, S(r, n)), r.precision = t, r.rounding = e, l(2 == gt || 3 == gt ? n.neg() : n, t, e, !0)) : new r(1) : new r(NaN);
      }, jt.cubeRoot = jt.cbrt = function () {
        var t,
            e,
            n,
            r,
            i,
            a,
            s,
            u,
            c,
            h,
            f = this,
            p = f.constructor;
        if (!f.isFinite() || f.isZero()) return new p(f);

        for (Mt = !1, a = f.s * Math.pow(f.s * f, 1 / 3), a && Math.abs(a) != 1 / 0 ? r = new p(a.toString()) : (n = o(f.d), t = f.e, (a = (t - n.length + 1) % 3) && (n += 1 == a || a == -2 ? "0" : "00"), a = Math.pow(n, 1 / 3), t = At((t + 1) / 3) - (t % 3 == (t < 0 ? -1 : 2)), a == 1 / 0 ? n = "5e" + t : (n = a.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + t), r = new p(n), r.s = f.s), s = (t = p.precision) + 3;;) {
          if (u = r, c = u.times(u).times(u), h = c.plus(f), r = Ft(h.plus(f).times(u), h.plus(c), s + 2, 1), o(u.d).slice(0, s) === (n = o(r.d)).slice(0, s)) {
            if (n = n.slice(s - 3, s + 1), "9999" != n && (i || "4999" != n)) {
              +n && (+n.slice(1) || "5" != n.charAt(0)) || (l(r, t + 1, 1), e = !r.times(r).times(r).eq(f));
              break;
            }

            if (!i && (l(u, t + 1, 0), u.times(u).times(u).eq(f))) {
              r = u;
              break;
            }

            s += 4, i = 1;
          }
        }

        return Mt = !0, l(r, t, p.rounding, e);
      }, jt.decimalPlaces = jt.dp = function () {
        var t,
            e = this.d,
            n = NaN;

        if (e) {
          if (t = e.length - 1, n = (t - At(this.e / zt)) * zt, t = e[t]) for (; t % 10 == 0; t /= 10) {
            n--;
          }
          n < 0 && (n = 0);
        }

        return n;
      }, jt.dividedBy = jt.div = function (t) {
        return Ft(this, new this.constructor(t));
      }, jt.dividedToIntegerBy = jt.divToInt = function (t) {
        var e = this,
            n = e.constructor;
        return l(Ft(e, new n(t), 0, 1, 1), n.precision, n.rounding);
      }, jt.equals = jt.eq = function (t) {
        return 0 === this.cmp(t);
      }, jt.floor = function () {
        return l(new this.constructor(this), this.e + 1, 3);
      }, jt.greaterThan = jt.gt = function (t) {
        return this.cmp(t) > 0;
      }, jt.greaterThanOrEqualTo = jt.gte = function (t) {
        var e = this.cmp(t);
        return 1 == e || 0 === e;
      }, jt.hyperbolicCosine = jt.cosh = function () {
        var t,
            e,
            n,
            r,
            i,
            o = this,
            a = o.constructor,
            s = new a(1);
        if (!o.isFinite()) return new a(o.s ? 1 / 0 : NaN);
        if (o.isZero()) return s;
        n = a.precision, r = a.rounding, a.precision = n + Math.max(o.e, o.sd()) + 4, a.rounding = 1, i = o.d.length, i < 32 ? (t = Math.ceil(i / 3), e = Math.pow(4, -t).toString()) : (t = 16, e = "2.3283064365386962890625e-10"), o = N(a, 1, o.times(e), new a(1), !0);

        for (var u, c = t, h = new a(8); c--;) {
          u = o.times(o), o = s.minus(u.times(h.minus(u.times(h))));
        }

        return l(o, a.precision = n, a.rounding = r, !0);
      }, jt.hyperbolicSine = jt.sinh = function () {
        var t,
            e,
            n,
            r,
            i = this,
            o = i.constructor;
        if (!i.isFinite() || i.isZero()) return new o(i);
        if (e = o.precision, n = o.rounding, o.precision = e + Math.max(i.e, i.sd()) + 4, o.rounding = 1, r = i.d.length, r < 3) i = N(o, 2, i, i, !0);else {
          t = 1.4 * Math.sqrt(r), t = t > 16 ? 16 : 0 | t, i = i.times(Math.pow(5, -t)), i = N(o, 2, i, i, !0);

          for (var a, s = new o(5), u = new o(16), c = new o(20); t--;) {
            a = i.times(i), i = i.times(s.plus(a.times(u.times(a).plus(c))));
          }
        }
        return o.precision = e, o.rounding = n, l(i, e, n, !0);
      }, jt.hyperbolicTangent = jt.tanh = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 7, r.rounding = 1, Ft(n.sinh(), n.cosh(), r.precision = t, r.rounding = e)) : new r(n.s);
      }, jt.inverseCosine = jt.acos = function () {
        var t,
            e = this,
            n = e.constructor,
            r = e.abs().cmp(1),
            i = n.precision,
            o = n.rounding;
        return r !== -1 ? 0 === r ? e.isNeg() ? m(n, i, o) : new n(0) : new n(NaN) : e.isZero() ? m(n, i + 4, o).times(.5) : (n.precision = i + 6, n.rounding = 1, e = e.asin(), t = m(n, i + 4, o).times(.5), n.precision = i, n.rounding = o, t.minus(e));
      }, jt.inverseHyperbolicCosine = jt.acosh = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return n.lte(1) ? new r(n.eq(1) ? 0 : NaN) : n.isFinite() ? (t = r.precision, e = r.rounding, r.precision = t + Math.max(Math.abs(n.e), n.sd()) + 4, r.rounding = 1, Mt = !1, n = n.times(n).minus(1).sqrt().plus(n), Mt = !0, r.precision = t, r.rounding = e, n.ln()) : new r(n);
      }, jt.inverseHyperbolicSine = jt.asinh = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return !n.isFinite() || n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 2 * Math.max(Math.abs(n.e), n.sd()) + 6, r.rounding = 1, Mt = !1, n = n.times(n).plus(1).sqrt().plus(n), Mt = !0, r.precision = t, r.rounding = e, n.ln());
      }, jt.inverseHyperbolicTangent = jt.atanh = function () {
        var t,
            e,
            n,
            r,
            i = this,
            o = i.constructor;
        return i.isFinite() ? i.e >= 0 ? new o(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (t = o.precision, e = o.rounding, r = i.sd(), Math.max(r, t) < 2 * -i.e - 1 ? l(new o(i), t, e, !0) : (o.precision = n = r - i.e, i = Ft(i.plus(1), new o(1).minus(i), n + t, 1), o.precision = t + 4, o.rounding = 1, i = i.ln(), o.precision = t, o.rounding = e, i.times(.5))) : new o(NaN);
      }, jt.inverseSine = jt.asin = function () {
        var t,
            e,
            n,
            r,
            i = this,
            o = i.constructor;
        return i.isZero() ? new o(i) : (e = i.abs().cmp(1), n = o.precision, r = o.rounding, e !== -1 ? 0 === e ? (t = m(o, n + 4, r).times(.5), t.s = i.s, t) : new o(NaN) : (o.precision = n + 6, o.rounding = 1, i = i.div(new o(1).minus(i.times(i)).sqrt().plus(1)).atan(), o.precision = n, o.rounding = r, i.times(2)));
      }, jt.inverseTangent = jt.atan = function () {
        var t,
            e,
            n,
            r,
            i,
            o,
            a,
            s,
            u,
            c = this,
            h = c.constructor,
            f = h.precision,
            p = h.rounding;

        if (c.isFinite()) {
          if (c.isZero()) return new h(c);
          if (c.abs().eq(1) && f + 4 <= Dt) return a = m(h, f + 4, p).times(.25), a.s = c.s, a;
        } else {
          if (!c.s) return new h(NaN);
          if (f + 4 <= Dt) return a = m(h, f + 4, p).times(.5), a.s = c.s, a;
        }

        for (h.precision = s = f + 10, h.rounding = 1, n = Math.min(28, s / zt + 2 | 0), t = n; t; --t) {
          c = c.div(c.times(c).plus(1).sqrt().plus(1));
        }

        for (Mt = !1, e = Math.ceil(s / zt), r = 1, u = c.times(c), a = new h(c), i = c; t !== -1;) {
          if (i = i.times(u), o = a.minus(i.div(r += 2)), i = i.times(u), a = o.plus(i.div(r += 2)), void 0 !== a.d[e]) for (t = e; a.d[t] === o.d[t] && t--;) {
            ;
          }
        }

        return n && (a = a.times(2 << n - 1)), Mt = !0, l(a, h.precision = f, h.rounding = p, !0);
      }, jt.isFinite = function () {
        return !!this.d;
      }, jt.isInteger = jt.isInt = function () {
        return !!this.d && At(this.e / zt) > this.d.length - 2;
      }, jt.isNaN = function () {
        return !this.s;
      }, jt.isNegative = jt.isNeg = function () {
        return this.s < 0;
      }, jt.isPositive = jt.isPos = function () {
        return this.s > 0;
      }, jt.isZero = function () {
        return !!this.d && 0 === this.d[0];
      }, jt.lessThan = jt.lt = function (t) {
        return this.cmp(t) < 0;
      }, jt.lessThanOrEqualTo = jt.lte = function (t) {
        return this.cmp(t) < 1;
      }, jt.logarithm = jt.log = function (t) {
        var e,
            n,
            r,
            i,
            a,
            u,
            c,
            h,
            f = this,
            m = f.constructor,
            d = m.precision,
            g = m.rounding,
            v = 5;
        if (null == t) t = new m(10), e = !0;else {
          if (t = new m(t), n = t.d, t.s < 0 || !n || !n[0] || t.eq(1)) return new m(NaN);
          e = t.eq(10);
        }
        if (n = f.d, f.s < 0 || !n || !n[0] || f.eq(1)) return new m(n && !n[0] ? -1 / 0 : 1 != f.s ? NaN : n ? 0 : 1 / 0);
        if (e) if (n.length > 1) a = !0;else {
          for (i = n[0]; i % 10 === 0;) {
            i /= 10;
          }

          a = 1 !== i;
        }
        if (Mt = !1, c = d + v, u = b(f, c), r = e ? p(m, c + 10) : b(t, c), h = Ft(u, r, c, 1), s(h.d, i = d, g)) do {
          if (c += 10, u = b(f, c), r = e ? p(m, c + 10) : b(t, c), h = Ft(u, r, c, 1), !a) {
            +o(h.d).slice(i + 1, i + 15) + 1 == 1e14 && (h = l(h, d + 1, 0));
            break;
          }
        } while (s(h.d, i += 10, g));
        return Mt = !0, l(h, d, g);
      }, jt.minus = jt.sub = function (t) {
        var e,
            n,
            r,
            i,
            o,
            a,
            s,
            u,
            c,
            h,
            p,
            m,
            d = this,
            g = d.constructor;
        if (t = new g(t), !d.d || !t.d) return d.s && t.s ? d.d ? t.s = -t.s : t = new g(t.d || d.s !== t.s ? d : NaN) : t = new g(NaN), t;
        if (d.s != t.s) return t.s = -t.s, d.plus(t);

        if (c = d.d, m = t.d, s = g.precision, u = g.rounding, !c[0] || !m[0]) {
          if (m[0]) t.s = -t.s;else {
            if (!c[0]) return new g(3 === u ? -0 : 0);
            t = new g(d);
          }
          return Mt ? l(t, s, u) : t;
        }

        if (n = At(t.e / zt), h = At(d.e / zt), c = c.slice(), o = h - n) {
          for (p = o < 0, p ? (e = c, o = -o, a = m.length) : (e = m, n = h, a = c.length), r = Math.max(Math.ceil(s / zt), a) + 2, o > r && (o = r, e.length = 1), e.reverse(), r = o; r--;) {
            e.push(0);
          }

          e.reverse();
        } else {
          for (r = c.length, a = m.length, p = r < a, p && (a = r), r = 0; r < a; r++) {
            if (c[r] != m[r]) {
              p = c[r] < m[r];
              break;
            }
          }

          o = 0;
        }

        for (p && (e = c, c = m, m = e, t.s = -t.s), a = c.length, r = m.length - a; r > 0; --r) {
          c[a++] = 0;
        }

        for (r = m.length; r > o;) {
          if (c[--r] < m[r]) {
            for (i = r; i && 0 === c[--i];) {
              c[i] = kt - 1;
            }

            --c[i], c[r] += kt;
          }

          c[r] -= m[r];
        }

        for (; 0 === c[--a];) {
          c.pop();
        }

        for (; 0 === c[0]; c.shift()) {
          --n;
        }

        return c[0] ? (t.d = c, t.e = f(c, n), Mt ? l(t, s, u) : t) : new g(3 === u ? -0 : 0);
      }, jt.modulo = jt.mod = function (t) {
        var e,
            n = this,
            r = n.constructor;
        return t = new r(t), !n.d || !t.s || t.d && !t.d[0] ? new r(NaN) : !t.d || n.d && !n.d[0] ? l(new r(n), r.precision, r.rounding) : (Mt = !1, 9 == r.modulo ? (e = Ft(n, t.abs(), 0, 3, 1), e.s *= t.s) : e = Ft(n, t, 0, r.modulo, 1), e = e.times(t), Mt = !0, n.minus(e));
      }, jt.naturalExponential = jt.exp = function () {
        return w(this);
      }, jt.naturalLogarithm = jt.ln = function () {
        return b(this);
      }, jt.negated = jt.neg = function () {
        var t = new this.constructor(this);
        return t.s = -t.s, l(t);
      }, jt.plus = jt.add = function (t) {
        var e,
            n,
            r,
            i,
            o,
            a,
            s,
            u,
            c,
            h,
            p = this,
            m = p.constructor;
        if (t = new m(t), !p.d || !t.d) return p.s && t.s ? p.d || (t = new m(t.d || p.s === t.s ? p : NaN)) : t = new m(NaN), t;
        if (p.s != t.s) return t.s = -t.s, p.minus(t);
        if (c = p.d, h = t.d, s = m.precision, u = m.rounding, !c[0] || !h[0]) return h[0] || (t = new m(p)), Mt ? l(t, s, u) : t;

        if (o = At(p.e / zt), r = At(t.e / zt), c = c.slice(), i = o - r) {
          for (i < 0 ? (n = c, i = -i, a = h.length) : (n = h, r = o, a = c.length), o = Math.ceil(s / zt), a = o > a ? o + 1 : a + 1, i > a && (i = a, n.length = 1), n.reverse(); i--;) {
            n.push(0);
          }

          n.reverse();
        }

        for (a = c.length, i = h.length, a - i < 0 && (i = a, n = h, h = c, c = n), e = 0; i;) {
          e = (c[--i] = c[i] + h[i] + e) / kt | 0, c[i] %= kt;
        }

        for (e && (c.unshift(e), ++r), a = c.length; 0 == c[--a];) {
          c.pop();
        }

        return t.d = c, t.e = f(c, r), Mt ? l(t, s, u) : t;
      }, jt.precision = jt.sd = function (t) {
        var e,
            n = this;
        if (void 0 !== t && t !== !!t && 1 !== t && 0 !== t) throw Error(Nt + t);
        return n.d ? (e = d(n.d), t && n.e + 1 > e && (e = n.e + 1)) : e = NaN, e;
      }, jt.round = function () {
        var t = this,
            e = t.constructor;
        return l(new e(t), t.e + 1, e.rounding);
      }, jt.sine = jt.sin = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + Math.max(n.e, n.sd()) + zt, r.rounding = 1, n = T(r, S(r, n)), r.precision = t, r.rounding = e, l(gt > 2 ? n.neg() : n, t, e, !0)) : new r(NaN);
      }, jt.squareRoot = jt.sqrt = function () {
        var t,
            e,
            n,
            r,
            i,
            a,
            s = this,
            u = s.d,
            c = s.e,
            h = s.s,
            f = s.constructor;
        if (1 !== h || !u || !u[0]) return new f(!h || h < 0 && (!u || u[0]) ? NaN : u ? s : 1 / 0);

        for (Mt = !1, h = Math.sqrt(+s), 0 == h || h == 1 / 0 ? (e = o(u), (e.length + c) % 2 == 0 && (e += "0"), h = Math.sqrt(e), c = At((c + 1) / 2) - (c < 0 || c % 2), h == 1 / 0 ? e = "1e" + c : (e = h.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + c), r = new f(e)) : r = new f(h.toString()), n = (c = f.precision) + 3;;) {
          if (a = r, r = a.plus(Ft(s, a, n + 2, 1)).times(.5), o(a.d).slice(0, n) === (e = o(r.d)).slice(0, n)) {
            if (e = e.slice(n - 3, n + 1), "9999" != e && (i || "4999" != e)) {
              +e && (+e.slice(1) || "5" != e.charAt(0)) || (l(r, c + 1, 1), t = !r.times(r).eq(s));
              break;
            }

            if (!i && (l(a, c + 1, 0), a.times(a).eq(s))) {
              r = a;
              break;
            }

            n += 4, i = 1;
          }
        }

        return Mt = !0, l(r, c, f.rounding, t);
      }, jt.tangent = jt.tan = function () {
        var t,
            e,
            n = this,
            r = n.constructor;
        return n.isFinite() ? n.isZero() ? new r(n) : (t = r.precision, e = r.rounding, r.precision = t + 10, r.rounding = 1, n = n.sin(), n.s = 1, n = Ft(n, new r(1).minus(n.times(n)).sqrt(), t + 10, 0), r.precision = t, r.rounding = e, l(2 == gt || 4 == gt ? n.neg() : n, t, e, !0)) : new r(NaN);
      }, jt.times = jt.mul = function (t) {
        var e,
            n,
            r,
            i,
            o,
            a,
            s,
            u,
            c,
            h = this,
            p = h.constructor,
            m = h.d,
            d = (t = new p(t)).d;
        if (t.s *= h.s, !(m && m[0] && d && d[0])) return new p(!t.s || m && !m[0] && !d || d && !d[0] && !m ? NaN : m && d ? 0 * t.s : t.s / 0);

        for (n = At(h.e / zt) + At(t.e / zt), u = m.length, c = d.length, u < c && (o = m, m = d, d = o, a = u, u = c, c = a), o = [], a = u + c, r = a; r--;) {
          o.push(0);
        }

        for (r = c; --r >= 0;) {
          for (e = 0, i = u + r; i > r;) {
            s = o[i] + d[r] * m[i - r - 1] + e, o[i--] = s % kt | 0, e = s / kt | 0;
          }

          o[i] = (o[i] + e) % kt | 0;
        }

        for (; !o[--a];) {
          o.pop();
        }

        for (e ? ++n : o.shift(), r = o.length; !o[--r];) {
          o.pop();
        }

        return t.d = o, t.e = f(o, n), Mt ? l(t, p.precision, p.rounding) : t;
      }, jt.toBinary = function (t, e) {
        return A(this, 2, t, e);
      }, jt.toDecimalPlaces = jt.toDP = function (t, e) {
        var n = this,
            r = n.constructor;
        return n = new r(n), void 0 === t ? n : (a(t, 0, yt), void 0 === e ? e = r.rounding : a(e, 0, 8), l(n, t + n.e + 1, e));
      }, jt.toExponential = function (t, e) {
        var n,
            r = this,
            i = r.constructor;
        return void 0 === t ? n = h(r, !0) : (a(t, 0, yt), void 0 === e ? e = i.rounding : a(e, 0, 8), r = l(new i(r), t + 1, e), n = h(r, !0, t + 1)), r.isNeg() && !r.isZero() ? "-" + n : n;
      }, jt.toFixed = function (t, e) {
        var n,
            r,
            i = this,
            o = i.constructor;
        return void 0 === t ? n = h(i) : (a(t, 0, yt), void 0 === e ? e = o.rounding : a(e, 0, 8), r = l(new o(i), t + i.e + 1, e), n = h(r, !1, t + r.e + 1)), i.isNeg() && !i.isZero() ? "-" + n : n;
      }, jt.toFraction = function (t) {
        var e,
            n,
            r,
            i,
            a,
            s,
            u,
            c,
            l,
            h,
            f,
            p,
            m = this,
            g = m.d,
            v = m.constructor;
        if (!g) return new v(m);
        if (l = n = new v(1), r = c = new v(0), e = new v(r), a = e.e = d(g) - m.e - 1, s = a % zt, e.d[0] = Ot(10, s < 0 ? zt + s : s), null == t) t = a > 0 ? e : l;else {
          if (u = new v(t), !u.isInt() || u.lt(l)) throw Error(Nt + u);
          t = u.gt(e) ? a > 0 ? e : l : u;
        }

        for (Mt = !1, u = new v(o(g)), h = v.precision, v.precision = a = g.length * zt * 2; f = Ft(u, e, 0, 1, 1), i = n.plus(f.times(r)), 1 != i.cmp(t);) {
          n = r, r = i, i = l, l = c.plus(f.times(i)), c = i, i = e, e = u.minus(f.times(i)), u = i;
        }

        return i = Ft(t.minus(n), r, 0, 1, 1), c = c.plus(i.times(l)), n = n.plus(i.times(r)), c.s = l.s = m.s, p = Ft(l, r, a, 1).minus(m).abs().cmp(Ft(c, n, a, 1).minus(m).abs()) < 1 ? [l, r] : [c, n], v.precision = h, Mt = !0, p;
      }, jt.toHexadecimal = jt.toHex = function (t, e) {
        return A(this, 16, t, e);
      }, jt.toJSON = function () {
        var t,
            e,
            n,
            r,
            i,
            a,
            s,
            c,
            l = this,
            h = l.s < 0;
        if (!l.d) return xt.charAt(l.s ? h ? 82 : 83 : 84);
        if (e = l.e, 1 === l.d.length && e < 4 && e >= 0 && (a = l.d[0], a < 2857)) return a < 41 ? xt.charAt(h ? a + 41 : a) : (a -= 41, h && (a += 2816), r = a / 88 | 0, xt.charAt(r) + xt.charAt(a - 88 * r));
        if (c = o(l.d), s = "", !h && e <= 8 && e >= -7) r = 64 + e + 7;else if (h && e <= 4 && e >= -3) r = 80 + e + 3;else if (c.length === e + 1) r = 32 * h;else if (r = 32 * h + 16 * (e < 0), e = Math.abs(e), e < 88) r += 1, s = xt.charAt(e);else if (e < 7744) r += 2, a = e / 88 | 0, s = xt.charAt(a) + xt.charAt(e - 88 * a);else for (t = u(String(e), 10, 88), i = t.length, r += i, n = 0; n < i; n++) {
          s += xt.charAt(t[n]);
        }

        for (s = xt.charAt(r) + s, t = u(c, 10, 88), i = t.length, n = 0; n < i; n++) {
          s += xt.charAt(t[n]);
        }

        return s;
      }, jt.toNearest = function (t, e) {
        var n = this,
            r = n.constructor;

        if (n = new r(n), null == t) {
          if (!n.d) return n;
          t = new r(1), e = r.rounding;
        } else {
          if (t = new r(t), void 0 !== e && a(e, 0, 8), !n.d) return t.s ? n : t;
          if (!t.d) return t.s && (t.s = n.s), t;
        }

        return t.d[0] ? (Mt = !1, e < 4 && (e = [4, 5, 7, 8][e]), n = Ft(n, t, 0, e, 1).times(t), Mt = !0, l(n)) : (t.s = n.s, n = t), n;
      }, jt.toNumber = function () {
        return +this;
      }, jt.toOctal = function (t, e) {
        return A(this, 8, t, e);
      }, jt.toPower = jt.pow = function (t) {
        var e,
            n,
            r,
            i,
            a,
            u,
            c,
            h = this,
            f = h.constructor,
            p = +(t = new f(t));
        if (!(h.d && t.d && h.d[0] && t.d[0])) return new f(Ot(+h, p));
        if (h = new f(h), h.eq(1)) return h;
        if (r = f.precision, a = f.rounding, t.eq(1)) return l(h, r, a);

        if (e = At(t.e / zt), n = t.d.length - 1, c = e >= n, u = h.s, c) {
          if ((n = p < 0 ? -p : p) <= Bt) return i = v(f, h, n, r), t.s < 0 ? new f(1).div(i) : l(i, r, a);
        } else if (u < 0) return new f(NaN);

        return u = u < 0 && 1 & t.d[Math.max(e, n)] ? -1 : 1, n = Ot(+h, p), e = 0 != n && isFinite(n) ? new f(n + "").e : At(p * (Math.log("0." + o(h.d)) / Math.LN10 + h.e + 1)), e > f.maxE + 1 || e < f.minE - 1 ? new f(e > 0 ? u / 0 : 0) : (Mt = !1, f.rounding = h.s = 1, n = Math.min(12, (e + "").length), i = w(t.times(b(h, r + n)), r), i = l(i, r + 5, 1), s(i.d, r, a) && (e = r + 10, i = l(w(t.times(b(h, e + n)), e), e + 5, 1), +o(i.d).slice(r + 1, r + 15) + 1 == 1e14 && (i = l(i, r + 1, 0))), i.s = u, Mt = !0, f.rounding = a, l(i, r, a));
      }, jt.toPrecision = function (t, e) {
        var n,
            r = this,
            i = r.constructor;
        return void 0 === t ? n = h(r, r.e <= i.toExpNeg || r.e >= i.toExpPos) : (a(t, 1, yt), void 0 === e ? e = i.rounding : a(e, 0, 8), r = l(new i(r), t, e), n = h(r, t <= r.e || r.e <= i.toExpNeg, t)), r.isNeg() && !r.isZero() ? "-" + n : n;
      }, jt.toSignificantDigits = jt.toSD = function (t, e) {
        var n = this,
            r = n.constructor;
        return void 0 === t ? (t = r.precision, e = r.rounding) : (a(t, 1, yt), void 0 === e ? e = r.rounding : a(e, 0, 8)), l(new r(n), t, e);
      }, jt.toString = function () {
        var t = this,
            e = t.constructor,
            n = h(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
        return t.isNeg() && !t.isZero() ? "-" + n : n;
      }, jt.truncated = jt.trunc = function () {
        return l(new this.constructor(this), this.e + 1, 1);
      }, jt.valueOf = function () {
        var t = this,
            e = t.constructor,
            n = h(t, t.e <= e.toExpNeg || t.e >= e.toExpPos);
        return t.isNeg() ? "-" + n : n;
      };

      var Ft = function () {
        function t(t, e, n) {
          var r,
              i = 0,
              o = t.length;

          for (t = t.slice(); o--;) {
            r = t[o] * e + i, t[o] = r % n | 0, i = r / n | 0;
          }

          return i && t.unshift(i), t;
        }

        function e(t, e, n, r) {
          var i, o;
          if (n != r) o = n > r ? 1 : -1;else for (i = o = 0; i < n; i++) {
            if (t[i] != e[i]) {
              o = t[i] > e[i] ? 1 : -1;
              break;
            }
          }
          return o;
        }

        function n(t, e, n, r) {
          for (var i = 0; n--;) {
            t[n] -= i, i = t[n] < e[n] ? 1 : 0, t[n] = i * r + t[n] - e[n];
          }

          for (; !t[0] && t.length > 1;) {
            t.shift();
          }
        }

        return function (r, i, o, a, s, u) {
          var c,
              h,
              f,
              p,
              m,
              d,
              g,
              v,
              y,
              x,
              w,
              b,
              _,
              E,
              M,
              T,
              N,
              S,
              A,
              O,
              C = r.constructor,
              P = r.s == i.s ? 1 : -1,
              R = r.d,
              I = i.d;

          if (!(R && R[0] && I && I[0])) return new C(r.s && i.s && (R ? !I || R[0] != I[0] : I) ? R && 0 == R[0] || !I ? 0 * P : P / 0 : NaN);

          for (u ? (m = 1, h = r.e - i.e) : (u = kt, m = zt, h = At(r.e / m) - At(i.e / m)), A = I.length, N = R.length, y = new C(P), x = y.d = [], f = 0; I[f] == (R[f] || 0); f++) {
            ;
          }

          if (I[f] > (R[f] || 0) && h--, null == o ? (E = o = C.precision, a = C.rounding) : E = s ? o + (r.e - i.e) + 1 : o, E < 0) x.push(1), d = !0;else {
            if (E = E / m + 2 | 0, f = 0, 1 == A) {
              for (p = 0, I = I[0], E++; (f < N || p) && E--; f++) {
                M = p * u + (R[f] || 0), x[f] = M / I | 0, p = M % I | 0;
              }

              d = p || f < N;
            } else {
              for (p = u / (I[0] + 1) | 0, p > 1 && (I = t(I, p, u), R = t(R, p, u), A = I.length, N = R.length), T = A, w = R.slice(0, A), b = w.length; b < A;) {
                w[b++] = 0;
              }

              O = I.slice(), O.unshift(0), S = I[0], I[1] >= u / 2 && ++S;

              do {
                p = 0, c = e(I, w, A, b), c < 0 ? (_ = w[0], A != b && (_ = _ * u + (w[1] || 0)), p = _ / S | 0, p > 1 ? (p >= u && (p = u - 1), g = t(I, p, u), v = g.length, b = w.length, c = e(g, w, v, b), 1 == c && (p--, n(g, A < v ? O : I, v, u))) : (0 == p && (c = p = 1), g = I.slice()), v = g.length, v < b && g.unshift(0), n(w, g, b, u), c == -1 && (b = w.length, c = e(I, w, A, b), c < 1 && (p++, n(w, A < b ? O : I, b, u))), b = w.length) : 0 === c && (p++, w = [0]), x[f++] = p, c && w[0] ? w[b++] = R[T] || 0 : (w = [R[T]], b = 1);
              } while ((T++ < N || void 0 !== w[0]) && E--);

              d = void 0 !== w[0];
            }

            x[0] || x.shift();
          }
          if (1 == m) y.e = h, dt = d;else {
            for (f = 1, p = x[0]; p >= 10; p /= 10) {
              f++;
            }

            y.e = f + h * m - 1, l(y, s ? o + y.e + 1 : o, a, d);
          }
          return y;
        };
      }();

      _t = W(_t), wt = new _t(wt), bt = new _t(bt), r = function () {
        return _t;
      }.call(e, n, e, t), !(void 0 !== r && (t.exports = r));
    }(this);
  },, function (t, e, n) {
    var r, i;
    (function (t) {
      /**
      * @license Fraction.js v3.3.1 09/09/2015
      * http://www.xarg.org/2014/03/precise-calculations-in-javascript/
      *
      * Copyright (c) 2015, Robert Eisele (robert@xarg.org)
      * Dual licensed under the MIT or GPL Version 2 licenses.
      **/
      !function (o) {
        "use strict";

        function a(t, e) {
          return isNaN(t = parseInt(t, 10)) && s(), t * e;
        }

        function s() {
          throw "Invalid Param";
        }

        function u(t, e) {
          return this instanceof u ? (h(t, e), t = u.REDUCE ? d(l.d, l.n) : 1, this.s = l.s, this.n = l.n / t, void (this.d = l.d / t)) : new u(t, e);
        }

        var c = 2e3,
            l = {
          s: 1,
          n: 0,
          d: 1
        },
            h = function h(t, e) {
          var n,
              r = 0,
              i = 1,
              o = 1,
              u = 0,
              c = 0,
              h = 0,
              f = 1,
              p = 1,
              m = 0,
              d = 1,
              g = 1,
              v = 1,
              y = 1e7;
          if (void 0 === t || null === t) ;else if (void 0 !== e) r = t, i = e, o = r * i;else switch (typeof t) {
            case "object":
              "d" in t && "n" in t ? (r = t.n, i = t.d, "s" in t && (r *= t.s)) : 0 in t ? (r = t[0], 1 in t && (i = t[1])) : s(), o = r * i;
              break;

            case "number":
              if (t < 0 && (o = t, t = -t), t % 1 === 0) r = t;else if (t > 0) {
                for (t >= 1 && (p = Math.pow(10, Math.floor(1 + Math.log(t) / Math.LN10)), t /= p); d <= y && v <= y;) {
                  if (n = (m + g) / (d + v), t === n) {
                    d + v <= y ? (r = m + g, i = d + v) : v > d ? (r = g, i = v) : (r = m, i = d);
                    break;
                  }

                  t > n ? (m += g, d += v) : (g += m, v += d), d > y ? (r = g, i = v) : (r = m, i = d);
                }

                r *= p;
              } else (isNaN(t) || isNaN(e)) && (i = r = NaN);
              break;

            case "string":
              if (d = t.match(/\d+|./g), "-" === d[m] ? (o = -1, m++) : "+" === d[m] && m++, d.length === m + 1 ? c = a(d[m++], o) : "." === d[m + 1] || "." === d[m] ? ("." !== d[m] && (u = a(d[m++], o)), m++, (m + 1 === d.length || "(" === d[m + 1] && ")" === d[m + 3] || "'" === d[m + 1] && "'" === d[m + 3]) && (c = a(d[m], o), f = Math.pow(10, d[m].length), m++), ("(" === d[m] && ")" === d[m + 2] || "'" === d[m] && "'" === d[m + 2]) && (h = a(d[m + 1], o), p = Math.pow(10, d[m + 1].length) - 1, m += 3)) : "/" === d[m + 1] || ":" === d[m + 1] ? (c = a(d[m], o), f = a(d[m + 2], 1), m += 3) : "/" === d[m + 3] && " " === d[m + 1] && (u = a(d[m], o), c = a(d[m + 2], o), f = a(d[m + 4], 1), m += 5), d.length <= m) {
                i = f * p, o = r = h + i * u + p * c;
                break;
              }

            default:
              s();
          }
          if (0 === i) throw "DIV/0";
          l.s = o < 0 ? -1 : 1, l.n = Math.abs(r), l.d = Math.abs(i);
        },
            f = function f(t, e, n) {
          for (var r = 1; e > 0; t = t * t % n, e >>= 1) {
            1 & e && (r = r * t % n);
          }

          return r;
        },
            p = function p(t, e) {
          for (; e % 2 === 0; e /= 2) {
            ;
          }

          for (; e % 5 === 0; e /= 5) {
            ;
          }

          if (1 === e) return 0;

          for (var n = 10 % e, r = 1; 1 !== n; r++) {
            if (n = 10 * n % e, r > c) return 0;
          }

          return r;
        },
            m = function m(t, e, n) {
          for (var r = 1, i = f(10, n, e), o = 0; o < 300; o++) {
            if (r === i) return o;
            r = 10 * r % e, i = 10 * i % e;
          }

          return 0;
        },
            d = function d(t, e) {
          if (!t) return e;
          if (!e) return t;

          for (;;) {
            if (t %= e, !t) return e;
            if (e %= t, !e) return t;
          }
        };

        u.REDUCE = 1, u.prototype = {
          s: 1,
          n: 0,
          d: 1,
          abs: function abs() {
            return new u(this.n, this.d);
          },
          neg: function neg() {
            return new u(-this.s * this.n, this.d);
          },
          add: function add(t, e) {
            return h(t, e), new u(this.s * this.n * l.d + l.s * this.d * l.n, this.d * l.d);
          },
          sub: function sub(t, e) {
            return h(t, e), new u(this.s * this.n * l.d - l.s * this.d * l.n, this.d * l.d);
          },
          mul: function mul(t, e) {
            return h(t, e), new u(this.s * l.s * this.n * l.n, this.d * l.d);
          },
          div: function div(t, e) {
            return h(t, e), new u(this.s * l.s * this.n * l.d, this.d * l.n);
          },
          clone: function clone() {
            return new u(this);
          },
          mod: function mod(t, e) {
            return isNaN(this.n) || isNaN(this.d) ? new u(NaN) : void 0 === t ? new u(this.s * this.n % this.d, 1) : (h(t, e), 0 === l.n && 0 === this.d && u(0, 0), new u(this.s * l.d * this.n % (l.n * this.d), l.d * this.d));
          },
          gcd: function gcd(t, e) {
            return h(t, e), new u(d(l.n, this.n), l.d * this.d / d(l.d, this.d));
          },
          lcm: function lcm(t, e) {
            return h(t, e), 0 === l.n && 0 === this.n ? new u() : new u(l.n * this.n / d(l.n, this.n), d(l.d, this.d));
          },
          ceil: function ceil(t) {
            return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : new u(Math.ceil(t * this.s * this.n / this.d), t);
          },
          floor: function floor(t) {
            return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : new u(Math.floor(t * this.s * this.n / this.d), t);
          },
          round: function round(t) {
            return t = Math.pow(10, t || 0), isNaN(this.n) || isNaN(this.d) ? new u(NaN) : new u(Math.round(t * this.s * this.n / this.d), t);
          },
          inverse: function inverse() {
            return new u(this.s * this.d, this.n);
          },
          pow: function pow(t) {
            return t < 0 ? new u(Math.pow(this.s * this.d, -t), Math.pow(this.n, -t)) : new u(Math.pow(this.s * this.n, t), Math.pow(this.d, t));
          },
          equals: function equals(t, e) {
            return h(t, e), this.s * this.n * l.d === l.s * l.n * this.d;
          },
          compare: function compare(t, e) {
            h(t, e);
            var n = this.s * this.n * l.d - l.s * l.n * this.d;
            return (0 < n) - (n < 0);
          },
          divisible: function divisible(t, e) {
            return h(t, e), !(!(l.n * this.d) || this.n * l.d % (l.n * this.d));
          },
          valueOf: function valueOf() {
            return this.s * this.n / this.d;
          },
          toFraction: function toFraction(t) {
            var e,
                n = "",
                r = this.n,
                i = this.d;
            return this.s < 0 && (n += "-"), 1 === i ? n += r : (t && (e = Math.floor(r / i)) > 0 && (n += e, n += " ", r %= i), n += r, n += "/", n += i), n;
          },
          toLatex: function toLatex(t) {
            var e,
                n = "",
                r = this.n,
                i = this.d;
            return this.s < 0 && (n += "-"), 1 === i ? n += r : (t && (e = Math.floor(r / i)) > 0 && (n += e, r %= i), n += "\\frac{", n += r, n += "}{", n += i, n += "}"), n;
          },
          toContinued: function toContinued() {
            var t,
                e = this.n,
                n = this.d,
                r = [];

            do {
              r.push(Math.floor(e / n)), t = e % n, e = n, n = t;
            } while (1 !== e);

            return r;
          },
          toString: function toString() {
            var t,
                e = this.n,
                n = this.d;
            if (isNaN(e) || isNaN(n)) return "NaN";
            u.REDUCE || (t = d(e, n), e /= t, n /= t);

            for (var r = String(e).split(""), i = 0, o = [~this.s ? "" : "-", "", ""], a = "", s = p(e, n), c = m(e, n, s), l = -1, h = 1, f = 15 + s + c + r.length, g = 0; g < f; g++, i *= 10) {
              if (g < r.length ? i += Number(r[g]) : (h = 2, l++), s > 0) if (l === c) o[h] += a + "(", a = "";else if (l === s + c) {
                o[h] += a + ")";
                break;
              }
              i >= n ? (o[h] += a + (i / n | 0), a = "", i %= n) : h > 1 ? a += "0" : o[h] && (o[h] += "0");
            }

            return o[0] += o[1] || "0", o[2] ? o[0] + "." + o[2] : o[0];
          }
        }, n(169).amd ? (r = [], i = function () {
          return u;
        }.apply(e, r), !(void 0 !== i && (t.exports = i))) : t.exports = u;
      }(this);
    }).call(e, n(96)(t));
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : t.exports = function (t, e) {
      t.super_ = e;

      var n = function n() {};

      n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
    };
  }, function (t, e, n) {
    function r(t, e) {
      return 2 == e ? function (e, n) {
        return t.apply(void 0, arguments);
      } : function (e) {
        return t.apply(void 0, arguments);
      };
    }

    function i(t, e) {
      return 2 == e ? function (e, n) {
        return t(e, n);
      } : function (e) {
        return t(e);
      };
    }

    function o(t) {
      for (var e = t ? t.length : 0, n = Array(e); e--;) {
        n[e] = t[e];
      }

      return n;
    }

    function a(t) {
      return function (e) {
        return t({}, e);
      };
    }

    function s(t, e) {
      return function () {
        for (var n = arguments.length, r = n - 1, i = Array(n); n--;) {
          i[n] = arguments[n];
        }

        var o = i[e],
            a = i.slice(0, e);
        return o && f.apply(a, o), e != r && f.apply(a, i.slice(e + 1)), t.apply(this, a);
      };
    }

    function u(t, e) {
      return function () {
        var n = arguments.length;

        if (n) {
          for (var r = Array(n); n--;) {
            r[n] = arguments[n];
          }

          var i = r[0] = e.apply(void 0, r);
          return t.apply(void 0, r), i;
        }
      };
    }

    function c(t, e, n, f) {
      function p(t, e) {
        if (S.cap) {
          var n = l.iterateeRearg[t];
          if (n) return b(e, n);
          var r = !T && l.iterateeAry[t];
          if (r) return w(e, r);
        }

        return e;
      }

      function m(t, e, n) {
        return A || S.curry && n > 1 ? L(e, n) : e;
      }

      function d(t, e, n) {
        if (S.fixed && (O || !l.skipFixed[t])) {
          var r = l.methodSpread[t],
              i = r && r.start;
          return void 0 === i ? k(e, n) : s(e, i);
        }

        return e;
      }

      function g(t, e, n) {
        return S.rearg && n > 1 && (C || !l.skipRearg[t]) ? W(e, l.methodRearg[t] || l.aryRearg[n]) : e;
      }

      function v(t, e) {
        e = $(e);

        for (var n = -1, r = e.length, i = r - 1, o = B(Object(t)), a = o; null != a && ++n < r;) {
          var s = e[n],
              u = a[s];
          null == u || U(u) || F(u) || q(u) || (a[s] = B(n == i ? u : Object(u))), a = a[s];
        }

        return o;
      }

      function y(t) {
        return X.runInContext.convert(t)(void 0);
      }

      function x(t, e) {
        var n = l.aliasToReal[t] || t,
            r = l.remap[n] || n,
            i = f;
        return function (t) {
          var o = T ? R : I,
              a = T ? R[r] : e,
              s = z(z({}, i), t);
          return c(o, n, a, s);
        };
      }

      function w(t, e) {
        return _(t, function (t) {
          return "function" == typeof t ? i(t, e) : t;
        });
      }

      function b(t, e) {
        return _(t, function (t) {
          var n = e.length;
          return r(W(i(t, n), e), n);
        });
      }

      function _(t, e) {
        return function () {
          var n = arguments.length;
          if (!n) return t();

          for (var r = Array(n); n--;) {
            r[n] = arguments[n];
          }

          var i = S.rearg ? 0 : n - 1;
          return r[i] = e(r[i]), t.apply(void 0, r);
        };
      }

      function E(t, e) {
        var n,
            r = l.aliasToReal[t] || t,
            i = e,
            s = Z[r];
        return s ? i = s(e) : S.immutable && (l.mutate.array[r] ? i = u(e, o) : l.mutate.object[r] ? i = u(e, a(e)) : l.mutate.set[r] && (i = u(e, v))), D(V, function (t) {
          return D(l.aryMethod[t], function (e) {
            if (r == e) {
              var o = l.methodSpread[r],
                  a = o && o.afterRearg;
              return n = a ? d(r, g(r, i, t), t) : g(r, d(r, i, t), t), n = p(r, n), n = m(r, n, t), !1;
            }
          }), !n;
        }), n || (n = i), n == e && (n = A ? L(n, 1) : function () {
          return e.apply(this, arguments);
        }), n.convert = x(r, e), l.placeholder[r] && (M = !0, n.placeholder = e.placeholder = P), n;
      }

      var M,
          T = "function" == typeof e,
          N = e === Object(e);
      if (N && (f = n, n = e, e = void 0), null == n) throw new TypeError();
      f || (f = {});
      var S = {
        cap: !("cap" in f) || f.cap,
        curry: !("curry" in f) || f.curry,
        fixed: !("fixed" in f) || f.fixed,
        immutable: !("immutable" in f) || f.immutable,
        rearg: !("rearg" in f) || f.rearg
      },
          A = "curry" in f && f.curry,
          O = "fixed" in f && f.fixed,
          C = "rearg" in f && f.rearg,
          P = T ? n : h,
          R = T ? n.runInContext() : void 0,
          I = T ? n : {
        ary: t.ary,
        assign: t.assign,
        clone: t.clone,
        curry: t.curry,
        forEach: t.forEach,
        isArray: t.isArray,
        isError: t.isError,
        isFunction: t.isFunction,
        isWeakMap: t.isWeakMap,
        iteratee: t.iteratee,
        keys: t.keys,
        rearg: t.rearg,
        toInteger: t.toInteger,
        toPath: t.toPath
      },
          k = I.ary,
          z = I.assign,
          B = I.clone,
          L = I.curry,
          D = I.forEach,
          j = I.isArray,
          F = I.isError,
          U = I.isFunction,
          q = I.isWeakMap,
          H = I.keys,
          W = I.rearg,
          G = I.toInteger,
          $ = I.toPath,
          V = H(l.aryMethod),
          Z = {
        castArray: function castArray(t) {
          return function () {
            var e = arguments[0];
            return j(e) ? t(o(e)) : t.apply(void 0, arguments);
          };
        },
        iteratee: function iteratee(t) {
          return function () {
            var e = arguments[0],
                n = arguments[1],
                r = t(e, n),
                o = r.length;
            return S.cap && "number" == typeof n ? (n = n > 2 ? n - 2 : 1, o && o <= n ? r : i(r, n)) : r;
          };
        },
        mixin: function mixin(t) {
          return function (e) {
            var n = this;
            if (!U(n)) return t(n, Object(e));
            var r = [];
            return D(H(e), function (t) {
              U(e[t]) && r.push([t, n.prototype[t]]);
            }), t(n, Object(e)), D(r, function (t) {
              var e = t[1];
              U(e) ? n.prototype[t[0]] = e : delete n.prototype[t[0]];
            }), n;
          };
        },
        nthArg: function nthArg(t) {
          return function (e) {
            var n = e < 0 ? 1 : G(e) + 1;
            return L(t(e), n);
          };
        },
        rearg: function rearg(t) {
          return function (e, n) {
            var r = n ? n.length : 0;
            return L(t(e, n), r);
          };
        },
        runInContext: function runInContext(e) {
          return function (n) {
            return c(t, e(n), f);
          };
        }
      };
      if (!N) return E(e, n);
      var X = n,
          Y = [];
      return D(V, function (t) {
        D(l.aryMethod[t], function (t) {
          var e = X[l.remap[t] || t];
          e && Y.push([t, E(t, e)]);
        });
      }), D(H(X), function (t) {
        var e = X[t];

        if ("function" == typeof e) {
          for (var n = Y.length; n--;) {
            if (Y[n][0] == t) return;
          }

          e.convert = x(t, e), Y.push([t, e]);
        }
      }), D(Y, function (t) {
        X[t[0]] = t[1];
      }), X.convert = y, M && (X.placeholder = P), D(H(X), function (t) {
        D(l.realToAlias[t] || [], function (e) {
          X[e] = X[t];
        });
      }), X;
    }

    var l = n(182),
        h = n(183),
        f = Array.prototype.push;
    t.exports = c;
  }, function (t, e) {
    e.aliasToReal = {
      each: "forEach",
      eachRight: "forEachRight",
      entries: "toPairs",
      entriesIn: "toPairsIn",
      extend: "assignIn",
      extendAll: "assignInAll",
      extendAllWith: "assignInAllWith",
      extendWith: "assignInWith",
      first: "head",
      conforms: "conformsTo",
      matches: "isMatch",
      property: "get",
      __: "placeholder",
      F: "stubFalse",
      T: "stubTrue",
      all: "every",
      allPass: "overEvery",
      always: "constant",
      any: "some",
      anyPass: "overSome",
      apply: "spread",
      assoc: "set",
      assocPath: "set",
      complement: "negate",
      compose: "flowRight",
      contains: "includes",
      dissoc: "unset",
      dissocPath: "unset",
      dropLast: "dropRight",
      dropLastWhile: "dropRightWhile",
      equals: "isEqual",
      identical: "eq",
      indexBy: "keyBy",
      init: "initial",
      invertObj: "invert",
      juxt: "over",
      omitAll: "omit",
      nAry: "ary",
      path: "get",
      pathEq: "matchesProperty",
      pathOr: "getOr",
      paths: "at",
      pickAll: "pick",
      pipe: "flow",
      pluck: "map",
      prop: "get",
      propEq: "matchesProperty",
      propOr: "getOr",
      props: "at",
      symmetricDifference: "xor",
      symmetricDifferenceBy: "xorBy",
      symmetricDifferenceWith: "xorWith",
      takeLast: "takeRight",
      takeLastWhile: "takeRightWhile",
      unapply: "rest",
      unnest: "flatten",
      useWith: "overArgs",
      where: "conformsTo",
      whereEq: "isMatch",
      zipObj: "zipObject"
    }, e.aryMethod = {
      1: ["assignAll", "assignInAll", "attempt", "castArray", "ceil", "create", "curry", "curryRight", "defaultsAll", "defaultsDeepAll", "floor", "flow", "flowRight", "fromPairs", "invert", "iteratee", "memoize", "method", "mergeAll", "methodOf", "mixin", "nthArg", "over", "overEvery", "overSome", "rest", "reverse", "round", "runInContext", "spread", "template", "trim", "trimEnd", "trimStart", "uniqueId", "words", "zipAll"],
      2: ["add", "after", "ary", "assign", "assignAllWith", "assignIn", "assignInAllWith", "at", "before", "bind", "bindAll", "bindKey", "chunk", "cloneDeepWith", "cloneWith", "concat", "conformsTo", "countBy", "curryN", "curryRightN", "debounce", "defaults", "defaultsDeep", "defaultTo", "delay", "difference", "divide", "drop", "dropRight", "dropRightWhile", "dropWhile", "endsWith", "eq", "every", "filter", "find", "findIndex", "findKey", "findLast", "findLastIndex", "findLastKey", "flatMap", "flatMapDeep", "flattenDepth", "forEach", "forEachRight", "forIn", "forInRight", "forOwn", "forOwnRight", "get", "groupBy", "gt", "gte", "has", "hasIn", "includes", "indexOf", "intersection", "invertBy", "invoke", "invokeMap", "isEqual", "isMatch", "join", "keyBy", "lastIndexOf", "lt", "lte", "map", "mapKeys", "mapValues", "matchesProperty", "maxBy", "meanBy", "merge", "mergeAllWith", "minBy", "multiply", "nth", "omit", "omitBy", "overArgs", "pad", "padEnd", "padStart", "parseInt", "partial", "partialRight", "partition", "pick", "pickBy", "propertyOf", "pull", "pullAll", "pullAt", "random", "range", "rangeRight", "rearg", "reject", "remove", "repeat", "restFrom", "result", "sampleSize", "some", "sortBy", "sortedIndex", "sortedIndexOf", "sortedLastIndex", "sortedLastIndexOf", "sortedUniqBy", "split", "spreadFrom", "startsWith", "subtract", "sumBy", "take", "takeRight", "takeRightWhile", "takeWhile", "tap", "throttle", "thru", "times", "trimChars", "trimCharsEnd", "trimCharsStart", "truncate", "union", "uniqBy", "uniqWith", "unset", "unzipWith", "without", "wrap", "xor", "zip", "zipObject", "zipObjectDeep"],
      3: ["assignInWith", "assignWith", "clamp", "differenceBy", "differenceWith", "findFrom", "findIndexFrom", "findLastFrom", "findLastIndexFrom", "getOr", "includesFrom", "indexOfFrom", "inRange", "intersectionBy", "intersectionWith", "invokeArgs", "invokeArgsMap", "isEqualWith", "isMatchWith", "flatMapDepth", "lastIndexOfFrom", "mergeWith", "orderBy", "padChars", "padCharsEnd", "padCharsStart", "pullAllBy", "pullAllWith", "rangeStep", "rangeStepRight", "reduce", "reduceRight", "replace", "set", "slice", "sortedIndexBy", "sortedLastIndexBy", "transform", "unionBy", "unionWith", "update", "xorBy", "xorWith", "zipWith"],
      4: ["fill", "setWith", "updateWith"]
    }, e.aryRearg = {
      2: [1, 0],
      3: [2, 0, 1],
      4: [3, 2, 0, 1]
    }, e.iterateeAry = {
      dropRightWhile: 1,
      dropWhile: 1,
      every: 1,
      filter: 1,
      find: 1,
      findFrom: 1,
      findIndex: 1,
      findIndexFrom: 1,
      findKey: 1,
      findLast: 1,
      findLastFrom: 1,
      findLastIndex: 1,
      findLastIndexFrom: 1,
      findLastKey: 1,
      flatMap: 1,
      flatMapDeep: 1,
      flatMapDepth: 1,
      forEach: 1,
      forEachRight: 1,
      forIn: 1,
      forInRight: 1,
      forOwn: 1,
      forOwnRight: 1,
      map: 1,
      mapKeys: 1,
      mapValues: 1,
      partition: 1,
      reduce: 2,
      reduceRight: 2,
      reject: 1,
      remove: 1,
      some: 1,
      takeRightWhile: 1,
      takeWhile: 1,
      times: 1,
      transform: 2
    }, e.iterateeRearg = {
      mapKeys: [1],
      reduceRight: [1, 0]
    }, e.methodRearg = {
      assignInAllWith: [1, 0],
      assignInWith: [1, 2, 0],
      assignAllWith: [1, 0],
      assignWith: [1, 2, 0],
      differenceBy: [1, 2, 0],
      differenceWith: [1, 2, 0],
      getOr: [2, 1, 0],
      intersectionBy: [1, 2, 0],
      intersectionWith: [1, 2, 0],
      isEqualWith: [1, 2, 0],
      isMatchWith: [2, 1, 0],
      mergeAllWith: [1, 0],
      mergeWith: [1, 2, 0],
      padChars: [2, 1, 0],
      padCharsEnd: [2, 1, 0],
      padCharsStart: [2, 1, 0],
      pullAllBy: [2, 1, 0],
      pullAllWith: [2, 1, 0],
      rangeStep: [1, 2, 0],
      rangeStepRight: [1, 2, 0],
      setWith: [3, 1, 2, 0],
      sortedIndexBy: [2, 1, 0],
      sortedLastIndexBy: [2, 1, 0],
      unionBy: [1, 2, 0],
      unionWith: [1, 2, 0],
      updateWith: [3, 1, 2, 0],
      xorBy: [1, 2, 0],
      xorWith: [1, 2, 0],
      zipWith: [1, 2, 0]
    }, e.methodSpread = {
      assignAll: {
        start: 0
      },
      assignAllWith: {
        start: 0
      },
      assignInAll: {
        start: 0
      },
      assignInAllWith: {
        start: 0
      },
      defaultsAll: {
        start: 0
      },
      defaultsDeepAll: {
        start: 0
      },
      invokeArgs: {
        start: 2
      },
      invokeArgsMap: {
        start: 2
      },
      mergeAll: {
        start: 0
      },
      mergeAllWith: {
        start: 0
      },
      partial: {
        start: 1
      },
      partialRight: {
        start: 1
      },
      without: {
        start: 1
      },
      zipAll: {
        start: 0
      }
    }, e.mutate = {
      array: {
        fill: !0,
        pull: !0,
        pullAll: !0,
        pullAllBy: !0,
        pullAllWith: !0,
        pullAt: !0,
        remove: !0,
        reverse: !0
      },
      object: {
        assign: !0,
        assignAll: !0,
        assignAllWith: !0,
        assignIn: !0,
        assignInAll: !0,
        assignInAllWith: !0,
        assignInWith: !0,
        assignWith: !0,
        defaults: !0,
        defaultsAll: !0,
        defaultsDeep: !0,
        defaultsDeepAll: !0,
        merge: !0,
        mergeAll: !0,
        mergeAllWith: !0,
        mergeWith: !0
      },
      set: {
        set: !0,
        setWith: !0,
        unset: !0,
        update: !0,
        updateWith: !0
      }
    }, e.placeholder = {
      bind: !0,
      bindKey: !0,
      curry: !0,
      curryRight: !0,
      partial: !0,
      partialRight: !0
    }, e.realToAlias = function () {
      var t = Object.prototype.hasOwnProperty,
          n = e.aliasToReal,
          r = {};

      for (var i in n) {
        var o = n[i];
        t.call(r, o) ? r[o].push(i) : r[o] = [i];
      }

      return r;
    }(), e.remap = {
      assignAll: "assign",
      assignAllWith: "assignWith",
      assignInAll: "assignIn",
      assignInAllWith: "assignInWith",
      curryN: "curry",
      curryRightN: "curryRight",
      defaultsAll: "defaults",
      defaultsDeepAll: "defaultsDeep",
      findFrom: "find",
      findIndexFrom: "findIndex",
      findLastFrom: "findLast",
      findLastIndexFrom: "findLastIndex",
      getOr: "get",
      includesFrom: "includes",
      indexOfFrom: "indexOf",
      invokeArgs: "invoke",
      invokeArgsMap: "invokeMap",
      lastIndexOfFrom: "lastIndexOf",
      mergeAll: "merge",
      mergeAllWith: "mergeWith",
      padChars: "pad",
      padCharsEnd: "padEnd",
      padCharsStart: "padStart",
      propertyOf: "get",
      rangeStep: "range",
      rangeStepRight: "rangeRight",
      restFrom: "rest",
      spreadFrom: "spread",
      trimChars: "trim",
      trimCharsEnd: "trimEnd",
      trimCharsStart: "trimStart",
      zipAll: "zip"
    }, e.skipFixed = {
      castArray: !0,
      flow: !0,
      flowRight: !0,
      iteratee: !0,
      mixin: !0,
      rearg: !0,
      runInContext: !0
    }, e.skipRearg = {
      add: !0,
      assign: !0,
      assignIn: !0,
      bind: !0,
      bindKey: !0,
      concat: !0,
      difference: !0,
      divide: !0,
      eq: !0,
      gt: !0,
      gte: !0,
      isEqual: !0,
      lt: !0,
      lte: !0,
      matchesProperty: !0,
      merge: !0,
      multiply: !0,
      overArgs: !0,
      partial: !0,
      partialRight: !0,
      propertyOf: !0,
      random: !0,
      range: !0,
      rangeRight: !0,
      subtract: !0,
      zip: !0,
      zipObject: !0,
      zipObjectDeep: !0
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r;
    (function (t, i) {
      (function () {
        function o(t, e, n) {
          switch (n.length) {
            case 0:
              return t.call(e);

            case 1:
              return t.call(e, n[0]);

            case 2:
              return t.call(e, n[0], n[1]);

            case 3:
              return t.call(e, n[0], n[1], n[2]);
          }

          return t.apply(e, n);
        }

        function a(t, e, n, r) {
          for (var i = -1, o = null == t ? 0 : t.length; ++i < o;) {
            var a = t[i];
            e(r, a, n(a), t);
          }

          return r;
        }

        function s(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r && !1 !== e(t[n], n, t);) {
            ;
          }

          return t;
        }

        function u(t, e) {
          for (var n = null == t ? 0 : t.length; n-- && !1 !== e(t[n], n, t);) {
            ;
          }

          return t;
        }

        function c(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
            if (!e(t[n], n, t)) return !1;
          }

          return !0;
        }

        function l(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = 0, o = []; ++n < r;) {
            var a = t[n];
            e(a, n, t) && (o[i++] = a);
          }

          return o;
        }

        function h(t, e) {
          return !(null == t || !t.length) && -1 < w(t, e, 0);
        }

        function f(t, e, n) {
          for (var r = -1, i = null == t ? 0 : t.length; ++r < i;) {
            if (n(e, t[r])) return !0;
          }

          return !1;
        }

        function p(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length, i = Array(r); ++n < r;) {
            i[n] = e(t[n], n, t);
          }

          return i;
        }

        function m(t, e) {
          for (var n = -1, r = e.length, i = t.length; ++n < r;) {
            t[i + n] = e[n];
          }

          return t;
        }

        function d(t, e, n, r) {
          var i = -1,
              o = null == t ? 0 : t.length;

          for (r && o && (n = t[++i]); ++i < o;) {
            n = e(n, t[i], i, t);
          }

          return n;
        }

        function g(t, e, n, r) {
          var i = null == t ? 0 : t.length;

          for (r && i && (n = t[--i]); i--;) {
            n = e(n, t[i], i, t);
          }

          return n;
        }

        function v(t, e) {
          for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
            if (e(t[n], n, t)) return !0;
          }

          return !1;
        }

        function y(t, e, n) {
          var r;
          return n(t, function (t, n, i) {
            if (e(t, n, i)) return r = n, !1;
          }), r;
        }

        function x(t, e, n, r) {
          var i = t.length;

          for (n += r ? 1 : -1; r ? n-- : ++n < i;) {
            if (e(t[n], n, t)) return n;
          }

          return -1;
        }

        function w(t, e, n) {
          if (e === e) t: {
            --n;

            for (var r = t.length; ++n < r;) {
              if (t[n] === e) {
                t = n;
                break t;
              }
            }

            t = -1;
          } else t = x(t, _, n);
          return t;
        }

        function b(t, e, n, r) {
          --n;

          for (var i = t.length; ++n < i;) {
            if (r(t[n], e)) return n;
          }

          return -1;
        }

        function _(t) {
          return t !== t;
        }

        function E(t, e) {
          var n = null == t ? 0 : t.length;
          return n ? A(t, e) / n : $;
        }

        function M(t) {
          return function (e) {
            return null == e ? W : e[t];
          };
        }

        function T(t) {
          return function (e) {
            return null == t ? W : t[e];
          };
        }

        function N(t, e, n, r, i) {
          return i(t, function (t, i, o) {
            n = r ? (r = !1, t) : e(n, t, i, o);
          }), n;
        }

        function S(t, e) {
          var n = t.length;

          for (t.sort(e); n--;) {
            t[n] = t[n].c;
          }

          return t;
        }

        function A(t, e) {
          for (var n, r = -1, i = t.length; ++r < i;) {
            var o = e(t[r]);
            o !== W && (n = n === W ? o : n + o);
          }

          return n;
        }

        function O(t, e) {
          for (var n = -1, r = Array(t); ++n < t;) {
            r[n] = e(n);
          }

          return r;
        }

        function C(t, e) {
          return p(e, function (e) {
            return [e, t[e]];
          });
        }

        function P(t) {
          return function (e) {
            return t(e);
          };
        }

        function R(t, e) {
          return p(e, function (e) {
            return t[e];
          });
        }

        function I(t, e) {
          return t.has(e);
        }

        function k(t, e) {
          for (var n = -1, r = t.length; ++n < r && -1 < w(e, t[n], 0);) {
            ;
          }

          return n;
        }

        function z(t, e) {
          for (var n = t.length; n-- && -1 < w(e, t[n], 0);) {
            ;
          }

          return n;
        }

        function B(t) {
          return "\\" + Ft[t];
        }

        function L(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t, r) {
            n[++e] = [r, t];
          }), n;
        }

        function D(t, e) {
          return function (n) {
            return t(e(n));
          };
        }

        function j(t, e) {
          for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
            var a = t[n];
            a !== e && "__lodash_placeholder__" !== a || (t[n] = "__lodash_placeholder__", o[i++] = n);
          }

          return o;
        }

        function F(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t) {
            n[++e] = t;
          }), n;
        }

        function U(t) {
          var e = -1,
              n = Array(t.size);
          return t.forEach(function (t) {
            n[++e] = [t, t];
          }), n;
        }

        function q(t) {
          if (kt.test(t)) {
            for (var e = Rt.lastIndex = 0; Rt.test(t);) {
              ++e;
            }

            t = e;
          } else t = ne(t);

          return t;
        }

        function H(t) {
          return kt.test(t) ? t.match(Rt) || [] : t.split("");
        }

        var W,
            G = 1 / 0,
            $ = NaN,
            V = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]],
            Z = /\b__p\+='';/g,
            X = /\b(__p\+=)''\+/g,
            Y = /(__e\(.*?\)|\b__t\))\+'';/g,
            K = /&(?:amp|lt|gt|quot|#39);/g,
            J = /[&<>"']/g,
            Q = RegExp(K.source),
            tt = RegExp(J.source),
            et = /<%-([\s\S]+?)%>/g,
            nt = /<%([\s\S]+?)%>/g,
            rt = /<%=([\s\S]+?)%>/g,
            it = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            ot = /^\w*$/,
            at = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            st = /[\\^$.*+?()[\]{}|]/g,
            ut = RegExp(st.source),
            ct = /^\s+|\s+$/g,
            lt = /^\s+/,
            ht = /\s+$/,
            ft = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            pt = /\{\n\/\* \[wrapped with (.+)\] \*/,
            mt = /,? & /,
            dt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            gt = /\\(\\)?/g,
            vt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            yt = /\w*$/,
            xt = /^[-+]0x[0-9a-f]+$/i,
            wt = /^0b[01]+$/i,
            bt = /^\[object .+?Constructor\]$/,
            _t = /^0o[0-7]+$/i,
            Et = /^(?:0|[1-9]\d*)$/,
            Mt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            Tt = /($^)/,
            Nt = /['\n\r\u2028\u2029\\]/g,
            St = "[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",
            At = "(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])" + St,
            Ot = "(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",
            Ct = RegExp("['’]", "g"),
            Pt = RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", "g"),
            Rt = RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|" + Ot + St, "g"),
            It = RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+", At].join("|"), "g"),
            kt = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),
            zt = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            Bt = "Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),
            Lt = {};
        Lt["[object Float32Array]"] = Lt["[object Float64Array]"] = Lt["[object Int8Array]"] = Lt["[object Int16Array]"] = Lt["[object Int32Array]"] = Lt["[object Uint8Array]"] = Lt["[object Uint8ClampedArray]"] = Lt["[object Uint16Array]"] = Lt["[object Uint32Array]"] = !0, Lt["[object Arguments]"] = Lt["[object Array]"] = Lt["[object ArrayBuffer]"] = Lt["[object Boolean]"] = Lt["[object DataView]"] = Lt["[object Date]"] = Lt["[object Error]"] = Lt["[object Function]"] = Lt["[object Map]"] = Lt["[object Number]"] = Lt["[object Object]"] = Lt["[object RegExp]"] = Lt["[object Set]"] = Lt["[object String]"] = Lt["[object WeakMap]"] = !1;
        var Dt = {};
        Dt["[object Arguments]"] = Dt["[object Array]"] = Dt["[object ArrayBuffer]"] = Dt["[object DataView]"] = Dt["[object Boolean]"] = Dt["[object Date]"] = Dt["[object Float32Array]"] = Dt["[object Float64Array]"] = Dt["[object Int8Array]"] = Dt["[object Int16Array]"] = Dt["[object Int32Array]"] = Dt["[object Map]"] = Dt["[object Number]"] = Dt["[object Object]"] = Dt["[object RegExp]"] = Dt["[object Set]"] = Dt["[object String]"] = Dt["[object Symbol]"] = Dt["[object Uint8Array]"] = Dt["[object Uint8ClampedArray]"] = Dt["[object Uint16Array]"] = Dt["[object Uint32Array]"] = !0, Dt["[object Error]"] = Dt["[object Function]"] = Dt["[object WeakMap]"] = !1;
        var jt,
            Ft = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
            Ut = parseFloat,
            qt = parseInt,
            Ht = "object" == typeof t && t && t.Object === Object && t,
            Wt = "object" == typeof self && self && self.Object === Object && self,
            Gt = Ht || Wt || Function("return this")(),
            $t = "object" == typeof e && e && !e.nodeType && e,
            Vt = $t && "object" == typeof i && i && !i.nodeType && i,
            Zt = Vt && Vt.exports === $t,
            Xt = Zt && Ht.process;

        t: {
          try {
            jt = Xt && Xt.binding && Xt.binding("util");
            break t;
          } catch (t) {}

          jt = void 0;
        }

        var Yt = jt && jt.isArrayBuffer,
            Kt = jt && jt.isDate,
            Jt = jt && jt.isMap,
            Qt = jt && jt.isRegExp,
            te = jt && jt.isSet,
            ee = jt && jt.isTypedArray,
            ne = M("length"),
            re = T({
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "Ç": "C",
          "ç": "c",
          "Ð": "D",
          "ð": "d",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "Ñ": "N",
          "ñ": "n",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "Ý": "Y",
          "ý": "y",
          "ÿ": "y",
          "Æ": "Ae",
          "æ": "ae",
          "Þ": "Th",
          "þ": "th",
          "ß": "ss",
          "Ā": "A",
          "Ă": "A",
          "Ą": "A",
          "ā": "a",
          "ă": "a",
          "ą": "a",
          "Ć": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Č": "C",
          "ć": "c",
          "ĉ": "c",
          "ċ": "c",
          "č": "c",
          "Ď": "D",
          "Đ": "D",
          "ď": "d",
          "đ": "d",
          "Ē": "E",
          "Ĕ": "E",
          "Ė": "E",
          "Ę": "E",
          "Ě": "E",
          "ē": "e",
          "ĕ": "e",
          "ė": "e",
          "ę": "e",
          "ě": "e",
          "Ĝ": "G",
          "Ğ": "G",
          "Ġ": "G",
          "Ģ": "G",
          "ĝ": "g",
          "ğ": "g",
          "ġ": "g",
          "ģ": "g",
          "Ĥ": "H",
          "Ħ": "H",
          "ĥ": "h",
          "ħ": "h",
          "Ĩ": "I",
          "Ī": "I",
          "Ĭ": "I",
          "Į": "I",
          "İ": "I",
          "ĩ": "i",
          "ī": "i",
          "ĭ": "i",
          "į": "i",
          "ı": "i",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "ĸ": "k",
          "Ĺ": "L",
          "Ļ": "L",
          "Ľ": "L",
          "Ŀ": "L",
          "Ł": "L",
          "ĺ": "l",
          "ļ": "l",
          "ľ": "l",
          "ŀ": "l",
          "ł": "l",
          "Ń": "N",
          "Ņ": "N",
          "Ň": "N",
          "Ŋ": "N",
          "ń": "n",
          "ņ": "n",
          "ň": "n",
          "ŋ": "n",
          "Ō": "O",
          "Ŏ": "O",
          "Ő": "O",
          "ō": "o",
          "ŏ": "o",
          "ő": "o",
          "Ŕ": "R",
          "Ŗ": "R",
          "Ř": "R",
          "ŕ": "r",
          "ŗ": "r",
          "ř": "r",
          "Ś": "S",
          "Ŝ": "S",
          "Ş": "S",
          "Š": "S",
          "ś": "s",
          "ŝ": "s",
          "ş": "s",
          "š": "s",
          "Ţ": "T",
          "Ť": "T",
          "Ŧ": "T",
          "ţ": "t",
          "ť": "t",
          "ŧ": "t",
          "Ũ": "U",
          "Ū": "U",
          "Ŭ": "U",
          "Ů": "U",
          "Ű": "U",
          "Ų": "U",
          "ũ": "u",
          "ū": "u",
          "ŭ": "u",
          "ů": "u",
          "ű": "u",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "Ż": "Z",
          "Ž": "Z",
          "ź": "z",
          "ż": "z",
          "ž": "z",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Œ": "Oe",
          "œ": "oe",
          "ŉ": "'n",
          "ſ": "s"
        }),
            ie = T({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }),
            oe = T({
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        }),
            ae = function t(e) {
          function n(t) {
            if (vi(t) && !os(t) && !(t instanceof T)) {
              if (t instanceof i) return t;
              if (oo.call(t, "__wrapped__")) return Fr(t);
            }

            return new i(t);
          }

          function r() {}

          function i(t, e) {
            this.__wrapped__ = t, this.__actions__ = [], this.__chain__ = !!e, this.__index__ = 0, this.__values__ = W;
          }

          function T(t) {
            this.__wrapped__ = t, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = 4294967295, this.__views__ = [];
          }

          function St(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function At(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function Ot(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.clear(); ++e < n;) {
              var r = t[e];
              this.set(r[0], r[1]);
            }
          }

          function Rt(t) {
            var e = -1,
                n = null == t ? 0 : t.length;

            for (this.__data__ = new Ot(); ++e < n;) {
              this.add(t[e]);
            }
          }

          function jt(t) {
            this.size = (this.__data__ = new At(t)).size;
          }

          function Ft(t, e) {
            var n,
                r = os(t),
                i = !r && is(t),
                o = !r && !i && ss(t),
                a = !r && !i && !o && fs(t),
                i = (r = r || i || o || a) ? O(t.length, Qi) : [],
                s = i.length;

            for (n in t) {
              !e && !oo.call(t, n) || r && ("length" == n || o && ("offset" == n || "parent" == n) || a && ("buffer" == n || "byteLength" == n || "byteOffset" == n) || Sr(n, s)) || i.push(n);
            }

            return i;
          }

          function Ht(t) {
            var e = t.length;
            return e ? t[on(0, e - 1)] : W;
          }

          function Wt(t, e) {
            return Br(zn(t), fe(e, 0, t.length));
          }

          function $t(t) {
            return Br(zn(t));
          }

          function Vt(t, e, n) {
            (n === W || ci(t[e], n)) && (n !== W || e in t) || le(t, e, n);
          }

          function Xt(t, e, n) {
            var r = t[e];
            oo.call(t, e) && ci(r, n) && (n !== W || e in t) || le(t, e, n);
          }

          function ne(t, e) {
            for (var n = t.length; n--;) {
              if (ci(t[n][0], e)) return n;
            }

            return -1;
          }

          function se(t, e, n, r) {
            return ia(t, function (t, i, o) {
              e(r, t, n(t), o);
            }), r;
          }

          function ue(t, e) {
            return t && Bn(e, Pi(e), t);
          }

          function ce(t, e) {
            return t && Bn(e, Ri(e), t);
          }

          function le(t, e, n) {
            "__proto__" == e && Mo ? Mo(t, e, {
              configurable: !0,
              enumerable: !0,
              value: n,
              writable: !0
            }) : t[e] = n;
          }

          function he(t, e) {
            for (var n = -1, r = e.length, i = $i(r), o = null == t; ++n < r;) {
              i[n] = o ? W : Oi(t, e[n]);
            }

            return i;
          }

          function fe(t, e, n) {
            return t === t && (n !== W && (t = t <= n ? t : n), e !== W && (t = t >= e ? t : e)), t;
          }

          function pe(t, e, n, r, i, o) {
            var a,
                u = 1 & e,
                c = 2 & e,
                l = 4 & e;
            if (n && (a = i ? n(t, r, i, o) : n(t)), a !== W) return a;
            if (!gi(t)) return t;

            if (r = os(t)) {
              if (a = Er(t), !u) return zn(t, a);
            } else {
              var h = da(t),
                  f = "[object Function]" == h || "[object GeneratorFunction]" == h;
              if (ss(t)) return On(t, u);

              if ("[object Object]" == h || "[object Arguments]" == h || f && !i) {
                if (a = c || f ? {} : Mr(t), !u) return c ? Dn(t, ce(a, t)) : Ln(t, ue(a, t));
              } else {
                if (!Dt[h]) return i ? t : {};
                a = Tr(t, h, u);
              }
            }

            if (o || (o = new jt()), i = o.get(t)) return i;
            if (o.set(t, a), hs(t)) return t.forEach(function (r) {
              a.add(pe(r, e, n, r, t, o));
            }), a;
            if (cs(t)) return t.forEach(function (r, i) {
              a.set(i, pe(r, e, n, i, t, o));
            }), a;
            var c = l ? c ? dr : mr : c ? Ri : Pi,
                p = r ? W : c(t);
            return s(p || t, function (r, i) {
              p && (i = r, r = t[i]), Xt(a, i, pe(r, e, n, i, t, o));
            }), a;
          }

          function me(t) {
            var e = Pi(t);
            return function (n) {
              return de(n, t, e);
            };
          }

          function de(t, e, n) {
            var r = n.length;
            if (null == t) return !r;

            for (t = Ki(t); r--;) {
              var i = n[r],
                  o = e[i],
                  a = t[i];
              if (a === W && !(i in t) || !o(a)) return !1;
            }

            return !0;
          }

          function ge(t, e, n) {
            if ("function" != typeof t) throw new to("Expected a function");
            return ya(function () {
              t.apply(W, n);
            }, e);
          }

          function ve(t, e, n, r) {
            var i = -1,
                o = h,
                a = !0,
                s = t.length,
                u = [],
                c = e.length;
            if (!s) return u;
            n && (e = p(e, P(n))), r ? (o = f, a = !1) : 200 <= e.length && (o = I, a = !1, e = new Rt(e));

            t: for (; ++i < s;) {
              var l = t[i],
                  m = null == n ? l : n(l),
                  l = r || 0 !== l ? l : 0;

              if (a && m === m) {
                for (var d = c; d--;) {
                  if (e[d] === m) continue t;
                }

                u.push(l);
              } else o(e, m, r) || u.push(l);
            }

            return u;
          }

          function ye(t, e) {
            var n = !0;
            return ia(t, function (t, r, i) {
              return n = !!e(t, r, i);
            }), n;
          }

          function xe(t, e, n) {
            for (var r = -1, i = t.length; ++r < i;) {
              var o = t[r],
                  a = e(o);
              if (null != a && (s === W ? a === a && !bi(a) : n(a, s))) var s = a,
                  u = o;
            }

            return u;
          }

          function we(t, e) {
            var n = [];
            return ia(t, function (t, r, i) {
              e(t, r, i) && n.push(t);
            }), n;
          }

          function be(t, e, n, r, i) {
            var o = -1,
                a = t.length;

            for (n || (n = Nr), i || (i = []); ++o < a;) {
              var s = t[o];
              0 < e && n(s) ? 1 < e ? be(s, e - 1, n, r, i) : m(i, s) : r || (i[i.length] = s);
            }

            return i;
          }

          function _e(t, e) {
            return t && aa(t, e, Pi);
          }

          function Ee(t, e) {
            return t && sa(t, e, Pi);
          }

          function Me(t, e) {
            return l(e, function (e) {
              return pi(t[e]);
            });
          }

          function Te(t, e) {
            e = Sn(e, t);

            for (var n = 0, r = e.length; null != t && n < r;) {
              t = t[Lr(e[n++])];
            }

            return n && n == r ? t : W;
          }

          function Ne(t, e, n) {
            return e = e(t), os(t) ? e : m(e, n(t));
          }

          function Se(t) {
            if (null == t) t = t === W ? "[object Undefined]" : "[object Null]";else if (Eo && Eo in Ki(t)) {
              var e = oo.call(t, Eo),
                  n = t[Eo];

              try {
                t[Eo] = W;
                var r = !0;
              } catch (t) {}

              var i = uo.call(t);
              r && (e ? t[Eo] = n : delete t[Eo]), t = i;
            } else t = uo.call(t);
            return t;
          }

          function Ae(t, e) {
            return t > e;
          }

          function Oe(t, e) {
            return null != t && oo.call(t, e);
          }

          function Ce(t, e) {
            return null != t && e in Ki(t);
          }

          function Pe(t, e, n) {
            for (var r = n ? f : h, i = t[0].length, o = t.length, a = o, s = $i(o), u = 1 / 0, c = []; a--;) {
              var l = t[a];
              a && e && (l = p(l, P(e))), u = Bo(l.length, u), s[a] = !n && (e || 120 <= i && 120 <= l.length) ? new Rt(a && l) : W;
            }

            var l = t[0],
                m = -1,
                d = s[0];

            t: for (; ++m < i && c.length < u;) {
              var g = l[m],
                  v = e ? e(g) : g,
                  g = n || 0 !== g ? g : 0;

              if (d ? !I(d, v) : !r(c, v, n)) {
                for (a = o; --a;) {
                  var y = s[a];
                  if (y ? !I(y, v) : !r(t[a], v, n)) continue t;
                }

                d && d.push(v), c.push(g);
              }
            }

            return c;
          }

          function Re(t, e, n) {
            var r = {};
            return _e(t, function (t, i, o) {
              e(r, n(t), i, o);
            }), r;
          }

          function Ie(t, e, n) {
            return e = Sn(e, t), t = 2 > e.length ? t : Te(t, fn(e, 0, -1)), e = null == t ? t : t[Lr(Gr(e))], null == e ? W : o(e, t, n);
          }

          function ke(t) {
            return vi(t) && "[object Arguments]" == Se(t);
          }

          function ze(t) {
            return vi(t) && "[object ArrayBuffer]" == Se(t);
          }

          function Be(t) {
            return vi(t) && "[object Date]" == Se(t);
          }

          function Le(t, e, n, r, i) {
            if (t === e) e = !0;else if (null == t || null == e || !vi(t) && !vi(e)) e = t !== t && e !== e;else t: {
              var o = os(t),
                  a = os(e),
                  s = o ? "[object Array]" : da(t),
                  u = a ? "[object Array]" : da(e),
                  s = "[object Arguments]" == s ? "[object Object]" : s,
                  u = "[object Arguments]" == u ? "[object Object]" : u,
                  c = "[object Object]" == s,
                  a = "[object Object]" == u;

              if ((u = s == u) && ss(t)) {
                if (!ss(e)) {
                  e = !1;
                  break t;
                }

                o = !0, c = !1;
              }

              if (u && !c) i || (i = new jt()), e = o || fs(t) ? hr(t, e, n, r, Le, i) : fr(t, e, s, n, r, Le, i);else {
                if (!(1 & n) && (o = c && oo.call(t, "__wrapped__"), s = a && oo.call(e, "__wrapped__"), o || s)) {
                  t = o ? t.value() : t, e = s ? e.value() : e, i || (i = new jt()), e = Le(t, e, n, r, i);
                  break t;
                }

                if (u) {
                  e: if (i || (i = new jt()), o = 1 & n, s = mr(t), a = s.length, u = mr(e).length, a == u || o) {
                    for (c = a; c--;) {
                      var l = s[c];

                      if (!(o ? l in e : oo.call(e, l))) {
                        e = !1;
                        break e;
                      }
                    }

                    if ((u = i.get(t)) && i.get(e)) e = u == e;else {
                      u = !0, i.set(t, e), i.set(e, t);

                      for (var h = o; ++c < a;) {
                        var l = s[c],
                            f = t[l],
                            p = e[l];
                        if (r) var m = o ? r(p, f, l, e, t, i) : r(f, p, l, t, e, i);

                        if (m === W ? f !== p && !Le(f, p, n, r, i) : !m) {
                          u = !1;
                          break;
                        }

                        h || (h = "constructor" == l);
                      }

                      u && !h && (n = t.constructor, r = e.constructor, n != r && "constructor" in t && "constructor" in e && !("function" == typeof n && n instanceof n && "function" == typeof r && r instanceof r) && (u = !1)), i.delete(t), i.delete(e), e = u;
                    }
                  } else e = !1;
                } else e = !1;
              }
            }
            return e;
          }

          function De(t) {
            return vi(t) && "[object Map]" == da(t);
          }

          function je(t, e, n, r) {
            var i = n.length,
                o = i,
                a = !r;
            if (null == t) return !o;

            for (t = Ki(t); i--;) {
              var s = n[i];
              if (a && s[2] ? s[1] !== t[s[0]] : !(s[0] in t)) return !1;
            }

            for (; ++i < o;) {
              var s = n[i],
                  u = s[0],
                  c = t[u],
                  l = s[1];

              if (a && s[2]) {
                if (c === W && !(u in t)) return !1;
              } else {
                if (s = new jt(), r) var h = r(c, l, u, t, e, s);
                if (h === W ? !Le(l, c, 3, r, s) : !h) return !1;
              }
            }

            return !0;
          }

          function Fe(t) {
            return !(!gi(t) || so && so in t) && (pi(t) ? ho : bt).test(Dr(t));
          }

          function Ue(t) {
            return vi(t) && "[object RegExp]" == Se(t);
          }

          function qe(t) {
            return vi(t) && "[object Set]" == da(t);
          }

          function He(t) {
            return vi(t) && di(t.length) && !!Lt[Se(t)];
          }

          function We(t) {
            return "function" == typeof t ? t : null == t ? ji : "object" == typeof t ? os(t) ? Xe(t[0], t[1]) : Ze(t) : Hi(t);
          }

          function Ge(t) {
            if (!Pr(t)) return ko(t);
            var e,
                n = [];

            for (e in Ki(t)) {
              oo.call(t, e) && "constructor" != e && n.push(e);
            }

            return n;
          }

          function $e(t, e) {
            return t < e;
          }

          function Ve(t, e) {
            var n = -1,
                r = li(t) ? $i(t.length) : [];
            return ia(t, function (t, i, o) {
              r[++n] = e(t, i, o);
            }), r;
          }

          function Ze(t) {
            var e = wr(t);
            return 1 == e.length && e[0][2] ? Rr(e[0][0], e[0][1]) : function (n) {
              return n === t || je(n, t, e);
            };
          }

          function Xe(t, e) {
            return Or(t) && e === e && !gi(e) ? Rr(Lr(t), e) : function (n) {
              var r = Oi(n, t);
              return r === W && r === e ? Ci(n, t) : Le(e, r, 3);
            };
          }

          function Ye(t, e, n, r, i) {
            t !== e && aa(e, function (o, a) {
              if (gi(o)) {
                i || (i = new jt());
                var s = i,
                    u = "__proto__" == a ? W : t[a],
                    c = "__proto__" == a ? W : e[a],
                    l = s.get(c);
                if (l) Vt(t, a, l);else {
                  var l = r ? r(u, c, a + "", t, e, s) : W,
                      h = l === W;

                  if (h) {
                    var f = os(c),
                        p = !f && ss(c),
                        m = !f && !p && fs(c),
                        l = c;
                    f || p || m ? os(u) ? l = u : hi(u) ? l = zn(u) : p ? (h = !1, l = On(c, !0)) : m ? (h = !1, l = Pn(c, !0)) : l = [] : xi(c) || is(c) ? (l = u, is(u) ? l = Si(u) : (!gi(u) || n && pi(u)) && (l = Mr(c))) : h = !1;
                  }

                  h && (s.set(c, l), Ye(l, c, n, r, s), s.delete(c)), Vt(t, a, l);
                }
              } else s = r ? r("__proto__" == a ? W : t[a], o, a + "", t, e, i) : W, s === W && (s = o), Vt(t, a, s);
            }, Ri);
          }

          function Ke(t, e) {
            var n = t.length;
            if (n) return e += 0 > e ? n : 0, Sr(e, n) ? t[e] : W;
          }

          function Je(t, e, n) {
            var r = -1;
            return e = p(e.length ? e : [ji], P(yr())), t = Ve(t, function (t) {
              return {
                a: p(e, function (e) {
                  return e(t);
                }),
                b: ++r,
                c: t
              };
            }), S(t, function (t, e) {
              var r;

              t: {
                r = -1;

                for (var i = t.a, o = e.a, a = i.length, s = n.length; ++r < a;) {
                  var u = Rn(i[r], o[r]);

                  if (u) {
                    r = r >= s ? u : u * ("desc" == n[r] ? -1 : 1);
                    break t;
                  }
                }

                r = t.b - e.b;
              }

              return r;
            });
          }

          function Qe(t, e) {
            return tn(t, e, function (e, n) {
              return Ci(t, n);
            });
          }

          function tn(t, e, n) {
            for (var r = -1, i = e.length, o = {}; ++r < i;) {
              var a = e[r],
                  s = Te(t, a);
              n(s, a) && ln(o, Sn(a, t), s);
            }

            return o;
          }

          function en(t) {
            return function (e) {
              return Te(e, t);
            };
          }

          function nn(t, e, n, r) {
            var i = r ? b : w,
                o = -1,
                a = e.length,
                s = t;

            for (t === e && (e = zn(e)), n && (s = p(t, P(n))); ++o < a;) {
              for (var u = 0, c = e[o], c = n ? n(c) : c; -1 < (u = i(s, c, u, r));) {
                s !== t && wo.call(s, u, 1), wo.call(t, u, 1);
              }
            }

            return t;
          }

          function rn(t, e) {
            for (var n = t ? e.length : 0, r = n - 1; n--;) {
              var i = e[n];

              if (n == r || i !== o) {
                var o = i;
                Sr(i) ? wo.call(t, i, 1) : wn(t, i);
              }
            }
          }

          function on(t, e) {
            return t + Oo(jo() * (e - t + 1));
          }

          function an(t, e) {
            var n = "";
            if (!t || 1 > e || 9007199254740991 < e) return n;

            do {
              e % 2 && (n += t), (e = Oo(e / 2)) && (t += t);
            } while (e);

            return n;
          }

          function sn(t, e) {
            return xa(Ir(t, e, ji), t + "");
          }

          function un(t) {
            return Ht(ki(t));
          }

          function cn(t, e) {
            var n = ki(t);
            return Br(n, fe(e, 0, n.length));
          }

          function ln(t, e, n, r) {
            if (!gi(t)) return t;
            e = Sn(e, t);

            for (var i = -1, o = e.length, a = o - 1, s = t; null != s && ++i < o;) {
              var u = Lr(e[i]),
                  c = n;

              if (i != a) {
                var l = s[u],
                    c = r ? r(l, u, s) : W;
                c === W && (c = gi(l) ? l : Sr(e[i + 1]) ? [] : {});
              }

              Xt(s, u, c), s = s[u];
            }

            return t;
          }

          function hn(t) {
            return Br(ki(t));
          }

          function fn(t, e, n) {
            var r = -1,
                i = t.length;

            for (0 > e && (e = -e > i ? 0 : i + e), n = n > i ? i : n, 0 > n && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0, n = $i(i); ++r < i;) {
              n[r] = t[r + e];
            }

            return n;
          }

          function pn(t, e) {
            var n;
            return ia(t, function (t, r, i) {
              return n = e(t, r, i), !n;
            }), !!n;
          }

          function mn(t, e, n) {
            var r = 0,
                i = null == t ? r : t.length;

            if ("number" == typeof e && e === e && 2147483647 >= i) {
              for (; r < i;) {
                var o = r + i >>> 1,
                    a = t[o];
                null !== a && !bi(a) && (n ? a <= e : a < e) ? r = o + 1 : i = o;
              }

              return i;
            }

            return dn(t, e, ji, n);
          }

          function dn(t, e, n, r) {
            e = n(e);

            for (var i = 0, o = null == t ? 0 : t.length, a = e !== e, s = null === e, u = bi(e), c = e === W; i < o;) {
              var l = Oo((i + o) / 2),
                  h = n(t[l]),
                  f = h !== W,
                  p = null === h,
                  m = h === h,
                  d = bi(h);
              (a ? r || m : c ? m && (r || f) : s ? m && f && (r || !p) : u ? m && f && !p && (r || !d) : p || d ? 0 : r ? h <= e : h < e) ? i = l + 1 : o = l;
            }

            return Bo(o, 4294967294);
          }

          function gn(t, e) {
            for (var n = -1, r = t.length, i = 0, o = []; ++n < r;) {
              var a = t[n],
                  s = e ? e(a) : a;

              if (!n || !ci(s, u)) {
                var u = s;
                o[i++] = 0 === a ? 0 : a;
              }
            }

            return o;
          }

          function vn(t) {
            return "number" == typeof t ? t : bi(t) ? $ : +t;
          }

          function yn(t) {
            if ("string" == typeof t) return t;
            if (os(t)) return p(t, yn) + "";
            if (bi(t)) return na ? na.call(t) : "";
            var e = t + "";
            return "0" == e && 1 / t == -G ? "-0" : e;
          }

          function xn(t, e, n) {
            var r = -1,
                i = h,
                o = t.length,
                a = !0,
                s = [],
                u = s;
            if (n) a = !1, i = f;else if (200 <= o) {
              if (i = e ? null : ha(t)) return F(i);
              a = !1, i = I, u = new Rt();
            } else u = e ? [] : s;

            t: for (; ++r < o;) {
              var c = t[r],
                  l = e ? e(c) : c,
                  c = n || 0 !== c ? c : 0;

              if (a && l === l) {
                for (var p = u.length; p--;) {
                  if (u[p] === l) continue t;
                }

                e && u.push(l), s.push(c);
              } else i(u, l, n) || (u !== s && u.push(l), s.push(c));
            }

            return s;
          }

          function wn(t, e) {
            return e = Sn(e, t), t = 2 > e.length ? t : Te(t, fn(e, 0, -1)), null == t || delete t[Lr(Gr(e))];
          }

          function bn(t, e, n, r) {
            for (var i = t.length, o = r ? i : -1; (r ? o-- : ++o < i) && e(t[o], o, t);) {
              ;
            }

            return n ? fn(t, r ? 0 : o, r ? o + 1 : i) : fn(t, r ? o + 1 : 0, r ? i : o);
          }

          function _n(t, e) {
            var n = t;
            return n instanceof T && (n = n.value()), d(e, function (t, e) {
              return e.func.apply(e.thisArg, m([t], e.args));
            }, n);
          }

          function En(t, e, n) {
            var r = t.length;
            if (2 > r) return r ? xn(t[0]) : [];

            for (var i = -1, o = $i(r); ++i < r;) {
              for (var a = t[i], s = -1; ++s < r;) {
                s != i && (o[i] = ve(o[i] || a, t[s], e, n));
              }
            }

            return xn(be(o, 1), e, n);
          }

          function Mn(t, e, n) {
            for (var r = -1, i = t.length, o = e.length, a = {}; ++r < i;) {
              n(a, t[r], r < o ? e[r] : W);
            }

            return a;
          }

          function Tn(t) {
            return hi(t) ? t : [];
          }

          function Nn(t) {
            return "function" == typeof t ? t : ji;
          }

          function Sn(t, e) {
            return os(t) ? t : Or(t, e) ? [t] : wa(Ai(t));
          }

          function An(t, e, n) {
            var r = t.length;
            return n = n === W ? r : n, !e && n >= r ? t : fn(t, e, n);
          }

          function On(t, e) {
            if (e) return t.slice();
            var n = t.length,
                n = go ? go(n) : new t.constructor(n);
            return t.copy(n), n;
          }

          function Cn(t) {
            var e = new t.constructor(t.byteLength);
            return new mo(e).set(new mo(t)), e;
          }

          function Pn(t, e) {
            return new t.constructor(e ? Cn(t.buffer) : t.buffer, t.byteOffset, t.length);
          }

          function Rn(t, e) {
            if (t !== e) {
              var n = t !== W,
                  r = null === t,
                  i = t === t,
                  o = bi(t),
                  a = e !== W,
                  s = null === e,
                  u = e === e,
                  c = bi(e);
              if (!s && !c && !o && t > e || o && a && u && !s && !c || r && a && u || !n && u || !i) return 1;
              if (!r && !o && !c && t < e || c && n && i && !r && !o || s && n && i || !a && i || !u) return -1;
            }

            return 0;
          }

          function In(t, e, n, r) {
            var i = -1,
                o = t.length,
                a = n.length,
                s = -1,
                u = e.length,
                c = zo(o - a, 0),
                l = $i(u + c);

            for (r = !r; ++s < u;) {
              l[s] = e[s];
            }

            for (; ++i < a;) {
              (r || i < o) && (l[n[i]] = t[i]);
            }

            for (; c--;) {
              l[s++] = t[i++];
            }

            return l;
          }

          function kn(t, e, n, r) {
            var i = -1,
                o = t.length,
                a = -1,
                s = n.length,
                u = -1,
                c = e.length,
                l = zo(o - s, 0),
                h = $i(l + c);

            for (r = !r; ++i < l;) {
              h[i] = t[i];
            }

            for (l = i; ++u < c;) {
              h[l + u] = e[u];
            }

            for (; ++a < s;) {
              (r || i < o) && (h[l + n[a]] = t[i++]);
            }

            return h;
          }

          function zn(t, e) {
            var n = -1,
                r = t.length;

            for (e || (e = $i(r)); ++n < r;) {
              e[n] = t[n];
            }

            return e;
          }

          function Bn(t, e, n, r) {
            var i = !n;
            n || (n = {});

            for (var o = -1, a = e.length; ++o < a;) {
              var s = e[o],
                  u = r ? r(n[s], t[s], s, n, t) : W;
              u === W && (u = t[s]), i ? le(n, s, u) : Xt(n, s, u);
            }

            return n;
          }

          function Ln(t, e) {
            return Bn(t, pa(t), e);
          }

          function Dn(t, e) {
            return Bn(t, ma(t), e);
          }

          function jn(t, e) {
            return function (n, r) {
              var i = os(n) ? a : se,
                  o = e ? e() : {};
              return i(n, t, yr(r, 2), o);
            };
          }

          function Fn(t) {
            return sn(function (e, n) {
              var r = -1,
                  i = n.length,
                  o = 1 < i ? n[i - 1] : W,
                  a = 2 < i ? n[2] : W,
                  o = 3 < t.length && "function" == typeof o ? (i--, o) : W;

              for (a && Ar(n[0], n[1], a) && (o = 3 > i ? W : o, i = 1), e = Ki(e); ++r < i;) {
                (a = n[r]) && t(e, a, r, o);
              }

              return e;
            });
          }

          function Un(t, e) {
            return function (n, r) {
              if (null == n) return n;
              if (!li(n)) return t(n, r);

              for (var i = n.length, o = e ? i : -1, a = Ki(n); (e ? o-- : ++o < i) && !1 !== r(a[o], o, a);) {
                ;
              }

              return n;
            };
          }

          function qn(t) {
            return function (e, n, r) {
              var i = -1,
                  o = Ki(e);
              r = r(e);

              for (var a = r.length; a--;) {
                var s = r[t ? a : ++i];
                if (!1 === n(o[s], s, o)) break;
              }

              return e;
            };
          }

          function Hn(t, e, n) {
            function r() {
              return (this && this !== Gt && this instanceof r ? o : t).apply(i ? n : this, arguments);
            }

            var i = 1 & e,
                o = $n(t);
            return r;
          }

          function Wn(t) {
            return function (e) {
              e = Ai(e);
              var n = kt.test(e) ? H(e) : W,
                  r = n ? n[0] : e.charAt(0);
              return e = n ? An(n, 1).join("") : e.slice(1), r[t]() + e;
            };
          }

          function Gn(t) {
            return function (e) {
              return d(Li(Bi(e).replace(Ct, "")), t, "");
            };
          }

          function $n(t) {
            return function () {
              var e = arguments;

              switch (e.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(e[0]);

                case 2:
                  return new t(e[0], e[1]);

                case 3:
                  return new t(e[0], e[1], e[2]);

                case 4:
                  return new t(e[0], e[1], e[2], e[3]);

                case 5:
                  return new t(e[0], e[1], e[2], e[3], e[4]);

                case 6:
                  return new t(e[0], e[1], e[2], e[3], e[4], e[5]);

                case 7:
                  return new t(e[0], e[1], e[2], e[3], e[4], e[5], e[6]);
              }

              var n = ra(t.prototype),
                  e = t.apply(n, e);
              return gi(e) ? e : n;
            };
          }

          function Vn(t, e, n) {
            function r() {
              for (var a = arguments.length, s = $i(a), u = a, c = vr(r); u--;) {
                s[u] = arguments[u];
              }

              return u = 3 > a && s[0] !== c && s[a - 1] !== c ? [] : j(s, c), a -= u.length, a < n ? ir(t, e, Yn, r.placeholder, W, s, u, W, W, n - a) : o(this && this !== Gt && this instanceof r ? i : t, this, s);
            }

            var i = $n(t);
            return r;
          }

          function Zn(t) {
            return function (e, n, r) {
              var i = Ki(e);

              if (!li(e)) {
                var o = yr(n, 3);
                e = Pi(e), n = function n(t) {
                  return o(i[t], t, i);
                };
              }

              return n = t(e, n, r), -1 < n ? i[o ? e[n] : n] : W;
            };
          }

          function Xn(t) {
            return pr(function (e) {
              var n = e.length,
                  r = n,
                  o = i.prototype.thru;

              for (t && e.reverse(); r--;) {
                var a = e[r];
                if ("function" != typeof a) throw new to("Expected a function");
                if (o && !s && "wrapper" == gr(a)) var s = new i([], !0);
              }

              for (r = s ? r : n; ++r < n;) {
                var a = e[r],
                    o = gr(a),
                    u = "wrapper" == o ? fa(a) : W,
                    s = u && Cr(u[0]) && 424 == u[1] && !u[4].length && 1 == u[9] ? s[gr(u[0])].apply(s, u[3]) : 1 == a.length && Cr(a) ? s[o]() : s.thru(a);
              }

              return function () {
                var t = arguments,
                    r = t[0];
                if (s && 1 == t.length && os(r)) return s.plant(r).value();

                for (var i = 0, t = n ? e[i].apply(this, t) : r; ++i < n;) {
                  t = e[i].call(this, t);
                }

                return t;
              };
            });
          }

          function Yn(t, e, n, r, i, o, a, s, u, c) {
            function l() {
              for (var v = arguments.length, y = $i(v), x = v; x--;) {
                y[x] = arguments[x];
              }

              if (m) {
                var w,
                    b = vr(l),
                    x = y.length;

                for (w = 0; x--;) {
                  y[x] === b && ++w;
                }
              }

              if (r && (y = In(y, r, i, m)), o && (y = kn(y, o, a, m)), v -= w, m && v < c) return b = j(y, b), ir(t, e, Yn, l.placeholder, n, y, b, s, u, c - v);

              if (b = f ? n : this, x = p ? b[t] : t, v = y.length, s) {
                w = y.length;

                for (var _ = Bo(s.length, w), E = zn(y); _--;) {
                  var M = s[_];
                  y[_] = Sr(M, w) ? E[M] : W;
                }
              } else d && 1 < v && y.reverse();

              return h && u < v && (y.length = u), this && this !== Gt && this instanceof l && (x = g || $n(x)), x.apply(b, y);
            }

            var h = 128 & e,
                f = 1 & e,
                p = 2 & e,
                m = 24 & e,
                d = 512 & e,
                g = p ? W : $n(t);
            return l;
          }

          function Kn(t, e) {
            return function (n, r) {
              return Re(n, t, e(r));
            };
          }

          function Jn(t, e) {
            return function (n, r) {
              var i;
              if (n === W && r === W) return e;

              if (n !== W && (i = n), r !== W) {
                if (i === W) return r;
                "string" == typeof n || "string" == typeof r ? (n = yn(n), r = yn(r)) : (n = vn(n), r = vn(r)), i = t(n, r);
              }

              return i;
            };
          }

          function Qn(t) {
            return pr(function (e) {
              return e = p(e, P(yr())), sn(function (n) {
                var r = this;
                return t(e, function (t) {
                  return o(t, r, n);
                });
              });
            });
          }

          function tr(t, e) {
            e = e === W ? " " : yn(e);
            var n = e.length;
            return 2 > n ? n ? an(e, t) : e : (n = an(e, Ao(t / q(e))), kt.test(e) ? An(H(n), 0, t).join("") : n.slice(0, t));
          }

          function er(t, e, n, r) {
            function i() {
              for (var e = -1, u = arguments.length, c = -1, l = r.length, h = $i(l + u), f = this && this !== Gt && this instanceof i ? s : t; ++c < l;) {
                h[c] = r[c];
              }

              for (; u--;) {
                h[c++] = arguments[++e];
              }

              return o(f, a ? n : this, h);
            }

            var a = 1 & e,
                s = $n(t);
            return i;
          }

          function nr(t) {
            return function (e, n, r) {
              r && "number" != typeof r && Ar(e, n, r) && (n = r = W), e = Ei(e), n === W ? (n = e, e = 0) : n = Ei(n), r = r === W ? e < n ? 1 : -1 : Ei(r);
              var i = -1;
              n = zo(Ao((n - e) / (r || 1)), 0);

              for (var o = $i(n); n--;) {
                o[t ? n : ++i] = e, e += r;
              }

              return o;
            };
          }

          function rr(t) {
            return function (e, n) {
              return "string" == typeof e && "string" == typeof n || (e = Ni(e), n = Ni(n)), t(e, n);
            };
          }

          function ir(t, e, n, r, i, o, a, s, u, c) {
            var l = 8 & e,
                h = l ? a : W;
            a = l ? W : a;
            var f = l ? o : W;
            return o = l ? W : o, e = (e | (l ? 32 : 64)) & ~(l ? 64 : 32), 4 & e || (e &= -4), i = [t, e, i, f, h, o, a, s, u, c], n = n.apply(W, i), Cr(t) && va(n, i), n.placeholder = r, kr(n, t, e);
          }

          function or(t) {
            var e = Yi[t];
            return function (t, n) {
              if (t = Ni(t), n = null == n ? 0 : Bo(Mi(n), 292)) {
                var r = (Ai(t) + "e").split("e"),
                    r = e(r[0] + "e" + (+r[1] + n)),
                    r = (Ai(r) + "e").split("e");
                return +(r[0] + "e" + (+r[1] - n));
              }

              return e(t);
            };
          }

          function ar(t) {
            return function (e) {
              var n = da(e);
              return "[object Map]" == n ? L(e) : "[object Set]" == n ? U(e) : C(e, t(e));
            };
          }

          function sr(t, e, n, r, i, o, a, s) {
            var u = 2 & e;
            if (!u && "function" != typeof t) throw new to("Expected a function");
            var c = r ? r.length : 0;

            if (c || (e &= -97, r = i = W), a = a === W ? a : zo(Mi(a), 0), s = s === W ? s : Mi(s), c -= i ? i.length : 0, 64 & e) {
              var l = r,
                  h = i;
              r = i = W;
            }

            var f = u ? W : fa(t);
            return o = [t, e, n, r, i, l, h, o, a, s], f && (n = o[1], t = f[1], e = n | t, r = 128 == t && 8 == n || 128 == t && 256 == n && o[7].length <= f[8] || 384 == t && f[7].length <= f[8] && 8 == n, 131 > e || r) && (1 & t && (o[2] = f[2], e |= 1 & n ? 0 : 4), (n = f[3]) && (r = o[3], o[3] = r ? In(r, n, f[4]) : n, o[4] = r ? j(o[3], "__lodash_placeholder__") : f[4]), (n = f[5]) && (r = o[5], o[5] = r ? kn(r, n, f[6]) : n, o[6] = r ? j(o[5], "__lodash_placeholder__") : f[6]), (n = f[7]) && (o[7] = n), 128 & t && (o[8] = null == o[8] ? f[8] : Bo(o[8], f[8])), null == o[9] && (o[9] = f[9]), o[0] = f[0], o[1] = e), t = o[0], e = o[1], n = o[2], r = o[3], i = o[4], s = o[9] = o[9] === W ? u ? 0 : t.length : zo(o[9] - c, 0), !s && 24 & e && (e &= -25), kr((f ? ua : va)(e && 1 != e ? 8 == e || 16 == e ? Vn(t, e, s) : 32 != e && 33 != e || i.length ? Yn.apply(W, o) : er(t, e, n, r) : Hn(t, e, n), o), t, e);
          }

          function ur(t, e, n, r) {
            return t === W || ci(t, no[n]) && !oo.call(r, n) ? e : t;
          }

          function cr(t, e, n, r, i, o) {
            return gi(t) && gi(e) && (o.set(e, t), Ye(t, e, W, cr, o), o.delete(e)), t;
          }

          function lr(t) {
            return xi(t) ? W : t;
          }

          function hr(t, e, n, r, i, o) {
            var a = 1 & n,
                s = t.length,
                u = e.length;
            if (s != u && !(a && u > s)) return !1;
            if ((u = o.get(t)) && o.get(e)) return u == e;
            var u = -1,
                c = !0,
                l = 2 & n ? new Rt() : W;

            for (o.set(t, e), o.set(e, t); ++u < s;) {
              var h = t[u],
                  f = e[u];
              if (r) var p = a ? r(f, h, u, e, t, o) : r(h, f, u, t, e, o);

              if (p !== W) {
                if (p) continue;
                c = !1;
                break;
              }

              if (l) {
                if (!v(e, function (t, e) {
                  if (!I(l, e) && (h === t || i(h, t, n, r, o))) return l.push(e);
                })) {
                  c = !1;
                  break;
                }
              } else if (h !== f && !i(h, f, n, r, o)) {
                c = !1;
                break;
              }
            }

            return o.delete(t), o.delete(e), c;
          }

          function fr(t, e, n, r, i, o, a) {
            switch (n) {
              case "[object DataView]":
                if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) break;
                t = t.buffer, e = e.buffer;

              case "[object ArrayBuffer]":
                if (t.byteLength != e.byteLength || !o(new mo(t), new mo(e))) break;
                return !0;

              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return ci(+t, +e);

              case "[object Error]":
                return t.name == e.name && t.message == e.message;

              case "[object RegExp]":
              case "[object String]":
                return t == e + "";

              case "[object Map]":
                var s = L;

              case "[object Set]":
                if (s || (s = F), t.size != e.size && !(1 & r)) break;
                return (n = a.get(t)) ? n == e : (r |= 2, a.set(t, e), e = hr(s(t), s(e), r, i, o, a), a.delete(t), e);

              case "[object Symbol]":
                if (ea) return ea.call(t) == ea.call(e);
            }

            return !1;
          }

          function pr(t) {
            return xa(Ir(t, W, Hr), t + "");
          }

          function mr(t) {
            return Ne(t, Pi, pa);
          }

          function dr(t) {
            return Ne(t, Ri, ma);
          }

          function gr(t) {
            for (var e = t.name + "", n = Zo[e], r = oo.call(Zo, e) ? n.length : 0; r--;) {
              var i = n[r],
                  o = i.func;
              if (null == o || o == t) return i.name;
            }

            return e;
          }

          function vr(t) {
            return (oo.call(n, "placeholder") ? n : t).placeholder;
          }

          function yr() {
            var t = n.iteratee || Fi,
                t = t === Fi ? We : t;
            return arguments.length ? t(arguments[0], arguments[1]) : t;
          }

          function xr(t, e) {
            var n = t.__data__,
                r = typeof e;
            return ("string" == r || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== e : null === e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
          }

          function wr(t) {
            for (var e = Pi(t), n = e.length; n--;) {
              var r = e[n],
                  i = t[r];
              e[n] = [r, i, i === i && !gi(i)];
            }

            return e;
          }

          function br(t, e) {
            var n = null == t ? W : t[e];
            return Fe(n) ? n : W;
          }

          function _r(t, e, n) {
            e = Sn(e, t);

            for (var r = -1, i = e.length, o = !1; ++r < i;) {
              var a = Lr(e[r]);
              if (!(o = null != t && n(t, a))) break;
              t = t[a];
            }

            return o || ++r != i ? o : (i = null == t ? 0 : t.length, !!i && di(i) && Sr(a, i) && (os(t) || is(t)));
          }

          function Er(t) {
            var e = t.length,
                n = new t.constructor(e);
            return e && "string" == typeof t[0] && oo.call(t, "index") && (n.index = t.index, n.input = t.input), n;
          }

          function Mr(t) {
            return "function" != typeof t.constructor || Pr(t) ? {} : ra(vo(t));
          }

          function Tr(t, e, n) {
            var r = t.constructor;

            switch (e) {
              case "[object ArrayBuffer]":
                return Cn(t);

              case "[object Boolean]":
              case "[object Date]":
                return new r(+t);

              case "[object DataView]":
                return e = n ? Cn(t.buffer) : t.buffer, new t.constructor(e, t.byteOffset, t.byteLength);

              case "[object Float32Array]":
              case "[object Float64Array]":
              case "[object Int8Array]":
              case "[object Int16Array]":
              case "[object Int32Array]":
              case "[object Uint8Array]":
              case "[object Uint8ClampedArray]":
              case "[object Uint16Array]":
              case "[object Uint32Array]":
                return Pn(t, n);

              case "[object Map]":
                return new r();

              case "[object Number]":
              case "[object String]":
                return new r(t);

              case "[object RegExp]":
                return e = new t.constructor(t.source, yt.exec(t)), e.lastIndex = t.lastIndex, e;

              case "[object Set]":
                return new r();

              case "[object Symbol]":
                return ea ? Ki(ea.call(t)) : {};
            }
          }

          function Nr(t) {
            return os(t) || is(t) || !!(bo && t && t[bo]);
          }

          function Sr(t, e) {
            var n = typeof t;
            return e = null == e ? 9007199254740991 : e, !!e && ("number" == n || "symbol" != n && Et.test(t)) && -1 < t && 0 == t % 1 && t < e;
          }

          function Ar(t, e, n) {
            if (!gi(n)) return !1;
            var r = typeof e;
            return !!("number" == r ? li(n) && Sr(e, n.length) : "string" == r && e in n) && ci(n[e], t);
          }

          function Or(t, e) {
            if (os(t)) return !1;
            var n = typeof t;
            return !("number" != n && "symbol" != n && "boolean" != n && null != t && !bi(t)) || ot.test(t) || !it.test(t) || null != e && t in Ki(e);
          }

          function Cr(t) {
            var e = gr(t),
                r = n[e];
            return "function" == typeof r && e in T.prototype && (t === r || (e = fa(r), !!e && t === e[0]));
          }

          function Pr(t) {
            var e = t && t.constructor;
            return t === ("function" == typeof e && e.prototype || no);
          }

          function Rr(t, e) {
            return function (n) {
              return null != n && n[t] === e && (e !== W || t in Ki(n));
            };
          }

          function Ir(t, e, n) {
            return e = zo(e === W ? t.length - 1 : e, 0), function () {
              for (var r = arguments, i = -1, a = zo(r.length - e, 0), s = $i(a); ++i < a;) {
                s[i] = r[e + i];
              }

              for (i = -1, a = $i(e + 1); ++i < e;) {
                a[i] = r[i];
              }

              return a[e] = n(s), o(t, this, a);
            };
          }

          function kr(t, e, n) {
            var r = e + "";
            e = xa;
            var i,
                o = jr;
            return i = (i = r.match(pt)) ? i[1].split(mt) : [], n = o(i, n), (o = n.length) && (i = o - 1, n[i] = (1 < o ? "& " : "") + n[i], n = n.join(2 < o ? ", " : " "), r = r.replace(ft, "{\n/* [wrapped with " + n + "] */\n")), e(t, r);
          }

          function zr(t) {
            var e = 0,
                n = 0;
            return function () {
              var r = Lo(),
                  i = 16 - (r - n);

              if (n = r, 0 < i) {
                if (800 <= ++e) return arguments[0];
              } else e = 0;

              return t.apply(W, arguments);
            };
          }

          function Br(t, e) {
            var n = -1,
                r = t.length,
                i = r - 1;

            for (e = e === W ? r : e; ++n < e;) {
              var r = on(n, i),
                  o = t[r];
              t[r] = t[n], t[n] = o;
            }

            return t.length = e, t;
          }

          function Lr(t) {
            if ("string" == typeof t || bi(t)) return t;
            var e = t + "";
            return "0" == e && 1 / t == -G ? "-0" : e;
          }

          function Dr(t) {
            if (null != t) {
              try {
                return io.call(t);
              } catch (t) {}

              return t + "";
            }

            return "";
          }

          function jr(t, e) {
            return s(V, function (n) {
              var r = "_." + n[0];
              e & n[1] && !h(t, r) && t.push(r);
            }), t.sort();
          }

          function Fr(t) {
            if (t instanceof T) return t.clone();
            var e = new i(t.__wrapped__, t.__chain__);
            return e.__actions__ = zn(t.__actions__), e.__index__ = t.__index__, e.__values__ = t.__values__, e;
          }

          function Ur(t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n = null == n ? 0 : Mi(n), 0 > n && (n = zo(r + n, 0)), x(t, yr(e, 3), n)) : -1;
          }

          function qr(t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = r - 1;
            return n !== W && (i = Mi(n), i = 0 > n ? zo(r + i, 0) : Bo(i, r - 1)), x(t, yr(e, 3), i, !0);
          }

          function Hr(t) {
            return (null == t ? 0 : t.length) ? be(t, 1) : [];
          }

          function Wr(t) {
            return t && t.length ? t[0] : W;
          }

          function Gr(t) {
            var e = null == t ? 0 : t.length;
            return e ? t[e - 1] : W;
          }

          function $r(t, e) {
            return t && t.length && e && e.length ? nn(t, e) : t;
          }

          function Vr(t) {
            return null == t ? t : Fo.call(t);
          }

          function Zr(t) {
            if (!t || !t.length) return [];
            var e = 0;
            return t = l(t, function (t) {
              if (hi(t)) return e = zo(t.length, e), !0;
            }), O(e, function (e) {
              return p(t, M(e));
            });
          }

          function Xr(t, e) {
            if (!t || !t.length) return [];
            var n = Zr(t);
            return null == e ? n : p(n, function (t) {
              return o(e, W, t);
            });
          }

          function Yr(t) {
            return t = n(t), t.__chain__ = !0, t;
          }

          function Kr(t, e) {
            return e(t);
          }

          function Jr() {
            return this;
          }

          function Qr(t, e) {
            return (os(t) ? s : ia)(t, yr(e, 3));
          }

          function ti(t, e) {
            return (os(t) ? u : oa)(t, yr(e, 3));
          }

          function ei(t, e) {
            return (os(t) ? p : Ve)(t, yr(e, 3));
          }

          function ni(t, e, n) {
            return e = n ? W : e, e = t && null == e ? t.length : e, sr(t, 128, W, W, W, W, e);
          }

          function ri(t, e) {
            var n;
            if ("function" != typeof e) throw new to("Expected a function");
            return t = Mi(t), function () {
              return 0 < --t && (n = e.apply(this, arguments)), 1 >= t && (e = W), n;
            };
          }

          function ii(t, e, n) {
            return e = n ? W : e, t = sr(t, 8, W, W, W, W, W, e), t.placeholder = ii.placeholder, t;
          }

          function oi(t, e, n) {
            return e = n ? W : e, t = sr(t, 16, W, W, W, W, W, e), t.placeholder = oi.placeholder, t;
          }

          function ai(t, e, n) {
            function r(e) {
              var n = u,
                  r = c;
              return u = c = W, m = e, h = t.apply(r, n);
            }

            function i(t) {
              var n = t - p;
              return t -= m, p === W || n >= e || 0 > n || g && t >= l;
            }

            function o() {
              var t = Va();
              if (i(t)) return a(t);
              var n,
                  r = ya;
              n = t - m, t = e - (t - p), n = g ? Bo(t, l - n) : t, f = r(o, n);
            }

            function a(t) {
              return f = W, v && u ? r(t) : (u = c = W, h);
            }

            function s() {
              var t = Va(),
                  n = i(t);

              if (u = arguments, c = this, p = t, n) {
                if (f === W) return m = t = p, f = ya(o, e), d ? r(t) : h;
                if (g) return f = ya(o, e), r(p);
              }

              return f === W && (f = ya(o, e)), h;
            }

            var u,
                c,
                l,
                h,
                f,
                p,
                m = 0,
                d = !1,
                g = !1,
                v = !0;
            if ("function" != typeof t) throw new to("Expected a function");
            return e = Ni(e) || 0, gi(n) && (d = !!n.leading, l = (g = "maxWait" in n) ? zo(Ni(n.maxWait) || 0, e) : l, v = "trailing" in n ? !!n.trailing : v), s.cancel = function () {
              f !== W && la(f), m = 0, u = p = c = f = W;
            }, s.flush = function () {
              return f === W ? h : a(Va());
            }, s;
          }

          function si(t, e) {
            function n() {
              var r = arguments,
                  i = e ? e.apply(this, r) : r[0],
                  o = n.cache;
              return o.has(i) ? o.get(i) : (r = t.apply(this, r), n.cache = o.set(i, r) || o, r);
            }

            if ("function" != typeof t || null != e && "function" != typeof e) throw new to("Expected a function");
            return n.cache = new (si.Cache || Ot)(), n;
          }

          function ui(t) {
            if ("function" != typeof t) throw new to("Expected a function");
            return function () {
              var e = arguments;

              switch (e.length) {
                case 0:
                  return !t.call(this);

                case 1:
                  return !t.call(this, e[0]);

                case 2:
                  return !t.call(this, e[0], e[1]);

                case 3:
                  return !t.call(this, e[0], e[1], e[2]);
              }

              return !t.apply(this, e);
            };
          }

          function ci(t, e) {
            return t === e || t !== t && e !== e;
          }

          function li(t) {
            return null != t && di(t.length) && !pi(t);
          }

          function hi(t) {
            return vi(t) && li(t);
          }

          function fi(t) {
            if (!vi(t)) return !1;
            var e = Se(t);
            return "[object Error]" == e || "[object DOMException]" == e || "string" == typeof t.message && "string" == typeof t.name && !xi(t);
          }

          function pi(t) {
            return !!gi(t) && (t = Se(t), "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t);
          }

          function mi(t) {
            return "number" == typeof t && t == Mi(t);
          }

          function di(t) {
            return "number" == typeof t && -1 < t && 0 == t % 1 && 9007199254740991 >= t;
          }

          function gi(t) {
            var e = typeof t;
            return null != t && ("object" == e || "function" == e);
          }

          function vi(t) {
            return null != t && "object" == typeof t;
          }

          function yi(t) {
            return "number" == typeof t || vi(t) && "[object Number]" == Se(t);
          }

          function xi(t) {
            return !(!vi(t) || "[object Object]" != Se(t)) && (t = vo(t), null === t || (t = oo.call(t, "constructor") && t.constructor, "function" == typeof t && t instanceof t && io.call(t) == co));
          }

          function wi(t) {
            return "string" == typeof t || !os(t) && vi(t) && "[object String]" == Se(t);
          }

          function bi(t) {
            return "symbol" == typeof t || vi(t) && "[object Symbol]" == Se(t);
          }

          function _i(t) {
            if (!t) return [];
            if (li(t)) return wi(t) ? H(t) : zn(t);

            if (_o && t[_o]) {
              t = t[_o]();

              for (var e, n = []; !(e = t.next()).done;) {
                n.push(e.value);
              }

              return n;
            }

            return e = da(t), ("[object Map]" == e ? L : "[object Set]" == e ? F : ki)(t);
          }

          function Ei(t) {
            return t ? (t = Ni(t), t === G || t === -G ? 1.7976931348623157e308 * (0 > t ? -1 : 1) : t === t ? t : 0) : 0 === t ? t : 0;
          }

          function Mi(t) {
            t = Ei(t);
            var e = t % 1;
            return t === t ? e ? t - e : t : 0;
          }

          function Ti(t) {
            return t ? fe(Mi(t), 0, 4294967295) : 0;
          }

          function Ni(t) {
            if ("number" == typeof t) return t;
            if (bi(t)) return $;
            if (gi(t) && (t = "function" == typeof t.valueOf ? t.valueOf() : t, t = gi(t) ? t + "" : t), "string" != typeof t) return 0 === t ? t : +t;
            t = t.replace(ct, "");
            var e = wt.test(t);
            return e || _t.test(t) ? qt(t.slice(2), e ? 2 : 8) : xt.test(t) ? $ : +t;
          }

          function Si(t) {
            return Bn(t, Ri(t));
          }

          function Ai(t) {
            return null == t ? "" : yn(t);
          }

          function Oi(t, e, n) {
            return t = null == t ? W : Te(t, e), t === W ? n : t;
          }

          function Ci(t, e) {
            return null != t && _r(t, e, Ce);
          }

          function Pi(t) {
            return li(t) ? Ft(t) : Ge(t);
          }

          function Ri(t) {
            if (li(t)) t = Ft(t, !0);else if (gi(t)) {
              var e,
                  n = Pr(t),
                  r = [];

              for (e in t) {
                ("constructor" != e || !n && oo.call(t, e)) && r.push(e);
              }

              t = r;
            } else {
              if (e = [], null != t) for (n in Ki(t)) {
                e.push(n);
              }
              t = e;
            }
            return t;
          }

          function Ii(t, e) {
            if (null == t) return {};
            var n = p(dr(t), function (t) {
              return [t];
            });
            return e = yr(e), tn(t, n, function (t, n) {
              return e(t, n[0]);
            });
          }

          function ki(t) {
            return null == t ? [] : R(t, Pi(t));
          }

          function zi(t) {
            return Ds(Ai(t).toLowerCase());
          }

          function Bi(t) {
            return (t = Ai(t)) && t.replace(Mt, re).replace(Pt, "");
          }

          function Li(t, e, n) {
            return t = Ai(t), e = n ? W : e, e === W ? zt.test(t) ? t.match(It) || [] : t.match(dt) || [] : t.match(e) || [];
          }

          function Di(t) {
            return function () {
              return t;
            };
          }

          function ji(t) {
            return t;
          }

          function Fi(t) {
            return We("function" == typeof t ? t : pe(t, 1));
          }

          function Ui(t, e, n) {
            var r = Pi(e),
                i = Me(e, r);
            null != n || gi(e) && (i.length || !r.length) || (n = e, e = t, t = this, i = Me(e, Pi(e)));
            var o = !(gi(n) && "chain" in n && !n.chain),
                a = pi(t);
            return s(i, function (n) {
              var r = e[n];
              t[n] = r, a && (t.prototype[n] = function () {
                var e = this.__chain__;

                if (o || e) {
                  var n = t(this.__wrapped__);
                  return (n.__actions__ = zn(this.__actions__)).push({
                    func: r,
                    args: arguments,
                    thisArg: t
                  }), n.__chain__ = e, n;
                }

                return r.apply(t, m([this.value()], arguments));
              });
            }), t;
          }

          function qi() {}

          function Hi(t) {
            return Or(t) ? M(Lr(t)) : en(t);
          }

          function Wi() {
            return [];
          }

          function Gi() {
            return !1;
          }

          e = null == e ? Gt : ae.defaults(Gt.Object(), e, ae.pick(Gt, Bt));

          var $i = e.Array,
              Vi = e.Date,
              Zi = e.Error,
              Xi = e.Function,
              Yi = e.Math,
              Ki = e.Object,
              Ji = e.RegExp,
              Qi = e.String,
              to = e.TypeError,
              eo = $i.prototype,
              no = Ki.prototype,
              ro = e["__core-js_shared__"],
              io = Xi.prototype.toString,
              oo = no.hasOwnProperty,
              ao = 0,
              so = function () {
            var t = /[^.]+$/.exec(ro && ro.keys && ro.keys.IE_PROTO || "");
            return t ? "Symbol(src)_1." + t : "";
          }(),
              uo = no.toString,
              co = io.call(Ki),
              lo = Gt._,
              ho = Ji("^" + io.call(oo).replace(st, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              fo = Zt ? e.Buffer : W,
              po = e.Symbol,
              mo = e.Uint8Array,
              go = fo ? fo.f : W,
              vo = D(Ki.getPrototypeOf, Ki),
              yo = Ki.create,
              xo = no.propertyIsEnumerable,
              wo = eo.splice,
              bo = po ? po.isConcatSpreadable : W,
              _o = po ? po.iterator : W,
              Eo = po ? po.toStringTag : W,
              Mo = function () {
            try {
              var t = br(Ki, "defineProperty");
              return t({}, "", {}), t;
            } catch (t) {}
          }(),
              To = e.clearTimeout !== Gt.clearTimeout && e.clearTimeout,
              No = Vi && Vi.now !== Gt.Date.now && Vi.now,
              So = e.setTimeout !== Gt.setTimeout && e.setTimeout,
              Ao = Yi.ceil,
              Oo = Yi.floor,
              Co = Ki.getOwnPropertySymbols,
              Po = fo ? fo.isBuffer : W,
              Ro = e.isFinite,
              Io = eo.join,
              ko = D(Ki.keys, Ki),
              zo = Yi.max,
              Bo = Yi.min,
              Lo = Vi.now,
              Do = e.parseInt,
              jo = Yi.random,
              Fo = eo.reverse,
              Uo = br(e, "DataView"),
              qo = br(e, "Map"),
              Ho = br(e, "Promise"),
              Wo = br(e, "Set"),
              Go = br(e, "WeakMap"),
              $o = br(Ki, "create"),
              Vo = Go && new Go(),
              Zo = {},
              Xo = Dr(Uo),
              Yo = Dr(qo),
              Ko = Dr(Ho),
              Jo = Dr(Wo),
              Qo = Dr(Go),
              ta = po ? po.prototype : W,
              ea = ta ? ta.valueOf : W,
              na = ta ? ta.toString : W,
              ra = function () {
            function t() {}

            return function (e) {
              return gi(e) ? yo ? yo(e) : (t.prototype = e, e = new t(), t.prototype = W, e) : {};
            };
          }();

          n.templateSettings = {
            escape: et,
            evaluate: nt,
            interpolate: rt,
            variable: "",
            imports: {
              _: n
            }
          }, n.prototype = r.prototype, n.prototype.constructor = n, i.prototype = ra(r.prototype), i.prototype.constructor = i, T.prototype = ra(r.prototype), T.prototype.constructor = T, St.prototype.clear = function () {
            this.__data__ = $o ? $o(null) : {}, this.size = 0;
          }, St.prototype.delete = function (t) {
            return t = this.has(t) && delete this.__data__[t], this.size -= t ? 1 : 0, t;
          }, St.prototype.get = function (t) {
            var e = this.__data__;
            return $o ? (t = e[t], "__lodash_hash_undefined__" === t ? W : t) : oo.call(e, t) ? e[t] : W;
          }, St.prototype.has = function (t) {
            var e = this.__data__;
            return $o ? e[t] !== W : oo.call(e, t);
          }, St.prototype.set = function (t, e) {
            var n = this.__data__;
            return this.size += this.has(t) ? 0 : 1, n[t] = $o && e === W ? "__lodash_hash_undefined__" : e, this;
          }, At.prototype.clear = function () {
            this.__data__ = [], this.size = 0;
          }, At.prototype.delete = function (t) {
            var e = this.__data__;
            return t = ne(e, t), !(0 > t || (t == e.length - 1 ? e.pop() : wo.call(e, t, 1), --this.size, 0));
          }, At.prototype.get = function (t) {
            var e = this.__data__;
            return t = ne(e, t), 0 > t ? W : e[t][1];
          }, At.prototype.has = function (t) {
            return -1 < ne(this.__data__, t);
          }, At.prototype.set = function (t, e) {
            var n = this.__data__,
                r = ne(n, t);
            return 0 > r ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
          }, Ot.prototype.clear = function () {
            this.size = 0, this.__data__ = {
              hash: new St(),
              map: new (qo || At)(),
              string: new St()
            };
          }, Ot.prototype.delete = function (t) {
            return t = xr(this, t).delete(t), this.size -= t ? 1 : 0, t;
          }, Ot.prototype.get = function (t) {
            return xr(this, t).get(t);
          }, Ot.prototype.has = function (t) {
            return xr(this, t).has(t);
          }, Ot.prototype.set = function (t, e) {
            var n = xr(this, t),
                r = n.size;
            return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
          }, Rt.prototype.add = Rt.prototype.push = function (t) {
            return this.__data__.set(t, "__lodash_hash_undefined__"), this;
          }, Rt.prototype.has = function (t) {
            return this.__data__.has(t);
          }, jt.prototype.clear = function () {
            this.__data__ = new At(), this.size = 0;
          }, jt.prototype.delete = function (t) {
            var e = this.__data__;
            return t = e.delete(t), this.size = e.size, t;
          }, jt.prototype.get = function (t) {
            return this.__data__.get(t);
          }, jt.prototype.has = function (t) {
            return this.__data__.has(t);
          }, jt.prototype.set = function (t, e) {
            var n = this.__data__;

            if (n instanceof At) {
              var r = n.__data__;
              if (!qo || 199 > r.length) return r.push([t, e]), this.size = ++n.size, this;
              n = this.__data__ = new Ot(r);
            }

            return n.set(t, e), this.size = n.size, this;
          };

          var ia = Un(_e),
              oa = Un(Ee, !0),
              aa = qn(),
              sa = qn(!0),
              ua = Vo ? function (t, e) {
            return Vo.set(t, e), t;
          } : ji,
              ca = Mo ? function (t, e) {
            return Mo(t, "toString", {
              configurable: !0,
              enumerable: !1,
              value: Di(e),
              writable: !0
            });
          } : ji,
              la = To || function (t) {
            return Gt.clearTimeout(t);
          },
              ha = Wo && 1 / F(new Wo([, -0]))[1] == G ? function (t) {
            return new Wo(t);
          } : qi,
              fa = Vo ? function (t) {
            return Vo.get(t);
          } : qi,
              pa = Co ? function (t) {
            return null == t ? [] : (t = Ki(t), l(Co(t), function (e) {
              return xo.call(t, e);
            }));
          } : Wi,
              ma = Co ? function (t) {
            for (var e = []; t;) {
              m(e, pa(t)), t = vo(t);
            }

            return e;
          } : Wi,
              da = Se;

          (Uo && "[object DataView]" != da(new Uo(new ArrayBuffer(1))) || qo && "[object Map]" != da(new qo()) || Ho && "[object Promise]" != da(Ho.resolve()) || Wo && "[object Set]" != da(new Wo()) || Go && "[object WeakMap]" != da(new Go())) && (da = function da(t) {
            var e = Se(t);
            if (t = (t = "[object Object]" == e ? t.constructor : W) ? Dr(t) : "") switch (t) {
              case Xo:
                return "[object DataView]";

              case Yo:
                return "[object Map]";

              case Ko:
                return "[object Promise]";

              case Jo:
                return "[object Set]";

              case Qo:
                return "[object WeakMap]";
            }
            return e;
          });

          var ga = ro ? pi : Gi,
              va = zr(ua),
              ya = So || function (t, e) {
            return Gt.setTimeout(t, e);
          },
              xa = zr(ca),
              wa = function (t) {
            t = si(t, function (t) {
              return 500 === e.size && e.clear(), t;
            });
            var e = t.cache;
            return t;
          }(function (t) {
            var e = [];
            return 46 === t.charCodeAt(0) && e.push(""), t.replace(at, function (t, n, r, i) {
              e.push(r ? i.replace(gt, "$1") : n || t);
            }), e;
          }),
              ba = sn(function (t, e) {
            return hi(t) ? ve(t, be(e, 1, hi, !0)) : [];
          }),
              _a = sn(function (t, e) {
            var n = Gr(e);
            return hi(n) && (n = W), hi(t) ? ve(t, be(e, 1, hi, !0), yr(n, 2)) : [];
          }),
              Ea = sn(function (t, e) {
            var n = Gr(e);
            return hi(n) && (n = W), hi(t) ? ve(t, be(e, 1, hi, !0), W, n) : [];
          }),
              Ma = sn(function (t) {
            var e = p(t, Tn);
            return e.length && e[0] === t[0] ? Pe(e) : [];
          }),
              Ta = sn(function (t) {
            var e = Gr(t),
                n = p(t, Tn);
            return e === Gr(n) ? e = W : n.pop(), n.length && n[0] === t[0] ? Pe(n, yr(e, 2)) : [];
          }),
              Na = sn(function (t) {
            var e = Gr(t),
                n = p(t, Tn);
            return (e = "function" == typeof e ? e : W) && n.pop(), n.length && n[0] === t[0] ? Pe(n, W, e) : [];
          }),
              Sa = sn($r),
              Aa = pr(function (t, e) {
            var n = null == t ? 0 : t.length,
                r = he(t, e);
            return rn(t, p(e, function (t) {
              return Sr(t, n) ? +t : t;
            }).sort(Rn)), r;
          }),
              Oa = sn(function (t) {
            return xn(be(t, 1, hi, !0));
          }),
              Ca = sn(function (t) {
            var e = Gr(t);
            return hi(e) && (e = W), xn(be(t, 1, hi, !0), yr(e, 2));
          }),
              Pa = sn(function (t) {
            var e = Gr(t),
                e = "function" == typeof e ? e : W;
            return xn(be(t, 1, hi, !0), W, e);
          }),
              Ra = sn(function (t, e) {
            return hi(t) ? ve(t, e) : [];
          }),
              Ia = sn(function (t) {
            return En(l(t, hi));
          }),
              ka = sn(function (t) {
            var e = Gr(t);
            return hi(e) && (e = W), En(l(t, hi), yr(e, 2));
          }),
              za = sn(function (t) {
            var e = Gr(t),
                e = "function" == typeof e ? e : W;
            return En(l(t, hi), W, e);
          }),
              Ba = sn(Zr),
              La = sn(function (t) {
            var e = t.length,
                e = 1 < e ? t[e - 1] : W,
                e = "function" == typeof e ? (t.pop(), e) : W;
            return Xr(t, e);
          }),
              Da = pr(function (t) {
            function e(e) {
              return he(e, t);
            }

            var n = t.length,
                r = n ? t[0] : 0,
                o = this.__wrapped__;
            return !(1 < n || this.__actions__.length) && o instanceof T && Sr(r) ? (o = o.slice(r, +r + (n ? 1 : 0)), o.__actions__.push({
              func: Kr,
              args: [e],
              thisArg: W
            }), new i(o, this.__chain__).thru(function (t) {
              return n && !t.length && t.push(W), t;
            })) : this.thru(e);
          }),
              ja = jn(function (t, e, n) {
            oo.call(t, n) ? ++t[n] : le(t, n, 1);
          }),
              Fa = Zn(Ur),
              Ua = Zn(qr),
              qa = jn(function (t, e, n) {
            oo.call(t, n) ? t[n].push(e) : le(t, n, [e]);
          }),
              Ha = sn(function (t, e, n) {
            var r = -1,
                i = "function" == typeof e,
                a = li(t) ? $i(t.length) : [];
            return ia(t, function (t) {
              a[++r] = i ? o(e, t, n) : Ie(t, e, n);
            }), a;
          }),
              Wa = jn(function (t, e, n) {
            le(t, n, e);
          }),
              Ga = jn(function (t, e, n) {
            t[n ? 0 : 1].push(e);
          }, function () {
            return [[], []];
          }),
              $a = sn(function (t, e) {
            if (null == t) return [];
            var n = e.length;
            return 1 < n && Ar(t, e[0], e[1]) ? e = [] : 2 < n && Ar(e[0], e[1], e[2]) && (e = [e[0]]), Je(t, be(e, 1), []);
          }),
              Va = No || function () {
            return Gt.Date.now();
          },
              Za = sn(function (t, e, n) {
            var r = 1;
            if (n.length) var i = j(n, vr(Za)),
                r = 32 | r;
            return sr(t, r, e, n, i);
          }),
              Xa = sn(function (t, e, n) {
            var r = 3;
            if (n.length) var i = j(n, vr(Xa)),
                r = 32 | r;
            return sr(e, r, t, n, i);
          }),
              Ya = sn(function (t, e) {
            return ge(t, 1, e);
          }),
              Ka = sn(function (t, e, n) {
            return ge(t, Ni(e) || 0, n);
          });

          si.Cache = Ot;

          var Ja = sn(function (t, e) {
            e = 1 == e.length && os(e[0]) ? p(e[0], P(yr())) : p(be(e, 1), P(yr()));
            var n = e.length;
            return sn(function (r) {
              for (var i = -1, a = Bo(r.length, n); ++i < a;) {
                r[i] = e[i].call(this, r[i]);
              }

              return o(t, this, r);
            });
          }),
              Qa = sn(function (t, e) {
            return sr(t, 32, W, e, j(e, vr(Qa)));
          }),
              ts = sn(function (t, e) {
            return sr(t, 64, W, e, j(e, vr(ts)));
          }),
              es = pr(function (t, e) {
            return sr(t, 256, W, W, W, e);
          }),
              ns = rr(Ae),
              rs = rr(function (t, e) {
            return t >= e;
          }),
              is = ke(function () {
            return arguments;
          }()) ? ke : function (t) {
            return vi(t) && oo.call(t, "callee") && !xo.call(t, "callee");
          },
              os = $i.isArray,
              as = Yt ? P(Yt) : ze,
              ss = Po || Gi,
              us = Kt ? P(Kt) : Be,
              cs = Jt ? P(Jt) : De,
              ls = Qt ? P(Qt) : Ue,
              hs = te ? P(te) : qe,
              fs = ee ? P(ee) : He,
              ps = rr($e),
              ms = rr(function (t, e) {
            return t <= e;
          }),
              ds = Fn(function (t, e) {
            if (Pr(e) || li(e)) Bn(e, Pi(e), t);else for (var n in e) {
              oo.call(e, n) && Xt(t, n, e[n]);
            }
          }),
              gs = Fn(function (t, e) {
            Bn(e, Ri(e), t);
          }),
              vs = Fn(function (t, e, n, r) {
            Bn(e, Ri(e), t, r);
          }),
              ys = Fn(function (t, e, n, r) {
            Bn(e, Pi(e), t, r);
          }),
              xs = pr(he),
              ws = sn(function (t, e) {
            t = Ki(t);
            var n = -1,
                r = e.length,
                i = 2 < r ? e[2] : W;

            for (i && Ar(e[0], e[1], i) && (r = 1); ++n < r;) {
              for (var i = e[n], o = Ri(i), a = -1, s = o.length; ++a < s;) {
                var u = o[a],
                    c = t[u];
                (c === W || ci(c, no[u]) && !oo.call(t, u)) && (t[u] = i[u]);
              }
            }

            return t;
          }),
              bs = sn(function (t) {
            return t.push(W, cr), o(Ns, W, t);
          }),
              _s = Kn(function (t, e, n) {
            null != e && "function" != typeof e.toString && (e = uo.call(e)), t[e] = n;
          }, Di(ji)),
              Es = Kn(function (t, e, n) {
            null != e && "function" != typeof e.toString && (e = uo.call(e)), oo.call(t, e) ? t[e].push(n) : t[e] = [n];
          }, yr),
              Ms = sn(Ie),
              Ts = Fn(function (t, e, n) {
            Ye(t, e, n);
          }),
              Ns = Fn(function (t, e, n, r) {
            Ye(t, e, n, r);
          }),
              Ss = pr(function (t, e) {
            var n = {};
            if (null == t) return n;
            var r = !1;
            e = p(e, function (e) {
              return e = Sn(e, t), r || (r = 1 < e.length), e;
            }), Bn(t, dr(t), n), r && (n = pe(n, 7, lr));

            for (var i = e.length; i--;) {
              wn(n, e[i]);
            }

            return n;
          }),
              As = pr(function (t, e) {
            return null == t ? {} : Qe(t, e);
          }),
              Os = ar(Pi),
              Cs = ar(Ri),
              Ps = Gn(function (t, e, n) {
            return e = e.toLowerCase(), t + (n ? zi(e) : e);
          }),
              Rs = Gn(function (t, e, n) {
            return t + (n ? "-" : "") + e.toLowerCase();
          }),
              Is = Gn(function (t, e, n) {
            return t + (n ? " " : "") + e.toLowerCase();
          }),
              ks = Wn("toLowerCase"),
              zs = Gn(function (t, e, n) {
            return t + (n ? "_" : "") + e.toLowerCase();
          }),
              Bs = Gn(function (t, e, n) {
            return t + (n ? " " : "") + Ds(e);
          }),
              Ls = Gn(function (t, e, n) {
            return t + (n ? " " : "") + e.toUpperCase();
          }),
              Ds = Wn("toUpperCase"),
              js = sn(function (t, e) {
            try {
              return o(t, W, e);
            } catch (t) {
              return fi(t) ? t : new Zi(t);
            }
          }),
              Fs = pr(function (t, e) {
            return s(e, function (e) {
              e = Lr(e), le(t, e, Za(t[e], t));
            }), t;
          }),
              Us = Xn(),
              qs = Xn(!0),
              Hs = sn(function (t, e) {
            return function (n) {
              return Ie(n, t, e);
            };
          }),
              Ws = sn(function (t, e) {
            return function (n) {
              return Ie(t, n, e);
            };
          }),
              Gs = Qn(p),
              $s = Qn(c),
              Vs = Qn(v),
              Zs = nr(),
              Xs = nr(!0),
              Ys = Jn(function (t, e) {
            return t + e;
          }, 0),
              Ks = or("ceil"),
              Js = Jn(function (t, e) {
            return t / e;
          }, 1),
              Qs = or("floor"),
              tu = Jn(function (t, e) {
            return t * e;
          }, 1),
              eu = or("round"),
              nu = Jn(function (t, e) {
            return t - e;
          }, 0);

          return n.after = function (t, e) {
            if ("function" != typeof e) throw new to("Expected a function");
            return t = Mi(t), function () {
              if (1 > --t) return e.apply(this, arguments);
            };
          }, n.ary = ni, n.assign = ds, n.assignIn = gs, n.assignInWith = vs, n.assignWith = ys, n.at = xs, n.before = ri, n.bind = Za, n.bindAll = Fs, n.bindKey = Xa, n.castArray = function () {
            if (!arguments.length) return [];
            var t = arguments[0];
            return os(t) ? t : [t];
          }, n.chain = Yr, n.chunk = function (t, e, n) {
            if (e = (n ? Ar(t, e, n) : e === W) ? 1 : zo(Mi(e), 0), n = null == t ? 0 : t.length, !n || 1 > e) return [];

            for (var r = 0, i = 0, o = $i(Ao(n / e)); r < n;) {
              o[i++] = fn(t, r, r += e);
            }

            return o;
          }, n.compact = function (t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = 0, i = []; ++e < n;) {
              var o = t[e];
              o && (i[r++] = o);
            }

            return i;
          }, n.concat = function () {
            var t = arguments.length;
            if (!t) return [];

            for (var e = $i(t - 1), n = arguments[0]; t--;) {
              e[t - 1] = arguments[t];
            }

            return m(os(n) ? zn(n) : [n], be(e, 1));
          }, n.cond = function (t) {
            var e = null == t ? 0 : t.length,
                n = yr();
            return t = e ? p(t, function (t) {
              if ("function" != typeof t[1]) throw new to("Expected a function");
              return [n(t[0]), t[1]];
            }) : [], sn(function (n) {
              for (var r = -1; ++r < e;) {
                var i = t[r];
                if (o(i[0], this, n)) return o(i[1], this, n);
              }
            });
          }, n.conforms = function (t) {
            return me(pe(t, 1));
          }, n.constant = Di, n.countBy = ja, n.create = function (t, e) {
            var n = ra(t);
            return null == e ? n : ue(n, e);
          }, n.curry = ii, n.curryRight = oi, n.debounce = ai, n.defaults = ws, n.defaultsDeep = bs, n.defer = Ya, n.delay = Ka, n.difference = ba, n.differenceBy = _a, n.differenceWith = Ea, n.drop = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === W ? 1 : Mi(e), fn(t, 0 > e ? 0 : e, r)) : [];
          }, n.dropRight = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === W ? 1 : Mi(e), e = r - e, fn(t, 0, 0 > e ? 0 : e)) : [];
          }, n.dropRightWhile = function (t, e) {
            return t && t.length ? bn(t, yr(e, 3), !0, !0) : [];
          }, n.dropWhile = function (t, e) {
            return t && t.length ? bn(t, yr(e, 3), !0) : [];
          }, n.fill = function (t, e, n, r) {
            var i = null == t ? 0 : t.length;
            if (!i) return [];

            for (n && "number" != typeof n && Ar(t, e, n) && (n = 0, r = i), i = t.length, n = Mi(n), 0 > n && (n = -n > i ? 0 : i + n), r = r === W || r > i ? i : Mi(r), 0 > r && (r += i), r = n > r ? 0 : Ti(r); n < r;) {
              t[n++] = e;
            }

            return t;
          }, n.filter = function (t, e) {
            return (os(t) ? l : we)(t, yr(e, 3));
          }, n.flatMap = function (t, e) {
            return be(ei(t, e), 1);
          }, n.flatMapDeep = function (t, e) {
            return be(ei(t, e), G);
          }, n.flatMapDepth = function (t, e, n) {
            return n = n === W ? 1 : Mi(n), be(ei(t, e), n);
          }, n.flatten = Hr, n.flattenDeep = function (t) {
            return (null == t ? 0 : t.length) ? be(t, G) : [];
          }, n.flattenDepth = function (t, e) {
            return null != t && t.length ? (e = e === W ? 1 : Mi(e), be(t, e)) : [];
          }, n.flip = function (t) {
            return sr(t, 512);
          }, n.flow = Us, n.flowRight = qs, n.fromPairs = function (t) {
            for (var e = -1, n = null == t ? 0 : t.length, r = {}; ++e < n;) {
              var i = t[e];
              r[i[0]] = i[1];
            }

            return r;
          }, n.functions = function (t) {
            return null == t ? [] : Me(t, Pi(t));
          }, n.functionsIn = function (t) {
            return null == t ? [] : Me(t, Ri(t));
          }, n.groupBy = qa, n.initial = function (t) {
            return (null == t ? 0 : t.length) ? fn(t, 0, -1) : [];
          }, n.intersection = Ma, n.intersectionBy = Ta, n.intersectionWith = Na, n.invert = _s, n.invertBy = Es, n.invokeMap = Ha, n.iteratee = Fi, n.keyBy = Wa, n.keys = Pi, n.keysIn = Ri, n.map = ei, n.mapKeys = function (t, e) {
            var n = {};
            return e = yr(e, 3), _e(t, function (t, r, i) {
              le(n, e(t, r, i), t);
            }), n;
          }, n.mapValues = function (t, e) {
            var n = {};
            return e = yr(e, 3), _e(t, function (t, r, i) {
              le(n, r, e(t, r, i));
            }), n;
          }, n.matches = function (t) {
            return Ze(pe(t, 1));
          }, n.matchesProperty = function (t, e) {
            return Xe(t, pe(e, 1));
          }, n.memoize = si, n.merge = Ts, n.mergeWith = Ns, n.method = Hs, n.methodOf = Ws, n.mixin = Ui, n.negate = ui, n.nthArg = function (t) {
            return t = Mi(t), sn(function (e) {
              return Ke(e, t);
            });
          }, n.omit = Ss, n.omitBy = function (t, e) {
            return Ii(t, ui(yr(e)));
          }, n.once = function (t) {
            return ri(2, t);
          }, n.orderBy = function (t, e, n, r) {
            return null == t ? [] : (os(e) || (e = null == e ? [] : [e]), n = r ? W : n, os(n) || (n = null == n ? [] : [n]), Je(t, e, n));
          }, n.over = Gs, n.overArgs = Ja, n.overEvery = $s, n.overSome = Vs, n.partial = Qa, n.partialRight = ts, n.partition = Ga, n.pick = As, n.pickBy = Ii, n.property = Hi, n.propertyOf = function (t) {
            return function (e) {
              return null == t ? W : Te(t, e);
            };
          }, n.pull = Sa, n.pullAll = $r, n.pullAllBy = function (t, e, n) {
            return t && t.length && e && e.length ? nn(t, e, yr(n, 2)) : t;
          }, n.pullAllWith = function (t, e, n) {
            return t && t.length && e && e.length ? nn(t, e, W, n) : t;
          }, n.pullAt = Aa, n.range = Zs, n.rangeRight = Xs, n.rearg = es, n.reject = function (t, e) {
            return (os(t) ? l : we)(t, ui(yr(e, 3)));
          }, n.remove = function (t, e) {
            var n = [];
            if (!t || !t.length) return n;
            var r = -1,
                i = [],
                o = t.length;

            for (e = yr(e, 3); ++r < o;) {
              var a = t[r];
              e(a, r, t) && (n.push(a), i.push(r));
            }

            return rn(t, i), n;
          }, n.rest = function (t, e) {
            if ("function" != typeof t) throw new to("Expected a function");
            return e = e === W ? e : Mi(e), sn(t, e);
          }, n.reverse = Vr, n.sampleSize = function (t, e, n) {
            return e = (n ? Ar(t, e, n) : e === W) ? 1 : Mi(e), (os(t) ? Wt : cn)(t, e);
          }, n.set = function (t, e, n) {
            return null == t ? t : ln(t, e, n);
          }, n.setWith = function (t, e, n, r) {
            return r = "function" == typeof r ? r : W, null == t ? t : ln(t, e, n, r);
          }, n.shuffle = function (t) {
            return (os(t) ? $t : hn)(t);
          }, n.slice = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n && "number" != typeof n && Ar(t, e, n) ? (e = 0, n = r) : (e = null == e ? 0 : Mi(e), n = n === W ? r : Mi(n)), fn(t, e, n)) : [];
          }, n.sortBy = $a, n.sortedUniq = function (t) {
            return t && t.length ? gn(t) : [];
          }, n.sortedUniqBy = function (t, e) {
            return t && t.length ? gn(t, yr(e, 2)) : [];
          }, n.split = function (t, e, n) {
            return n && "number" != typeof n && Ar(t, e, n) && (e = n = W), n = n === W ? 4294967295 : n >>> 0, n ? (t = Ai(t)) && ("string" == typeof e || null != e && !ls(e)) && (e = yn(e), !e && kt.test(t)) ? An(H(t), 0, n) : t.split(e, n) : [];
          }, n.spread = function (t, e) {
            if ("function" != typeof t) throw new to("Expected a function");
            return e = null == e ? 0 : zo(Mi(e), 0), sn(function (n) {
              var r = n[e];
              return n = An(n, 0, e), r && m(n, r), o(t, this, n);
            });
          }, n.tail = function (t) {
            var e = null == t ? 0 : t.length;
            return e ? fn(t, 1, e) : [];
          }, n.take = function (t, e, n) {
            return t && t.length ? (e = n || e === W ? 1 : Mi(e), fn(t, 0, 0 > e ? 0 : e)) : [];
          }, n.takeRight = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (e = n || e === W ? 1 : Mi(e), e = r - e, fn(t, 0 > e ? 0 : e, r)) : [];
          }, n.takeRightWhile = function (t, e) {
            return t && t.length ? bn(t, yr(e, 3), !1, !0) : [];
          }, n.takeWhile = function (t, e) {
            return t && t.length ? bn(t, yr(e, 3)) : [];
          }, n.tap = function (t, e) {
            return e(t), t;
          }, n.throttle = function (t, e, n) {
            var r = !0,
                i = !0;
            if ("function" != typeof t) throw new to("Expected a function");
            return gi(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), ai(t, e, {
              leading: r,
              maxWait: e,
              trailing: i
            });
          }, n.thru = Kr, n.toArray = _i, n.toPairs = Os, n.toPairsIn = Cs, n.toPath = function (t) {
            return os(t) ? p(t, Lr) : bi(t) ? [t] : zn(wa(Ai(t)));
          }, n.toPlainObject = Si, n.transform = function (t, e, n) {
            var r = os(t),
                i = r || ss(t) || fs(t);

            if (e = yr(e, 4), null == n) {
              var o = t && t.constructor;
              n = i ? r ? new o() : [] : gi(t) && pi(o) ? ra(vo(t)) : {};
            }

            return (i ? s : _e)(t, function (t, r, i) {
              return e(n, t, r, i);
            }), n;
          }, n.unary = function (t) {
            return ni(t, 1);
          }, n.union = Oa, n.unionBy = Ca, n.unionWith = Pa, n.uniq = function (t) {
            return t && t.length ? xn(t) : [];
          }, n.uniqBy = function (t, e) {
            return t && t.length ? xn(t, yr(e, 2)) : [];
          }, n.uniqWith = function (t, e) {
            return e = "function" == typeof e ? e : W, t && t.length ? xn(t, W, e) : [];
          }, n.unset = function (t, e) {
            return null == t || wn(t, e);
          }, n.unzip = Zr, n.unzipWith = Xr, n.update = function (t, e, n) {
            return null == t ? t : ln(t, e, Nn(n)(Te(t, e)), void 0);
          }, n.updateWith = function (t, e, n, r) {
            return r = "function" == typeof r ? r : W, null != t && (t = ln(t, e, Nn(n)(Te(t, e)), r)), t;
          }, n.values = ki, n.valuesIn = function (t) {
            return null == t ? [] : R(t, Ri(t));
          }, n.without = Ra, n.words = Li, n.wrap = function (t, e) {
            return Qa(Nn(e), t);
          }, n.xor = Ia, n.xorBy = ka, n.xorWith = za, n.zip = Ba, n.zipObject = function (t, e) {
            return Mn(t || [], e || [], Xt);
          }, n.zipObjectDeep = function (t, e) {
            return Mn(t || [], e || [], ln);
          }, n.zipWith = La, n.entries = Os, n.entriesIn = Cs, n.extend = gs, n.extendWith = vs, Ui(n, n), n.add = Ys, n.attempt = js, n.camelCase = Ps, n.capitalize = zi, n.ceil = Ks, n.clamp = function (t, e, n) {
            return n === W && (n = e, e = W), n !== W && (n = Ni(n), n = n === n ? n : 0), e !== W && (e = Ni(e), e = e === e ? e : 0), fe(Ni(t), e, n);
          }, n.clone = function (t) {
            return pe(t, 4);
          }, n.cloneDeep = function (t) {
            return pe(t, 5);
          }, n.cloneDeepWith = function (t, e) {
            return e = "function" == typeof e ? e : W, pe(t, 5, e);
          }, n.cloneWith = function (t, e) {
            return e = "function" == typeof e ? e : W, pe(t, 4, e);
          }, n.conformsTo = function (t, e) {
            return null == e || de(t, e, Pi(e));
          }, n.deburr = Bi, n.defaultTo = function (t, e) {
            return null == t || t !== t ? e : t;
          }, n.divide = Js, n.endsWith = function (t, e, n) {
            t = Ai(t), e = yn(e);
            var r = t.length,
                r = n = n === W ? r : fe(Mi(n), 0, r);
            return n -= e.length, 0 <= n && t.slice(n, r) == e;
          }, n.eq = ci, n.escape = function (t) {
            return (t = Ai(t)) && tt.test(t) ? t.replace(J, ie) : t;
          }, n.escapeRegExp = function (t) {
            return (t = Ai(t)) && ut.test(t) ? t.replace(st, "\\$&") : t;
          }, n.every = function (t, e, n) {
            var r = os(t) ? c : ye;
            return n && Ar(t, e, n) && (e = W), r(t, yr(e, 3));
          }, n.find = Fa, n.findIndex = Ur, n.findKey = function (t, e) {
            return y(t, yr(e, 3), _e);
          }, n.findLast = Ua, n.findLastIndex = qr, n.findLastKey = function (t, e) {
            return y(t, yr(e, 3), Ee);
          }, n.floor = Qs, n.forEach = Qr, n.forEachRight = ti, n.forIn = function (t, e) {
            return null == t ? t : aa(t, yr(e, 3), Ri);
          }, n.forInRight = function (t, e) {
            return null == t ? t : sa(t, yr(e, 3), Ri);
          }, n.forOwn = function (t, e) {
            return t && _e(t, yr(e, 3));
          }, n.forOwnRight = function (t, e) {
            return t && Ee(t, yr(e, 3));
          }, n.get = Oi, n.gt = ns, n.gte = rs, n.has = function (t, e) {
            return null != t && _r(t, e, Oe);
          }, n.hasIn = Ci, n.head = Wr, n.identity = ji, n.includes = function (t, e, n, r) {
            return t = li(t) ? t : ki(t), n = n && !r ? Mi(n) : 0, r = t.length, 0 > n && (n = zo(r + n, 0)), wi(t) ? n <= r && -1 < t.indexOf(e, n) : !!r && -1 < w(t, e, n);
          }, n.indexOf = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            return r ? (n = null == n ? 0 : Mi(n), 0 > n && (n = zo(r + n, 0)), w(t, e, n)) : -1;
          }, n.inRange = function (t, e, n) {
            return e = Ei(e), n === W ? (n = e, e = 0) : n = Ei(n), t = Ni(t), t >= Bo(e, n) && t < zo(e, n);
          }, n.invoke = Ms, n.isArguments = is, n.isArray = os, n.isArrayBuffer = as, n.isArrayLike = li, n.isArrayLikeObject = hi, n.isBoolean = function (t) {
            return !0 === t || !1 === t || vi(t) && "[object Boolean]" == Se(t);
          }, n.isBuffer = ss, n.isDate = us, n.isElement = function (t) {
            return vi(t) && 1 === t.nodeType && !xi(t);
          }, n.isEmpty = function (t) {
            if (null == t) return !0;
            if (li(t) && (os(t) || "string" == typeof t || "function" == typeof t.splice || ss(t) || fs(t) || is(t))) return !t.length;
            var e = da(t);
            if ("[object Map]" == e || "[object Set]" == e) return !t.size;
            if (Pr(t)) return !Ge(t).length;

            for (var n in t) {
              if (oo.call(t, n)) return !1;
            }

            return !0;
          }, n.isEqual = function (t, e) {
            return Le(t, e);
          }, n.isEqualWith = function (t, e, n) {
            var r = (n = "function" == typeof n ? n : W) ? n(t, e) : W;
            return r === W ? Le(t, e, W, n) : !!r;
          }, n.isError = fi, n.isFinite = function (t) {
            return "number" == typeof t && Ro(t);
          }, n.isFunction = pi, n.isInteger = mi, n.isLength = di, n.isMap = cs, n.isMatch = function (t, e) {
            return t === e || je(t, e, wr(e));
          }, n.isMatchWith = function (t, e, n) {
            return n = "function" == typeof n ? n : W, je(t, e, wr(e), n);
          }, n.isNaN = function (t) {
            return yi(t) && t != +t;
          }, n.isNative = function (t) {
            if (ga(t)) throw new Zi("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
            return Fe(t);
          }, n.isNil = function (t) {
            return null == t;
          }, n.isNull = function (t) {
            return null === t;
          }, n.isNumber = yi, n.isObject = gi, n.isObjectLike = vi, n.isPlainObject = xi, n.isRegExp = ls, n.isSafeInteger = function (t) {
            return mi(t) && -9007199254740991 <= t && 9007199254740991 >= t;
          }, n.isSet = hs, n.isString = wi, n.isSymbol = bi, n.isTypedArray = fs, n.isUndefined = function (t) {
            return t === W;
          }, n.isWeakMap = function (t) {
            return vi(t) && "[object WeakMap]" == da(t);
          }, n.isWeakSet = function (t) {
            return vi(t) && "[object WeakSet]" == Se(t);
          }, n.join = function (t, e) {
            return null == t ? "" : Io.call(t, e);
          }, n.kebabCase = Rs, n.last = Gr, n.lastIndexOf = function (t, e, n) {
            var r = null == t ? 0 : t.length;
            if (!r) return -1;
            var i = r;

            if (n !== W && (i = Mi(n), i = 0 > i ? zo(r + i, 0) : Bo(i, r - 1)), e === e) {
              for (n = i + 1; n-- && t[n] !== e;) {
                ;
              }

              t = n;
            } else t = x(t, _, i, !0);

            return t;
          }, n.lowerCase = Is, n.lowerFirst = ks, n.lt = ps, n.lte = ms, n.max = function (t) {
            return t && t.length ? xe(t, ji, Ae) : W;
          }, n.maxBy = function (t, e) {
            return t && t.length ? xe(t, yr(e, 2), Ae) : W;
          }, n.mean = function (t) {
            return E(t, ji);
          }, n.meanBy = function (t, e) {
            return E(t, yr(e, 2));
          }, n.min = function (t) {
            return t && t.length ? xe(t, ji, $e) : W;
          }, n.minBy = function (t, e) {
            return t && t.length ? xe(t, yr(e, 2), $e) : W;
          }, n.stubArray = Wi, n.stubFalse = Gi, n.stubObject = function () {
            return {};
          }, n.stubString = function () {
            return "";
          }, n.stubTrue = function () {
            return !0;
          }, n.multiply = tu, n.nth = function (t, e) {
            return t && t.length ? Ke(t, Mi(e)) : W;
          }, n.noConflict = function () {
            return Gt._ === this && (Gt._ = lo), this;
          }, n.noop = qi, n.now = Va, n.pad = function (t, e, n) {
            t = Ai(t);
            var r = (e = Mi(e)) ? q(t) : 0;
            return !e || r >= e ? t : (e = (e - r) / 2, tr(Oo(e), n) + t + tr(Ao(e), n));
          }, n.padEnd = function (t, e, n) {
            t = Ai(t);
            var r = (e = Mi(e)) ? q(t) : 0;
            return e && r < e ? t + tr(e - r, n) : t;
          }, n.padStart = function (t, e, n) {
            t = Ai(t);
            var r = (e = Mi(e)) ? q(t) : 0;
            return e && r < e ? tr(e - r, n) + t : t;
          }, n.parseInt = function (t, e, n) {
            return n || null == e ? e = 0 : e && (e = +e), Do(Ai(t).replace(lt, ""), e || 0);
          }, n.random = function (t, e, n) {
            if (n && "boolean" != typeof n && Ar(t, e, n) && (e = n = W), n === W && ("boolean" == typeof e ? (n = e, e = W) : "boolean" == typeof t && (n = t, t = W)), t === W && e === W ? (t = 0, e = 1) : (t = Ei(t), e === W ? (e = t, t = 0) : e = Ei(e)), t > e) {
              var r = t;
              t = e, e = r;
            }

            return n || t % 1 || e % 1 ? (n = jo(), Bo(t + n * (e - t + Ut("1e-" + ((n + "").length - 1))), e)) : on(t, e);
          }, n.reduce = function (t, e, n) {
            var r = os(t) ? d : N,
                i = 3 > arguments.length;
            return r(t, yr(e, 4), n, i, ia);
          }, n.reduceRight = function (t, e, n) {
            var r = os(t) ? g : N,
                i = 3 > arguments.length;
            return r(t, yr(e, 4), n, i, oa);
          }, n.repeat = function (t, e, n) {
            return e = (n ? Ar(t, e, n) : e === W) ? 1 : Mi(e), an(Ai(t), e);
          }, n.replace = function () {
            var t = arguments,
                e = Ai(t[0]);
            return 3 > t.length ? e : e.replace(t[1], t[2]);
          }, n.result = function (t, e, n) {
            e = Sn(e, t);
            var r = -1,
                i = e.length;

            for (i || (i = 1, t = W); ++r < i;) {
              var o = null == t ? W : t[Lr(e[r])];
              o === W && (r = i, o = n), t = pi(o) ? o.call(t) : o;
            }

            return t;
          }, n.round = eu, n.runInContext = t, n.sample = function (t) {
            return (os(t) ? Ht : un)(t);
          }, n.size = function (t) {
            if (null == t) return 0;
            if (li(t)) return wi(t) ? q(t) : t.length;
            var e = da(t);
            return "[object Map]" == e || "[object Set]" == e ? t.size : Ge(t).length;
          }, n.snakeCase = zs, n.some = function (t, e, n) {
            var r = os(t) ? v : pn;
            return n && Ar(t, e, n) && (e = W), r(t, yr(e, 3));
          }, n.sortedIndex = function (t, e) {
            return mn(t, e);
          }, n.sortedIndexBy = function (t, e, n) {
            return dn(t, e, yr(n, 2));
          }, n.sortedIndexOf = function (t, e) {
            var n = null == t ? 0 : t.length;

            if (n) {
              var r = mn(t, e);
              if (r < n && ci(t[r], e)) return r;
            }

            return -1;
          }, n.sortedLastIndex = function (t, e) {
            return mn(t, e, !0);
          }, n.sortedLastIndexBy = function (t, e, n) {
            return dn(t, e, yr(n, 2), !0);
          }, n.sortedLastIndexOf = function (t, e) {
            if (null == t ? 0 : t.length) {
              var n = mn(t, e, !0) - 1;
              if (ci(t[n], e)) return n;
            }

            return -1;
          }, n.startCase = Bs, n.startsWith = function (t, e, n) {
            return t = Ai(t), n = null == n ? 0 : fe(Mi(n), 0, t.length), e = yn(e), t.slice(n, n + e.length) == e;
          }, n.subtract = nu, n.sum = function (t) {
            return t && t.length ? A(t, ji) : 0;
          }, n.sumBy = function (t, e) {
            return t && t.length ? A(t, yr(e, 2)) : 0;
          }, n.template = function (t, e, r) {
            var i = n.templateSettings;
            r && Ar(t, e, r) && (e = W), t = Ai(t), e = vs({}, e, i, ur), r = vs({}, e.imports, i.imports, ur);
            var o,
                a,
                s = Pi(r),
                u = R(r, s),
                c = 0;
            r = e.interpolate || Tt;
            var l = "__p+='";
            r = Ji((e.escape || Tt).source + "|" + r.source + "|" + (r === rt ? vt : Tt).source + "|" + (e.evaluate || Tt).source + "|$", "g");
            var h = "sourceURL" in e ? "//# sourceURL=" + e.sourceURL + "\n" : "";
            if (t.replace(r, function (e, n, r, i, s, u) {
              return r || (r = i), l += t.slice(c, u).replace(Nt, B), n && (o = !0, l += "'+__e(" + n + ")+'"), s && (a = !0, l += "';" + s + ";\n__p+='"), r && (l += "'+((__t=(" + r + "))==null?'':__t)+'"), c = u + e.length, e;
            }), l += "';", (e = e.variable) || (l = "with(obj){" + l + "}"), l = (a ? l.replace(Z, "") : l).replace(X, "$1").replace(Y, "$1;"), l = "function(" + (e || "obj") + "){" + (e ? "" : "obj||(obj={});") + "var __t,__p=''" + (o ? ",__e=_.escape" : "") + (a ? ",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}" : ";") + l + "return __p}", e = js(function () {
              return Xi(s, h + "return " + l).apply(W, u);
            }), e.source = l, fi(e)) throw e;
            return e;
          }, n.times = function (t, e) {
            if (t = Mi(t), 1 > t || 9007199254740991 < t) return [];
            var n = 4294967295,
                r = Bo(t, 4294967295);

            for (e = yr(e), t -= 4294967295, r = O(r, e); ++n < t;) {
              e(n);
            }

            return r;
          }, n.toFinite = Ei, n.toInteger = Mi, n.toLength = Ti, n.toLower = function (t) {
            return Ai(t).toLowerCase();
          }, n.toNumber = Ni, n.toSafeInteger = function (t) {
            return t ? fe(Mi(t), -9007199254740991, 9007199254740991) : 0 === t ? t : 0;
          }, n.toString = Ai, n.toUpper = function (t) {
            return Ai(t).toUpperCase();
          }, n.trim = function (t, e, n) {
            return (t = Ai(t)) && (n || e === W) ? t.replace(ct, "") : t && (e = yn(e)) ? (t = H(t), n = H(e), e = k(t, n), n = z(t, n) + 1, An(t, e, n).join("")) : t;
          }, n.trimEnd = function (t, e, n) {
            return (t = Ai(t)) && (n || e === W) ? t.replace(ht, "") : t && (e = yn(e)) ? (t = H(t), e = z(t, H(e)) + 1, An(t, 0, e).join("")) : t;
          }, n.trimStart = function (t, e, n) {
            return (t = Ai(t)) && (n || e === W) ? t.replace(lt, "") : t && (e = yn(e)) ? (t = H(t), e = k(t, H(e)), An(t, e).join("")) : t;
          }, n.truncate = function (t, e) {
            var n = 30,
                r = "...";
            if (gi(e)) var i = "separator" in e ? e.separator : i,
                n = "length" in e ? Mi(e.length) : n,
                r = "omission" in e ? yn(e.omission) : r;
            t = Ai(t);
            var o = t.length;
            if (kt.test(t)) var a = H(t),
                o = a.length;
            if (n >= o) return t;
            if (o = n - q(r), 1 > o) return r;
            if (n = a ? An(a, 0, o).join("") : t.slice(0, o), i === W) return n + r;

            if (a && (o += n.length - o), ls(i)) {
              if (t.slice(o).search(i)) {
                var s = n;

                for (i.global || (i = Ji(i.source, Ai(yt.exec(i)) + "g")), i.lastIndex = 0; a = i.exec(s);) {
                  var u = a.index;
                }

                n = n.slice(0, u === W ? o : u);
              }
            } else t.indexOf(yn(i), o) != o && (i = n.lastIndexOf(i), -1 < i && (n = n.slice(0, i)));

            return n + r;
          }, n.unescape = function (t) {
            return (t = Ai(t)) && Q.test(t) ? t.replace(K, oe) : t;
          }, n.uniqueId = function (t) {
            var e = ++ao;
            return Ai(t) + e;
          }, n.upperCase = Ls, n.upperFirst = Ds, n.each = Qr, n.eachRight = ti, n.first = Wr, Ui(n, function () {
            var t = {};
            return _e(n, function (e, r) {
              oo.call(n.prototype, r) || (t[r] = e);
            }), t;
          }(), {
            chain: !1
          }), n.VERSION = "4.17.5", s("bind bindKey curry curryRight partial partialRight".split(" "), function (t) {
            n[t].placeholder = n;
          }), s(["drop", "take"], function (t, e) {
            T.prototype[t] = function (n) {
              n = n === W ? 1 : zo(Mi(n), 0);
              var r = this.__filtered__ && !e ? new T(this) : this.clone();
              return r.__filtered__ ? r.__takeCount__ = Bo(n, r.__takeCount__) : r.__views__.push({
                size: Bo(n, 4294967295),
                type: t + (0 > r.__dir__ ? "Right" : "")
              }), r;
            }, T.prototype[t + "Right"] = function (e) {
              return this.reverse()[t](e).reverse();
            };
          }), s(["filter", "map", "takeWhile"], function (t, e) {
            var n = e + 1,
                r = 1 == n || 3 == n;

            T.prototype[t] = function (t) {
              var e = this.clone();
              return e.__iteratees__.push({
                iteratee: yr(t, 3),
                type: n
              }), e.__filtered__ = e.__filtered__ || r, e;
            };
          }), s(["head", "last"], function (t, e) {
            var n = "take" + (e ? "Right" : "");

            T.prototype[t] = function () {
              return this[n](1).value()[0];
            };
          }), s(["initial", "tail"], function (t, e) {
            var n = "drop" + (e ? "" : "Right");

            T.prototype[t] = function () {
              return this.__filtered__ ? new T(this) : this[n](1);
            };
          }), T.prototype.compact = function () {
            return this.filter(ji);
          }, T.prototype.find = function (t) {
            return this.filter(t).head();
          }, T.prototype.findLast = function (t) {
            return this.reverse().find(t);
          }, T.prototype.invokeMap = sn(function (t, e) {
            return "function" == typeof t ? new T(this) : this.map(function (n) {
              return Ie(n, t, e);
            });
          }), T.prototype.reject = function (t) {
            return this.filter(ui(yr(t)));
          }, T.prototype.slice = function (t, e) {
            t = Mi(t);
            var n = this;
            return n.__filtered__ && (0 < t || 0 > e) ? new T(n) : (0 > t ? n = n.takeRight(-t) : t && (n = n.drop(t)), e !== W && (e = Mi(e), n = 0 > e ? n.dropRight(-e) : n.take(e - t)), n);
          }, T.prototype.takeRightWhile = function (t) {
            return this.reverse().takeWhile(t).reverse();
          }, T.prototype.toArray = function () {
            return this.take(4294967295);
          }, _e(T.prototype, function (t, e) {
            var r = /^(?:filter|find|map|reject)|While$/.test(e),
                o = /^(?:head|last)$/.test(e),
                a = n[o ? "take" + ("last" == e ? "Right" : "") : e],
                s = o || /^find/.test(e);
            a && (n.prototype[e] = function () {
              function e(t) {
                return t = a.apply(n, m([t], c)), o && p ? t[0] : t;
              }

              var u = this.__wrapped__,
                  c = o ? [1] : arguments,
                  l = u instanceof T,
                  h = c[0],
                  f = l || os(u);
              f && r && "function" == typeof h && 1 != h.length && (l = f = !1);
              var p = this.__chain__,
                  d = !!this.__actions__.length,
                  h = s && !p,
                  l = l && !d;
              return !s && f ? (u = l ? u : new T(this), u = t.apply(u, c), u.__actions__.push({
                func: Kr,
                args: [e],
                thisArg: W
              }), new i(u, p)) : h && l ? t.apply(this, c) : (u = this.thru(e), h ? o ? u.value()[0] : u.value() : u);
            });
          }), s("pop push shift sort splice unshift".split(" "), function (t) {
            var e = eo[t],
                r = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
                i = /^(?:pop|shift)$/.test(t);

            n.prototype[t] = function () {
              var t = arguments;

              if (i && !this.__chain__) {
                var n = this.value();
                return e.apply(os(n) ? n : [], t);
              }

              return this[r](function (n) {
                return e.apply(os(n) ? n : [], t);
              });
            };
          }), _e(T.prototype, function (t, e) {
            var r = n[e];

            if (r) {
              var i = r.name + "";
              (Zo[i] || (Zo[i] = [])).push({
                name: e,
                func: r
              });
            }
          }), Zo[Yn(W, 2).name] = [{
            name: "wrapper",
            func: W
          }], T.prototype.clone = function () {
            var t = new T(this.__wrapped__);
            return t.__actions__ = zn(this.__actions__), t.__dir__ = this.__dir__, t.__filtered__ = this.__filtered__, t.__iteratees__ = zn(this.__iteratees__), t.__takeCount__ = this.__takeCount__, t.__views__ = zn(this.__views__), t;
          }, T.prototype.reverse = function () {
            if (this.__filtered__) {
              var t = new T(this);
              t.__dir__ = -1, t.__filtered__ = !0;
            } else t = this.clone(), t.__dir__ *= -1;

            return t;
          }, T.prototype.value = function () {
            var t,
                e = this.__wrapped__.value(),
                n = this.__dir__,
                r = os(e),
                i = 0 > n,
                o = r ? e.length : 0;

            t = o;

            for (var a = this.__views__, s = 0, u = -1, c = a.length; ++u < c;) {
              var l = a[u],
                  h = l.size;

              switch (l.type) {
                case "drop":
                  s += h;
                  break;

                case "dropRight":
                  t -= h;
                  break;

                case "take":
                  t = Bo(t, s + h);
                  break;

                case "takeRight":
                  s = zo(s, t - h);
              }
            }

            if (t = {
              start: s,
              end: t
            }, a = t.start, s = t.end, t = s - a, a = i ? s : a - 1, s = this.__iteratees__, u = s.length, c = 0, l = Bo(t, this.__takeCount__), !r || !i && o == t && l == t) return _n(e, this.__actions__);
            r = [];

            t: for (; t-- && c < l;) {
              for (a += n, i = -1, o = e[a]; ++i < u;) {
                var f = s[i],
                    h = f.type,
                    f = (0, f.iteratee)(o);
                if (2 == h) o = f;else if (!f) {
                  if (1 == h) continue t;
                  break t;
                }
              }

              r[c++] = o;
            }

            return r;
          }, n.prototype.at = Da, n.prototype.chain = function () {
            return Yr(this);
          }, n.prototype.commit = function () {
            return new i(this.value(), this.__chain__);
          }, n.prototype.next = function () {
            this.__values__ === W && (this.__values__ = _i(this.value()));
            var t = this.__index__ >= this.__values__.length;
            return {
              done: t,
              value: t ? W : this.__values__[this.__index__++]
            };
          }, n.prototype.plant = function (t) {
            for (var e, n = this; n instanceof r;) {
              var i = Fr(n);
              i.__index__ = 0, i.__values__ = W, e ? o.__wrapped__ = i : e = i;
              var o = i,
                  n = n.__wrapped__;
            }

            return o.__wrapped__ = t, e;
          }, n.prototype.reverse = function () {
            var t = this.__wrapped__;
            return t instanceof T ? (this.__actions__.length && (t = new T(this)), t = t.reverse(), t.__actions__.push({
              func: Kr,
              args: [Vr],
              thisArg: W
            }), new i(t, this.__chain__)) : this.thru(Vr);
          }, n.prototype.toJSON = n.prototype.valueOf = n.prototype.value = function () {
            return _n(this.__wrapped__, this.__actions__);
          }, n.prototype.first = n.prototype.head, _o && (n.prototype[_o] = Jr), n;
        }();

        Gt._ = ae, r = function () {
          return ae;
        }.call(e, n, e, i), !(void 0 !== r && (i.exports = r));
      }).call(this);
    }).call(e, function () {
      return this;
    }(), n(96)(t));
  }, function (t, e, n) {
    t.exports = n(187);
  }, function (t, e, n) {
    "use strict";

    function r(t, e, a, s, u) {
      u.on("config", function (n, i) {
        n.number !== i.number && r(t, e, a, s, u);
      }), u.true = !0, u.false = !1, u.null = null, u.uninitialized = n(8).UNINITIALIZED, "BigNumber" === e.number ? (u.Infinity = new t.BigNumber(1 / 0), u.NaN = new t.BigNumber(NaN), i.lazy(u, "pi", function () {
        return o.pi(t.BigNumber);
      }), i.lazy(u, "tau", function () {
        return o.tau(t.BigNumber);
      }), i.lazy(u, "e", function () {
        return o.e(t.BigNumber);
      }), i.lazy(u, "phi", function () {
        return o.phi(t.BigNumber);
      }), i.lazy(u, "E", function () {
        return u.e;
      }), i.lazy(u, "LN2", function () {
        return new t.BigNumber(2).ln();
      }), i.lazy(u, "LN10", function () {
        return new t.BigNumber(10).ln();
      }), i.lazy(u, "LOG2E", function () {
        return new t.BigNumber(1).div(new t.BigNumber(2).ln());
      }), i.lazy(u, "LOG10E", function () {
        return new t.BigNumber(1).div(new t.BigNumber(10).ln());
      }), i.lazy(u, "PI", function () {
        return u.pi;
      }), i.lazy(u, "SQRT1_2", function () {
        return new t.BigNumber("0.5").sqrt();
      }), i.lazy(u, "SQRT2", function () {
        return new t.BigNumber(2).sqrt();
      })) : (u.Infinity = 1 / 0, u.NaN = NaN, u.pi = Math.PI, u.tau = 2 * Math.PI, u.e = Math.E, u.phi = 1.618033988749895, u.E = u.e, u.LN2 = Math.LN2, u.LN10 = Math.LN10, u.LOG2E = Math.LOG2E, u.LOG10E = Math.LOG10E, u.PI = u.pi, u.SQRT1_2 = Math.SQRT1_2, u.SQRT2 = Math.SQRT2), u.i = t.Complex.I, u.version = n(549);
    }

    var i = n(5),
        o = n(157);
    e.factory = r, e.lazy = !1, e.math = !0;
  }, function (t, e, n) {
    var r = n(5).isFactory,
        i = (n(5).deepExtend, n(190)),
        o = n(158),
        a = n(189),
        s = n(188);

    e.create = function (t) {
      function e(t) {
        if (!r(t)) throw new Error("Factory object with properties `type`, `name`, and `factory` expected");
        var i,
            o = n.indexOf(t);
        return o === -1 ? (i = t.math === !0 ? t.factory(c.type, l, e, c.typed, c) : t.factory(c.type, l, e, c.typed), n.push(t), u.push(i)) : i = u[o], i;
      }

      if ("function" != typeof Object.create) throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
      var n = [],
          u = [],
          c = o.mixin({});
      c.type = {}, c.expression = {
        transform: Object.create(c)
      }, c.typed = i.create(c.type);
      var l = {
        epsilon: 1e-12,
        matrix: "Matrix",
        number: "number",
        precision: 64,
        predictable: !1
      };
      return c.import = e(a), c.config = e(s), t && c.config(t), c;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, i) {
      function o(t) {
        if (t) {
          var n = s.clone(e);
          a(t, "matrix", u), a(t, "number", c), s.deepExtend(e, t);
          var r = s.clone(e);
          return i.emit("config", r, n), r;
        }

        return s.clone(e);
      }

      var u = ["Matrix", "Array"],
          c = ["number", "BigNumber", "Fraction"];
      return o.MATRIX = u, o.NUMBER = c, o;
    }

    function i(t, e) {
      return t.indexOf(e) !== -1;
    }

    function o(t, e) {
      return t.map(function (t) {
        return t.toLowerCase();
      }).indexOf(e.toLowerCase());
    }

    function a(t, e, n) {
      if (void 0 !== t[e] && !i(n, t[e])) {
        var r = o(n, t[e]);
        r !== -1 ? (console.warn('Warning: Wrong casing for configuration option "' + e + '", should be "' + n[r] + '" instead of "' + t[e] + '".'), t[e] = n[r]) : console.warn('Warning: Unknown value "' + t[e] + '" for configuration option "' + e + '". Available options: ' + n.map(JSON.stringify).join(", ") + ".");
      }
    }

    var s = n(5);
    e.name = "config", e.math = !0, e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, u) {
      function c(t, e) {
        var n = arguments.length;
        if (1 != n && 2 != n) throw new s("import", n, 1, 2);
        if (e || (e = {}), o(t)) p(t, e);else if (Array.isArray(t)) t.forEach(function (t) {
          c(t, e);
        });else if ("object" == typeof t) {
          for (var r in t) {
            if (t.hasOwnProperty(r)) {
              var i = t[r];
              m(i) ? l(r, i, e) : o(t) ? p(t, e) : c(i, e);
            }
          }
        } else if (!e.silent) throw new TypeError("Factory, Object, or Array expected");
      }

      function l(t, e, n) {
        if (n.wrap && "function" == typeof e && (e = f(e)), d(u[t]) && d(e)) return e = n.override ? r(t, e.signatures) : r(u[t], e), u[t] = e, h(t, e), void u.emit("import", t, function () {
          return e;
        });
        if (void 0 === u[t] || n.override) return u[t] = e, h(t, e), void u.emit("import", t, function () {
          return e;
        });
        if (!n.silent) throw new Error('Cannot import "' + t + '": already exists');
      }

      function h(t, e) {
        e && "function" == typeof e.transform && (u.expression.transform[t] = e.transform);
      }

      function f(t) {
        var e = function e() {
          for (var e = [], n = 0, r = arguments.length; n < r; n++) {
            var i = arguments[n];
            e[n] = i && i.valueOf();
          }

          return t.apply(u, e);
        };

        return t.transform && (e.transform = t.transform), e;
      }

      function p(t, e) {
        if ("string" == typeof t.name) {
          var o = t.name,
              s = t.path ? a(u, t.path) : u,
              c = s.hasOwnProperty(o) ? s[o] : void 0,
              l = function l() {
            var i = n(t);
            if (d(c) && d(i)) return e.override || (i = r(c, i)), i;
            if (void 0 === c || e.override) return i;
            if (!e.silent) throw new Error('Cannot import "' + o + '": already exists');
          };

          t.lazy !== !1 ? i(s, o, l) : s[o] = l(), u.emit("import", o, l, t.path);
        } else n(t);
      }

      function m(t) {
        return "function" == typeof t || "number" == typeof t || "string" == typeof t || "boolean" == typeof t || null === t || t && t.isUnit === !0 || t && t.isComplex === !0 || t && t.isBigNumber === !0 || t && t.isFraction === !0 || t && t.isMatrix === !0 || t && Array.isArray(t) === !0;
      }

      function d(t) {
        return "function" == typeof t && "object" == typeof t.signatures;
      }

      return c;
    }

    var i = n(5).lazy,
        o = n(5).isFactory,
        a = n(5).traverse,
        s = (n(5).extend, n(51));
    e.math = !0, e.name = "import", e.factory = r, e.lazy = !0;
  }, function (t, e, n) {
    var r = n(579),
        i = n(3).digits,
        _o4 = function o() {
      return _o4 = r.create, r;
    };

    e.create = function (t) {
      var e = _o4();

      return e.types = [{
        name: "number",
        test: function test(t) {
          return "number" == typeof t;
        }
      }, {
        name: "Complex",
        test: function test(t) {
          return t && t.isComplex;
        }
      }, {
        name: "BigNumber",
        test: function test(t) {
          return t && t.isBigNumber;
        }
      }, {
        name: "Fraction",
        test: function test(t) {
          return t && t.isFraction;
        }
      }, {
        name: "Unit",
        test: function test(t) {
          return t && t.isUnit;
        }
      }, {
        name: "string",
        test: function test(t) {
          return "string" == typeof t;
        }
      }, {
        name: "Array",
        test: Array.isArray
      }, {
        name: "Matrix",
        test: function test(t) {
          return t && t.isMatrix;
        }
      }, {
        name: "DenseMatrix",
        test: function test(t) {
          return t && t.isDenseMatrix;
        }
      }, {
        name: "SparseMatrix",
        test: function test(t) {
          return t && t.isSparseMatrix;
        }
      }, {
        name: "ImmutableDenseMatrix",
        test: function test(t) {
          return t && t.isImmutableDenseMatrix;
        }
      }, {
        name: "Range",
        test: function test(t) {
          return t && t.isRange;
        }
      }, {
        name: "Index",
        test: function test(t) {
          return t && t.isIndex;
        }
      }, {
        name: "boolean",
        test: function test(t) {
          return "boolean" == typeof t;
        }
      }, {
        name: "ResultSet",
        test: function test(t) {
          return t && t.isResultSet;
        }
      }, {
        name: "Help",
        test: function test(t) {
          return t && t.isHelp;
        }
      }, {
        name: "function",
        test: function test(t) {
          return "function" == typeof t;
        }
      }, {
        name: "Date",
        test: function test(t) {
          return t instanceof Date;
        }
      }, {
        name: "RegExp",
        test: function test(t) {
          return t instanceof RegExp;
        }
      }, {
        name: "Object",
        test: function test(t) {
          return "object" == typeof t;
        }
      }, {
        name: "null",
        test: function test(t) {
          return null === t;
        }
      }, {
        name: "undefined",
        test: function test(t) {
          return void 0 === t;
        }
      }], e.conversions = [{
        from: "number",
        to: "BigNumber",
        convert: function convert(e) {
          if (i(e) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + e + "). Use function bignumber(x) to convert to BigNumber.");
          return new t.BigNumber(e);
        }
      }, {
        from: "number",
        to: "Complex",
        convert: function convert(e) {
          return new t.Complex(e, 0);
        }
      }, {
        from: "number",
        to: "string",
        convert: function convert(t) {
          return t + "";
        }
      }, {
        from: "BigNumber",
        to: "Complex",
        convert: function convert(e) {
          return new t.Complex(e.toNumber(), 0);
        }
      }, {
        from: "Fraction",
        to: "BigNumber",
        convert: function convert(t) {
          throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
        }
      }, {
        from: "Fraction",
        to: "Complex",
        convert: function convert(e) {
          return new t.Complex(e.valueOf(), 0);
        }
      }, {
        from: "number",
        to: "Fraction",
        convert: function convert(e) {
          if (i(e) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to Fraction (value: " + e + "). Use function fraction(x) to convert to Fraction.");
          return new t.Fraction(e);
        }
      }, {
        from: "string",
        to: "number",
        convert: function convert(t) {
          var e = Number(t);
          if (isNaN(e)) throw new Error('Cannot convert "' + t + '" to a number');
          return e;
        }
      }, {
        from: "boolean",
        to: "number",
        convert: function convert(t) {
          return +t;
        }
      }, {
        from: "boolean",
        to: "BigNumber",
        convert: function convert(e) {
          return new t.BigNumber(+e);
        }
      }, {
        from: "boolean",
        to: "Fraction",
        convert: function convert(e) {
          return new t.Fraction(+e);
        }
      }, {
        from: "boolean",
        to: "string",
        convert: function convert(t) {
          return +t;
        }
      }, {
        from: "null",
        to: "number",
        convert: function convert() {
          return 0;
        }
      }, {
        from: "null",
        to: "string",
        convert: function convert() {
          return "null";
        }
      }, {
        from: "null",
        to: "BigNumber",
        convert: function convert() {
          return new t.BigNumber(0);
        }
      }, {
        from: "null",
        to: "Fraction",
        convert: function convert() {
          return new t.Fraction(0);
        }
      }, {
        from: "Array",
        to: "Matrix",
        convert: function convert(e) {
          return new t.DenseMatrix(e);
        }
      }, {
        from: "Matrix",
        to: "Array",
        convert: function convert(t) {
          return t.valueOf();
        }
      }], e;
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(51),
        i = n(12),
        o = n(52);
    t.exports = [{
      name: "ArgumentsError",
      path: "error",
      factory: function factory() {
        return r;
      }
    }, {
      name: "DimensionError",
      path: "error",
      factory: function factory() {
        return i;
      }
    }, {
      name: "IndexError",
      path: "error",
      factory: function factory() {
        return o;
      }
    }];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(t) {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
        if (!t) throw new Error('Argument "doc" missing');
        this.doc = t;
      }

      var u = r(n(108))();
      return s.prototype.type = "Help", s.prototype.isHelp = !0, s.prototype.toString = function () {
        var t = this.doc || {},
            e = "\n";

        if (t.name && (e += "Name: " + t.name + "\n\n"), t.category && (e += "Category: " + t.category + "\n\n"), t.description && (e += "Description:\n    " + t.description + "\n\n"), t.syntax && (e += "Syntax:\n    " + t.syntax.join("\n    ") + "\n\n"), t.examples) {
          e += "Examples:\n";

          for (var n = 0; n < t.examples.length; n++) {
            var r = t.examples[n];
            e += "    " + r + "\n";
            var i;

            try {
              i = u.eval(r);
            } catch (t) {
              i = t;
            }

            i && !i.isHelp && (e += "        " + o.format(i, {
              precision: 14
            }) + "\n");
          }

          e += "\n";
        }

        return t.seealso && (e += "See also: " + t.seealso.join(", ") + "\n"), e;
      }, s.prototype.toJSON = function () {
        var t = i.clone(this.doc);
        return t.mathjs = "Help", t;
      }, s.fromJSON = function (t) {
        var e = {};

        for (var n in t) {
          "mathjs" !== n && (e[n] = t[n]);
        }

        return new s(e);
      }, s.prototype.valueOf = s.prototype.toString, s;
    }

    var i = n(5),
        o = n(23);
    e.name = "Help", e.path = "type", e.factory = r;
  }, function (t, e) {
    t.exports = {
      name: "Infinity",
      category: "Constants",
      syntax: ["Infinity"],
      description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
      examples: ["Infinity", "1 / 0"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "LN10",
      category: "Constants",
      syntax: ["LN10"],
      description: "Returns the natural logarithm of 10, approximately equal to 2.302",
      examples: ["LN10", "log(10)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "LN2",
      category: "Constants",
      syntax: ["LN2"],
      description: "Returns the natural logarithm of 2, approximately equal to 0.693",
      examples: ["LN2", "log(2)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "LOG10E",
      category: "Constants",
      syntax: ["LOG10E"],
      description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
      examples: ["LOG10E", "log(e, 10)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "LOG2E",
      category: "Constants",
      syntax: ["LOG2E"],
      description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
      examples: ["LOG2E", "log(e, 2)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "NaN",
      category: "Constants",
      syntax: ["NaN"],
      description: "Not a number",
      examples: ["NaN", "0 / 0"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "SQRT1_2",
      category: "Constants",
      syntax: ["SQRT1_2"],
      description: "Returns the square root of 1/2, approximately equal to 0.707",
      examples: ["SQRT1_2", "sqrt(1/2)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "SQRT2",
      category: "Constants",
      syntax: ["SQRT2"],
      description: "Returns the square root of 2, approximately equal to 1.414",
      examples: ["SQRT2", "sqrt(2)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "false",
      category: "Constants",
      syntax: ["false"],
      description: "Boolean value false",
      examples: ["false"],
      seealso: ["true"]
    };
  }, function (t, e) {
    t.exports = {
      name: "i",
      category: "Constants",
      syntax: ["i"],
      description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
      examples: ["i", "i * i", "sqrt(-1)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "null",
      category: "Constants",
      syntax: ["null"],
      description: "Value null",
      examples: ["null"],
      seealso: ["true", "false"]
    };
  }, function (t, e) {
    t.exports = {
      name: "phi",
      category: "Constants",
      syntax: ["phi"],
      description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
      examples: ["tau"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "tau",
      category: "Constants",
      syntax: ["tau"],
      description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
      examples: ["tau", "2 * pi"],
      seealso: ["pi"]
    };
  }, function (t, e) {
    t.exports = {
      name: "true",
      category: "Constants",
      syntax: ["true"],
      description: "Boolean value true",
      examples: ["true"],
      seealso: ["false"]
    };
  }, function (t, e) {
    t.exports = {
      name: "version",
      category: "Constants",
      syntax: ["version"],
      description: "A string with the version number of math.js",
      examples: ["version"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "bignumber",
      category: "Construction",
      syntax: ["bignumber(x)"],
      description: "Create a big number from a number or string.",
      examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"],
      seealso: ["boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "boolean",
      category: "Construction",
      syntax: ["x", "boolean(x)"],
      description: "Convert a string or number into a boolean.",
      examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"],
      seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "complex",
      category: "Construction",
      syntax: ["complex()", "complex(re, im)", "complex(string)"],
      description: "Create a complex number.",
      examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'],
      seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "createUnit",
      category: "Construction",
      syntax: ["createUnit(definitions)", "createUnit(name, definition)"],
      description: "Create a user-defined unit and register it with the Unit type.",
      examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'],
      seealso: ["unit", "splitUnit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "fraction",
      category: "Construction",
      syntax: ["fraction(num)", "fraction(num,den)"],
      description: "Create a fraction from a number or from a numerator and denominator.",
      examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)"],
      seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "index",
      category: "Construction",
      syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"],
      description: "Create an index to get or replace a subset of a matrix",
      examples: ["[]", "[1, 2, 3]", "A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[0:2, 0:2] = ones(2, 2)"],
      seealso: ["bignumber", "boolean", "complex", "matrix,", "number", "range", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "matrix",
      category: "Construction",
      syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"],
      description: "Create a matrix.",
      examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'],
      seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"]
    };
  }, function (t, e) {
    t.exports = {
      name: "number",
      category: "Construction",
      syntax: ["x", "number(x)"],
      description: "Create a number or convert a string or boolean into a number.",
      examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number("52cm", "m")'],
      seealso: ["bignumber", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sparse",
      category: "Construction",
      syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'],
      description: "Create a sparse matrix.",
      examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'],
      seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"]
    };
  }, function (t, e) {
    t.exports = {
      name: "splitUnit",
      category: "Construction",
      syntax: ["splitUnit(unit: Unit, parts: Unit[])"],
      description: "Split a unit in an array of units whose sum is equal to the original unit.",
      examples: ['splitUnit(1 m, ["feet", "inch"])'],
      seealso: ["unit", "createUnit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "string",
      category: "Construction",
      syntax: ['"text"', "string(x)"],
      description: "Create a string or convert a value to a string",
      examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"],
      seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"]
    };
  }, function (t, e) {
    t.exports = {
      name: "unit",
      category: "Construction",
      syntax: ["value unit", "unit(value, unit)", "unit(string)"],
      description: "Create a unit.",
      examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'],
      seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"]
    };
  }, function (t, e) {
    t.exports = {
      name: "config",
      category: "Core",
      syntax: ["config()", "config(options)"],
      description: "Get configuration or change configuration.",
      examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "import",
      category: "Core",
      syntax: ["import(functions)", "import(functions, options)"],
      description: "Import functions or constants from an object.",
      examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "typed",
      category: "Core",
      syntax: ["typed(signatures)", "typed(name, signatures)"],
      description: "Create a typed function.",
      examples: ['double = typed({ "number, number": f(x)=x+x })', "double(2)", 'double("hello")'],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "lsolve",
      category: "Algebra",
      syntax: ["x=lsolve(L, b)"],
      description: "Solves the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
      examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
      seealso: ["lup", "lusolve", "usolve", "matrix", "sparse"]
    };
  }, function (t, e) {
    t.exports = {
      name: "lup",
      category: "Algebra",
      syntax: ["lup(m)"],
      description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
      examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"],
      seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu"]
    };
  }, function (t, e) {
    t.exports = {
      name: "lusolve",
      category: "Algebra",
      syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"],
      description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
      examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"],
      seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"]
    };
  }, function (t, e) {
    t.exports = {
      name: "slu",
      category: "Algebra",
      syntax: ["slu(A, order, threshold)"],
      description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
      examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],
      seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup"]
    };
  }, function (t, e) {
    t.exports = {
      name: "usolve",
      category: "Algebra",
      syntax: ["x=usolve(U, b)"],
      description: "Solves the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
      examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
      seealso: ["lup", "lusolve", "lsolve", "matrix", "sparse"]
    };
  }, function (t, e) {
    t.exports = {
      name: "abs",
      category: "Arithmetic",
      syntax: ["abs(x)"],
      description: "Compute the absolute value.",
      examples: ["abs(3.5)", "abs(-4.2)"],
      seealso: ["sign"]
    };
  }, function (t, e) {
    t.exports = {
      name: "add",
      category: "Operators",
      syntax: ["x + y", "add(x, y)"],
      description: "Add two values.",
      examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'],
      seealso: ["subtract"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cbrt",
      category: "Arithmetic",
      syntax: ["cbrt(x)", "cbrt(x, allRoots)"],
      description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
      examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"],
      seealso: ["square", "sqrt", "cube", "multiply"]
    };
  }, function (t, e) {
    t.exports = {
      name: "ceil",
      category: "Arithmetic",
      syntax: ["ceil(x)"],
      description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
      examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)"],
      seealso: ["floor", "fix", "round"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cube",
      category: "Arithmetic",
      syntax: ["cube(x)"],
      description: "Compute the cube of a value. The cube of x is x * x * x.",
      examples: ["cube(2)", "2^3", "2 * 2 * 2"],
      seealso: ["multiply", "square", "pow"]
    };
  }, function (t, e) {
    t.exports = {
      name: "divide",
      category: "Operators",
      syntax: ["x / y", "divide(x, y)"],
      description: "Divide two values.",
      examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"],
      seealso: ["multiply"]
    };
  }, function (t, e) {
    t.exports = {
      name: "dotDivide",
      category: "Operators",
      syntax: ["x ./ y", "dotDivide(x, y)"],
      description: "Divide two values element wise.",
      examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"],
      seealso: ["multiply", "dotMultiply", "divide"]
    };
  }, function (t, e) {
    t.exports = {
      name: "dotMultiply",
      category: "Operators",
      syntax: ["x .* y", "dotMultiply(x, y)"],
      description: "Multiply two values element wise.",
      examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"],
      seealso: ["multiply", "divide", "dotDivide"]
    };
  }, function (t, e) {
    t.exports = {
      name: "dotpow",
      category: "Operators",
      syntax: ["x .^ y", "dotpow(x, y)"],
      description: "Calculates the power of x to y element wise.",
      examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"],
      seealso: ["pow"]
    };
  }, function (t, e) {
    t.exports = {
      name: "exp",
      category: "Arithmetic",
      syntax: ["exp(x)"],
      description: "Calculate the exponent of a value.",
      examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],
      seealso: ["pow", "log"]
    };
  }, function (t, e) {
    t.exports = {
      name: "fix",
      category: "Arithmetic",
      syntax: ["fix(x)"],
      description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
      examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)"],
      seealso: ["ceil", "floor", "round"]
    };
  }, function (t, e) {
    t.exports = {
      name: "floor",
      category: "Arithmetic",
      syntax: ["floor(x)"],
      description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
      examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)"],
      seealso: ["ceil", "fix", "round"]
    };
  }, function (t, e) {
    t.exports = {
      name: "gcd",
      category: "Arithmetic",
      syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"],
      description: "Compute the greatest common divisor.",
      examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"],
      seealso: ["lcm", "xgcd"]
    };
  }, function (t, e) {
    t.exports = {
      name: "hypot",
      category: "Arithmetic",
      syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"],
      description: "Calculate the hypotenusa of a list with values. ",
      examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"],
      seealso: ["abs", "norm"]
    };
  }, function (t, e) {
    t.exports = {
      name: "lcm",
      category: "Arithmetic",
      syntax: ["lcm(x, y)"],
      description: "Compute the least common multiple.",
      examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"],
      seealso: ["gcd"]
    };
  }, function (t, e) {
    t.exports = {
      name: "log",
      category: "Arithmetic",
      syntax: ["log(x)", "log(x, base)"],
      description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
      examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"],
      seealso: ["exp", "log10"]
    };
  }, function (t, e) {
    t.exports = {
      name: "log10",
      category: "Arithmetic",
      syntax: ["log10(x)"],
      description: "Compute the 10-base logarithm of a value.",
      examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"],
      seealso: ["exp", "log"]
    };
  }, function (t, e) {
    t.exports = {
      name: "mod",
      category: "Operators",
      syntax: ["x % y", "x mod y", "mod(x, y)"],
      description: "Calculates the modulus, the remainder of an integer division.",
      examples: ["7 % 3", "11 % 2", "10 mod 4", "function isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"],
      seealso: ["divide"]
    };
  }, function (t, e) {
    t.exports = {
      name: "multiply",
      category: "Operators",
      syntax: ["x * y", "multiply(x, y)"],
      description: "multiply two values.",
      examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"],
      seealso: ["divide"]
    };
  }, function (t, e) {
    t.exports = {
      name: "norm",
      category: "Arithmetic",
      syntax: ["norm(x)", "norm(x, p)"],
      description: "Calculate the norm of a number, vector or matrix.",
      examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i))", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", "norm([[1, 2], [3, 4]], 'inf')", "norm([[1, 2], [3, 4]], 'fro')"]
    };
  }, function (t, e) {
    t.exports = {
      name: "nthRoot",
      category: "Arithmetic",
      syntax: ["nthRoot(a)", "nthRoot(a, root)"],
      description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
      examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"],
      seealso: ["sqrt", "pow"]
    };
  }, function (t, e) {
    t.exports = {
      name: "pow",
      category: "Operators",
      syntax: ["x ^ y", "pow(x, y)"],
      description: "Calculates the power of x to y, x^y.",
      examples: ["2^3 = 8", "2*2*2", "1 + e ^ (pi * i)"],
      seealso: ["multiply"]
    };
  }, function (t, e) {
    t.exports = {
      name: "round",
      category: "Arithmetic",
      syntax: ["round(x)", "round(x, n)"],
      description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
      examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)"],
      seealso: ["ceil", "floor", "fix"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sign",
      category: "Arithmetic",
      syntax: ["sign(x)"],
      description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
      examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"],
      seealso: ["abs"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sqrt",
      category: "Arithmetic",
      syntax: ["sqrt(x)"],
      description: "Compute the square root value. If x = y * y, then y is the square root of x.",
      examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"],
      seealso: ["square", "multiply"]
    };
  }, function (t, e) {
    t.exports = {
      name: "square",
      category: "Arithmetic",
      syntax: ["square(x)"],
      description: "Compute the square of a value. The square of x is x * x.",
      examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"],
      seealso: ["multiply", "pow", "sqrt", "cube"]
    };
  }, function (t, e) {
    t.exports = {
      name: "subtract",
      category: "Operators",
      syntax: ["x - y", "subtract(x, y)"],
      description: "subtract two values.",
      examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"],
      seealso: ["add"]
    };
  }, function (t, e) {
    t.exports = {
      name: "unaryMinus",
      category: "Operators",
      syntax: ["-x", "unaryMinus(x)"],
      description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
      examples: ["-4.5", "-(-5.6)", '-"22"'],
      seealso: ["add", "subtract", "unaryPlus"]
    };
  }, function (t, e) {
    t.exports = {
      name: "unaryPlus",
      category: "Operators",
      syntax: ["+x", "unaryPlus(x)"],
      description: "Converts booleans and strings to numbers.",
      examples: ["+true", '+"2"'],
      seealso: ["add", "subtract", "unaryMinus"]
    };
  }, function (t, e) {
    t.exports = {
      name: "xgcd",
      category: "Arithmetic",
      syntax: ["xgcd(a, b)"],
      description: "Calculate the extended greatest common divisor for two values",
      examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"],
      seealso: ["gcd", "lcm"]
    };
  }, function (t, e) {
    t.exports = {
      name: "bitAnd",
      category: "Bitwise",
      syntax: ["x & y", "bitAnd(x, y)"],
      description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
      examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"],
      seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "bitNot",
      category: "Bitwise",
      syntax: ["~x", "bitNot(x)"],
      description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
      examples: ["~1", "~2", "bitNot([2, -3, 4])"],
      seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "bitOr",
      category: "Bitwise",
      syntax: ["x | y", "bitOr(x, y)"],
      description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
      examples: ["5 | 3", "bitOr([1, 2, 3], 4)"],
      seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "bitXor",
      category: "Bitwise",
      syntax: ["bitXor(x, y)"],
      description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
      examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"],
      seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "leftShift",
      category: "Bitwise",
      syntax: ["x << y", "leftShift(x, y)"],
      description: "Bitwise left logical shift of a value x by y number of bits.",
      examples: ["4 << 1", "8 >> 1"],
      seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "rightArithShift",
      category: "Bitwise",
      syntax: ["x >> y", "leftShift(x, y)"],
      description: "Bitwise right arithmetic shift of a value x by y number of bits.",
      examples: ["8 >> 1", "4 << 1", "-12 >> 2"],
      seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "rightLogShift",
      category: "Bitwise",
      syntax: ["x >> y", "leftShift(x, y)"],
      description: "Bitwise right logical shift of a value x by y number of bits.",
      examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"],
      seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"]
    };
  }, function (t, e) {
    t.exports = {
      name: "bellNumbers",
      category: "Combinatorics",
      syntax: ["bellNumbers(n)"],
      description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
      examples: ["bellNumbers(3)", "bellNumbers(8)"],
      seealso: ["stirlingS2"]
    };
  }, function (t, e) {
    t.exports = {
      name: "catalan",
      category: "Combinatorics",
      syntax: ["catalan(n)"],
      description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
      examples: ["catalan(3)", "catalan(8)"],
      seealso: ["bellNumbers"]
    };
  }, function (t, e) {
    t.exports = {
      name: "composition",
      category: "Combinatorics",
      syntax: ["composition(n, k)"],
      description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
      examples: ["composition(5, 3)"],
      seealso: ["combinations"]
    };
  }, function (t, e) {
    t.exports = {
      name: "stirlingS2",
      category: "Combinatorics",
      syntax: ["stirlingS2(n, k)"],
      description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
      examples: ["stirlingS2(5, 3)"],
      seealso: ["bellNumbers"]
    };
  }, function (t, e) {
    t.exports = {
      name: "arg",
      category: "Complex",
      syntax: ["arg(x)"],
      description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
      examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"],
      seealso: ["re", "im", "conj", "abs"]
    };
  }, function (t, e) {
    t.exports = {
      name: "conj",
      category: "Complex",
      syntax: ["conj(x)"],
      description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
      examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"],
      seealso: ["re", "im", "abs", "arg"]
    };
  }, function (t, e) {
    t.exports = {
      name: "im",
      category: "Complex",
      syntax: ["im(x)"],
      description: "Get the imaginary part of a complex number.",
      examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"],
      seealso: ["re", "conj", "abs", "arg"]
    };
  }, function (t, e) {
    t.exports = {
      name: "re",
      category: "Complex",
      syntax: ["re(x)"],
      description: "Get the real part of a complex number.",
      examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"],
      seealso: ["im", "conj", "abs", "arg"]
    };
  }, function (t, e) {
    t.exports = {
      name: "eval",
      category: "Expression",
      syntax: ["eval(expression)", "eval([expr1, expr2, expr3, ...])"],
      description: "Evaluate an expression or an array with expressions.",
      examples: ['eval("2 + 3")', 'eval("sqrt(" + 4 + ")")'],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "help",
      category: "Expression",
      syntax: ["help(object)", "help(string)"],
      description: "Display documentation on a function or data type.",
      examples: ["help(sqrt)", 'help("complex")'],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "distance",
      category: "Geometry",
      syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2])"],
      description: "Calculates the Euclidean distance between two points.",
      examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "intersect",
      category: "Geometry",
      syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"],
      description: "Computes the intersection point of lines and/or planes.",
      examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "and",
      category: "Logical",
      syntax: ["x and y", "and(x, y)"],
      description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
      examples: ["true and false", "true and true", "2 and 4"],
      seealso: ["not", "or", "xor"]
    };
  }, function (t, e) {
    t.exports = {
      name: "not",
      category: "Logical",
      syntax: ["not x", "not(x)"],
      description: "Logical not. Flips the boolean value of given argument.",
      examples: ["not true", "not false", "not 2", "not 0"],
      seealso: ["and", "or", "xor"]
    };
  }, function (t, e) {
    t.exports = {
      name: "or",
      category: "Logical",
      syntax: ["x or y", "or(x, y)"],
      description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
      examples: ["true or false", "false or false", "0 or 4"],
      seealso: ["not", "and", "xor"]
    };
  }, function (t, e) {
    t.exports = {
      name: "xor",
      category: "Logical",
      syntax: ["x or y", "or(x, y)"],
      description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
      examples: ["true xor false", "false xor false", "true xor true", "0 or 4"],
      seealso: ["not", "and", "or"]
    };
  }, function (t, e) {
    t.exports = {
      name: "concat",
      category: "Matrix",
      syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"],
      description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
      examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"],
      seealso: ["det", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cross",
      category: "Matrix",
      syntax: ["cross(A, B)"],
      description: "Calculate the cross product for two vectors in three dimensional space.",
      examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"],
      seealso: ["multiply", "dot"]
    };
  }, function (t, e) {
    t.exports = {
      name: "det",
      category: "Matrix",
      syntax: ["det(x)"],
      description: "Calculate the determinant of a matrix",
      examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],
      seealso: ["concat", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "diag",
      category: "Matrix",
      syntax: ["diag(x)", "diag(x, k)"],
      description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
      examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"],
      seealso: ["concat", "det", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "dot",
      category: "Matrix",
      syntax: ["dot(A, B)"],
      description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
      examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"],
      seealso: ["multiply", "cross"]
    };
  }, function (t, e) {
    t.exports = {
      name: "eye",
      category: "Matrix",
      syntax: ["eye(n)", "eye(m, n)", "eye([m, n])", "eye"],
      description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
      examples: ["eye(3)", "eye(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "eye(size(a))"],
      seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "filter",
      category: "Matrix",
      syntax: ["filter(x, test)"],
      description: "Filter items in a matrix.",
      examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"],
      seealso: ["sort", "map", "forEach"]
    };
  }, function (t, e) {
    t.exports = {
      name: "flatten",
      category: "Matrix",
      syntax: ["flatten(x)"],
      description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
      examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"],
      seealso: ["concat", "resize", "size", "squeeze"]
    };
  }, function (t, e) {
    t.exports = {
      name: "forEach",
      category: "Matrix",
      syntax: ["forEach(x, callback)"],
      description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
      examples: ["forEach([1, 2, 3], function(val) { console.log(val) })"],
      seealso: ["map", "sort", "filter"]
    };
  }, function (t, e) {
    t.exports = {
      name: "inv",
      category: "Matrix",
      syntax: ["inv(x)"],
      description: "Calculate the inverse of a matrix",
      examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"],
      seealso: ["concat", "det", "diag", "eye", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "map",
      category: "Matrix",
      syntax: ["map(x, callback)"],
      description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
      examples: ["map([1, 2, 3], function(val) { return value * value })"],
      seealso: ["filter", "forEach"]
    };
  }, function (t, e) {
    t.exports = {
      name: "ones",
      category: "Matrix",
      syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])", "ones"],
      description: "Create a matrix containing ones.",
      examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"],
      seealso: ["concat", "det", "diag", "eye", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "partitionSelect",
      category: "Matrix",
      syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"],
      description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
      examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1)'],
      seealso: ["sort"]
    };
  }, function (t, e) {
    t.exports = {
      name: "range",
      category: "Type",
      syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"],
      description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
      examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "resize",
      category: "Matrix",
      syntax: ["resize(x, size)", "resize(x, size, defaultValue)"],
      description: "Resize a matrix.",
      examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'],
      seealso: ["size", "subset", "squeeze"]
    };
  }, function (t, e) {
    t.exports = {
      name: "size",
      category: "Matrix",
      syntax: ["size(x)"],
      description: "Calculate the size of a matrix.",
      examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sort",
      category: "Matrix",
      syntax: ["sort(x)", "sort(x, compare)"],
      description: 'Sort the items in a matrix. Compare can be a string "asc" or "desc", or a custom sort function.',
      examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"])', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)'],
      seealso: ["map", "filter", "forEach"]
    };
  }, function (t, e) {
    t.exports = {
      name: "squeeze",
      category: "Matrix",
      syntax: ["squeeze(x)"],
      description: "Remove inner and outer singleton dimensions from a matrix.",
      examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "subset",
      category: "Matrix",
      syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"],
      description: "Get or set a subset of a matrix or string. Indexes are one-based. Both the ranges lower-bound and upper-bound are included.",
      examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "trace",
      category: "Matrix",
      syntax: ["trace(A)"],
      description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
      examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "transpose",
      category: "Matrix",
      syntax: ["x'", "transpose(x)"],
      description: "Transpose a matrix",
      examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
    };
  }, function (t, e) {
    t.exports = {
      name: "zeros",
      category: "Matrix",
      syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])", "zeros"],
      description: "Create a matrix containing zeros.",
      examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"],
      seealso: ["concat", "det", "diag", "eye", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"]
    };
  }, function (t, e) {
    t.exports = {
      name: "combinations",
      category: "Probability",
      syntax: ["combinations(n, k)"],
      description: "Compute the number of combinations of n items taken k at a time",
      examples: ["combinations(7, 5)"],
      seealso: ["permutations", "factorial"]
    };
  }, function (t, e) {
    t.exports = {
      name: "factorial",
      category: "Probability",
      syntax: ["kldivergence(x, y)"],
      description: "Compute the factorial of a value",
      examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"],
      seealso: ["combinations", "permutations", "gamma"]
    };
  }, function (t, e) {
    t.exports = {
      name: "gamma",
      category: "Probability",
      syntax: ["gamma(n)"],
      description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
      examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"],
      seealso: ["factorial"]
    };
  }, function (t, e) {
    t.exports = {
      name: "kldivergence",
      category: "Probability",
      syntax: ["n!", "factorial(n)"],
      description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
      examples: ["math.kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "multinomial",
      category: "Probability",
      syntax: ["multinomial(A)"],
      description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai <= 0.",
      examples: ["multinomial([1, 2, 1])"],
      seealso: ["combinations", "factorial"]
    };
  }, function (t, e) {
    t.exports = {
      name: "permutations",
      category: "Probability",
      syntax: ["permutations(n)", "permutations(n, k)"],
      description: "Compute the number of permutations of n items taken k at a time",
      examples: ["permutations(5)", "permutations(5, 3)"],
      seealso: ["combinations", "factorial"]
    };
  }, function (t, e) {
    t.exports = {
      name: "pickRandom",
      category: "Probability",
      syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"],
      description: "Pick a random entry from a given array.",
      examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],
      seealso: ["random", "randomInt"]
    };
  }, function (t, e) {
    t.exports = {
      name: "random",
      category: "Probability",
      syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"],
      description: "Return a random number.",
      examples: ["random()", "random(10, 20)", "random([2, 3])"],
      seealso: ["pickRandom", "randomInt"]
    };
  }, function (t, e) {
    t.exports = {
      name: "randInt",
      category: "Probability",
      syntax: ["randInt(max)", "randInt(min, max)", "randInt(size)", "randInt(size, max)", "randInt(size, min, max)"],
      description: "Return a random integer number",
      examples: ["randInt(10, 20)", "randInt([2, 3], 10)"],
      seealso: ["pickRandom", "random"]
    };
  }, function (t, e) {
    t.exports = {
      name: "compare",
      category: "Relational",
      syntax: ["compare(x, y)"],
      description: "Compare two values. Returns 1 if x is larger than y, -1 if x is smaller than y, and 0 if x and y are equal.",
      examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"],
      seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq"]
    };
  }, function (t, e) {
    t.exports = {
      name: "deepEqual",
      category: "Relational",
      syntax: ["deepEqual(x, y)"],
      description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
      examples: ["[1,3,4] == [1,3,4]", "[1,3,4] == [1,3]"],
      seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"]
    };
  }, function (t, e) {
    t.exports = {
      name: "equal",
      category: "Relational",
      syntax: ["x == y", "equal(x, y)"],
      description: "Check equality of two values. Returns true if the values are equal, and false if not.",
      examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"],
      seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
    };
  }, function (t, e) {
    t.exports = {
      name: "larger",
      category: "Relational",
      syntax: ["x > y", "larger(x, y)"],
      description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
      examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"],
      seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"]
    };
  }, function (t, e) {
    t.exports = {
      name: "largerEq",
      category: "Relational",
      syntax: ["x >= y", "largerEq(x, y)"],
      description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
      examples: ["2 > 1+1", "2 >= 1+1", "a = 3.2", "b = 6-2.8", "(a > b)"],
      seealso: ["equal", "unequal", "smallerEq", "smaller", "largerEq", "compare"]
    };
  }, function (t, e) {
    t.exports = {
      name: "smaller",
      category: "Relational",
      syntax: ["x < y", "smaller(x, y)"],
      description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
      examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"],
      seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"]
    };
  }, function (t, e) {
    t.exports = {
      name: "smallerEq",
      category: "Relational",
      syntax: ["x <= y", "smallerEq(x, y)"],
      description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
      examples: ["2 < 1+1", "2 <= 1+1", "a = 3.2", "b = 6-2.8", "(a < b)"],
      seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"]
    };
  }, function (t, e) {
    t.exports = {
      name: "unequal",
      category: "Relational",
      syntax: ["x != y", "unequal(x, y)"],
      description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
      examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"],
      seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
    };
  }, function (t, e) {
    t.exports = {
      name: "erf",
      category: "Special",
      syntax: ["erf(x)"],
      description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
      examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "max",
      category: "Statistics",
      syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dim)"],
      description: "Compute the maximum value of a list of values.",
      examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"],
      seealso: ["mean", "median", "min", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "mean",
      category: "Statistics",
      syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dim)"],
      description: "Compute the arithmetic mean of a list of values.",
      examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"],
      seealso: ["max", "median", "min", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "median",
      category: "Statistics",
      syntax: ["median(a, b, c, ...)", "median(A)"],
      description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
      examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"],
      seealso: ["max", "mean", "min", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "min",
      category: "Statistics",
      syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dim)"],
      description: "Compute the minimum value of a list of values.",
      examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"],
      seealso: ["max", "mean", "median", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "mode",
      category: "Statistics",
      syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"],
      description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
      examples: ["mode(5, 2, 7)", "mode([3, -1, 5, 7])"],
      seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "prod",
      category: "Statistics",
      syntax: ["prod(a, b, c, ...)", "prod(A)"],
      description: "Compute the product of all values.",
      examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"],
      seealso: ["max", "mean", "min", "median", "min", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "quantileSeq",
      category: "Statistics",
      syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"],
      description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.",
      examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"],
      seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "std",
      category: "Statistics",
      syntax: ["std(a, b, c, ...)", "std(A)", "std(A, normalization)"],
      description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(var(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
      examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"],
      seealso: ["max", "mean", "min", "median", "min", "prod", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sum",
      category: "Statistics",
      syntax: ["sum(a, b, c, ...)", "sum(A)"],
      description: "Compute the sum of all values.",
      examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"],
      seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "var"]
    };
  }, function (t, e) {
    t.exports = {
      name: "var",
      category: "Statistics",
      syntax: ["var(a, b, c, ...)", "var(A)", "var(A, normalization)"],
      description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
      examples: ["var(2, 4, 6)", "var([2, 4, 6, 8])", 'var([2, 4, 6, 8], "uncorrected")', 'var([2, 4, 6, 8], "biased")', "var([1, 2, 3; 4, 5, 6])"],
      seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acos",
      category: "Trigonometry",
      syntax: ["acos(x)"],
      description: "Compute the inverse cosine of a value in radians.",
      examples: ["acos(0.5)", "acos(cos(2.3))"],
      seealso: ["cos", "atan", "asin"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acosh",
      category: "Trigonometry",
      syntax: ["acosh(x)"],
      description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
      examples: ["acosh(1.5)"],
      seealso: ["cosh", "asinh", "atanh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acot",
      category: "Trigonometry",
      syntax: ["acot(x)"],
      description: "Calculate the inverse cotangent of a value.",
      examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"],
      seealso: ["cot", "atan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acoth",
      category: "Trigonometry",
      syntax: ["acoth(x)"],
      description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
      examples: ["acoth(0.5)"],
      seealso: ["acsch", "asech"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acsc",
      category: "Trigonometry",
      syntax: ["acsc(x)"],
      description: "Calculate the inverse cotangent of a value.",
      examples: ["acsc(0.5)", "acsc(csc(0.5))", "acsc(2)"],
      seealso: ["csc", "asin", "asec"]
    };
  }, function (t, e) {
    t.exports = {
      name: "acsch",
      category: "Trigonometry",
      syntax: ["acsch(x)"],
      description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
      examples: ["acsch(0.5)"],
      seealso: ["asech", "acoth"]
    };
  }, function (t, e) {
    t.exports = {
      name: "asec",
      category: "Trigonometry",
      syntax: ["asec(x)"],
      description: "Calculate the inverse secant of a value.",
      examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"],
      seealso: ["acos", "acot", "acsc"]
    };
  }, function (t, e) {
    t.exports = {
      name: "asech",
      category: "Trigonometry",
      syntax: ["asech(x)"],
      description: "Calculate the inverse secant of a value.",
      examples: ["asech(0.5)"],
      seealso: ["acsch", "acoth"]
    };
  }, function (t, e) {
    t.exports = {
      name: "asin",
      category: "Trigonometry",
      syntax: ["asin(x)"],
      description: "Compute the inverse sine of a value in radians.",
      examples: ["asin(0.5)", "asin(sin(2.3))"],
      seealso: ["sin", "acos", "atan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "asinh",
      category: "Trigonometry",
      syntax: ["asinh(x)"],
      description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
      examples: ["asinh(0.5)"],
      seealso: ["acosh", "atanh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "atan",
      category: "Trigonometry",
      syntax: ["atan(x)"],
      description: "Compute the inverse tangent of a value in radians.",
      examples: ["atan(0.5)", "atan(tan(2.3))"],
      seealso: ["tan", "acos", "asin"]
    };
  }, function (t, e) {
    t.exports = {
      name: "atan2",
      category: "Trigonometry",
      syntax: ["atan2(y, x)"],
      description: "Computes the principal value of the arc tangent of y/x in radians.",
      examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"],
      seealso: ["sin", "cos", "tan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "atanh",
      category: "Trigonometry",
      syntax: ["atanh(x)"],
      description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
      examples: ["atanh(0.5)"],
      seealso: ["acosh", "asinh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cos",
      category: "Trigonometry",
      syntax: ["cos(x)"],
      description: "Compute the cosine of x in radians.",
      examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"],
      seealso: ["acos", "sin", "tan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cosh",
      category: "Trigonometry",
      syntax: ["cosh(x)"],
      description: "Compute the hyperbolic cosine of x in radians.",
      examples: ["cosh(0.5)"],
      seealso: ["sinh", "tanh", "coth"]
    };
  }, function (t, e) {
    t.exports = {
      name: "cot",
      category: "Trigonometry",
      syntax: ["cot(x)"],
      description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
      examples: ["cot(2)", "1 / tan(2)"],
      seealso: ["sec", "csc", "tan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "coth",
      category: "Trigonometry",
      syntax: ["coth(x)"],
      description: "Compute the hyperbolic cotangent of x in radians.",
      examples: ["coth(2)", "1 / tanh(2)"],
      seealso: ["sech", "csch", "tanh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "csc",
      category: "Trigonometry",
      syntax: ["csc(x)"],
      description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
      examples: ["csc(2)", "1 / sin(2)"],
      seealso: ["sec", "cot", "sin"]
    };
  }, function (t, e) {
    t.exports = {
      name: "csch",
      category: "Trigonometry",
      syntax: ["csch(x)"],
      description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
      examples: ["csch(2)", "1 / sinh(2)"],
      seealso: ["sech", "coth", "sinh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sec",
      category: "Trigonometry",
      syntax: ["sec(x)"],
      description: "Compute the secant of x in radians. Defined as 1/cos(x)",
      examples: ["sec(2)", "1 / cos(2)"],
      seealso: ["cot", "csc", "cos"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sech",
      category: "Trigonometry",
      syntax: ["sech(x)"],
      description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
      examples: ["sech(2)", "1 / cosh(2)"],
      seealso: ["coth", "csch", "cosh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sin",
      category: "Trigonometry",
      syntax: ["sin(x)"],
      description: "Compute the sine of x in radians.",
      examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"],
      seealso: ["asin", "cos", "tan"]
    };
  }, function (t, e) {
    t.exports = {
      name: "sinh",
      category: "Trigonometry",
      syntax: ["sinh(x)"],
      description: "Compute the hyperbolic sine of x in radians.",
      examples: ["sinh(0.5)"],
      seealso: ["cosh", "tanh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "tan",
      category: "Trigonometry",
      syntax: ["tan(x)"],
      description: "Compute the tangent of x in radians.",
      examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"],
      seealso: ["atan", "sin", "cos"]
    };
  }, function (t, e) {
    t.exports = {
      name: "tanh",
      category: "Trigonometry",
      syntax: ["tanh(x)"],
      description: "Compute the hyperbolic tangent of x in radians.",
      examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"],
      seealso: ["sinh", "cosh"]
    };
  }, function (t, e) {
    t.exports = {
      name: "to",
      category: "Units",
      syntax: ["x to unit", "to(x, unit)"],
      description: "Change the unit of a value.",
      examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "clone",
      category: "Utils",
      syntax: ["clone(x)"],
      description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
      examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'],
      seealso: []
    };
  }, function (t, e) {
    t.exports = {
      name: "format",
      category: "Utils",
      syntax: ["format(value)", "format(value, precision)"],
      description: "Format a value of any type as string.",
      examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"],
      seealso: ["print"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isInteger",
      category: "Utils",
      syntax: ["isInteger(x)"],
      description: "Test whether a value is an integer number.",
      examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"],
      seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isNaN",
      category: "Utils",
      syntax: ["isNaN(x)"],
      description: "Test whether a value is NaN (not a number)",
      examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"],
      seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isNegative",
      category: "Utils",
      syntax: ["isNegative(x)"],
      description: "Test whether a value is negative: smaller than zero.",
      examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"],
      seealso: ["isInteger", "isNumeric", "isPositive", "isZero"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isNumeric",
      category: "Utils",
      syntax: ["isNumeric(x)"],
      description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
      examples: ["isNumeric(2)", "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", 'isNumeric("3")', "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'],
      seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isPositive",
      category: "Utils",
      syntax: ["isPositive(x)"],
      description: "Test whether a value is positive: larger than zero.",
      examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"],
      seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isPrime",
      category: "Utils",
      syntax: ["isPrime(x)"],
      description: "Test whether a value is prime: has no divisors other than itself and one.",
      examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"],
      seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
    };
  }, function (t, e) {
    t.exports = {
      name: "isZero",
      category: "Utils",
      syntax: ["isZero(x)"],
      description: "Test whether a value is zero.",
      examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"],
      seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"]
    };
  }, function (t, e) {
    t.exports = {
      name: "typeof",
      category: "Utils",
      syntax: ["typeof(x)"],
      description: "Get the type of a variable.",
      examples: ["typeof(3.5)", "typeof(2 - 4i)", "typeof(45 deg)", 'typeof("hello world")'],
      seealso: []
    };
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(54));
      return o("compile", {
        string: function string(t) {
          return a(t).compile();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, function (t) {
            return a(t).compile();
          });
        }
      });
    }

    var i = n(1);
    e.name = "compile", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(54));
      return o("compile", {
        string: function string(t) {
          var e = {};
          return a(t).compile().eval(e);
        },
        "string, Object": function stringObject(t, e) {
          return a(t).compile().eval(e);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          var e = {};
          return i(t, function (t) {
            return a(t).compile().eval(e);
          });
        },
        "Array | Matrix, Object": function ArrayMatrixObject(t, e) {
          return i(t, function (t) {
            return a(t).compile().eval(e);
          });
        }
      });
    }

    var i = n(1);
    e.name = "eval", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i, o) {
      var a = r(n(107));
      return i("help", {
        any: function any(e) {
          var n,
              r = e;
          if ("string" != typeof e) for (n in o) {
            if (o.hasOwnProperty(n) && e === o[n]) {
              r = n;
              break;
            }
          }
          var i = a[r];
          if (!i) throw new Error('No documentation found on "' + r + '"');
          return new t.Help(i);
        }
      });
    }

    e.math = !0, e.name = "help", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(367), n(368), n(369), n(371), n(108)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(54));
      return i("parse", {
        "string | Array | Matrix": o,
        "string | Array | Matrix, Object": o
      });
    }

    e.name = "parse", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(107), n(370), n(374), n(379), n(192), n(54), n(104)];
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      function i() {
        throw new Error("UpdateNode is deprecated. Use AssignmentNode instead.");
      }

      return i;
    }

    e.name = "UpdateNode", e.path = "expression.node", e.factory = n;
  }, function (t, e, n) {
    t.exports = [n(109), n(75), n(110), n(111), n(112), n(76), n(114), n(113), n(77), n(14), n(115), n(116), n(117), n(78), n(40), n(373)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(61)),
          s = r(n(2));
      return function (t, e, n) {
        try {
          if (Array.isArray(t)) return s(t).subset(e, n).valueOf();
          if (t && "function" == typeof t.subset) return t.subset(e, n);
          if ("string" == typeof t) return a(t, e, n);

          if ("object" == typeof t) {
            if (!e.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
            return t[e.getObjectProperty()] = n, t;
          }

          throw new TypeError("Cannot apply index: unsupported type of object");
        } catch (t) {
          throw i(t);
        }
      };
    }

    var i = n(34).transform;
    e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(131));
      return o("concat", {
        "...any": function any(t) {
          var e = t.length - 1,
              n = t[e];
          "number" == typeof n ? t[e] = n - 1 : n && n.isBigNumber === !0 && (t[e] = n.minus(1));

          try {
            return a.apply(null, t);
          } catch (t) {
            throw i(t);
          }
        }
      });
    }

    var i = n(34).transform;
    e.name = "concat", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e, n) {
        var r, i;
        if (t[0] && (r = t[0].compile().eval(n)), t[1]) if (t[1] && t[1].isSymbolNode) i = t[1].compile().eval(n);else {
          var o = n || {},
              s = t[1].filter(function (t) {
            return t && t.isSymbolNode && !(t.name in e) && !(t.name in o);
          })[0],
              u = Object.create(o),
              c = t[1].compile();
          if (!s) throw new Error("No undefined variable found in filter equation");
          var l = s.name;

          i = function i(t) {
            return u[l] = t, c.eval(u);
          };
        }
        return a(r, i);
      }

      var a = r(n(133));
      r(n(40));
      return o.rawArgs = !0, o;
    }

    n(32).maxArgumentCount;
    e.name = "filter", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      r(n(134));
      return o("forEach", {
        "Array | Matrix, function": function ArrayMatrixFunction(t, e) {
          var n = i(e),
              r = function r(i, o) {
            Array.isArray(i) ? i.forEach(function (t, e) {
              r(t, o.concat(e + 1));
            }) : 1 === n ? e(i) : 2 === n ? e(i, o) : e(i, o, t);
          };

          r(t.valueOf(), []);
        }
      });
    }

    var i = n(32).maxArgumentCount;
    e.name = "forEach", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(376), n(377), n(378), n(380), n(381), n(382), n(383), n(384), n(385), n(386)];
  }, function (t, e) {
    "use strict";

    function n(t, e, n) {
      return function () {
        for (var e = [], n = 0, r = arguments.length; n < r; n++) {
          var i = arguments[n];
          if (i && i.isRange === !0) i.start--, i.end -= i.step > 0 ? 0 : 2;else if (i && i.isSet === !0) i = i.map(function (t) {
            return t - 1;
          });else if (i && (i.isArray === !0 || i.isMatrix)) i = i.map(function (t) {
            return t - 1;
          });else if ("number" == typeof i) i--;else if (i && i.isBigNumber === !0) i = i.toNumber() - 1;else if ("string" != typeof i) throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
          e[n] = i;
        }

        var o = new t.Index();
        return t.Index.apply(o, e), o;
      };
    }

    e.name = "index", e.path = "expression.transform", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = (r(n(136)), r(n(2)));
      return o("max", {
        "Array, function": function ArrayFunction(t, e) {
          return i(t, e, t);
        },
        "Matrix, function": function MatrixFunction(t, e) {
          return a(i(t.valueOf(), e, t));
        }
      });
    }

    function i(t, e, n) {
      function r(t, o) {
        return Array.isArray(t) ? t.map(function (t, e) {
          return r(t, o.concat(e + 1));
        }) : 1 === i ? e(t) : 2 === i ? e(t, o) : e(t, o, n);
      }

      var i = o(e);
      return r(t, []);
    }

    var o = n(32).maxArgumentCount;
    e.name = "map", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(141));
      return a("max", {
        "...any": function any(t) {
          if (2 == t.length && o(t[0])) {
            var e = t[1];
            "number" == typeof e ? t[1] = e - 1 : e && e.isBigNumber === !0 && (t[1] = e.minus(1));
          }

          try {
            return s.apply(null, t);
          } catch (t) {
            throw i(t);
          }
        }
      });
    }

    var i = n(34).transform,
        o = n(47);
    e.name = "max", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(142));
      return a("mean", {
        "...any": function any(t) {
          if (2 == t.length && o(t[0])) {
            var e = t[1];
            "number" == typeof e ? t[1] = e - 1 : e && e.isBigNumber === !0 && (t[1] = e.minus(1));
          }

          try {
            return s.apply(null, t);
          } catch (t) {
            throw i(t);
          }
        }
      });
    }

    var i = n(34).transform,
        o = n(47);
    e.name = "mean", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(143));
      return a("min", {
        "...any": function any(t) {
          if (2 == t.length && o(t[0])) {
            var e = t[1];
            "number" == typeof e ? t[1] = e - 1 : e && e.isBigNumber === !0 && (t[1] = e.minus(1));
          }

          try {
            return s.apply(null, t);
          } catch (t) {
            throw i(t);
          }
        }
      });
    }

    var i = n(34).transform,
        o = n(47);
    e.name = "min", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(137));
      return i("range", {
        "...any": function any(t) {
          var e = t.length - 1,
              n = t[e];
          return "boolean" != typeof n && t.push(!0), o.apply(null, t);
        }
      });
    }

    e.name = "range", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(61));
      return o("subset", {
        "...any": function any(t) {
          try {
            return a.apply(null, t);
          } catch (t) {
            throw i(t);
          }
        }
      });
    }

    var i = n(34).transform;
    e.name = "subset", e.path = "expression.transform", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(119), n(120), n(121), n(388), n(122)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(2)),
          s = r(n(119)),
          u = r(n(120)),
          c = r(n(394)),
          l = r(n(79)),
          h = r(n(122)),
          f = r(n(121)),
          p = o("lusolve", {
        "Array, Array | Matrix": function ArrayArrayMatrix(t, e) {
          t = a(t);
          var n = s(t),
              r = d(n.L, n.U, n.p, null, e);
          return r.valueOf();
        },
        "DenseMatrix, Array | Matrix": function DenseMatrixArrayMatrix(t, e) {
          var n = s(t);
          return d(n.L, n.U, n.p, null, e);
        },
        "SparseMatrix, Array | Matrix": function SparseMatrixArrayMatrix(t, e) {
          var n = s(t);
          return d(n.L, n.U, n.p, null, e);
        },
        "SparseMatrix, Array | Matrix, number, number": function SparseMatrixArrayMatrixNumberNumber(t, e, n, r) {
          var i = u(t, n, r);
          return d(i.L, i.U, i.p, i.q, e);
        },
        "Object, Array | Matrix": function ObjectArrayMatrix(t, e) {
          return d(t.L, t.U, t.p, t.q, e);
        }
      }),
          m = function m(t) {
        if (t && t.isMatrix === !0) return t;
        if (i(t)) return a(t);
        throw new TypeError("Invalid Matrix LU decomposition");
      },
          d = function d(t, e, n, r, i) {
        t = m(t), e = m(e), i = l(t, i, !1), n && (i._data = c(n, i._data));
        var o = f(t, i),
            a = h(e, o);
        return r && (a._data = c(r, a._data)), a;
      };

      return p;
    }

    var i = Array.isArray;
    e.name = "lusolve", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(80)),
          o = r(n(393)),
          a = r(n(125)),
          s = r(n(18)),
          u = r(n(13)),
          c = r(n(62)),
          l = function l(t, e) {
        if (!e || t <= 0 || t > 3) return null;
        var n = e._size,
            r = n[0],
            s = n[1],
            u = 0,
            c = Math.max(16, 10 * Math.sqrt(s));
        c = Math.min(s - 2, c);
        var l = h(t, e, r, s, c);
        o(l, d, null);

        for (var g, v, y, x, w, b, _, E, M, T, N, S, A, O, C, P, R = l._index, I = l._ptr, k = I[s], z = [], B = [], L = 0, D = s + 1, j = 2 * (s + 1), F = 3 * (s + 1), U = 4 * (s + 1), q = 5 * (s + 1), H = 6 * (s + 1), W = 7 * (s + 1), G = z, $ = f(s, I, B, L, F, G, j, W, D, H, U, q), V = p(s, I, B, q, U, H, c, D, F, G, j), Z = 0; V < s;) {
          for (y = -1; Z < s && (y = B[F + Z]) == -1; Z++) {
            ;
          }

          B[j + y] != -1 && (G[B[j + y]] = -1), B[F + Z] = B[j + y];
          var X = B[U + y],
              Y = B[D + y];
          V += Y;
          var K = 0;
          B[D + y] = -Y;
          var J = I[y],
              Q = 0 === X ? J : k,
              tt = Q;

          for (x = 1; x <= X + 1; x++) {
            for (x > X ? (b = y, _ = J, E = B[L + y] - X) : (b = R[J++], _ = I[b], E = B[L + b]), w = 1; w <= E; w++) {
              g = R[_++], (M = B[D + g]) <= 0 || (K += M, B[D + g] = -M, R[tt++] = g, B[j + g] != -1 && (G[B[j + g]] = G[g]), G[g] != -1 ? B[j + G[g]] = B[j + g] : B[F + B[q + g]] = B[j + g]);
            }

            b != y && (I[b] = i(y), B[H + b] = 0);
          }

          for (0 !== X && (k = tt), B[q + y] = K, I[y] = Q, B[L + y] = tt - Q, B[U + y] = -2, $ = m($, u, B, H, s), T = Q; T < tt; T++) {
            if (g = R[T], !((N = B[U + g]) <= 0)) {
              M = -B[D + g];
              var et = $ - M;

              for (J = I[g], S = I[g] + N - 1; J <= S; J++) {
                b = R[J], B[H + b] >= $ ? B[H + b] -= M : 0 !== B[H + b] && (B[H + b] = B[q + b] + et);
              }
            }
          }

          for (T = Q; T < tt; T++) {
            for (g = R[T], S = I[g], A = S + B[U + g] - 1, O = S, C = 0, P = 0, J = S; J <= A; J++) {
              if (b = R[J], 0 !== B[H + b]) {
                var nt = B[H + b] - $;
                nt > 0 ? (P += nt, R[O++] = b, C += b) : (I[b] = i(y), B[H + b] = 0);
              }
            }

            B[U + g] = O - S + 1;
            var rt = O,
                it = S + B[L + g];

            for (J = A + 1; J < it; J++) {
              v = R[J];
              var ot = B[D + v];
              ot <= 0 || (P += ot, R[O++] = v, C += v);
            }

            0 === P ? (I[g] = i(y), M = -B[D + g], K -= M, Y += M, V += M, B[D + g] = 0, B[U + g] = -1) : (B[q + g] = Math.min(B[q + g], P), R[O] = R[rt], R[rt] = R[S], R[S] = y, B[L + g] = O - S + 1, C = (C < 0 ? -C : C) % s, B[j + g] = B[W + C], B[W + C] = g, G[g] = C);
          }

          for (B[q + y] = K, u = Math.max(u, K), $ = m($ + u, u, B, H, s), T = Q; T < tt; T++) {
            if (g = R[T], !(B[D + g] >= 0)) for (C = G[g], g = B[W + C], B[W + C] = -1; g != -1 && B[j + g] != -1; g = B[j + g], $++) {
              for (E = B[L + g], N = B[U + g], J = I[g] + 1; J <= I[g] + E - 1; J++) {
                B[H + R[J]] = $;
              }

              var at = g;

              for (v = B[j + g]; v != -1;) {
                var st = B[L + v] === E && B[U + v] === N;

                for (J = I[v] + 1; st && J <= I[v] + E - 1; J++) {
                  B[H + R[J]] != $ && (st = 0);
                }

                st ? (I[v] = i(g), B[D + g] += B[D + v], B[D + v] = 0, B[U + v] = -1, v = B[j + v], B[j + at] = v) : (at = v, v = B[j + v]);
              }
            }
          }

          for (J = Q, T = Q; T < tt; T++) {
            g = R[T], (M = -B[D + g]) <= 0 || (B[D + g] = M, P = B[q + g] + K - M, P = Math.min(P, s - V - M), B[F + P] != -1 && (G[B[F + P]] = g), B[j + g] = B[F + P], G[g] = -1, B[F + P] = g, Z = Math.min(Z, P), B[q + g] = P, R[J++] = g);
          }

          B[D + y] = Y, 0 === (B[L + y] = J - Q) && (I[y] = -1, B[H + y] = 0), 0 !== X && (k = J);
        }

        for (g = 0; g < s; g++) {
          I[g] = i(I[g]);
        }

        for (v = 0; v <= s; v++) {
          B[F + v] = -1;
        }

        for (v = s; v >= 0; v--) {
          B[D + v] > 0 || (B[j + v] = B[F + I[v]], B[F + I[v]] = v);
        }

        for (b = s; b >= 0; b--) {
          B[D + b] <= 0 || I[b] != -1 && (B[j + b] = B[F + I[b]], B[F + I[b]] = b);
        }

        for (y = 0, g = 0; g <= s; g++) {
          I[g] == -1 && (y = a(g, y, B, F, j, z, H));
        }

        return z.splice(z.length - 1, 1), z;
      },
          h = function h(t, e, n, r, i) {
        var o = c(e);
        if (1 === t && r === n) return s(e, o);

        if (2 == t) {
          for (var a = o._index, l = o._ptr, h = 0, f = 0; f < n; f++) {
            var p = l[f];
            if (l[f] = h, !(l[f + 1] - p > i)) for (var m = l[f + 1]; p < m; p++) {
              a[h++] = a[p];
            }
          }

          return l[n] = h, e = c(o), u(o, e);
        }

        return u(o, e);
      },
          f = function f(t, e, n, r, i, o, a, s, u, c, l, h) {
        for (var f = 0; f < t; f++) {
          n[r + f] = e[f + 1] - e[f];
        }

        n[r + t] = 0;

        for (var p = 0; p <= t; p++) {
          n[i + p] = -1, o[p] = -1, n[a + p] = -1, n[s + p] = -1, n[u + p] = 1, n[c + p] = 1, n[l + p] = 0, n[h + p] = n[r + p];
        }

        var d = m(0, 0, n, c, t);
        return n[l + t] = -2, e[t] = -1, n[c + t] = 0, d;
      },
          p = function p(t, e, n, r, o, a, s, u, c, l, h) {
        for (var f = 0, p = 0; p < t; p++) {
          var m = n[r + p];
          if (0 === m) n[o + p] = -2, f++, e[p] = -1, n[a + p] = 0;else if (m > s) n[u + p] = 0, n[o + p] = -1, f++, e[p] = i(t), n[u + t]++;else {
            var d = n[c + m];
            d != -1 && (l[d] = p), n[h + p] = n[c + m], n[c + m] = p;
          }
        }

        return f;
      },
          m = function m(t, e, n, r, i) {
        if (t < 2 || t + e < 0) {
          for (var o = 0; o < i; o++) {
            0 !== n[r + o] && (n[r + o] = 1);
          }

          t = 2;
        }

        return t;
      },
          d = function d(t, e) {
        return t != e;
      };

      return l;
    }

    e.name = "cs_amd", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(62)),
          o = r(n(395)),
          a = function a(t, e, n, r) {
        if (!t || !e || !n) return null;

        var a,
            s,
            u,
            c,
            l,
            h,
            f,
            p = t._size,
            m = p[0],
            d = p[1],
            g = 4 * d + (r ? d + m + 1 : 0),
            v = [],
            y = 0,
            x = d,
            w = 2 * d,
            b = 3 * d,
            _ = 4 * d,
            E = 5 * d + 1;

        for (u = 0; u < g; u++) {
          v[u] = -1;
        }

        var M = [],
            T = i(t),
            N = T._index,
            S = T._ptr;

        for (u = 0; u < d; u++) {
          for (s = n[u], M[s] = v[b + s] == -1 ? 1 : 0; s != -1 && v[b + s] == -1; s = e[s]) {
            v[b + s] = u;
          }
        }

        if (r) {
          for (u = 0; u < d; u++) {
            v[n[u]] = u;
          }

          for (a = 0; a < m; a++) {
            for (u = d, h = S[a], f = S[a + 1], l = h; l < f; l++) {
              u = Math.min(u, v[N[l]]);
            }

            v[E + a] = v[_ + u], v[_ + u] = a;
          }
        }

        for (a = 0; a < d; a++) {
          v[y + a] = a;
        }

        for (u = 0; u < d; u++) {
          for (s = n[u], e[s] != -1 && M[e[s]]--, c = r ? v[_ + u] : s; c != -1; c = r ? v[E + c] : -1) {
            for (l = S[c]; l < S[c + 1]; l++) {
              a = N[l];
              var A = o(a, s, v, b, x, w, y);
              A.jleaf >= 1 && M[s]++, 2 == A.jleaf && M[A.q]--;
            }
          }

          e[s] != -1 && (v[y + s] = e[s]);
        }

        for (s = 0; s < d; s++) {
          e[s] != -1 && (M[e[s]] += M[s]);
        }

        return M;
      };

      return a;
    }

    e.name = "cs_counts", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(124)),
          o = r(n(123)),
          a = r(n(402)),
          s = function s(t, e, n, r, _s2) {
        var u,
            c,
            l,
            h = e._index,
            f = e._ptr,
            p = e._size,
            m = p[1],
            d = 0;

        for (r[0] = t; d >= 0;) {
          t = r[d];
          var g = _s2 ? _s2[t] : t;
          i(f, t) || (o(f, t), r[m + d] = g < 0 ? 0 : a(f[g]));
          var v = 1;

          for (c = r[m + d], l = g < 0 ? 0 : a(f[g + 1]); c < l; c++) {
            if (u = h[c], !i(f, u)) {
              r[m + d] = c, r[++d] = u, v = 0;
              break;
            }
          }

          v && (d--, r[--n] = t);
        }

        return n;
      };

      return s;
    }

    e.name = "cs_dfs", e.path = "sparse", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t5, e) {
        if (!_t5) return null;
        var n,
            r,
            i = _t5._index,
            o = _t5._ptr,
            a = _t5._size,
            s = a[0],
            u = a[1],
            c = [],
            l = [],
            h = 0,
            f = u;
        if (e) for (n = 0; n < s; n++) {
          l[f + n] = -1;
        }

        for (var p = 0; p < u; p++) {
          c[p] = -1, l[h + p] = -1;

          for (var m = o[p], d = o[p + 1], g = m; g < d; g++) {
            var v = i[g];

            for (n = e ? l[f + v] : v; n != -1 && n < p; n = r) {
              r = l[h + n], l[h + n] = p, r == -1 && (c[n] = p);
            }

            e && (l[f + v] = p);
          }
        }

        return c;
      };

      return t;
    }

    e.name = "cs_etree", e.path = "sparse", e.factory = n;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t6, e, n) {
        for (var r = _t6._values, i = _t6._index, o = _t6._ptr, a = _t6._size, s = a[1], u = 0, c = 0; c < s; c++) {
          var l = o[c];

          for (o[c] = u; l < o[c + 1]; l++) {
            e(i[l], c, r ? r[l] : 1, n) && (i[u] = i[l], r && (r[u] = r[l]), u++);
          }
        }

        return o[s] = u, i.splice(u, i.length - u), r && r.splice(u, r.length - u), u;
      };

      return t;
    }

    e.name = "cs_fkeep", e.path = "sparse", e.factory = n;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t7, e, n) {
        var r,
            n = e.length,
            i = [];
        if (_t7) for (r = 0; r < n; r++) {
          i[_t7[r]] = e[r];
        } else for (r = 0; r < n; r++) {
          i[r] = e[r];
        }
        return i;
      };

      return t;
    }

    e.name = "cs_ipvec", e.path = "sparse", e.factory = n;
  }, function (t, e) {
    "use strict";

    function n() {
      var t = function t(_t8, e, n, r, i, o, a) {
        var s,
            u,
            c,
            l,
            h = 0;
        if (_t8 <= e || n[r + e] <= n[i + _t8]) return -1;
        if (n[i + _t8] = n[r + e], c = n[o + _t8], n[o + _t8] = e, c === -1) h = 1, l = _t8;else {
          for (h = 2, l = c; l != n[a + l]; l = n[a + l]) {
            ;
          }

          for (s = c; s != l; s = u) {
            u = n[a + s], n[a + s] = l;
          }
        }
        return {
          jleaf: h,
          q: l
        };
      };

      return t;
    }

    e.name = "cs_leaf", e.path = "sparse", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(35)),
          o = r(n(20)),
          a = r(n(13)),
          s = r(n(30)),
          u = r(n(140)),
          c = r(n(400)),
          l = t.SparseMatrix,
          h = function h(t, e, n) {
        if (!t) return null;
        var r,
            h = t._size,
            f = h[1],
            p = 100,
            m = 100;
        e && (r = e.q, p = e.lnz || p, m = e.unz || m);
        var d,
            g,
            v = [],
            y = [],
            x = [],
            w = new l({
          values: v,
          index: y,
          ptr: x,
          size: [f, f]
        }),
            b = [],
            _ = [],
            E = [],
            M = new l({
          values: b,
          index: _,
          ptr: E,
          size: [f, f]
        }),
            T = [],
            N = [],
            S = [];

        for (d = 0; d < f; d++) {
          N[d] = 0, T[d] = -1, x[d + 1] = 0;
        }

        p = 0, m = 0;

        for (var A = 0; A < f; A++) {
          x[A] = p, E[A] = m;
          var O = r ? r[A] : A,
              C = c(w, t, O, S, N, T, 1),
              P = -1,
              R = -1;

          for (g = C; g < f; g++) {
            if (d = S[g], T[d] < 0) {
              var I = i(N[d]);
              s(I, R) && (R = I, P = d);
            } else _[m] = T[d], b[m++] = N[d];
          }

          if (P == -1 || R <= 0) return null;
          T[O] < 0 && u(i(N[O]), a(R, n)) && (P = O);
          var k = N[P];

          for (_[m] = A, b[m++] = k, T[P] = A, y[p] = P, v[p++] = 1, g = C; g < f; g++) {
            d = S[g], T[d] < 0 && (y[p] = d, v[p++] = o(N[d], k)), N[d] = 0;
          }
        }

        for (x[f] = p, E[f] = m, g = 0; g < p; g++) {
          y[g] = T[y[g]];
        }

        return v.splice(p, v.length - p), y.splice(p, y.length - p), b.splice(m, b.length - m), _.splice(m, _.length - m), {
          L: w,
          U: M,
          pinv: T
        };
      };

      return h;
    }

    e.name = "cs_lu", e.path = "sparse", e.factory = r;
  }, function (t, e) {
    "use strict";

    function n(t) {
      var e = t.SparseMatrix,
          n = function n(t, _n4, r, i) {
        for (var o = t._values, a = t._index, s = t._ptr, u = t._size, c = t._datatype, l = u[0], h = u[1], f = i && t._values ? [] : null, p = [], m = [], d = 0, g = 0; g < h; g++) {
          m[g] = d;

          for (var v = r ? r[g] : g, y = s[v], x = s[v + 1], w = y; w < x; w++) {
            var b = _n4 ? _n4[a[w]] : a[w];
            p[d] = b, f && (f[d] = o[w]), d++;
          }
        }

        return m[h] = d, new e({
          values: f,
          index: p,
          ptr: m,
          size: [l, h],
          datatype: c
        });
      };

      return n;
    }

    e.name = "cs_permute", e.path = "sparse", e.factory = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(125)),
          o = function o(t, e) {
        if (!t) return null;
        var n,
            r = 0,
            o = [],
            a = [],
            s = 0,
            u = e,
            c = 2 * e;

        for (n = 0; n < e; n++) {
          a[s + n] = -1;
        }

        for (n = e - 1; n >= 0; n--) {
          t[n] != -1 && (a[u + n] = a[s + t[n]], a[s + t[n]] = n);
        }

        for (n = 0; n < e; n++) {
          t[n] == -1 && (r = i(n, r, a, s, u, o, c));
        }

        return o;
      };

      return o;
    }

    e.name = "cs_post", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(391)),
          o = r(n(124)),
          a = r(n(123)),
          s = function s(t, e, n, r, _s3) {
        var u,
            c,
            l,
            h = t._ptr,
            f = t._size,
            p = e._index,
            m = e._ptr,
            d = f[1],
            g = d;

        for (c = m[n], l = m[n + 1], u = c; u < l; u++) {
          var v = p[u];
          o(h, v) || (g = i(v, t, g, r, _s3));
        }

        for (u = g; u < d; u++) {
          a(h, r[u]);
        }

        return g;
      };

      return s;
    }

    e.name = "cs_reach", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(20)),
          o = r(n(13)),
          a = r(n(24)),
          s = r(n(399)),
          u = function u(t, e, n, r, _u, c, l) {
        var h,
            f,
            p,
            m,
            d = t._values,
            g = t._index,
            v = t._ptr,
            y = t._size,
            x = y[1],
            w = e._values,
            b = e._index,
            _ = e._ptr,
            E = s(t, e, n, r, c);

        for (h = E; h < x; h++) {
          _u[r[h]] = 0;
        }

        for (f = _[n], p = _[n + 1], h = f; h < p; h++) {
          _u[b[h]] = w[h];
        }

        for (var M = E; M < x; M++) {
          var T = r[M],
              N = c ? c[T] : T;
          if (!(N < 0)) for (f = v[N], p = v[N + 1], _u[T] = i(_u[T], d[l ? f : p - 1]), h = l ? f + 1 : f, m = l ? p : p - 1; h < m; h++) {
            var S = g[h];
            _u[S] = a(_u[S], o(d[h], _u[T]));
          }
        }

        return E;
      };

      return u;
    }

    e.name = "cs_spsolve", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(389)),
          o = r(n(397)),
          a = r(n(392)),
          s = r(n(398)),
          u = r(n(390)),
          c = function c(t, e, n) {
        var r,
            c = e._ptr,
            h = e._size,
            f = h[1],
            p = {};
        if (p.q = i(t, e), t && !p.q) return null;

        if (n) {
          var m = t ? o(e, null, p.q, 0) : e;
          p.parent = a(m, 1);
          var d = s(p.parent, f);
          if (p.cp = u(m, p.parent, d, 1), m && p.parent && p.cp && l(m, p)) for (p.unz = 0, r = 0; r < f; r++) {
            p.unz += p.cp[r];
          }
        } else p.unz = 4 * c[f] + f, p.lnz = p.unz;

        return p;
      },
          l = function l(t, e) {
        var n = t._ptr,
            r = t._index,
            i = t._size,
            o = i[0],
            a = i[1];
        e.pinv = [], e.leftmost = [];
        var s,
            u,
            c,
            l,
            h,
            f = e.parent,
            p = e.pinv,
            m = e.leftmost,
            d = [],
            g = 0,
            v = o,
            y = o + a,
            x = o + 2 * a;

        for (u = 0; u < a; u++) {
          d[v + u] = -1, d[y + u] = -1, d[x + u] = 0;
        }

        for (s = 0; s < o; s++) {
          m[s] = -1;
        }

        for (u = a - 1; u >= 0; u--) {
          for (l = n[u], h = n[u + 1], c = l; c < h; c++) {
            m[r[c]] = u;
          }
        }

        for (s = o - 1; s >= 0; s--) {
          p[s] = -1, u = m[s], u != -1 && (0 === d[x + u]++ && (d[y + u] = s), d[g + s] = d[v + u], d[v + u] = s);
        }

        for (e.lnz = 0, e.m2 = o, u = 0; u < a; u++) {
          if (s = d[v + u], e.lnz++, s < 0 && (s = e.m2++), p[s] = u, !(--x[u] <= 0)) {
            e.lnz += d[x + u];
            var w = f[u];
            w != -1 && (0 === d[x + w] && (d[y + w] = d[y + u]), d[g + d[y + u]] = d[v + w], d[v + w] = d[g + s], d[x + w] += d[x + u]);
          }
        }

        for (s = 0; s < o; s++) {
          p[s] < 0 && (p[s] = u++);
        }

        return !0;
      };

      return c;
    }

    e.name = "cs_sqr", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      var i = r(n(80)),
          o = function o(t) {
        return t < 0 ? i(t) : t;
      };

      return o;
    }

    e.name = "cs_unflip", e.path = "sparse", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(n, r) {
        var i = n.arg() / 3,
            a = n.abs(),
            s = new t.Complex(o(a), 0).mul(new t.Complex(0, i).exp());

        if (r) {
          var u = [s, new t.Complex(o(a), 0).mul(new t.Complex(0, i + 2 * Math.PI / 3).exp()), new t.Complex(o(a), 0).mul(new t.Complex(0, i - 2 * Math.PI / 3).exp())];
          return "Array" === e.matrix ? u : h(u);
        }

        return s;
      }

      function u(e) {
        if (e.value && e.value.isComplex) {
          var n = e.clone();
          return n.value = 1, n = n.pow(1 / 3), n.value = s(e.value), n;
        }

        var r = l(e.value);
        r && (e.value = c(e.value));
        var i;
        i = e.value && e.value.isBigNumber ? new t.BigNumber(1).div(3) : e.value && e.value.isFraction ? new t.Fraction(1, 3) : 1 / 3;
        var n = e.pow(i);
        return r && (n.value = c(n.value)), n;
      }

      var c = r(n(43)),
          l = r(n(56)),
          h = r(n(2)),
          f = a("cbrt", {
        number: o,
        Complex: s,
        "Complex, boolean": s,
        BigNumber: function BigNumber(t) {
          return t.cbrt();
        },
        Unit: u,
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, f, !0);
        }
      });
      return f.toTex = {
        1: "\\sqrt[3]{${args[0]}}"
      }, f;
    }

    var i = n(1),
        o = Math.cbrt || function (t) {
      if (0 === t) return t;
      var e,
          n = t < 0;
      return n && (t = -t), isFinite(t) ? (e = Math.exp(Math.log(t) / 3), e = (t / (e * e) + 2 * e) / 3) : e = t, n ? -e : e;
    };

    e.name = "cbrt", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("ceil", {
        number: Math.ceil,
        Complex: function Complex(t) {
          return t.ceil();
        },
        BigNumber: function BigNumber(t) {
          return t.ceil();
        },
        Fraction: function Fraction(t) {
          return t.ceil();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\left\\lceil${args[0]}\\right\\rceil"
      }, o;
    }

    var i = n(1);
    e.name = "ceil", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("cube", {
        number: function number(t) {
          return t * t * t;
        },
        Complex: function Complex(t) {
          return t.mul(t).mul(t);
        },
        BigNumber: function BigNumber(t) {
          return t.times(t).times(t);
        },
        Fraction: function Fraction(t) {
          return t.pow(3);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        },
        Unit: function Unit(t) {
          return t.pow(3);
        }
      });
      return o.toTex = {
        1: "\\left(${args[0]}\\right)^3"
      }, o;
    }

    var i = n(1);
    e.name = "cube", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(26)),
          s = n(4),
          u = r(n(25)),
          c = r(n(154)),
          l = r(n(16)),
          h = r(n(7)),
          f = r(n(6)),
          p = i("dotMultiply", {
        "any, any": a,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, a, !1);
                  break;

                default:
                  n = u(e, t, a, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, a, !1);
                  break;

                default:
                  n = h(t, e, a);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(o(t), o(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(o(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, o(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, a, !1);
              break;

            default:
              n = f(t, e, a, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, a, !0);
              break;

            default:
              n = f(e, t, a, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(o(t), e, a, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(o(e), t, a, !0).valueOf();
        }
      });
      return p.toTex = {
        2: "\\left(${args[0]}" + s.operators.dotMultiply + "${args[1]}\\right)"
      }, p;
    }

    e.name = "dotMultiply", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(42)),
          s = n(4),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(16)),
          h = r(n(17)),
          f = r(n(7)),
          p = r(n(6)),
          m = i("dotPow", {
        "any, any": a,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, a, !1);
                  break;

                default:
                  n = u(e, t, a, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, a, !1);
                  break;

                default:
                  n = f(t, e, a);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(o(t), o(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(o(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, o(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, m, !1);
              break;

            default:
              n = p(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, m, !0);
              break;

            default:
              n = p(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(o(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(o(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + s.operators.dotPow + "${args[1]}\\right)"
      }, m;
    }

    e.name = "dotPow", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("exp", {
        number: Math.exp,
        Complex: function Complex(t) {
          return t.exp();
        },
        BigNumber: function BigNumber(t) {
          return t.exp();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\exp\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "exp", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("floor", {
        number: Math.floor,
        Complex: function Complex(t) {
          return t.floor();
        },
        BigNumber: function BigNumber(t) {
          return t.floor();
        },
        Fraction: function Fraction(t) {
          return t.floor();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\left\\lfloor${args[0]}\\right\\rfloor"
      }, o;
    }

    var i = n(1);
    e.name = "floor", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(e, n) {
        if (!e.isInt() || !n.isInt()) throw new Error("Parameters in function gcd must be integer numbers");

        for (var r = new t.BigNumber(0); !n.isZero();) {
          var i = e.mod(n);
          e = n, n = i;
        }

        return e.lt(r) ? e.neg() : e;
      }

      var s = r(n(2)),
          u = r(n(31)),
          c = r(n(87)),
          l = r(n(36)),
          h = r(n(7)),
          f = r(n(6)),
          p = o("gcd", {
        "number, number": i,
        "BigNumber, BigNumber": a,
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.gcd(e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, p);
                  break;

                default:
                  n = u(e, t, p, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, p, !1);
                  break;

                default:
                  n = h(t, e, p);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, s(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, p, !1);
              break;

            default:
              n = f(t, e, p, !1);
          }

          return n;
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, p, !0);
              break;

            default:
              n = f(e, t, p, !0);
          }

          return n;
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return f(s(t), e, p, !1).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return f(s(e), t, p, !0).valueOf();
        },
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(t, e, n) {
          for (var r = p(t, e), i = 0; i < n.length; i++) {
            r = p(r, n[i]);
          }

          return r;
        }
      });
      return p.toTex = "\\gcd\\left(${args}\\right)", p;
    }

    function i(t, e) {
      if (!o(t) || !o(e)) throw new Error("Parameters in function gcd must be integer numbers");

      for (var n; 0 != e;) {
        n = t % e, t = e, e = n;
      }

      return t < 0 ? -t : t;
    }

    var o = n(3).isInteger;
    e.name = "gcd", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t) {
        for (var e = 0, n = 0, r = 0; r < t.length; r++) {
          var i = s(t[r]);
          f(n, i) ? (e = l(e, l(c(n, i), c(n, i))), e = u(e, 1), n = i) : e = u(e, p(i) ? l(c(i, n), c(i, n)) : i);
        }

        return l(n, h(e));
      }

      var s = r(n(35)),
          u = r(n(22)),
          c = r(n(20)),
          l = r(n(26)),
          h = r(n(60)),
          f = r(n(45)),
          p = r(n(65)),
          m = o("hypot", {
        "... number | BigNumber": a,
        Array: function Array(t) {
          return m.apply(m, i(t));
        },
        Matrix: function Matrix(t) {
          return m.apply(m, i(t.toArray()));
        }
      });
      return m.toTex = "\\hypot\\left(${args}\\right)", m;
    }

    var i = n(8).flatten;
    e.name = "hypot", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(35), n(18), n(22), n(403), n(404), n(405), n(41), n(126), n(406), n(407), n(408), n(127), n(409), n(410), n(411), n(413), n(128), n(414), n(415), n(13), n(416), n(417), n(42), n(418), n(419), n(60), n(420), n(24), n(43), n(421), n(422)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(e, n) {
        if (!e.isInt() || !n.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
        if (e.isZero() || n.isZero()) return new t.BigNumber(0);

        for (var r = e.times(n); !n.isZero();) {
          var i = n;
          n = e.mod(i), e = i;
        }

        return r.div(e).abs();
      }

      var s = r(n(2)),
          u = r(n(25)),
          c = r(n(67)),
          l = r(n(16)),
          h = r(n(7)),
          f = r(n(6)),
          p = o("lcm", {
        "number, number": i,
        "BigNumber, BigNumber": a,
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.lcm(e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, p);
                  break;

                default:
                  n = u(e, t, p, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, p, !1);
                  break;

                default:
                  n = h(t, e, p);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, s(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, p, !1);
              break;

            default:
              n = f(t, e, p, !1);
          }

          return n;
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, p, !0);
              break;

            default:
              n = f(e, t, p, !0);
          }

          return n;
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return f(s(t), e, p, !1).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return f(s(e), t, p, !0).valueOf();
        },
        "Array | Matrix | number | BigNumber, Array | Matrix | number | BigNumber, ...Array | Matrix | number | BigNumber": function ArrayMatrixNumberBigNumberArrayMatrixNumberBigNumberArrayMatrixNumberBigNumber(t, e, n) {
          for (var r = p(t, e), i = 0; i < n.length; i++) {
            r = p(r, n[i]);
          }

          return r;
        }
      });
      return p.toTex = void 0, p;
    }

    function i(t, e) {
      if (!o(t) || !o(e)) throw new Error("Parameters in function lcm must be integer numbers");
      if (0 == t || 0 == e) return 0;

      for (var n, r = t * e; 0 != e;) {
        n = e, e = t % n, t = n;
      }

      return Math.abs(r / t);
    }

    var o = n(3).isInteger;
    e.name = "lcm", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("log10", {
        number: function number(n) {
          return n >= 0 || e.predictable ? o(n) : new t.Complex(n, 0).log().div(Math.LN10);
        },
        Complex: function Complex(e) {
          return new t.Complex(e).log().div(Math.LN10);
        },
        BigNumber: function BigNumber(n) {
          return !n.isNegative() || e.predictable ? n.log() : new t.Complex(n.toNumber(), 0).log().div(Math.LN10);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        }
      });
      return a.toTex = {
        1: "\\log_{10}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.log10 || function (t) {
      return Math.log(t) / Math.LN10;
    };

    e.name = "log10", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        if (e > 0) return t - e * Math.floor(t / e);
        if (0 === e) return t;
        throw new Error("Cannot calculate mod for a negative divisor");
      }

      var a = r(n(2)),
          s = n(4),
          u = r(n(25)),
          c = r(n(15)),
          l = r(n(66)),
          h = r(n(16)),
          f = r(n(17)),
          p = r(n(7)),
          m = r(n(6)),
          d = i("mod", {
        "number, number": o,
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return e.isZero() ? t : t.mod(e);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return t.mod(e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, d, !1);
                  break;

                default:
                  n = u(e, t, d, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, d, !1);
                  break;

                default:
                  n = p(t, e, d);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return d(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return d(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return d(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, d, !1);
              break;

            default:
              n = m(t, e, d, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = f(e, t, d, !0);
              break;

            default:
              n = m(e, t, d, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return m(a(t), e, d, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return m(a(e), t, d, !0).valueOf();
        }
      });
      return d.toTex = {
        2: "\\left(${args[0]}" + s.operators.mod + "${args[1]}\\right)"
      }, d;
    }

    e.name = "mod", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        var n = t.size();

        if (1 == n.length) {
          if (e === Number.POSITIVE_INFINITY || "inf" === e) {
            var r = 0;
            return t.forEach(function (t) {
              var e = a(t);
              f(e, r) && (r = e);
            }, !0), r;
          }

          if (e === Number.NEGATIVE_INFINITY || "-inf" === e) {
            var i;
            return t.forEach(function (t) {
              var e = a(t);
              i && !p(e, i) || (i = e);
            }, !0), i || 0;
          }

          if ("fro" === e) return o(t, 2);

          if ("number" == typeof e && !isNaN(e)) {
            if (!h(e, 0)) {
              var m = 0;
              return t.forEach(function (t) {
                m = s(u(a(t), e), m);
              }, !0), u(m, 1 / e);
            }

            return Number.POSITIVE_INFINITY;
          }

          throw new Error("Unsupported parameter value");
        }

        if (2 == n.length) {
          if (1 === e) {
            var v = [],
                y = 0;
            return t.forEach(function (t, e) {
              var n = e[1],
                  r = s(v[n] || 0, a(t));
              f(r, y) && (y = r), v[n] = r;
            }, !0), y;
          }

          if (e === Number.POSITIVE_INFINITY || "inf" === e) {
            var x = [],
                w = 0;
            return t.forEach(function (t, e) {
              var n = e[0],
                  r = s(x[n] || 0, a(t));
              f(r, w) && (w = r), x[n] = r;
            }, !0), w;
          }

          if ("fro" === e) return c(d(l(g(t), t)));
          if (2 === e) throw new Error("Unsupported parameter value, missing implementation of matrix singular value decomposition");
          throw new Error("Unsupported parameter value");
        }
      }

      var a = r(n(35)),
          s = r(n(18)),
          u = r(n(42)),
          c = r(n(60)),
          l = r(n(13)),
          h = r(n(11)),
          f = r(n(30)),
          p = r(n(45)),
          m = r(n(2)),
          d = r(n(138)),
          g = r(n(62)),
          v = i("norm", {
        number: Math.abs,
        Complex: function Complex(t) {
          return t.abs();
        },
        BigNumber: function BigNumber(t) {
          return t.abs();
        },
        "boolean | null": function booleanNull(t) {
          return Math.abs(t);
        },
        Array: function Array(t) {
          return o(m(t), 2);
        },
        Matrix: function Matrix(t) {
          return o(t, 2);
        },
        "number | Complex | BigNumber | boolean | null, number | BigNumber | string": function numberComplexBigNumberBooleanNullNumberBigNumberString(t) {
          return v(t);
        },
        "Array, number | BigNumber | string": function ArrayNumberBigNumberString(t, e) {
          return o(m(t), e);
        },
        "Matrix, number | BigNumber | string": function MatrixNumberBigNumberString(t, e) {
          return o(t, e);
        }
      });
      return v.toTex = {
        1: "\\left\\|${args[0]}\\right\\|",
        2: void 0
      }, v;
    }

    e.name = "norm", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(e, n) {
        var r = t.BigNumber.precision,
            i = t.BigNumber.clone({
          precision: r + 2
        }),
            o = new t.BigNumber(0),
            a = new i(1),
            s = n.isNegative();
        if (s && (n = n.neg()), n.isZero()) throw new Error("Root must be non-zero");
        if (e.isNegative() && !n.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
        if (e.isZero()) return s ? new i(1 / 0) : 0;
        if (!e.isFinite()) return s ? o : e;
        var u = e.abs().pow(a.div(n));
        return u = e.isNeg() ? u.neg() : u, new t.BigNumber((s ? a.div(u) : u).toPrecision(r));
      }

      var u = r(n(2)),
          c = r(n(31)),
          l = r(n(25)),
          h = r(n(67)),
          f = r(n(16)),
          p = r(n(7)),
          m = r(n(6)),
          d = a("nthRoot", {
        number: function number(t) {
          return i(t, 2);
        },
        "number, number": i,
        BigNumber: function BigNumber(e) {
          return s(e, new t.BigNumber(2));
        },
        Complex: function Complex(t) {
          return o(t, 2);
        },
        "Complex, number": o,
        "BigNumber, BigNumber": s,
        "Array | Matrix": function ArrayMatrix(t) {
          return d(t, 2);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  if (1 !== e.density()) throw new Error("Root must be non-zero");
                  n = h(t, e, d);
                  break;

                default:
                  n = l(e, t, d, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  if (1 !== e.density()) throw new Error("Root must be non-zero");
                  n = c(t, e, d, !1);
                  break;

                default:
                  n = p(t, e, d);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return d(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return d(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return d(t, u(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = f(t, e, d, !1);
              break;

            default:
              n = m(t, e, d, !1);
          }

          return n;
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              if (1 !== e.density()) throw new Error("Root must be non-zero");
              n = f(e, t, d, !0);
              break;

            default:
              n = m(e, t, d, !0);
          }

          return n;
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return d(u(t), e).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return d(t, u(e)).valueOf();
        }
      });
      return d.toTex = {
        2: "\\sqrt[${args[1]}]{${args[0]}}"
      }, d;
    }

    function i(t, e) {
      var n = e < 0;
      if (n && (e = -e), 0 === e) throw new Error("Root must be non-zero");
      if (t < 0 && Math.abs(e) % 2 != 1) throw new Error("Root must be odd when a is negative.");
      if (0 == t) return n ? 1 / 0 : 0;
      if (!isFinite(t)) return n ? 0 : t;
      var r = Math.pow(Math.abs(t), 1 / e);
      return r = t < 0 ? -r : r, n ? 1 / r : r;
    }

    function o(t, e) {
      if (e < 0) throw new Error("Root must be greater than zero");
      if (0 === e) throw new Error("Root must be non-zero");
      if (e % 1 !== 0) throw new Error("Root must be an integer");

      for (var n = t.arg(), r = t.abs(), i = [], o = Math.pow(r, 1 / e), a = 0; a < e; a++) {
        i.push({
          r: o,
          phi: (n + 2 * Math.PI * a) / e
        });
      }

      return i;
    }

    e.name = "nthRoot", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var c = r(n(2)),
          l = r(n(11)),
          h = r(n(44)),
          f = r(n(16)),
          p = r(n(17)),
          m = r(n(6)),
          d = a("round", {
        number: Math.round,
        "number, number": function numberNumber(t, e) {
          if (!o(e)) throw new TypeError(u);
          if (e < 0 || e > 15) throw new Error("Number of decimals in function round must be in te range of 0-15");
          return i(t, e);
        },
        Complex: function Complex(t) {
          return t.round();
        },
        "Complex, number": function ComplexNumber(t, e) {
          if (e % 1) throw new TypeError(u);
          return t.round(e);
        },
        "Complex, BigNumber": function ComplexBigNumber(t, e) {
          if (!e.isInteger()) throw new TypeError(u);
          var n = e.toNumber();
          return t.round(n);
        },
        "number, BigNumber": function numberBigNumber(e, n) {
          if (!n.isInteger()) throw new TypeError(u);
          return new t.BigNumber(e).toDecimalPlaces(n.toNumber());
        },
        BigNumber: function BigNumber(t) {
          return t.toDecimalPlaces(0);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          if (!e.isInteger()) throw new TypeError(u);
          return t.toDecimalPlaces(e.toNumber());
        },
        Fraction: function Fraction(t) {
          return t.round();
        },
        "Fraction, number": function FractionNumber(t, e) {
          if (e % 1) throw new TypeError(u);
          return t.round(e);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return s(t, d, !0);
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = f(t, e, d, !1);
              break;

            default:
              n = m(t, e, d, !1);
          }

          return n;
        },
        "number | Complex | BigNumber, Matrix": function numberComplexBigNumberMatrix(t, e) {
          if (!l(t, 0)) {
            var n;

            switch (e.storage()) {
              case "sparse":
                n = p(e, t, d, !0);
                break;

              default:
                n = m(e, t, d, !0);
            }

            return n;
          }

          return h(e.size(), e.storage());
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return m(c(t), e, d, !1).valueOf();
        },
        "number | Complex | BigNumber, Array": function numberComplexBigNumberArray(t, e) {
          return m(c(e), t, d, !0).valueOf();
        }
      });
      return d.toTex = {
        1: "\\left\\lfloor${args[0]}\\right\\rceil",
        2: void 0
      }, d;
    }

    function i(t, e) {
      return parseFloat(a(t, e));
    }

    var o = n(3).isInteger,
        a = n(3).toFixed,
        s = n(1),
        u = "Number of decimals in function round must be an integer";
    e.name = "round", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("sign", {
        number: i.sign,
        Complex: function Complex(t) {
          return t.sign();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(e.cmp(0));
        },
        Fraction: function Fraction(e) {
          return new t.Fraction(e.s, 1);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return o(t, a, !0);
        },
        Unit: function Unit(t) {
          return a(t.value);
        }
      });
      return a.toTex = {
        1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(3),
        o = n(1);
    e.name = "sign", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("square", {
        number: function number(t) {
          return t * t;
        },
        Complex: function Complex(t) {
          return t.mul(t);
        },
        BigNumber: function BigNumber(t) {
          return t.times(t);
        },
        Fraction: function Fraction(t) {
          return t.mul(t);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        },
        Unit: function Unit(t) {
          return t.pow(2);
        }
      });
      return o.toTex = {
        1: "\\left(${args[0]}\\right)^2"
      }, o;
    }

    var i = n(1);
    e.name = "square", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = o("unaryPlus", {
        number: function number(t) {
          return t;
        },
        Complex: function Complex(t) {
          return t;
        },
        BigNumber: function BigNumber(t) {
          return t;
        },
        Fraction: function Fraction(t) {
          return t;
        },
        Unit: function Unit(t) {
          return t.clone();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, s, !0);
        },
        "boolean | string | null": function booleanStringNull(n) {
          return "BigNumber" == e.number ? new t.BigNumber(+n) : +n;
        }
      });
      return s.toTex = {
        1: a.operators.unaryPlus + "\\left(${args[0]}\\right)"
      }, s;
    }

    var i = n(1);
    e.name = "unaryPlus", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, n) {
        var r,
            o,
            a,
            s = 0,
            c = 1,
            l = 1,
            h = 0;
        if (!i(t) || !i(n)) throw new Error("Parameters in function xgcd must be integer numbers");

        for (; n;) {
          o = Math.floor(t / n), a = t % n, r = s, s = c - o * s, c = r, r = l, l = h - o * l, h = r, t = n, n = a;
        }

        var f;
        return f = t < 0 ? [-t, -c, -h] : [t, t ? c : 0, h], "Array" === e.matrix ? f : u(f);
      }

      function s(n, r) {
        var i,
            o,
            a,
            s = new t.BigNumber(0),
            c = new t.BigNumber(1),
            l = s,
            h = c,
            f = c,
            p = s;
        if (!n.isInt() || !r.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");

        for (; !r.isZero();) {
          o = n.div(r).floor(), a = n.mod(r), i = l, l = h.minus(o.times(l)), h = i, i = f, f = p.minus(o.times(f)), p = i, n = r, r = a;
        }

        var m;
        return m = n.lt(s) ? [n.neg(), h.neg(), p.neg()] : [n, n.isZero() ? 0 : h, p], "Array" === e.matrix ? m : u(m);
      }

      var u = r(n(2)),
          c = o("xgcd", {
        "number, number": a,
        "BigNumber, BigNumber": s
      });
      return c.toTex = void 0, c;
    }

    var i = n(3).isInteger;
    e.name = "xgcd", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(25)),
          l = r(n(67)),
          h = r(n(16)),
          f = r(n(7)),
          p = r(n(6)),
          m = a("bitAnd", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function bitAnd");
          return t & e;
        },
        "BigNumber, BigNumber": o,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, m, !1);
                  break;

                default:
                  n = c(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m, !1);
                  break;

                default:
                  n = f(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, u(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, m, !1);
              break;

            default:
              n = p(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, m, !0);
              break;

            default:
              n = p(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(u(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(u(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + s.operators.bitAnd + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).isInteger,
        o = n(541);
    e.name = "bitAnd", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      var u = n(4),
          c = s("bitNot", {
        number: function number(t) {
          if (!a(t)) throw new Error("Integer expected in function bitNot");
          return ~t;
        },
        BigNumber: o,
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, c);
        }
      });
      return c.toTex = {
        1: u.operators.bitNot + "\\left(${args[0]}\\right)"
      }, c;
    }

    var i = n(1),
        o = n(90),
        a = n(3).isInteger;
    e.name = "bitNot", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(31)),
          l = r(n(87)),
          h = r(n(36)),
          f = r(n(7)),
          p = r(n(6)),
          m = a("bitOr", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function bitOr");
          return t | e;
        },
        "BigNumber, BigNumber": o,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, m);
                  break;

                default:
                  n = c(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m, !1);
                  break;

                default:
                  n = f(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, u(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, m, !1);
              break;

            default:
              n = p(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, m, !0);
              break;

            default:
              n = p(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(u(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(u(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + s.operators.bitOr + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).isInteger,
        o = n(542);
    e.name = "bitOr", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(15)),
          l = r(n(27)),
          h = r(n(17)),
          f = r(n(7)),
          p = r(n(6)),
          m = a("bitXor", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function bitXor");
          return t ^ e;
        },
        "BigNumber, BigNumber": o,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, m);
                  break;

                default:
                  n = c(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m, !1);
                  break;

                default:
                  n = f(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, u(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, m, !1);
              break;

            default:
              n = p(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, m, !0);
              break;

            default:
              n = p(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return p(u(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return p(u(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + s.operators.bitXor + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).isInteger,
        o = n(543);
    e.name = "bitXor", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(423), n(424), n(425), n(426), n(428), n(429), n(430)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(11)),
          l = r(n(44)),
          h = r(n(31)),
          f = r(n(25)),
          p = r(n(88)),
          m = r(n(36)),
          d = r(n(16)),
          g = r(n(7)),
          v = r(n(6)),
          y = a("leftShift", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function leftShift");
          return t << e;
        },
        "BigNumber, BigNumber": o,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = p(t, e, y, !1);
                  break;

                default:
                  n = f(e, t, y, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = h(t, e, y, !1);
                  break;

                default:
                  n = g(t, e, y);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return y(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return y(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return y(t, u(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          if (!c(e, 0)) {
            var n;

            switch (t.storage()) {
              case "sparse":
                n = d(t, e, y, !1);
                break;

              default:
                n = v(t, e, y, !1);
            }

            return n;
          }

          return t.clone();
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          if (!c(t, 0)) {
            var n;

            switch (e.storage()) {
              case "sparse":
                n = m(e, t, y, !0);
                break;

              default:
                n = v(e, t, y, !0);
            }

            return n;
          }

          return l(e.size(), e.storage());
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return y(u(t), e).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return y(t, u(e)).valueOf();
        }
      });
      return y.toTex = {
        2: "\\left(${args[0]}" + s.operators.leftShift + "${args[1]}\\right)"
      }, y;
    }

    var i = n(3).isInteger,
        o = n(545);
    e.name = "leftShift", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = n(4),
          u = r(n(2)),
          c = r(n(11)),
          l = r(n(44)),
          h = r(n(31)),
          f = r(n(25)),
          p = r(n(88)),
          m = r(n(36)),
          d = r(n(16)),
          g = r(n(7)),
          v = r(n(6)),
          y = a("rightArithShift", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function rightArithShift");
          return t >> e;
        },
        "BigNumber, BigNumber": o,
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = p(t, e, y, !1);
                  break;

                default:
                  n = f(e, t, y, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = h(t, e, y, !1);
                  break;

                default:
                  n = g(t, e, y);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return y(u(t), u(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return y(u(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return y(t, u(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          if (!c(e, 0)) {
            var n;

            switch (t.storage()) {
              case "sparse":
                n = d(t, e, y, !1);
                break;

              default:
                n = v(t, e, y, !1);
            }

            return n;
          }

          return t.clone();
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          if (!c(t, 0)) {
            var n;

            switch (e.storage()) {
              case "sparse":
                n = m(e, t, y, !0);
                break;

              default:
                n = v(e, t, y, !0);
            }

            return n;
          }

          return l(e.size(), e.storage());
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return y(u(t), e).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return y(t, u(e)).valueOf();
        }
      });
      return y.toTex = {
        2: "\\left(${args[0]}" + s.operators.rightArithShift + "${args[1]}\\right)"
      }, y;
    }

    var i = n(3).isInteger,
        o = n(546);
    e.name = "rightArithShift", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = r(n(2)),
          u = r(n(11)),
          c = r(n(44)),
          l = r(n(31)),
          h = r(n(25)),
          f = r(n(88)),
          p = r(n(36)),
          m = r(n(16)),
          d = r(n(7)),
          g = r(n(6)),
          v = o("rightLogShift", {
        "number, number": function numberNumber(t, e) {
          if (!i(t) || !i(e)) throw new Error("Integers expected in function rightLogShift");
          return t >>> e;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = f(t, e, v, !1);
                  break;

                default:
                  n = h(e, t, v, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, v, !1);
                  break;

                default:
                  n = d(t, e, v);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return v(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return v(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return v(t, s(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          if (!u(e, 0)) {
            var n;

            switch (t.storage()) {
              case "sparse":
                n = m(t, e, v, !1);
                break;

              default:
                n = g(t, e, v, !1);
            }

            return n;
          }

          return t.clone();
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          if (!u(t, 0)) {
            var n;

            switch (e.storage()) {
              case "sparse":
                n = p(e, t, v, !0);
                break;

              default:
                n = g(e, t, v, !0);
            }

            return n;
          }

          return c(e.size(), e.storage());
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return v(s(t), e).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return v(t, s(e)).valueOf();
        }
      });
      return v.toTex = {
        2: "\\left(${args[0]}" + a.operators.rightLogShift + "${args[1]}\\right)"
      }, v;
    }

    var i = n(3).isInteger;
    e.name = "rightLogShift", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(18)),
          a = r(n(129)),
          s = r(n(56)),
          u = r(n(46)),
          c = i("bellNumbers", {
        "number | BigNumber": function numberBigNumber(t) {
          if (!u(t) || s(t)) throw new TypeError("Non-negative integer value expected in function bellNumbers");

          for (var e = 0, n = 0; n <= t; n++) {
            e = o(e, a(t, n));
          }

          return e;
        }
      });
      return c.toTex = {
        1: "\\mathrm{B}_{${args[0]}}"
      }, c;
    }

    e.name = "bellNumbers", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(18)),
          a = r(n(41)),
          s = r(n(13)),
          u = r(n(63)),
          c = r(n(56)),
          l = r(n(46)),
          h = i("catalan", {
        "number | BigNumber": function numberBigNumber(t) {
          if (!l(t) || c(t)) throw new TypeError("Non-negative integer value expected in function catalan");
          return a(u(s(t, 2), t), o(t, 1));
        }
      });
      return h.toTex = {
        1: "\\mathrm{C}_{${args[0]}}"
      }, h;
    }

    e.name = "catalan", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(63)),
          a = r(n(22)),
          s = r(n(65)),
          u = r(n(46)),
          c = r(n(30)),
          l = i("composition", {
        "number | BigNumber, number | BigNumber": function numberBigNumberNumberBigNumber(t, e) {
          if (!(u(t) && s(t) && u(e) && s(e))) throw new TypeError("Positive integer value expected in function composition");
          if (c(e, t)) throw new TypeError("k must be less than or equal to n in function composition");
          return o(a(t, -1), a(e, -1));
        }
      });
      return l.toTex = void 0, l;
    }

    e.name = "composition", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(431), n(433), n(129), n(432)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("arg", {
        number: function number(t) {
          return Math.atan2(0, t);
        },
        BigNumber: function BigNumber(e) {
          return t.BigNumber.atan2(0, e);
        },
        Complex: function Complex(t) {
          return t.arg();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\arg\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "arg", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("conj", {
        number: function number(t) {
          return t;
        },
        BigNumber: function BigNumber(t) {
          return t;
        },
        Complex: function Complex(t) {
          return t.conjugate();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\left(${args[0]}\\right)^*"
      }, o;
    }

    var i = n(1);
    e.name = "conj", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("im", {
        number: function number(t) {
          return 0;
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(0);
        },
        Complex: function Complex(t) {
          return t.im;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
      }, o;
    }

    var i = n(1);
    e.name = "im", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(435), n(436), n(437), n(439)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("re", {
        number: function number(t) {
          return t;
        },
        BigNumber: function BigNumber(t) {
          return t;
        },
        Complex: function Complex(t) {
          return t.re;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
      }, o;
    }

    var i = n(1);
    e.name = "re", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, s) {
      var m = (r(n(2)), s("distance", {
        "Array, Array, Array": function ArrayArrayArray(t, e, n) {
          if (2 == t.length && 2 == e.length && 2 == n.length) {
            if (!i(t)) throw new TypeError("Array with 2 numbers expected for first argument");
            if (!i(e)) throw new TypeError("Array with 2 numbers expected for second argument");
            if (!i(n)) throw new TypeError("Array with 2 numbers expected for third argument");
            var r = (n[1] - n[0]) / (e[1] - e[0]),
                o = r * r * e[0],
                a = -1 * (r * e[0]),
                s = t[1];
            return c(t[0], t[1], o, a, s);
          }

          throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object, Object": function ObjectObjectObject(t, e, n) {
          if (2 == Object.keys(t).length && 2 == Object.keys(e).length && 2 == Object.keys(n).length) {
            if (!i(t)) throw new TypeError("Values of pointX and pointY should be numbers");
            if (!i(e)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers");
            if (!i(n)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers");

            if (t.hasOwnProperty("pointX") && t.hasOwnProperty("pointY") && e.hasOwnProperty("lineOnePtX") && e.hasOwnProperty("lineOnePtY") && n.hasOwnProperty("lineTwoPtX") && n.hasOwnProperty("lineTwoPtY")) {
              var r = (n.lineTwoPtY - n.lineTwoPtX) / (e.lineOnePtY - e.lineOnePtX),
                  o = r * r * e.lineOnePtX,
                  a = -1 * (r * e.lineOnePtX),
                  s = t.pointX;
              return c(t.pointX, t.pointY, o, a, s);
            }

            throw new TypeError("Key names do not match");
          }

          throw new TypeError("Invalid Arguments: Try again");
        },
        "Array, Array": function ArrayArray(t, e) {
          if (2 == t.length && 3 == e.length) {
            if (!i(t)) throw new TypeError("Array with 2 numbers expected for first argument");
            if (!o(e)) throw new TypeError("Array with 3 numbers expected for second argument");
            return c(t[0], t[1], e[0], e[1], e[2]);
          }

          if (3 == t.length && 6 == e.length) {
            if (!o(t)) throw new TypeError("Array with 3 numbers expected for first argument");
            if (!a(e)) throw new TypeError("Array with 6 numbers expected for second argument");
            return l(t[0], t[1], t[2], e[0], e[1], e[2], e[3], e[4], e[5]);
          }

          if (2 == t.length && 2 == e.length) {
            if (!i(t)) throw new TypeError("Array with 2 numbers expected for first argument");
            if (!i(e)) throw new TypeError("Array with 2 numbers expected for second argument");
            return h(t[0], t[1], e[0], e[1]);
          }

          if (3 == t.length && 3 == e.length) {
            if (!o(t)) throw new TypeError("Array with 3 numbers expected for first argument");
            if (!o(e)) throw new TypeError("Array with 3 numbers expected for second argument");
            return f(t[0], t[1], t[2], e[0], e[1], e[2]);
          }

          throw new TypeError("Invalid Arguments: Try again");
        },
        "Object, Object": function ObjectObject(t, e) {
          if (2 == Object.keys(t).length && 3 == Object.keys(e).length) {
            if (!i(t)) throw new TypeError("Values of pointX and pointY should be numbers");
            if (!o(e)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers");
            if (t.hasOwnProperty("pointX") && t.hasOwnProperty("pointY") && e.hasOwnProperty("xCoeffLine") && e.hasOwnProperty("yCoeffLine") && e.hasOwnProperty("yCoeffLine")) return c(t.pointX, t.pointY, e.xCoeffLine, e.yCoeffLine, e.constant);
            throw new TypeError("Key names do not match");
          }

          if (3 == Object.keys(t).length && 6 == Object.keys(e).length) {
            if (!o(t)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers");
            if (!a(e)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers");
            if (t.hasOwnProperty("pointX") && t.hasOwnProperty("pointY") && e.hasOwnProperty("x0") && e.hasOwnProperty("y0") && e.hasOwnProperty("z0") && e.hasOwnProperty("a") && e.hasOwnProperty("b") && e.hasOwnProperty("c")) return l(t.pointX, t.pointY, t.pointZ, e.x0, e.y0, e.z0, e.a, e.b, e.c);
            throw new TypeError("Key names do not match");
          }

          if (2 == Object.keys(t).length && 2 == Object.keys(e).length) {
            if (!i(t)) throw new TypeError("Values of pointOneX and pointOneY should be numbers");
            if (!i(e)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers");
            if (t.hasOwnProperty("pointOneX") && t.hasOwnProperty("pointOneY") && e.hasOwnProperty("pointTwoX") && e.hasOwnProperty("pointTwoY")) return h(t.pointOneX, t.pointOneY, e.pointTwoX, e.pointTwoY);
            throw new TypeError("Key names do not match");
          }

          if (3 == Object.keys(t).length && 3 == Object.keys(e).length) {
            if (!o(t)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers");
            if (!o(e)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers");
            if (t.hasOwnProperty("pointOneX") && t.hasOwnProperty("pointOneY") && t.hasOwnProperty("pointOneZ") && e.hasOwnProperty("pointTwoX") && e.hasOwnProperty("pointTwoY") && e.hasOwnProperty("pointTwoZ")) return f(t.pointOneX, t.pointOneY, t.pointOneZ, e.pointTwoX, e.pointTwoY, e.pointTwoZ);
            throw new TypeError("Key names do not match");
          }

          throw new TypeError("Invalid Arguments: Try again");
        },
        Array: function Array(t) {
          if (!u(t)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
          return p(t);
        }
      }));
      return m;
    }

    function i(t) {
      return t.constructor !== Array && (t = s(t)), "number" == typeof t[0] && "number" == typeof t[1];
    }

    function o(t) {
      return t.constructor !== Array && (t = s(t)), "number" == typeof t[0] && "number" == typeof t[1] && "number" == typeof t[2];
    }

    function a(t) {
      return t.constructor !== Array && (t = s(t)), "number" == typeof t[0] && "number" == typeof t[1] && "number" == typeof t[2] && "number" == typeof t[3] && "number" == typeof t[4] && "number" == typeof t[5];
    }

    function s(t) {
      for (var e = Object.keys(t), n = [], r = 0; r < e.length; r++) {
        n.push(t[e[r]]);
      }

      return n;
    }

    function u(t) {
      if (2 == t[0].length && "number" == typeof t[0][0] && "number" == typeof t[0][1]) {
        for (var e in t) {
          if (2 != t[e].length || "number" != typeof t[e][0] || "number" != typeof t[e][1]) return !1;
        }
      } else {
        if (3 != t[0].length || "number" != typeof t[0][0] || "number" != typeof t[0][1] || "number" != typeof t[0][2]) return !1;

        for (var e in t) {
          if (3 != t[e].length || "number" != typeof t[e][0] || "number" != typeof t[e][1] || "number" != typeof t[e][2]) return !1;
        }
      }

      return !0;
    }

    function c(t, e, n, r, i) {
      var o = Math.abs(n * t + r * e + i),
          a = Math.pow(n * n + r * r, .5),
          s = o / a;
      return s;
    }

    function l(t, e, n, r, i, o, a, s, u) {
      var c = [(i - e) * u - (o - n) * s, (o - n) * a - (r - t) * u, (r - t) * s - (i - e) * a];
      c = Math.pow(c[0] * c[0] + c[1] * c[1] + c[2] * c[2], .5);
      var l = Math.pow(a * a + s * s + u * u, .5),
          h = c / l;
      return h;
    }

    function h(t, e, n, r) {
      var i = r - e,
          o = n - t,
          a = i * i + o * o,
          s = Math.pow(a, .5);
      return s;
    }

    function f(t, e, n, r, i, o) {
      var a = o - n,
          s = i - e,
          u = r - t,
          c = a * a + s * s + u * u,
          l = Math.pow(c, .5);
      return l;
    }

    function p(t) {
      for (var e = [], n = 0; n < t.length - 1; n++) {
        for (var r = n + 1; r < t.length; r++) {
          2 == t[0].length ? e.push(h(t[n][0], t[n][1], t[r][0], t[r][1])) : 3 == t[0].length && e.push(f(t[n][0], t[n][1], t[n][2], t[r][0], t[r][1], t[r][2]));
        }
      }

      return e;
    }

    e.name = "distance", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(442), n(440)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t) {
        return 2 === t.length && "number" == typeof t[0] && "number" == typeof t[1];
      }

      function a(t) {
        return 3 === t.length && "number" == typeof t[0] && "number" == typeof t[1] && "number" == typeof t[2];
      }

      function s(t) {
        return 4 === t.length && "number" == typeof t[0] && "number" == typeof t[1] && "number" == typeof t[2] && "number" == typeof t[3];
      }

      function u(t, n, r, i) {
        var o = t,
            a = r,
            s = d(o, n),
            u = d(a, i),
            c = s[0] * u[1] - u[0] * s[1];
        if (h(c) < e.epsilon) return null;
        var l = (u[0] * o[1] - u[1] * o[0] - u[0] * a[1] + u[1] * a[0]) / c;
        return f(m(s, l), o);
      }

      function c(t, e, n, r, i, o, a, s, u, c, l, h) {
        var f = (t - a) * (c - a) + (e - s) * (l - s) + (n - u) * (h - u),
            p = (c - a) * (r - t) + (l - s) * (i - e) + (h - u) * (o - n),
            m = (t - a) * (r - t) + (e - s) * (i - e) + (n - u) * (o - n),
            d = (c - a) * (c - a) + (l - s) * (l - s) + (h - u) * (h - u),
            g = (r - t) * (r - t) + (i - e) * (i - e) + (o - n) * (o - n),
            v = (f * p - m * d) / (g * d - p * p),
            y = (f + v * p) / d,
            x = t + v * (r - t),
            w = e + v * (i - e),
            b = n + v * (o - n),
            _ = a + y * (c - a),
            E = s + y * (l - s),
            M = u + y * (h - u);

        return x === _ && w === E && b === M ? [x, w, b] : null;
      }

      function l(t, e, n, r, i, o, a, s, u, c) {
        var l = (c - t * a - e * s - n * u) / (r * a + i * s + o * u - t - e - n),
            h = t + l * (r - t),
            f = e + l * (i - e),
            p = n + l * (o - n);
        return [h, f, p];
      }

      var h = r(n(35)),
          f = r(n(18)),
          p = r(n(2)),
          m = r(n(13)),
          d = r(n(24)),
          g = i("intersect", {
        "Array, Array, Array": function ArrayArrayArray(t, e, n) {
          if (!a(t)) throw new TypeError("Array with 3 numbers expected for first argument");
          if (!a(e)) throw new TypeError("Array with 3 numbers expected for second argument");
          if (!s(n)) throw new TypeError("Array with 4 numbers expected as third argument");
          return l(t[0], t[1], t[2], e[0], e[1], e[2], n[0], n[1], n[2], n[3]);
        },
        "Array, Array, Array, Array": function ArrayArrayArrayArray(t, e, n, r) {
          if (2 === t.length) {
            if (!o(t)) throw new TypeError("Array with 2 numbers expected for first argument");
            if (!o(e)) throw new TypeError("Array with 2 numbers expected for second argument");
            if (!o(n)) throw new TypeError("Array with 2 numbers expected for third argument");
            if (!o(r)) throw new TypeError("Array with 2 numbers expected for fourth argument");
            return u(t, e, n, r);
          }

          if (3 === t.length) {
            if (!a(t)) throw new TypeError("Array with 3 numbers expected for first argument");
            if (!a(e)) throw new TypeError("Array with 3 numbers expected for second argument");
            if (!a(n)) throw new TypeError("Array with 3 numbers expected for third argument");
            if (!a(r)) throw new TypeError("Array with 3 numbers expected for fourth argument");
            return c(t[0], t[1], t[2], e[0], e[1], e[2], n[0], n[1], n[2], r[0], r[1], r[2]);
          }

          throw new TypeError("Arrays with two or thee dimensional points expected");
        },
        "Matrix, Matrix, Matrix": function MatrixMatrixMatrix(t, e, n) {
          return p(g(t.valueOf(), e.valueOf(), n.valueOf()));
        },
        "Matrix, Matrix, Matrix, Matrix": function MatrixMatrixMatrixMatrix(t, e, n, r) {
          return p(g(t.valueOf(), e.valueOf(), n.valueOf(), r.valueOf()));
        }
      });
      return g;
    }

    e.name = "intersect", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(387), n(412), n(427), n(434), n(438), n(441), n(445), n(452), n(458), n(466), n(470), n(471), n(477), n(497), n(504), n(507)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = n(4),
          a = r(n(2)),
          s = r(n(44)),
          u = r(n(130)),
          c = (r(n(148)), r(n(25))),
          l = r(n(67)),
          h = r(n(16)),
          f = r(n(7)),
          p = r(n(6)),
          m = i("and", {
        "number, number": function numberNumber(t, e) {
          return !(!t || !e);
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return !(0 === t.re && 0 === t.im || 0 === e.re && 0 === e.im);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return !(t.isZero() || e.isZero() || t.isNaN() || e.isNaN());
        },
        "Unit, Unit": function UnitUnit(t, e) {
          return m(t.value, e.value);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = l(t, e, m, !1);
                  break;

                default:
                  n = c(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m, !1);
                  break;

                default:
                  n = f(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          if (u(e)) return s(t.size(), t.storage());
          var n;

          switch (t.storage()) {
            case "sparse":
              n = h(t, e, m, !1);
              break;

            default:
              n = p(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          if (u(t)) return s(t.size(), t.storage());
          var n;

          switch (e.storage()) {
            case "sparse":
              n = h(e, t, m, !0);
              break;

            default:
              n = p(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return m(a(t), e).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return m(t, a(e)).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + o.operators.and + "${args[1]}\\right)"
      }, m;
    }

    e.name = "and", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(444), n(130), n(446), n(447)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = n(4),
          a = r(n(2)),
          s = r(n(15)),
          u = r(n(66)),
          c = r(n(17)),
          l = r(n(7)),
          h = r(n(6)),
          f = i("or", {
        "number, number": function numberNumber(t, e) {
          return !(!t && !e);
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return 0 !== t.re || 0 !== t.im || 0 !== e.re || 0 !== e.im;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return !t.isZero() && !t.isNaN() || !e.isZero() && !e.isNaN();
        },
        "Unit, Unit": function UnitUnit(t, e) {
          return f(t.value, e.value);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, f);
                  break;

                default:
                  n = s(e, t, f, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = s(t, e, f, !1);
                  break;

                default:
                  n = l(t, e, f);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return f(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return f(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return f(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = c(t, e, f, !1);
              break;

            default:
              n = h(t, e, f, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = c(e, t, f, !0);
              break;

            default:
              n = h(e, t, f, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return h(a(t), e, f, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return h(a(e), t, f, !0).valueOf();
        }
      });
      return f.toTex = {
        2: "\\left(${args[0]}" + o.operators.or + "${args[1]}\\right)"
      }, f;
    }

    e.name = "or", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = n(4),
          a = r(n(2)),
          s = r(n(15)),
          u = r(n(27)),
          c = r(n(17)),
          l = r(n(7)),
          h = r(n(6)),
          f = i("xor", {
        "number, number": function numberNumber(t, e) {
          return !!(!!t ^ !!e);
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return (0 !== t.re || 0 !== t.im) != (0 !== e.re || 0 !== e.im);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, e) {
          return (!t.isZero() && !t.isNaN()) != (!e.isZero() && !e.isNaN());
        },
        "Unit, Unit": function UnitUnit(t, e) {
          return f(t.value, e.value);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, f);
                  break;

                default:
                  n = s(e, t, f, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = s(t, e, f, !1);
                  break;

                default:
                  n = l(t, e, f);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return f(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return f(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return f(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = c(t, e, f, !1);
              break;

            default:
              n = h(t, e, f, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = c(e, t, f, !0);
              break;

            default:
              n = h(e, t, f, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return h(a(t), e, f, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return h(a(e), t, f, !0).valueOf();
        }
      });
      return f.toTex = {
        2: "\\left(${args[0]}" + o.operators.xor + "${args[1]}\\right)"
      }, f;
    }

    e.name = "xor", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e) {
        var n = Math.max(i.size(t).length, i.size(e).length);
        t = i.squeeze(t), e = i.squeeze(e);
        var r = i.size(t),
            o = i.size(e);
        if (1 != r.length || 1 != o.length || 3 != r[0] || 3 != o[0]) throw new RangeError("Vectors with length 3 expected (Size A = [" + r.join(", ") + "], B = [" + o.join(", ") + "])");
        var a = [u(c(t[1], e[2]), c(t[2], e[1])), u(c(t[2], e[0]), c(t[0], e[2])), u(c(t[0], e[1]), c(t[1], e[0]))];
        return n > 1 ? [a] : a;
      }

      var s = r(n(2)),
          u = r(n(24)),
          c = r(n(13)),
          l = o("cross", {
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          return s(a(t.toArray(), e.toArray()));
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return s(a(t.toArray(), e));
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return s(a(t, e.toArray()));
        },
        "Array, Array": a
      });
      return l.toTex = {
        2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
      }, l;
    }

    var i = n(8);
    e.name = "cross", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(t, e, n, r) {
        if (!o(e)) throw new TypeError("Second parameter in function diag must be an integer");
        var i = e > 0 ? e : 0,
            a = e < 0 ? -e : 0;

        switch (n.length) {
          case 1:
            return u(t, e, r, n[0], a, i);

          case 2:
            return c(t, e, r, n, a, i);
        }

        throw new RangeError("Matrix for function diag must be 2 dimensional");
      }

      function u(e, n, r, i, o, a) {
        var s = [i + o, i + a],
            u = t.Matrix.storage(r || "dense"),
            c = u.diagonal(s, e, n);
        return null !== r ? c : c.valueOf();
      }

      function c(t, e, n, r, i, o) {
        if (t && t.isMatrix === !0) {
          var a = t.diagonal(e);
          return null !== n ? n !== a.storage() ? l(a, n) : a : a.valueOf();
        }

        for (var s = Math.min(r[0] - i, r[1] - o), u = [], c = 0; c < s; c++) {
          u[c] = t[c + i][c + o];
        }

        return null !== n ? l(u) : u;
      }

      var l = r(n(2)),
          h = a("diag", {
        Array: function Array(t) {
          return s(t, 0, i.size(t), null);
        },
        "Array, number": function ArrayNumber(t, e) {
          return s(t, e, i.size(t), null);
        },
        "Array, BigNumber": function ArrayBigNumber(t, e) {
          return s(t, e.toNumber(), i.size(t), null);
        },
        "Array, string": function ArrayString(t, e) {
          return s(t, 0, i.size(t), e);
        },
        "Array, number, string": function ArrayNumberString(t, e, n) {
          return s(t, e, i.size(t), n);
        },
        "Array, BigNumber, string": function ArrayBigNumberString(t, e, n) {
          return s(t, e.toNumber(), i.size(t), n);
        },
        Matrix: function Matrix(t) {
          return s(t, 0, t.size(), t.storage());
        },
        "Matrix, number": function MatrixNumber(t, e) {
          return s(t, e, t.size(), t.storage());
        },
        "Matrix, BigNumber": function MatrixBigNumber(t, e) {
          return s(t, e.toNumber(), t.size(), t.storage());
        },
        "Matrix, string": function MatrixString(t, e) {
          return s(t, 0, t.size(), e);
        },
        "Matrix, number, string": function MatrixNumberString(t, e, n) {
          return s(t, e, t.size(), n);
        },
        "Matrix, BigNumber, string": function MatrixBigNumberString(t, e, n) {
          return s(t, e.toNumber(), t.size(), n);
        }
      });
      return h.toTex = void 0, h;
    }

    var i = n(8),
        o = (n(5).clone, n(3).isInteger);
    e.name = "diag", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t, e) {
        var n = i(t),
            r = i(e),
            o = n[0];
        if (1 !== n.length || 1 !== r.length) throw new RangeError("Vector expected");
        if (n[0] != r[0]) throw new RangeError("Vectors must have equal length (" + n[0] + " != " + r[0] + ")");
        if (0 == o) throw new RangeError("Cannot calculate the dot product of empty vectors");

        for (var a = 0, c = 0; c < o; c++) {
          a = s(a, u(t[c], e[c]));
        }

        return a;
      }

      var s = r(n(18)),
          u = r(n(13)),
          c = o("dot", {
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          return a(t.toArray(), e.toArray());
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return a(t.toArray(), e);
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return a(t, e.toArray());
        },
        "Array, Array": a
      });
      return c.toTex = {
        2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
      }, c;
    }

    var i = n(8).size;
    e.name = "dot", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = a("flatten", {
        Array: function Array(t) {
          return o(i(t));
        },
        Matrix: function Matrix(t) {
          var e = o(i(t.toArray()));
          return s(e);
        }
      });
      return u.toTex = void 0, u;
    }

    var i = n(5).clone,
        o = n(8).flatten;
    e.name = "flatten", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(131), n(448), n(132), n(449), n(450), n(81), n(133), n(451), n(134), n(135), n(136), n(453), n(82), n(137), n(454), n(455), n(456), n(457), n(61), n(138), n(62), n(44)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(e, n) {
        var r = u(e),
            i = r ? new t.BigNumber(1) : 1;

        if (c(e), n) {
          var a = l(n);
          return e.length > 0 ? a.resize(e, i) : a;
        }

        var s = [];
        return e.length > 0 ? o(s, e, i) : s;
      }

      function u(t) {
        var e = !1;
        return t.forEach(function (t, n, r) {
          t && t.isBigNumber === !0 && (e = !0, r[n] = t.toNumber());
        }), e;
      }

      function c(t) {
        t.forEach(function (t) {
          if ("number" != typeof t || !i(t) || t < 0) throw new Error("Parameters in function ones must be positive integers");
        });
      }

      var l = r(n(2)),
          h = a("ones", {
        "": function _() {
          return "Array" === e.matrix ? s([]) : s([], "default");
        },
        "...number | BigNumber | string": function numberBigNumberString(t) {
          var n = t[t.length - 1];

          if ("string" == typeof n) {
            var r = t.pop();
            return s(t, r);
          }

          return "Array" === e.matrix ? s(t) : s(t, "default");
        },
        Array: s,
        Matrix: function Matrix(t) {
          var e = t.storage();
          return s(t.valueOf(), e);
        },
        "Array | Matrix, string": function ArrayMatrixString(t, e) {
          return s(t.valueOf(), e);
        }
      });
      return h.toTex = void 0, h;
    }

    var i = n(3).isInteger,
        o = n(8).resize;
    e.name = "ones", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, l) {
      function h(t, e, n) {
        if (void 0 !== n) {
          if ("string" != typeof n || 1 !== n.length) throw new TypeError("Single character expected as defaultValue");
        } else n = " ";

        if (1 !== e.length) throw new i(e.length, 1);
        var r = e[0];
        if ("number" != typeof r || !a(r)) throw new TypeError("Invalid size, must contain positive integers (size: " + s(e) + ")");
        if (t.length > r) return t.substring(0, r);

        if (t.length < r) {
          for (var o = t, u = 0, c = r - t.length; u < c; u++) {
            o += n;
          }

          return o;
        }

        return t;
      }

      var f = r(n(2)),
          p = function p(t, n, r) {
        if (2 != arguments.length && 3 != arguments.length) throw new o("resize", arguments.length, 2, 3);
        if (n && n.isMatrix === !0 && (n = n.valueOf()), n.length && n[0] && n[0].isBigNumber === !0 && (n = n.map(function (t) {
          return t && t.isBigNumber === !0 ? t.toNumber() : t;
        })), t && t.isMatrix === !0) return t.resize(n, r, !0);
        if ("string" == typeof t) return h(t, n, r);
        var i = !Array.isArray(t) && "Array" !== e.matrix;

        if (0 == n.length) {
          for (; Array.isArray(t);) {
            t = t[0];
          }

          return u(t);
        }

        Array.isArray(t) || (t = [t]), t = u(t);
        var a = c.resize(t, n, r);
        return i ? f(a) : a;
      };

      return p.toTex = void 0, p;
    }

    var i = n(12),
        o = n(51),
        a = n(3).isInteger,
        s = n(23).format,
        u = n(5).clone,
        c = n(8);
    e.name = "resize", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(2)),
          s = o("size", {
        Matrix: function Matrix(t) {
          return a(t.size());
        },
        Array: i.size,
        string: function string(t) {
          return "Array" === e.matrix ? [t.length] : a([t.length]);
        },
        "number | Complex | BigNumber | Unit | boolean | null": function numberComplexBigNumberUnitBooleanNull(t) {
          return "Array" === e.matrix ? [] : a([]);
        }
      });
      return s.toTex = void 0, s;
    }

    var i = n(8);
    e.name = "size", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t) {
        if ("asc" === t) return l;
        if ("desc" === t) return h;
        throw new Error('String "asc" or "desc" expected');
      }

      function s(t) {
        if (1 !== i(t).length) throw new Error("One dimensional array expected");
      }

      function u(t) {
        if (1 !== t.size().length) throw new Error("One dimensional matrix expected");
      }

      var c = r(n(2)),
          l = r(n(55)),
          h = function h(t, e) {
        return -l(t, e);
      },
          f = o("sort", {
        Array: function Array(t) {
          return s(t), t.sort(l);
        },
        Matrix: function Matrix(t) {
          return u(t), c(t.toArray().sort(l), t.storage());
        },
        "Array, function": function ArrayFunction(t, e) {
          return s(t), t.sort(e);
        },
        "Matrix, function": function MatrixFunction(t, e) {
          return u(t), c(t.toArray().sort(e), t.storage());
        },
        "Array, string": function ArrayString(t, e) {
          return s(t), t.sort(a(e));
        },
        "Matrix, string": function MatrixString(t, e) {
          return u(t), c(t.toArray().sort(a(e)), t.storage());
        }
      });

      return f.toTex = void 0, f;
    }

    var i = n(8).size;
    e.name = "sort", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = a("squeeze", {
        Array: function Array(t) {
          return o.squeeze(i.clone(t));
        },
        Matrix: function Matrix(t) {
          var e = o.squeeze(t.toArray());
          return Array.isArray(e) ? s(e) : e;
        },
        any: function any(t) {
          return i.clone(t);
        }
      });
      return u.toTex = void 0, u;
    }

    var i = n(5),
        o = n(8);
    e.name = "squeeze", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(63), n(64), n(139), n(459), n(460), n(461), n(462), n(463), n(464)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        var n = e.size().length,
            r = t.size().length;
        if (n > 1) throw new Error("first object must be one dimensional");
        if (r > 1) throw new Error("second object must be one dimensional");
        if (n !== r) throw new Error("Length of two vectors must be equal");
        var i = u(t);
        if (0 === i) throw new Error("Sum of elements in first object must be non zero");
        var o = u(e);
        if (0 === o) throw new Error("Sum of elements in second object must be non zero");
        var a = s(t, u(t)),
            p = s(e, u(e)),
            m = u(c(a, h(l(a, p))));
        return f(m) ? m : Number.NaN;
      }

      var a = r(n(2)),
          s = r(n(41)),
          u = r(n(144)),
          c = r(n(13)),
          l = r(n(126)),
          h = r(n(128)),
          f = r(n(85)),
          p = i("kldivergence", {
        "Array, Array": function ArrayArray(t, e) {
          return o(a(t), a(e));
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return o(t, a(e));
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return o(a(t), e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          return o(t, e);
        }
      });
      return p;
    }

    e.name = "kldivergence", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = r(n(18)),
          s = r(n(13)),
          u = r(n(41)),
          c = r(n(64)),
          l = r(n(46)),
          h = r(n(65));
      return o("multinomial", {
        "Array | Matrix": function ArrayMatrix(t) {
          var e = 0,
              n = 1;
          return i(t, function (t) {
            if (!l(t) || !h(t)) throw new TypeError("Positive integer value expected in function multinomial");
            e = a(e, t), n = s(n, c(t));
          }), u(c(e), n);
        }
      });
    }

    var i = n(38);
    e.name = "multinomial", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(64)),
          u = a("permutations", {
        "number | BigNumber": s,
        "number, number": function numberNumber(t, e) {
          var n, r;
          if (!o(t) || t < 0) throw new TypeError("Positive integer value expected in function permutations");
          if (!o(e) || e < 0) throw new TypeError("Positive integer value expected in function permutations");
          if (e > t) throw new TypeError("second argument k must be less than or equal to first argument n");

          for (n = 1, r = t - e + 1; r <= t; r++) {
            n *= r;
          }

          return n;
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(e, n) {
          var r, o;
          if (!i(e) || !i(n)) throw new TypeError("Positive integer value expected in function permutations");
          if (n.gt(e)) throw new TypeError("second argument k must be less than or equal to first argument n");

          for (r = new t.BigNumber(1), o = e.minus(n).plus(1); o.lte(e); o = o.plus(1)) {
            r = r.times(o);
          }

          return r;
        }
      });
      return u.toTex = void 0, u;
    }

    function i(t) {
      return t.isInteger() && t.gte(0);
    }

    var o = n(3).isInteger;
    e.name = "permutations", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(83)),
          a = o("uniform").pickRandom;
      return a.toTex = void 0, a;
    }

    e.name = "pickRandom", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(83)),
          a = o("uniform").random;
      return a.toTex = void 0, a;
    }

    e.name = "random", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(83)),
          a = o("uniform").randomInt;
      return a.toTex = void 0, a;
    }

    e.name = "randomInt", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        if (Array.isArray(t)) {
          if (Array.isArray(e)) {
            var n = t.length;
            if (n !== e.length) return !1;

            for (var r = 0; r < n; r++) {
              if (!o(t[r], e[r])) return !1;
            }

            return !0;
          }

          return !1;
        }

        return !Array.isArray(e) && a(t, e);
      }

      var a = r(n(84)),
          s = i("deepEqual", {
        "any, any": function anyAny(t, e) {
          return o(t.valueOf(), e.valueOf());
        }
      });
      return s.toTex = void 0, s;
    }

    e.name = "deepEqual", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(55), n(465), n(84), n(30), n(140), n(45), n(467), n(468)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = n(4),
          m = a("smallerEq", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t <= e;
        },
        "number, number": function numberNumber(t, n) {
          return t <= n || i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return t.lte(n) || o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return 1 !== t.compare(e);
        },
        "Complex, Complex": function ComplexComplex() {
          throw new TypeError("No ordering relation is defined for complex numbers");
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return m(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t <= e;
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, m);
                  break;

                default:
                  n = u(e, t, m, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, m, !1);
                  break;

                default:
                  n = h(t, e, m);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, m, !1);
              break;

            default:
              n = f(t, e, m, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, m, !0);
              break;

            default:
              n = f(e, t, m, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, m, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, m, !0).valueOf();
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + p.operators.smallerEq + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "smallerEq", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      var s = r(n(2)),
          u = r(n(15)),
          c = r(n(27)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = n(4),
          m = a("unequal", {
        "any, any": function anyAny(t, e) {
          return null === t ? null !== e : null === e ? null !== t : void 0 === t ? void 0 !== e : void 0 === e ? void 0 !== t : d(t, e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = c(t, e, d);
                  break;

                default:
                  n = u(e, t, d, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, d, !1);
                  break;

                default:
                  n = h(t, e, d);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return m(s(t), s(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return m(s(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return m(t, s(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = l(t, e, d, !1);
              break;

            default:
              n = f(t, e, d, !1);
          }

          return n;
        },
        "any, Matrix": function anyMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, d, !0);
              break;

            default:
              n = f(e, t, d, !0);
          }

          return n;
        },
        "Array, any": function ArrayAny(t, e) {
          return f(s(t), e, d, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return f(s(e), t, d, !0).valueOf();
        }
      }),
          d = a("_unequal", {
        "boolean, boolean": function booleanBoolean(t, e) {
          return t !== e;
        },
        "number, number": function numberNumber(t, n) {
          return !i(t, n, e.epsilon);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(t, n) {
          return !o(t, n, e.epsilon);
        },
        "Fraction, Fraction": function FractionFraction(t, e) {
          return !t.equals(e);
        },
        "Complex, Complex": function ComplexComplex(t, e) {
          return !t.equals(e);
        },
        "Unit, Unit": function UnitUnit(t, e) {
          if (!t.equalBase(e)) throw new Error("Cannot compare units with different base");
          return m(t.value, e.value);
        },
        "string, string": function stringString(t, e) {
          return t !== e;
        }
      });
      return m.toTex = {
        2: "\\left(${args[0]}" + p.operators.unequal + "${args[1]}\\right)"
      }, m;
    }

    var i = n(3).nearlyEqual,
        o = n(37);
    e.name = "unequal", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      function h(t) {
        var e,
            n = t * t,
            r = u[0][4] * n,
            i = n;

        for (e = 0; e < 3; e += 1) {
          r = (r + u[0][e]) * n, i = (i + c[0][e]) * n;
        }

        return t * (r + u[0][3]) / (i + c[0][3]);
      }

      function f(t) {
        var e,
            n = u[1][8] * t,
            r = t;

        for (e = 0; e < 7; e += 1) {
          n = (n + u[1][e]) * t, r = (r + c[1][e]) * t;
        }

        var i = (n + u[1][7]) / (r + c[1][7]),
            o = parseInt(16 * t) / 16,
            a = (t - o) * (t + o);
        return Math.exp(-o * o) * Math.exp(-a) * i;
      }

      function p(t) {
        var e,
            n = 1 / (t * t),
            r = u[2][5] * n,
            i = n;

        for (e = 0; e < 4; e += 1) {
          r = (r + u[2][e]) * n, i = (i + c[2][e]) * n;
        }

        var o = n * (r + u[2][4]) / (i + c[2][4]);
        o = (s - o) / t, n = parseInt(16 * t) / 16;
        var a = (t - n) * (t + n);
        return Math.exp(-n * n) * Math.exp(-a) * o;
      }

      var m = r("erf", {
        number: function number(t) {
          var e = Math.abs(t);
          return e >= l ? o(t) : e <= a ? o(t) * h(e) : e <= 4 ? o(t) * (1 - f(e)) : o(t) * (1 - p(e));
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(m(e.toNumber()));
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, m);
        }
      });
      return m.toTex = {
        1: "erf\\left(${args[0]}\\right)"
      }, m;
    }

    var i = n(1),
        o = n(3).sign,
        a = .46875,
        s = .5641895835477563,
        u = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, .18577770618460315], [.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 2.1531153547440383e-8], [.30532663496123236, .36034489994980445, .12578172611122926, .016083785148742275, .0006587491615298378, .016315387137302097]],
        c = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, .5279051029514285, .06051834131244132, .0023352049762686918]],
        l = Math.pow(2, 53);
    e.name = "erf", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(469)];
  }, function (t, e, n) {
    t.exports = [n(141), n(142), n(472), n(143), n(473), n(474), n(475), n(476), n(144), n(145)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, a) {
      function s(t) {
        t = i(t.valueOf());
        var e = t.length;
        if (0 == e) throw new Error("Cannot calculate median of an empty array");

        if (e % 2 == 0) {
          for (var n = e / 2 - 1, r = h(t, n + 1), o = t[n], a = 0; a < n; ++a) {
            l(t[a], o) > 0 && (o = t[a]);
          }

          return m(o, r);
        }

        var s = h(t, (e - 1) / 2);
        return p(s);
      }

      var u = r(n(22)),
          c = r(n(20)),
          l = r(n(55)),
          h = r(n(82)),
          f = a("median", {
        "Array | Matrix": s,
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(t, e) {
          throw new Error("median(A, dim) is not yet supported");
        },
        "...": function _(t) {
          if (o(t)) throw new TypeError("Scalar values expected in function median");
          return s(t);
        }
      }),
          p = a({
        "number | BigNumber | Unit": function numberBigNumberUnit(t) {
          return t;
        }
      }),
          m = a({
        "number | BigNumber | Unit, number | BigNumber | Unit": function numberBigNumberUnitNumberBigNumberUnit(t, e) {
          return c(u(t, e), 2);
        }
      });
      return f.toTex = void 0, f;
    }

    var i = n(8).flatten,
        o = (n(69), n(68));
    e.name = "median", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      function o(t) {
        t = i(t.valueOf());
        var e = t.length;
        if (0 == e) throw new Error("Cannot calculate mode of an empty array");
        var n = {},
            r = [],
            o = 0;

        for (var a in t) {
          t[a] in n || (n[t[a]] = 0), n[t[a]]++, n[t[a]] == o ? r.push(t[a]) : n[t[a]] > o && (o = n[t[a]], r = [t[a]]);
        }

        return r;
      }

      var a = r("mode", {
        "Array | Matrix": o,
        "...": function _(t) {
          return o(t);
        }
      });
      return a;
    }

    var i = n(8).flatten;
    e.name = "mode", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      function a(t) {
        var e = void 0;
        if (i(t, function (t) {
          e = void 0 === e ? t : s(e, t);
        }), void 0 === e) throw new Error("Cannot calculate prod of an empty array");
        return e;
      }

      var s = r(n(26)),
          u = o("prod", {
        "Array | Matrix": a,
        "Array | Matrix, number | BigNumber": function ArrayMatrixNumberBigNumber(t, e) {
          throw new Error("prod(A, dim) is not yet supported");
        },
        "...": function _(t) {
          return a(t);
        }
      });
      return u.toTex = void 0, u;
    }

    var i = n(38);
    e.name = "prod", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, u) {
      function c(e, n, r) {
        var a, u, c;
        if (arguments.length < 2 || arguments.length > 3) throw new SyntaxError("Function quantileSeq requires two or three parameters");

        if (s(e)) {
          if (r = r || !1, "boolean" == typeof r) {
            if (u = e.valueOf(), o(n)) {
              if (n < 0) throw new Error("N/prob must be non-negative");
              if (n <= 1) return l(u, n, r);

              if (n > 1) {
                if (!i(n)) throw new Error("N must be a positive integer");
                var h = n + 1;
                a = new Array(n);

                for (var f = 0; f < n;) {
                  a[f] = l(u, ++f / h, r);
                }

                return a;
              }
            }

            if (n && n.isBigNumber) {
              if (n.isNegative()) throw new Error("N/prob must be non-negative");
              if (c = new n.constructor(1), n.lte(c)) return l(u, n, r);

              if (n.gt(c)) {
                if (!n.isInteger()) throw new Error("N must be a positive integer");
                var p = n.toNumber();
                if (p > 4294967295) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
                var h = new t.BigNumber(p + 1);
                a = new Array(p);

                for (var f = 0; f < p;) {
                  a[f] = l(u, new t.BigNumber(++f).div(h), r);
                }

                return a;
              }
            }

            if (Array.isArray(n)) {
              a = new Array(n.length);

              for (var f = 0; f < a.length; ++f) {
                var m = n[f];

                if (o(m)) {
                  if (m < 0 || m > 1) throw new Error("Probability must be between 0 and 1, inclusive");
                } else {
                  if (!m || !m.isBigNumber) throw new TypeError("Unexpected type of argument in function quantileSeq");
                  if (c = new m.constructor(1), m.isNegative() || m.gt(c)) throw new Error("Probability must be between 0 and 1, inclusive");
                }

                a[f] = l(u, m, r);
              }

              return a;
            }

            throw new TypeError("Unexpected type of argument in function quantileSeq");
          }

          throw new TypeError("Unexpected type of argument in function quantileSeq");
        }

        throw new TypeError("Unexpected type of argument in function quantileSeq");
      }

      function l(t, e, n) {
        var r = a(t),
            i = r.length;
        if (0 === i) throw new Error("Cannot calculate quantile of an empty sequence");

        if (o(e)) {
          var s = e * (i - 1),
              u = s % 1;

          if (0 === u) {
            var c = n ? r[s] : p(r, s);
            return d(c), c;
          }

          var l,
              g,
              v = Math.floor(s);
          if (n) l = r[v], g = r[v + 1];else {
            g = p(r, v + 1), l = r[v];

            for (var y = 0; y < v; ++y) {
              m(r[y], l) > 0 && (l = r[y]);
            }
          }
          return d(l), d(g), h(f(l, 1 - u), f(g, u));
        }

        var s = e.times(i - 1);

        if (s.isInteger()) {
          s = s.toNumber();
          var c = n ? r[s] : p(r, s);
          return d(c), c;
        }

        var l,
            g,
            v = s.floor(),
            u = s.minus(v),
            x = v.toNumber();
        if (n) l = r[x], g = r[x + 1];else {
          g = p(r, x + 1), l = r[x];

          for (var y = 0; y < x; ++y) {
            m(r[y], l) > 0 && (l = r[y]);
          }
        }
        d(l), d(g);
        var w = new u.constructor(1);
        return h(f(l, w.minus(u)), f(g, u));
      }

      var h = r(n(18)),
          f = r(n(13)),
          p = r(n(82)),
          m = r(n(55)),
          d = u({
        "number | BigNumber | Unit": function numberBigNumberUnit(t) {
          return t;
        }
      });
      return c;
    }

    var i = n(3).isInteger,
        o = n(3).isNumber,
        a = n(8).flatten,
        s = n(47);
    e.name = "quantileSeq", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o(t, e) {
        if (0 == t.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
        return a(s.apply(null, arguments));
      }

      var a = r(n(60)),
          s = r(n(145)),
          u = i("std", {
        "Array | Matrix": o,
        "Array | Matrix, string": o,
        "...": function _(t) {
          return o(t);
        }
      });
      return u.toTex = void 0, u;
    }

    e.name = "std", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(146), n(478)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("print", {
        "string, Object": i,
        "string, Object, number | Object": i
      });
      return o.toTex = void 0, o;
    }

    function i(t, e, n) {
      return t.replace(/\$([\w\.]+)/g, function (t, r) {
        for (var i = r.split("."), s = e[i.shift()]; i.length && void 0 !== s;) {
          var u = i.shift();
          s = u ? s[u] : s + ".";
        }

        return void 0 !== s ? o(s) ? s : a(s, n) : t;
      });
    }

    var o = n(23).isString,
        a = n(23).format;
    e.name = "print", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("acos", {
        number: function number(n) {
          return n >= -1 && n <= 1 || e.predictable ? Math.acos(n) : new t.Complex(n, 0).acos();
        },
        Complex: function Complex(t) {
          return t.acos();
        },
        BigNumber: function BigNumber(t) {
          return t.acos();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\cos^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "acos", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("acot", {
        number: function number(t) {
          return Math.atan(1 / t);
        },
        Complex: function Complex(t) {
          return t.acot();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).atan();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\cot^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "acot", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("acoth", {
        number: function number(n) {
          return n >= 1 || n <= -1 || e.predictable ? isFinite(n) ? (Math.log((n + 1) / n) + Math.log(n / (n - 1))) / 2 : 0 : new t.Complex(n, 0).acoth();
        },
        Complex: function Complex(t) {
          return t.acoth();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).atanh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\coth^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "acoth", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("acsc", {
        number: function number(n) {
          return n <= -1 || n >= 1 || e.predictable ? Math.asin(1 / n) : new t.Complex(n, 0).acsc();
        },
        Complex: function Complex(t) {
          return t.acsc();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).asin();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\csc^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "acsc", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("acsch", {
        number: function number(t) {
          return t = 1 / t, Math.log(t + Math.sqrt(t * t + 1));
        },
        Complex: function Complex(t) {
          return t.acsch();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).asinh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "acsch", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("asec", {
        number: function number(n) {
          return n <= -1 || n >= 1 || e.predictable ? Math.acos(1 / n) : new t.Complex(n, 0).asec();
        },
        Complex: function Complex(t) {
          return t.asec();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).acos();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\sec^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "asec", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = (o.find(r(n(147)), ["Complex"]), o("asech", {
        number: function number(n) {
          if (n <= 1 && n >= -1 || e.predictable) {
            n = 1 / n;
            var r = Math.sqrt(n * n - 1);
            return n > 0 || e.predictable ? Math.log(r + n) : new t.Complex(Math.log(r - n), Math.PI);
          }

          return new t.Complex(n, 0).asech();
        },
        Complex: function Complex(t) {
          return t.asech();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e).acosh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        }
      }));
      return a.toTex = {
        1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1);
    e.name = "asech", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("asin", {
        number: function number(n) {
          return n >= -1 && n <= 1 || e.predictable ? Math.asin(n) : new t.Complex(n, 0).asin();
        },
        Complex: function Complex(t) {
          return t.asin();
        },
        BigNumber: function BigNumber(t) {
          return t.asin();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\sin^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "asin", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("asinh", {
        number: Math.asinh || function (t) {
          return Math.log(Math.sqrt(t * t + 1) + t);
        },
        Complex: function Complex(t) {
          return t.asinh();
        },
        BigNumber: function BigNumber(t) {
          return t.asinh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\sinh^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "asinh", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("atan", {
        number: function number(t) {
          return Math.atan(t);
        },
        Complex: function Complex(t) {
          return t.atan();
        },
        BigNumber: function BigNumber(t) {
          return t.atan();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\tan^{-1}\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "atan", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = r(n(2)),
          a = r(n(25)),
          s = r(n(15)),
          u = r(n(154)),
          c = r(n(16)),
          l = r(n(17)),
          h = r(n(7)),
          f = r(n(6)),
          p = i("atan2", {
        "number, number": Math.atan2,
        "BigNumber, BigNumber": function BigNumberBigNumber(e, n) {
          return t.BigNumber.atan2(e, n);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              switch (e.storage()) {
                case "sparse":
                  n = u(t, e, p, !1);
                  break;

                default:
                  n = a(e, t, p, !0);
              }

              break;

            default:
              switch (e.storage()) {
                case "sparse":
                  n = s(t, e, p, !1);
                  break;

                default:
                  n = h(t, e, p);
              }

          }

          return n;
        },
        "Array, Array": function ArrayArray(t, e) {
          return p(o(t), o(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return p(o(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return p(t, o(e));
        },
        "Matrix, number | BigNumber": function MatrixNumberBigNumber(t, e) {
          var n;

          switch (t.storage()) {
            case "sparse":
              n = c(t, e, p, !1);
              break;

            default:
              n = f(t, e, p, !1);
          }

          return n;
        },
        "number | BigNumber, Matrix": function numberBigNumberMatrix(t, e) {
          var n;

          switch (e.storage()) {
            case "sparse":
              n = l(e, t, p, !0);
              break;

            default:
              n = f(e, t, p, !0);
          }

          return n;
        },
        "Array, number | BigNumber": function ArrayNumberBigNumber(t, e) {
          return f(o(t), e, p, !1).valueOf();
        },
        "number | BigNumber, Array": function numberBigNumberArray(t, e) {
          return f(o(e), t, p, !0).valueOf();
        }
      });
      return p.toTex = {
        2: "\\mathrm{atan2}\\left(${args}\\right)"
      }, p;
    }

    e.name = "atan2", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("atanh", {
        number: function number(n) {
          return n <= 1 && n >= -1 || e.predictable ? o(n) : new t.Complex(n, 0).atanh();
        },
        Complex: function Complex(t) {
          return t.atanh();
        },
        BigNumber: function BigNumber(t) {
          return t.atanh();
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a, !0);
        }
      });
      return a.toTex = {
        1: "\\tanh^{-1}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.atanh || function (t) {
      return Math.log((1 + t) / (1 - t)) / 2;
    };

    e.name = "atanh", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("cos", {
        number: Math.cos,
        Complex: function Complex(t) {
          return t.cos();
        },
        BigNumber: function BigNumber(t) {
          return t.cos();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cos is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\cos\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "cos", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("cosh", {
        number: o,
        Complex: function Complex(t) {
          return t.cosh();
        },
        BigNumber: function BigNumber(t) {
          return t.cosh();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cosh is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        }
      });
      return a.toTex = {
        1: "\\cosh\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.cosh || function (t) {
      return (Math.exp(t) + Math.exp(-t)) / 2;
    };

    e.name = "cosh", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("cot", {
        number: function number(t) {
          return 1 / Math.tan(t);
        },
        Complex: function Complex(t) {
          return t.cot();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.tan());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\cot\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "cot", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("coth", {
        number: i,
        Complex: function Complex(t) {
          return t.coth();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.tanh());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function coth is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return o(t, a);
        }
      });
      return a.toTex = {
        1: "\\coth\\left(${args[0]}\\right)"
      }, a;
    }

    function i(t) {
      var e = Math.exp(2 * t);
      return (e + 1) / (e - 1);
    }

    var o = n(1);
    e.name = "coth", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("csc", {
        number: function number(t) {
          return 1 / Math.sin(t);
        },
        Complex: function Complex(t) {
          return t.csc();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.sin());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csc is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\csc\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "csc", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("csch", {
        number: i,
        Complex: function Complex(t) {
          return t.csch();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.sinh());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function csch is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return o(t, a);
        }
      });
      return a.toTex = {
        1: "\\mathrm{csch}\\left(${args[0]}\\right)"
      }, a;
    }

    function i(t) {
      return 0 == t ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(t) - Math.exp(-t))) * a(t);
    }

    var o = n(1),
        a = n(3).sign;
    e.name = "csch", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(479), n(147), n(480), n(481), n(482), n(483), n(484), n(485), n(486), n(487), n(488), n(489), n(490), n(491), n(492), n(493), n(494), n(495), n(496), n(498), n(499), n(500), n(501), n(502), n(503)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("sec", {
        number: function number(t) {
          return 1 / Math.cos(t);
        },
        Complex: function Complex(t) {
          return t.sec();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.cos());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sec is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\sec\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "sec", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("sech", {
        number: i,
        Complex: function Complex(t) {
          return t.sech();
        },
        BigNumber: function BigNumber(e) {
          return new t.BigNumber(1).div(e.cosh());
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sech is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return o(t, a);
        }
      });
      return a.toTex = {
        1: "\\mathrm{sech}\\left(${args[0]}\\right)"
      }, a;
    }

    function i(t) {
      return 2 / (Math.exp(t) + Math.exp(-t));
    }

    var o = n(1);
    e.name = "sech", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("sin", {
        number: Math.sin,
        Complex: function Complex(t) {
          return t.sin();
        },
        BigNumber: function BigNumber(t) {
          return t.sin();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sin is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\sin\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "sin", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("sinh", {
        number: o,
        Complex: function Complex(t) {
          return t.sinh();
        },
        BigNumber: function BigNumber(t) {
          return t.sinh();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function sinh is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a, !0);
        }
      });
      return a.toTex = {
        1: "\\sinh\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.sinh || function (t) {
      return (Math.exp(t) - Math.exp(-t)) / 2;
    };

    e.name = "sinh", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("tan", {
        number: Math.tan,
        Complex: function Complex(t) {
          return t.tan();
        },
        BigNumber: function BigNumber(t) {
          return t.tan();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tan is no angle");
          return o(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o, !0);
        }
      });
      return o.toTex = {
        1: "\\tan\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "tan", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("tanh", {
        number: o,
        Complex: function Complex(t) {
          return t.tanh();
        },
        BigNumber: function BigNumber(t) {
          return t.tanh();
        },
        Unit: function Unit(e) {
          if (!e.hasBase(t.Unit.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function tanh is no angle");
          return a(e.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a, !0);
        }
      });
      return a.toTex = {
        1: "\\tanh\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = Math.tanh || function (t) {
      var e = Math.exp(2 * t);
      return (e - 1) / (e + 1);
    };

    e.name = "tanh", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(505)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      var o = n(4),
          a = r(n(2)),
          s = r(n(7)),
          u = r(n(6)),
          c = i("to", {
        "Unit, Unit | string": function UnitUnitString(t, e) {
          return t.to(e);
        },
        "Matrix, Matrix": function MatrixMatrix(t, e) {
          return s(t, e, c);
        },
        "Array, Array": function ArrayArray(t, e) {
          return c(a(t), a(e)).valueOf();
        },
        "Array, Matrix": function ArrayMatrix(t, e) {
          return c(a(t), e);
        },
        "Matrix, Array": function MatrixArray(t, e) {
          return c(t, a(e));
        },
        "Matrix, any": function MatrixAny(t, e) {
          return u(t, e, c, !1);
        },
        "any, Matrix": function anyMatrix(t, e) {
          return u(e, t, c, !0);
        },
        "Array, any": function ArrayAny(t, e) {
          return u(a(t), e, c, !1).valueOf();
        },
        "any, Array": function anyArray(t, e) {
          return u(a(e), t, c, !0).valueOf();
        }
      });
      return c.toTex = {
        2: "\\left(${args[0]}" + o.operators.to + "${args[1]}\\right)"
      }, c;
    }

    e.name = "to", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("clone", {
        any: i.clone
      });
      return o.toTex = void 0, o;
    }

    var i = n(5);
    e.name = "clone", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(506), n(46), n(56), n(85), n(65), n(509), n(148), n(508), n(149)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isNaN", {
        number: function number(t) {
          return Number.isNaN(t);
        },
        BigNumber: function BigNumber(t) {
          return t.isNaN();
        },
        Fraction: function Fraction(t) {
          return !1;
        },
        Complex: function Complex(t) {
          return Number.isNaN(t.re) && Number.isNaN(t.im);
        },
        Unit: function Unit(t) {
          return Number.isNaN(t.value);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, Number.isNaN);
        }
      });
      return o;
    }

    var i = n(1);
    n(3);
    e.name = "isNaN", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("isPrime", {
        number: function number(t) {
          if (t < 2) return !1;
          if (2 == t) return !0;
          if (t % 2 == 0) return !1;

          for (var e = 3; e * e <= t; e += 2) {
            if (t % e == 0) return !1;
          }

          return !0;
        },
        BigNumber: function BigNumber(e) {
          if (e.lt(2)) return !1;
          if (e.equals(2)) return !0;
          if (e.mod(2).isZero()) return !1;

          for (var n = t.BigNumber(3); n.times(n).lte(e); n = n.plus(1)) {
            if (e.mod(n).isZero()) return !1;
          }

          return !0;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    e.name = "isPrime", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(524), n(186), n(372), n(443), n(511), n(191)];
  }, function (t, e, n) {
    t.exports = [n(512)];
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      return function (e, n) {
        var r = t[n && n.mathjs];
        return r && "function" == typeof r.fromJSON ? r.fromJSON(n) : n;
      };
    }

    e.name = "reviver", e.path = "json", e.factory = n;
  }, function (t, e, n) {
    function r(t, e, n, r, o) {
      var a = i.clone({
        precision: e.precision
      });
      return a.prototype.type = "BigNumber", a.prototype.isBigNumber = !0, a.prototype.toJSON = function () {
        return {
          mathjs: "BigNumber",
          value: this.toString()
        };
      }, a.fromJSON = function (t) {
        return new a(t.value);
      }, o.on("config", function (t, e) {
        t.precision !== e.precision && a.config({
          precision: t.precision
        });
      }), a;
    }

    var i = n(177);
    e.name = "BigNumber", e.path = "type", e.factory = r, e.math = !0;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("bignumber", {
        "": function _() {
          return new t.BigNumber(0);
        },
        number: function number(e) {
          return new t.BigNumber(e + "");
        },
        string: function string(e) {
          return new t.BigNumber(e);
        },
        BigNumber: function BigNumber(t) {
          return t;
        },
        Fraction: function Fraction(e) {
          return new t.BigNumber(e.n).div(e.d);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        0: "0",
        1: "\\left(${args[0]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "bignumber", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(513), n(514)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("bool", {
        "": function _() {
          return !1;
        },
        boolean: function boolean(t) {
          return t;
        },
        number: function number(t) {
          return !!t;
        },
        BigNumber: function BigNumber(t) {
          return !t.isZero();
        },
        string: function string(t) {
          var e = t.toLowerCase();
          if ("true" === e) return !0;
          if ("false" === e) return !1;
          var n = Number(t);
          if ("" != t && !isNaN(n)) return !!n;
          throw new Error('Cannot convert "' + t + '" to a boolean');
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o;
    }

    var i = n(1);
    e.name = "boolean", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r, a) {
      function s(t) {
        if (!(this instanceof s)) throw new SyntaxError("Constructor must be called with the new operator");
        t && t.isChain ? this.value = t.value : this.value = t;
      }

      function u(t, e) {
        "function" == typeof e && (s.prototype[t] = l(e));
      }

      function c(t, e) {
        o(s.prototype, t, function () {
          var t = e();
          if ("function" == typeof t) return l(t);
        });
      }

      function l(t) {
        return function () {
          for (var e = [this.value], n = 0; n < arguments.length; n++) {
            e[n + 1] = arguments[n];
          }

          return new s(t.apply(t, e));
        };
      }

      return s.prototype.type = "Chain", s.prototype.isChain = !0, s.prototype.done = function () {
        return this.value;
      }, s.prototype.valueOf = function () {
        return this.value;
      }, s.prototype.toString = function () {
        return i(this.value);
      }, s.createProxy = function (t, e) {
        if ("string" == typeof t) u(t, e);else for (var n in t) {
          t.hasOwnProperty(n) && u(n, t[n]);
        }
      }, s.createProxy(a), a.on("import", function (t, e, n) {
        void 0 === n && c(t, e);
      }), s;
    }

    var i = n(23).format,
        o = n(5).lazy;
    e.name = "Chain", e.path = "type", e.factory = r, e.math = !0, e.lazy = !1;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      return r("chain", {
        "": function _() {
          return new t.Chain();
        },
        any: function any(e) {
          return new t.Chain(e);
        }
      });
    }

    e.name = "chain", e.factory = n;
  }, function (t, e, n) {
    t.exports = [n(517), n(518)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, o) {
      var a = n(4),
          s = o("complex", {
        "": function _() {
          return t.Complex.ZERO;
        },
        number: function number(e) {
          return new t.Complex(e, 0);
        },
        "number, number": function numberNumber(e, n) {
          return new t.Complex(e, n);
        },
        "BigNumber, BigNumber": function BigNumberBigNumber(e, n) {
          return new t.Complex(e.toNumber(), n.toNumber());
        },
        Complex: function Complex(t) {
          return t.clone();
        },
        string: function string(e) {
          return t.Complex(e);
        },
        Object: function Object(e) {
          if ("re" in e && "im" in e) return new t.Complex(e.re, e.im);
          if ("r" in e && "phi" in e) return new t.Complex(e);
          throw new Error("Expected object with either properties re and im, or properties r and phi.");
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, s);
        }
      });
      return s.toTex = {
        0: "0",
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)+" + a.symbols.i + "\\cdot\\left(${args[1]}\\right)\\right)"
      }, s;
    }

    var i = n(1);
    e.name = "complex", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(150), n(520)];
  }, function (t, e, n) {
    function r(t, e, n, r) {
      return i;
    }

    var i = n(179);
    i.prototype.type = "Fraction", i.prototype.isFraction = !0, i.prototype.toJSON = function () {
      return {
        mathjs: "Fraction",
        n: this.s * this.n,
        d: this.d
      };
    }, i.fromJSON = function (t) {
      return new i(t);
    }, e.name = "Fraction", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(522), n(151)];
  }, function (t, e, n) {
    t.exports = [n(515), n(516), n(519), n(521), n(523), n(532), n(89), n(533), n(534), n(538)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, i) {
      function o() {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        this._minimum = null, this._size = 0;
      }

      var a = r(n(45)),
          s = r(n(30)),
          u = 1 / Math.log((1 + Math.sqrt(5)) / 2);
      o.prototype.type = "FibonacciHeap", o.prototype.isFibonacciHeap = !0, o.prototype.insert = function (t, e) {
        var n = {
          key: t,
          value: e,
          degree: 0
        };

        if (this._minimum) {
          var r = this._minimum;
          n.left = r, n.right = r.right, r.right = n, n.right.left = n, a(t, r.key) && (this._minimum = n);
        } else n.left = n, n.right = n, this._minimum = n;

        return this._size++, n;
      }, o.prototype.size = function () {
        return this._size;
      }, o.prototype.clear = function () {
        this._minimum = null, this._size = 0;
      }, o.prototype.isEmpty = function () {
        return !!this._minimum;
      }, o.prototype.extractMinimum = function () {
        var t = this._minimum;
        if (null === t) return t;

        for (var e = this._minimum, n = t.degree, r = t.child; n > 0;) {
          var i = r.right;
          r.left.right = r.right, r.right.left = r.left, r.left = e, r.right = e.right, e.right = r, r.right.left = r, r.parent = null, r = i, n--;
        }

        return t.left.right = t.right, t.right.left = t.left, t == t.right ? e = null : (e = t.right, e = p(e, this._size)), this._size--, this._minimum = e, t;
      }, o.prototype.remove = function (t) {
        this._minimum = c(this._minimum, t, -1), this.extractMinimum();
      };

      var c = function c(t, e, n) {
        e.key = n;
        var r = e.parent;
        return r && a(e.key, r.key) && (l(t, e, r), h(t, r)), a(e.key, t.key) && (t = e), t;
      },
          l = function l(t, e, n) {
        e.left.right = e.right, e.right.left = e.left, n.degree--, n.child == e && (n.child = e.right), 0 === n.degree && (n.child = null), e.left = t, e.right = t.right, t.right = e, e.right.left = e, e.parent = null, e.mark = !1;
      },
          h = function h(t, e) {
        var n = e.parent;
        n && (e.mark ? (l(t, e, n), h(n)) : e.mark = !0);
      },
          f = function f(t, e) {
        t.left.right = t.right, t.right.left = t.left, t.parent = e, e.child ? (t.left = e.child, t.right = e.child.right, e.child.right = t, t.right.left = t) : (e.child = t, t.right = t, t.left = t), e.degree++, t.mark = !1;
      },
          p = function p(t, e) {
        var n = Math.floor(Math.log(e) * u) + 1,
            r = new Array(n),
            i = 0,
            o = t;
        if (o) for (i++, o = o.right; o !== t;) {
          i++, o = o.right;
        }

        for (var c; i > 0;) {
          for (var l = o.degree, h = o.right;;) {
            if (c = r[l], !c) break;

            if (s(o.key, c.key)) {
              var p = c;
              c = o, o = p;
            }

            f(c, o), r[l] = null, l++;
          }

          r[l] = o, o = h, i--;
        }

        t = null;

        for (var m = 0; m < n; m++) {
          c = r[m], c && (t ? (c.left.right = c.right, c.right.left = c.left, c.left = t, c.right = t.right, t.right = c, c.right.left = c, a(c.key, t.key) && (t = c)) : t = c);
        }

        return t;
      };

      return o;
    }

    e.name = "FibonacciHeap", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      function o(t, e) {
        if (!(this instanceof o)) throw new SyntaxError("Constructor must be called with the new operator");
        if (e && !u(e)) throw new Error("Invalid datatype: " + e);

        if (t && t.isMatrix === !0 || s(t)) {
          var n = new c(t, e);
          this._data = n._data, this._size = n._size, this._datatype = n._datatype, this._min = null, this._max = null;
        } else if (t && s(t.data) && s(t.size)) this._data = t.data, this._size = t.size, this._datatype = t.datatype, this._min = "undefined" != typeof t.min ? t.min : null, this._max = "undefined" != typeof t.max ? t.max : null;else {
          if (t) throw new TypeError("Unsupported type of data (" + i.types.type(t) + ")");
          this._data = [], this._size = [0], this._datatype = e, this._min = null, this._max = null;
        }
      }

      var c = r(n(152)),
          l = r(n(45));
      return o.prototype = new c(), o.prototype.type = "ImmutableDenseMatrix", o.prototype.isImmutableDenseMatrix = !0, o.prototype.subset = function (t) {
        switch (arguments.length) {
          case 1:
            var e = c.prototype.subset.call(this, t);
            return e.isMatrix ? new o({
              data: e._data,
              size: e._size,
              datatype: e._datatype
            }) : e;

          case 2:
          case 3:
            throw new Error("Cannot invoke set subset on an Immutable Matrix instance");

          default:
            throw new SyntaxError("Wrong number of arguments");
        }
      }, o.prototype.set = function () {
        throw new Error("Cannot invoke set on an Immutable Matrix instance");
      }, o.prototype.resize = function () {
        throw new Error("Cannot invoke resize on an Immutable Matrix instance");
      }, o.prototype.clone = function () {
        var t = new o({
          data: a.clone(this._data),
          size: a.clone(this._size),
          datatype: this._datatype
        });
        return t;
      }, o.prototype.toJSON = function () {
        return {
          mathjs: "ImmutableDenseMatrix",
          data: this._data,
          size: this._size,
          datatype: this._datatype
        };
      }, o.fromJSON = function (t) {
        return new o(t);
      }, o.prototype.swapRows = function () {
        throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
      }, o.prototype.min = function () {
        if (null === this._min) {
          var t = null;
          this.forEach(function (e) {
            (null === t || l(e, t)) && (t = e);
          }), this._min = null !== t ? t : void 0;
        }

        return this._min;
      }, o.prototype.max = function () {
        if (null === this._max) {
          var t = null;
          this.forEach(function (e) {
            (null === t || l(t, e)) && (t = e);
          }), this._max = null !== t ? t : void 0;
        }

        return this._max;
      }, o;
    }

    var i = n(28),
        o = i.string,
        a = i.object,
        s = Array.isArray,
        u = o.isString;
    e.name = "ImmutableDenseMatrix", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      function e(t) {
        if (!(this instanceof e)) throw new SyntaxError("Constructor must be called with the new operator");
        this._dimensions = [], this._isScalar = !0;

        for (var r = 0, i = arguments.length; r < i; r++) {
          var o = arguments[r];
          if (o && o.isRange === !0) this._dimensions.push(o), this._isScalar = !1;else if (o && (Array.isArray(o) || o.isMatrix === !0)) {
            var a = n(o.valueOf());

            this._dimensions.push(a);

            var s = a.size();
            1 === s.length && 1 === s[0] || (this._isScalar = !1);
          } else if ("number" == typeof o) this._dimensions.push(n([o]));else {
            if ("string" != typeof o) throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");

            this._dimensions.push(o);
          }
        }
      }

      function n(e) {
        for (var n = 0, r = e.length; n < r; n++) {
          if ("number" != typeof e[n] || !o(e[n])) throw new TypeError("Index parameters must be positive integer numbers");
        }

        return new t.ImmutableDenseMatrix(e);
      }

      return e.prototype.type = "Index", e.prototype.isIndex = !0, e.prototype.clone = function () {
        var t = new e();
        return t._dimensions = i(this._dimensions), t._isScalar = this._isScalar, t;
      }, e.create = function (t) {
        var n = new e();
        return e.apply(n, t), n;
      }, e.prototype.size = function () {
        for (var t = [], e = 0, n = this._dimensions.length; e < n; e++) {
          var r = this._dimensions[e];
          t[e] = "string" == typeof r ? 1 : r.size()[0];
        }

        return t;
      }, e.prototype.max = function () {
        for (var t = [], e = 0, n = this._dimensions.length; e < n; e++) {
          var r = this._dimensions[e];
          t[e] = "string" == typeof r ? r : r.max();
        }

        return t;
      }, e.prototype.min = function () {
        for (var t = [], e = 0, n = this._dimensions.length; e < n; e++) {
          var r = this._dimensions[e];
          t[e] = "string" == typeof r ? r : r.min();
        }

        return t;
      }, e.prototype.forEach = function (t) {
        for (var e = 0, n = this._dimensions.length; e < n; e++) {
          t(this._dimensions[e], e, this);
        }
      }, e.prototype.dimension = function (t) {
        return this._dimensions[t] || null;
      }, e.prototype.isObjectProperty = function () {
        return 1 === this._dimensions.length && "string" == typeof this._dimensions[0];
      }, e.prototype.getObjectProperty = function () {
        return this.isObjectProperty() ? this._dimensions[0] : null;
      }, e.prototype.isScalar = function () {
        return this._isScalar;
      }, e.prototype.toArray = function () {
        for (var t = [], e = 0, n = this._dimensions.length; e < n; e++) {
          var r = this._dimensions[e];
          t.push("string" == typeof r ? r : r.toArray());
        }

        return t;
      }, e.prototype.valueOf = e.prototype.toArray, e.prototype.toString = function () {
        for (var t = [], e = 0, n = this._dimensions.length; e < n; e++) {
          var r = this._dimensions[e];
          "string" == typeof r ? t.push(JSON.stringify(r)) : t.push(r.toString());
        }

        return "[" + t.join(", ") + "]";
      }, e.prototype.toJSON = function () {
        return {
          mathjs: "Index",
          dimensions: this._dimensions
        };
      }, e.fromJSON = function (t) {
        return e.create(t.dimensions);
      }, e;
    }

    var i = n(5).clone,
        o = n(3).isInteger;
    e.name = "Index", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r) {
      function i() {
        if (!(this instanceof i)) throw new SyntaxError("Constructor must be called with the new operator");
        this._values = [], this._heap = new t.FibonacciHeap();
      }

      var o = r(n(18)),
          a = r(n(11));
      return i.prototype.type = "Spa", i.prototype.isSpa = !0, i.prototype.set = function (t, e) {
        if (this._values[t]) this._values[t].value = e;else {
          var n = this._heap.insert(t, e);

          this._values[t] = n;
        }
      }, i.prototype.get = function (t) {
        var e = this._values[t];
        return e ? e.value : 0;
      }, i.prototype.accumulate = function (t, e) {
        var n = this._values[t];
        n ? n.value = o(n.value, e) : (n = this._heap.insert(t, e), this._values[t] = n);
      }, i.prototype.forEach = function (t, e, n) {
        var r = this._heap,
            i = this._values,
            o = [],
            s = r.extractMinimum();

        for (s && o.push(s); s && s.key <= e;) {
          s.key >= t && (a(s.value, 0) || n(s.key, s.value, this)), s = r.extractMinimum(), s && o.push(s);
        }

        for (var u = 0; u < o.length; u++) {
          var c = o[u];
          s = r.insert(c.key, c.value), i[s.key] = s;
        }
      }, i.prototype.swap = function (t, e) {
        var n = this._values[t],
            r = this._values[e];
        if (!n && r) n = this._heap.insert(t, r.value), this._heap.remove(r), this._values[t] = n, this._values[e] = void 0;else if (n && !r) r = this._heap.insert(e, n.value), this._heap.remove(n), this._values[e] = r, this._values[t] = void 0;else if (n && r) {
          var i = n.value;
          n.value = r.value, r.value = i;
        }
      }, i;
    }

    e.name = "Spa", e.path = "type", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, r, d) {
      function g(t, e) {
        if (!(this instanceof g)) throw new SyntaxError("Constructor must be called with the new operator");
        if (e && !p(e)) throw new Error("Invalid datatype: " + e);
        if (t && t.isMatrix === !0) x(this, t, e);else if (t && l(t.index) && l(t.ptr) && l(t.size)) this._values = t.values, this._index = t.index, this._ptr = t.ptr, this._size = t.size, this._datatype = e || t.datatype;else if (l(t)) w(this, t, e);else {
          if (t) throw new TypeError("Unsupported type of data (" + i.types.type(t) + ")");
          this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = e;
        }
      }

      var v = r(n(86)),
          y = r(n(11)),
          x = function x(t, e, n) {
        "SparseMatrix" === e.type ? (t._values = e._values ? s.clone(e._values) : void 0, t._index = s.clone(e._index), t._ptr = s.clone(e._ptr), t._size = s.clone(e._size), t._datatype = n || e._datatype) : w(t, e.valueOf(), n || e._datatype);
      },
          w = function w(t, e, n) {
        t._values = [], t._index = [], t._ptr = [], t._datatype = n;
        var r = e.length,
            i = 0,
            o = y,
            a = 0;

        if (p(n) && (o = d.find(y, [n, n]) || y, a = d.convert(0, n)), r > 0) {
          var s = 0;

          do {
            t._ptr.push(t._index.length);

            for (var u = 0; u < r; u++) {
              var c = e[u];

              if (l(c)) {
                if (0 === s && i < c.length && (i = c.length), s < c.length) {
                  var h = c[s];
                  o(h, a) || (t._values.push(h), t._index.push(u));
                }
              } else 0 === s && i < 1 && (i = 1), o(c, a) || (t._values.push(c), t._index.push(u));
            }

            s++;
          } while (s < i);
        }

        t._ptr.push(t._index.length), t._size = [r, i];
      };

      g.prototype = new v(), g.prototype.type = "SparseMatrix", g.prototype.isSparseMatrix = !0, g.prototype.storage = function () {
        return "sparse";
      }, g.prototype.datatype = function () {
        return this._datatype;
      }, g.prototype.create = function (t, e) {
        return new g(t, e);
      }, g.prototype.density = function () {
        var t = this._size[0],
            e = this._size[1];
        return 0 !== t && 0 !== e ? this._index.length / (t * e) : 0;
      }, g.prototype.subset = function (t, e, n) {
        if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");

        switch (arguments.length) {
          case 1:
            return b(this, t);

          case 2:
          case 3:
            return _(this, t, e, n);

          default:
            throw new SyntaxError("Wrong number of arguments");
        }
      };

      var b = function b(t, e) {
        if (!e || e.isIndex !== !0) throw new TypeError("Invalid index");
        var n = e.isScalar();
        if (n) return t.get(e.min());
        var r = e.size();
        if (r.length != t._size.length) throw new o(r.length, t._size.length);
        var i,
            a,
            s,
            u,
            c = e.min(),
            l = e.max();

        for (i = 0, a = t._size.length; i < a; i++) {
          m(c[i], t._size[i]), m(l[i], t._size[i]);
        }

        var h = t._values,
            f = t._index,
            p = t._ptr,
            d = e.dimension(0),
            v = e.dimension(1),
            y = [],
            x = [];
        d.forEach(function (t, e) {
          x[t] = e[0], y[t] = !0;
        });
        var w = h ? [] : void 0,
            b = [],
            _ = [];
        return v.forEach(function (t) {
          for (_.push(b.length), s = p[t], u = p[t + 1]; s < u; s++) {
            i = f[s], y[i] === !0 && (b.push(x[i]), w && w.push(h[s]));
          }
        }), _.push(b.length), new g({
          values: w,
          index: b,
          ptr: _,
          size: r,
          datatype: t._datatype
        });
      },
          _ = function _(t, e, n, r) {
        if (!e || e.isIndex !== !0) throw new TypeError("Invalid index");
        var i,
            u = e.size(),
            c = e.isScalar();

        if (n && n.isMatrix === !0 ? (i = n.size(), n = n.toArray()) : i = a.size(n), c) {
          if (0 !== i.length) throw new TypeError("Scalar expected");
          t.set(e.min(), n, r);
        } else {
          if (1 !== u.length && 2 !== u.length) throw new o(u.length, t._size.length, "<");

          if (i.length < u.length) {
            for (var l = 0, h = 0; 1 === u[l] && 1 === i[l];) {
              l++;
            }

            for (; 1 === u[l];) {
              h++, l++;
            }

            n = a.unsqueeze(n, u.length, h, i);
          }

          if (!s.deepEqual(u, i)) throw new o(u, i, ">");

          for (var f = e.min()[0], p = e.min()[1], m = i[0], d = i[1], g = 0; g < m; g++) {
            for (var v = 0; v < d; v++) {
              var y = n[g][v];
              t.set([g + f, v + p], y, r);
            }
          }
        }

        return t;
      };

      g.prototype.get = function (t) {
        if (!l(t)) throw new TypeError("Array expected");
        if (t.length != this._size.length) throw new o(t.length, this._size.length);
        if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
        var e = t[0],
            n = t[1];
        m(e, this._size[0]), m(n, this._size[1]);
        var r = E(e, this._ptr[n], this._ptr[n + 1], this._index);
        return r < this._ptr[n + 1] && this._index[r] === e ? this._values[r] : 0;
      }, g.prototype.set = function (t, e, n) {
        if (!l(t)) throw new TypeError("Array expected");
        if (t.length != this._size.length) throw new o(t.length, this._size.length);
        if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
        var r = t[0],
            i = t[1],
            a = this._size[0],
            s = this._size[1],
            u = y,
            c = 0;
        p(this._datatype) && (u = d.find(y, [this._datatype, this._datatype]) || y, c = d.convert(0, this._datatype)), (r > a - 1 || i > s - 1) && (N(this, Math.max(r + 1, a), Math.max(i + 1, s), n), a = this._size[0], s = this._size[1]), m(r, a), m(i, s);
        var h = E(r, this._ptr[i], this._ptr[i + 1], this._index);
        return h < this._ptr[i + 1] && this._index[h] === r ? u(e, c) ? M(h, i, this._values, this._index, this._ptr) : this._values[h] = e : T(h, r, i, e, this._values, this._index, this._ptr), this;
      };

      var E = function E(t, e, n, r) {
        if (n - e === 0) return n;

        for (var i = e; i < n; i++) {
          if (r[i] === t) return i;
        }

        return e;
      },
          M = function M(t, e, n, r, i) {
        n.splice(t, 1), r.splice(t, 1);

        for (var o = e + 1; o < i.length; o++) {
          i[o]--;
        }
      },
          T = function T(t, e, n, r, i, o, a) {
        i.splice(t, 0, r), o.splice(t, 0, e);

        for (var s = n + 1; s < a.length; s++) {
          a[s]++;
        }
      };

      g.prototype.resize = function (t, e, n) {
        if (!l(t)) throw new TypeError("Array expected");
        if (2 !== t.length) throw new Error("Only two dimensions matrix are supported");
        t.forEach(function (e) {
          if (!c.isNumber(e) || !c.isInteger(e) || e < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + u.format(t) + ")");
        });
        var r = n ? this.clone() : this;
        return N(r, t[0], t[1], e);
      };

      var N = function N(t, e, n, r) {
        var i = r || 0,
            o = y,
            a = 0;
        p(t._datatype) && (o = d.find(y, [t._datatype, t._datatype]) || y, a = d.convert(0, t._datatype), i = d.convert(i, t._datatype));
        var s,
            u,
            c,
            l = !o(i, a),
            h = t._size[0],
            f = t._size[1];

        if (n > f) {
          for (u = f; u < n; u++) {
            if (t._ptr[u] = t._values.length, l) for (s = 0; s < h; s++) {
              t._values.push(i), t._index.push(s);
            }
          }

          t._ptr[n] = t._values.length;
        } else n < f && (t._ptr.splice(n + 1, f - n), t._values.splice(t._ptr[n], t._values.length), t._index.splice(t._ptr[n], t._index.length));

        if (f = n, e > h) {
          if (l) {
            var m = 0;

            for (u = 0; u < f; u++) {
              t._ptr[u] = t._ptr[u] + m, c = t._ptr[u + 1] + m;
              var g = 0;

              for (s = h; s < e; s++, g++) {
                t._values.splice(c + g, 0, i), t._index.splice(c + g, 0, s), m++;
              }
            }

            t._ptr[f] = t._values.length;
          }
        } else if (e < h) {
          var v = 0;

          for (u = 0; u < f; u++) {
            t._ptr[u] = t._ptr[u] - v;
            var x = t._ptr[u],
                w = t._ptr[u + 1] - v;

            for (c = x; c < w; c++) {
              s = t._index[c], s > e - 1 && (t._values.splice(c, 1), t._index.splice(c, 1), v++);
            }
          }

          t._ptr[u] = t._values.length;
        }

        return t._size[0] = e, t._size[1] = n, t;
      };

      g.prototype.clone = function () {
        var t = new g({
          values: this._values ? s.clone(this._values) : void 0,
          index: s.clone(this._index),
          ptr: s.clone(this._ptr),
          size: s.clone(this._size),
          datatype: this._datatype
        });
        return t;
      }, g.prototype.size = function () {
        return this._size.slice(0);
      }, g.prototype.map = function (t, e) {
        if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");

        var n = this,
            r = this._size[0],
            i = this._size[1],
            o = function o(e, r, i) {
          return t(e, [r, i], n);
        };

        return S(this, 0, r - 1, 0, i - 1, o, e);
      };

      var S = function S(t, e, n, r, i, o, a) {
        var s = [],
            u = [],
            c = [],
            l = y,
            h = 0;
        p(t._datatype) && (l = d.find(y, [t._datatype, t._datatype]) || y, h = d.convert(0, t._datatype));

        for (var f = function f(t, e, n) {
          t = o(t, e, n), l(t, h) || (s.push(t), u.push(e));
        }, m = r; m <= i; m++) {
          c.push(s.length);

          for (var v = t._ptr[m], x = t._ptr[m + 1], w = e, b = v; b < x; b++) {
            var _ = t._index[b];

            if (_ >= e && _ <= n) {
              if (!a) for (var E = w; E < _; E++) {
                f(0, E - e, m - r);
              }
              f(t._values[b], _ - e, m - r);
            }

            w = _ + 1;
          }

          if (!a) for (var M = w; M <= n; M++) {
            f(0, M - e, m - r);
          }
        }

        return c.push(s.length), new g({
          values: s,
          index: u,
          ptr: c,
          size: [n - e + 1, i - r + 1]
        });
      };

      g.prototype.forEach = function (t, e) {
        if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");

        for (var n = this, r = this._size[0], i = this._size[1], o = 0; o < i; o++) {
          for (var a = this._ptr[o], s = this._ptr[o + 1], u = 0, c = a; c < s; c++) {
            var l = this._index[c];
            if (!e) for (var h = u; h < l; h++) {
              t(0, [h, o], n);
            }
            t(this._values[c], [l, o], n), u = l + 1;
          }

          if (!e) for (var f = u; f < r; f++) {
            t(0, [f, o], n);
          }
        }
      }, g.prototype.toArray = function () {
        return A(this._values, this._index, this._ptr, this._size, !0);
      }, g.prototype.valueOf = function () {
        return A(this._values, this._index, this._ptr, this._size, !1);
      };

      var A = function A(t, e, n, r, i) {
        var o,
            a,
            u = r[0],
            c = r[1],
            l = [];

        for (o = 0; o < u; o++) {
          for (l[o] = [], a = 0; a < c; a++) {
            l[o][a] = 0;
          }
        }

        for (a = 0; a < c; a++) {
          for (var h = n[a], f = n[a + 1], p = h; p < f; p++) {
            o = e[p], l[o][a] = t ? i ? s.clone(t[p]) : t[p] : 1;
          }
        }

        return l;
      };

      return g.prototype.format = function (t) {
        for (var e = this._size[0], n = this._size[1], r = this.density(), i = "Sparse Matrix [" + u.format(e, t) + " x " + u.format(n, t) + "] density: " + u.format(r, t) + "\n", o = 0; o < n; o++) {
          for (var a = this._ptr[o], s = this._ptr[o + 1], c = a; c < s; c++) {
            var l = this._index[c];
            i += "\n    (" + u.format(l, t) + ", " + u.format(o, t) + ") ==> " + (this._values ? u.format(this._values[c], t) : "X");
          }
        }

        return i;
      }, g.prototype.toString = function () {
        return u.format(this.toArray());
      }, g.prototype.toJSON = function () {
        return {
          mathjs: "SparseMatrix",
          values: this._values,
          index: this._index,
          ptr: this._ptr,
          size: this._size,
          datatype: this._datatype
        };
      }, g.prototype.diagonal = function (t) {
        if (t) {
          if (t.isBigNumber === !0 && (t = t.toNumber()), !h(t) || !f(t)) throw new TypeError("The parameter k must be an integer number");
        } else t = 0;

        var e = t > 0 ? t : 0,
            n = t < 0 ? -t : 0,
            r = this._size[0],
            i = this._size[1],
            o = Math.min(r - n, i - e),
            a = [],
            s = [],
            u = [];
        u[0] = 0;

        for (var c = e; c < i && a.length < o; c++) {
          for (var l = this._ptr[c], p = this._ptr[c + 1], m = l; m < p; m++) {
            var d = this._index[m];

            if (d === c - e + n) {
              a.push(this._values[m]), s[a.length - 1] = d - n;
              break;
            }
          }
        }

        return u.push(a.length), new g({
          values: a,
          index: s,
          ptr: u,
          size: [o, 1]
        });
      }, g.fromJSON = function (t) {
        return new g(t);
      }, g.diagonal = function (t, e, n, r, i) {
        if (!l(t)) throw new TypeError("Array expected, size parameter");
        if (2 !== t.length) throw new Error("Only two dimensions matrix are supported");

        if (t = t.map(function (t) {
          if (t && t.isBigNumber === !0 && (t = t.toNumber()), !h(t) || !f(t) || t < 1) throw new Error("Size values must be positive integers");
          return t;
        }), n) {
          if (n.isBigNumber === !0 && (n = n.toNumber()), !h(n) || !f(n)) throw new TypeError("The parameter k must be an integer number");
        } else n = 0;

        var o = y,
            a = 0;
        p(i) && (o = d.find(y, [i, i]) || y, a = d.convert(0, i));
        var s,
            u = n > 0 ? n : 0,
            c = n < 0 ? -n : 0,
            m = t[0],
            v = t[1],
            x = Math.min(m - c, v - u);

        if (l(e)) {
          if (e.length !== x) throw new Error("Invalid value array length");

          s = function s(t) {
            return e[t];
          };
        } else if (e && e.isMatrix === !0) {
          var w = e.size();
          if (1 !== w.length || w[0] !== x) throw new Error("Invalid matrix length");

          s = function s(t) {
            return e.get([t]);
          };
        } else s = function s() {
          return e;
        };

        for (var b = [], _ = [], E = [], M = 0; M < v; M++) {
          E.push(b.length);
          var T = M - u;

          if (T >= 0 && T < x) {
            var N = s(T);
            o(N, a) || (_.push(T + c), b.push(N));
          }
        }

        return E.push(b.length), new g({
          values: b,
          index: _,
          ptr: E,
          size: [m, v]
        });
      }, g.prototype.swapRows = function (t, e) {
        if (!(h(t) && f(t) && h(e) && f(e))) throw new Error("Row index must be positive integers");
        if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
        return m(t, this._size[0]), m(e, this._size[0]), g._swapRows(t, e, this._size[1], this._values, this._index, this._ptr), this;
      }, g._forEachRow = function (t, e, n, r, i) {
        for (var o = r[t], a = r[t + 1], s = o; s < a; s++) {
          i(n[s], e[s]);
        }
      }, g._swapRows = function (t, e, n, r, i, o) {
        for (var a = 0; a < n; a++) {
          var s = o[a],
              u = o[a + 1],
              c = E(t, s, u, i),
              l = E(e, s, u, i);

          if (c < u && l < u && i[c] === t && i[l] === e) {
            if (r) {
              var h = r[c];
              r[c] = r[l], r[l] = h;
            }
          } else if (c < u && i[c] === t && (l >= u || i[l] !== e)) {
            var f = r ? r[c] : void 0;
            i.splice(l, 0, e), r && r.splice(l, 0, f), i.splice(l <= c ? c + 1 : c, 1), r && r.splice(l <= c ? c + 1 : c, 1);
          } else if (l < u && i[l] === e && (c >= u || i[c] !== t)) {
            var p = r ? r[l] : void 0;
            i.splice(c, 0, t), r && r.splice(c, 0, p), i.splice(c <= l ? l + 1 : l, 1), r && r.splice(c <= l ? l + 1 : l, 1);
          }
        }
      }, t.Matrix._storage.sparse = g, g;
    }

    var i = n(28),
        o = n(12),
        a = i.array,
        s = i.object,
        u = i.string,
        c = i.number,
        l = Array.isArray,
        h = c.isNumber,
        f = c.isInteger,
        p = u.isString,
        m = a.validateIndex;
    e.name = "SparseMatrix", e.path = "type", e.factory = r, e.lazy = !1;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      return r("index", {
        "...number | string | BigNumber | Range | Array | Matrix": function numberStringBigNumberRangeArrayMatrix(e) {
          var n = e.map(function (t) {
            return t && t.isBigNumber === !0 ? t.toNumber() : t && (Array.isArray(t) || t.isMatrix === !0) ? t.map(function (t) {
              return t && t.isBigNumber === !0 ? t.toNumber() : t;
            }) : t;
          }),
              r = new t.Index();
          return t.Index.apply(r, n), r;
        }
      });
    }

    e.name = "index", e.factory = n;
  }, function (t, e) {
    "use strict";

    function n(t, e, n, r) {
      var i = t.SparseMatrix,
          o = r("sparse", {
        "": function _() {
          return new i([]);
        },
        string: function string(t) {
          return new i([], t);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return new i(t);
        },
        "Array | Matrix, string": function ArrayMatrixString(t, e) {
          return new i(t, e);
        }
      });
      return o.toTex = {
        0: "\\begin{bsparse}\\end{bsparse}",
        1: "\\left(${args[0]}\\right)"
      }, o;
    }

    e.name = "sparse", e.factory = n;
  }, function (t, e, n) {
    t.exports = [n(86), n(152), n(529), n(528), n(525), n(526), n(527), n(153), n(530), n(2), n(531)];
  }, function (t, e, n) {
    t.exports = [n(155)];
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var a = r("string", {
        "": function _() {
          return "";
        },
        number: o.format,
        null: function _null(t) {
          return "null";
        },
        boolean: function boolean(t) {
          return t + "";
        },
        string: function string(t) {
          return t;
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, a);
        },
        any: function any(t) {
          return String(t);
        }
      });
      return a.toTex = {
        0: '\\mathtt{""}',
        1: "\\mathrm{string}\\left(${args[0]}\\right)"
      }, a;
    }

    var i = n(1),
        o = n(3);
    e.name = "string", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var i = r("createUnit", {
        "Object, Object": function ObjectObject(e, n) {
          return t.Unit.createUnit(e, n);
        },
        Object: function Object(e) {
          return t.Unit.createUnit(e, {});
        },
        "string, Unit | string | Object, Object": function stringUnitStringObjectObject(e, n, r) {
          var i = {};
          return i[e] = n, t.Unit.createUnit(i, r);
        },
        "string, Unit | string | Object": function stringUnitStringObject(e, n) {
          var r = {};
          return r[e] = n, t.Unit.createUnit(r, {});
        },
        string: function string(e) {
          var n = {};
          return n[e] = {}, t.Unit.createUnit(n, {});
        }
      });
      return i;
    }

    n(1);
    e.name = "createUnit", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var i = r("splitUnit", {
        "Unit, Array": function UnitArray(t, e) {
          return t.splitUnit(e);
        }
      });
      return i;
    }

    n(1);
    e.name = "splitUnit", e.factory = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n, r) {
      var o = r("unit", {
        Unit: function Unit(t) {
          return t.clone();
        },
        string: function string(e) {
          return t.Unit.isValuelessUnit(e) ? new t.Unit(null, e) : t.Unit.parse(e);
        },
        "number | BigNumber | Fraction | Complex, string": function numberBigNumberFractionComplexString(e, n) {
          return new t.Unit(e, n);
        },
        "Array | Matrix": function ArrayMatrix(t) {
          return i(t, o);
        }
      });
      return o.toTex = {
        1: "\\left(${args[0]}\\right)",
        2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
      }, o;
    }

    var i = n(1);
    e.name = "unit", e.factory = r;
  }, function (t, e, n) {
    t.exports = [n(156), n(537), n(535), n(536), n(539)];
  }, function (t, e, n) {
    function r(t, e, n, r, o) {
      function a(e) {
        var n = t.Unit.parse(e);
        return n.fixPrefix = !0, n;
      }

      i(o, "speedOfLight", function () {
        return a("299792458 m s^-1");
      }), i(o, "gravitationConstant", function () {
        return a("6.6738480e-11 m^3 kg^-1 s^-2");
      }), i(o, "planckConstant", function () {
        return a("6.626069311e-34 J s");
      }), i(o, "reducedPlanckConstant", function () {
        return a("1.05457172647e-34 J s");
      }), i(o, "magneticConstant", function () {
        return a("1.2566370614e-6 N A^-2");
      }), i(o, "electricConstant", function () {
        return a("8.854187817e-12 F m^-1");
      }), i(o, "vacuumImpedance", function () {
        return a("376.730313461 ohm");
      }), i(o, "coulomb", function () {
        return a("8.9875517873681764e9 N m^2 C^-2");
      }), i(o, "elementaryCharge", function () {
        return a("1.60217656535e-19 C");
      }), i(o, "bohrMagneton", function () {
        return a("9.2740096820e-24 J T^-1");
      }), i(o, "conductanceQuantum", function () {
        return a("7.748091734625e-5 S");
      }), i(o, "inverseConductanceQuantum", function () {
        return a("12906.403721742 ohm");
      }), i(o, "magneticFluxQuantum", function () {
        return a("2.06783375846e-15 Wb");
      }), i(o, "nuclearMagneton", function () {
        return a("5.0507835311e-27 J T^-1");
      }), i(o, "klitzing", function () {
        return a("25812.807443484 ohm");
      }), i(o, "bohrRadius", function () {
        return a("5.291772109217e-11 m");
      }), i(o, "classicalElectronRadius", function () {
        return a("2.817940326727e-15 m");
      }), i(o, "electronMass", function () {
        return a("9.1093829140e-31 kg");
      }), i(o, "fermiCoupling", function () {
        return a("1.1663645e-5 GeV^-2");
      }), i(o, "fineStructure", function () {
        return .007297352569824;
      }), i(o, "hartreeEnergy", function () {
        return a("4.3597443419e-18 J");
      }), i(o, "protonMass", function () {
        return a("1.67262177774e-27 kg");
      }), i(o, "deuteronMass", function () {
        return a("3.3435830926e-27 kg");
      }), i(o, "neutronMass", function () {
        return a("1.6749271613e-27 kg");
      }), i(o, "quantumOfCirculation", function () {
        return a("3.636947552024e-4 m^2 s^-1");
      }), i(o, "rydberg", function () {
        return a("10973731.56853955 m^-1");
      }), i(o, "thomsonCrossSection", function () {
        return a("6.65245873413e-29 m^2");
      }), i(o, "weakMixingAngle", function () {
        return .222321;
      }), i(o, "efimovFactor", function () {
        return 22.7;
      }), i(o, "atomicMass", function () {
        return a("1.66053892173e-27 kg");
      }), i(o, "avogadro", function () {
        return a("6.0221412927e23 mol^-1");
      }), i(o, "boltzmann", function () {
        return a("1.380648813e-23 J K^-1");
      }), i(o, "faraday", function () {
        return a("96485.336521 C mol^-1");
      }), i(o, "firstRadiation", function () {
        return a("3.7417715317e-16 W m^2");
      }), i(o, "loschmidt", function () {
        return a("2.686780524e25 m^-3");
      }), i(o, "gasConstant", function () {
        return a("8.314462175 J K^-1 mol^-1");
      }), i(o, "molarPlanckConstant", function () {
        return a("3.990312717628e-10 J s mol^-1");
      }), i(o, "molarVolume", function () {
        return a("2.241396820e-10 m^3 mol^-1");
      }), i(o, "sackurTetrode", function () {
        return -1.164870823;
      }), i(o, "secondRadiation", function () {
        return a("1.438777013e-2 m K");
      }), i(o, "stefanBoltzmann", function () {
        return a("5.67037321e-8 W m^-2 K^-4");
      }), i(o, "wienDisplacement", function () {
        return a("2.897772126e-3 m K");
      }), i(o, "molarMass", function () {
        return a("1e-3 kg mol^-1");
      }), i(o, "molarMassC12", function () {
        return a("1.2e-2 kg mol^-1");
      }), i(o, "gravity", function () {
        return a("9.80665 m s^-2");
      }), i(o, "planckLength", function () {
        return a("1.61619997e-35 m");
      }), i(o, "planckMass", function () {
        return a("2.1765113e-8 kg");
      }), i(o, "planckTime", function () {
        return a("5.3910632e-44 s");
      }), i(o, "planckCharge", function () {
        return a("1.87554595641e-18 C");
      }), i(o, "planckTemperature", function () {
        return a("1.41683385e+32 K");
      });
    }

    var i = n(5).lazy;
    e.factory = r, e.lazy = !1, e.math = !0;
  }, function (t, e) {
    "use strict";

    function n(t) {
      var e = String(t).toLowerCase().match(/^0*?(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
      if (!e) throw new SyntaxError("Invalid number");
      var n = e[1],
          r = e[2],
          i = parseFloat(e[4] || "0"),
          o = r.indexOf(".");
      i += o !== -1 ? o - 1 : r.length - 1, this.sign = n, this.coefficients = r.replace(".", "").replace(/^0*/, function (t) {
        return i -= t.length, "";
      }).replace(/0*$/, "").split("").map(function (t) {
        return parseInt(t);
      }), 0 === this.coefficients.length && (this.coefficients.push(0), i++), this.exponent = i;
    }

    function r(t) {
      for (var e = [], n = 0; n < t; n++) {
        e.push(0);
      }

      return e;
    }

    n.prototype.toEngineering = function (t) {
      var e = this.roundDigits(t),
          n = e.exponent,
          i = e.coefficients,
          o = n % 3 === 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3,
          a = n >= 0 ? n : Math.abs(o);
      i.length - 1 < a && (i = i.concat(r(a - (i.length - 1))));

      for (var s = Math.abs(n - o), u = 1, c = ""; --s >= 0;) {
        u++;
      }

      var l = i.slice(u).join(""),
          h = l.match(/[1-9]/) ? "." + l : "";
      return c = i.slice(0, u).join("") + h, c += "e" + (n >= 0 ? "+" : "") + o.toString(), e.sign + c;
    }, n.prototype.toFixed = function (t) {
      var e = this.roundDigits(this.exponent + 1 + (t || 0)),
          n = e.coefficients,
          i = e.exponent + 1,
          o = i + (t || 0);
      return n.length < o && (n = n.concat(r(o - n.length))), i < 0 && (n = r(-i + 1).concat(n), i = 1), t && n.splice(i, 0, 0 === i ? "0." : "."), this.sign + n.join("");
    }, n.prototype.toExponential = function (t) {
      var e = t ? this.roundDigits(t) : this.clone(),
          n = e.coefficients,
          i = e.exponent;
      n.length < t && (n = n.concat(r(t - n.length)));
      var o = n.shift();
      return this.sign + o + (n.length > 0 ? "." + n.join("") : "") + "e" + (i >= 0 ? "+" : "") + i;
    }, n.prototype.toPrecision = function (t, e) {
      var n = e && void 0 !== e.lower ? e.lower : .001,
          i = e && void 0 !== e.upper ? e.upper : 1e5,
          o = Math.abs(Math.pow(10, this.exponent));
      if (o < n || o >= i) return this.toExponential(t);
      var a = t ? this.roundDigits(t) : this.clone(),
          s = a.coefficients,
          u = a.exponent;
      s.length < t && (s = s.concat(r(t - s.length))), s = s.concat(r(u - s.length + 1 + (s.length < t ? t - s.length : 0))), s = r(-u).concat(s);
      var c = u > 0 ? u : 0;
      return c < s.length - 1 && s.splice(c + 1, 0, "."), this.sign + s.join("");
    }, n.prototype.clone = function () {
      var t = new n("0");
      return t.sign = this.sign, t.coefficients = this.coefficients.slice(0), t.exponent = this.exponent, t;
    }, n.prototype.roundDigits = function (t) {
      for (var e = this.clone(), n = e.coefficients; t <= 0;) {
        n.unshift(0), e.exponent++, t++;
      }

      if (n.length > t) {
        var r = n.splice(t, n.length - t);

        if (r[0] >= 5) {
          var i = t - 1;

          for (n[i]++; 10 === n[i];) {
            n.pop(), 0 === i && (n.unshift(0), e.exponent++, i++), i--, n[i]++;
          }
        }
      }

      return e;
    }, t.exports = n;
  }, function (t, e, n) {
    var r = n(91);

    t.exports = function (t, e) {
      if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitAnd");
      var n = t.constructor;
      if (t.isNaN() || e.isNaN()) return new n(NaN);
      if (t.isZero() || e.eq(-1) || t.eq(e)) return t;
      if (e.isZero() || t.eq(-1)) return e;

      if (!t.isFinite() || !e.isFinite()) {
        if (!t.isFinite() && !e.isFinite()) return t.isNegative() == e.isNegative() ? t : new n(0);
        if (!t.isFinite()) return e.isNegative() ? t : t.isNegative() ? new n(0) : e;
        if (!e.isFinite()) return t.isNegative() ? e : e.isNegative() ? new n(0) : t;
      }

      return r(t, e, function (t, e) {
        return t & e;
      });
    };
  }, function (t, e, n) {
    var r = n(91);

    t.exports = function (t, e) {
      if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitOr");
      var n = t.constructor;
      if (t.isNaN() || e.isNaN()) return new n(NaN);
      var i = new n(-1);
      return t.isZero() || e.eq(i) || t.eq(e) ? e : e.isZero() || t.eq(i) ? t : t.isFinite() && e.isFinite() ? r(t, e, function (t, e) {
        return t | e;
      }) : !t.isFinite() && !t.isNegative() && e.isNegative() || t.isNegative() && !e.isNegative() && !e.isFinite() ? i : t.isNegative() && e.isNegative() ? t.isFinite() ? t : e : t.isFinite() ? e : t;
    };
  }, function (t, e, n) {
    var r = n(91),
        i = n(90);

    t.exports = function (t, e) {
      if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function bitXor");
      var n = t.constructor;
      if (t.isNaN() || e.isNaN()) return new n(NaN);
      if (t.isZero()) return e;
      if (e.isZero()) return t;
      if (t.eq(e)) return new n(0);
      var o = new n(-1);
      return t.eq(o) ? i(e) : e.eq(o) ? i(t) : t.isFinite() && e.isFinite() ? r(t, e, function (t, e) {
        return t ^ e;
      }) : t.isFinite() || e.isFinite() ? new n(t.isNegative() == e.isNegative() ? 1 / 0 : -(1 / 0)) : o;
    };
  }, function (t, e) {
    e.format = function (t, n) {
      if ("function" == typeof n) return n(t);
      if (!t.isFinite()) return t.isNaN() ? "NaN" : t.gt(0) ? "Infinity" : "-Infinity";
      var r = "auto",
          i = void 0;

      switch (void 0 !== n && (n.notation && (r = n.notation), "number" == typeof n ? i = n : n.precision && (i = n.precision)), r) {
        case "fixed":
          return e.toFixed(t, i);

        case "exponential":
          return e.toExponential(t, i);

        case "auto":
          var o = .001,
              a = 1e5;
          n && n.exponential && (void 0 !== n.exponential.lower && (o = n.exponential.lower), void 0 !== n.exponential.upper && (a = n.exponential.upper));
          ({
            toExpNeg: t.constructor.toExpNeg,
            toExpPos: t.constructor.toExpPos
          });
          if (t.constructor.config({
            toExpNeg: Math.round(Math.log(o) / Math.LN10),
            toExpPos: Math.round(Math.log(a) / Math.LN10)
          }), t.isZero()) return "0";
          var s,
              u = t.abs();
          return s = u.gte(o) && u.lt(a) ? t.toSignificantDigits(i).toFixed() : e.toExponential(t, i), s.replace(/((\.\d*?)(0+))($|e)/, function () {
            var t = arguments[2],
                e = arguments[4];
            return "." !== t ? t + e : e;
          });

        default:
          throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", or "fixed".');
      }
    }, e.toExponential = function (t, e) {
      return void 0 !== e ? t.toExponential(e - 1) : t.toExponential();
    }, e.toFixed = function (t, e) {
      return t.toFixed(e || 0);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function leftShift");
      var n = t.constructor;
      return t.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new n(NaN) : t.isZero() || e.isZero() ? t : t.isFinite() || e.isFinite() ? e.lt(55) ? t.times(Math.pow(2, e.toNumber()) + "") : t.times(new n(2).pow(e)) : new n(NaN);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (t.isFinite() && !t.isInteger() || e.isFinite() && !e.isInteger()) throw new Error("Integers expected in function rightArithShift");
      var n = t.constructor;
      return t.isNaN() || e.isNaN() || e.isNegative() && !e.isZero() ? new n(NaN) : t.isZero() || e.isZero() ? t : e.isFinite() ? e.lt(55) ? t.div(Math.pow(2, e.toNumber()) + "").floor() : t.div(new n(2).pow(e)).floor() : new n(t.isNegative() ? -1 : t.isFinite() ? 0 : NaN);
    };
  }, function (t, e) {
    "use strict";

    e.isBoolean = function (t) {
      return "boolean" == typeof t;
    };
  }, function (t, e) {
    "use strict";

    t.exports = function (t, e, n, r, i, o, a, s, u, c, l) {
      var h,
          f,
          p,
          m,
          d = t._values,
          g = t._index,
          v = t._ptr,
          y = a._index;
      if (r) for (f = v[e], p = v[e + 1], h = f; h < p; h++) {
        m = g[h], n[m] !== o ? (n[m] = o, y.push(m), c ? (r[m] = u ? s(d[h], l) : s(l, d[h]), i[m] = o) : r[m] = d[h]) : (r[m] = u ? s(d[h], r[m]) : s(r[m], d[h]), i[m] = o);
      } else for (f = v[e], p = v[e + 1], h = f; h < p; h++) {
        m = g[h], n[m] !== o ? (n[m] = o, y.push(m)) : i[m] = o;
      }
    };
  }, function (t, e) {
    t.exports = "3.8.0";
  }, function (t, e, n) {
    var r, r;
    !function (e) {
      t.exports = e();
    }(function () {
      return function t(e, n, i) {
        function o(s, u) {
          if (!n[s]) {
            if (!e[s]) {
              var c = "function" == typeof r && r;
              if (!u && c) return r(s, !0);
              if (a) return a(s, !0);
              var l = new Error("Cannot find module '" + s + "'");
              throw l.code = "MODULE_NOT_FOUND", l;
            }

            var h = n[s] = {
              exports: {}
            };
            e[s][0].call(h.exports, function (t) {
              var n = e[s][1][t];
              return o(n ? n : t);
            }, h, h.exports, t, e, n, i);
          }

          return n[s].exports;
        }

        for (var a = "function" == typeof r && r, s = 0; s < i.length; s++) {
          o(i[s]);
        }

        return o;
      }({
        "./includedProjections": [function (t, e, n) {
          var r = [t("./lib/projections/tmerc"), t("./lib/projections/utm"), t("./lib/projections/sterea"), t("./lib/projections/stere"), t("./lib/projections/somerc"), t("./lib/projections/omerc"), t("./lib/projections/lcc"), t("./lib/projections/krovak"), t("./lib/projections/cass"), t("./lib/projections/laea"), t("./lib/projections/aea"), t("./lib/projections/gnom"), t("./lib/projections/cea"), t("./lib/projections/eqc"), t("./lib/projections/poly"), t("./lib/projections/nzmg"), t("./lib/projections/mill"), t("./lib/projections/sinu"), t("./lib/projections/moll"), t("./lib/projections/eqdc"), t("./lib/projections/vandg"), t("./lib/projections/aeqd"), t("./lib/projections/ortho")];

          e.exports = function (t) {
            r.forEach(function (e) {
              t.Proj.projections.add(e);
            });
          };
        }, {
          "./lib/projections/aea": 40,
          "./lib/projections/aeqd": 41,
          "./lib/projections/cass": 42,
          "./lib/projections/cea": 43,
          "./lib/projections/eqc": 44,
          "./lib/projections/eqdc": 45,
          "./lib/projections/gnom": 47,
          "./lib/projections/krovak": 48,
          "./lib/projections/laea": 49,
          "./lib/projections/lcc": 50,
          "./lib/projections/mill": 53,
          "./lib/projections/moll": 54,
          "./lib/projections/nzmg": 55,
          "./lib/projections/omerc": 56,
          "./lib/projections/ortho": 57,
          "./lib/projections/poly": 58,
          "./lib/projections/sinu": 59,
          "./lib/projections/somerc": 60,
          "./lib/projections/stere": 61,
          "./lib/projections/sterea": 62,
          "./lib/projections/tmerc": 63,
          "./lib/projections/utm": 64,
          "./lib/projections/vandg": 65
        }],
        1: [function (t, e, n) {
          function r(t, e, n) {
            if (!(this instanceof r)) return new r(t, e, n);
            if (Array.isArray(t)) this.x = t[0], this.y = t[1], this.z = t[2] || 0;else if ("object" == typeof t) this.x = t.x, this.y = t.y, this.z = t.z || 0;else if ("string" == typeof t && "undefined" == typeof e) {
              var i = t.split(",");
              this.x = parseFloat(i[0], 10), this.y = parseFloat(i[1], 10), this.z = parseFloat(i[2], 10) || 0;
            } else this.x = t, this.y = e, this.z = n || 0;
            console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
          }

          var i = t("mgrs");
          r.fromMGRS = function (t) {
            return new r(i.toPoint(t));
          }, r.prototype.toMGRS = function (t) {
            return i.forward([this.x, this.y], t);
          }, e.exports = r;
        }, {
          mgrs: 68
        }],
        2: [function (t, e, n) {
          function r(t, e) {
            if (!(this instanceof r)) return new r(t);

            e = e || function (t) {
              if (t) throw t;
            };

            var n = i(t);
            if ("object" != typeof n) return void e(t);
            var a = s(n),
                u = r.projections.get(a.projName);
            u ? (o(this, a), o(this, u), this.init(), e(null, this)) : e(t);
          }

          var i = t("./parseCode"),
              o = t("./extend"),
              a = t("./projections"),
              s = t("./deriveConstants");
          r.projections = a, r.projections.start(), e.exports = r;
        }, {
          "./deriveConstants": 33,
          "./extend": 34,
          "./parseCode": 37,
          "./projections": 39
        }],
        3: [function (t, e, n) {
          e.exports = function (t, e, n) {
            var r,
                i,
                o,
                a = n.x,
                s = n.y,
                u = n.z || 0;

            for (o = 0; 3 > o; o++) {
              if (!e || 2 !== o || void 0 !== n.z) switch (0 === o ? (r = a, i = "x") : 1 === o ? (r = s, i = "y") : (r = u, i = "z"), t.axis[o]) {
                case "e":
                  n[i] = r;
                  break;

                case "w":
                  n[i] = -r;
                  break;

                case "n":
                  n[i] = r;
                  break;

                case "s":
                  n[i] = -r;
                  break;

                case "u":
                  void 0 !== n[i] && (n.z = r);
                  break;

                case "d":
                  void 0 !== n[i] && (n.z = -r);
                  break;

                default:
                  return null;
              }
            }

            return n;
          };
        }, {}],
        4: [function (t, e, n) {
          var r = Math.PI / 2,
              i = t("./sign");

          e.exports = function (t) {
            return Math.abs(t) < r ? t : t - i(t) * Math.PI;
          };
        }, {
          "./sign": 21
        }],
        5: [function (t, e, n) {
          var r = 2 * Math.PI,
              i = 3.14159265359,
              o = t("./sign");

          e.exports = function (t) {
            return Math.abs(t) <= i ? t : t - o(t) * r;
          };
        }, {
          "./sign": 21
        }],
        6: [function (t, e, n) {
          e.exports = function (t) {
            return Math.abs(t) > 1 && (t = t > 1 ? 1 : -1), Math.asin(t);
          };
        }, {}],
        7: [function (t, e, n) {
          e.exports = function (t) {
            return 1 - .25 * t * (1 + t / 16 * (3 + 1.25 * t));
          };
        }, {}],
        8: [function (t, e, n) {
          e.exports = function (t) {
            return .375 * t * (1 + .25 * t * (1 + .46875 * t));
          };
        }, {}],
        9: [function (t, e, n) {
          e.exports = function (t) {
            return .05859375 * t * t * (1 + .75 * t);
          };
        }, {}],
        10: [function (t, e, n) {
          e.exports = function (t) {
            return t * t * t * (35 / 3072);
          };
        }, {}],
        11: [function (t, e, n) {
          e.exports = function (t, e, n) {
            var r = e * n;
            return t / Math.sqrt(1 - r * r);
          };
        }, {}],
        12: [function (t, e, n) {
          e.exports = function (t, e, n, r, i) {
            var o, a;
            o = t / e;

            for (var s = 0; 15 > s; s++) {
              if (a = (t - (e * o - n * Math.sin(2 * o) + r * Math.sin(4 * o) - i * Math.sin(6 * o))) / (e - 2 * n * Math.cos(2 * o) + 4 * r * Math.cos(4 * o) - 6 * i * Math.cos(6 * o)), o += a, Math.abs(a) <= 1e-10) return o;
            }

            return NaN;
          };
        }, {}],
        13: [function (t, e, n) {
          var r = Math.PI / 2;

          e.exports = function (t, e) {
            var n = 1 - (1 - t * t) / (2 * t) * Math.log((1 - t) / (1 + t));
            if (Math.abs(Math.abs(e) - n) < 1e-6) return 0 > e ? -1 * r : r;

            for (var i, o, a, s, u = Math.asin(.5 * e), c = 0; 30 > c; c++) {
              if (o = Math.sin(u), a = Math.cos(u), s = t * o, i = Math.pow(1 - s * s, 2) / (2 * a) * (e / (1 - t * t) - o / (1 - s * s) + .5 / t * Math.log((1 - s) / (1 + s))), u += i, Math.abs(i) <= 1e-10) return u;
            }

            return NaN;
          };
        }, {}],
        14: [function (t, e, n) {
          e.exports = function (t, e, n, r, i) {
            return t * i - e * Math.sin(2 * i) + n * Math.sin(4 * i) - r * Math.sin(6 * i);
          };
        }, {}],
        15: [function (t, e, n) {
          e.exports = function (t, e, n) {
            var r = t * e;
            return n / Math.sqrt(1 - r * r);
          };
        }, {}],
        16: [function (t, e, n) {
          var r = Math.PI / 2;

          e.exports = function (t, e) {
            for (var n, i, o = .5 * t, a = r - 2 * Math.atan(e), s = 0; 15 >= s; s++) {
              if (n = t * Math.sin(a), i = r - 2 * Math.atan(e * Math.pow((1 - n) / (1 + n), o)) - a, a += i, Math.abs(i) <= 1e-10) return a;
            }

            return -9999;
          };
        }, {}],
        17: [function (t, e, n) {
          var r = 1,
              i = .25,
              o = .046875,
              a = .01953125,
              s = .01068115234375,
              u = .75,
              c = .46875,
              l = .013020833333333334,
              h = .007120768229166667,
              f = .3645833333333333,
              p = .005696614583333333,
              m = .3076171875;

          e.exports = function (t) {
            var e = [];
            e[0] = r - t * (i + t * (o + t * (a + t * s))), e[1] = t * (u - t * (o + t * (a + t * s)));
            var n = t * t;
            return e[2] = n * (c - t * (l + t * h)), n *= t, e[3] = n * (f - t * p), e[4] = n * t * m, e;
          };
        }, {}],
        18: [function (t, e, n) {
          var r = t("./pj_mlfn"),
              i = 1e-10,
              o = 20;

          e.exports = function (t, e, n) {
            for (var a = 1 / (1 - e), s = t, u = o; u; --u) {
              var c = Math.sin(s),
                  l = 1 - e * c * c;
              if (l = (r(s, c, Math.cos(s), n) - t) * (l * Math.sqrt(l)) * a, s -= l, Math.abs(l) < i) return s;
            }

            return s;
          };
        }, {
          "./pj_mlfn": 19
        }],
        19: [function (t, e, n) {
          e.exports = function (t, e, n, r) {
            return n *= e, e *= e, r[0] * t - n * (r[1] + e * (r[2] + e * (r[3] + e * r[4])));
          };
        }, {}],
        20: [function (t, e, n) {
          e.exports = function (t, e) {
            var n;
            return t > 1e-7 ? (n = t * e, (1 - t * t) * (e / (1 - n * n) - .5 / t * Math.log((1 - n) / (1 + n)))) : 2 * e;
          };
        }, {}],
        21: [function (t, e, n) {
          e.exports = function (t) {
            return 0 > t ? -1 : 1;
          };
        }, {}],
        22: [function (t, e, n) {
          e.exports = function (t, e) {
            return Math.pow((1 - t) / (1 + t), e);
          };
        }, {}],
        23: [function (t, e, n) {
          e.exports = function (t) {
            var e = {
              x: t[0],
              y: t[1]
            };
            return t.length > 2 && (e.z = t[2]), t.length > 3 && (e.m = t[3]), e;
          };
        }, {}],
        24: [function (t, e, n) {
          var r = Math.PI / 2;

          e.exports = function (t, e, n) {
            var i = t * n,
                o = .5 * t;
            return i = Math.pow((1 - i) / (1 + i), o), Math.tan(.5 * (r - e)) / i;
          };
        }, {}],
        25: [function (t, e, n) {
          n.wgs84 = {
            towgs84: "0,0,0",
            ellipse: "WGS84",
            datumName: "WGS84"
          }, n.ch1903 = {
            towgs84: "674.374,15.056,405.346",
            ellipse: "bessel",
            datumName: "swiss"
          }, n.ggrs87 = {
            towgs84: "-199.87,74.79,246.62",
            ellipse: "GRS80",
            datumName: "Greek_Geodetic_Reference_System_1987"
          }, n.nad83 = {
            towgs84: "0,0,0",
            ellipse: "GRS80",
            datumName: "North_American_Datum_1983"
          }, n.nad27 = {
            nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
            ellipse: "clrk66",
            datumName: "North_American_Datum_1927"
          }, n.potsdam = {
            towgs84: "606.0,23.0,413.0",
            ellipse: "bessel",
            datumName: "Potsdam Rauenberg 1950 DHDN"
          }, n.carthage = {
            towgs84: "-263.0,6.0,431.0",
            ellipse: "clark80",
            datumName: "Carthage 1934 Tunisia"
          }, n.hermannskogel = {
            towgs84: "653.0,-212.0,449.0",
            ellipse: "bessel",
            datumName: "Hermannskogel"
          }, n.ire65 = {
            towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
            ellipse: "mod_airy",
            datumName: "Ireland 1965"
          }, n.rassadiran = {
            towgs84: "-133.63,-157.5,-158.62",
            ellipse: "intl",
            datumName: "Rassadiran"
          }, n.nzgd49 = {
            towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
            ellipse: "intl",
            datumName: "New Zealand Geodetic Datum 1949"
          }, n.osgb36 = {
            towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
            ellipse: "airy",
            datumName: "Airy 1830"
          }, n.s_jtsk = {
            towgs84: "589,76,480",
            ellipse: "bessel",
            datumName: "S-JTSK (Ferro)"
          }, n.beduaram = {
            towgs84: "-106,-87,188",
            ellipse: "clrk80",
            datumName: "Beduaram"
          }, n.gunung_segara = {
            towgs84: "-403,684,41",
            ellipse: "bessel",
            datumName: "Gunung Segara Jakarta"
          }, n.rnb72 = {
            towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
            ellipse: "intl",
            datumName: "Reseau National Belge 1972"
          };
        }, {}],
        26: [function (t, e, n) {
          n.MERIT = {
            a: 6378137,
            rf: 298.257,
            ellipseName: "MERIT 1983"
          }, n.SGS85 = {
            a: 6378136,
            rf: 298.257,
            ellipseName: "Soviet Geodetic System 85"
          }, n.GRS80 = {
            a: 6378137,
            rf: 298.257222101,
            ellipseName: "GRS 1980(IUGG, 1980)"
          }, n.IAU76 = {
            a: 6378140,
            rf: 298.257,
            ellipseName: "IAU 1976"
          }, n.airy = {
            a: 6377563.396,
            b: 6356256.91,
            ellipseName: "Airy 1830"
          }, n.APL4 = {
            a: 6378137,
            rf: 298.25,
            ellipseName: "Appl. Physics. 1965"
          }, n.NWL9D = {
            a: 6378145,
            rf: 298.25,
            ellipseName: "Naval Weapons Lab., 1965"
          }, n.mod_airy = {
            a: 6377340.189,
            b: 6356034.446,
            ellipseName: "Modified Airy"
          }, n.andrae = {
            a: 6377104.43,
            rf: 300,
            ellipseName: "Andrae 1876 (Den., Iclnd.)"
          }, n.aust_SA = {
            a: 6378160,
            rf: 298.25,
            ellipseName: "Australian Natl & S. Amer. 1969"
          }, n.GRS67 = {
            a: 6378160,
            rf: 298.247167427,
            ellipseName: "GRS 67(IUGG 1967)"
          }, n.bessel = {
            a: 6377397.155,
            rf: 299.1528128,
            ellipseName: "Bessel 1841"
          }, n.bess_nam = {
            a: 6377483.865,
            rf: 299.1528128,
            ellipseName: "Bessel 1841 (Namibia)"
          }, n.clrk66 = {
            a: 6378206.4,
            b: 6356583.8,
            ellipseName: "Clarke 1866"
          }, n.clrk80 = {
            a: 6378249.145,
            rf: 293.4663,
            ellipseName: "Clarke 1880 mod."
          }, n.clrk58 = {
            a: 6378293.645208759,
            rf: 294.2606763692654,
            ellipseName: "Clarke 1858"
          }, n.CPM = {
            a: 6375738.7,
            rf: 334.29,
            ellipseName: "Comm. des Poids et Mesures 1799"
          }, n.delmbr = {
            a: 6376428,
            rf: 311.5,
            ellipseName: "Delambre 1810 (Belgium)"
          }, n.engelis = {
            a: 6378136.05,
            rf: 298.2566,
            ellipseName: "Engelis 1985"
          }, n.evrst30 = {
            a: 6377276.345,
            rf: 300.8017,
            ellipseName: "Everest 1830"
          }, n.evrst48 = {
            a: 6377304.063,
            rf: 300.8017,
            ellipseName: "Everest 1948"
          }, n.evrst56 = {
            a: 6377301.243,
            rf: 300.8017,
            ellipseName: "Everest 1956"
          }, n.evrst69 = {
            a: 6377295.664,
            rf: 300.8017,
            ellipseName: "Everest 1969"
          }, n.evrstSS = {
            a: 6377298.556,
            rf: 300.8017,
            ellipseName: "Everest (Sabah & Sarawak)"
          }, n.fschr60 = {
            a: 6378166,
            rf: 298.3,
            ellipseName: "Fischer (Mercury Datum) 1960"
          }, n.fschr60m = {
            a: 6378155,
            rf: 298.3,
            ellipseName: "Fischer 1960"
          }, n.fschr68 = {
            a: 6378150,
            rf: 298.3,
            ellipseName: "Fischer 1968"
          }, n.helmert = {
            a: 6378200,
            rf: 298.3,
            ellipseName: "Helmert 1906"
          }, n.hough = {
            a: 6378270,
            rf: 297,
            ellipseName: "Hough"
          }, n.intl = {
            a: 6378388,
            rf: 297,
            ellipseName: "International 1909 (Hayford)"
          }, n.kaula = {
            a: 6378163,
            rf: 298.24,
            ellipseName: "Kaula 1961"
          }, n.lerch = {
            a: 6378139,
            rf: 298.257,
            ellipseName: "Lerch 1979"
          }, n.mprts = {
            a: 6397300,
            rf: 191,
            ellipseName: "Maupertius 1738"
          }, n.new_intl = {
            a: 6378157.5,
            b: 6356772.2,
            ellipseName: "New International 1967"
          }, n.plessis = {
            a: 6376523,
            rf: 6355863,
            ellipseName: "Plessis 1817 (France)"
          }, n.krass = {
            a: 6378245,
            rf: 298.3,
            ellipseName: "Krassovsky, 1942"
          }, n.SEasia = {
            a: 6378155,
            b: 6356773.3205,
            ellipseName: "Southeast Asia"
          }, n.walbeck = {
            a: 6376896,
            b: 6355834.8467,
            ellipseName: "Walbeck"
          }, n.WGS60 = {
            a: 6378165,
            rf: 298.3,
            ellipseName: "WGS 60"
          }, n.WGS66 = {
            a: 6378145,
            rf: 298.25,
            ellipseName: "WGS 66"
          }, n.WGS7 = {
            a: 6378135,
            rf: 298.26,
            ellipseName: "WGS 72"
          }, n.WGS84 = {
            a: 6378137,
            rf: 298.257223563,
            ellipseName: "WGS 84"
          }, n.sphere = {
            a: 6370997,
            b: 6370997,
            ellipseName: "Normal Sphere (r=6370997)"
          };
        }, {}],
        27: [function (t, e, n) {
          n.greenwich = 0, n.lisbon = -9.131906111111, n.paris = 2.337229166667, n.bogota = -74.080916666667, n.madrid = -3.687938888889, n.rome = 12.452333333333, n.bern = 7.439583333333, n.jakarta = 106.807719444444, n.ferro = -17.666666666667, n.brussels = 4.367975, n.stockholm = 18.058277777778, n.athens = 23.7163375, n.oslo = 10.722916666667;
        }, {}],
        28: [function (t, e, n) {
          n.ft = {
            to_meter: .3048
          }, n["us-ft"] = {
            to_meter: 1200 / 3937
          };
        }, {}],
        29: [function (t, e, n) {
          function r(t, e, n) {
            var r;
            return Array.isArray(n) ? (r = s(t, e, n), 3 === n.length ? [r.x, r.y, r.z] : [r.x, r.y]) : s(t, e, n);
          }

          function i(t) {
            return t instanceof a ? t : t.oProj ? t.oProj : a(t);
          }

          function o(t, e, n) {
            t = i(t);
            var o,
                a = !1;
            return "undefined" == typeof e ? (e = t, t = u, a = !0) : ("undefined" != typeof e.x || Array.isArray(e)) && (n = e, e = t, t = u, a = !0), e = i(e), n ? r(t, e, n) : (o = {
              forward: function forward(n) {
                return r(t, e, n);
              },
              inverse: function inverse(n) {
                return r(e, t, n);
              }
            }, a && (o.oProj = e), o);
          }

          var a = t("./Proj"),
              s = t("./transform"),
              u = a("WGS84");
          e.exports = o;
        }, {
          "./Proj": 2,
          "./transform": 66
        }],
        30: [function (t, e, n) {
          var r = Math.PI / 2,
              i = 1,
              o = 2,
              a = 3,
              s = 4,
              u = 5,
              c = 484813681109536e-20,
              l = 1.0026,
              h = .3826834323650898,
              f = function f(t) {
            return this instanceof f ? (this.datum_type = s, void (t && (t.datumCode && "none" === t.datumCode && (this.datum_type = u), t.datum_params && (this.datum_params = t.datum_params.map(parseFloat), 0 === this.datum_params[0] && 0 === this.datum_params[1] && 0 === this.datum_params[2] || (this.datum_type = i), this.datum_params.length > 3 && (0 === this.datum_params[3] && 0 === this.datum_params[4] && 0 === this.datum_params[5] && 0 === this.datum_params[6] || (this.datum_type = o, this.datum_params[3] *= c, this.datum_params[4] *= c, this.datum_params[5] *= c, this.datum_params[6] = this.datum_params[6] / 1e6 + 1))), this.datum_type = t.grids ? a : this.datum_type, this.a = t.a, this.b = t.b, this.es = t.es, this.ep2 = t.ep2, this.datum_type === a && (this.grids = t.grids)))) : new f(t);
          };

          f.prototype = {
            compare_datums: function compare_datums(t) {
              return this.datum_type === t.datum_type && !(this.a !== t.a || Math.abs(this.es - t.es) > 5e-11) && (this.datum_type === i ? this.datum_params[0] === t.datum_params[0] && this.datum_params[1] === t.datum_params[1] && this.datum_params[2] === t.datum_params[2] : this.datum_type === o ? this.datum_params[0] === t.datum_params[0] && this.datum_params[1] === t.datum_params[1] && this.datum_params[2] === t.datum_params[2] && this.datum_params[3] === t.datum_params[3] && this.datum_params[4] === t.datum_params[4] && this.datum_params[5] === t.datum_params[5] && this.datum_params[6] === t.datum_params[6] : this.datum_type !== a && t.datum_type !== a || this.nadgrids === t.nadgrids);
            },
            geodetic_to_geocentric: function geodetic_to_geocentric(t) {
              var e,
                  n,
                  i,
                  o,
                  a,
                  s,
                  u,
                  c = t.x,
                  l = t.y,
                  h = t.z ? t.z : 0,
                  f = 0;
              if (-r > l && l > -1.001 * r) l = -r;else if (l > r && 1.001 * r > l) l = r;else if (-r > l || l > r) return null;
              return c > Math.PI && (c -= 2 * Math.PI), a = Math.sin(l), u = Math.cos(l), s = a * a, o = this.a / Math.sqrt(1 - this.es * s), e = (o + h) * u * Math.cos(c), n = (o + h) * u * Math.sin(c), i = (o * (1 - this.es) + h) * a, t.x = e, t.y = n, t.z = i, f;
            },
            geocentric_to_geodetic: function geocentric_to_geodetic(t) {
              var e,
                  n,
                  i,
                  o,
                  a,
                  s,
                  u,
                  c,
                  l,
                  h,
                  f,
                  p,
                  m,
                  d,
                  g,
                  v,
                  y,
                  x = 1e-12,
                  w = x * x,
                  b = 30,
                  _ = t.x,
                  E = t.y,
                  M = t.z ? t.z : 0;

              if (m = !1, e = Math.sqrt(_ * _ + E * E), n = Math.sqrt(_ * _ + E * E + M * M), e / this.a < x) {
                if (m = !0, g = 0, n / this.a < x) return v = r, void (y = -this.b);
              } else g = Math.atan2(E, _);

              i = M / n, o = e / n, a = 1 / Math.sqrt(1 - this.es * (2 - this.es) * o * o), c = o * (1 - this.es) * a, l = i * a, d = 0;

              do {
                d++, u = this.a / Math.sqrt(1 - this.es * l * l), y = e * c + M * l - u * (1 - this.es * l * l), s = this.es * u / (u + y), a = 1 / Math.sqrt(1 - s * (2 - s) * o * o), h = o * (1 - s) * a, f = i * a, p = f * c - h * l, c = h, l = f;
              } while (p * p > w && b > d);

              return v = Math.atan(f / Math.abs(h)), t.x = g, t.y = v, t.z = y, t;
            },
            geocentric_to_geodetic_noniter: function geocentric_to_geodetic_noniter(t) {
              var e,
                  n,
                  i,
                  o,
                  a,
                  s,
                  u,
                  c,
                  f,
                  p,
                  m,
                  d,
                  g,
                  v,
                  y,
                  x,
                  w,
                  b = t.x,
                  _ = t.y,
                  E = t.z ? t.z : 0;
              if (b = parseFloat(b), _ = parseFloat(_), E = parseFloat(E), w = !1, 0 !== b) e = Math.atan2(_, b);else if (_ > 0) e = r;else if (0 > _) e = -r;else if (w = !0, e = 0, E > 0) n = r;else {
                if (!(0 > E)) return n = r, void (i = -this.b);
                n = -r;
              }
              return a = b * b + _ * _, o = Math.sqrt(a), s = E * l, c = Math.sqrt(s * s + a), p = s / c, d = o / c, m = p * p * p, u = E + this.b * this.ep2 * m, x = o - this.a * this.es * d * d * d, f = Math.sqrt(u * u + x * x), g = u / f, v = x / f, y = this.a / Math.sqrt(1 - this.es * g * g), i = v >= h ? o / v - y : -h >= v ? o / -v - y : E / g + y * (this.es - 1), w === !1 && (n = Math.atan(g / v)), t.x = e, t.y = n, t.z = i, t;
            },
            geocentric_to_wgs84: function geocentric_to_wgs84(t) {
              if (this.datum_type === i) t.x += this.datum_params[0], t.y += this.datum_params[1], t.z += this.datum_params[2];else if (this.datum_type === o) {
                var e = this.datum_params[0],
                    n = this.datum_params[1],
                    r = this.datum_params[2],
                    a = this.datum_params[3],
                    s = this.datum_params[4],
                    u = this.datum_params[5],
                    c = this.datum_params[6],
                    l = c * (t.x - u * t.y + s * t.z) + e,
                    h = c * (u * t.x + t.y - a * t.z) + n,
                    f = c * (-s * t.x + a * t.y + t.z) + r;
                t.x = l, t.y = h, t.z = f;
              }
            },
            geocentric_from_wgs84: function geocentric_from_wgs84(t) {
              if (this.datum_type === i) t.x -= this.datum_params[0], t.y -= this.datum_params[1], t.z -= this.datum_params[2];else if (this.datum_type === o) {
                var e = this.datum_params[0],
                    n = this.datum_params[1],
                    r = this.datum_params[2],
                    a = this.datum_params[3],
                    s = this.datum_params[4],
                    u = this.datum_params[5],
                    c = this.datum_params[6],
                    l = (t.x - e) / c,
                    h = (t.y - n) / c,
                    f = (t.z - r) / c;
                t.x = l + u * h - s * f, t.y = -u * l + h + a * f, t.z = s * l - a * h + f;
              }
            }
          }, e.exports = f;
        }, {}],
        31: [function (t, e, n) {
          var r = 1,
              i = 2,
              o = 3,
              a = 5,
              s = 6378137,
              u = .006694379990141316;

          e.exports = function (t, e, n) {
            function c(t) {
              return t === r || t === i;
            }

            var l, h, f;
            if (t.compare_datums(e)) return n;
            if (t.datum_type === a || e.datum_type === a) return n;
            var p = t.a,
                m = t.es,
                d = e.a,
                g = e.es,
                v = t.datum_type;
            if (v === o) if (0 === this.apply_gridshift(t, 0, n)) t.a = s, t.es = u;else {
              if (!t.datum_params) return t.a = p, t.es = t.es, n;

              for (l = 1, h = 0, f = t.datum_params.length; f > h; h++) {
                l *= t.datum_params[h];
              }

              if (0 === l) return t.a = p, t.es = t.es, n;
              v = t.datum_params.length > 3 ? i : r;
            }
            return e.datum_type === o && (e.a = s, e.es = u), (t.es !== e.es || t.a !== e.a || c(v) || c(e.datum_type)) && (t.geodetic_to_geocentric(n), c(t.datum_type) && t.geocentric_to_wgs84(n), c(e.datum_type) && e.geocentric_from_wgs84(n), e.geocentric_to_geodetic(n)), e.datum_type === o && this.apply_gridshift(e, 1, n), t.a = p, t.es = m, e.a = d, e.es = g, n;
          };
        }, {}],
        32: [function (t, e, n) {
          function r(t) {
            var e = this;

            if (2 === arguments.length) {
              var n = arguments[1];
              "string" == typeof n ? "+" === n.charAt(0) ? r[t] = o(arguments[1]) : r[t] = a(arguments[1]) : r[t] = n;
            } else if (1 === arguments.length) {
              if (Array.isArray(t)) return t.map(function (t) {
                Array.isArray(t) ? r.apply(e, t) : r(t);
              });

              if ("string" == typeof t) {
                if (t in r) return r[t];
              } else "EPSG" in t ? r["EPSG:" + t.EPSG] = t : "ESRI" in t ? r["ESRI:" + t.ESRI] = t : "IAU2000" in t ? r["IAU2000:" + t.IAU2000] = t : console.log(t);

              return;
            }
          }

          var i = t("./global"),
              o = t("./projString"),
              a = t("./wkt");
          i(r), e.exports = r;
        }, {
          "./global": 35,
          "./projString": 38,
          "./wkt": 67
        }],
        33: [function (t, e, n) {
          var r = t("./constants/Datum"),
              i = t("./constants/Ellipsoid"),
              o = t("./extend"),
              a = t("./datum"),
              s = 1e-10,
              u = .16666666666666666,
              c = .04722222222222222,
              l = .022156084656084655;

          e.exports = function (t) {
            if (t.datumCode && "none" !== t.datumCode) {
              var e = r[t.datumCode];
              e && (t.datum_params = e.towgs84 ? e.towgs84.split(",") : null, t.ellps = e.ellipse, t.datumName = e.datumName ? e.datumName : t.datumCode);
            }

            if (!t.a) {
              var n = i[t.ellps] ? i[t.ellps] : i.WGS84;
              o(t, n);
            }

            return t.rf && !t.b && (t.b = (1 - 1 / t.rf) * t.a), (0 === t.rf || Math.abs(t.a - t.b) < s) && (t.sphere = !0, t.b = t.a), t.a2 = t.a * t.a, t.b2 = t.b * t.b, t.es = (t.a2 - t.b2) / t.a2, t.e = Math.sqrt(t.es), t.R_A && (t.a *= 1 - t.es * (u + t.es * (c + t.es * l)), t.a2 = t.a * t.a, t.b2 = t.b * t.b, t.es = 0), t.ep2 = (t.a2 - t.b2) / t.b2, t.k0 || (t.k0 = 1), t.axis || (t.axis = "enu"), t.datum || (t.datum = a(t)), t;
          };
        }, {
          "./constants/Datum": 25,
          "./constants/Ellipsoid": 26,
          "./datum": 30,
          "./extend": 34
        }],
        34: [function (t, e, n) {
          e.exports = function (t, e) {
            t = t || {};
            var n, r;
            if (!e) return t;

            for (r in e) {
              n = e[r], void 0 !== n && (t[r] = n);
            }

            return t;
          };
        }, {}],
        35: [function (t, e, n) {
          e.exports = function (t) {
            t("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), t("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), t("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"), t.WGS84 = t["EPSG:4326"], t["EPSG:3785"] = t["EPSG:3857"], t.GOOGLE = t["EPSG:3857"], t["EPSG:900913"] = t["EPSG:3857"], t["EPSG:102113"] = t["EPSG:3857"];
          };
        }, {}],
        36: [function (t, e, n) {
          var r = t("./core");
          r.defaultDatum = "WGS84", r.Proj = t("./Proj"), r.WGS84 = new r.Proj("WGS84"), r.Point = t("./Point"), r.toPoint = t("./common/toPoint"), r.defs = t("./defs"), r.transform = t("./transform"), r.mgrs = t("mgrs"), r.version = t("../package.json").version, t("./includedProjections")(r), e.exports = r;
        }, {
          "../package.json": 69,
          "./Point": 1,
          "./Proj": 2,
          "./common/toPoint": 23,
          "./core": 29,
          "./defs": 32,
          "./includedProjections": "./includedProjections",
          "./transform": 66,
          mgrs: 68
        }],
        37: [function (t, e, n) {
          function r(t) {
            return "string" == typeof t;
          }

          function i(t) {
            return t in u;
          }

          function o(t) {
            var e = ["GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS"];
            return e.reduce(function (e, n) {
              return e + 1 + t.indexOf(n);
            }, 0);
          }

          function a(t) {
            return "+" === t[0];
          }

          function s(t) {
            return r(t) ? i(t) ? u[t] : o(t) ? c(t) : a(t) ? l(t) : void 0 : t;
          }

          var u = t("./defs"),
              c = t("./wkt"),
              l = t("./projString");
          e.exports = s;
        }, {
          "./defs": 32,
          "./projString": 38,
          "./wkt": 67
        }],
        38: [function (t, e, n) {
          var r = .017453292519943295,
              i = t("./constants/PrimeMeridian"),
              o = t("./constants/units");

          e.exports = function (t) {
            var e = {},
                n = {};
            t.split("+").map(function (t) {
              return t.trim();
            }).filter(function (t) {
              return t;
            }).forEach(function (t) {
              var e = t.split("=");
              e.push(!0), n[e[0].toLowerCase()] = e[1];
            });
            var a,
                s,
                u,
                c = {
              proj: "projName",
              datum: "datumCode",
              rf: function rf(t) {
                e.rf = parseFloat(t);
              },
              lat_0: function lat_0(t) {
                e.lat0 = t * r;
              },
              lat_1: function lat_1(t) {
                e.lat1 = t * r;
              },
              lat_2: function lat_2(t) {
                e.lat2 = t * r;
              },
              lat_ts: function lat_ts(t) {
                e.lat_ts = t * r;
              },
              lon_0: function lon_0(t) {
                e.long0 = t * r;
              },
              lon_1: function lon_1(t) {
                e.long1 = t * r;
              },
              lon_2: function lon_2(t) {
                e.long2 = t * r;
              },
              alpha: function alpha(t) {
                e.alpha = parseFloat(t) * r;
              },
              lonc: function lonc(t) {
                e.longc = t * r;
              },
              x_0: function x_0(t) {
                e.x0 = parseFloat(t);
              },
              y_0: function y_0(t) {
                e.y0 = parseFloat(t);
              },
              k_0: function k_0(t) {
                e.k0 = parseFloat(t);
              },
              k: function k(t) {
                e.k0 = parseFloat(t);
              },
              a: function a(t) {
                e.a = parseFloat(t);
              },
              b: function b(t) {
                e.b = parseFloat(t);
              },
              r_a: function r_a() {
                e.R_A = !0;
              },
              zone: function zone(t) {
                e.zone = parseInt(t, 10);
              },
              south: function south() {
                e.utmSouth = !0;
              },
              towgs84: function towgs84(t) {
                e.datum_params = t.split(",").map(function (t) {
                  return parseFloat(t);
                });
              },
              to_meter: function to_meter(t) {
                e.to_meter = parseFloat(t);
              },
              units: function units(t) {
                e.units = t, o[t] && (e.to_meter = o[t].to_meter);
              },
              from_greenwich: function from_greenwich(t) {
                e.from_greenwich = t * r;
              },
              pm: function pm(t) {
                e.from_greenwich = (i[t] ? i[t] : parseFloat(t)) * r;
              },
              nadgrids: function nadgrids(t) {
                "@null" === t ? e.datumCode = "none" : e.nadgrids = t;
              },
              axis: function axis(t) {
                var n = "ewnsud";
                3 === t.length && -1 !== n.indexOf(t.substr(0, 1)) && -1 !== n.indexOf(t.substr(1, 1)) && -1 !== n.indexOf(t.substr(2, 1)) && (e.axis = t);
              }
            };

            for (a in n) {
              s = n[a], a in c ? (u = c[a], "function" == typeof u ? u(s) : e[u] = s) : e[a] = s;
            }

            return "string" == typeof e.datumCode && "WGS84" !== e.datumCode && (e.datumCode = e.datumCode.toLowerCase()), e;
          };
        }, {
          "./constants/PrimeMeridian": 27,
          "./constants/units": 28
        }],
        39: [function (t, e, n) {
          function r(t, e) {
            var n = a.length;
            return t.names ? (a[n] = t, t.names.forEach(function (t) {
              o[t.toLowerCase()] = n;
            }), this) : (console.log(e), !0);
          }

          var i = [t("./projections/merc"), t("./projections/longlat")],
              o = {},
              a = [];
          n.add = r, n.get = function (t) {
            if (!t) return !1;
            var e = t.toLowerCase();
            return "undefined" != typeof o[e] && a[o[e]] ? a[o[e]] : void 0;
          }, n.start = function () {
            i.forEach(r);
          };
        }, {
          "./projections/longlat": 51,
          "./projections/merc": 52
        }],
        40: [function (t, e, n) {
          var r = 1e-10,
              i = t("../common/msfnz"),
              o = t("../common/qsfnz"),
              a = t("../common/adjust_lon"),
              s = t("../common/asinz");
          n.init = function () {
            Math.abs(this.lat1 + this.lat2) < r || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = i(this.e3, this.sin_po, this.cos_po), this.qs1 = o(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = i(this.e3, this.sin_po, this.cos_po), this.qs2 = o(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = o(this.e3, this.sin_po, this.cos_po), Math.abs(this.lat1 - this.lat2) > r ? this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.ns0 = this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
          }, n.forward = function (t) {
            var e = t.x,
                n = t.y;
            this.sin_phi = Math.sin(n), this.cos_phi = Math.cos(n);
            var r = o(this.e3, this.sin_phi, this.cos_phi),
                i = this.a * Math.sqrt(this.c - this.ns0 * r) / this.ns0,
                s = this.ns0 * a(e - this.long0),
                u = i * Math.sin(s) + this.x0,
                c = this.rh - i * Math.cos(s) + this.y0;
            return t.x = u, t.y = c, t;
          }, n.inverse = function (t) {
            var e, n, r, i, o, s;
            return t.x -= this.x0, t.y = this.rh - t.y + this.y0, this.ns0 >= 0 ? (e = Math.sqrt(t.x * t.x + t.y * t.y), r = 1) : (e = -Math.sqrt(t.x * t.x + t.y * t.y), r = -1), i = 0, 0 !== e && (i = Math.atan2(r * t.x, r * t.y)), r = e * this.ns0 / this.a, this.sphere ? s = Math.asin((this.c - r * r) / (2 * this.ns0)) : (n = (this.c - r * r) / this.ns0, s = this.phi1z(this.e3, n)), o = a(i / this.ns0 + this.long0), t.x = o, t.y = s, t;
          }, n.phi1z = function (t, e) {
            var n,
                i,
                o,
                a,
                u,
                c = s(.5 * e);
            if (r > t) return c;

            for (var l = t * t, h = 1; 25 >= h; h++) {
              if (n = Math.sin(c), i = Math.cos(c), o = t * n, a = 1 - o * o, u = .5 * a * a / i * (e / (1 - l) - n / a + .5 / t * Math.log((1 - o) / (1 + o))), c += u, Math.abs(u) <= 1e-7) return c;
            }

            return null;
          }, n.names = ["Albers_Conic_Equal_Area", "Albers", "aea"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6,
          "../common/msfnz": 15,
          "../common/qsfnz": 20
        }],
        41: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = Math.PI / 2,
              o = 1e-10,
              a = t("../common/mlfn"),
              s = t("../common/e0fn"),
              u = t("../common/e1fn"),
              c = t("../common/e2fn"),
              l = t("../common/e3fn"),
              h = t("../common/gN"),
              f = t("../common/asinz"),
              p = t("../common/imlfn");
          n.init = function () {
            this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0);
          }, n.forward = function (t) {
            var e,
                n,
                f,
                p,
                m,
                d,
                g,
                v,
                y,
                x,
                w,
                b,
                _,
                E,
                M,
                T,
                N,
                S,
                A,
                O,
                C,
                P,
                R,
                I = t.x,
                k = t.y,
                z = Math.sin(t.y),
                B = Math.cos(t.y),
                L = r(I - this.long0);

            return this.sphere ? Math.abs(this.sin_p12 - 1) <= o ? (t.x = this.x0 + this.a * (i - k) * Math.sin(L), t.y = this.y0 - this.a * (i - k) * Math.cos(L), t) : Math.abs(this.sin_p12 + 1) <= o ? (t.x = this.x0 + this.a * (i + k) * Math.sin(L), t.y = this.y0 + this.a * (i + k) * Math.cos(L), t) : (S = this.sin_p12 * z + this.cos_p12 * B * Math.cos(L), T = Math.acos(S), N = T / Math.sin(T), t.x = this.x0 + this.a * N * B * Math.sin(L), t.y = this.y0 + this.a * N * (this.cos_p12 * z - this.sin_p12 * B * Math.cos(L)), t) : (e = s(this.es), n = u(this.es), f = c(this.es), p = l(this.es), Math.abs(this.sin_p12 - 1) <= o ? (m = this.a * a(e, n, f, p, i), d = this.a * a(e, n, f, p, k), t.x = this.x0 + (m - d) * Math.sin(L), t.y = this.y0 - (m - d) * Math.cos(L), t) : Math.abs(this.sin_p12 + 1) <= o ? (m = this.a * a(e, n, f, p, i), d = this.a * a(e, n, f, p, k), t.x = this.x0 + (m + d) * Math.sin(L), t.y = this.y0 + (m + d) * Math.cos(L), t) : (g = z / B, v = h(this.a, this.e, this.sin_p12), y = h(this.a, this.e, z), x = Math.atan((1 - this.es) * g + this.es * v * this.sin_p12 / (y * B)), w = Math.atan2(Math.sin(L), this.cos_p12 * Math.tan(x) - this.sin_p12 * Math.cos(L)), A = 0 === w ? Math.asin(this.cos_p12 * Math.sin(x) - this.sin_p12 * Math.cos(x)) : Math.abs(Math.abs(w) - Math.PI) <= o ? -Math.asin(this.cos_p12 * Math.sin(x) - this.sin_p12 * Math.cos(x)) : Math.asin(Math.sin(L) * Math.cos(x) / Math.sin(w)), b = this.e * this.sin_p12 / Math.sqrt(1 - this.es), _ = this.e * this.cos_p12 * Math.cos(w) / Math.sqrt(1 - this.es), E = b * _, M = _ * _, O = A * A, C = O * A, P = C * A, R = P * A, T = v * A * (1 - O * M * (1 - M) / 6 + C / 8 * E * (1 - 2 * M) + P / 120 * (M * (4 - 7 * M) - 3 * b * b * (1 - 7 * M)) - R / 48 * E), t.x = this.x0 + T * Math.sin(w), t.y = this.y0 + T * Math.cos(w), t));
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;

            var e, n, m, d, g, v, y, x, w, b, _, E, M, T, N, S, A, O, C, P, R, I, k;

            if (this.sphere) {
              if (e = Math.sqrt(t.x * t.x + t.y * t.y), e > 2 * i * this.a) return;
              return n = e / this.a, m = Math.sin(n), d = Math.cos(n), g = this.long0, Math.abs(e) <= o ? v = this.lat0 : (v = f(d * this.sin_p12 + t.y * m * this.cos_p12 / e), y = Math.abs(this.lat0) - i, g = r(Math.abs(y) <= o ? this.lat0 >= 0 ? this.long0 + Math.atan2(t.x, -t.y) : this.long0 - Math.atan2(-t.x, t.y) : this.long0 + Math.atan2(t.x * m, e * this.cos_p12 * d - t.y * this.sin_p12 * m))), t.x = g, t.y = v, t;
            }

            return x = s(this.es), w = u(this.es), b = c(this.es), _ = l(this.es), Math.abs(this.sin_p12 - 1) <= o ? (E = this.a * a(x, w, b, _, i), e = Math.sqrt(t.x * t.x + t.y * t.y), M = E - e, v = p(M / this.a, x, w, b, _), g = r(this.long0 + Math.atan2(t.x, -1 * t.y)), t.x = g, t.y = v, t) : Math.abs(this.sin_p12 + 1) <= o ? (E = this.a * a(x, w, b, _, i), e = Math.sqrt(t.x * t.x + t.y * t.y), M = e - E, v = p(M / this.a, x, w, b, _), g = r(this.long0 + Math.atan2(t.x, t.y)), t.x = g, t.y = v, t) : (e = Math.sqrt(t.x * t.x + t.y * t.y), S = Math.atan2(t.x, t.y), T = h(this.a, this.e, this.sin_p12), A = Math.cos(S), O = this.e * this.cos_p12 * A, C = -O * O / (1 - this.es), P = 3 * this.es * (1 - C) * this.sin_p12 * this.cos_p12 * A / (1 - this.es), R = e / T, I = R - C * (1 + C) * Math.pow(R, 3) / 6 - P * (1 + 3 * C) * Math.pow(R, 4) / 24, k = 1 - C * I * I / 2 - R * I * I * I / 6, N = Math.asin(this.sin_p12 * Math.cos(I) + this.cos_p12 * Math.sin(I) * A), g = r(this.long0 + Math.asin(Math.sin(S) * Math.sin(I) / Math.cos(N))), v = Math.atan((1 - this.es * k * this.sin_p12 / Math.sin(N)) * Math.tan(N) / (1 - this.es)), t.x = g, t.y = v, t);
          }, n.names = ["Azimuthal_Equidistant", "aeqd"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6,
          "../common/e0fn": 7,
          "../common/e1fn": 8,
          "../common/e2fn": 9,
          "../common/e3fn": 10,
          "../common/gN": 11,
          "../common/imlfn": 12,
          "../common/mlfn": 14
        }],
        42: [function (t, e, n) {
          var r = t("../common/mlfn"),
              i = t("../common/e0fn"),
              o = t("../common/e1fn"),
              a = t("../common/e2fn"),
              s = t("../common/e3fn"),
              u = t("../common/gN"),
              c = t("../common/adjust_lon"),
              l = t("../common/adjust_lat"),
              h = t("../common/imlfn"),
              f = Math.PI / 2,
              p = 1e-10;
          n.init = function () {
            this.sphere || (this.e0 = i(this.es), this.e1 = o(this.es), this.e2 = a(this.es), this.e3 = s(this.es), this.ml0 = this.a * r(this.e0, this.e1, this.e2, this.e3, this.lat0));
          }, n.forward = function (t) {
            var e,
                n,
                i = t.x,
                o = t.y;
            if (i = c(i - this.long0), this.sphere) e = this.a * Math.asin(Math.cos(o) * Math.sin(i)), n = this.a * (Math.atan2(Math.tan(o), Math.cos(i)) - this.lat0);else {
              var a = Math.sin(o),
                  s = Math.cos(o),
                  l = u(this.a, this.e, a),
                  h = Math.tan(o) * Math.tan(o),
                  f = i * Math.cos(o),
                  p = f * f,
                  m = this.es * s * s / (1 - this.es),
                  d = this.a * r(this.e0, this.e1, this.e2, this.e3, o);
              e = l * f * (1 - p * h * (1 / 6 - (8 - h + 8 * m) * p / 120)), n = d - this.ml0 + l * a / s * p * (.5 + (5 - h + 6 * m) * p / 24);
            }
            return t.x = e + this.x0, t.y = n + this.y0, t;
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;
            var e,
                n,
                r = t.x / this.a,
                i = t.y / this.a;

            if (this.sphere) {
              var o = i + this.lat0;
              e = Math.asin(Math.sin(o) * Math.cos(r)), n = Math.atan2(Math.tan(r), Math.cos(o));
            } else {
              var a = this.ml0 / this.a + i,
                  s = h(a, this.e0, this.e1, this.e2, this.e3);
              if (Math.abs(Math.abs(s) - f) <= p) return t.x = this.long0, t.y = f, 0 > i && (t.y *= -1), t;
              var m = u(this.a, this.e, Math.sin(s)),
                  d = m * m * m / this.a / this.a * (1 - this.es),
                  g = Math.pow(Math.tan(s), 2),
                  v = r * this.a / m,
                  y = v * v;
              e = s - m * Math.tan(s) / d * v * v * (.5 - (1 + 3 * g) * v * v / 24), n = v * (1 - y * (g / 3 + (1 + 3 * g) * g * y / 15)) / Math.cos(s);
            }

            return t.x = c(n + this.long0), t.y = l(e), t;
          }, n.names = ["Cassini", "Cassini_Soldner", "cass"];
        }, {
          "../common/adjust_lat": 4,
          "../common/adjust_lon": 5,
          "../common/e0fn": 7,
          "../common/e1fn": 8,
          "../common/e2fn": 9,
          "../common/e3fn": 10,
          "../common/gN": 11,
          "../common/imlfn": 12,
          "../common/mlfn": 14
        }],
        43: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = t("../common/qsfnz"),
              o = t("../common/msfnz"),
              a = t("../common/iqsfnz");
          n.init = function () {
            this.sphere || (this.k0 = o(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
          }, n.forward = function (t) {
            var e,
                n,
                o = t.x,
                a = t.y,
                s = r(o - this.long0);
            if (this.sphere) e = this.x0 + this.a * s * Math.cos(this.lat_ts), n = this.y0 + this.a * Math.sin(a) / Math.cos(this.lat_ts);else {
              var u = i(this.e, Math.sin(a));
              e = this.x0 + this.a * this.k0 * s, n = this.y0 + this.a * u * .5 / this.k0;
            }
            return t.x = e, t.y = n, t;
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;
            var e, n;
            return this.sphere ? (e = r(this.long0 + t.x / this.a / Math.cos(this.lat_ts)), n = Math.asin(t.y / this.a * Math.cos(this.lat_ts))) : (n = a(this.e, 2 * t.y * this.k0 / this.a), e = r(this.long0 + t.x / (this.a * this.k0))), t.x = e, t.y = n, t;
          }, n.names = ["cea"];
        }, {
          "../common/adjust_lon": 5,
          "../common/iqsfnz": 13,
          "../common/msfnz": 15,
          "../common/qsfnz": 20
        }],
        44: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = t("../common/adjust_lat");
          n.init = function () {
            this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
          }, n.forward = function (t) {
            var e = t.x,
                n = t.y,
                o = r(e - this.long0),
                a = i(n - this.lat0);
            return t.x = this.x0 + this.a * o * this.rc, t.y = this.y0 + this.a * a, t;
          }, n.inverse = function (t) {
            var e = t.x,
                n = t.y;
            return t.x = r(this.long0 + (e - this.x0) / (this.a * this.rc)), t.y = i(this.lat0 + (n - this.y0) / this.a), t;
          }, n.names = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
        }, {
          "../common/adjust_lat": 4,
          "../common/adjust_lon": 5
        }],
        45: [function (t, e, n) {
          var r = t("../common/e0fn"),
              i = t("../common/e1fn"),
              o = t("../common/e2fn"),
              a = t("../common/e3fn"),
              s = t("../common/msfnz"),
              u = t("../common/mlfn"),
              c = t("../common/adjust_lon"),
              l = t("../common/adjust_lat"),
              h = t("../common/imlfn"),
              f = 1e-10;
          n.init = function () {
            Math.abs(this.lat1 + this.lat2) < f || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = r(this.es), this.e1 = i(this.es), this.e2 = o(this.es), this.e3 = a(this.es), this.sinphi = Math.sin(this.lat1), this.cosphi = Math.cos(this.lat1), this.ms1 = s(this.e, this.sinphi, this.cosphi), this.ml1 = u(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < f ? this.ns = this.sinphi : (this.sinphi = Math.sin(this.lat2), this.cosphi = Math.cos(this.lat2), this.ms2 = s(this.e, this.sinphi, this.cosphi), this.ml2 = u(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = u(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
          }, n.forward = function (t) {
            var e,
                n = t.x,
                r = t.y;
            if (this.sphere) e = this.a * (this.g - r);else {
              var i = u(this.e0, this.e1, this.e2, this.e3, r);
              e = this.a * (this.g - i);
            }
            var o = this.ns * c(n - this.long0),
                a = this.x0 + e * Math.sin(o),
                s = this.y0 + this.rh - e * Math.cos(o);
            return t.x = a, t.y = s, t;
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y = this.rh - t.y + this.y0;
            var e, n, r, i;
            this.ns >= 0 ? (n = Math.sqrt(t.x * t.x + t.y * t.y), e = 1) : (n = -Math.sqrt(t.x * t.x + t.y * t.y), e = -1);
            var o = 0;
            if (0 !== n && (o = Math.atan2(e * t.x, e * t.y)), this.sphere) return i = c(this.long0 + o / this.ns), r = l(this.g - n / this.a), t.x = i, t.y = r, t;
            var a = this.g - n / this.a;
            return r = h(a, this.e0, this.e1, this.e2, this.e3), i = c(this.long0 + o / this.ns), t.x = i, t.y = r, t;
          }, n.names = ["Equidistant_Conic", "eqdc"];
        }, {
          "../common/adjust_lat": 4,
          "../common/adjust_lon": 5,
          "../common/e0fn": 7,
          "../common/e1fn": 8,
          "../common/e2fn": 9,
          "../common/e3fn": 10,
          "../common/imlfn": 12,
          "../common/mlfn": 14,
          "../common/msfnz": 15
        }],
        46: [function (t, e, n) {
          var r = Math.PI / 4,
              i = t("../common/srat"),
              o = Math.PI / 2,
              a = 20;
          n.init = function () {
            var t = Math.sin(this.lat0),
                e = Math.cos(this.lat0);
            e *= e, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * t * t), this.C = Math.sqrt(1 + this.es * e * e / (1 - this.es)), this.phic0 = Math.asin(t / this.C), this.ratexp = .5 * this.C * this.e, this.K = Math.tan(.5 * this.phic0 + r) / (Math.pow(Math.tan(.5 * this.lat0 + r), this.C) * i(this.e * t, this.ratexp));
          }, n.forward = function (t) {
            var e = t.x,
                n = t.y;
            return t.y = 2 * Math.atan(this.K * Math.pow(Math.tan(.5 * n + r), this.C) * i(this.e * Math.sin(n), this.ratexp)) - o, t.x = this.C * e, t;
          }, n.inverse = function (t) {
            for (var e = 1e-14, n = t.x / this.C, s = t.y, u = Math.pow(Math.tan(.5 * s + r) / this.K, 1 / this.C), c = a; c > 0 && (s = 2 * Math.atan(u * i(this.e * Math.sin(t.y), -.5 * this.e)) - o, !(Math.abs(s - t.y) < e)); --c) {
              t.y = s;
            }

            return c ? (t.x = n, t.y = s, t) : null;
          }, n.names = ["gauss"];
        }, {
          "../common/srat": 22
        }],
        47: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = 1e-10,
              o = t("../common/asinz");
          n.init = function () {
            this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
          }, n.forward = function (t) {
            var e,
                n,
                o,
                a,
                s,
                u,
                c,
                l,
                h = t.x,
                f = t.y;
            return o = r(h - this.long0), e = Math.sin(f), n = Math.cos(f), a = Math.cos(o), u = this.sin_p14 * e + this.cos_p14 * n * a, s = 1, u > 0 || Math.abs(u) <= i ? (c = this.x0 + this.a * s * n * Math.sin(o) / u, l = this.y0 + this.a * s * (this.cos_p14 * e - this.sin_p14 * n * a) / u) : (c = this.x0 + this.infinity_dist * n * Math.sin(o), l = this.y0 + this.infinity_dist * (this.cos_p14 * e - this.sin_p14 * n * a)), t.x = c, t.y = l, t;
          }, n.inverse = function (t) {
            var e, n, i, a, s, u;
            return t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, (e = Math.sqrt(t.x * t.x + t.y * t.y)) ? (a = Math.atan2(e, this.rc), n = Math.sin(a), i = Math.cos(a), u = o(i * this.sin_p14 + t.y * n * this.cos_p14 / e), s = Math.atan2(t.x * n, e * this.cos_p14 * i - t.y * this.sin_p14 * n), s = r(this.long0 + s)) : (u = this.phic0, s = 0), t.x = s, t.y = u, t;
          }, n.names = ["gnom"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6
        }],
        48: [function (t, e, n) {
          var r = t("../common/adjust_lon");
          n.init = function () {
            this.a = 6377397.155, this.es = .006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = .863937979737193), this.long0 || (this.long0 = .4334234309119251), this.k0 || (this.k0 = .9999), this.s45 = .785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
          }, n.forward = function (t) {
            var e,
                n,
                i,
                o,
                a,
                s,
                u,
                c = t.x,
                l = t.y,
                h = r(c - this.long0);
            return e = Math.pow((1 + this.e * Math.sin(l)) / (1 - this.e * Math.sin(l)), this.alfa * this.e / 2), n = 2 * (Math.atan(this.k * Math.pow(Math.tan(l / 2 + this.s45), this.alfa) / e) - this.s45), i = -h * this.alfa, o = Math.asin(Math.cos(this.ad) * Math.sin(n) + Math.sin(this.ad) * Math.cos(n) * Math.cos(i)), a = Math.asin(Math.cos(n) * Math.sin(i) / Math.cos(o)), s = this.n * a, u = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(o / 2 + this.s45), this.n), t.y = u * Math.cos(s) / 1, t.x = u * Math.sin(s) / 1, this.czech || (t.y *= -1, t.x *= -1), t;
          }, n.inverse = function (t) {
            var e,
                n,
                r,
                i,
                o,
                a,
                s,
                u,
                c = t.x;
            t.x = t.y, t.y = c, this.czech || (t.y *= -1, t.x *= -1), a = Math.sqrt(t.x * t.x + t.y * t.y), o = Math.atan2(t.y, t.x), i = o / Math.sin(this.s0), r = 2 * (Math.atan(Math.pow(this.ro0 / a, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), e = Math.asin(Math.cos(this.ad) * Math.sin(r) - Math.sin(this.ad) * Math.cos(r) * Math.cos(i)), n = Math.asin(Math.cos(r) * Math.sin(i) / Math.cos(e)), t.x = this.long0 - n / this.alfa, s = e, u = 0;
            var l = 0;

            do {
              t.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(e / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(s)) / (1 - this.e * Math.sin(s)), this.e / 2)) - this.s45), Math.abs(s - t.y) < 1e-10 && (u = 1), s = t.y, l += 1;
            } while (0 === u && 15 > l);

            return l >= 15 ? null : t;
          }, n.names = ["Krovak", "krovak"];
        }, {
          "../common/adjust_lon": 5
        }],
        49: [function (t, e, n) {
          var r = Math.PI / 2,
              i = Math.PI / 4,
              o = 1e-10,
              a = t("../common/qsfnz"),
              s = t("../common/adjust_lon");
          n.S_POLE = 1, n.N_POLE = 2, n.EQUIT = 3, n.OBLIQ = 4, n.init = function () {
            var t = Math.abs(this.lat0);

            if (Math.abs(t - r) < o ? this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE : Math.abs(t) < o ? this.mode = this.EQUIT : this.mode = this.OBLIQ, this.es > 0) {
              var e;

              switch (this.qp = a(this.e, 1), this.mmf = .5 / (1 - this.es), this.apa = this.authset(this.es), this.mode) {
                case this.N_POLE:
                  this.dd = 1;
                  break;

                case this.S_POLE:
                  this.dd = 1;
                  break;

                case this.EQUIT:
                  this.rq = Math.sqrt(.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = .5 * this.qp;
                  break;

                case this.OBLIQ:
                  this.rq = Math.sqrt(.5 * this.qp), e = Math.sin(this.lat0), this.sinb1 = a(this.e, e) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * e * e) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;
              }
            } else this.mode === this.OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
          }, n.forward = function (t) {
            var e,
                n,
                u,
                c,
                l,
                h,
                f,
                p,
                m,
                d,
                g = t.x,
                v = t.y;

            if (g = s(g - this.long0), this.sphere) {
              if (l = Math.sin(v), d = Math.cos(v), u = Math.cos(g), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                if (n = this.mode === this.EQUIT ? 1 + d * u : 1 + this.sinph0 * l + this.cosph0 * d * u, o >= n) return null;
                n = Math.sqrt(2 / n), e = n * d * Math.sin(g), n *= this.mode === this.EQUIT ? l : this.cosph0 * l - this.sinph0 * d * u;
              } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                if (this.mode === this.N_POLE && (u = -u), Math.abs(v + this.phi0) < o) return null;
                n = i - .5 * v, n = 2 * (this.mode === this.S_POLE ? Math.cos(n) : Math.sin(n)), e = n * Math.sin(g), n *= u;
              }
            } else {
              switch (f = 0, p = 0, m = 0, u = Math.cos(g), c = Math.sin(g), l = Math.sin(v), h = a(this.e, l), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (f = h / this.qp, p = Math.sqrt(1 - f * f)), this.mode) {
                case this.OBLIQ:
                  m = 1 + this.sinb1 * f + this.cosb1 * p * u;
                  break;

                case this.EQUIT:
                  m = 1 + p * u;
                  break;

                case this.N_POLE:
                  m = r + v, h = this.qp - h;
                  break;

                case this.S_POLE:
                  m = v - r, h = this.qp + h;
              }

              if (Math.abs(m) < o) return null;

              switch (this.mode) {
                case this.OBLIQ:
                case this.EQUIT:
                  m = Math.sqrt(2 / m), n = this.mode === this.OBLIQ ? this.ymf * m * (this.cosb1 * f - this.sinb1 * p * u) : (m = Math.sqrt(2 / (1 + p * u))) * f * this.ymf, e = this.xmf * m * p * c;
                  break;

                case this.N_POLE:
                case this.S_POLE:
                  h >= 0 ? (e = (m = Math.sqrt(h)) * c, n = u * (this.mode === this.S_POLE ? m : -m)) : e = n = 0;
              }
            }

            return t.x = this.a * e + this.x0, t.y = this.a * n + this.y0, t;
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;
            var e,
                n,
                i,
                a,
                u,
                c,
                l,
                h = t.x / this.a,
                f = t.y / this.a;

            if (this.sphere) {
              var p,
                  m = 0,
                  d = 0;
              if (p = Math.sqrt(h * h + f * f), n = .5 * p, n > 1) return null;

              switch (n = 2 * Math.asin(n), this.mode !== this.OBLIQ && this.mode !== this.EQUIT || (d = Math.sin(n), m = Math.cos(n)), this.mode) {
                case this.EQUIT:
                  n = Math.abs(p) <= o ? 0 : Math.asin(f * d / p), h *= d, f = m * p;
                  break;

                case this.OBLIQ:
                  n = Math.abs(p) <= o ? this.phi0 : Math.asin(m * this.sinph0 + f * d * this.cosph0 / p), h *= d * this.cosph0, f = (m - Math.sin(n) * this.sinph0) * p;
                  break;

                case this.N_POLE:
                  f = -f, n = r - n;
                  break;

                case this.S_POLE:
                  n -= r;
              }

              e = 0 !== f || this.mode !== this.EQUIT && this.mode !== this.OBLIQ ? Math.atan2(h, f) : 0;
            } else {
              if (l = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
                if (h /= this.dd, f *= this.dd, c = Math.sqrt(h * h + f * f), o > c) return t.x = 0, t.y = this.phi0, t;
                a = 2 * Math.asin(.5 * c / this.rq), i = Math.cos(a), h *= a = Math.sin(a), this.mode === this.OBLIQ ? (l = i * this.sinb1 + f * a * this.cosb1 / c, u = this.qp * l, f = c * this.cosb1 * i - f * this.sinb1 * a) : (l = f * a / c, u = this.qp * l, f = c * i);
              } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
                if (this.mode === this.N_POLE && (f = -f), u = h * h + f * f, !u) return t.x = 0, t.y = this.phi0, t;
                l = 1 - u / this.qp, this.mode === this.S_POLE && (l = -l);
              }

              e = Math.atan2(h, f), n = this.authlat(Math.asin(l), this.apa);
            }

            return t.x = s(this.long0 + e), t.y = n, t;
          }, n.P00 = .3333333333333333, n.P01 = .17222222222222222, n.P02 = .10257936507936508, n.P10 = .06388888888888888, n.P11 = .0664021164021164, n.P20 = .016415012942191543, n.authset = function (t) {
            var e,
                n = [];
            return n[0] = t * this.P00, e = t * t, n[0] += e * this.P01, n[1] = e * this.P10, e *= t, n[0] += e * this.P02, n[1] += e * this.P11, n[2] = e * this.P20, n;
          }, n.authlat = function (t, e) {
            var n = t + t;
            return t + e[0] * Math.sin(n) + e[1] * Math.sin(n + n) + e[2] * Math.sin(n + n + n);
          }, n.names = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
        }, {
          "../common/adjust_lon": 5,
          "../common/qsfnz": 20
        }],
        50: [function (t, e, n) {
          var r = 1e-10,
              i = t("../common/msfnz"),
              o = t("../common/tsfnz"),
              a = Math.PI / 2,
              s = t("../common/sign"),
              u = t("../common/adjust_lon"),
              c = t("../common/phi2z");
          n.init = function () {
            if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < r)) {
              var t = this.b / this.a;
              this.e = Math.sqrt(1 - t * t);
              var e = Math.sin(this.lat1),
                  n = Math.cos(this.lat1),
                  a = i(this.e, e, n),
                  s = o(this.e, this.lat1, e),
                  u = Math.sin(this.lat2),
                  c = Math.cos(this.lat2),
                  l = i(this.e, u, c),
                  h = o(this.e, this.lat2, u),
                  f = o(this.e, this.lat0, Math.sin(this.lat0));
              Math.abs(this.lat1 - this.lat2) > r ? this.ns = Math.log(a / l) / Math.log(s / h) : this.ns = e, isNaN(this.ns) && (this.ns = e), this.f0 = a / (this.ns * Math.pow(s, this.ns)), this.rh = this.a * this.f0 * Math.pow(f, this.ns), this.title || (this.title = "Lambert Conformal Conic");
            }
          }, n.forward = function (t) {
            var e = t.x,
                n = t.y;
            Math.abs(2 * Math.abs(n) - Math.PI) <= r && (n = s(n) * (a - 2 * r));
            var i,
                c,
                l = Math.abs(Math.abs(n) - a);
            if (l > r) i = o(this.e, n, Math.sin(n)), c = this.a * this.f0 * Math.pow(i, this.ns);else {
              if (l = n * this.ns, 0 >= l) return null;
              c = 0;
            }
            var h = this.ns * u(e - this.long0);
            return t.x = this.k0 * (c * Math.sin(h)) + this.x0, t.y = this.k0 * (this.rh - c * Math.cos(h)) + this.y0, t;
          }, n.inverse = function (t) {
            var e,
                n,
                r,
                i,
                o,
                s = (t.x - this.x0) / this.k0,
                l = this.rh - (t.y - this.y0) / this.k0;
            this.ns > 0 ? (e = Math.sqrt(s * s + l * l), n = 1) : (e = -Math.sqrt(s * s + l * l), n = -1);
            var h = 0;

            if (0 !== e && (h = Math.atan2(n * s, n * l)), 0 !== e || this.ns > 0) {
              if (n = 1 / this.ns, r = Math.pow(e / (this.a * this.f0), n), i = c(this.e, r), -9999 === i) return null;
            } else i = -a;

            return o = u(h / this.ns + this.long0), t.x = o, t.y = i, t;
          }, n.names = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];
        }, {
          "../common/adjust_lon": 5,
          "../common/msfnz": 15,
          "../common/phi2z": 16,
          "../common/sign": 21,
          "../common/tsfnz": 24
        }],
        51: [function (t, e, n) {
          function r(t) {
            return t;
          }

          n.init = function () {}, n.forward = r, n.inverse = r, n.names = ["longlat", "identity"];
        }, {}],
        52: [function (t, e, n) {
          var r = t("../common/msfnz"),
              i = Math.PI / 2,
              o = 1e-10,
              a = 57.29577951308232,
              s = t("../common/adjust_lon"),
              u = Math.PI / 4,
              c = t("../common/tsfnz"),
              l = t("../common/phi2z");
          n.init = function () {
            var t = this.b / this.a;
            this.es = 1 - t * t, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.sphere ? this.k0 = Math.cos(this.lat_ts) : this.k0 = r(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k ? this.k0 = this.k : this.k0 = 1);
          }, n.forward = function (t) {
            var e = t.x,
                n = t.y;
            if (n * a > 90 && -90 > n * a && e * a > 180 && -180 > e * a) return null;
            var r, l;
            if (Math.abs(Math.abs(n) - i) <= o) return null;
            if (this.sphere) r = this.x0 + this.a * this.k0 * s(e - this.long0), l = this.y0 + this.a * this.k0 * Math.log(Math.tan(u + .5 * n));else {
              var h = Math.sin(n),
                  f = c(this.e, n, h);
              r = this.x0 + this.a * this.k0 * s(e - this.long0), l = this.y0 - this.a * this.k0 * Math.log(f);
            }
            return t.x = r, t.y = l, t;
          }, n.inverse = function (t) {
            var e,
                n,
                r = t.x - this.x0,
                o = t.y - this.y0;
            if (this.sphere) n = i - 2 * Math.atan(Math.exp(-o / (this.a * this.k0)));else {
              var a = Math.exp(-o / (this.a * this.k0));
              if (n = l(this.e, a), -9999 === n) return null;
            }
            return e = s(this.long0 + r / (this.a * this.k0)), t.x = e, t.y = n, t;
          }, n.names = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
        }, {
          "../common/adjust_lon": 5,
          "../common/msfnz": 15,
          "../common/phi2z": 16,
          "../common/tsfnz": 24
        }],
        53: [function (t, e, n) {
          var r = t("../common/adjust_lon");
          n.init = function () {}, n.forward = function (t) {
            var e = t.x,
                n = t.y,
                i = r(e - this.long0),
                o = this.x0 + this.a * i,
                a = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + n / 2.5)) * 1.25;
            return t.x = o, t.y = a, t;
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;
            var e = r(this.long0 + t.x / this.a),
                n = 2.5 * (Math.atan(Math.exp(.8 * t.y / this.a)) - Math.PI / 4);
            return t.x = e, t.y = n, t;
          }, n.names = ["Miller_Cylindrical", "mill"];
        }, {
          "../common/adjust_lon": 5
        }],
        54: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = 1e-10;
          n.init = function () {}, n.forward = function (t) {
            for (var e = t.x, n = t.y, o = r(e - this.long0), a = n, s = Math.PI * Math.sin(n), u = 0; !0; u++) {
              var c = -(a + Math.sin(a) - s) / (1 + Math.cos(a));
              if (a += c, Math.abs(c) < i) break;
            }

            a /= 2, Math.PI / 2 - Math.abs(n) < i && (o = 0);
            var l = .900316316158 * this.a * o * Math.cos(a) + this.x0,
                h = 1.4142135623731 * this.a * Math.sin(a) + this.y0;
            return t.x = l, t.y = h, t;
          }, n.inverse = function (t) {
            var e, n;
            t.x -= this.x0, t.y -= this.y0, n = t.y / (1.4142135623731 * this.a), Math.abs(n) > .999999999999 && (n = .999999999999), e = Math.asin(n);
            var i = r(this.long0 + t.x / (.900316316158 * this.a * Math.cos(e)));
            i < -Math.PI && (i = -Math.PI), i > Math.PI && (i = Math.PI), n = (2 * e + Math.sin(2 * e)) / Math.PI, Math.abs(n) > 1 && (n = 1);
            var o = Math.asin(n);
            return t.x = i, t.y = o, t;
          }, n.names = ["Mollweide", "moll"];
        }, {
          "../common/adjust_lon": 5
        }],
        55: [function (t, e, n) {
          var r = 484813681109536e-20;
          n.iterations = 1, n.init = function () {
            this.A = [], this.A[1] = .6399175073, this.A[2] = -.1358797613, this.A[3] = .063294409, this.A[4] = -.02526853, this.A[5] = .0117879, this.A[6] = -.0055161, this.A[7] = .0026906, this.A[8] = -.001333, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = .7557853228, this.B_im[1] = 0, this.B_re[2] = .249204646, this.B_im[2] = .003371507, this.B_re[3] = -.001541739, this.B_im[3] = .04105856, this.B_re[4] = -.10162907, this.B_im[4] = .01727609, this.B_re[5] = -.26623489, this.B_im[5] = -.36249218, this.B_re[6] = -.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -.577245789, this.C_im[2] = -.007809598, this.C_re[3] = .508307513, this.C_im[3] = -.112208952, this.C_re[4] = -.15094762, this.C_im[4] = .18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = .5185406398, this.D[3] = -.03333098, this.D[4] = -.1052906, this.D[5] = -.0368594, this.D[6] = .007317, this.D[7] = .0122, this.D[8] = .00394, this.D[9] = -.0013;
          }, n.forward = function (t) {
            var e,
                n = t.x,
                i = t.y,
                o = i - this.lat0,
                a = n - this.long0,
                s = o / r * 1e-5,
                u = a,
                c = 1,
                l = 0;

            for (e = 1; 10 >= e; e++) {
              c *= s, l += this.A[e] * c;
            }

            var h,
                f,
                p = l,
                m = u,
                d = 1,
                g = 0,
                v = 0,
                y = 0;

            for (e = 1; 6 >= e; e++) {
              h = d * p - g * m, f = g * p + d * m, d = h, g = f, v = v + this.B_re[e] * d - this.B_im[e] * g, y = y + this.B_im[e] * d + this.B_re[e] * g;
            }

            return t.x = y * this.a + this.x0, t.y = v * this.a + this.y0, t;
          }, n.inverse = function (t) {
            var e,
                n,
                i,
                o = t.x,
                a = t.y,
                s = o - this.x0,
                u = a - this.y0,
                c = u / this.a,
                l = s / this.a,
                h = 1,
                f = 0,
                p = 0,
                m = 0;

            for (e = 1; 6 >= e; e++) {
              n = h * c - f * l, i = f * c + h * l, h = n, f = i, p = p + this.C_re[e] * h - this.C_im[e] * f, m = m + this.C_im[e] * h + this.C_re[e] * f;
            }

            for (var d = 0; d < this.iterations; d++) {
              var g,
                  v,
                  y = p,
                  x = m,
                  w = c,
                  b = l;

              for (e = 2; 6 >= e; e++) {
                g = y * p - x * m, v = x * p + y * m, y = g, x = v, w += (e - 1) * (this.B_re[e] * y - this.B_im[e] * x), b += (e - 1) * (this.B_im[e] * y + this.B_re[e] * x);
              }

              y = 1, x = 0;
              var _ = this.B_re[1],
                  E = this.B_im[1];

              for (e = 2; 6 >= e; e++) {
                g = y * p - x * m, v = x * p + y * m, y = g, x = v, _ += e * (this.B_re[e] * y - this.B_im[e] * x), E += e * (this.B_im[e] * y + this.B_re[e] * x);
              }

              var M = _ * _ + E * E;
              p = (w * _ + b * E) / M, m = (b * _ - w * E) / M;
            }

            var T = p,
                N = m,
                S = 1,
                A = 0;

            for (e = 1; 9 >= e; e++) {
              S *= T, A += this.D[e] * S;
            }

            var O = this.lat0 + A * r * 1e5,
                C = this.long0 + N;
            return t.x = C, t.y = O, t;
          }, n.names = ["New_Zealand_Map_Grid", "nzmg"];
        }, {}],
        56: [function (t, e, n) {
          var r = t("../common/tsfnz"),
              i = t("../common/adjust_lon"),
              o = t("../common/phi2z"),
              a = Math.PI / 2,
              s = Math.PI / 4,
              u = 1e-10;
          n.init = function () {
            this.no_off = this.no_off || !1, this.no_rot = this.no_rot || !1, isNaN(this.k0) && (this.k0 = 1);
            var t = Math.sin(this.lat0),
                e = Math.cos(this.lat0),
                n = this.e * t;
            this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(e, 4)), this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - n * n);
            var o = r(this.e, this.lat0, t),
                a = this.bl / e * Math.sqrt((1 - this.es) / (1 - n * n));
            1 > a * a && (a = 1);
            var s, u;

            if (isNaN(this.longc)) {
              var c = r(this.e, this.lat1, Math.sin(this.lat1)),
                  l = r(this.e, this.lat2, Math.sin(this.lat2));
              this.lat0 >= 0 ? this.el = (a + Math.sqrt(a * a - 1)) * Math.pow(o, this.bl) : this.el = (a - Math.sqrt(a * a - 1)) * Math.pow(o, this.bl);
              var h = Math.pow(c, this.bl),
                  f = Math.pow(l, this.bl);
              s = this.el / h, u = .5 * (s - 1 / s);
              var p = (this.el * this.el - f * h) / (this.el * this.el + f * h),
                  m = (f - h) / (f + h),
                  d = i(this.long1 - this.long2);
              this.long0 = .5 * (this.long1 + this.long2) - Math.atan(p * Math.tan(.5 * this.bl * d) / m) / this.bl, this.long0 = i(this.long0);
              var g = i(this.long1 - this.long0);
              this.gamma0 = Math.atan(Math.sin(this.bl * g) / u), this.alpha = Math.asin(a * Math.sin(this.gamma0));
            } else s = this.lat0 >= 0 ? a + Math.sqrt(a * a - 1) : a - Math.sqrt(a * a - 1), this.el = s * Math.pow(o, this.bl), u = .5 * (s - 1 / s), this.gamma0 = Math.asin(Math.sin(this.alpha) / a), this.long0 = this.longc - Math.asin(u * Math.tan(this.gamma0)) / this.bl;

            this.no_off ? this.uc = 0 : this.lat0 >= 0 ? this.uc = this.al / this.bl * Math.atan2(Math.sqrt(a * a - 1), Math.cos(this.alpha)) : this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(a * a - 1), Math.cos(this.alpha));
          }, n.forward = function (t) {
            var e,
                n,
                o,
                c = t.x,
                l = t.y,
                h = i(c - this.long0);
            if (Math.abs(Math.abs(l) - a) <= u) o = l > 0 ? -1 : 1, n = this.al / this.bl * Math.log(Math.tan(s + o * this.gamma0 * .5)), e = -1 * o * a * this.al / this.bl;else {
              var f = r(this.e, l, Math.sin(l)),
                  p = this.el / Math.pow(f, this.bl),
                  m = .5 * (p - 1 / p),
                  d = .5 * (p + 1 / p),
                  g = Math.sin(this.bl * h),
                  v = (m * Math.sin(this.gamma0) - g * Math.cos(this.gamma0)) / d;
              n = Math.abs(Math.abs(v) - 1) <= u ? Number.POSITIVE_INFINITY : .5 * this.al * Math.log((1 - v) / (1 + v)) / this.bl, e = Math.abs(Math.cos(this.bl * h)) <= u ? this.al * this.bl * h : this.al * Math.atan2(m * Math.cos(this.gamma0) + g * Math.sin(this.gamma0), Math.cos(this.bl * h)) / this.bl;
            }
            return this.no_rot ? (t.x = this.x0 + e, t.y = this.y0 + n) : (e -= this.uc, t.x = this.x0 + n * Math.cos(this.alpha) + e * Math.sin(this.alpha), t.y = this.y0 + e * Math.cos(this.alpha) - n * Math.sin(this.alpha)), t;
          }, n.inverse = function (t) {
            var e, n;
            this.no_rot ? (n = t.y - this.y0, e = t.x - this.x0) : (n = (t.x - this.x0) * Math.cos(this.alpha) - (t.y - this.y0) * Math.sin(this.alpha), e = (t.y - this.y0) * Math.cos(this.alpha) + (t.x - this.x0) * Math.sin(this.alpha), e += this.uc);
            var r = Math.exp(-1 * this.bl * n / this.al),
                s = .5 * (r - 1 / r),
                c = .5 * (r + 1 / r),
                l = Math.sin(this.bl * e / this.al),
                h = (l * Math.cos(this.gamma0) + s * Math.sin(this.gamma0)) / c,
                f = Math.pow(this.el / Math.sqrt((1 + h) / (1 - h)), 1 / this.bl);
            return Math.abs(h - 1) < u ? (t.x = this.long0, t.y = a) : Math.abs(h + 1) < u ? (t.x = this.long0, t.y = -1 * a) : (t.y = o(this.e, f), t.x = i(this.long0 - Math.atan2(s * Math.cos(this.gamma0) - l * Math.sin(this.gamma0), Math.cos(this.bl * e / this.al)) / this.bl)), t;
          }, n.names = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];
        }, {
          "../common/adjust_lon": 5,
          "../common/phi2z": 16,
          "../common/tsfnz": 24
        }],
        57: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = 1e-10,
              o = t("../common/asinz"),
              a = Math.PI / 2;
          n.init = function () {
            this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0);
          }, n.forward = function (t) {
            var e,
                n,
                o,
                a,
                s,
                u,
                c,
                l,
                h = t.x,
                f = t.y;
            return o = r(h - this.long0), e = Math.sin(f), n = Math.cos(f), a = Math.cos(o), u = this.sin_p14 * e + this.cos_p14 * n * a, s = 1, (u > 0 || Math.abs(u) <= i) && (c = this.a * s * n * Math.sin(o), l = this.y0 + this.a * s * (this.cos_p14 * e - this.sin_p14 * n * a)), t.x = c, t.y = l, t;
          }, n.inverse = function (t) {
            var e, n, s, u, c, l, h;
            return t.x -= this.x0, t.y -= this.y0, e = Math.sqrt(t.x * t.x + t.y * t.y), n = o(e / this.a), s = Math.sin(n), u = Math.cos(n), l = this.long0, Math.abs(e) <= i ? (h = this.lat0, t.x = l, t.y = h, t) : (h = o(u * this.sin_p14 + t.y * s * this.cos_p14 / e), c = Math.abs(this.lat0) - a, Math.abs(c) <= i ? (l = r(this.lat0 >= 0 ? this.long0 + Math.atan2(t.x, -t.y) : this.long0 - Math.atan2(-t.x, t.y)), t.x = l, t.y = h, t) : (l = r(this.long0 + Math.atan2(t.x * s, e * this.cos_p14 * u - t.y * this.sin_p14 * s)), t.x = l, t.y = h, t));
          }, n.names = ["ortho"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6
        }],
        58: [function (t, e, n) {
          var r = t("../common/e0fn"),
              i = t("../common/e1fn"),
              o = t("../common/e2fn"),
              a = t("../common/e3fn"),
              s = t("../common/adjust_lon"),
              u = t("../common/adjust_lat"),
              c = t("../common/mlfn"),
              l = 1e-10,
              h = t("../common/gN"),
              f = 20;
          n.init = function () {
            this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = r(this.es), this.e1 = i(this.es), this.e2 = o(this.es), this.e3 = a(this.es), this.ml0 = this.a * c(this.e0, this.e1, this.e2, this.e3, this.lat0);
          }, n.forward = function (t) {
            var e,
                n,
                r,
                i = t.x,
                o = t.y,
                a = s(i - this.long0);
            if (r = a * Math.sin(o), this.sphere) Math.abs(o) <= l ? (e = this.a * a, n = -1 * this.a * this.lat0) : (e = this.a * Math.sin(r) / Math.tan(o), n = this.a * (u(o - this.lat0) + (1 - Math.cos(r)) / Math.tan(o)));else if (Math.abs(o) <= l) e = this.a * a, n = -1 * this.ml0;else {
              var f = h(this.a, this.e, Math.sin(o)) / Math.tan(o);
              e = f * Math.sin(r), n = this.a * c(this.e0, this.e1, this.e2, this.e3, o) - this.ml0 + f * (1 - Math.cos(r));
            }
            return t.x = e + this.x0, t.y = n + this.y0, t;
          }, n.inverse = function (t) {
            var e, n, r, i, o, a, u, h, p;
            if (r = t.x - this.x0, i = t.y - this.y0, this.sphere) {
              if (Math.abs(i + this.a * this.lat0) <= l) e = s(r / this.a + this.long0), n = 0;else {
                a = this.lat0 + i / this.a, u = r * r / this.a / this.a + a * a, h = a;
                var m;

                for (o = f; o; --o) {
                  if (m = Math.tan(h), p = -1 * (a * (h * m + 1) - h - .5 * (h * h + u) * m) / ((h - a) / m - 1), h += p, Math.abs(p) <= l) {
                    n = h;
                    break;
                  }
                }

                e = s(this.long0 + Math.asin(r * Math.tan(h) / this.a) / Math.sin(n));
              }
            } else if (Math.abs(i + this.ml0) <= l) n = 0, e = s(this.long0 + r / this.a);else {
              a = (this.ml0 + i) / this.a, u = r * r / this.a / this.a + a * a, h = a;
              var d, g, v, y, x;

              for (o = f; o; --o) {
                if (x = this.e * Math.sin(h), d = Math.sqrt(1 - x * x) * Math.tan(h), g = this.a * c(this.e0, this.e1, this.e2, this.e3, h), v = this.e0 - 2 * this.e1 * Math.cos(2 * h) + 4 * this.e2 * Math.cos(4 * h) - 6 * this.e3 * Math.cos(6 * h), y = g / this.a, p = (a * (d * y + 1) - y - .5 * d * (y * y + u)) / (this.es * Math.sin(2 * h) * (y * y + u - 2 * a * y) / (4 * d) + (a - y) * (d * v - 2 / Math.sin(2 * h)) - v), h -= p, Math.abs(p) <= l) {
                  n = h;
                  break;
                }
              }

              d = Math.sqrt(1 - this.es * Math.pow(Math.sin(n), 2)) * Math.tan(n), e = s(this.long0 + Math.asin(r * d / this.a) / Math.sin(n));
            }
            return t.x = e, t.y = n, t;
          }, n.names = ["Polyconic", "poly"];
        }, {
          "../common/adjust_lat": 4,
          "../common/adjust_lon": 5,
          "../common/e0fn": 7,
          "../common/e1fn": 8,
          "../common/e2fn": 9,
          "../common/e3fn": 10,
          "../common/gN": 11,
          "../common/mlfn": 14
        }],
        59: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = t("../common/adjust_lat"),
              o = t("../common/pj_enfn"),
              a = 20,
              s = t("../common/pj_mlfn"),
              u = t("../common/pj_inv_mlfn"),
              c = Math.PI / 2,
              l = 1e-10,
              h = t("../common/asinz");
          n.init = function () {
            this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = o(this.es);
          }, n.forward = function (t) {
            var e,
                n,
                i = t.x,
                o = t.y;

            if (i = r(i - this.long0), this.sphere) {
              if (this.m) for (var u = this.n * Math.sin(o), c = a; c; --c) {
                var h = (this.m * o + Math.sin(o) - u) / (this.m + Math.cos(o));
                if (o -= h, Math.abs(h) < l) break;
              } else o = 1 !== this.n ? Math.asin(this.n * Math.sin(o)) : o;
              e = this.a * this.C_x * i * (this.m + Math.cos(o)), n = this.a * this.C_y * o;
            } else {
              var f = Math.sin(o),
                  p = Math.cos(o);
              n = this.a * s(o, f, p, this.en), e = this.a * i * p / Math.sqrt(1 - this.es * f * f);
            }

            return t.x = e, t.y = n, t;
          }, n.inverse = function (t) {
            var e, n, o, a;
            return t.x -= this.x0, o = t.x / this.a, t.y -= this.y0, e = t.y / this.a, this.sphere ? (e /= this.C_y, o /= this.C_x * (this.m + Math.cos(e)), this.m ? e = h((this.m * e + Math.sin(e)) / this.n) : 1 !== this.n && (e = h(Math.sin(e) / this.n)), o = r(o + this.long0), e = i(e)) : (e = u(t.y / this.a, this.es, this.en), a = Math.abs(e), c > a ? (a = Math.sin(e), n = this.long0 + t.x * Math.sqrt(1 - this.es * a * a) / (this.a * Math.cos(e)), o = r(n)) : c > a - l && (o = this.long0)), t.x = o, t.y = e, t;
          }, n.names = ["Sinusoidal", "sinu"];
        }, {
          "../common/adjust_lat": 4,
          "../common/adjust_lon": 5,
          "../common/asinz": 6,
          "../common/pj_enfn": 17,
          "../common/pj_inv_mlfn": 18,
          "../common/pj_mlfn": 19
        }],
        60: [function (t, e, n) {
          n.init = function () {
            var t = this.lat0;
            this.lambda0 = this.long0;
            var e = Math.sin(t),
                n = this.a,
                r = this.rf,
                i = 1 / r,
                o = 2 * i - Math.pow(i, 2),
                a = this.e = Math.sqrt(o);
            this.R = this.k0 * n * Math.sqrt(1 - o) / (1 - o * Math.pow(e, 2)), this.alpha = Math.sqrt(1 + o / (1 - o) * Math.pow(Math.cos(t), 4)), this.b0 = Math.asin(e / this.alpha);
            var s = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)),
                u = Math.log(Math.tan(Math.PI / 4 + t / 2)),
                c = Math.log((1 + a * e) / (1 - a * e));
            this.K = s - this.alpha * u + this.alpha * a / 2 * c;
          }, n.forward = function (t) {
            var e = Math.log(Math.tan(Math.PI / 4 - t.y / 2)),
                n = this.e / 2 * Math.log((1 + this.e * Math.sin(t.y)) / (1 - this.e * Math.sin(t.y))),
                r = -this.alpha * (e + n) + this.K,
                i = 2 * (Math.atan(Math.exp(r)) - Math.PI / 4),
                o = this.alpha * (t.x - this.lambda0),
                a = Math.atan(Math.sin(o) / (Math.sin(this.b0) * Math.tan(i) + Math.cos(this.b0) * Math.cos(o))),
                s = Math.asin(Math.cos(this.b0) * Math.sin(i) - Math.sin(this.b0) * Math.cos(i) * Math.cos(o));
            return t.y = this.R / 2 * Math.log((1 + Math.sin(s)) / (1 - Math.sin(s))) + this.y0, t.x = this.R * a + this.x0, t;
          }, n.inverse = function (t) {
            for (var e = t.x - this.x0, n = t.y - this.y0, r = e / this.R, i = 2 * (Math.atan(Math.exp(n / this.R)) - Math.PI / 4), o = Math.asin(Math.cos(this.b0) * Math.sin(i) + Math.sin(this.b0) * Math.cos(i) * Math.cos(r)), a = Math.atan(Math.sin(r) / (Math.cos(this.b0) * Math.cos(r) - Math.sin(this.b0) * Math.tan(i))), s = this.lambda0 + a / this.alpha, u = 0, c = o, l = -1e3, h = 0; Math.abs(c - l) > 1e-7;) {
              if (++h > 20) return;
              u = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + o / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(c)) / 2)), l = c, c = 2 * Math.atan(Math.exp(u)) - Math.PI / 2;
            }

            return t.x = s, t.y = c, t;
          }, n.names = ["somerc"];
        }, {}],
        61: [function (t, e, n) {
          var r = Math.PI / 2,
              i = 1e-10,
              o = t("../common/sign"),
              a = t("../common/msfnz"),
              s = t("../common/tsfnz"),
              u = t("../common/phi2z"),
              c = t("../common/adjust_lon");
          n.ssfn_ = function (t, e, n) {
            return e *= n, Math.tan(.5 * (r + t)) * Math.pow((1 - e) / (1 + e), .5 * n);
          }, n.init = function () {
            this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= i && (this.k0 = .5 * (1 + o(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= i && (this.lat0 > 0 ? this.con = 1 : this.con = -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= i && (this.k0 = .5 * this.cons * a(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / s(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = a(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - r, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
          }, n.forward = function (t) {
            var e,
                n,
                o,
                a,
                u,
                l,
                h = t.x,
                f = t.y,
                p = Math.sin(f),
                m = Math.cos(f),
                d = c(h - this.long0);
            return Math.abs(Math.abs(h - this.long0) - Math.PI) <= i && Math.abs(f + this.lat0) <= i ? (t.x = NaN, t.y = NaN, t) : this.sphere ? (e = 2 * this.k0 / (1 + this.sinlat0 * p + this.coslat0 * m * Math.cos(d)), t.x = this.a * e * m * Math.sin(d) + this.x0, t.y = this.a * e * (this.coslat0 * p - this.sinlat0 * m * Math.cos(d)) + this.y0, t) : (n = 2 * Math.atan(this.ssfn_(f, p, this.e)) - r, a = Math.cos(n), o = Math.sin(n), Math.abs(this.coslat0) <= i ? (u = s(this.e, f * this.con, this.con * p), l = 2 * this.a * this.k0 * u / this.cons, t.x = this.x0 + l * Math.sin(h - this.long0), t.y = this.y0 - this.con * l * Math.cos(h - this.long0), t) : (Math.abs(this.sinlat0) < i ? (e = 2 * this.a * this.k0 / (1 + a * Math.cos(d)), t.y = e * o) : (e = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * o + this.cosX0 * a * Math.cos(d))), t.y = e * (this.cosX0 * o - this.sinX0 * a * Math.cos(d)) + this.y0), t.x = e * a * Math.sin(d) + this.x0, t));
          }, n.inverse = function (t) {
            t.x -= this.x0, t.y -= this.y0;
            var e,
                n,
                o,
                a,
                s,
                l = Math.sqrt(t.x * t.x + t.y * t.y);

            if (this.sphere) {
              var h = 2 * Math.atan(l / (.5 * this.a * this.k0));
              return e = this.long0, n = this.lat0, i >= l ? (t.x = e, t.y = n, t) : (n = Math.asin(Math.cos(h) * this.sinlat0 + t.y * Math.sin(h) * this.coslat0 / l), e = c(Math.abs(this.coslat0) < i ? this.lat0 > 0 ? this.long0 + Math.atan2(t.x, -1 * t.y) : this.long0 + Math.atan2(t.x, t.y) : this.long0 + Math.atan2(t.x * Math.sin(h), l * this.coslat0 * Math.cos(h) - t.y * this.sinlat0 * Math.sin(h))), t.x = e, t.y = n, t);
            }

            if (Math.abs(this.coslat0) <= i) {
              if (i >= l) return n = this.lat0, e = this.long0, t.x = e, t.y = n, t;
              t.x *= this.con, t.y *= this.con, o = l * this.cons / (2 * this.a * this.k0), n = this.con * u(this.e, o), e = this.con * c(this.con * this.long0 + Math.atan2(t.x, -1 * t.y));
            } else a = 2 * Math.atan(l * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), e = this.long0, i >= l ? s = this.X0 : (s = Math.asin(Math.cos(a) * this.sinX0 + t.y * Math.sin(a) * this.cosX0 / l), e = c(this.long0 + Math.atan2(t.x * Math.sin(a), l * this.cosX0 * Math.cos(a) - t.y * this.sinX0 * Math.sin(a)))), n = -1 * u(this.e, Math.tan(.5 * (r + s)));

            return t.x = e, t.y = n, t;
          }, n.names = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
        }, {
          "../common/adjust_lon": 5,
          "../common/msfnz": 15,
          "../common/phi2z": 16,
          "../common/sign": 21,
          "../common/tsfnz": 24
        }],
        62: [function (t, e, n) {
          var r = t("./gauss"),
              i = t("../common/adjust_lon");
          n.init = function () {
            r.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
          }, n.forward = function (t) {
            var e, n, o, a;
            return t.x = i(t.x - this.long0), r.forward.apply(this, [t]), e = Math.sin(t.y), n = Math.cos(t.y), o = Math.cos(t.x), a = this.k0 * this.R2 / (1 + this.sinc0 * e + this.cosc0 * n * o), t.x = a * n * Math.sin(t.x), t.y = a * (this.cosc0 * e - this.sinc0 * n * o), t.x = this.a * t.x + this.x0, t.y = this.a * t.y + this.y0, t;
          }, n.inverse = function (t) {
            var e, n, o, a, s;

            if (t.x = (t.x - this.x0) / this.a, t.y = (t.y - this.y0) / this.a, t.x /= this.k0, t.y /= this.k0, s = Math.sqrt(t.x * t.x + t.y * t.y)) {
              var u = 2 * Math.atan2(s, this.R2);
              e = Math.sin(u), n = Math.cos(u), a = Math.asin(n * this.sinc0 + t.y * e * this.cosc0 / s), o = Math.atan2(t.x * e, s * this.cosc0 * n - t.y * this.sinc0 * e);
            } else a = this.phic0, o = 0;

            return t.x = o, t.y = a, r.inverse.apply(this, [t]), t.x = i(t.x + this.long0), t;
          }, n.names = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea", "Oblique Stereographic Alternative"];
        }, {
          "../common/adjust_lon": 5,
          "./gauss": 46
        }],
        63: [function (t, e, n) {
          var r = t("../common/e0fn"),
              i = t("../common/e1fn"),
              o = t("../common/e2fn"),
              a = t("../common/e3fn"),
              s = t("../common/mlfn"),
              u = t("../common/adjust_lon"),
              c = Math.PI / 2,
              l = 1e-10,
              h = t("../common/sign"),
              f = t("../common/asinz");
          n.init = function () {
            this.e0 = r(this.es), this.e1 = i(this.es), this.e2 = o(this.es), this.e3 = a(this.es), this.ml0 = this.a * s(this.e0, this.e1, this.e2, this.e3, this.lat0);
          }, n.forward = function (t) {
            var e,
                n,
                r,
                i = t.x,
                o = t.y,
                a = u(i - this.long0),
                c = Math.sin(o),
                l = Math.cos(o);

            if (this.sphere) {
              var h = l * Math.sin(a);
              if (Math.abs(Math.abs(h) - 1) < 1e-10) return 93;
              n = .5 * this.a * this.k0 * Math.log((1 + h) / (1 - h)), e = Math.acos(l * Math.cos(a) / Math.sqrt(1 - h * h)), 0 > o && (e = -e), r = this.a * this.k0 * (e - this.lat0);
            } else {
              var f = l * a,
                  p = Math.pow(f, 2),
                  m = this.ep2 * Math.pow(l, 2),
                  d = Math.tan(o),
                  g = Math.pow(d, 2);
              e = 1 - this.es * Math.pow(c, 2);
              var v = this.a / Math.sqrt(e),
                  y = this.a * s(this.e0, this.e1, this.e2, this.e3, o);
              n = this.k0 * v * f * (1 + p / 6 * (1 - g + m + p / 20 * (5 - 18 * g + Math.pow(g, 2) + 72 * m - 58 * this.ep2))) + this.x0, r = this.k0 * (y - this.ml0 + v * d * (p * (.5 + p / 24 * (5 - g + 9 * m + 4 * Math.pow(m, 2) + p / 30 * (61 - 58 * g + Math.pow(g, 2) + 600 * m - 330 * this.ep2))))) + this.y0;
            }

            return t.x = n, t.y = r, t;
          }, n.inverse = function (t) {
            var e,
                n,
                r,
                i,
                o,
                a,
                s = 6;

            if (this.sphere) {
              var p = Math.exp(t.x / (this.a * this.k0)),
                  m = .5 * (p - 1 / p),
                  d = this.lat0 + t.y / (this.a * this.k0),
                  g = Math.cos(d);
              e = Math.sqrt((1 - g * g) / (1 + m * m)), o = f(e), 0 > d && (o = -o), a = 0 === m && 0 === g ? this.long0 : u(Math.atan2(m, g) + this.long0);
            } else {
              var v = t.x - this.x0,
                  y = t.y - this.y0;

              for (e = (this.ml0 + y / this.k0) / this.a, n = e, i = 0; r = (e + this.e1 * Math.sin(2 * n) - this.e2 * Math.sin(4 * n) + this.e3 * Math.sin(6 * n)) / this.e0 - n, n += r, !(Math.abs(r) <= l); i++) {
                if (i >= s) return 95;
              }

              if (Math.abs(n) < c) {
                var x = Math.sin(n),
                    w = Math.cos(n),
                    b = Math.tan(n),
                    _ = this.ep2 * Math.pow(w, 2),
                    E = Math.pow(_, 2),
                    M = Math.pow(b, 2),
                    T = Math.pow(M, 2);

                e = 1 - this.es * Math.pow(x, 2);
                var N = this.a / Math.sqrt(e),
                    S = N * (1 - this.es) / e,
                    A = v / (N * this.k0),
                    O = Math.pow(A, 2);
                o = n - N * b * O / S * (.5 - O / 24 * (5 + 3 * M + 10 * _ - 4 * E - 9 * this.ep2 - O / 30 * (61 + 90 * M + 298 * _ + 45 * T - 252 * this.ep2 - 3 * E))), a = u(this.long0 + A * (1 - O / 6 * (1 + 2 * M + _ - O / 20 * (5 - 2 * _ + 28 * M - 3 * E + 8 * this.ep2 + 24 * T))) / w);
              } else o = c * h(y), a = this.long0;
            }

            return t.x = a, t.y = o, t;
          }, n.names = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6,
          "../common/e0fn": 7,
          "../common/e1fn": 8,
          "../common/e2fn": 9,
          "../common/e3fn": 10,
          "../common/mlfn": 14,
          "../common/sign": 21
        }],
        64: [function (t, e, n) {
          var r = .017453292519943295,
              i = t("./tmerc");
          n.dependsOn = "tmerc", n.init = function () {
            this.zone && (this.lat0 = 0, this.long0 = (6 * Math.abs(this.zone) - 183) * r, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = .9996, i.init.apply(this), this.forward = i.forward, this.inverse = i.inverse);
          }, n.names = ["Universal Transverse Mercator System", "utm"];
        }, {
          "./tmerc": 63
        }],
        65: [function (t, e, n) {
          var r = t("../common/adjust_lon"),
              i = Math.PI / 2,
              o = 1e-10,
              a = t("../common/asinz");
          n.init = function () {
            this.R = this.a;
          }, n.forward = function (t) {
            var e,
                n,
                s = t.x,
                u = t.y,
                c = r(s - this.long0);
            Math.abs(u) <= o && (e = this.x0 + this.R * c, n = this.y0);
            var l = a(2 * Math.abs(u / Math.PI));
            (Math.abs(c) <= o || Math.abs(Math.abs(u) - i) <= o) && (e = this.x0, n = u >= 0 ? this.y0 + Math.PI * this.R * Math.tan(.5 * l) : this.y0 + Math.PI * this.R * -Math.tan(.5 * l));
            var h = .5 * Math.abs(Math.PI / c - c / Math.PI),
                f = h * h,
                p = Math.sin(l),
                m = Math.cos(l),
                d = m / (p + m - 1),
                g = d * d,
                v = d * (2 / p - 1),
                y = v * v,
                x = Math.PI * this.R * (h * (d - y) + Math.sqrt(f * (d - y) * (d - y) - (y + f) * (g - y))) / (y + f);
            0 > c && (x = -x), e = this.x0 + x;
            var w = f + d;
            return x = Math.PI * this.R * (v * w - h * Math.sqrt((y + f) * (f + 1) - w * w)) / (y + f), n = u >= 0 ? this.y0 + x : this.y0 - x, t.x = e, t.y = n, t;
          }, n.inverse = function (t) {
            var e, n, i, a, s, u, c, l, h, f, p, m, d;
            return t.x -= this.x0, t.y -= this.y0, p = Math.PI * this.R, i = t.x / p, a = t.y / p, s = i * i + a * a, u = -Math.abs(a) * (1 + s), c = u - 2 * a * a + i * i, l = -2 * u + 1 + 2 * a * a + s * s, d = a * a / l + (2 * c * c * c / l / l / l - 9 * u * c / l / l) / 27, h = (u - c * c / 3 / l) / l, f = 2 * Math.sqrt(-h / 3), p = 3 * d / h / f, Math.abs(p) > 1 && (p = p >= 0 ? 1 : -1), m = Math.acos(p) / 3, n = t.y >= 0 ? (-f * Math.cos(m + Math.PI / 3) - c / 3 / l) * Math.PI : -(-f * Math.cos(m + Math.PI / 3) - c / 3 / l) * Math.PI, e = Math.abs(i) < o ? this.long0 : r(this.long0 + Math.PI * (s - 1 + Math.sqrt(1 + 2 * (i * i - a * a) + s * s)) / 2 / i), t.x = e, t.y = n, t;
          }, n.names = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
        }, {
          "../common/adjust_lon": 5,
          "../common/asinz": 6
        }],
        66: [function (t, e, n) {
          var r = .017453292519943295,
              i = 57.29577951308232,
              o = 1,
              a = 2,
              s = t("./datum_transform"),
              u = t("./adjust_axis"),
              c = t("./Proj"),
              l = t("./common/toPoint");

          e.exports = function t(e, n, h) {
            function f(t, e) {
              return (t.datum.datum_type === o || t.datum.datum_type === a) && "WGS84" !== e.datumCode;
            }

            var p;
            return Array.isArray(h) && (h = l(h)), e.datum && n.datum && (f(e, n) || f(n, e)) && (p = new c("WGS84"), t(e, p, h), e = p), "enu" !== e.axis && u(e, !1, h), "longlat" === e.projName ? (h.x *= r, h.y *= r) : (e.to_meter && (h.x *= e.to_meter, h.y *= e.to_meter), e.inverse(h)), e.from_greenwich && (h.x += e.from_greenwich), h = s(e.datum, n.datum, h), n.from_greenwich && (h.x -= n.from_greenwich), "longlat" === n.projName ? (h.x *= i, h.y *= i) : (n.forward(h), n.to_meter && (h.x /= n.to_meter, h.y /= n.to_meter)), "enu" !== n.axis && u(n, !0, h), h;
          };
        }, {
          "./Proj": 2,
          "./adjust_axis": 3,
          "./common/toPoint": 23,
          "./datum_transform": 31
        }],
        67: [function (t, e, n) {
          function r(t, e, n) {
            t[e] = n.map(function (t) {
              var e = {};
              return i(t, e), e;
            }).reduce(function (t, e) {
              return c(t, e);
            }, {});
          }

          function i(t, e) {
            var n;
            return Array.isArray(t) ? (n = t.shift(), "PARAMETER" === n && (n = t.shift()), void (1 === t.length ? Array.isArray(t[0]) ? (e[n] = {}, i(t[0], e[n])) : e[n] = t[0] : t.length ? "TOWGS84" === n ? e[n] = t : (e[n] = {}, ["UNIT", "PRIMEM", "VERT_DATUM"].indexOf(n) > -1 ? (e[n] = {
              name: t[0].toLowerCase(),
              convert: t[1]
            }, 3 === t.length && (e[n].auth = t[2])) : "SPHEROID" === n ? (e[n] = {
              name: t[0],
              a: t[1],
              rf: t[2]
            }, 4 === t.length && (e[n].auth = t[3])) : ["GEOGCS", "GEOCCS", "DATUM", "VERT_CS", "COMPD_CS", "LOCAL_CS", "FITTED_CS", "LOCAL_DATUM"].indexOf(n) > -1 ? (t[0] = ["name", t[0]], r(e, n, t)) : t.every(function (t) {
              return Array.isArray(t);
            }) ? r(e, n, t) : i(t, e[n])) : e[n] = !0)) : void (e[t] = !0);
          }

          function o(t, e) {
            var n = e[0],
                r = e[1];
            !(n in t) && r in t && (t[n] = t[r], 3 === e.length && (t[n] = e[2](t[n])));
          }

          function a(t) {
            return t * u;
          }

          function s(t) {
            function e(e) {
              var n = t.to_meter || 1;
              return parseFloat(e, 10) * n;
            }

            "GEOGCS" === t.type ? t.projName = "longlat" : "LOCAL_CS" === t.type ? (t.projName = "identity", t.local = !0) : "object" == typeof t.PROJECTION ? t.projName = Object.keys(t.PROJECTION)[0] : t.projName = t.PROJECTION, t.UNIT && (t.units = t.UNIT.name.toLowerCase(), "metre" === t.units && (t.units = "meter"), t.UNIT.convert && ("GEOGCS" === t.type ? t.DATUM && t.DATUM.SPHEROID && (t.to_meter = parseFloat(t.UNIT.convert, 10) * t.DATUM.SPHEROID.a) : t.to_meter = parseFloat(t.UNIT.convert, 10))), t.GEOGCS && (t.GEOGCS.DATUM ? t.datumCode = t.GEOGCS.DATUM.name.toLowerCase() : t.datumCode = t.GEOGCS.name.toLowerCase(), "d_" === t.datumCode.slice(0, 2) && (t.datumCode = t.datumCode.slice(2)), "new_zealand_geodetic_datum_1949" !== t.datumCode && "new_zealand_1949" !== t.datumCode || (t.datumCode = "nzgd49"), "wgs_1984" === t.datumCode && ("Mercator_Auxiliary_Sphere" === t.PROJECTION && (t.sphere = !0), t.datumCode = "wgs84"), "_ferro" === t.datumCode.slice(-6) && (t.datumCode = t.datumCode.slice(0, -6)), "_jakarta" === t.datumCode.slice(-8) && (t.datumCode = t.datumCode.slice(0, -8)), ~t.datumCode.indexOf("belge") && (t.datumCode = "rnb72"), t.GEOGCS.DATUM && t.GEOGCS.DATUM.SPHEROID && (t.ellps = t.GEOGCS.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === t.ellps.toLowerCase().slice(0, 13) && (t.ellps = "intl"), t.a = t.GEOGCS.DATUM.SPHEROID.a, t.rf = parseFloat(t.GEOGCS.DATUM.SPHEROID.rf, 10)), ~t.datumCode.indexOf("osgb_1936") && (t.datumCode = "osgb36")), t.b && !isFinite(t.b) && (t.b = t.a);

            var n = function n(e) {
              return o(t, e);
            },
                r = [["standard_parallel_1", "Standard_Parallel_1"], ["standard_parallel_2", "Standard_Parallel_2"], ["false_easting", "False_Easting"], ["false_northing", "False_Northing"], ["central_meridian", "Central_Meridian"], ["latitude_of_origin", "Latitude_Of_Origin"], ["latitude_of_origin", "Central_Parallel"], ["scale_factor", "Scale_Factor"], ["k0", "scale_factor"], ["latitude_of_center", "Latitude_of_center"], ["lat0", "latitude_of_center", a], ["longitude_of_center", "Longitude_Of_Center"], ["longc", "longitude_of_center", a], ["x0", "false_easting", e], ["y0", "false_northing", e], ["long0", "central_meridian", a], ["lat0", "latitude_of_origin", a], ["lat0", "standard_parallel_1", a], ["lat1", "standard_parallel_1", a], ["lat2", "standard_parallel_2", a], ["alpha", "azimuth", a], ["srsCode", "name"]];

            r.forEach(n), t.long0 || !t.longc || "Albers_Conic_Equal_Area" !== t.projName && "Lambert_Azimuthal_Equal_Area" !== t.projName || (t.long0 = t.longc), t.lat_ts || !t.lat1 || "Stereographic_South_Pole" !== t.projName && "Polar Stereographic (variant B)" !== t.projName || (t.lat0 = a(t.lat1 > 0 ? 90 : -90), t.lat_ts = t.lat1);
          }

          var u = .017453292519943295,
              c = t("./extend");

          e.exports = function (t, e) {
            var n = JSON.parse(("," + t).replace(/\s*\,\s*([A-Z_0-9]+?)(\[)/g, ',["$1",').slice(1).replace(/\s*\,\s*([A-Z_0-9]+?)\]/g, ',"$1"]').replace(/,\["VERTCS".+/, "")),
                r = n.shift(),
                o = n.shift();
            n.unshift(["name", o]), n.unshift(["type", r]), n.unshift("output");
            var a = {};
            return i(n, a), s(a.output), c(e, a.output);
          };
        }, {
          "./extend": 34
        }],
        68: [function (t, e, n) {
          function r(t) {
            return t * (Math.PI / 180);
          }

          function i(t) {
            return 180 * (t / Math.PI);
          }

          function o(t) {
            var e,
                n,
                i,
                o,
                a,
                u,
                c,
                l,
                h,
                f = t.lat,
                p = t.lon,
                m = 6378137,
                d = .00669438,
                g = .9996,
                v = r(f),
                y = r(p);
            h = Math.floor((p + 180) / 6) + 1, 180 === p && (h = 60), f >= 56 && 64 > f && p >= 3 && 12 > p && (h = 32), f >= 72 && 84 > f && (p >= 0 && 9 > p ? h = 31 : p >= 9 && 21 > p ? h = 33 : p >= 21 && 33 > p ? h = 35 : p >= 33 && 42 > p && (h = 37)), e = 6 * (h - 1) - 180 + 3, l = r(e), n = d / (1 - d), i = m / Math.sqrt(1 - d * Math.sin(v) * Math.sin(v)), o = Math.tan(v) * Math.tan(v), a = n * Math.cos(v) * Math.cos(v), u = Math.cos(v) * (y - l), c = m * ((1 - d / 4 - 3 * d * d / 64 - 5 * d * d * d / 256) * v - (3 * d / 8 + 3 * d * d / 32 + 45 * d * d * d / 1024) * Math.sin(2 * v) + (15 * d * d / 256 + 45 * d * d * d / 1024) * Math.sin(4 * v) - 35 * d * d * d / 3072 * Math.sin(6 * v));
            var x = g * i * (u + (1 - o + a) * u * u * u / 6 + (5 - 18 * o + o * o + 72 * a - 58 * n) * u * u * u * u * u / 120) + 5e5,
                w = g * (c + i * Math.tan(v) * (u * u / 2 + (5 - o + 9 * a + 4 * a * a) * u * u * u * u / 24 + (61 - 58 * o + o * o + 600 * a - 330 * n) * u * u * u * u * u * u / 720));
            return 0 > f && (w += 1e7), {
              northing: Math.round(w),
              easting: Math.round(x),
              zoneNumber: h,
              zoneLetter: s(f)
            };
          }

          function a(t) {
            var e = t.northing,
                n = t.easting,
                r = t.zoneLetter,
                o = t.zoneNumber;
            if (0 > o || o > 60) return null;
            var s,
                u,
                c,
                l,
                h,
                f,
                p,
                m,
                d,
                g,
                v = .9996,
                y = 6378137,
                x = .00669438,
                w = (1 - Math.sqrt(1 - x)) / (1 + Math.sqrt(1 - x)),
                b = n - 5e5,
                _ = e;
            "N" > r && (_ -= 1e7), m = 6 * (o - 1) - 180 + 3, s = x / (1 - x), p = _ / v, d = p / (y * (1 - x / 4 - 3 * x * x / 64 - 5 * x * x * x / 256)), g = d + (3 * w / 2 - 27 * w * w * w / 32) * Math.sin(2 * d) + (21 * w * w / 16 - 55 * w * w * w * w / 32) * Math.sin(4 * d) + 151 * w * w * w / 96 * Math.sin(6 * d), u = y / Math.sqrt(1 - x * Math.sin(g) * Math.sin(g)), c = Math.tan(g) * Math.tan(g), l = s * Math.cos(g) * Math.cos(g), h = y * (1 - x) / Math.pow(1 - x * Math.sin(g) * Math.sin(g), 1.5), f = b / (u * v);
            var E = g - u * Math.tan(g) / h * (f * f / 2 - (5 + 3 * c + 10 * l - 4 * l * l - 9 * s) * f * f * f * f / 24 + (61 + 90 * c + 298 * l + 45 * c * c - 252 * s - 3 * l * l) * f * f * f * f * f * f / 720);
            E = i(E);
            var M = (f - (1 + 2 * c + l) * f * f * f / 6 + (5 - 2 * l + 28 * c - 3 * l * l + 8 * s + 24 * c * c) * f * f * f * f * f / 120) / Math.cos(g);
            M = m + i(M);
            var T;

            if (t.accuracy) {
              var N = a({
                northing: t.northing + t.accuracy,
                easting: t.easting + t.accuracy,
                zoneLetter: t.zoneLetter,
                zoneNumber: t.zoneNumber
              });
              T = {
                top: N.lat,
                right: N.lon,
                bottom: E,
                left: M
              };
            } else T = {
              lat: E,
              lon: M
            };

            return T;
          }

          function s(t) {
            var e = "Z";
            return 84 >= t && t >= 72 ? e = "X" : 72 > t && t >= 64 ? e = "W" : 64 > t && t >= 56 ? e = "V" : 56 > t && t >= 48 ? e = "U" : 48 > t && t >= 40 ? e = "T" : 40 > t && t >= 32 ? e = "S" : 32 > t && t >= 24 ? e = "R" : 24 > t && t >= 16 ? e = "Q" : 16 > t && t >= 8 ? e = "P" : 8 > t && t >= 0 ? e = "N" : 0 > t && t >= -8 ? e = "M" : -8 > t && t >= -16 ? e = "L" : -16 > t && t >= -24 ? e = "K" : -24 > t && t >= -32 ? e = "J" : -32 > t && t >= -40 ? e = "H" : -40 > t && t >= -48 ? e = "G" : -48 > t && t >= -56 ? e = "F" : -56 > t && t >= -64 ? e = "E" : -64 > t && t >= -72 ? e = "D" : -72 > t && t >= -80 && (e = "C"), e;
          }

          function u(t, e) {
            var n = "00000" + t.easting,
                r = "00000" + t.northing;
            return t.zoneNumber + t.zoneLetter + c(t.easting, t.northing, t.zoneNumber) + n.substr(n.length - 5, e) + r.substr(r.length - 5, e);
          }

          function c(t, e, n) {
            var r = l(n),
                i = Math.floor(t / 1e5),
                o = Math.floor(e / 1e5) % 20;
            return h(i, o, r);
          }

          function l(t) {
            var e = t % g;
            return 0 === e && (e = g), e;
          }

          function h(t, e, n) {
            var r = n - 1,
                i = v.charCodeAt(r),
                o = y.charCodeAt(r),
                a = i + t - 1,
                s = o + e,
                u = !1;
            a > E && (a = a - E + x - 1, u = !0), (a === w || w > i && a > w || (a > w || w > i) && u) && a++, (a === b || b > i && a > b || (a > b || b > i) && u) && (a++, a === w && a++), a > E && (a = a - E + x - 1), s > _ ? (s = s - _ + x - 1, u = !0) : u = !1, (s === w || w > o && s > w || (s > w || w > o) && u) && s++, (s === b || b > o && s > b || (s > b || b > o) && u) && (s++, s === w && s++), s > _ && (s = s - _ + x - 1);
            var c = String.fromCharCode(a) + String.fromCharCode(s);
            return c;
          }

          function f(t) {
            if (t && 0 === t.length) throw "MGRSPoint coverting from nothing";

            for (var e, n = t.length, r = null, i = "", o = 0; !/[A-Z]/.test(e = t.charAt(o));) {
              if (o >= 2) throw "MGRSPoint bad conversion from: " + t;
              i += e, o++;
            }

            var a = parseInt(i, 10);
            if (0 === o || o + 3 > n) throw "MGRSPoint bad conversion from: " + t;
            var s = t.charAt(o++);
            if ("A" >= s || "B" === s || "Y" === s || s >= "Z" || "I" === s || "O" === s) throw "MGRSPoint zone letter " + s + " not handled: " + t;
            r = t.substring(o, o += 2);

            for (var u = l(a), c = p(r.charAt(0), u), h = m(r.charAt(1), u); h < d(s);) {
              h += 2e6;
            }

            var f = n - o;
            if (f % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + t;
            var g,
                v,
                y,
                x,
                w,
                b = f / 2,
                _ = 0,
                E = 0;
            return b > 0 && (g = 1e5 / Math.pow(10, b), v = t.substring(o, o + b), _ = parseFloat(v) * g, y = t.substring(o + b), E = parseFloat(y) * g), x = _ + c, w = E + h, {
              easting: x,
              northing: w,
              zoneLetter: s,
              zoneNumber: a,
              accuracy: g
            };
          }

          function p(t, e) {
            for (var n = v.charCodeAt(e - 1), r = 1e5, i = !1; n !== t.charCodeAt(0);) {
              if (n++, n === w && n++, n === b && n++, n > E) {
                if (i) throw "Bad character: " + t;
                n = x, i = !0;
              }

              r += 1e5;
            }

            return r;
          }

          function m(t, e) {
            if (t > "V") throw "MGRSPoint given invalid Northing " + t;

            for (var n = y.charCodeAt(e - 1), r = 0, i = !1; n !== t.charCodeAt(0);) {
              if (n++, n === w && n++, n === b && n++, n > _) {
                if (i) throw "Bad character: " + t;
                n = x, i = !0;
              }

              r += 1e5;
            }

            return r;
          }

          function d(t) {
            var e;

            switch (t) {
              case "C":
                e = 11e5;
                break;

              case "D":
                e = 2e6;
                break;

              case "E":
                e = 28e5;
                break;

              case "F":
                e = 37e5;
                break;

              case "G":
                e = 46e5;
                break;

              case "H":
                e = 55e5;
                break;

              case "J":
                e = 64e5;
                break;

              case "K":
                e = 73e5;
                break;

              case "L":
                e = 82e5;
                break;

              case "M":
                e = 91e5;
                break;

              case "N":
                e = 0;
                break;

              case "P":
                e = 8e5;
                break;

              case "Q":
                e = 17e5;
                break;

              case "R":
                e = 26e5;
                break;

              case "S":
                e = 35e5;
                break;

              case "T":
                e = 44e5;
                break;

              case "U":
                e = 53e5;
                break;

              case "V":
                e = 62e5;
                break;

              case "W":
                e = 7e6;
                break;

              case "X":
                e = 79e5;
                break;

              default:
                e = -1;
            }

            if (e >= 0) return e;
            throw "Invalid zone letter: " + t;
          }

          var g = 6,
              v = "AJSAJS",
              y = "AFAFAF",
              x = 65,
              w = 73,
              b = 79,
              _ = 86,
              E = 90;
          n.forward = function (t, e) {
            return e = e || 5, u(o({
              lat: t[1],
              lon: t[0]
            }), e);
          }, n.inverse = function (t) {
            var e = a(f(t.toUpperCase()));
            return e.lat && e.lon ? [e.lon, e.lat, e.lon, e.lat] : [e.left, e.bottom, e.right, e.top];
          }, n.toPoint = function (t) {
            var e = a(f(t.toUpperCase()));
            return e.lat && e.lon ? [e.lon, e.lat] : [(e.left + e.right) / 2, (e.top + e.bottom) / 2];
          };
        }, {}],
        69: [function (t, e, n) {
          e.exports = {
            name: "proj4",
            version: "2.3.15",
            description: "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",
            main: "lib/index.js",
            directories: {
              test: "test",
              doc: "docs"
            },
            scripts: {
              test: "./node_modules/istanbul/lib/cli.js test ./node_modules/mocha/bin/_mocha test/test.js"
            },
            repository: {
              type: "git",
              url: "git://github.com/proj4js/proj4js.git"
            },
            author: "",
            license: "MIT",
            jam: {
              main: "dist/proj4.js",
              include: ["dist/proj4.js", "README.md", "AUTHORS", "LICENSE.md"]
            },
            devDependencies: {
              "grunt-cli": "~0.1.13",
              grunt: "~0.4.2",
              "grunt-contrib-connect": "~0.6.0",
              "grunt-contrib-jshint": "~0.8.0",
              chai: "~1.8.1",
              mocha: "~1.17.1",
              "grunt-mocha-phantomjs": "~0.4.0",
              browserify: "~12.0.1",
              "grunt-browserify": "~4.0.1",
              "grunt-contrib-uglify": "~0.11.1",
              curl: "git://github.com/cujojs/curl.git",
              istanbul: "~0.2.4",
              tin: "~0.4.0"
            },
            dependencies: {
              mgrs: "~0.0.2"
            }
          };
        }, {}]
      }, {}, [36])(36);
    });
  },,,,,,,,,,,,,,,,, function (t, e) {
    "use strict";

    function n(t) {
      var e = /[=:]/g,
          n = {
        "=": "=0",
        ":": "=2"
      },
          r = ("" + t).replace(e, function (t) {
        return n[t];
      });
      return "$" + r;
    }

    function r(t) {
      var e = /(=0|=2)/g,
          n = {
        "=0": "=",
        "=2": ":"
      },
          r = "." === t[0] && "$" === t[1] ? t.substring(2) : t.substring(1);
      return ("" + r).replace(e, function (t) {
        return n[t];
      });
    }

    var i = {
      escape: n,
      unescape: r
    };
    t.exports = i;
  }, function (t, e, n) {
    "use strict";

    var r = n(50),
        i = (n(9), function (t) {
      var e = this;

      if (e.instancePool.length) {
        var n = e.instancePool.pop();
        return e.call(n, t), n;
      }

      return new e(t);
    }),
        o = function o(t, e) {
      var n = this;

      if (n.instancePool.length) {
        var r = n.instancePool.pop();
        return n.call(r, t, e), r;
      }

      return new n(t, e);
    },
        a = function a(t, e, n) {
      var r = this;

      if (r.instancePool.length) {
        var i = r.instancePool.pop();
        return r.call(i, t, e, n), i;
      }

      return new r(t, e, n);
    },
        s = function s(t, e, n, r) {
      var i = this;

      if (i.instancePool.length) {
        var o = i.instancePool.pop();
        return i.call(o, t, e, n, r), o;
      }

      return new i(t, e, n, r);
    },
        u = function u(t) {
      var e = this;
      t instanceof e ? void 0 : r("25"), t.destructor(), e.instancePool.length < e.poolSize && e.instancePool.push(t);
    },
        c = 10,
        l = i,
        h = function h(t, e) {
      var n = t;
      return n.instancePool = [], n.getPooled = e || l, n.poolSize || (n.poolSize = c), n.release = u, n;
    },
        f = {
      addPoolingTo: h,
      oneArgumentPooler: i,
      twoArgumentPooler: o,
      threeArgumentPooler: a,
      fourArgumentPooler: s
    };

    t.exports = f;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return ("" + t).replace(w, "$&/");
    }

    function i(t, e) {
      this.func = t, this.context = e, this.count = 0;
    }

    function o(t, e, n) {
      var r = t.func,
          i = t.context;
      r.call(i, e, t.count++);
    }

    function a(t, e, n) {
      if (null == t) return t;
      var r = i.getPooled(e, n);
      v(t, o, r), i.release(r);
    }

    function s(t, e, n, r) {
      this.result = t, this.keyPrefix = e, this.func = n, this.context = r, this.count = 0;
    }

    function u(t, e, n) {
      var i = t.result,
          o = t.keyPrefix,
          a = t.func,
          s = t.context,
          u = a.call(s, e, t.count++);
      Array.isArray(u) ? c(u, i, n, g.thatReturnsArgument) : null != u && (d.isValidElement(u) && (u = d.cloneAndReplaceKey(u, o + (!u.key || e && e.key === u.key ? "" : r(u.key) + "/") + n)), i.push(u));
    }

    function c(t, e, n, i, o) {
      var a = "";
      null != n && (a = r(n) + "/");
      var c = s.getPooled(e, a, i, o);
      v(t, u, c), s.release(c);
    }

    function l(t, e, n) {
      if (null == t) return t;
      var r = [];
      return c(t, r, null, e, n), r;
    }

    function h(t, e, n) {
      return null;
    }

    function f(t, e) {
      return v(t, h, null);
    }

    function p(t) {
      var e = [];
      return c(t, e, null, g.thatReturnsArgument), e;
    }

    var m = n(568),
        d = n(48),
        g = n(33),
        v = n(577),
        y = m.twoArgumentPooler,
        x = m.fourArgumentPooler,
        w = /\/+/g;
    i.prototype.destructor = function () {
      this.func = null, this.context = null, this.count = 0;
    }, m.addPoolingTo(i, y), s.prototype.destructor = function () {
      this.result = null, this.keyPrefix = null, this.func = null, this.context = null, this.count = 0;
    }, m.addPoolingTo(s, x);
    var b = {
      forEach: a,
      map: l,
      mapIntoWithKeyPrefixInternal: c,
      count: f,
      toArray: p
    };
    t.exports = b;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t;
    }

    function i(t, e) {
      var n = w.hasOwnProperty(e) ? w[e] : null;
      _.hasOwnProperty(e) && ("OVERRIDE_BASE" !== n ? f("73", e) : void 0), t && ("DEFINE_MANY" !== n && "DEFINE_MANY_MERGED" !== n ? f("74", e) : void 0);
    }

    function o(t, e) {
      if (e) {
        "function" == typeof e ? f("75") : void 0, d.isValidElement(e) ? f("76") : void 0;
        var n = t.prototype,
            r = n.__reactAutoBindPairs;
        e.hasOwnProperty(y) && b.mixins(t, e.mixins);

        for (var o in e) {
          if (e.hasOwnProperty(o) && o !== y) {
            var a = e[o],
                s = n.hasOwnProperty(o);
            if (i(s, o), b.hasOwnProperty(o)) b[o](t, a);else {
              var l = w.hasOwnProperty(o),
                  h = "function" == typeof a,
                  p = h && !l && !s && e.autobind !== !1;
              if (p) r.push(o, a), n[o] = a;else if (s) {
                var m = w[o];
                !l || "DEFINE_MANY_MERGED" !== m && "DEFINE_MANY" !== m ? f("77", m, o) : void 0, "DEFINE_MANY_MERGED" === m ? n[o] = u(n[o], a) : "DEFINE_MANY" === m && (n[o] = c(n[o], a));
              } else n[o] = a;
            }
          }
        }
      } else ;
    }

    function a(t, e) {
      if (e) for (var n in e) {
        var r = e[n];

        if (e.hasOwnProperty(n)) {
          var i = (n in b);
          i ? f("78", n) : void 0;
          var o = (n in t);
          o ? f("79", n) : void 0, t[n] = r;
        }
      }
    }

    function s(t, e) {
      t && e && "object" == typeof t && "object" == typeof e ? void 0 : f("80");

      for (var n in e) {
        e.hasOwnProperty(n) && (void 0 !== t[n] ? f("81", n) : void 0, t[n] = e[n]);
      }

      return t;
    }

    function u(t, e) {
      return function () {
        var n = t.apply(this, arguments),
            r = e.apply(this, arguments);
        if (null == n) return r;
        if (null == r) return n;
        var i = {};
        return s(i, n), s(i, r), i;
      };
    }

    function c(t, e) {
      return function () {
        t.apply(this, arguments), e.apply(this, arguments);
      };
    }

    function l(t, e) {
      var n = e.bind(t);
      return n;
    }

    function h(t) {
      for (var e = t.__reactAutoBindPairs, n = 0; n < e.length; n += 2) {
        var r = e[n],
            i = e[n + 1];
        t[r] = l(t, i);
      }
    }

    var f = n(50),
        p = n(21),
        m = n(94),
        d = n(48),
        g = (n(165), n(95)),
        v = n(59),
        y = (n(9), n(10), "mixins"),
        x = [],
        w = {
      mixins: "DEFINE_MANY",
      statics: "DEFINE_MANY",
      propTypes: "DEFINE_MANY",
      contextTypes: "DEFINE_MANY",
      childContextTypes: "DEFINE_MANY",
      getDefaultProps: "DEFINE_MANY_MERGED",
      getInitialState: "DEFINE_MANY_MERGED",
      getChildContext: "DEFINE_MANY_MERGED",
      render: "DEFINE_ONCE",
      componentWillMount: "DEFINE_MANY",
      componentDidMount: "DEFINE_MANY",
      componentWillReceiveProps: "DEFINE_MANY",
      shouldComponentUpdate: "DEFINE_ONCE",
      componentWillUpdate: "DEFINE_MANY",
      componentDidUpdate: "DEFINE_MANY",
      componentWillUnmount: "DEFINE_MANY",
      updateComponent: "OVERRIDE_BASE"
    },
        b = {
      displayName: function displayName(t, e) {
        t.displayName = e;
      },
      mixins: function mixins(t, e) {
        if (e) for (var n = 0; n < e.length; n++) {
          o(t, e[n]);
        }
      },
      childContextTypes: function childContextTypes(t, e) {
        t.childContextTypes = p({}, t.childContextTypes, e);
      },
      contextTypes: function contextTypes(t, e) {
        t.contextTypes = p({}, t.contextTypes, e);
      },
      getDefaultProps: function getDefaultProps(t, e) {
        t.getDefaultProps ? t.getDefaultProps = u(t.getDefaultProps, e) : t.getDefaultProps = e;
      },
      propTypes: function propTypes(t, e) {
        t.propTypes = p({}, t.propTypes, e);
      },
      statics: function statics(t, e) {
        a(t, e);
      },
      autobind: function autobind() {}
    },
        _ = {
      replaceState: function replaceState(t, e) {
        this.updater.enqueueReplaceState(this, t), e && this.updater.enqueueCallback(this, e, "replaceState");
      },
      isMounted: function isMounted() {
        return this.updater.isMounted(this);
      }
    },
        E = function E() {};

    p(E.prototype, m.prototype, _);
    var M = {
      createClass: function createClass(t) {
        var e = r(function (t, n, r) {
          this.__reactAutoBindPairs.length && h(this), this.props = t, this.context = n, this.refs = v, this.updater = r || g, this.state = null;
          var i = this.getInitialState ? this.getInitialState() : null;
          "object" != typeof i || Array.isArray(i) ? f("82", e.displayName || "ReactCompositeComponent") : void 0, this.state = i;
        });
        e.prototype = new E(), e.prototype.constructor = e, e.prototype.__reactAutoBindPairs = [], x.forEach(o.bind(null, e)), o(e, t), e.getDefaultProps && (e.defaultProps = e.getDefaultProps()), e.prototype.render ? void 0 : f("83");

        for (var n in w) {
          e.prototype[n] || (e.prototype[n] = null);
        }

        return e;
      },
      injection: {
        injectMixin: function injectMixin(t) {
          x.push(t);
        }
      }
    };
    t.exports = M;
  }, function (t, e, n) {
    "use strict";

    var r = n(48),
        i = r.createFactory,
        o = {
      a: i("a"),
      abbr: i("abbr"),
      address: i("address"),
      area: i("area"),
      article: i("article"),
      aside: i("aside"),
      audio: i("audio"),
      b: i("b"),
      base: i("base"),
      bdi: i("bdi"),
      bdo: i("bdo"),
      big: i("big"),
      blockquote: i("blockquote"),
      body: i("body"),
      br: i("br"),
      button: i("button"),
      canvas: i("canvas"),
      caption: i("caption"),
      cite: i("cite"),
      code: i("code"),
      col: i("col"),
      colgroup: i("colgroup"),
      data: i("data"),
      datalist: i("datalist"),
      dd: i("dd"),
      del: i("del"),
      details: i("details"),
      dfn: i("dfn"),
      dialog: i("dialog"),
      div: i("div"),
      dl: i("dl"),
      dt: i("dt"),
      em: i("em"),
      embed: i("embed"),
      fieldset: i("fieldset"),
      figcaption: i("figcaption"),
      figure: i("figure"),
      footer: i("footer"),
      form: i("form"),
      h1: i("h1"),
      h2: i("h2"),
      h3: i("h3"),
      h4: i("h4"),
      h5: i("h5"),
      h6: i("h6"),
      head: i("head"),
      header: i("header"),
      hgroup: i("hgroup"),
      hr: i("hr"),
      html: i("html"),
      i: i("i"),
      iframe: i("iframe"),
      img: i("img"),
      input: i("input"),
      ins: i("ins"),
      kbd: i("kbd"),
      keygen: i("keygen"),
      label: i("label"),
      legend: i("legend"),
      li: i("li"),
      link: i("link"),
      main: i("main"),
      map: i("map"),
      mark: i("mark"),
      menu: i("menu"),
      menuitem: i("menuitem"),
      meta: i("meta"),
      meter: i("meter"),
      nav: i("nav"),
      noscript: i("noscript"),
      object: i("object"),
      ol: i("ol"),
      optgroup: i("optgroup"),
      option: i("option"),
      output: i("output"),
      p: i("p"),
      param: i("param"),
      picture: i("picture"),
      pre: i("pre"),
      progress: i("progress"),
      q: i("q"),
      rp: i("rp"),
      rt: i("rt"),
      ruby: i("ruby"),
      s: i("s"),
      samp: i("samp"),
      script: i("script"),
      section: i("section"),
      select: i("select"),
      small: i("small"),
      source: i("source"),
      span: i("span"),
      strong: i("strong"),
      style: i("style"),
      sub: i("sub"),
      summary: i("summary"),
      sup: i("sup"),
      table: i("table"),
      tbody: i("tbody"),
      td: i("td"),
      textarea: i("textarea"),
      tfoot: i("tfoot"),
      th: i("th"),
      thead: i("thead"),
      time: i("time"),
      title: i("title"),
      tr: i("tr"),
      track: i("track"),
      u: i("u"),
      ul: i("ul"),
      var: i("var"),
      video: i("video"),
      wbr: i("wbr"),
      circle: i("circle"),
      clipPath: i("clipPath"),
      defs: i("defs"),
      ellipse: i("ellipse"),
      g: i("g"),
      image: i("image"),
      line: i("line"),
      linearGradient: i("linearGradient"),
      mask: i("mask"),
      path: i("path"),
      pattern: i("pattern"),
      polygon: i("polygon"),
      polyline: i("polyline"),
      radialGradient: i("radialGradient"),
      rect: i("rect"),
      stop: i("stop"),
      svg: i("svg"),
      text: i("text"),
      tspan: i("tspan")
    };
    t.exports = o;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      return t === e ? 0 !== t || 1 / t === 1 / e : t !== t && e !== e;
    }

    function i(t) {
      this.message = t, this.stack = "";
    }

    function o(t) {
      function e(e, n, r, o, a, s, u) {
        o = o || N, s = s || r;

        if (null == n[r]) {
          var c = _[a];
          return e ? new i(null === n[r] ? "The " + c + " `" + s + "` is marked as required " + ("in `" + o + "`, but its value is `null`.") : "The " + c + " `" + s + "` is marked as required in " + ("`" + o + "`, but its value is `undefined`.")) : null;
        }

        return t(n, r, o, a, s);
      }

      var n = e.bind(null, !1);
      return n.isRequired = e.bind(null, !0), n;
    }

    function a(t) {
      function e(e, n, r, o, a, s) {
        var u = e[n],
            c = y(u);

        if (c !== t) {
          var l = _[o],
              h = x(u);
          return new i("Invalid " + l + " `" + a + "` of type " + ("`" + h + "` supplied to `" + r + "`, expected ") + ("`" + t + "`."));
        }

        return null;
      }

      return o(e);
    }

    function s() {
      return o(M.thatReturns(null));
    }

    function u(t) {
      function e(e, n, r, o, a) {
        if ("function" != typeof t) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var s = e[n];

        if (!Array.isArray(s)) {
          var u = _[o],
              c = y(s);
          return new i("Invalid " + u + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
        }

        for (var l = 0; l < s.length; l++) {
          var h = t(s, l, r, o, a + "[" + l + "]", E);
          if (h instanceof Error) return h;
        }

        return null;
      }

      return o(e);
    }

    function c() {
      function t(t, e, n, r, o) {
        var a = t[e];

        if (!b.isValidElement(a)) {
          var s = _[r],
              u = y(a);
          return new i("Invalid " + s + " `" + o + "` of type " + ("`" + u + "` supplied to `" + n + "`, expected a single ReactElement."));
        }

        return null;
      }

      return o(t);
    }

    function l(t) {
      function e(e, n, r, o, a) {
        if (!(e[n] instanceof t)) {
          var s = _[o],
              u = t.name || N,
              c = w(e[n]);
          return new i("Invalid " + s + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("instance of `" + u + "`."));
        }

        return null;
      }

      return o(e);
    }

    function h(t) {
      function e(e, n, o, a, s) {
        for (var u = e[n], c = 0; c < t.length; c++) {
          if (r(u, t[c])) return null;
        }

        var l = _[a],
            h = JSON.stringify(t);
        return new i("Invalid " + l + " `" + s + "` of value `" + u + "` " + ("supplied to `" + o + "`, expected one of " + h + "."));
      }

      return Array.isArray(t) ? o(e) : M.thatReturnsNull;
    }

    function f(t) {
      function e(e, n, r, o, a) {
        if ("function" != typeof t) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var s = e[n],
            u = y(s);

        if ("object" !== u) {
          var c = _[o];
          return new i("Invalid " + c + " `" + a + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected an object."));
        }

        for (var l in s) {
          if (s.hasOwnProperty(l)) {
            var h = t(s, l, r, o, a + "." + l, E);
            if (h instanceof Error) return h;
          }
        }

        return null;
      }

      return o(e);
    }

    function p(t) {
      function e(e, n, r, o, a) {
        for (var s = 0; s < t.length; s++) {
          var u = t[s];
          if (null == u(e, n, r, o, a, E)) return null;
        }

        var c = _[o];
        return new i("Invalid " + c + " `" + a + "` supplied to " + ("`" + r + "`."));
      }

      return Array.isArray(t) ? o(e) : M.thatReturnsNull;
    }

    function m() {
      function t(t, e, n, r, o) {
        if (!g(t[e])) {
          var a = _[r];
          return new i("Invalid " + a + " `" + o + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
        }

        return null;
      }

      return o(t);
    }

    function d(t) {
      function e(e, n, r, o, a) {
        var s = e[n],
            u = y(s);

        if ("object" !== u) {
          var c = _[o];
          return new i("Invalid " + c + " `" + a + "` of type `" + u + "` " + ("supplied to `" + r + "`, expected `object`."));
        }

        for (var l in t) {
          var h = t[l];

          if (h) {
            var f = h(s, l, r, o, a + "." + l, E);
            if (f) return f;
          }
        }

        return null;
      }

      return o(e);
    }

    function g(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(g);
          if (null === t || b.isValidElement(t)) return !0;
          var e = T(t);
          if (!e) return !1;
          var n,
              r = e.call(t);

          if (e !== t.entries) {
            for (; !(n = r.next()).done;) {
              if (!g(n.value)) return !1;
            }
          } else for (; !(n = r.next()).done;) {
            var i = n.value;
            if (i && !g(i[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function v(t, e) {
      return "symbol" === t || "Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol;
    }

    function y(t) {
      var e = typeof t;
      return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : v(e, t) ? "symbol" : e;
    }

    function x(t) {
      var e = y(t);

      if ("object" === e) {
        if (t instanceof Date) return "date";
        if (t instanceof RegExp) return "regexp";
      }

      return e;
    }

    function w(t) {
      return t.constructor && t.constructor.name ? t.constructor.name : N;
    }

    var b = n(48),
        _ = n(165),
        E = n(573),
        M = n(33),
        T = n(167),
        N = (n(10), "<<anonymous>>"),
        S = {
      array: a("array"),
      bool: a("boolean"),
      func: a("function"),
      number: a("number"),
      object: a("object"),
      string: a("string"),
      symbol: a("symbol"),
      any: s(),
      arrayOf: u,
      element: c(),
      instanceOf: l,
      node: m(),
      objectOf: f,
      oneOf: h,
      oneOfType: p,
      shape: d
    };

    i.prototype = Error.prototype, t.exports = S;
  }, function (t, e) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    function r(t, e, n) {
      this.props = t, this.context = e, this.refs = u, this.updater = n || s;
    }

    function i() {}

    var o = n(21),
        a = n(94),
        s = n(95),
        u = n(59);
    i.prototype = a.prototype, r.prototype = new i(), r.prototype.constructor = r, o(r.prototype, a.prototype), r.prototype.isPureReactComponent = !0, t.exports = r;
  }, function (t, e) {
    "use strict";

    t.exports = "15.4.2";
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return o.isValidElement(t) ? void 0 : i("143"), t;
    }

    var i = n(50),
        o = n(48);
    n(9);
    t.exports = r;
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      return t && "object" == typeof t && null != t.key ? c.escape(t.key) : e.toString(36);
    }

    function i(t, e, n, o) {
      var f = typeof t;
      if ("undefined" !== f && "boolean" !== f || (t = null), null === t || "string" === f || "number" === f || "object" === f && t.$$typeof === s) return n(o, t, "" === e ? l + r(t, 0) : e), 1;
      var p,
          m,
          d = 0,
          g = "" === e ? l : e + h;
      if (Array.isArray(t)) for (var v = 0; v < t.length; v++) {
        p = t[v], m = g + r(p, v), d += i(p, m, n, o);
      } else {
        var y = u(t);

        if (y) {
          var x,
              w = y.call(t);
          if (y !== t.entries) for (var b = 0; !(x = w.next()).done;) {
            p = x.value, m = g + r(p, b++), d += i(p, m, n, o);
          } else for (; !(x = w.next()).done;) {
            var _ = x.value;
            _ && (p = _[1], m = g + c.escape(_[0]) + h + r(p, 0), d += i(p, m, n, o));
          }
        } else if ("object" === f) {
          var E = "",
              M = String(t);
          a("31", "[object Object]" === M ? "object with keys {" + Object.keys(t).join(", ") + "}" : M, E);
        }
      }
      return d;
    }

    function o(t, e, n) {
      return null == t ? 0 : i(t, "", e, n);
    }

    var a = n(50),
        s = (n(49), n(164)),
        u = n(167),
        c = (n(9), n(567)),
        l = (n(10), "."),
        h = ":";
    t.exports = o;
  }, function (t, e) {
    function n() {}

    n.prototype = {
      on: function on(t, e, n) {
        var r = this.e || (this.e = {});
        return (r[t] || (r[t] = [])).push({
          fn: e,
          ctx: n
        }), this;
      },
      once: function once(t, e, n) {
        function r() {
          i.off(t, r), e.apply(n, arguments);
        }

        var i = this;
        return r._ = e, this.on(t, r, n);
      },
      emit: function emit(t) {
        var e = [].slice.call(arguments, 1),
            n = ((this.e || (this.e = {}))[t] || []).slice(),
            r = 0,
            i = n.length;

        for (r; r < i; r++) {
          n[r].fn.apply(n[r].ctx, e);
        }

        return this;
      },
      off: function off(t, e) {
        var n = this.e || (this.e = {}),
            r = n[t],
            i = [];
        if (r && e) for (var o = 0, a = r.length; o < a; o++) {
          r[o].fn !== e && r[o].fn._ !== e && i.push(r[o]);
        }
        return i.length ? n[t] = i : delete n[t], this;
      }
    }, t.exports = n;
  }, function (t, e, n) {
    var r, i, o;
    !function (n, a) {
      i = [], r = a, o = "function" == typeof r ? r.apply(e, i) : r, !(void 0 !== o && (t.exports = o));
    }(this, function () {
      function t() {
        function e(t) {
          for (var e, n = 0; n < M.types.length; n++) {
            var r = M.types[n];

            if (r.name === t) {
              e = r.test;
              break;
            }
          }

          if (!e) {
            var i;

            for (n = 0; n < M.types.length; n++) {
              if (r = M.types[n], r.name.toLowerCase() == t.toLowerCase()) {
                i = r.name;
                break;
              }
            }

            throw new Error('Unknown type "' + t + '"' + (i ? '. Did you mean "' + i + '"?' : ""));
          }

          return e;
        }

        function n(t) {
          for (var e = "", n = 0; n < t.length; n++) {
            var r = t[n];
            if (r.signatures && "" != r.name) if ("" == e) e = r.name;else if (e != r.name) {
              var i = new Error("Function names do not match (expected: " + e + ", actual: " + r.name + ")");
              throw i.data = {
                actual: r.name,
                expected: e
              }, i;
            }
          }

          return e;
        }

        function r(t, e, n, r, i) {
          var o,
              a = d(r),
              s = i ? i.split(",") : null,
              u = t || "unnamed",
              c = s && g(s, "any"),
              l = {
            fn: t,
            index: n,
            actual: r,
            expected: s
          };
          o = s ? e > n && !c ? "Unexpected type of argument in function " + u + " (expected: " + s.join(" or ") + ", actual: " + a + ", index: " + n + ")" : "Too few arguments in function " + u + " (expected: " + s.join(" or ") + ", index: " + n + ")" : "Too many arguments in function " + u + " (expected: " + n + ", actual: " + e + ")";
          var h = new TypeError(o);
          return h.data = l, h;
        }

        function i(t) {
          this.name = t || "refs", this.categories = {};
        }

        function o(t, e) {
          if ("string" == typeof t) {
            var n = t.trim(),
                r = "..." === n.substr(0, 3);
            if (r && (n = n.substr(3)), "" === n) this.types = ["any"];else {
              this.types = n.split("|");

              for (var i = 0; i < this.types.length; i++) {
                this.types[i] = this.types[i].trim();
              }
            }
          } else {
            if (!Array.isArray(t)) {
              if (t instanceof o) return t.clone();
              throw new Error("String or Array expected");
            }

            this.types = t;
          }

          this.conversions = [], this.varArgs = r || e || !1, this.anyType = this.types.indexOf("any") !== -1;
        }

        function a(t, e) {
          var n;
          if ("string" == typeof t) n = "" !== t ? t.split(",") : [];else {
            if (!Array.isArray(t)) throw new Error("string or Array expected");
            n = t;
          }
          this.params = new Array(n.length), this.anyType = !1, this.varArgs = !1;

          for (var r = 0; r < n.length; r++) {
            var i = new o(n[r]);
            if (this.params[r] = i, i.anyType && (this.anyType = !0), r === n.length - 1) this.varArgs = i.varArgs;else if (i.varArgs) throw new SyntaxError('Unexpected variable arguments operator "..."');
          }

          this.fn = e;
        }

        function s(t, e, n, r) {
          this.path = t || [], this.param = t[t.length - 1] || null, this.signature = e || null, this.childs = n || [], this.fallThrough = r || !1;
        }

        function u(t) {
          var e,
              n,
              r = {},
              i = [];

          for (var o in t) {
            if (t.hasOwnProperty(o)) {
              var s = t[o];
              if (e = new a(o, s), e.ignore()) continue;
              var u = e.expand();

              for (n = 0; n < u.length; n++) {
                var c = u[n],
                    l = c.toString(),
                    h = r[l];

                if (h) {
                  var f = a.compare(c, h);
                  if (f < 0) r[l] = c;else if (0 === f) throw new Error('Signature "' + l + '" is defined twice');
                } else r[l] = c;
              }
            }
          }

          for (l in r) {
            r.hasOwnProperty(l) && i.push(r[l]);
          }

          for (i.sort(function (t, e) {
            return a.compare(t, e);
          }), n = 0; n < i.length; n++) {
            if (e = i[n], e.varArgs) for (var p = e.params.length - 1, m = e.params[p], d = 0; d < m.types.length;) {
              if (m.conversions[d]) for (var v = m.types[d], y = 0; y < i.length; y++) {
                var x = i[y],
                    w = x.params[p];

                if (x !== e && w && g(w.types, v) && !w.conversions[p]) {
                  m.types.splice(d, 1), m.conversions.splice(d, 1), d--;
                  break;
                }
              }
              d++;
            }
          }

          return i;
        }

        function c(t) {
          for (var e = [], n = 0; n < t.length; n++) {
            t[n].anyType && e.push(t[n]);
          }

          return e;
        }

        function l(t) {
          for (var e = {}, n = 0; n < t.length; n++) {
            var r = t[n];

            if (r.fn && !r.hasConversions()) {
              var i = r.params.join(",");
              e[i] = r.fn;
            }
          }

          return e;
        }

        function h(t, e, n) {
          var r,
              i,
              a,
              u = e.length,
              c = [];

          for (r = 0; r < t.length; r++) {
            i = t[r], i.params.length !== u || a || (a = i), void 0 != i.params[u] && c.push(i);
          }

          c.sort(function (t, e) {
            return o.compare(t.params[u], e.params[u]);
          });
          var l = [];

          for (r = 0; r < c.length; r++) {
            i = c[r];
            var f = i.params[u],
                p = l.filter(function (t) {
              return t.param.overlapping(f);
            })[0];

            if (p) {
              if (p.param.varArgs) throw new Error('Conflicting types "' + p.param + '" and "' + f + '"');
              p.signatures.push(i);
            } else l.push({
              param: f,
              signatures: [i]
            });
          }

          var m = [];

          for (r = 0; r < n.length; r++) {
            n[r].paramsStartWith(e) && m.push(n[r]);
          }

          var d = !1;

          for (r = 0; r < m.length; r++) {
            if (!g(t, m[r])) {
              d = !0;
              break;
            }
          }

          var v = new Array(l.length);

          for (r = 0; r < l.length; r++) {
            var y = l[r];
            v[r] = h(y.signatures, e.concat(y.param), m);
          }

          return new s(e, a, v, d);
        }

        function f(t) {
          for (var e = [], n = 0; n < t; n++) {
            e[n] = "arg" + n;
          }

          return e;
        }

        function p(t, e) {
          var n = new i(),
              o = u(e);
          if (0 == o.length) throw new Error("No signatures provided");
          var a = c(o),
              s = h(o, [], a),
              p = [],
              d = t || "",
              g = f(m(o));
          p.push("function " + d + "(" + g.join(", ") + ") {"), p.push('  "use strict";'), p.push("  var name = '" + d + "';"), p.push(s.toCode(n, "  ", !1)), p.push("}");
          var v = [n.toCode(), "return " + p.join("\n")].join("\n"),
              y = new Function(n.name, "createError", v),
              x = y(n, r);
          return x.signatures = l(o), x;
        }

        function m(t) {
          for (var e = 0, n = 0; n < t.length; n++) {
            var r = t[n].params.length;
            r > e && (e = r);
          }

          return e;
        }

        function d(t) {
          for (var e, n = 0; n < M.types.length; n++) {
            var r = M.types[n];
            if ("Object" === r.name) e = r;else if (r.test(t)) return r.name;
          }

          return e && e.test(t) ? e.name : "unknown";
        }

        function g(t, e) {
          return t.indexOf(e) !== -1;
        }

        function v(t) {
          return t[t.length - 1];
        }

        function y(t, e) {
          if (!t.signatures) throw new TypeError("Function is no typed-function");
          var n;

          if ("string" == typeof e) {
            n = e.split(",");

            for (var r = 0; r < n.length; r++) {
              n[r] = n[r].trim();
            }
          } else {
            if (!Array.isArray(e)) throw new TypeError("String array or a comma separated string expected");
            n = e;
          }

          var i = n.join(","),
              o = t.signatures[i];
          if (o) return o;
          throw new TypeError("Signature not found (signature: " + (t.name || "unnamed") + "(" + n.join(", ") + "))");
        }

        function x(t, e) {
          var n = d(t);
          if (e === n) return t;

          for (var r = 0; r < M.conversions.length; r++) {
            var i = M.conversions[r];
            if (i.from === n && i.to === e) return i.convert(t);
          }

          throw new Error("Cannot convert from " + n + " to " + e);
        }

        i.prototype.add = function (t, e) {
          var n = e || "fn";
          this.categories[n] || (this.categories[n] = []);
          var r = this.categories[n].indexOf(t);
          return r == -1 && (r = this.categories[n].length, this.categories[n].push(t)), n + r;
        }, i.prototype.toCode = function () {
          var t = [],
              e = this.name + ".categories",
              n = this.categories;

          for (var r in n) {
            if (n.hasOwnProperty(r)) for (var i = n[r], o = 0; o < i.length; o++) {
              t.push("var " + r + o + " = " + e + "['" + r + "'][" + o + "];");
            }
          }

          return t.join("\n");
        }, o.compare = function (t, e) {
          if (t.anyType) return 1;
          if (e.anyType) return -1;
          if (g(t.types, "Object")) return 1;
          if (g(e.types, "Object")) return -1;

          if (t.hasConversions()) {
            if (e.hasConversions()) {
              var n, r, i;

              for (n = 0; n < t.conversions.length; n++) {
                if (void 0 !== t.conversions[n]) {
                  r = t.conversions[n];
                  break;
                }
              }

              for (n = 0; n < e.conversions.length; n++) {
                if (void 0 !== e.conversions[n]) {
                  i = e.conversions[n];
                  break;
                }
              }

              return M.conversions.indexOf(r) - M.conversions.indexOf(i);
            }

            return 1;
          }

          if (e.hasConversions()) return -1;
          var o, a;

          for (n = 0; n < M.types.length; n++) {
            if (M.types[n].name === t.types[0]) {
              o = n;
              break;
            }
          }

          for (n = 0; n < M.types.length; n++) {
            if (M.types[n].name === e.types[0]) {
              a = n;
              break;
            }
          }

          return o - a;
        }, o.prototype.overlapping = function (t) {
          for (var e = 0; e < this.types.length; e++) {
            if (g(t.types, this.types[e])) return !0;
          }

          return !1;
        }, o.prototype.matches = function (t) {
          return this.anyType || t.anyType || this.overlapping(t);
        }, o.prototype.clone = function () {
          var t = new o(this.types.slice(), this.varArgs);
          return t.conversions = this.conversions.slice(), t;
        }, o.prototype.hasConversions = function () {
          return this.conversions.length > 0;
        }, o.prototype.contains = function (t) {
          for (var e = 0; e < this.types.length; e++) {
            if (t[this.types[e]]) return !0;
          }

          return !1;
        }, o.prototype.toString = function (t) {
          for (var e = [], n = {}, r = 0; r < this.types.length; r++) {
            var i = this.conversions[r],
                o = t && i ? i.to : this.types[r];
            o in n || (n[o] = !0, e.push(o));
          }

          return (this.varArgs ? "..." : "") + e.join("|");
        }, a.prototype.clone = function () {
          return new a(this.params.slice(), this.fn);
        }, a.prototype.expand = function () {
          function t(n, r) {
            if (r.length < n.params.length) {
              var i,
                  s,
                  u,
                  c = n.params[r.length];

              if (c.varArgs) {
                for (s = c.clone(), i = 0; i < M.conversions.length; i++) {
                  if (u = M.conversions[i], !g(c.types, u.from) && g(c.types, u.to)) {
                    var l = s.types.length;
                    s.types[l] = u.from, s.conversions[l] = u;
                  }
                }

                t(n, r.concat(s));
              } else {
                for (i = 0; i < c.types.length; i++) {
                  t(n, r.concat(new o(c.types[i])));
                }

                for (i = 0; i < M.conversions.length; i++) {
                  u = M.conversions[i], !g(c.types, u.from) && g(c.types, u.to) && (s = new o(u.from), s.conversions[0] = u, t(n, r.concat(s)));
                }
              }
            } else e.push(new a(r, n.fn));
          }

          var e = [];
          return t(this, []), e;
        }, a.compare = function (t, e) {
          if (t.params.length > e.params.length) return 1;
          if (t.params.length < e.params.length) return -1;
          var n,
              r = t.params.length,
              i = 0,
              a = 0;

          for (n = 0; n < r; n++) {
            t.params[n].hasConversions() && i++, e.params[n].hasConversions() && a++;
          }

          if (i > a) return 1;
          if (i < a) return -1;

          for (n = 0; n < t.params.length; n++) {
            var s = o.compare(t.params[n], e.params[n]);
            if (0 !== s) return s;
          }

          return 0;
        }, a.prototype.hasConversions = function () {
          for (var t = 0; t < this.params.length; t++) {
            if (this.params[t].hasConversions()) return !0;
          }

          return !1;
        }, a.prototype.ignore = function () {
          for (var t = {}, e = 0; e < M.ignore.length; e++) {
            t[M.ignore[e]] = !0;
          }

          for (e = 0; e < this.params.length; e++) {
            if (this.params[e].contains(t)) return !0;
          }

          return !1;
        }, a.prototype.paramsStartWith = function (t) {
          if (0 === t.length) return !0;

          for (var e = v(this.params), n = v(t), r = 0; r < t.length; r++) {
            var i = this.params[r] || (e.varArgs ? e : null),
                o = t[r] || (n.varArgs ? n : null);
            if (!i || !o || !i.matches(o)) return !1;
          }

          return !0;
        }, a.prototype.toCode = function (t, e) {
          for (var n = [], r = new Array(this.params.length), i = 0; i < this.params.length; i++) {
            var o = this.params[i],
                a = o.conversions[0];
            o.varArgs ? r[i] = "varArgs" : a ? r[i] = t.add(a.convert, "convert") + "(arg" + i + ")" : r[i] = "arg" + i;
          }

          var s = this.fn ? t.add(this.fn, "signature") : void 0;
          return s ? e + "return " + s + "(" + r.join(", ") + "); // signature: " + this.params.join(", ") : n.join("\n");
        }, a.prototype.toString = function () {
          return this.params.join(", ");
        }, s.prototype.toCode = function (t, n) {
          var r = [];

          if (this.param) {
            var i = this.path.length - 1,
                o = this.param.conversions[0],
                a = "// type: " + (o ? o.from + " (convert to " + o.to + ")" : this.param);
            if (this.param.varArgs) {
              if (this.param.anyType) r.push(n + "if (arguments.length > " + i + ") {"), r.push(n + "  var varArgs = [];"), r.push(n + "  for (var i = " + i + "; i < arguments.length; i++) {"), r.push(n + "    varArgs.push(arguments[i]);"), r.push(n + "  }"), r.push(this.signature.toCode(t, n + "  ")), r.push(n + "}");else {
                for (var s = function (n, r) {
                  for (var i = [], o = 0; o < n.length; o++) {
                    i[o] = t.add(e(n[o]), "test") + "(" + r + ")";
                  }

                  return i.join(" || ");
                }.bind(this), u = this.param.types, c = [], l = 0; l < u.length; l++) {
                  void 0 === this.param.conversions[l] && c.push(u[l]);
                }

                r.push(n + "if (" + s(u, "arg" + i) + ") { " + a), r.push(n + "  var varArgs = [arg" + i + "];"), r.push(n + "  for (var i = " + (i + 1) + "; i < arguments.length; i++) {"), r.push(n + "    if (" + s(c, "arguments[i]") + ") {"), r.push(n + "      varArgs.push(arguments[i]);");

                for (var l = 0; l < u.length; l++) {
                  var h = this.param.conversions[l];

                  if (h) {
                    var f = t.add(e(u[l]), "test"),
                        p = t.add(h.convert, "convert");
                    r.push(n + "    }"), r.push(n + "    else if (" + f + "(arguments[i])) {"), r.push(n + "      varArgs.push(" + p + "(arguments[i]));");
                  }
                }

                r.push(n + "    } else {"), r.push(n + "      throw createError(name, arguments.length, i, arguments[i], '" + c.join(",") + "');"), r.push(n + "    }"), r.push(n + "  }"), r.push(this.signature.toCode(t, n + "  ")), r.push(n + "}");
              }
            } else if (this.param.anyType) r.push(n + "// type: any"), r.push(this._innerCode(t, n));else {
              var m = this.param.types[0],
                  f = "any" !== m ? t.add(e(m), "test") : null;
              r.push(n + "if (" + f + "(arg" + i + ")) { " + a), r.push(this._innerCode(t, n + "  ")), r.push(n + "}");
            }
          } else r.push(this._innerCode(t, n));

          return r.join("\n");
        }, s.prototype._innerCode = function (t, e) {
          var n,
              r = [];

          for (this.signature && (r.push(e + "if (arguments.length === " + this.path.length + ") {"), r.push(this.signature.toCode(t, e + "  ")), r.push(e + "}")), n = 0; n < this.childs.length; n++) {
            r.push(this.childs[n].toCode(t, e));
          }

          if (!this.fallThrough || this.param && this.param.anyType) {
            var i = this._exceptions(t, e);

            i && r.push(i);
          }

          return r.join("\n");
        }, s.prototype._exceptions = function (t, e) {
          var n = this.path.length;
          if (0 === this.childs.length) return [e + "if (arguments.length > " + n + ") {", e + "  throw createError(name, arguments.length, " + n + ", arguments[" + n + "]);", e + "}"].join("\n");

          for (var r = {}, i = [], o = 0; o < this.childs.length; o++) {
            var a = this.childs[o];
            if (a.param) for (var s = 0; s < a.param.types.length; s++) {
              var u = a.param.types[s];
              u in r || a.param.conversions[s] || (r[u] = !0, i.push(u));
            }
          }

          return e + "throw createError(name, arguments.length, " + n + ", arguments[" + n + "], '" + i.join(",") + "');";
        };
        var w = [{
          name: "number",
          test: function test(t) {
            return "number" == typeof t;
          }
        }, {
          name: "string",
          test: function test(t) {
            return "string" == typeof t;
          }
        }, {
          name: "boolean",
          test: function test(t) {
            return "boolean" == typeof t;
          }
        }, {
          name: "Function",
          test: function test(t) {
            return "function" == typeof t;
          }
        }, {
          name: "Array",
          test: Array.isArray
        }, {
          name: "Date",
          test: function test(t) {
            return t instanceof Date;
          }
        }, {
          name: "RegExp",
          test: function test(t) {
            return t instanceof RegExp;
          }
        }, {
          name: "Object",
          test: function test(t) {
            return "object" == typeof t;
          }
        }, {
          name: "null",
          test: function test(t) {
            return null === t;
          }
        }, {
          name: "undefined",
          test: function test(t) {
            return void 0 === t;
          }
        }],
            b = {},
            _ = [],
            E = [],
            M = {
          config: b,
          types: w,
          conversions: _,
          ignore: E
        };
        return M = p("typed", {
          Object: function Object(t) {
            var e = [];

            for (var r in t) {
              t.hasOwnProperty(r) && e.push(t[r]);
            }

            var i = n(e);
            return p(i, t);
          },
          "string, Object": p,
          "...Function": function Function(t) {
            for (var e, r = n(t), i = {}, o = 0; o < t.length; o++) {
              var a = t[o];
              if ("object" != typeof a.signatures) throw e = new TypeError("Function is no typed-function (index: " + o + ")"), e.data = {
                index: o
              }, e;

              for (var s in a.signatures) {
                if (a.signatures.hasOwnProperty(s)) if (i.hasOwnProperty(s)) {
                  if (a.signatures[s] !== i[s]) throw e = new Error('Signature "' + s + '" is defined twice'), e.data = {
                    signature: s
                  }, e;
                } else i[s] = a.signatures[s];
              }
            }

            return p(r, i);
          }
        }), M.config = b, M.types = w, M.conversions = _, M.ignore = E, M.create = t, M.find = y, M.convert = x, M.addType = function (t) {
          if (!t || "string" != typeof t.name || "function" != typeof t.test) throw new TypeError("Object with properties {name: string, test: function} expected");
          M.types.push(t);
        }, M.addConversion = function (t) {
          if (!t || "string" != typeof t.from || "string" != typeof t.to || "function" != typeof t.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
          M.conversions.push(t);
        }, M;
      }

      return t();
    });
  }, function (t, e) {
    t.exports = function (t) {
      return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
    };
  }, function (t, e, n) {
    (function (t, r) {
      function i(t, n) {
        var r = {
          seen: [],
          stylize: a
        };
        return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), d(n) ? r.showHidden = n : n && e._extend(r, n), b(r.showHidden) && (r.showHidden = !1), b(r.depth) && (r.depth = 2), b(r.colors) && (r.colors = !1), b(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = o), u(r, t, r.depth);
      }

      function o(t, e) {
        var n = i.styles[e];
        return n ? "[" + i.colors[n][0] + "m" + t + "[" + i.colors[n][1] + "m" : t;
      }

      function a(t, e) {
        return t;
      }

      function s(t) {
        var e = {};
        return t.forEach(function (t, n) {
          e[t] = !0;
        }), e;
      }

      function u(t, n, r) {
        if (t.customInspect && n && N(n.inspect) && n.inspect !== e.inspect && (!n.constructor || n.constructor.prototype !== n)) {
          var i = n.inspect(r, t);
          return x(i) || (i = u(t, i, r)), i;
        }

        var o = c(t, n);
        if (o) return o;
        var a = Object.keys(n),
            d = s(a);
        if (t.showHidden && (a = Object.getOwnPropertyNames(n)), T(n) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return l(n);

        if (0 === a.length) {
          if (N(n)) {
            var g = n.name ? ": " + n.name : "";
            return t.stylize("[Function" + g + "]", "special");
          }

          if (_(n)) return t.stylize(RegExp.prototype.toString.call(n), "regexp");
          if (M(n)) return t.stylize(Date.prototype.toString.call(n), "date");
          if (T(n)) return l(n);
        }

        var v = "",
            y = !1,
            w = ["{", "}"];

        if (m(n) && (y = !0, w = ["[", "]"]), N(n)) {
          var b = n.name ? ": " + n.name : "";
          v = " [Function" + b + "]";
        }

        if (_(n) && (v = " " + RegExp.prototype.toString.call(n)), M(n) && (v = " " + Date.prototype.toUTCString.call(n)), T(n) && (v = " " + l(n)), 0 === a.length && (!y || 0 == n.length)) return w[0] + v + w[1];
        if (r < 0) return _(n) ? t.stylize(RegExp.prototype.toString.call(n), "regexp") : t.stylize("[Object]", "special");
        t.seen.push(n);
        var E;
        return E = y ? h(t, n, r, d, a) : a.map(function (e) {
          return f(t, n, r, d, e, y);
        }), t.seen.pop(), p(E, v, w);
      }

      function c(t, e) {
        if (b(e)) return t.stylize("undefined", "undefined");

        if (x(e)) {
          var n = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return t.stylize(n, "string");
        }

        return y(e) ? t.stylize("" + e, "number") : d(e) ? t.stylize("" + e, "boolean") : g(e) ? t.stylize("null", "null") : void 0;
      }

      function l(t) {
        return "[" + Error.prototype.toString.call(t) + "]";
      }

      function h(t, e, n, r, i) {
        for (var o = [], a = 0, s = e.length; a < s; ++a) {
          P(e, String(a)) ? o.push(f(t, e, n, r, String(a), !0)) : o.push("");
        }

        return i.forEach(function (i) {
          i.match(/^\d+$/) || o.push(f(t, e, n, r, i, !0));
        }), o;
      }

      function f(t, e, n, r, i, o) {
        var a, s, c;

        if (c = Object.getOwnPropertyDescriptor(e, i) || {
          value: e[i]
        }, c.get ? s = c.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : c.set && (s = t.stylize("[Setter]", "special")), P(r, i) || (a = "[" + i + "]"), s || (t.seen.indexOf(c.value) < 0 ? (s = g(n) ? u(t, c.value, null) : u(t, c.value, n - 1), s.indexOf("\n") > -1 && (s = o ? s.split("\n").map(function (t) {
          return "  " + t;
        }).join("\n").substr(2) : "\n" + s.split("\n").map(function (t) {
          return "   " + t;
        }).join("\n"))) : s = t.stylize("[Circular]", "special")), b(a)) {
          if (o && i.match(/^\d+$/)) return s;
          a = JSON.stringify("" + i), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = t.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = t.stylize(a, "string"));
        }

        return a + ": " + s;
      }

      function p(t, e, n) {
        var r = 0,
            i = t.reduce(function (t, e) {
          return r++, e.indexOf("\n") >= 0 && r++, t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        return i > 60 ? n[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + n[1] : n[0] + e + " " + t.join(", ") + " " + n[1];
      }

      function m(t) {
        return Array.isArray(t);
      }

      function d(t) {
        return "boolean" == typeof t;
      }

      function g(t) {
        return null === t;
      }

      function v(t) {
        return null == t;
      }

      function y(t) {
        return "number" == typeof t;
      }

      function x(t) {
        return "string" == typeof t;
      }

      function w(t) {
        return "symbol" == typeof t;
      }

      function b(t) {
        return void 0 === t;
      }

      function _(t) {
        return E(t) && "[object RegExp]" === A(t);
      }

      function E(t) {
        return "object" == typeof t && null !== t;
      }

      function M(t) {
        return E(t) && "[object Date]" === A(t);
      }

      function T(t) {
        return E(t) && ("[object Error]" === A(t) || t instanceof Error);
      }

      function N(t) {
        return "function" == typeof t;
      }

      function S(t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || "undefined" == typeof t;
      }

      function A(t) {
        return Object.prototype.toString.call(t);
      }

      function O(t) {
        return t < 10 ? "0" + t.toString(10) : t.toString(10);
      }

      function C() {
        var t = new Date(),
            e = [O(t.getHours()), O(t.getMinutes()), O(t.getSeconds())].join(":");
        return [t.getDate(), z[t.getMonth()], e].join(" ");
      }

      function P(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      var R = /%[sdj%]/g;
      e.format = function (t) {
        if (!x(t)) {
          for (var e = [], n = 0; n < arguments.length; n++) {
            e.push(i(arguments[n]));
          }

          return e.join(" ");
        }

        for (var n = 1, r = arguments, o = r.length, a = String(t).replace(R, function (t) {
          if ("%%" === t) return "%";
          if (n >= o) return t;

          switch (t) {
            case "%s":
              return String(r[n++]);

            case "%d":
              return Number(r[n++]);

            case "%j":
              try {
                return JSON.stringify(r[n++]);
              } catch (t) {
                return "[Circular]";
              }

            default:
              return t;
          }
        }), s = r[n]; n < o; s = r[++n]) {
          a += g(s) || !E(s) ? " " + s : " " + i(s);
        }

        return a;
      }, e.deprecate = function (n, i) {
        function o() {
          if (!a) {
            if (r.throwDeprecation) throw new Error(i);
            r.traceDeprecation ? console.trace(i) : console.error(i), a = !0;
          }

          return n.apply(this, arguments);
        }

        if (b(t.process)) return function () {
          return e.deprecate(n, i).apply(this, arguments);
        };
        if (r.noDeprecation === !0) return n;
        var a = !1;
        return o;
      };
      var I,
          k = {};
      e.debuglog = function (t) {
        if (b(I) && (I = {
          NODE_ENV: "production"
        }.NODE_DEBUG || ""), t = t.toUpperCase(), !k[t]) if (new RegExp("\\b" + t + "\\b", "i").test(I)) {
          var n = r.pid;

          k[t] = function () {
            var r = e.format.apply(e, arguments);
            console.error("%s %d: %s", t, n, r);
          };
        } else k[t] = function () {};
        return k[t];
      }, e.inspect = i, i.colors = {
        bold: [1, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        white: [37, 39],
        grey: [90, 39],
        black: [30, 39],
        blue: [34, 39],
        cyan: [36, 39],
        green: [32, 39],
        magenta: [35, 39],
        red: [31, 39],
        yellow: [33, 39]
      }, i.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
      }, e.isArray = m, e.isBoolean = d, e.isNull = g, e.isNullOrUndefined = v, e.isNumber = y, e.isString = x, e.isSymbol = w, e.isUndefined = b, e.isRegExp = _, e.isObject = E, e.isDate = M, e.isError = T, e.isFunction = N, e.isPrimitive = S, e.isBuffer = n(580);
      var z = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      e.log = function () {
        console.log("%s - %s", C(), e.format.apply(e, arguments));
      }, e.inherits = n(180), e._extend = function (t, e) {
        if (!e || !E(e)) return t;

        for (var n = Object.keys(e), r = n.length; r--;) {
          t[n[r]] = e[n[r]];
        }

        return t;
      };
    }).call(e, function () {
      return this;
    }(), n(159));
  },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
    "use strict";

    function r() {}

    function i() {}

    var o = n(623);
    i.resetWarningCache = r, t.exports = function () {
      function t(t, e, n, r, i, a) {
        if (a !== o) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var n = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: i,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }, function (t, e, n) {
    t.exports = n(621)();
  }, function (t, e) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    t.exports = n;
  },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (t, e, n) {
    "use strict";

    function r(t) {
      return this instanceof r ? (this._canvas = t = "string" == typeof t ? document.getElementById(t) : t, this._ctx = t.getContext("2d"), this._width = t.width, this._height = t.height, this._max = 1, void (this._data = [])) : new r(t);
    }

    t.exports = r, r.prototype = {
      defaultRadius: 25,
      defaultGradient: {
        .4: "blue",
        .6: "cyan",
        .7: "lime",
        .8: "yellow",
        1: "red"
      },
      data: function data(t) {
        return this._data = t, this;
      },
      max: function max(t) {
        return this._max = t, this;
      },
      add: function add(t) {
        return this._data.push(t), this;
      },
      clear: function clear() {
        return this._data = [], this;
      },
      radius: function radius(t, e) {
        e = void 0 === e ? 15 : e;

        var n = this._circle = this._createCanvas(),
            r = n.getContext("2d"),
            i = this._r = t + e;

        return n.width = n.height = 2 * i, r.shadowOffsetX = r.shadowOffsetY = 2 * i, r.shadowBlur = e, r.shadowColor = "black", r.beginPath(), r.arc(-i, -i, t, 0, 2 * Math.PI, !0), r.closePath(), r.fill(), this;
      },
      resize: function resize() {
        this._width = this._canvas.width, this._height = this._canvas.height;
      },
      gradient: function gradient(t) {
        var e = this._createCanvas(),
            n = e.getContext("2d"),
            r = n.createLinearGradient(0, 0, 0, 256);

        e.width = 1, e.height = 256;

        for (var i in t) {
          r.addColorStop(+i, t[i]);
        }

        return n.fillStyle = r, n.fillRect(0, 0, 1, 256), this._grad = n.getImageData(0, 0, 1, 256).data, this;
      },
      draw: function draw(t) {
        this._circle || this.radius(this.defaultRadius), this._grad || this.gradient(this.defaultGradient);
        var e = this._ctx;
        e.clearRect(0, 0, this._width, this._height);

        for (var n, r = 0, i = this._data.length; r < i; r++) {
          n = this._data[r], e.globalAlpha = Math.max(n[2] / this._max, void 0 === t ? .05 : t), e.drawImage(this._circle, n[0] - this._r, n[1] - this._r);
        }

        var o = e.getImageData(0, 0, this._width, this._height);
        return this._colorize(o.data, this._grad), e.putImageData(o, 0, 0), this;
      },
      _colorize: function _colorize(t, e) {
        for (var n, r = 0, i = t.length; r < i; r += 4) {
          n = 4 * t[r + 3], n && (t[r] = e[n], t[r + 1] = e[n + 1], t[r + 2] = e[n + 2]);
        }
      },
      _createCanvas: function _createCanvas() {
        return "undefined" != typeof document ? document.createElement("canvas") : new this._canvas.constructor();
      }
    };
  }]);
});